/*! Rappid v2.2.0 - HTML5 Diagramming Framework

Copyright (c) 2015 client IO

 2017-10-23 


This Source Code Form is subject to the terms of the Rappid License
, v. 2.0. If a copy of the Rappid License was not distributed with this
file, You can obtain one at http://jointjs.com/license/rappid_v2.txt
 or from the Rappid archive as was distributed by client IO. See the LICENSE file.*/


(function (root, factory) {

	if (typeof define === 'function' && define.amd) {

		// For AMD.

		define(['backbone', 'lodash', 'jquery'], function (Backbone, _, $) {
			Backbone.$ = $;

			return factory(root, Backbone, _, $);
		});

	} else if (typeof exports !== 'undefined') {

		// For Node.js or CommonJS.

		var Backbone = require('backbone');
		var _ = require('lodash');
		var $ = Backbone.$ = require('jquery');

		module.exports = factory(root, Backbone, _, $);

	} else {

		// As a browser global.

		var Backbone = root.Backbone;
		var _ = root._;
		var $ = Backbone.$ = root.jQuery || root.$;

		root.joint = factory(root, Backbone, _, $);
		root.g = root.joint.g;
		root.V = root.Vectorizer = root.joint.V;
	}

}(this, function (root, Backbone, _, $) {

	(function () {

		/**
		 * version: 0.3.0
		 * git://github.com/davidchambers/Base64.js.git
		 */

		var object = typeof exports != 'undefined' ? exports : this; // #8: web workers
		var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

		function InvalidCharacterError(message) {
			this.message = message;
		}

		InvalidCharacterError.prototype = new Error;
		InvalidCharacterError.prototype.name = 'InvalidCharacterError';

		// encoder
		// [https://gist.github.com/999166] by [https://github.com/nignag]
		object.btoa || (
			object.btoa = function (input) {
				var str = String(input);
				for (
					// initialize result and counter
					var block, charCode, idx = 0, map = chars, output = '';
					// if the next str index does not exist:
					//   change the mapping table to "="
					//   check if d has no fractional digits
					str.charAt(idx | 0) || (map = '=', idx % 1);
					// "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
					output += map.charAt(63 & block >> 8 - idx % 1 * 8)
				) {
					charCode = str.charCodeAt(idx += 3 / 4);
					if (charCode > 0xFF) {
						throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
					}
					block = block << 8 | charCode;
				}
				return output;
			});

		// decoder
		// [https://gist.github.com/1020396] by [https://github.com/atk]
		object.atob || (
			object.atob = function (input) {
				var str = String(input).replace(/=+$/, '');
				if (str.length % 4 == 1) {
					throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
				}
				for (
					// initialize result and counters
					var bc = 0, bs, buffer, idx = 0, output = '';
					// get next character
					// eslint-disable-next-line no-cond-assign
					buffer = str.charAt(idx++);
					// character found in table? initialize bit storage and add its ascii value;
					~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
						// and if not first of each 4 characters,
						// convert the first 8 bits to one ascii character
						bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
				) {
					// try to find character in table (0-63, not found => -1)
					buffer = chars.indexOf(buffer);
				}
				return output;
			});

	}());

	(function () {

		if (typeof Uint8Array !== 'undefined' || typeof window === 'undefined') {
			return;
		}

		function subarray(start, end) {
			return this.slice(start, end);
		}

		function set_(array, offset) {

			if (arguments.length < 2) {
				offset = 0;
			}
			for (var i = 0, n = array.length; i < n; ++i, ++offset) {
				this[offset] = array[i] & 0xFF;
			}
		}

		// we need typed arrays
		function TypedArray(arg1) {

			var result;
			if (typeof arg1 === 'number') {
				result = new Array(arg1);
				for (var i = 0; i < arg1; ++i) {
					result[i] = 0;
				}
			} else {
				result = arg1.slice(0);
			}
			result.subarray = subarray;
			result.buffer = result;
			result.byteLength = result.length;
			result.set = set_;
			if (typeof arg1 === 'object' && arg1.buffer) {
				result.buffer = arg1.buffer;
			}

			return result;
		}

		window.Uint8Array = TypedArray;
		window.Uint32Array = TypedArray;
		window.Int32Array = TypedArray;
	})();

	/**
	 * make xhr.response = 'arraybuffer' available for the IE9
	 */
	(function () {

		if (typeof XMLHttpRequest === 'undefined') {
			return;
		}

		if ('response' in XMLHttpRequest.prototype ||
			'mozResponseArrayBuffer' in XMLHttpRequest.prototype ||
			'mozResponse' in XMLHttpRequest.prototype ||
			'responseArrayBuffer' in XMLHttpRequest.prototype) {
			return;
		}

		Object.defineProperty(XMLHttpRequest.prototype, 'response', {
			get: function () {
				return new Uint8Array(new VBArray(this.responseBody).toArray());
			}
		});
	})();

	// https://tc39.github.io/ecma262/#sec-array.prototype.includes
	if (!Array.prototype.includes) {
		Object.defineProperty(Array.prototype, 'includes', {
			value: function (searchElement, fromIndex) {

				// 1. Let O be ? ToObject(this value).
				if (this == null) {
					throw new TypeError('"this" is null or not defined');
				}

				var o = Object(this);

				// 2. Let len be ? ToLength(? Get(O, "length")).
				var len = o.length >>> 0;

				// 3. If len is 0, return false.
				if (len === 0) {
					return false;
				}

				// 4. Let n be ? ToInteger(fromIndex).
				//    (If fromIndex is undefined, this step produces the value 0.)
				var n = fromIndex | 0;

				// 5. If n ≥ 0, then
				//  a. Let k be n.
				// 6. Else n < 0,
				//  a. Let k be len + n.
				//  b. If k < 0, let k be 0.
				var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

				function sameValueZero(x, y) {
					return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
				}

				// 7. Repeat, while k < len
				while (k < len) {
					// a. Let elementK be the result of ? Get(O, ! ToString(k)).
					// b. If SameValueZero(searchElement, elementK) is true, return true.
					// c. Increase k by 1.
					if (sameValueZero(o[k], searchElement)) {
						return true;
					}
					k++;
				}

				// 8. Return false
				return false;
			}
		});
	}

	// https://tc39.github.io/ecma262/#sec-array.prototype.find
	if (!Array.prototype.find) {
		Object.defineProperty(Array.prototype, 'find', {
			value: function (predicate) {
				// 1. Let O be ? ToObject(this value).
				if (this == null) {
					throw new TypeError('"this" is null or not defined');
				}

				var o = Object(this);

				// 2. Let len be ? ToLength(? Get(O, "length")).
				var len = o.length >>> 0;

				// 3. If IsCallable(predicate) is false, throw a TypeError exception.
				if (typeof predicate !== 'function') {
					throw new TypeError('predicate must be a function');
				}

				// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
				var thisArg = arguments[1];

				// 5. Let k be 0.
				var k = 0;

				// 6. Repeat, while k < len
				while (k < len) {
					// a. Let Pk be ! ToString(k).
					// b. Let kValue be ? Get(O, Pk).
					// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
					// d. If testResult is true, return kValue.
					var kValue = o[k];
					if (predicate.call(thisArg, kValue, k, o)) {
						return kValue;
					}
					// e. Increase k by 1.
					k++;
				}

				// 7. Return undefined.
				return undefined;
			}
		});
	}

	// Production steps of ECMA-262, Edition 6, 22.1.2.1
	if (!Array.from) {
		Array.from = (function () {
			var toStr = Object.prototype.toString;
			var isCallable = function (fn) {
				return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
			};
			var toInteger = function (value) {
				var number = Number(value);
				if (isNaN(number)) { return 0; }
				if (number === 0 || !isFinite(number)) { return number; }
				return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
			};
			var maxSafeInteger = Math.pow(2, 53) - 1;
			var toLength = function (value) {
				var len = toInteger(value);
				return Math.min(Math.max(len, 0), maxSafeInteger);
			};

			// The length property of the from method is 1.
			return function from(arrayLike/*, mapFn, thisArg */) {
				// 1. Let C be the this value.
				var C = this;

				// 2. Let items be ToObject(arrayLike).
				var items = Object(arrayLike);

				// 3. ReturnIfAbrupt(items).
				if (arrayLike == null) {
					throw new TypeError('Array.from requires an array-like object - not null or undefined');
				}

				// 4. If mapfn is undefined, then let mapping be false.
				var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
				var T;
				if (typeof mapFn !== 'undefined') {
					// 5. else
					// 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
					if (!isCallable(mapFn)) {
						throw new TypeError('Array.from: when provided, the second argument must be a function');
					}

					// 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
					if (arguments.length > 2) {
						T = arguments[2];
					}
				}

				// 10. Let lenValue be Get(items, "length").
				// 11. Let len be ToLength(lenValue).
				var len = toLength(items.length);

				// 13. If IsConstructor(C) is true, then
				// 13. a. Let A be the result of calling the [[Construct]] internal method
				// of C with an argument list containing the single item len.
				// 14. a. Else, Let A be ArrayCreate(len).
				var A = isCallable(C) ? Object(new C(len)) : new Array(len);

				// 16. Let k be 0.
				var k = 0;
				// 17. Repeat, while k < len… (also steps a - h)
				var kValue;
				while (k < len) {
					kValue = items[k];
					if (mapFn) {
						A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
					} else {
						A[k] = kValue;
					}
					k += 1;
				}
				// 18. Let putStatus be Put(A, "length", len, true).
				A.length = len;
				// 20. Return A.
				return A;
			};
		}());
	}

	// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
	if (!Array.prototype.findIndex) {
		Object.defineProperty(Array.prototype, 'findIndex', {
			value: function (predicate) {
				// 1. Let O be ? ToObject(this value).
				if (this == null) {
					throw new TypeError('"this" is null or not defined');
				}

				var o = Object(this);

				// 2. Let len be ? ToLength(? Get(O, "length")).
				var len = o.length >>> 0;

				// 3. If IsCallable(predicate) is false, throw a TypeError exception.
				if (typeof predicate !== 'function') {
					throw new TypeError('predicate must be a function');
				}

				// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
				var thisArg = arguments[1];

				// 5. Let k be 0.
				var k = 0;

				// 6. Repeat, while k < len
				while (k < len) {
					// a. Let Pk be ! ToString(k).
					// b. Let kValue be ? Get(O, Pk).
					// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
					// d. If testResult is true, return k.
					var kValue = o[k];
					if (predicate.call(thisArg, kValue, k, o)) {
						return k;
					}
					// e. Increase k by 1.
					k++;
				}

				// 7. Return -1.
				return -1;
			}
		});
	}

	if (!String.prototype.includes) {
		String.prototype.includes = function (search, start) {
			'use strict';
			if (typeof start !== 'number') {
				start = 0;
			}

			if (start + search.length > this.length) {
				return false;
			} else {
				return this.indexOf(search, start) !== -1;
			}
		};
	}

	if (!String.prototype.startsWith) {
		String.prototype.startsWith = function (searchString, position) {
			return this.substr(position || 0, searchString.length) === searchString;
		};
	}

	Number.isFinite = Number.isFinite || function (value) {
		return typeof value === 'number' && isFinite(value);
	};

	//The following works because NaN is the only value in javascript which is not equal to itself.
	Number.isNaN = Number.isNaN || function (value) {
		return value !== value;
	}



	//      Geometry library.

	var g = (function () {

		var g = {};

		// Declare shorthands to the most used math functions.
		var math = Math;
		var abs = math.abs;
		var cos = math.cos;
		var sin = math.sin;
		var sqrt = math.sqrt;
		var mmin = math.min;
		var mmax = math.max;
		var atan2 = math.atan2;
		var round = math.round;
		var floor = math.floor;
		var PI = math.PI;
		var random = math.random;
		var pow = math.pow;

		g.bezier = {

			// Cubic Bezier curve path through points.
			// Ported from C# implementation by Oleg V. Polikarpotchkin and Peter Lee (http://www.codeproject.com/KB/graphics/BezierSpline.aspx).
			// @param {array} points Array of points through which the smooth line will go.
			// @return {array} SVG Path commands as an array
			curveThroughPoints: function (points) {

				var controlPoints = this.getCurveControlPoints(points);
				var path = ['M', points[0].x, points[0].y];

				for (var i = 0; i < controlPoints[0].length; i++) {
					path.push('C', controlPoints[0][i].x, controlPoints[0][i].y, controlPoints[1][i].x, controlPoints[1][i].y, points[i + 1].x, points[i + 1].y);
				}

				return path;
			},

			// Get open-ended Bezier Spline Control Points.
			// @param knots Input Knot Bezier spline points (At least two points!).
			// @param firstControlPoints Output First Control points. Array of knots.length - 1 length.
			// @param secondControlPoints Output Second Control points. Array of knots.length - 1 length.
			getCurveControlPoints: function (knots) {

				var firstControlPoints = [];
				var secondControlPoints = [];
				var n = knots.length - 1;
				var i;

				// Special case: Bezier curve should be a straight line.
				if (n == 1) {
					// 3P1 = 2P0 + P3
					firstControlPoints[0] = Point((2 * knots[0].x + knots[1].x) / 3,
						(2 * knots[0].y + knots[1].y) / 3);
					// P2 = 2P1 – P0
					secondControlPoints[0] = Point(2 * firstControlPoints[0].x - knots[0].x,
						2 * firstControlPoints[0].y - knots[0].y);
					return [firstControlPoints, secondControlPoints];
				}

				// Calculate first Bezier control points.
				// Right hand side vector.
				var rhs = [];

				// Set right hand side X values.
				for (i = 1; i < n - 1; i++) {
					rhs[i] = 4 * knots[i].x + 2 * knots[i + 1].x;
				}
				rhs[0] = knots[0].x + 2 * knots[1].x;
				rhs[n - 1] = (8 * knots[n - 1].x + knots[n].x) / 2.0;
				// Get first control points X-values.
				var x = this.getFirstControlPoints(rhs);

				// Set right hand side Y values.
				for (i = 1; i < n - 1; ++i) {
					rhs[i] = 4 * knots[i].y + 2 * knots[i + 1].y;
				}
				rhs[0] = knots[0].y + 2 * knots[1].y;
				rhs[n - 1] = (8 * knots[n - 1].y + knots[n].y) / 2.0;
				// Get first control points Y-values.
				var y = this.getFirstControlPoints(rhs);

				// Fill output arrays.
				for (i = 0; i < n; i++) {
					// First control point.
					firstControlPoints.push(Point(x[i], y[i]));
					// Second control point.
					if (i < n - 1) {
						secondControlPoints.push(Point(2 * knots[i + 1].x - x[i + 1],
							2 * knots[i + 1].y - y[i + 1]));
					} else {
						secondControlPoints.push(Point((knots[n].x + x[n - 1]) / 2,
							(knots[n].y + y[n - 1]) / 2));
					}
				}
				return [firstControlPoints, secondControlPoints];
			},

			// Divide a Bezier curve into two at point defined by value 't' <0,1>.
			// Using deCasteljau algorithm. http://math.stackexchange.com/a/317867
			// @param control points (start, control start, control end, end)
			// @return a function accepts t and returns 2 curves each defined by 4 control points.
			getCurveDivider: function (p0, p1, p2, p3) {

				return function divideCurve(t) {

					var l = Line(p0, p1).pointAt(t);
					var m = Line(p1, p2).pointAt(t);
					var n = Line(p2, p3).pointAt(t);
					var p = Line(l, m).pointAt(t);
					var q = Line(m, n).pointAt(t);
					var r = Line(p, q).pointAt(t);
					return [{ p0: p0, p1: l, p2: p, p3: r }, { p0: r, p1: q, p2: n, p3: p3 }];
				};
			},

			// Solves a tridiagonal system for one of coordinates (x or y) of first Bezier control points.
			// @param rhs Right hand side vector.
			// @return Solution vector.
			getFirstControlPoints: function (rhs) {

				var n = rhs.length;
				// `x` is a solution vector.
				var x = [];
				var tmp = [];
				var b = 2.0;

				x[0] = rhs[0] / b;
				// Decomposition and forward substitution.
				for (var i = 1; i < n; i++) {
					tmp[i] = 1 / b;
					b = (i < n - 1 ? 4.0 : 3.5) - tmp[i];
					x[i] = (rhs[i] - x[i - 1]) / b;
				}
				for (i = 1; i < n; i++) {
					// Backsubstitution.
					x[n - i - 1] -= tmp[n - i] * x[n - i];
				}
				return x;
			},

			// Solves an inversion problem -- Given the (x, y) coordinates of a point which lies on
			// a parametric curve x = x(t)/w(t), y = y(t)/w(t), ﬁnd the parameter value t
			// which corresponds to that point.
			// @param control points (start, control start, control end, end)
			// @return a function accepts a point and returns t.
			getInversionSolver: function (p0, p1, p2, p3) {

				var pts = arguments;
				function l(i, j) {
					// calculates a determinant 3x3
					// [p.x  p.y  1]
					// [pi.x pi.y 1]
					// [pj.x pj.y 1]
					var pi = pts[i];
					var pj = pts[j];
					return function (p) {
						var w = (i % 3 ? 3 : 1) * (j % 3 ? 3 : 1);
						var lij = p.x * (pi.y - pj.y) + p.y * (pj.x - pi.x) + pi.x * pj.y - pi.y * pj.x;
						return w * lij;
					};
				}
				return function solveInversion(p) {
					var ct = 3 * l(2, 3)(p1);
					var c1 = l(1, 3)(p0) / ct;
					var c2 = -l(2, 3)(p0) / ct;
					var la = c1 * l(3, 1)(p) + c2 * (l(3, 0)(p) + l(2, 1)(p)) + l(2, 0)(p);
					var lb = c1 * l(3, 0)(p) + c2 * l(2, 0)(p) + l(1, 0)(p);
					return lb / (lb - la);
				};
			}
		};

		var Ellipse = g.Ellipse = function (c, a, b) {

			if (!(this instanceof Ellipse)) {
				return new Ellipse(c, a, b);
			}

			if (c instanceof Ellipse) {
				return new Ellipse(Point(c), c.a, c.b);
			}

			c = Point(c);
			this.x = c.x;
			this.y = c.y;
			this.a = a;
			this.b = b;
		};

		g.Ellipse.fromRect = function (rect) {

			rect = Rect(rect);
			return Ellipse(rect.center(), rect.width / 2, rect.height / 2);
		};

		g.Ellipse.prototype = {

			bbox: function () {

				return Rect(this.x - this.a, this.y - this.b, 2 * this.a, 2 * this.b);
			},

			clone: function () {

				return Ellipse(this);
			},

			/**
			 * @param {g.Point} point
			 * @returns {number} result < 1 - inside ellipse, result == 1 - on ellipse boundary, result > 1 - outside
			 */
			normalizedDistance: function (point) {

				var x0 = point.x;
				var y0 = point.y;
				var a = this.a;
				var b = this.b;
				var x = this.x;
				var y = this.y;

				return ((x0 - x) * (x0 - x)) / (a * a) + ((y0 - y) * (y0 - y)) / (b * b);
			},

			// inflate by dx and dy
			// @param dx {delta_x} representing additional size to x
			// @param dy {delta_y} representing additional size to y -
			// dy param is not required -> in that case y is sized by dx
			inflate: function (dx, dy) {
				if (dx === undefined) {
					dx = 0;
				}

				if (dy === undefined) {
					dy = dx;
				}

				this.a += 2 * dx;
				this.b += 2 * dy;

				return this;
			},


			/**
			 * @param {g.Point} p
			 * @returns {boolean}
			 */
			containsPoint: function (p) {

				return this.normalizedDistance(p) <= 1;
			},

			/**
			 * @returns {g.Point}
			 */
			center: function () {

				return Point(this.x, this.y);
			},

			/** Compute angle between tangent and x axis
			 * @param {g.Point} p Point of tangency, it has to be on ellipse boundaries.
			 * @returns {number} angle between tangent and x axis
			 */
			tangentTheta: function (p) {

				var refPointDelta = 30;
				var x0 = p.x;
				var y0 = p.y;
				var a = this.a;
				var b = this.b;
				var center = this.bbox().center();
				var m = center.x;
				var n = center.y;

				var q1 = x0 > center.x + a / 2;
				var q3 = x0 < center.x - a / 2;

				var y, x;
				if (q1 || q3) {
					y = x0 > center.x ? y0 - refPointDelta : y0 + refPointDelta;
					x = (a * a / (x0 - m)) - (a * a * (y0 - n) * (y - n)) / (b * b * (x0 - m)) + m;
				} else {
					x = y0 > center.y ? x0 + refPointDelta : x0 - refPointDelta;
					y = (b * b / (y0 - n)) - (b * b * (x0 - m) * (x - m)) / (a * a * (y0 - n)) + n;
				}

				return g.point(x, y).theta(p);

			},

			equals: function (ellipse) {

				return !!ellipse &&
					ellipse.x === this.x &&
					ellipse.y === this.y &&
					ellipse.a === this.a &&
					ellipse.b === this.b;
			},

			// Find point on me where line from my center to
			// point p intersects my boundary.
			// @param {number} angle If angle is specified, intersection with rotated ellipse is computed.
			intersectionWithLineFromCenterToPoint: function (p, angle) {

				p = Point(p);
				if (angle) p.rotate(Point(this.x, this.y), angle);
				var dx = p.x - this.x;
				var dy = p.y - this.y;
				var result;
				if (dx === 0) {
					result = this.bbox().pointNearestToPoint(p);
					if (angle) return result.rotate(Point(this.x, this.y), -angle);
					return result;
				}
				var m = dy / dx;
				var mSquared = m * m;
				var aSquared = this.a * this.a;
				var bSquared = this.b * this.b;
				var x = sqrt(1 / ((1 / aSquared) + (mSquared / bSquared)));

				x = dx < 0 ? -x : x;
				var y = m * x;
				result = Point(this.x + x, this.y + y);
				if (angle) return result.rotate(Point(this.x, this.y), -angle);
				return result;
			},

			toString: function () {

				return Point(this.x, this.y).toString() + ' ' + this.a + ' ' + this.b;
			}
		};

		var Line = g.Line = function (p1, p2) {

			if (!(this instanceof Line)) {
				return new Line(p1, p2);
			}

			if (p1 instanceof Line) {
				return Line(p1.start, p1.end);
			}

			this.start = Point(p1);
			this.end = Point(p2);
		};

		g.Line.prototype = {

			// @return the bearing (cardinal direction) of the line. For example N, W, or SE.
			// @returns {String} One of the following bearings : NE, E, SE, S, SW, W, NW, N.
			bearing: function () {

				var lat1 = toRad(this.start.y);
				var lat2 = toRad(this.end.y);
				var lon1 = this.start.x;
				var lon2 = this.end.x;
				var dLon = toRad(lon2 - lon1);
				var y = sin(dLon) * cos(lat2);
				var x = cos(lat1) * sin(lat2) - sin(lat1) * cos(lat2) * cos(dLon);
				var brng = toDeg(atan2(y, x));

				var bearings = ['NE', 'E', 'SE', 'S', 'SW', 'W', 'NW', 'N'];

				var index = brng - 22.5;
				if (index < 0)
					index += 360;
				index = parseInt(index / 45);

				return bearings[index];
			},

			clone: function () {

				return Line(this.start, this.end);
			},

			equals: function (l) {

				return !!l &&
					this.start.x === l.start.x &&
					this.start.y === l.start.y &&
					this.end.x === l.end.x &&
					this.end.y === l.end.y;
			},

			// @return {point} Point where I'm intersecting a line.
			// @return [point] Points where I'm intersecting a rectangle.
			// @see Squeak Smalltalk, LineSegment>>intersectionWith:
			intersect: function (l) {

				if (l instanceof Line) {
					// Passed in parameter is a line.

					var pt1Dir = Point(this.end.x - this.start.x, this.end.y - this.start.y);
					var pt2Dir = Point(l.end.x - l.start.x, l.end.y - l.start.y);
					var det = (pt1Dir.x * pt2Dir.y) - (pt1Dir.y * pt2Dir.x);
					var deltaPt = Point(l.start.x - this.start.x, l.start.y - this.start.y);
					var alpha = (deltaPt.x * pt2Dir.y) - (deltaPt.y * pt2Dir.x);
					var beta = (deltaPt.x * pt1Dir.y) - (deltaPt.y * pt1Dir.x);

					if (det === 0 ||
						alpha * det < 0 ||
						beta * det < 0) {
						// No intersection found.
						return null;
					}
					if (det > 0) {
						if (alpha > det || beta > det) {
							return null;
						}
					} else {
						if (alpha < det || beta < det) {
							return null;
						}
					}
					return Point(
						this.start.x + (alpha * pt1Dir.x / det),
						this.start.y + (alpha * pt1Dir.y / det)
					);

				} else if (l instanceof Rect) {
					// Passed in parameter is a rectangle.

					var r = l;
					var rectLines = [r.topLine(), r.rightLine(), r.bottomLine(), r.leftLine()];
					var points = [];
					var dedupeArr = [];
					var pt, i;

					for (i = 0; i < rectLines.length; i++) {
						pt = this.intersect(rectLines[i]);
						if (pt !== null && dedupeArr.indexOf(pt.toString()) < 0) {
							points.push(pt);
							dedupeArr.push(pt.toString());
						}
					}

					return points.length > 0 ? points : null;
				}

				// Passed in parameter is neither a Line nor a Rectangle.
				return null;
			},

			// @return {double} length of the line
			length: function () {
				return sqrt(this.squaredLength());
			},

			// @return {point} my midpoint
			midpoint: function () {
				return Point(
					(this.start.x + this.end.x) / 2,
					(this.start.y + this.end.y) / 2
				);
			},

			// @return {point} my point at 't' <0,1>
			pointAt: function (t) {

				var x = (1 - t) * this.start.x + t * this.end.x;
				var y = (1 - t) * this.start.y + t * this.end.y;
				return Point(x, y);
			},

			// @return {number} the offset of the point `p` from the line. + if the point `p` is on the right side of the line, - if on the left and 0 if on the line.
			pointOffset: function (p) {

				// Find the sign of the determinant of vectors (start,end), where p is the query point.
				return ((this.end.x - this.start.x) * (p.y - this.start.y) - (this.end.y - this.start.y) * (p.x - this.start.x)) / 2;
			},

			// @return vector {point} of the line
			vector: function () {

				return Point(this.end.x - this.start.x, this.end.y - this.start.y);
			},

			// @return {point} the closest point on the line to point `p`
			closestPoint: function (p) {

				return this.pointAt(this.closestPointNormalizedLength(p));
			},

			// @return {number} the normalized length of the closest point on the line to point `p`
			closestPointNormalizedLength: function (p) {

				var product = this.vector().dot(Line(this.start, p).vector());

				return Math.min(1, Math.max(0, product / this.squaredLength()));
			},

			// @return {integer} length without sqrt
			// @note for applications where the exact length is not necessary (e.g. compare only)
			squaredLength: function () {
				var x0 = this.start.x;
				var y0 = this.start.y;
				var x1 = this.end.x;
				var y1 = this.end.y;
				return (x0 -= x1) * x0 + (y0 -= y1) * y0;
			},

			toString: function () {
				return this.start.toString() + ' ' + this.end.toString();
			}
		};

		// For backwards compatibility:
		g.Line.prototype.intersection = g.Line.prototype.intersect;

		/*
			Point is the most basic object consisting of x/y coordinate.
	
			Possible instantiations are:
			* `Point(10, 20)`
			* `new Point(10, 20)`
			* `Point('10 20')`
			* `Point(Point(10, 20))`
		*/
		var Point = g.Point = function (x, y) {

			if (!(this instanceof Point)) {
				return new Point(x, y);
			}

			if (typeof x === 'string') {
				var xy = x.split(x.indexOf('@') === -1 ? ' ' : '@');
				x = parseInt(xy[0], 10);
				y = parseInt(xy[1], 10);
			} else if (Object(x) === x) {
				y = x.y;
				x = x.x;
			}

			this.x = x === undefined ? 0 : x;
			this.y = y === undefined ? 0 : y;
		};

		// Alternative constructor, from polar coordinates.
		// @param {number} Distance.
		// @param {number} Angle in radians.
		// @param {point} [optional] Origin.
		g.Point.fromPolar = function (distance, angle, origin) {

			origin = (origin && Point(origin)) || Point(0, 0);
			var x = abs(distance * cos(angle));
			var y = abs(distance * sin(angle));
			var deg = normalizeAngle(toDeg(angle));

			if (deg < 90) {
				y = -y;
			} else if (deg < 180) {
				x = -x;
				y = -y;
			} else if (deg < 270) {
				x = -x;
			}

			return Point(origin.x + x, origin.y + y);
		};

		// Create a point with random coordinates that fall into the range `[x1, x2]` and `[y1, y2]`.
		g.Point.random = function (x1, x2, y1, y2) {

			return Point(floor(random() * (x2 - x1 + 1) + x1), floor(random() * (y2 - y1 + 1) + y1));
		};

		g.Point.prototype = {

			// If point lies outside rectangle `r`, return the nearest point on the boundary of rect `r`,
			// otherwise return point itself.
			// (see Squeak Smalltalk, Point>>adhereTo:)
			adhereToRect: function (r) {

				if (r.containsPoint(this)) {
					return this;
				}

				this.x = mmin(mmax(this.x, r.x), r.x + r.width);
				this.y = mmin(mmax(this.y, r.y), r.y + r.height);
				return this;
			},

			// Return the bearing between me and the given point.
			bearing: function (point) {

				return Line(this, point).bearing();
			},

			// Returns change in angle from my previous position (-dx, -dy) to my new position
			// relative to ref point.
			changeInAngle: function (dx, dy, ref) {

				// Revert the translation and measure the change in angle around x-axis.
				return Point(this).offset(-dx, -dy).theta(ref) - this.theta(ref);
			},

			clone: function () {

				return Point(this);
			},

			difference: function (dx, dy) {

				if ((Object(dx) === dx)) {
					dy = dx.y;
					dx = dx.x;
				}

				return Point(this.x - (dx || 0), this.y - (dy || 0));
			},

			// Returns distance between me and point `p`.
			distance: function (p) {

				return Line(this, p).length();
			},

			squaredDistance: function (p) {

				return Line(this, p).squaredLength();
			},

			equals: function (p) {

				return !!p && this.x === p.x && this.y === p.y;
			},

			magnitude: function () {

				return sqrt((this.x * this.x) + (this.y * this.y)) || 0.01;
			},

			// Returns a manhattan (taxi-cab) distance between me and point `p`.
			manhattanDistance: function (p) {

				return abs(p.x - this.x) + abs(p.y - this.y);
			},

			// Move point on line starting from ref ending at me by
			// distance distance.
			move: function (ref, distance) {

				var theta = toRad(Point(ref).theta(this));
				return this.offset(cos(theta) * distance, -sin(theta) * distance);
			},

			// Scales x and y such that the distance between the point and the origin (0,0) is equal to the given length.
			normalize: function (length) {

				var scale = (length || 1) / this.magnitude();
				return this.scale(scale, scale);
			},

			// Offset me by the specified amount.
			offset: function (dx, dy) {

				if ((Object(dx) === dx)) {
					dy = dx.y;
					dx = dx.x;
				}

				this.x += dx || 0;
				this.y += dy || 0;
				return this;
			},

			// Returns a point that is the reflection of me with
			// the center of inversion in ref point.
			reflection: function (ref) {

				return Point(ref).move(this, this.distance(ref));
			},

			// Rotate point by angle around origin.
			rotate: function (origin, angle) {

				angle = (angle + 360) % 360;
				this.toPolar(origin);
				this.y += toRad(angle);
				var point = Point.fromPolar(this.x, this.y, origin);
				this.x = point.x;
				this.y = point.y;
				return this;
			},

			round: function (precision) {

				var f = pow(10, precision || 0);
				this.x = round(this.x * f) / f;
				this.y = round(this.y * f) / f;
				return this;
			},

			// Scale point with origin.
			scale: function (sx, sy, origin) {

				origin = (origin && Point(origin)) || Point(0, 0);
				this.x = origin.x + sx * (this.x - origin.x);
				this.y = origin.y + sy * (this.y - origin.y);
				return this;
			},

			snapToGrid: function (gx, gy) {

				this.x = snapToGrid(this.x, gx);
				this.y = snapToGrid(this.y, gy || gx);
				return this;
			},

			// Compute the angle between me and `p` and the x axis.
			// (cartesian-to-polar coordinates conversion)
			// Return theta angle in degrees.
			theta: function (p) {

				p = Point(p);
				// Invert the y-axis.
				var y = -(p.y - this.y);
				var x = p.x - this.x;
				var rad = atan2(y, x); // defined for all 0 corner cases

				// Correction for III. and IV. quadrant.
				if (rad < 0) {
					rad = 2 * PI + rad;
				}
				return 180 * rad / PI;
			},

			// Compute the angle between vector from me to p1 and the vector from me to p2.
			// ordering of points p1 and p2 is important!
			// theta function's angle convention:
			// returns angles between 0 and 180 when the angle is counterclockwise
			// returns angles between 180 and 360 to convert clockwise angles into counterclockwise ones
			// returns NaN if any of the points p1, p2 is coincident with this point
			angleBetween: function (p1, p2) {

				var angleBetween = (this.equals(p1) || this.equals(p2)) ? NaN : (this.theta(p2) - this.theta(p1));
				if (angleBetween < 0) {
					angleBetween += 360; // correction to keep angleBetween between 0 and 360
				}
				return angleBetween;
			},

			// Compute the angle between the vector from 0,0 to me and the vector from 0,0 to p.
			// Returns NaN if p is at 0,0.
			vectorAngle: function (p) {

				var zero = Point(0, 0);
				return zero.angleBetween(this, p);
			},

			toJSON: function () {

				return { x: this.x, y: this.y };
			},

			// Converts rectangular to polar coordinates.
			// An origin can be specified, otherwise it's 0@0.
			toPolar: function (o) {

				o = (o && Point(o)) || Point(0, 0);
				var x = this.x;
				var y = this.y;
				this.x = sqrt((x - o.x) * (x - o.x) + (y - o.y) * (y - o.y)); // r
				this.y = toRad(o.theta(Point(x, y)));
				return this;
			},

			toString: function () {

				return this.x + '@' + this.y;
			},

			update: function (x, y) {

				this.x = x || 0;
				this.y = y || 0;
				return this;
			},

			// Returns the dot product of this point with given other point
			dot: function (p) {

				return p ? (this.x * p.x + this.y * p.y) : NaN;
			},

			// Returns the cross product of this point relative to two other points
			// this point is the common point
			// point p1 lies on the first vector, point p2 lies on the second vector
			// watch out for the ordering of points p1 and p2!
			// positive result indicates a clockwise ("right") turn from first to second vector
			// negative result indicates a counterclockwise ("left") turn from first to second vector
			// note that the above directions are reversed from the usual answer on the Internet
			// that is because we are in a left-handed coord system (because the y-axis points downward)
			cross: function (p1, p2) {

				return (p1 && p2) ? (((p2.x - this.x) * (p1.y - this.y)) - ((p2.y - this.y) * (p1.x - this.x))) : NaN;
			}
		};

		var Rect = g.Rect = function (x, y, w, h) {

			if (!(this instanceof Rect)) {
				return new Rect(x, y, w, h);
			}

			if ((Object(x) === x)) {
				y = x.y;
				w = x.width;
				h = x.height;
				x = x.x;
			}

			this.x = x === undefined ? 0 : x;
			this.y = y === undefined ? 0 : y;
			this.width = w === undefined ? 0 : w;
			this.height = h === undefined ? 0 : h;
		};

		g.Rect.fromEllipse = function (e) {

			e = Ellipse(e);
			return Rect(e.x - e.a, e.y - e.b, 2 * e.a, 2 * e.b);
		};

		g.Rect.prototype = {

			// Find my bounding box when I'm rotated with the center of rotation in the center of me.
			// @return r {rectangle} representing a bounding box
			bbox: function (angle) {

				var theta = toRad(angle || 0);
				var st = abs(sin(theta));
				var ct = abs(cos(theta));
				var w = this.width * ct + this.height * st;
				var h = this.width * st + this.height * ct;
				return Rect(this.x + (this.width - w) / 2, this.y + (this.height - h) / 2, w, h);
			},

			bottomLeft: function () {

				return Point(this.x, this.y + this.height);
			},

			bottomLine: function () {

				return Line(this.bottomLeft(), this.corner());
			},

			bottomMiddle: function () {

				return Point(this.x + this.width / 2, this.y + this.height);
			},

			center: function () {

				return Point(this.x + this.width / 2, this.y + this.height / 2);
			},

			clone: function () {

				return Rect(this);
			},

			// @return {bool} true if point p is insight me
			containsPoint: function (p) {

				p = Point(p);
				return p.x >= this.x && p.x <= this.x + this.width && p.y >= this.y && p.y <= this.y + this.height;
			},

			// @return {bool} true if rectangle `r` is inside me.
			containsRect: function (r) {

				var r0 = Rect(this).normalize();
				var r1 = Rect(r).normalize();
				var w0 = r0.width;
				var h0 = r0.height;
				var w1 = r1.width;
				var h1 = r1.height;

				if (!w0 || !h0 || !w1 || !h1) {
					// At least one of the dimensions is 0
					return false;
				}

				var x0 = r0.x;
				var y0 = r0.y;
				var x1 = r1.x;
				var y1 = r1.y;

				w1 += x1;
				w0 += x0;
				h1 += y1;
				h0 += y0;

				return x0 <= x1 && w1 <= w0 && y0 <= y1 && h1 <= h0;
			},

			corner: function () {

				return Point(this.x + this.width, this.y + this.height);
			},

			// @return {boolean} true if rectangles are equal.
			equals: function (r) {

				var mr = Rect(this).normalize();
				var nr = Rect(r).normalize();
				return mr.x === nr.x && mr.y === nr.y && mr.width === nr.width && mr.height === nr.height;
			},

			// @return {rect} if rectangles intersect, {null} if not.
			intersect: function (r) {

				var myOrigin = this.origin();
				var myCorner = this.corner();
				var rOrigin = r.origin();
				var rCorner = r.corner();

				// No intersection found
				if (rCorner.x <= myOrigin.x ||
					rCorner.y <= myOrigin.y ||
					rOrigin.x >= myCorner.x ||
					rOrigin.y >= myCorner.y) return null;

				var x = Math.max(myOrigin.x, rOrigin.x);
				var y = Math.max(myOrigin.y, rOrigin.y);

				return Rect(x, y, Math.min(myCorner.x, rCorner.x) - x, Math.min(myCorner.y, rCorner.y) - y);
			},

			// Find point on my boundary where line starting
			// from my center ending in point p intersects me.
			// @param {number} angle If angle is specified, intersection with rotated rectangle is computed.
			intersectionWithLineFromCenterToPoint: function (p, angle) {

				p = Point(p);
				var center = Point(this.x + this.width / 2, this.y + this.height / 2);
				var result;
				if (angle) p.rotate(center, angle);

				// (clockwise, starting from the top side)
				var sides = [
					Line(this.origin(), this.topRight()),
					Line(this.topRight(), this.corner()),
					Line(this.corner(), this.bottomLeft()),
					Line(this.bottomLeft(), this.origin())
				];
				var connector = Line(center, p);

				for (var i = sides.length - 1; i >= 0; --i) {
					var intersection = sides[i].intersection(connector);
					if (intersection !== null) {
						result = intersection;
						break;
					}
				}
				if (result && angle) result.rotate(center, -angle);
				return result;
			},

			leftLine: function () {

				return Line(this.origin(), this.bottomLeft());
			},

			leftMiddle: function () {

				return Point(this.x, this.y + this.height / 2);
			},

			// Move and expand me.
			// @param r {rectangle} representing deltas
			moveAndExpand: function (r) {

				this.x += r.x || 0;
				this.y += r.y || 0;
				this.width += r.width || 0;
				this.height += r.height || 0;
				return this;
			},

			// Offset me by the specified amount.
			offset: function (dx, dy) {
				return Point.prototype.offset.call(this, dx, dy);
			},

			// inflate by dx and dy, recompute origin [x, y]
			// @param dx {delta_x} representing additional size to x
			// @param dy {delta_y} representing additional size to y -
			// dy param is not required -> in that case y is sized by dx
			inflate: function (dx, dy) {
				if (dx === undefined) {
					dx = 0;
				}

				if (dy === undefined) {
					dy = dx;
				}

				this.x -= dx;
				this.y -= dy;
				this.width += 2 * dx;
				this.height += 2 * dy;

				return this;
			},

			// Normalize the rectangle; i.e., make it so that it has a non-negative width and height.
			// If width < 0 the function swaps the left and right corners,
			// and it swaps the top and bottom corners if height < 0
			// like in http://qt-project.org/doc/qt-4.8/qrectf.html#normalized
			normalize: function () {

				var newx = this.x;
				var newy = this.y;
				var newwidth = this.width;
				var newheight = this.height;
				if (this.width < 0) {
					newx = this.x + this.width;
					newwidth = -this.width;
				}
				if (this.height < 0) {
					newy = this.y + this.height;
					newheight = -this.height;
				}
				this.x = newx;
				this.y = newy;
				this.width = newwidth;
				this.height = newheight;
				return this;
			},

			origin: function () {

				return Point(this.x, this.y);
			},

			// @return {point} a point on my boundary nearest to the given point.
			// @see Squeak Smalltalk, Rectangle>>pointNearestTo:
			pointNearestToPoint: function (point) {

				point = Point(point);
				if (this.containsPoint(point)) {
					var side = this.sideNearestToPoint(point);
					switch (side) {
						case 'right': return Point(this.x + this.width, point.y);
						case 'left': return Point(this.x, point.y);
						case 'bottom': return Point(point.x, this.y + this.height);
						case 'top': return Point(point.x, this.y);
					}
				}
				return point.adhereToRect(this);
			},

			rightLine: function () {

				return Line(this.topRight(), this.corner());
			},

			rightMiddle: function () {

				return Point(this.x + this.width, this.y + this.height / 2);
			},

			round: function (precision) {

				var f = pow(10, precision || 0);
				this.x = round(this.x * f) / f;
				this.y = round(this.y * f) / f;
				this.width = round(this.width * f) / f;
				this.height = round(this.height * f) / f;
				return this;
			},

			// Scale rectangle with origin.
			scale: function (sx, sy, origin) {

				origin = this.origin().scale(sx, sy, origin);
				this.x = origin.x;
				this.y = origin.y;
				this.width *= sx;
				this.height *= sy;
				return this;
			},

			maxRectScaleToFit: function (rect, origin) {

				rect = g.Rect(rect);
				origin || (origin = rect.center());

				var sx1, sx2, sx3, sx4, sy1, sy2, sy3, sy4;
				var ox = origin.x;
				var oy = origin.y;

				// Here we find the maximal possible scale for all corner points (for x and y axis) of the rectangle,
				// so when the scale is applied the point is still inside the rectangle.

				sx1 = sx2 = sx3 = sx4 = sy1 = sy2 = sy3 = sy4 = Infinity;

				// Top Left
				var p1 = rect.origin();
				if (p1.x < ox) {
					sx1 = (this.x - ox) / (p1.x - ox);
				}
				if (p1.y < oy) {
					sy1 = (this.y - oy) / (p1.y - oy);
				}
				// Bottom Right
				var p2 = rect.corner();
				if (p2.x > ox) {
					sx2 = (this.x + this.width - ox) / (p2.x - ox);
				}
				if (p2.y > oy) {
					sy2 = (this.y + this.height - oy) / (p2.y - oy);
				}
				// Top Right
				var p3 = rect.topRight();
				if (p3.x > ox) {
					sx3 = (this.x + this.width - ox) / (p3.x - ox);
				}
				if (p3.y < oy) {
					sy3 = (this.y - oy) / (p3.y - oy);
				}
				// Bottom Left
				var p4 = rect.bottomLeft();
				if (p4.x < ox) {
					sx4 = (this.x - ox) / (p4.x - ox);
				}
				if (p4.y > oy) {
					sy4 = (this.y + this.height - oy) / (p4.y - oy);
				}

				return {
					sx: Math.min(sx1, sx2, sx3, sx4),
					sy: Math.min(sy1, sy2, sy3, sy4)
				};
			},

			maxRectUniformScaleToFit: function (rect, origin) {

				var scale = this.maxRectScaleToFit(rect, origin);
				return Math.min(scale.sx, scale.sy);
			},

			// @return {string} (left|right|top|bottom) side which is nearest to point
			// @see Squeak Smalltalk, Rectangle>>sideNearestTo:
			sideNearestToPoint: function (point) {

				point = Point(point);
				var distToLeft = point.x - this.x;
				var distToRight = (this.x + this.width) - point.x;
				var distToTop = point.y - this.y;
				var distToBottom = (this.y + this.height) - point.y;
				var closest = distToLeft;
				var side = 'left';

				if (distToRight < closest) {
					closest = distToRight;
					side = 'right';
				}
				if (distToTop < closest) {
					closest = distToTop;
					side = 'top';
				}
				if (distToBottom < closest) {
					closest = distToBottom;
					side = 'bottom';
				}
				return side;
			},

			snapToGrid: function (gx, gy) {

				var origin = this.origin().snapToGrid(gx, gy);
				var corner = this.corner().snapToGrid(gx, gy);
				this.x = origin.x;
				this.y = origin.y;
				this.width = corner.x - origin.x;
				this.height = corner.y - origin.y;
				return this;
			},

			topLine: function () {

				return Line(this.origin(), this.topRight());
			},

			topMiddle: function () {

				return Point(this.x + this.width / 2, this.y);
			},

			topRight: function () {

				return Point(this.x + this.width, this.y);
			},

			toJSON: function () {

				return { x: this.x, y: this.y, width: this.width, height: this.height };
			},

			toString: function () {

				return this.origin().toString() + ' ' + this.corner().toString();
			},

			// @return {rect} representing the union of both rectangles.
			union: function (rect) {

				rect = Rect(rect);
				var myOrigin = this.origin();
				var myCorner = this.corner();
				var rOrigin = rect.origin();
				var rCorner = rect.corner();

				var originX = Math.min(myOrigin.x, rOrigin.x);
				var originY = Math.min(myOrigin.y, rOrigin.y);
				var cornerX = Math.max(myCorner.x, rCorner.x);
				var cornerY = Math.max(myCorner.y, rCorner.y);

				return Rect(originX, originY, cornerX - originX, cornerY - originY);
			}
		};

		var Polyline = g.Polyline = function (points) {

			if (!(this instanceof Polyline)) {
				return new Polyline(points);
			}

			this.points = (Array.isArray(points)) ? points.map(Point) : [];
		};

		Polyline.prototype = {

			pointAtLength: function (length) {
				var points = this.points;
				var l = 0;
				for (var i = 0, n = points.length - 1; i < n; i++) {
					var a = points[i];
					var b = points[i + 1];
					var d = a.distance(b);
					l += d;
					if (length <= l) {
						return Line(b, a).pointAt(d ? (l - length) / d : 0);
					}
				}
				return null;
			},

			length: function () {
				var points = this.points;
				var length = 0;
				for (var i = 0, n = points.length - 1; i < n; i++) {
					length += points[i].distance(points[i + 1]);
				}
				return length;
			},

			closestPoint: function (p) {
				return this.pointAtLength(this.closestPointLength(p));
			},

			closestPointLength: function (p) {
				var points = this.points;
				var pointLength;
				var minSqrDistance = Infinity;
				var length = 0;
				for (var i = 0, n = points.length - 1; i < n; i++) {
					var line = Line(points[i], points[i + 1]);
					var lineLength = line.length();
					var cpNormalizedLength = line.closestPointNormalizedLength(p);
					var cp = line.pointAt(cpNormalizedLength);
					var sqrDistance = cp.squaredDistance(p);
					if (sqrDistance < minSqrDistance) {
						minSqrDistance = sqrDistance;
						pointLength = length + cpNormalizedLength * lineLength;
					}
					length += lineLength;
				}
				return pointLength;
			},

			toString: function () {

				return this.points + '';
			},

			// Returns a convex-hull polyline from this polyline.
			// this function implements the Graham scan (https://en.wikipedia.org/wiki/Graham_scan)
			// output polyline starts at the first element of the original polyline that is on the hull
			// output polyline then continues clockwise from that point
			convexHull: function () {

				var i;
				var n;

				var points = this.points;

				// step 1: find the starting point - point with the lowest y (if equality, highest x)
				var startPoint;
				n = points.length;
				for (i = 0; i < n; i++) {
					if (startPoint === undefined) {
						// if this is the first point we see, set it as start point
						startPoint = points[i];
					} else if (points[i].y < startPoint.y) {
						// start point should have lowest y from all points
						startPoint = points[i];
					} else if ((points[i].y === startPoint.y) && (points[i].x > startPoint.x)) {
						// if two points have the lowest y, choose the one that has highest x
						// there are no points to the right of startPoint - no ambiguity about theta 0
						// if there are several coincident start point candidates, first one is reported
						startPoint = points[i];
					}
				}

				// step 2: sort the list of points
				// sorting by angle between line from startPoint to point and the x-axis (theta)

				// step 2a: create the point records = [point, originalIndex, angle]
				var sortedPointRecords = [];
				n = points.length;
				for (i = 0; i < n; i++) {
					var angle = startPoint.theta(points[i]);
					if (angle === 0) {
						angle = 360; // give highest angle to start point
						// the start point will end up at end of sorted list
						// the start point will end up at beginning of hull points list
					}

					var entry = [points[i], i, angle];
					sortedPointRecords.push(entry);
				}

				// step 2b: sort the list in place
				sortedPointRecords.sort(function (record1, record2) {
					// returning a negative number here sorts record1 before record2
					// if first angle is smaller than second, first angle should come before second
					var sortOutput = record1[2] - record2[2];  // negative if first angle smaller
					if (sortOutput === 0) {
						// if the two angles are equal, sort by originalIndex
						sortOutput = record2[1] - record1[1]; // negative if first index larger
						// coincident points will be sorted in reverse-numerical order
						// so the coincident points with lower original index will be considered first
					}
					return sortOutput;
				});

				// step 2c: duplicate start record from the top of the stack to the bottom of the stack
				if (sortedPointRecords.length > 2) {
					var startPointRecord = sortedPointRecords[sortedPointRecords.length - 1];
					sortedPointRecords.unshift(startPointRecord);
				}

				// step 3a: go through sorted points in order and find those with right turns
				// we want to get our results in clockwise order
				var insidePoints = {}; // dictionary of points with left turns - cannot be on the hull
				var hullPointRecords = []; // stack of records with right turns - hull point candidates

				var currentPointRecord;
				var currentPoint;
				var lastHullPointRecord;
				var lastHullPoint;
				var secondLastHullPointRecord;
				var secondLastHullPoint;
				while (sortedPointRecords.length !== 0) {
					currentPointRecord = sortedPointRecords.pop();
					currentPoint = currentPointRecord[0];

					// check if point has already been discarded
					// keys for insidePoints are stored in the form 'point.x@point.y@@originalIndex'
					if (insidePoints.hasOwnProperty(currentPointRecord[0] + '@@' + currentPointRecord[1])) {
						// this point had an incorrect turn at some previous iteration of this loop
						// this disqualifies it from possibly being on the hull
						continue;
					}

					var correctTurnFound = false;
					while (!correctTurnFound) {
						if (hullPointRecords.length < 2) {
							// not enough points for comparison, just add current point
							hullPointRecords.push(currentPointRecord);
							correctTurnFound = true;

						} else {
							lastHullPointRecord = hullPointRecords.pop();
							lastHullPoint = lastHullPointRecord[0];
							secondLastHullPointRecord = hullPointRecords.pop();
							secondLastHullPoint = secondLastHullPointRecord[0];

							var crossProduct = secondLastHullPoint.cross(lastHullPoint, currentPoint);

							if (crossProduct < 0) {
								// found a right turn
								hullPointRecords.push(secondLastHullPointRecord);
								hullPointRecords.push(lastHullPointRecord);
								hullPointRecords.push(currentPointRecord);
								correctTurnFound = true;

							} else if (crossProduct === 0) {
								// the three points are collinear
								// three options:
								// there may be a 180 or 0 degree angle at lastHullPoint
								// or two of the three points are coincident
								var THRESHOLD = 1e-10; // we have to take rounding errors into account
								var angleBetween = lastHullPoint.angleBetween(secondLastHullPoint, currentPoint);
								if (Math.abs(angleBetween - 180) < THRESHOLD) { // rouding around 180 to 180
									// if the cross product is 0 because the angle is 180 degrees
									// discard last hull point (add to insidePoints)
									//insidePoints.unshift(lastHullPoint);
									insidePoints[lastHullPointRecord[0] + '@@' + lastHullPointRecord[1]] = lastHullPoint;
									// reenter second-to-last hull point (will be last at next iter)
									hullPointRecords.push(secondLastHullPointRecord);
									// do not do anything with current point
									// correct turn not found

								} else if (lastHullPoint.equals(currentPoint) || secondLastHullPoint.equals(lastHullPoint)) {
									// if the cross product is 0 because two points are the same
									// discard last hull point (add to insidePoints)
									//insidePoints.unshift(lastHullPoint);
									insidePoints[lastHullPointRecord[0] + '@@' + lastHullPointRecord[1]] = lastHullPoint;
									// reenter second-to-last hull point (will be last at next iter)
									hullPointRecords.push(secondLastHullPointRecord);
									// do not do anything with current point
									// correct turn not found

								} else if (Math.abs(((angleBetween + 1) % 360) - 1) < THRESHOLD) { // rounding around 0 and 360 to 0
									// if the cross product is 0 because the angle is 0 degrees
									// remove last hull point from hull BUT do not discard it
									// reenter second-to-last hull point (will be last at next iter)
									hullPointRecords.push(secondLastHullPointRecord);
									// put last hull point back into the sorted point records list
									sortedPointRecords.push(lastHullPointRecord);
									// we are switching the order of the 0deg and 180deg points
									// correct turn not found
								}

							} else {
								// found a left turn
								// discard last hull point (add to insidePoints)
								//insidePoints.unshift(lastHullPoint);
								insidePoints[lastHullPointRecord[0] + '@@' + lastHullPointRecord[1]] = lastHullPoint;
								// reenter second-to-last hull point (will be last at next iter of loop)
								hullPointRecords.push(secondLastHullPointRecord);
								// do not do anything with current point
								// correct turn not found
							}
						}
					}
				}
				// at this point, hullPointRecords contains the output points in clockwise order
				// the points start with lowest-y,highest-x startPoint, and end at the same point

				// step 3b: remove duplicated startPointRecord from the end of the array
				if (hullPointRecords.length > 2) {
					hullPointRecords.pop();
				}

				// step 4: find the lowest originalIndex record and put it at the beginning of hull
				var lowestHullIndex; // the lowest originalIndex on the hull
				var indexOfLowestHullIndexRecord = -1; // the index of the record with lowestHullIndex
				n = hullPointRecords.length;
				for (i = 0; i < n; i++) {
					var currentHullIndex = hullPointRecords[i][1];

					if (lowestHullIndex === undefined || currentHullIndex < lowestHullIndex) {
						lowestHullIndex = currentHullIndex;
						indexOfLowestHullIndexRecord = i;
					}
				}

				var hullPointRecordsReordered = [];
				if (indexOfLowestHullIndexRecord > 0) {
					var newFirstChunk = hullPointRecords.slice(indexOfLowestHullIndexRecord);
					var newSecondChunk = hullPointRecords.slice(0, indexOfLowestHullIndexRecord);
					hullPointRecordsReordered = newFirstChunk.concat(newSecondChunk);
				} else {
					hullPointRecordsReordered = hullPointRecords;
				}

				var hullPoints = [];
				n = hullPointRecordsReordered.length;
				for (i = 0; i < n; i++) {
					hullPoints.push(hullPointRecordsReordered[i][0]);
				}

				return Polyline(hullPoints);
			}
		};


		g.scale = {

			// Return the `value` from the `domain` interval scaled to the `range` interval.
			linear: function (domain, range, value) {

				var domainSpan = domain[1] - domain[0];
				var rangeSpan = range[1] - range[0];
				return (((value - domain[0]) / domainSpan) * rangeSpan + range[0]) || 0;
			}
		};

		var normalizeAngle = g.normalizeAngle = function (angle) {

			return (angle % 360) + (angle < 0 ? 360 : 0);
		};

		var snapToGrid = g.snapToGrid = function (value, gridSize) {

			return gridSize * Math.round(value / gridSize);
		};

		var toDeg = g.toDeg = function (rad) {

			return (180 * rad / PI) % 360;
		};

		var toRad = g.toRad = function (deg, over360) {

			over360 = over360 || false;
			deg = over360 ? deg : (deg % 360);
			return deg * PI / 180;
		};

		// For backwards compatibility:
		g.ellipse = g.Ellipse;
		g.line = g.Line;
		g.point = g.Point;
		g.rect = g.Rect;

		return g;

	})();

	// Vectorizer.
	// -----------

	// A tiny library for making your life easier when dealing with SVG.
	// The only Vectorizer dependency is the Geometry library.


	var V;
	var Vectorizer;

	V = Vectorizer = (function () {

		'use strict';

		var hasSvg = typeof window === 'object' &&
			!!(
				window.SVGAngle ||
				document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1')
			);

		// SVG support is required.
		if (!hasSvg) {

			// Return a function that throws an error when it is used.
			return function () {
				throw new Error('SVG is required to use Vectorizer.');
			};
		}

		// XML namespaces.
		var ns = {
			xmlns: 'http://www.w3.org/2000/svg',
			xml: 'http://www.w3.org/XML/1998/namespace',
			xlink: 'http://www.w3.org/1999/xlink'
		};

		var SVGversion = '1.1';

		var V = function (el, attrs, children) {

			// This allows using V() without the new keyword.
			if (!(this instanceof V)) {
				return V.apply(Object.create(V.prototype), arguments);
			}

			if (!el) return;

			if (V.isV(el)) {
				el = el.node;
			}

			attrs = attrs || {};

			if (V.isString(el)) {

				if (el.toLowerCase() === 'svg') {

					// Create a new SVG canvas.
					el = V.createSvgDocument();

				} else if (el[0] === '<') {

					// Create element from an SVG string.
					// Allows constructs of type: `document.appendChild(V('<rect></rect>').node)`.

					var svgDoc = V.createSvgDocument(el);

					// Note that `V()` might also return an array should the SVG string passed as
					// the first argument contain more than one root element.
					if (svgDoc.childNodes.length > 1) {

						// Map child nodes to `V`s.
						var arrayOfVels = [];
						var i, len;

						for (i = 0, len = svgDoc.childNodes.length; i < len; i++) {

							var childNode = svgDoc.childNodes[i];
							arrayOfVels.push(new V(document.importNode(childNode, true)));
						}

						return arrayOfVels;
					}

					el = document.importNode(svgDoc.firstChild, true);

				} else {

					el = document.createElementNS(ns.xmlns, el);
				}

				V.ensureId(el);
			}

			this.node = el;

			this.setAttributes(attrs);

			if (children) {
				this.append(children);
			}

			return this;
		};

		/**
		 * @param {SVGGElement} toElem
		 * @returns {SVGMatrix}
		 */
		V.prototype.getTransformToElement = function (toElem) {
			toElem = V.toNode(toElem);
			return toElem.getScreenCTM().inverse().multiply(this.node.getScreenCTM());
		};

		/**
		 * @param {SVGMatrix} matrix
		 * @param {Object=} opt
		 * @returns {Vectorizer|SVGMatrix} Setter / Getter
		 */
		V.prototype.transform = function (matrix, opt) {

			var node = this.node;
			if (V.isUndefined(matrix)) {
				return V.transformStringToMatrix(this.attr('transform'));
			}

			if (opt && opt.absolute) {
				return this.attr('transform', V.matrixToTransformString(matrix));
			}

			var svgTransform = V.createSVGTransform(matrix);
			node.transform.baseVal.appendItem(svgTransform);
			return this;
		};

		V.prototype.translate = function (tx, ty, opt) {

			opt = opt || {};
			ty = ty || 0;

			var transformAttr = this.attr('transform') || '';
			var transform = V.parseTransformString(transformAttr);
			transformAttr = transform.value;
			// Is it a getter?
			if (V.isUndefined(tx)) {
				return transform.translate;
			}

			transformAttr = transformAttr.replace(/translate\([^\)]*\)/g, '').trim();

			var newTx = opt.absolute ? tx : transform.translate.tx + tx;
			var newTy = opt.absolute ? ty : transform.translate.ty + ty;
			var newTranslate = 'translate(' + newTx + ',' + newTy + ')';

			// Note that `translate()` is always the first transformation. This is
			// usually the desired case.
			this.attr('transform', (newTranslate + ' ' + transformAttr).trim());
			return this;
		};

		V.prototype.rotate = function (angle, cx, cy, opt) {

			opt = opt || {};

			var transformAttr = this.attr('transform') || '';
			var transform = V.parseTransformString(transformAttr);
			transformAttr = transform.value;

			// Is it a getter?
			if (V.isUndefined(angle)) {
				return transform.rotate;
			}

			transformAttr = transformAttr.replace(/rotate\([^\)]*\)/g, '').trim();

			angle %= 360;

			var newAngle = opt.absolute ? angle : transform.rotate.angle + angle;
			var newOrigin = (cx !== undefined && cy !== undefined) ? ',' + cx + ',' + cy : '';
			var newRotate = 'rotate(' + newAngle + newOrigin + ')';

			this.attr('transform', (transformAttr + ' ' + newRotate).trim());
			return this;
		};

		// Note that `scale` as the only transformation does not combine with previous values.
		V.prototype.scale = function (sx, sy) {

			sy = V.isUndefined(sy) ? sx : sy;

			var transformAttr = this.attr('transform') || '';
			var transform = V.parseTransformString(transformAttr);
			transformAttr = transform.value;

			// Is it a getter?
			if (V.isUndefined(sx)) {
				return transform.scale;
			}

			transformAttr = transformAttr.replace(/scale\([^\)]*\)/g, '').trim();

			var newScale = 'scale(' + sx + ',' + sy + ')';

			this.attr('transform', (transformAttr + ' ' + newScale).trim());
			return this;
		};

		// Get SVGRect that contains coordinates and dimension of the real bounding box,
		// i.e. after transformations are applied.
		// If `target` is specified, bounding box will be computed relatively to `target` element.
		V.prototype.bbox = function (withoutTransformations, target) {

			var box;
			var node = this.node;
			var ownerSVGElement = node.ownerSVGElement;

			// If the element is not in the live DOM, it does not have a bounding box defined and
			// so fall back to 'zero' dimension element.
			if (!ownerSVGElement) {
				return g.Rect(0, 0, 0, 0);
			}

			try {

				box = node.getBBox();

			} catch (e) {

				// Fallback for IE.
				box = {
					x: node.clientLeft,
					y: node.clientTop,
					width: node.clientWidth,
					height: node.clientHeight
				};
			}

			if (withoutTransformations) {
				return g.Rect(box);
			}

			var matrix = this.getTransformToElement(target || ownerSVGElement);

			return V.transformRect(box, matrix);
		};

		// Returns an SVGRect that contains coordinates and dimensions of the real bounding box,
		// i.e. after transformations are applied.
		// Fixes a browser implementation bug that returns incorrect bounding boxes for groups of svg elements.
		// Takes an (Object) `opt` argument (optional) with the following attributes:
		// (Object) `target` (optional): if not undefined, transform bounding boxes relative to `target`; if undefined, transform relative to this
		// (Boolean) `recursive` (optional): if true, recursively enter all groups and get a union of element bounding boxes (svg bbox fix); if false or undefined, return result of native function this.node.getBBox();
		V.prototype.getBBox = function (opt) {

			var options = {};

			var outputBBox;
			var node = this.node;
			var ownerSVGElement = node.ownerSVGElement;

			// If the element is not in the live DOM, it does not have a bounding box defined and
			// so fall back to 'zero' dimension element.
			if (!ownerSVGElement) {
				return g.Rect(0, 0, 0, 0);
			}

			if (opt) {
				if (opt.target) { // check if target exists
					options.target = V.toNode(opt.target); // works for V objects, jquery objects, and node objects
				}
				if (opt.recursive) {
					options.recursive = opt.recursive;
				}
			}

			if (!options.recursive) {
				try {
					outputBBox = node.getBBox();
				} catch (e) {
					// Fallback for IE.
					outputBBox = {
						x: node.clientLeft,
						y: node.clientTop,
						width: node.clientWidth,
						height: node.clientHeight
					};
				}

				if (!options.target) {
					// transform like this (that is, not at all)
					return g.Rect(outputBBox);
				} else {
					// transform like target
					var matrix = this.getTransformToElement(options.target);
					return V.transformRect(outputBBox, matrix);
				}
			} else { // if we want to calculate the bbox recursively
				// browsers report correct bbox around svg elements (one that envelops the path lines tightly)
				// but some browsers fail to report the same bbox when the elements are in a group (returning a looser bbox that also includes control points, like node.getClientRect())
				// this happens even if we wrap a single svg element into a group!
				// this option setting makes the function recursively enter all the groups from this and deeper, get bboxes of the elements inside, then return a union of those bboxes

				var children = this.children();
				var n = children.length;

				if (n === 0) {
					return this.getBBox({ target: options.target, recursive: false });
				}

				// recursion's initial pass-through setting:
				// recursive passes-through just keep the target as whatever was set up here during the initial pass-through
				if (!options.target) {
					// transform children/descendants like this (their parent/ancestor)
					options.target = this;
				} // else transform children/descendants like target

				for (var i = 0; i < n; i++) {
					var currentChild = children[i];

					var childBBox;

					// if currentChild is not a group element, get its bbox with a nonrecursive call
					if (currentChild.children().length === 0) {
						childBBox = currentChild.getBBox({ target: options.target, recursive: false });
					}
					else {
						// if currentChild is a group element (determined by checking the number of children), enter it with a recursive call
						childBBox = currentChild.getBBox({ target: options.target, recursive: true });
					}

					if (!outputBBox) {
						// if this is the first iteration
						outputBBox = childBBox;
					} else {
						// make a new bounding box rectangle that contains this child's bounding box and previous bounding box
						outputBBox = outputBBox.union(childBBox);
					}
				}

				return outputBBox;
			}
		};

		V.prototype.text = function (content, opt) {

			// Replace all spaces with the Unicode No-break space (http://www.fileformat.info/info/unicode/char/a0/index.htm).
			// IE would otherwise collapse all spaces into one.
			content = V.sanitizeText(content);
			opt = opt || {};
			var eol = opt.eol;
			var lines = content.split('\n');
			var tspan;

			// An empty text gets rendered into the DOM in webkit-based browsers.
			// In order to unify this behaviour across all browsers
			// we rather hide the text element when it's empty.
			if (content) {
				this.removeAttr('display');
			} else {
				this.attr('display', 'none');
			}

			// Preserve spaces. In other words, we do not want consecutive spaces to get collapsed to one.
			this.attr('xml:space', 'preserve');

			// Easy way to erase all `<tspan>` children;
			this.node.textContent = '';

			var textNode = this.node;

			if (opt.textPath) {

				// Wrap the text in the SVG <textPath> element that points
				// to a path defined by `opt.textPath` inside the internal `<defs>` element.
				var defs = this.find('defs');
				if (defs.length === 0) {
					defs = V('defs');
					this.append(defs);
				}

				// If `opt.textPath` is a plain string, consider it to be directly the
				// SVG path data for the text to go along (this is a shortcut).
				// Otherwise if it is an object and contains the `d` property, then this is our path.
				var d = Object(opt.textPath) === opt.textPath ? opt.textPath.d : opt.textPath;
				if (d) {
					var path = V('path', { d: d });
					defs.append(path);
				}

				var textPath = V('textPath');
				// Set attributes on the `<textPath>`. The most important one
				// is the `xlink:href` that points to our newly created `<path/>` element in `<defs/>`.
				// Note that we also allow the following construct:
				// `t.text('my text', { textPath: { 'xlink:href': '#my-other-path' } })`.
				// In other words, one can completely skip the auto-creation of the path
				// and use any other arbitrary path that is in the document.
				if (!opt.textPath['xlink:href'] && path) {
					textPath.attr('xlink:href', '#' + path.node.id);
				}

				if (Object(opt.textPath) === opt.textPath) {
					textPath.attr(opt.textPath);
				}
				this.append(textPath);
				// Now all the `<tspan>`s will be inside the `<textPath>`.
				textNode = textPath.node;
			}

			var offset = 0;
			var x = ((opt.x !== undefined) ? opt.x : this.attr('x')) || 0;

			// Shift all the <tspan> but first by one line (`1em`)
			var lineHeight = opt.lineHeight || '1em';
			if (opt.lineHeight === 'auto') {
				lineHeight = '1.5em';
			}

			var firstLineHeight = 0;
			for (var i = 0; i < lines.length; i++) {

				var vLineAttributes = { 'class': 'v-line' };
				if (i === 0) {
					vLineAttributes.dy = '0em';
				} else {
					vLineAttributes.dy = lineHeight;
					vLineAttributes.x = x;
				}
				var vLine = V('tspan', vLineAttributes);

				var lastI = lines.length - 1;
				var line = lines[i];
				if (line) {

					// Get the line height based on the biggest font size in the annotations for this line.
					var maxFontSize = 0;
					if (opt.annotations) {

						// Find the *compacted* annotations for this line.
						var lineAnnotations = V.annotateString(lines[i], V.isArray(opt.annotations) ? opt.annotations : [opt.annotations], { offset: -offset, includeAnnotationIndices: opt.includeAnnotationIndices });

						var lastJ = lineAnnotations.length - 1;
						for (var j = 0; j < lineAnnotations.length; j++) {

							var annotation = lineAnnotations[j];
							if (V.isObject(annotation)) {

								var fontSize = parseFloat(annotation.attrs['font-size']);
								if (fontSize && fontSize > maxFontSize) {
									maxFontSize = fontSize;
								}

								tspan = V('tspan', annotation.attrs);
								if (opt.includeAnnotationIndices) {
									// If `opt.includeAnnotationIndices` is `true`,
									// set the list of indices of all the applied annotations
									// in the `annotations` attribute. This list is a comma
									// separated list of indices.
									tspan.attr('annotations', annotation.annotations);
								}
								if (annotation.attrs['class']) {
									tspan.addClass(annotation.attrs['class']);
								}

								if (eol && j === lastJ && i !== lastI) {
									annotation.t += eol;
								}
								tspan.node.textContent = annotation.t;

							} else {

								if (eol && j === lastJ && i !== lastI) {
									annotation += eol;
								}
								tspan = document.createTextNode(annotation || ' ');
							}
							vLine.append(tspan);
						}

						if (opt.lineHeight === 'auto' && maxFontSize && i !== 0) {

							vLine.attr('dy', (maxFontSize * 1.2) + 'px');
						}

					} else {

						if (eol && i !== lastI) {
							line += eol;
						}

						vLine.node.textContent = line;
					}

					if (i === 0) {
						firstLineHeight = maxFontSize;
					}
				} else {

					// Make sure the textContent is never empty. If it is, add a dummy
					// character and make it invisible, making the following lines correctly
					// relatively positioned. `dy=1em` won't work with empty lines otherwise.
					vLine.addClass('v-empty-line');
					// 'opacity' needs to be specified with fill, stroke. Opacity without specification
					// is not applied in Firefox
					vLine.node.style.fillOpacity = 0;
					vLine.node.style.strokeOpacity = 0;
					vLine.node.textContent = '-';
				}

				V(textNode).append(vLine);

				offset += line.length + 1;      // + 1 = newline character.
			}

			// `alignment-baseline` does not work in Firefox.
			// Setting `dominant-baseline` on the `<text>` element doesn't work in IE9.
			// In order to have the 0,0 coordinate of the `<text>` element (or the first `<tspan>`)
			// in the top left corner we translate the `<text>` element by `0.8em`.
			// See `http://www.w3.org/Graphics/SVG/WG/wiki/How_to_determine_dominant_baseline`.
			// See also `http://apike.ca/prog_svg_text_style.html`.
			var y = this.attr('y');
			if (y === null) {
				this.attr('y', firstLineHeight || '0.8em');
			}

			return this;
		};

		/**
		 * @public
		 * @param {string} name
		 * @returns {Vectorizer}
		 */
		V.prototype.removeAttr = function (name) {

			var qualifiedName = V.qualifyAttr(name);
			var el = this.node;

			if (qualifiedName.ns) {
				if (el.hasAttributeNS(qualifiedName.ns, qualifiedName.local)) {
					el.removeAttributeNS(qualifiedName.ns, qualifiedName.local);
				}
			} else if (el.hasAttribute(name)) {
				el.removeAttribute(name);
			}
			return this;
		};

		V.prototype.attr = function (name, value) {

			if (V.isUndefined(name)) {

				// Return all attributes.
				var attributes = this.node.attributes;
				var attrs = {};

				for (var i = 0; i < attributes.length; i++) {
					attrs[attributes[i].name] = attributes[i].value;
				}

				return attrs;
			}

			if (V.isString(name) && V.isUndefined(value)) {
				return this.node.getAttribute(name);
			}

			if (typeof name === 'object') {

				for (var attrName in name) {
					if (name.hasOwnProperty(attrName)) {
						this.setAttribute(attrName, name[attrName]);
					}
				}

			} else {

				this.setAttribute(name, value);
			}

			return this;
		};

		V.prototype.remove = function () {

			if (this.node.parentNode) {
				this.node.parentNode.removeChild(this.node);
			}

			return this;
		};

		V.prototype.empty = function () {

			while (this.node.firstChild) {
				this.node.removeChild(this.node.firstChild);
			}

			return this;
		};

		/**
		 * @private
		 * @param {object} attrs
		 * @returns {Vectorizer}
		 */
		V.prototype.setAttributes = function (attrs) {

			for (var key in attrs) {
				if (attrs.hasOwnProperty(key)) {
					this.setAttribute(key, attrs[key]);
				}
			}

			return this;
		};

		V.prototype.append = function (els) {

			if (!V.isArray(els)) {
				els = [els];
			}

			for (var i = 0, len = els.length; i < len; i++) {
				this.node.appendChild(V.toNode(els[i]));
			}

			return this;
		};

		V.prototype.prepend = function (els) {

			var child = this.node.firstChild;
			return child ? V(child).before(els) : this.append(els);
		};

		V.prototype.before = function (els) {

			var node = this.node;
			var parent = node.parentNode;

			if (parent) {

				if (!V.isArray(els)) {
					els = [els];
				}

				for (var i = 0, len = els.length; i < len; i++) {
					parent.insertBefore(V.toNode(els[i]), node);
				}
			}

			return this;
		};

		V.prototype.appendTo = function (node) {
			V.toNode(node).appendChild(this.node);
			return this;
		},

			V.prototype.svg = function () {

				return this.node instanceof window.SVGSVGElement ? this : V(this.node.ownerSVGElement);
			};

		V.prototype.defs = function () {

			var defs = this.svg().node.getElementsByTagName('defs');

			return (defs && defs.length) ? V(defs[0]) : undefined;
		};

		V.prototype.clone = function () {

			var clone = V(this.node.cloneNode(true/* deep */));
			// Note that clone inherits also ID. Therefore, we need to change it here.
			clone.node.id = V.uniqueId();
			return clone;
		};

		V.prototype.findOne = function (selector) {

			var found = this.node.querySelector(selector);
			return found ? V(found) : undefined;
		};

		V.prototype.find = function (selector) {

			var vels = [];
			var nodes = this.node.querySelectorAll(selector);

			if (nodes) {

				// Map DOM elements to `V`s.
				for (var i = 0; i < nodes.length; i++) {
					vels.push(V(nodes[i]));
				}
			}

			return vels;
		};

		// Returns an array of V elements made from children of this.node.
		V.prototype.children = function () {

			var children = this.node.childNodes;

			var outputArray = [];
			for (var i = 0; i < children.length; i++) {
				var currentChild = children[i];
				if (currentChild.nodeType === 1) {
					outputArray.push(V(children[i]));
				}
			}
			return outputArray;
		};

		// Find an index of an element inside its container.
		V.prototype.index = function () {

			var index = 0;
			var node = this.node.previousSibling;

			while (node) {
				// nodeType 1 for ELEMENT_NODE
				if (node.nodeType === 1) index++;
				node = node.previousSibling;
			}

			return index;
		};

		V.prototype.findParentByClass = function (className, terminator) {

			var ownerSVGElement = this.node.ownerSVGElement;
			var node = this.node.parentNode;

			while (node && node !== terminator && node !== ownerSVGElement) {

				var vel = V(node);
				if (vel.hasClass(className)) {
					return vel;
				}

				node = node.parentNode;
			}

			return null;
		};

		// https://jsperf.com/get-common-parent
		V.prototype.contains = function (el) {

			var a = this.node;
			var b = V.toNode(el);
			var bup = b && b.parentNode;

			return (a === bup) || !!(bup && bup.nodeType === 1 && (a.compareDocumentPosition(bup) & 16));
		};

		// Convert global point into the coordinate space of this element.
		V.prototype.toLocalPoint = function (x, y) {

			var svg = this.svg().node;

			var p = svg.createSVGPoint();
			p.x = x;
			p.y = y;

			try {

				var globalPoint = p.matrixTransform(svg.getScreenCTM().inverse());
				var globalToLocalMatrix = this.getTransformToElement(svg).inverse();

			} catch (e) {
				// IE9 throws an exception in odd cases. (`Unexpected call to method or property access`)
				// We have to make do with the original coordianates.
				return p;
			}

			return globalPoint.matrixTransform(globalToLocalMatrix);
		};

		V.prototype.translateCenterToPoint = function (p) {

			var bbox = this.getBBox({ target: this.svg() });
			var center = bbox.center();

			this.translate(p.x - center.x, p.y - center.y);
			return this;
		};

		// Efficiently auto-orient an element. This basically implements the orient=auto attribute
		// of markers. The easiest way of understanding on what this does is to imagine the element is an
		// arrowhead. Calling this method on the arrowhead makes it point to the `position` point while
		// being auto-oriented (properly rotated) towards the `reference` point.
		// `target` is the element relative to which the transformations are applied. Usually a viewport.
		V.prototype.translateAndAutoOrient = function (position, reference, target) {

			// Clean-up previously set transformations except the scale. If we didn't clean up the
			// previous transformations then they'd add up with the old ones. Scale is an exception as
			// it doesn't add up, consider: `this.scale(2).scale(2).scale(2)`. The result is that the
			// element is scaled by the factor 2, not 8.

			var s = this.scale();
			this.attr('transform', '');
			this.scale(s.sx, s.sy);

			var svg = this.svg().node;
			var bbox = this.getBBox({ target: target || svg });

			// 1. Translate to origin.
			var translateToOrigin = svg.createSVGTransform();
			translateToOrigin.setTranslate(-bbox.x - bbox.width / 2, -bbox.y - bbox.height / 2);

			// 2. Rotate around origin.
			var rotateAroundOrigin = svg.createSVGTransform();
			var angle = g.point(position).changeInAngle(position.x - reference.x, position.y - reference.y, reference);
			rotateAroundOrigin.setRotate(angle, 0, 0);

			// 3. Translate to the `position` + the offset (half my width) towards the `reference` point.
			var translateFinal = svg.createSVGTransform();
			var finalPosition = g.point(position).move(reference, bbox.width / 2);
			translateFinal.setTranslate(position.x + (position.x - finalPosition.x), position.y + (position.y - finalPosition.y));

			// 4. Apply transformations.
			var ctm = this.getTransformToElement(target || svg);
			var transform = svg.createSVGTransform();
			transform.setMatrix(
				translateFinal.matrix.multiply(
					rotateAroundOrigin.matrix.multiply(
						translateToOrigin.matrix.multiply(
							ctm)))
			);

			// Instead of directly setting the `matrix()` transform on the element, first, decompose
			// the matrix into separate transforms. This allows us to use normal Vectorizer methods
			// as they don't work on matrices. An example of this is to retrieve a scale of an element.
			// this.node.transform.baseVal.initialize(transform);

			var decomposition = V.decomposeMatrix(transform.matrix);

			this.translate(decomposition.translateX, decomposition.translateY);
			this.rotate(decomposition.rotation);
			// Note that scale has been already applied, hence the following line stays commented. (it's here just for reference).
			//this.scale(decomposition.scaleX, decomposition.scaleY);

			return this;
		};

		V.prototype.animateAlongPath = function (attrs, path) {

			path = V.toNode(path);

			var id = V.ensureId(path);
			var animateMotion = V('animateMotion', attrs);
			var mpath = V('mpath', { 'xlink:href': '#' + id });

			animateMotion.append(mpath);

			this.append(animateMotion);
			try {
				animateMotion.node.beginElement();
			} catch (e) {
				// Fallback for IE 9.
				// Run the animation programatically if FakeSmile (`http://leunen.me/fakesmile/`) present
				if (document.documentElement.getAttribute('smiling') === 'fake') {

					// Register the animation. (See `https://answers.launchpad.net/smil/+question/203333`)
					var animation = animateMotion.node;
					animation.animators = [];

					var animationID = animation.getAttribute('id');
					if (animationID) id2anim[animationID] = animation;

					var targets = getTargets(animation);
					for (var i = 0, len = targets.length; i < len; i++) {
						var target = targets[i];
						var animator = new Animator(animation, target, i);
						animators.push(animator);
						animation.animators[i] = animator;
						animator.register();
					}
				}
			}
			return this;
		};

		V.prototype.hasClass = function (className) {

			return new RegExp('(\\s|^)' + className + '(\\s|$)').test(this.node.getAttribute('class'));
		};

		V.prototype.addClass = function (className) {

			if (!this.hasClass(className)) {
				var prevClasses = this.node.getAttribute('class') || '';
				this.node.setAttribute('class', (prevClasses + ' ' + className).trim());
			}

			return this;
		};

		V.prototype.removeClass = function (className) {

			if (this.hasClass(className)) {
				var newClasses = this.node.getAttribute('class').replace(new RegExp('(\\s|^)' + className + '(\\s|$)', 'g'), '$2');
				this.node.setAttribute('class', newClasses);
			}

			return this;
		};

		V.prototype.toggleClass = function (className, toAdd) {

			var toRemove = V.isUndefined(toAdd) ? this.hasClass(className) : !toAdd;

			if (toRemove) {
				this.removeClass(className);
			} else {
				this.addClass(className);
			}

			return this;
		};

		// Interpolate path by discrete points. The precision of the sampling
		// is controlled by `interval`. In other words, `sample()` will generate
		// a point on the path starting at the beginning of the path going to the end
		// every `interval` pixels.
		// The sampler can be very useful for e.g. finding intersection between two
		// paths (finding the two closest points from two samples).
		V.prototype.sample = function (interval) {

			interval = interval || 1;
			var node = this.node;
			var length = node.getTotalLength();
			var samples = [];
			var distance = 0;
			var sample;
			while (distance < length) {
				sample = node.getPointAtLength(distance);
				samples.push({ x: sample.x, y: sample.y, distance: distance });
				distance += interval;
			}
			return samples;
		};

		V.prototype.convertToPath = function () {

			var path = V('path');
			path.attr(this.attr());
			var d = this.convertToPathData();
			if (d) {
				path.attr('d', d);
			}
			return path;
		};

		V.prototype.convertToPathData = function () {

			var tagName = this.node.tagName.toUpperCase();

			switch (tagName) {
				case 'PATH':
					return this.attr('d');
				case 'LINE':
					return V.convertLineToPathData(this.node);
				case 'POLYGON':
					return V.convertPolygonToPathData(this.node);
				case 'POLYLINE':
					return V.convertPolylineToPathData(this.node);
				case 'ELLIPSE':
					return V.convertEllipseToPathData(this.node);
				case 'CIRCLE':
					return V.convertCircleToPathData(this.node);
				case 'RECT':
					return V.convertRectToPathData(this.node);
			}

			throw new Error(tagName + ' cannot be converted to PATH.');
		};

		// Find the intersection of a line starting in the center
		// of the SVG `node` ending in the point `ref`.
		// `target` is an SVG element to which `node`s transformations are relative to.
		// In JointJS, `target` is the `paper.viewport` SVG group element.
		// Note that `ref` point must be in the coordinate system of the `target` for this function to work properly.
		// Returns a point in the `target` coordinte system (the same system as `ref` is in) if
		// an intersection is found. Returns `undefined` otherwise.
		V.prototype.findIntersection = function (ref, target) {

			var svg = this.svg().node;
			target = target || svg;
			var bbox = this.getBBox({ target: target });
			var center = bbox.center();

			if (!bbox.intersectionWithLineFromCenterToPoint(ref)) return undefined;

			var spot;
			var tagName = this.node.localName.toUpperCase();

			// Little speed up optimalization for `<rect>` element. We do not do conversion
			// to path element and sampling but directly calculate the intersection through
			// a transformed geometrical rectangle.
			if (tagName === 'RECT') {

				var gRect = g.rect(
					parseFloat(this.attr('x') || 0),
					parseFloat(this.attr('y') || 0),
					parseFloat(this.attr('width')),
					parseFloat(this.attr('height'))
				);
				// Get the rect transformation matrix with regards to the SVG document.
				var rectMatrix = this.getTransformToElement(target);
				// Decompose the matrix to find the rotation angle.
				var rectMatrixComponents = V.decomposeMatrix(rectMatrix);
				// Now we want to rotate the rectangle back so that we
				// can use `intersectionWithLineFromCenterToPoint()` passing the angle as the second argument.
				var resetRotation = svg.createSVGTransform();
				resetRotation.setRotate(-rectMatrixComponents.rotation, center.x, center.y);
				var rect = V.transformRect(gRect, resetRotation.matrix.multiply(rectMatrix));
				spot = g.rect(rect).intersectionWithLineFromCenterToPoint(ref, rectMatrixComponents.rotation);

			} else if (tagName === 'PATH' || tagName === 'POLYGON' || tagName === 'POLYLINE' || tagName === 'CIRCLE' || tagName === 'ELLIPSE') {

				var pathNode = (tagName === 'PATH') ? this : this.convertToPath();
				var samples = pathNode.sample();
				var minDistance = Infinity;
				var closestSamples = [];

				var i, sample, gp, centerDistance, refDistance, distance;

				for (i = 0; i < samples.length; i++) {

					sample = samples[i];
					// Convert the sample point in the local coordinate system to the global coordinate system.
					gp = V.createSVGPoint(sample.x, sample.y);
					gp = gp.matrixTransform(this.getTransformToElement(target));
					sample = g.point(gp);
					centerDistance = sample.distance(center);
					// Penalize a higher distance to the reference point by 10%.
					// This gives better results. This is due to
					// inaccuracies introduced by rounding errors and getPointAtLength() returns.
					refDistance = sample.distance(ref) * 1.1;
					distance = centerDistance + refDistance;

					if (distance < minDistance) {
						minDistance = distance;
						closestSamples = [{ sample: sample, refDistance: refDistance }];
					} else if (distance < minDistance + 1) {
						closestSamples.push({ sample: sample, refDistance: refDistance });
					}
				}

				closestSamples.sort(function (a, b) {
					return a.refDistance - b.refDistance;
				});

				if (closestSamples[0]) {
					spot = closestSamples[0].sample;
				}
			}

			return spot;
		};

		/**
		 * @private
		 * @param {string} name
		 * @param {string} value
		 * @returns {Vectorizer}
		 */
		V.prototype.setAttribute = function (name, value) {

			var el = this.node;

			if (value === null) {
				this.removeAttr(name);
				return this;
			}

			var qualifiedName = V.qualifyAttr(name);

			if (qualifiedName.ns) {
				// Attribute names can be namespaced. E.g. `image` elements
				// have a `xlink:href` attribute to set the source of the image.
				el.setAttributeNS(qualifiedName.ns, name, value);
			} else if (name === 'id') {
				el.id = value;
			} else {
				el.setAttribute(name, value);
			}

			return this;
		};

		// Create an SVG document element.
		// If `content` is passed, it will be used as the SVG content of the `<svg>` root element.
		V.createSvgDocument = function (content) {

			var svg = '<svg xmlns="' + ns.xmlns + '" xmlns:xlink="' + ns.xlink + '" version="' + SVGversion + '">' + (content || '') + '</svg>';
			var xml = V.parseXML(svg, { async: false });
			return xml.documentElement;
		};

		V.idCounter = 0;

		// A function returning a unique identifier for this client session with every call.
		V.uniqueId = function () {

			return 'v-' + (++V.idCounter);
		};

		V.toNode = function (el) {
			return V.isV(el) ? el.node : (el.nodeName && el || el[0]);
		};

		V.ensureId = function (node) {
			node = V.toNode(node);
			return node.id || (node.id = V.uniqueId());
		};
		// Replace all spaces with the Unicode No-break space (http://www.fileformat.info/info/unicode/char/a0/index.htm).
		// IE would otherwise collapse all spaces into one. This is used in the text() method but it is
		// also exposed so that the programmer can use it in case he needs to. This is useful e.g. in tests
		// when you want to compare the actual DOM text content without having to add the unicode character in
		// the place of all spaces.
		V.sanitizeText = function (text) {

			return (text || '').replace(/ /g, '\u00A0');
		};

		V.isUndefined = function (value) {

			return typeof value === 'undefined';
		};

		V.isString = function (value) {

			return typeof value === 'string';
		};

		V.isObject = function (value) {

			return value && (typeof value === 'object');
		};

		V.isArray = Array.isArray;

		V.parseXML = function (data, opt) {

			opt = opt || {};

			var xml;

			try {
				var parser = new DOMParser();

				if (!V.isUndefined(opt.async)) {
					parser.async = opt.async;
				}

				xml = parser.parseFromString(data, 'text/xml');
			} catch (error) {
				xml = undefined;
			}

			if (!xml || xml.getElementsByTagName('parsererror').length) {
				throw new Error('Invalid XML: ' + data);
			}

			return xml;
		};

		/**
		 * @param {string} name
		 * @returns {{ns: string|null, local: string}} namespace and attribute name
		 */
		V.qualifyAttr = function (name) {

			if (name.indexOf(':') !== -1) {
				var combinedKey = name.split(':');
				return {
					ns: ns[combinedKey[0]],
					local: combinedKey[1]
				};
			}

			return {
				ns: null,
				local: name
			};
		};

		V.transformRegex = /(\w+)\(([^,)]+),?([^)]+)?\)/gi;
		V.transformSeparatorRegex = /[ ,]+/;
		V.transformationListRegex = /^(\w+)\((.*)\)/;

		V.transformStringToMatrix = function (transform) {

			var transformationMatrix = V.createSVGMatrix();
			var matches = transform && transform.match(V.transformRegex);
			if (!matches) {
				return transformationMatrix;
			}

			for (var i = 0, n = matches.length; i < n; i++) {
				var transformationString = matches[i];

				var transformationMatch = transformationString.match(V.transformationListRegex);
				if (transformationMatch) {
					var sx, sy, tx, ty, angle;
					var ctm = V.createSVGMatrix();
					var args = transformationMatch[2].split(V.transformSeparatorRegex);
					switch (transformationMatch[1].toLowerCase()) {
						case 'scale':
							sx = parseFloat(args[0]);
							sy = (args[1] === undefined) ? sx : parseFloat(args[1]);
							ctm = ctm.scaleNonUniform(sx, sy);
							break;
						case 'translate':
							tx = parseFloat(args[0]);
							ty = parseFloat(args[1]);
							ctm = ctm.translate(tx, ty);
							break;
						case 'rotate':
							angle = parseFloat(args[0]);
							tx = parseFloat(args[1]) || 0;
							ty = parseFloat(args[2]) || 0;
							if (tx !== 0 || ty !== 0) {
								ctm = ctm.translate(tx, ty).rotate(angle).translate(-tx, -ty);
							} else {
								ctm = ctm.rotate(angle);
							}
							break;
						case 'skewx':
							angle = parseFloat(args[0]);
							ctm = ctm.skewX(angle);
							break;
						case 'skewy':
							angle = parseFloat(args[0]);
							ctm = ctm.skewY(angle);
							break;
						case 'matrix':
							ctm.a = parseFloat(args[0]);
							ctm.b = parseFloat(args[1]);
							ctm.c = parseFloat(args[2]);
							ctm.d = parseFloat(args[3]);
							ctm.e = parseFloat(args[4]);
							ctm.f = parseFloat(args[5]);
							break;
						default:
							continue;
					}

					transformationMatrix = transformationMatrix.multiply(ctm);
				}

			}
			return transformationMatrix;
		};

		V.matrixToTransformString = function (matrix) {
			matrix || (matrix = true);

			return 'matrix(' +
				(matrix.a !== undefined ? matrix.a : 1) + ',' +
				(matrix.b !== undefined ? matrix.b : 0) + ',' +
				(matrix.c !== undefined ? matrix.c : 0) + ',' +
				(matrix.d !== undefined ? matrix.d : 1) + ',' +
				(matrix.e !== undefined ? matrix.e : 0) + ',' +
				(matrix.f !== undefined ? matrix.f : 0) +
				')';
		};

		V.parseTransformString = function (transform) {

			var translate, rotate, scale;

			if (transform) {

				var separator = V.transformSeparatorRegex;

				// Allow reading transform string with a single matrix
				if (transform.trim().indexOf('matrix') >= 0) {

					var matrix = V.transformStringToMatrix(transform);
					var decomposedMatrix = V.decomposeMatrix(matrix);

					translate = [decomposedMatrix.translateX, decomposedMatrix.translateY];
					scale = [decomposedMatrix.scaleX, decomposedMatrix.scaleY];
					rotate = [decomposedMatrix.rotation];

					var transformations = [];
					if (translate[0] !== 0 || translate[0] !== 0) {
						transformations.push('translate(' + translate + ')');
					}
					if (scale[0] !== 1 || scale[1] !== 1) {
						transformations.push('scale(' + scale + ')');
					}
					if (rotate[0] !== 0) {
						transformations.push('rotate(' + rotate + ')');
					}
					transform = transformations.join(' ');

				} else {

					var translateMatch = transform.match(/translate\((.*?)\)/);
					if (translateMatch) {
						translate = translateMatch[1].split(separator);
					}
					var rotateMatch = transform.match(/rotate\((.*?)\)/);
					if (rotateMatch) {
						rotate = rotateMatch[1].split(separator);
					}
					var scaleMatch = transform.match(/scale\((.*?)\)/);
					if (scaleMatch) {
						scale = scaleMatch[1].split(separator);
					}
				}
			}

			var sx = (scale && scale[0]) ? parseFloat(scale[0]) : 1;

			return {
				value: transform,
				translate: {
					tx: (translate && translate[0]) ? parseInt(translate[0], 10) : 0,
					ty: (translate && translate[1]) ? parseInt(translate[1], 10) : 0
				},
				rotate: {
					angle: (rotate && rotate[0]) ? parseInt(rotate[0], 10) : 0,
					cx: (rotate && rotate[1]) ? parseInt(rotate[1], 10) : undefined,
					cy: (rotate && rotate[2]) ? parseInt(rotate[2], 10) : undefined
				},
				scale: {
					sx: sx,
					sy: (scale && scale[1]) ? parseFloat(scale[1]) : sx
				}
			};
		};

		V.deltaTransformPoint = function (matrix, point) {

			var dx = point.x * matrix.a + point.y * matrix.c + 0;
			var dy = point.x * matrix.b + point.y * matrix.d + 0;
			return { x: dx, y: dy };
		};

		V.decomposeMatrix = function (matrix) {

			// @see https://gist.github.com/2052247

			// calculate delta transform point
			var px = V.deltaTransformPoint(matrix, { x: 0, y: 1 });
			var py = V.deltaTransformPoint(matrix, { x: 1, y: 0 });

			// calculate skew
			var skewX = ((180 / Math.PI) * Math.atan2(px.y, px.x) - 90);
			var skewY = ((180 / Math.PI) * Math.atan2(py.y, py.x));

			return {

				translateX: matrix.e,
				translateY: matrix.f,
				scaleX: Math.sqrt(matrix.a * matrix.a + matrix.b * matrix.b),
				scaleY: Math.sqrt(matrix.c * matrix.c + matrix.d * matrix.d),
				skewX: skewX,
				skewY: skewY,
				rotation: skewX // rotation is the same as skew x
			};
		};

		// Return the `scale` transformation from the following equation:
		// `translate(tx, ty) . rotate(angle) . scale(sx, sy) === matrix(a,b,c,d,e,f)`
		V.matrixToScale = function (matrix) {

			var a, b, c, d;
			if (matrix) {
				a = V.isUndefined(matrix.a) ? 1 : matrix.a;
				d = V.isUndefined(matrix.d) ? 1 : matrix.d;
				b = matrix.b;
				c = matrix.c;
			} else {
				a = d = 1;
			}
			return {
				sx: b ? Math.sqrt(a * a + b * b) : a,
				sy: c ? Math.sqrt(c * c + d * d) : d
			};
		},

			// Return the `rotate` transformation from the following equation:
			// `translate(tx, ty) . rotate(angle) . scale(sx, sy) === matrix(a,b,c,d,e,f)`
			V.matrixToRotate = function (matrix) {

				var p = { x: 0, y: 1 };
				if (matrix) {
					p = V.deltaTransformPoint(matrix, p);
				}

				return {
					angle: g.normalizeAngle(g.toDeg(Math.atan2(p.y, p.x)) - 90)
				};
			},

			// Return the `translate` transformation from the following equation:
			// `translate(tx, ty) . rotate(angle) . scale(sx, sy) === matrix(a,b,c,d,e,f)`
			V.matrixToTranslate = function (matrix) {

				return {
					tx: (matrix && matrix.e) || 0,
					ty: (matrix && matrix.f) || 0
				};
			},

			V.isV = function (object) {

				return object instanceof V;
			};

		// For backwards compatibility:
		V.isVElement = V.isV;

		var svgDocument = V('svg').node;

		V.createSVGMatrix = function (matrix) {

			var svgMatrix = svgDocument.createSVGMatrix();
			for (var component in matrix) {
				svgMatrix[component] = matrix[component];
			}

			return svgMatrix;
		};

		V.createSVGTransform = function (matrix) {

			if (!V.isUndefined(matrix)) {

				if (!(matrix instanceof SVGMatrix)) {
					matrix = V.createSVGMatrix(matrix);
				}

				return svgDocument.createSVGTransformFromMatrix(matrix);
			}

			return svgDocument.createSVGTransform();
		};

		V.createSVGPoint = function (x, y) {

			var p = svgDocument.createSVGPoint();
			p.x = x;
			p.y = y;
			return p;
		};

		V.transformRect = function (r, matrix) {

			var p = svgDocument.createSVGPoint();

			p.x = r.x;
			p.y = r.y;
			var corner1 = p.matrixTransform(matrix);

			p.x = r.x + r.width;
			p.y = r.y;
			var corner2 = p.matrixTransform(matrix);

			p.x = r.x + r.width;
			p.y = r.y + r.height;
			var corner3 = p.matrixTransform(matrix);

			p.x = r.x;
			p.y = r.y + r.height;
			var corner4 = p.matrixTransform(matrix);

			var minX = Math.min(corner1.x, corner2.x, corner3.x, corner4.x);
			var maxX = Math.max(corner1.x, corner2.x, corner3.x, corner4.x);
			var minY = Math.min(corner1.y, corner2.y, corner3.y, corner4.y);
			var maxY = Math.max(corner1.y, corner2.y, corner3.y, corner4.y);

			return g.Rect(minX, minY, maxX - minX, maxY - minY);
		};

		V.transformPoint = function (p, matrix) {

			return g.Point(V.createSVGPoint(p.x, p.y).matrixTransform(matrix));
		};

		// Convert a style represented as string (e.g. `'fill="blue"; stroke="red"'`) to
		// an object (`{ fill: 'blue', stroke: 'red' }`).
		V.styleToObject = function (styleString) {
			var ret = {};
			var styles = styleString.split(';');
			for (var i = 0; i < styles.length; i++) {
				var style = styles[i];
				var pair = style.split('=');
				ret[pair[0].trim()] = pair[1].trim();
			}
			return ret;
		};

		// Inspired by d3.js https://github.com/mbostock/d3/blob/master/src/svg/arc.js
		V.createSlicePathData = function (innerRadius, outerRadius, startAngle, endAngle) {

			var svgArcMax = 2 * Math.PI - 1e-6;
			var r0 = innerRadius;
			var r1 = outerRadius;
			var a0 = startAngle;
			var a1 = endAngle;
			var da = (a1 < a0 && (da = a0, a0 = a1, a1 = da), a1 - a0);
			var df = da < Math.PI ? '0' : '1';
			var c0 = Math.cos(a0);
			var s0 = Math.sin(a0);
			var c1 = Math.cos(a1);
			var s1 = Math.sin(a1);

			return (da >= svgArcMax)
				? (r0
					? 'M0,' + r1
					+ 'A' + r1 + ',' + r1 + ' 0 1,1 0,' + (-r1)
					+ 'A' + r1 + ',' + r1 + ' 0 1,1 0,' + r1
					+ 'M0,' + r0
					+ 'A' + r0 + ',' + r0 + ' 0 1,0 0,' + (-r0)
					+ 'A' + r0 + ',' + r0 + ' 0 1,0 0,' + r0
					+ 'Z'
					: 'M0,' + r1
					+ 'A' + r1 + ',' + r1 + ' 0 1,1 0,' + (-r1)
					+ 'A' + r1 + ',' + r1 + ' 0 1,1 0,' + r1
					+ 'Z')
				: (r0
					? 'M' + r1 * c0 + ',' + r1 * s0
					+ 'A' + r1 + ',' + r1 + ' 0 ' + df + ',1 ' + r1 * c1 + ',' + r1 * s1
					+ 'L' + r0 * c1 + ',' + r0 * s1
					+ 'A' + r0 + ',' + r0 + ' 0 ' + df + ',0 ' + r0 * c0 + ',' + r0 * s0
					+ 'Z'
					: 'M' + r1 * c0 + ',' + r1 * s0
					+ 'A' + r1 + ',' + r1 + ' 0 ' + df + ',1 ' + r1 * c1 + ',' + r1 * s1
					+ 'L0,0'
					+ 'Z');
		};

		// Merge attributes from object `b` with attributes in object `a`.
		// Note that this modifies the object `a`.
		// Also important to note that attributes are merged but CSS classes are concatenated.
		V.mergeAttrs = function (a, b) {

			for (var attr in b) {

				if (attr === 'class') {
					// Concatenate classes.
					a[attr] = a[attr] ? a[attr] + ' ' + b[attr] : b[attr];
				} else if (attr === 'style') {
					// `style` attribute can be an object.
					if (V.isObject(a[attr]) && V.isObject(b[attr])) {
						// `style` stored in `a` is an object.
						a[attr] = V.mergeAttrs(a[attr], b[attr]);
					} else if (V.isObject(a[attr])) {
						// `style` in `a` is an object but it's a string in `b`.
						// Convert the style represented as a string to an object in `b`.
						a[attr] = V.mergeAttrs(a[attr], V.styleToObject(b[attr]));
					} else if (V.isObject(b[attr])) {
						// `style` in `a` is a string, in `b` it's an object.
						a[attr] = V.mergeAttrs(V.styleToObject(a[attr]), b[attr]);
					} else {
						// Both styles are strings.
						a[attr] = V.mergeAttrs(V.styleToObject(a[attr]), V.styleToObject(b[attr]));
					}
				} else {
					a[attr] = b[attr];
				}
			}

			return a;
		};

		V.annotateString = function (t, annotations, opt) {

			annotations = annotations || [];
			opt = opt || {};

			var offset = opt.offset || 0;
			var compacted = [];
			var batch;
			var ret = [];
			var item;
			var prev;

			for (var i = 0; i < t.length; i++) {

				item = ret[i] = t[i];

				for (var j = 0; j < annotations.length; j++) {

					var annotation = annotations[j];
					var start = annotation.start + offset;
					var end = annotation.end + offset;

					if (i >= start && i < end) {
						// Annotation applies.
						if (V.isObject(item)) {
							// There is more than one annotation to be applied => Merge attributes.
							item.attrs = V.mergeAttrs(V.mergeAttrs({}, item.attrs), annotation.attrs);
						} else {
							item = ret[i] = { t: t[i], attrs: annotation.attrs };
						}
						if (opt.includeAnnotationIndices) {
							(item.annotations || (item.annotations = [])).push(j);
						}
					}
				}

				prev = ret[i - 1];

				if (!prev) {

					batch = item;

				} else if (V.isObject(item) && V.isObject(prev)) {
					// Both previous item and the current one are annotations. If the attributes
					// didn't change, merge the text.
					if (JSON.stringify(item.attrs) === JSON.stringify(prev.attrs)) {
						batch.t += item.t;
					} else {
						compacted.push(batch);
						batch = item;
					}

				} else if (V.isObject(item)) {
					// Previous item was a string, current item is an annotation.
					compacted.push(batch);
					batch = item;

				} else if (V.isObject(prev)) {
					// Previous item was an annotation, current item is a string.
					compacted.push(batch);
					batch = item;

				} else {
					// Both previous and current item are strings.
					batch = (batch || '') + item;
				}
			}

			if (batch) {
				compacted.push(batch);
			}

			return compacted;
		};

		V.findAnnotationsAtIndex = function (annotations, index) {

			var found = [];

			if (annotations) {

				annotations.forEach(function (annotation) {

					if (annotation.start < index && index <= annotation.end) {
						found.push(annotation);
					}
				});
			}

			return found;
		};

		V.findAnnotationsBetweenIndexes = function (annotations, start, end) {

			var found = [];

			if (annotations) {

				annotations.forEach(function (annotation) {

					if ((start >= annotation.start && start < annotation.end) || (end > annotation.start && end <= annotation.end) || (annotation.start >= start && annotation.end < end)) {
						found.push(annotation);
					}
				});
			}

			return found;
		};

		// Shift all the text annotations after character `index` by `offset` positions.
		V.shiftAnnotations = function (annotations, index, offset) {

			if (annotations) {

				annotations.forEach(function (annotation) {

					if (annotation.start < index && annotation.end >= index) {
						annotation.end += offset;
					} else if (annotation.start >= index) {
						annotation.start += offset;
						annotation.end += offset;
					}
				});
			}

			return annotations;
		};

		V.convertLineToPathData = function (line) {

			line = V(line);
			var d = [
				'M', line.attr('x1'), line.attr('y1'),
				'L', line.attr('x2'), line.attr('y2')
			].join(' ');
			return d;
		};

		V.convertPolygonToPathData = function (polygon) {

			var points = V.getPointsFromSvgNode(V(polygon).node);

			if (!(points.length > 0)) return null;

			return V.svgPointsToPath(points) + ' Z';
		};

		V.convertPolylineToPathData = function (polyline) {

			var points = V.getPointsFromSvgNode(V(polyline).node);

			if (!(points.length > 0)) return null;

			return V.svgPointsToPath(points);
		};

		V.svgPointsToPath = function (points) {

			var i;

			for (i = 0; i < points.length; i++) {
				points[i] = points[i].x + ' ' + points[i].y;
			}

			return 'M ' + points.join(' L');
		};

		V.getPointsFromSvgNode = function (node) {

			node = V.toNode(node);
			var points = [];
			var nodePoints = node.points;
			if (nodePoints) {
				for (var i = 0; i < nodePoints.numberOfItems; i++) {
					points.push(nodePoints.getItem(i));
				}
			}

			return points;
		};

		V.KAPPA = 0.5522847498307935;

		V.convertCircleToPathData = function (circle) {

			circle = V(circle);
			var cx = parseFloat(circle.attr('cx')) || 0;
			var cy = parseFloat(circle.attr('cy')) || 0;
			var r = parseFloat(circle.attr('r'));
			var cd = r * V.KAPPA; // Control distance.

			var d = [
				'M', cx, cy - r,    // Move to the first point.
				'C', cx + cd, cy - r, cx + r, cy - cd, cx + r, cy, // I. Quadrant.
				'C', cx + r, cy + cd, cx + cd, cy + r, cx, cy + r, // II. Quadrant.
				'C', cx - cd, cy + r, cx - r, cy + cd, cx - r, cy, // III. Quadrant.
				'C', cx - r, cy - cd, cx - cd, cy - r, cx, cy - r, // IV. Quadrant.
				'Z'
			].join(' ');
			return d;
		};

		V.convertEllipseToPathData = function (ellipse) {

			ellipse = V(ellipse);
			var cx = parseFloat(ellipse.attr('cx')) || 0;
			var cy = parseFloat(ellipse.attr('cy')) || 0;
			var rx = parseFloat(ellipse.attr('rx'));
			var ry = parseFloat(ellipse.attr('ry')) || rx;
			var cdx = rx * V.KAPPA; // Control distance x.
			var cdy = ry * V.KAPPA; // Control distance y.

			var d = [
				'M', cx, cy - ry,    // Move to the first point.
				'C', cx + cdx, cy - ry, cx + rx, cy - cdy, cx + rx, cy, // I. Quadrant.
				'C', cx + rx, cy + cdy, cx + cdx, cy + ry, cx, cy + ry, // II. Quadrant.
				'C', cx - cdx, cy + ry, cx - rx, cy + cdy, cx - rx, cy, // III. Quadrant.
				'C', cx - rx, cy - cdy, cx - cdx, cy - ry, cx, cy - ry, // IV. Quadrant.
				'Z'
			].join(' ');
			return d;
		};

		V.convertRectToPathData = function (rect) {

			rect = V(rect);

			return V.rectToPath({
				x: parseFloat(rect.attr('x')) || 0,
				y: parseFloat(rect.attr('y')) || 0,
				width: parseFloat(rect.attr('width')) || 0,
				height: parseFloat(rect.attr('height')) || 0,
				rx: parseFloat(rect.attr('rx')) || 0,
				ry: parseFloat(rect.attr('ry')) || 0
			});
		};

		// Convert a rectangle to SVG path commands. `r` is an object of the form:
		// `{ x: [number], y: [number], width: [number], height: [number], top-ry: [number], top-ry: [number], bottom-rx: [number], bottom-ry: [number] }`,
		// where `x, y, width, height` are the usual rectangle attributes and [top-/bottom-]rx/ry allows for
		// specifying radius of the rectangle for all its sides (as opposed to the built-in SVG rectangle
		// that has only `rx` and `ry` attributes).
		V.rectToPath = function (r) {

			var d;
			var x = r.x;
			var y = r.y;
			var width = r.width;
			var height = r.height;
			var topRx = Math.min(r.rx || r['top-rx'] || 0, width / 2);
			var bottomRx = Math.min(r.rx || r['bottom-rx'] || 0, width / 2);
			var topRy = Math.min(r.ry || r['top-ry'] || 0, height / 2);
			var bottomRy = Math.min(r.ry || r['bottom-ry'] || 0, height / 2);

			if (topRx || bottomRx || topRy || bottomRy) {
				d = [
					'M', x, y + topRy,
					'v', height - topRy - bottomRy,
					'a', bottomRx, bottomRy, 0, 0, 0, bottomRx, bottomRy,
					'h', width - 2 * bottomRx,
					'a', bottomRx, bottomRy, 0, 0, 0, bottomRx, -bottomRy,
					'v', -(height - bottomRy - topRy),
					'a', topRx, topRy, 0, 0, 0, -topRx, -topRy,
					'h', -(width - 2 * topRx),
					'a', topRx, topRy, 0, 0, 0, -topRx, topRy,
					'Z'
				];
			} else {
				d = [
					'M', x, y,
					'H', x + width,
					'V', y + height,
					'H', x,
					'V', y,
					'Z'
				];
			}

			return d.join(' ');
		};

		V.namespace = ns;

		return V;

	})();


	// Global namespace.

	var joint = {

		version: '2.0.0',

		config: {
			// The class name prefix config is for advanced use only.
			// Be aware that if you change the prefix, the JointJS CSS will no longer function properly.
			classNamePrefix: 'joint-',
			defaultTheme: 'default'
		},

		// `joint.dia` namespace.
		dia: {},

		// `joint.ui` namespace.
		ui: {},

		// `joint.layout` namespace.
		layout: {},

		// `joint.shapes` namespace.
		shapes: {},

		// `joint.format` namespace.
		format: {},

		// `joint.connectors` namespace.
		connectors: {},

		// `joint.highlighters` namespace.
		highlighters: {},

		// `joint.routers` namespace.
		routers: {},

		// `joint.mvc` namespace.
		mvc: {
			views: {}
		},

		setTheme: function (theme, opt) {

			opt = opt || {};

			joint.util.invoke(joint.mvc.views, 'setTheme', theme, opt);

			// Update the default theme on the view prototype.
			joint.mvc.View.prototype.defaultTheme = theme;
		},

		// `joint.env` namespace.
		env: {

			_results: {},

			_tests: {

				svgforeignobject: function () {
					return !!document.createElementNS &&
						/SVGForeignObject/.test(({}).toString.call(document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject')));
				}
			},

			addTest: function (name, fn) {

				return joint.env._tests[name] = fn;
			},

			test: function (name) {

				var fn = joint.env._tests[name];

				if (!fn) {
					throw new Error('Test not defined ("' + name + '"). Use `joint.env.addTest(name, fn) to add a new test.`');
				}

				var result = joint.env._results[name];

				if (typeof result !== 'undefined') {
					return result;
				}

				try {
					result = fn();
				} catch (error) {
					result = false;
				}

				// Cache the test result.
				joint.env._results[name] = result;

				return result;
			}
		},

		util: {

			// Return a simple hash code from a string. See http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/.
			hashCode: function (str) {

				var hash = 0;
				if (str.length == 0) return hash;
				for (var i = 0; i < str.length; i++) {
					var c = str.charCodeAt(i);
					hash = ((hash << 5) - hash) + c;
					hash = hash & hash; // Convert to 32bit integer
				}
				return hash;
			},

			getByPath: function (obj, path, delim) {

				var keys = Array.isArray(path) ? path.slice() : path.split(delim || '/');
				var key;

				while (keys.length) {
					key = keys.shift();
					if (Object(obj) === obj && key in obj) {
						obj = obj[key];
					} else {
						return undefined;
					}
				}
				return obj;
			},

			setByPath: function (obj, path, value, delim) {

				var keys = Array.isArray(path) ? path : path.split(delim || '/');

				var diver = obj;
				var i = 0;

				for (var len = keys.length; i < len - 1; i++) {
					// diver creates an empty object if there is no nested object under such a key.
					// This means that one can populate an empty nested object with setByPath().
					diver = diver[keys[i]] || (diver[keys[i]] = {});
				}
				diver[keys[len - 1]] = value;

				return obj;
			},

			unsetByPath: function (obj, path, delim) {

				delim = delim || '/';

				var pathArray = Array.isArray(path) ? path.slice() : path.split(delim);

				var propertyToRemove = pathArray.pop();
				if (pathArray.length > 0) {

					// unsetting a nested attribute
					var parent = joint.util.getByPath(obj, pathArray, delim);

					if (parent) {
						delete parent[propertyToRemove];
					}

				} else {

					// unsetting a primitive attribute
					delete obj[propertyToRemove];
				}

				return obj;
			},

			flattenObject: function (obj, delim, stop) {

				delim = delim || '/';
				var ret = {};

				for (var key in obj) {

					if (!obj.hasOwnProperty(key)) continue;

					var shouldGoDeeper = typeof obj[key] === 'object';
					if (shouldGoDeeper && stop && stop(obj[key])) {
						shouldGoDeeper = false;
					}

					if (shouldGoDeeper) {

						var flatObject = this.flattenObject(obj[key], delim, stop);

						for (var flatKey in flatObject) {
							if (!flatObject.hasOwnProperty(flatKey)) continue;
							ret[key + delim + flatKey] = flatObject[flatKey];
						}

					} else {

						ret[key] = obj[key];
					}
				}

				return ret;
			},

			uuid: function () {

				// credit: http://stackoverflow.com/posts/2117523/revisions

				return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = Math.random() * 16 | 0;
					var v = c == 'x' ? r : (r & 0x3 | 0x8);
					return v.toString(16);
				});
			},

			// Generate global unique id for obj and store it as a property of the object.
			guid: function (obj) {

				this.guid.id = this.guid.id || 1;
				obj.id = (obj.id === undefined ? 'j_' + this.guid.id++ : obj.id);
				return obj.id;
			},

			toKebabCase: function (string) {

				return string.replace(/[A-Z]/g, '-$&').toLowerCase();
			},

			// Copy all the properties to the first argument from the following arguments.
			// All the properties will be overwritten by the properties from the following
			// arguments. Inherited properties are ignored.
			mixin: _.assign,

			// Copy all properties to the first argument from the following
			// arguments only in case if they don't exists in the first argument.
			// All the function propererties in the first argument will get
			// additional property base pointing to the extenders same named
			// property function's call method.
			supplement: _.defaults,

			// Same as `mixin()` but deep version.
			deepMixin: _.mixin,

			// Same as `supplement()` but deep version.
			deepSupplement: _.defaultsDeep,

			normalizeEvent: function (evt) {

				var touchEvt = evt.originalEvent && evt.originalEvent.changedTouches && evt.originalEvent.changedTouches[0];
				if (touchEvt) {
					for (var property in evt) {
						// copy all the properties from the input event that are not
						// defined on the touch event (functions included).
						if (touchEvt[property] === undefined) {
							touchEvt[property] = evt[property];
						}
					}
					return touchEvt;
				}

				return evt;
			},

			nextFrame: (function () {

				var raf;

				if (typeof window !== 'undefined') {

					raf = window.requestAnimationFrame ||
						window.webkitRequestAnimationFrame ||
						window.mozRequestAnimationFrame ||
						window.oRequestAnimationFrame ||
						window.msRequestAnimationFrame;
				}

				if (!raf) {

					var lastTime = 0;

					raf = function (callback) {

						var currTime = new Date().getTime();
						var timeToCall = Math.max(0, 16 - (currTime - lastTime));
						var id = setTimeout(function () { callback(currTime + timeToCall); }, timeToCall);

						lastTime = currTime + timeToCall;

						return id;
					};
				}

				return function (callback, context) {
					return context
						? raf(callback.bind(context))
						: raf(callback);
				};

			})(),

			cancelFrame: (function () {

				var caf;
				var client = typeof window != 'undefined';

				if (client) {

					caf = window.cancelAnimationFrame ||
						window.webkitCancelAnimationFrame ||
						window.webkitCancelRequestAnimationFrame ||
						window.msCancelAnimationFrame ||
						window.msCancelRequestAnimationFrame ||
						window.oCancelAnimationFrame ||
						window.oCancelRequestAnimationFrame ||
						window.mozCancelAnimationFrame ||
						window.mozCancelRequestAnimationFrame;
				}

				caf = caf || clearTimeout;

				return client ? caf.bind(window) : caf;

			})(),

			shapePerimeterConnectionPoint: function (linkView, view, magnet, reference) {

				var bbox;
				var spot;

				if (!magnet) {

					// There is no magnet, try to make the best guess what is the
					// wrapping SVG element. This is because we want this "smart"
					// connection points to work out of the box without the
					// programmer to put magnet marks to any of the subelements.
					// For example, we want the functoin to work on basic.Path elements
					// without any special treatment of such elements.
					// The code below guesses the wrapping element based on
					// one simple assumption. The wrapping elemnet is the
					// first child of the scalable group if such a group exists
					// or the first child of the rotatable group if not.
					// This makese sense because usually the wrapping element
					// is below any other sub element in the shapes.
					var scalable = view.$('.scalable')[0];
					var rotatable = view.$('.rotatable')[0];

					if (scalable && scalable.firstChild) {

						magnet = scalable.firstChild;

					} else if (rotatable && rotatable.firstChild) {

						magnet = rotatable.firstChild;
					}
				}

				if (magnet) {

					spot = V(magnet).findIntersection(reference, linkView.paper.viewport);
					if (!spot) {
						bbox = V(magnet).getBBox({ target: linkView.paper.viewport });
					}

				} else {

					bbox = view.model.getBBox();
					spot = bbox.intersectionWithLineFromCenterToPoint(reference);
				}
				return spot || bbox.center();
			},

			parseCssNumeric: function (strValue, restrictUnits) {

				restrictUnits = restrictUnits || [];
				var cssNumeric = { value: parseFloat(strValue) };

				if (Number.isNaN(cssNumeric.value)) {
					return null;
				}

				var validUnitsExp = restrictUnits.join('|');

				if (joint.util.isString(strValue)) {
					var matches = new RegExp('(\\d+)(' + validUnitsExp + ')$').exec(strValue);
					if (!matches) {
						return null;
					}
					if (matches[2]) {
						cssNumeric.unit = matches[2];
					}
				}
				return cssNumeric;
			},

			breakText: function (text, size, styles, opt) {

				opt = opt || {};

				var width = size.width;
				var height = size.height;

				var svgDocument = opt.svgDocument || V('svg').node;
				var textElement = V('<text><tspan></tspan></text>').attr(styles || {}).node;
				var textSpan = textElement.firstChild;
				var textNode = document.createTextNode('');

				// Prevent flickering
				textElement.style.opacity = 0;
				// Prevent FF from throwing an uncaught exception when `getBBox()`
				// called on element that is not in the render tree (is not measurable).
				// <tspan>.getComputedTextLength() returns always 0 in this case.
				// Note that the `textElement` resp. `textSpan` can become hidden
				// when it's appended to the DOM and a `display: none` CSS stylesheet
				// rule gets applied.
				textElement.style.display = 'block';
				textSpan.style.display = 'block';

				textSpan.appendChild(textNode);
				svgDocument.appendChild(textElement);

				if (!opt.svgDocument) {

					document.body.appendChild(svgDocument);
				}

				var words = text.split(' ');
				var full = [];
				var lines = [];
				var p;
				var lineHeight;

				for (var i = 0, l = 0, len = words.length; i < len; i++) {

					var word = words[i];

					textNode.data = lines[l] ? lines[l] + ' ' + word : word;

					if (textSpan.getComputedTextLength() <= width) {

						// the current line fits
						lines[l] = textNode.data;

						if (p) {
							// We were partitioning. Put rest of the word onto next line
							full[l++] = true;

							// cancel partitioning
							p = 0;
						}

					} else {

						if (!lines[l] || p) {

							var partition = !!p;

							p = word.length - 1;

							if (partition || !p) {

								// word has only one character.
								if (!p) {

									if (!lines[l]) {

										// we won't fit this text within our rect
										lines = [];

										break;
									}

									// partitioning didn't help on the non-empty line
									// try again, but this time start with a new line

									// cancel partitions created
									words.splice(i, 2, word + words[i + 1]);

									// adjust word length
									len--;

									full[l++] = true;
									i--;

									continue;
								}

								// move last letter to the beginning of the next word
								words[i] = word.substring(0, p);
								words[i + 1] = word.substring(p) + words[i + 1];

							} else {

								// We initiate partitioning
								// split the long word into two words
								words.splice(i, 1, word.substring(0, p), word.substring(p));

								// adjust words length
								len++;

								if (l && !full[l - 1]) {
									// if the previous line is not full, try to fit max part of
									// the current word there
									l--;
								}
							}

							i--;

							continue;
						}

						l++;
						i--;
					}

					// if size.height is defined we have to check whether the height of the entire
					// text exceeds the rect height
					if (height !== undefined) {

						if (lineHeight === undefined) {

							var heightValue;

							// use the same defaults as in V.prototype.text
							if (styles.lineHeight === 'auto') {
								heightValue = { value: 1.5, unit: 'em' };
							} else {
								heightValue = joint.util.parseCssNumeric(styles.lineHeight, ['em']) || { value: 1, unit: 'em' };
							}

							lineHeight = heightValue.value;
							if (heightValue.unit === 'em') {
								lineHeight *= textElement.getBBox().height;
							}
						}

						if (lineHeight * lines.length > height) {

							// remove overflowing lines
							lines.splice(Math.floor(height / lineHeight));

							break;
						}
					}
				}

				if (opt.svgDocument) {

					// svg document was provided, remove the text element only
					svgDocument.removeChild(textElement);

				} else {

					// clean svg document
					document.body.removeChild(svgDocument);
				}

				return lines.join('\n');
			},

			imageToDataUri: function (url, callback) {

				if (!url || url.substr(0, 'data:'.length) === 'data:') {
					// No need to convert to data uri if it is already in data uri.

					// This not only convenient but desired. For example,
					// IE throws a security error if data:image/svg+xml is used to render
					// an image to the canvas and an attempt is made to read out data uri.
					// Now if our image is already in data uri, there is no need to render it to the canvas
					// and so we can bypass this error.

					// Keep the async nature of the function.
					return setTimeout(function () {
						callback(null, url);
					}, 0);
				}

				// chrome IE10 IE11
				var modernHandler = function (xhr, callback) {

					if (xhr.status === 200) {

						var reader = new FileReader();

						reader.onload = function (evt) {
							var dataUri = evt.target.result;
							callback(null, dataUri);
						};

						reader.onerror = function () {
							callback(new Error('Failed to load image ' + url));
						};

						reader.readAsDataURL(xhr.response);
					} else {
						callback(new Error('Failed to load image ' + url));
					}

				};

				var legacyHandler = function (xhr, callback) {

					var Uint8ToString = function (u8a) {
						var CHUNK_SZ = 0x8000;
						var c = [];
						for (var i = 0; i < u8a.length; i += CHUNK_SZ) {
							c.push(String.fromCharCode.apply(null, u8a.subarray(i, i + CHUNK_SZ)));
						}
						return c.join('');
					};


					if (xhr.status === 200) {

						var bytes = new Uint8Array(xhr.response);

						var suffix = (url.split('.').pop()) || 'png';
						var map = {
							'svg': 'svg+xml'
						};
						var meta = 'data:image/' + (map[suffix] || suffix) + ';base64,';
						var b64encoded = meta + btoa(Uint8ToString(bytes));
						callback(null, b64encoded);
					} else {
						callback(new Error('Failed to load image ' + url));
					}
				};

				var xhr = new XMLHttpRequest();

				xhr.open('GET', url, true);
				xhr.addEventListener('error', function () {
					callback(new Error('Failed to load image ' + url));
				});

				xhr.responseType = window.FileReader ? 'blob' : 'arraybuffer';

				xhr.addEventListener('load', function () {
					if (window.FileReader) {
						modernHandler(xhr, callback);
					} else {
						legacyHandler(xhr, callback);
					}
				});

				xhr.send();
			},

			getElementBBox: function (el) {

				var $el = $(el);
				if ($el.length === 0) {
					throw new Error('Element not found')
				}

				var element = $el[0];
				var doc = element.ownerDocument;
				var clientBBox = element.getBoundingClientRect();

				var strokeWidthX = 0;
				var strokeWidthY = 0;

				// Firefox correction
				if (element.ownerSVGElement) {

					var vel = V(element);
					var bbox = vel.getBBox({ target: vel.svg() });

					// if FF getBoundingClientRect includes stroke-width, getBBox doesn't.
					// To unify this across all browsers we need to adjust the final bBox with `stroke-width` value.
					strokeWidthX = (clientBBox.width - bbox.width);
					strokeWidthY = (clientBBox.height - bbox.height);
				}

				return {
					x: clientBBox.left + window.pageXOffset - doc.documentElement.offsetLeft + strokeWidthX / 2,
					y: clientBBox.top + window.pageYOffset - doc.documentElement.offsetTop + strokeWidthY / 2,
					width: clientBBox.width - strokeWidthX,
					height: clientBBox.height - strokeWidthY
				};
			},


			// Highly inspired by the jquery.sortElements plugin by Padolsey.
			// See http://james.padolsey.com/javascript/sorting-elements-with-jquery/.
			sortElements: function (elements, comparator) {

				var $elements = $(elements);
				var placements = $elements.map(function () {

					var sortElement = this;
					var parentNode = sortElement.parentNode;
					// Since the element itself will change position, we have
					// to have some way of storing it's original position in
					// the DOM. The easiest way is to have a 'flag' node:
					var nextSibling = parentNode.insertBefore(document.createTextNode(''), sortElement.nextSibling);

					return function () {

						if (parentNode === this) {
							throw new Error('You can\'t sort elements if any one is a descendant of another.');
						}

						// Insert before flag:
						parentNode.insertBefore(this, nextSibling);
						// Remove flag:
						parentNode.removeChild(nextSibling);
					};
				});

				return Array.prototype.sort.call($elements, comparator).each(function (i) {
					placements[i].call(this);
				});
			},

			// Sets attributes on the given element and its descendants based on the selector.
			// `attrs` object: { [SELECTOR1]: { attrs1 }, [SELECTOR2]: { attrs2}, ... } e.g. { 'input': { color : 'red' }}
			setAttributesBySelector: function (element, attrs) {

				var $element = $(element);

				joint.util.forIn(attrs, function (attrs, selector) {
					var $elements = $element.find(selector).addBack().filter(selector);
					// Make a special case for setting classes.
					// We do not want to overwrite any existing class.
					if (joint.util.has(attrs, 'class')) {
						$elements.addClass(attrs['class']);
						attrs = joint.util.omit(attrs, 'class');
					}
					$elements.attr(attrs);
				});
			},

			// Return a new object with all for sides (top, bottom, left and right) in it.
			// Value of each side is taken from the given argument (either number or object).
			// Default value for a side is 0.
			// Examples:
			// joint.util.normalizeSides(5) --> { top: 5, left: 5, right: 5, bottom: 5 }
			// joint.util.normalizeSides({ left: 5 }) --> { top: 0, left: 5, right: 0, bottom: 0 }
			normalizeSides: function (box) {

				if (Object(box) !== box) {
					box = box || 0;
					return { top: box, bottom: box, left: box, right: box };
				}

				return {
					top: box.top || 0,
					bottom: box.bottom || 0,
					left: box.left || 0,
					right: box.right || 0
				};
			},

			timing: {

				linear: function (t) {
					return t;
				},

				quad: function (t) {
					return t * t;
				},

				cubic: function (t) {
					return t * t * t;
				},

				inout: function (t) {
					if (t <= 0) return 0;
					if (t >= 1) return 1;
					var t2 = t * t;
					var t3 = t2 * t;
					return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
				},

				exponential: function (t) {
					return Math.pow(2, 10 * (t - 1));
				},

				bounce: function (t) {
					for (var a = 0, b = 1; 1; a += b, b /= 2) {
						if (t >= (7 - 4 * a) / 11) {
							var q = (11 - 6 * a - 11 * t) / 4;
							return -q * q + b * b;
						}
					}
				},

				reverse: function (f) {
					return function (t) {
						return 1 - f(1 - t);
					};
				},

				reflect: function (f) {
					return function (t) {
						return .5 * (t < .5 ? f(2 * t) : (2 - f(2 - 2 * t)));
					};
				},

				clamp: function (f, n, x) {
					n = n || 0;
					x = x || 1;
					return function (t) {
						var r = f(t);
						return r < n ? n : r > x ? x : r;
					};
				},

				back: function (s) {
					if (!s) s = 1.70158;
					return function (t) {
						return t * t * ((s + 1) * t - s);
					};
				},

				elastic: function (x) {
					if (!x) x = 1.5;
					return function (t) {
						return Math.pow(2, 10 * (t - 1)) * Math.cos(20 * Math.PI * x / 3 * t);
					};
				}
			},

			interpolate: {

				number: function (a, b) {
					var d = b - a;
					return function (t) { return a + d * t; };
				},

				object: function (a, b) {
					var s = Object.keys(a);
					return function (t) {
						var i, p;
						var r = {};
						for (i = s.length - 1; i != -1; i--) {
							p = s[i];
							r[p] = a[p] + (b[p] - a[p]) * t;
						}
						return r;
					};
				},

				hexColor: function (a, b) {

					var ca = parseInt(a.slice(1), 16);
					var cb = parseInt(b.slice(1), 16);
					var ra = ca & 0x0000ff;
					var rd = (cb & 0x0000ff) - ra;
					var ga = ca & 0x00ff00;
					var gd = (cb & 0x00ff00) - ga;
					var ba = ca & 0xff0000;
					var bd = (cb & 0xff0000) - ba;

					return function (t) {

						var r = (ra + rd * t) & 0x000000ff;
						var g = (ga + gd * t) & 0x0000ff00;
						var b = (ba + bd * t) & 0x00ff0000;

						return '#' + (1 << 24 | r | g | b).toString(16).slice(1);
					};
				},

				unit: function (a, b) {

					var r = /(-?[0-9]*.[0-9]*)(px|em|cm|mm|in|pt|pc|%)/;
					var ma = r.exec(a);
					var mb = r.exec(b);
					var p = mb[1].indexOf('.');
					var f = p > 0 ? mb[1].length - p - 1 : 0;
					a = +ma[1];
					var d = +mb[1] - a;
					var u = ma[2];

					return function (t) {
						return (a + d * t).toFixed(f) + u;
					};
				}
			},

			// SVG filters.
			filter: {

				// `color` ... outline color
				// `width`... outline width
				// `opacity` ... outline opacity
				// `margin` ... gap between outline and the element
				outline: function (args) {

					var tpl = '<filter><feFlood flood-color="${color}" flood-opacity="${opacity}" result="colored"/><feMorphology in="SourceAlpha" result="morphedOuter" operator="dilate" radius="${outerRadius}" /><feMorphology in="SourceAlpha" result="morphedInner" operator="dilate" radius="${innerRadius}" /><feComposite result="morphedOuterColored" in="colored" in2="morphedOuter" operator="in"/><feComposite operator="xor" in="morphedOuterColored" in2="morphedInner" result="outline"/><feMerge><feMergeNode in="outline"/><feMergeNode in="SourceGraphic"/></feMerge></filter>';

					var margin = Number.isFinite(args.margin) ? args.margin : 2;
					var width = Number.isFinite(args.width) ? args.width : 1;

					return joint.util.template(tpl)({
						color: args.color || 'blue',
						opacity: Number.isFinite(args.opacity) ? args.opacity : 1,
						outerRadius: margin + width,
						innerRadius: margin
					});
				},

				// `color` ... color
				// `width`... width
				// `blur` ... blur
				// `opacity` ... opacity
				highlight: function (args) {

					var tpl = '<filter><feFlood flood-color="${color}" flood-opacity="${opacity}" result="colored"/><feMorphology result="morphed" in="SourceGraphic" operator="dilate" radius="${width}"/><feComposite result="composed" in="colored" in2="morphed" operator="in"/><feGaussianBlur result="blured" in="composed" stdDeviation="${blur}"/><feBlend in="SourceGraphic" in2="blured" mode="normal"/></filter>';

					return joint.util.template(tpl)({
						color: args.color || 'red',
						width: Number.isFinite(args.width) ? args.width : 1,
						blur: Number.isFinite(args.blur) ? args.blur : 0,
						opacity: Number.isFinite(args.opacity) ? args.opacity : 1
					});
				},

				// `x` ... horizontal blur
				// `y` ... vertical blur (optional)
				blur: function (args) {

					var x = Number.isFinite(args.x) ? args.x : 2;

					return joint.util.template('<filter><feGaussianBlur stdDeviation="${stdDeviation}"/></filter>')({
						stdDeviation: Number.isFinite(args.y) ? [x, args.y] : x
					});
				},

				// `dx` ... horizontal shift
				// `dy` ... vertical shift
				// `blur` ... blur
				// `color` ... color
				// `opacity` ... opacity
				dropShadow: function (args) {

					var tpl = 'SVGFEDropShadowElement' in window
						? '<filter><feDropShadow stdDeviation="${blur}" dx="${dx}" dy="${dy}" flood-color="${color}" flood-opacity="${opacity}"/></filter>'
						: '<filter><feGaussianBlur in="SourceAlpha" stdDeviation="${blur}"/><feOffset dx="${dx}" dy="${dy}" result="offsetblur"/><feFlood flood-color="${color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="${opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter>';

					return joint.util.template(tpl)({
						dx: args.dx || 0,
						dy: args.dy || 0,
						opacity: Number.isFinite(args.opacity) ? args.opacity : 1,
						color: args.color || 'black',
						blur: Number.isFinite(args.blur) ? args.blur : 4
					});
				},

				// `amount` ... the proportion of the conversion. A value of 1 is completely grayscale. A value of 0 leaves the input unchanged.
				grayscale: function (args) {

					var amount = Number.isFinite(args.amount) ? args.amount : 1;

					return joint.util.template('<filter><feColorMatrix type="matrix" values="${a} ${b} ${c} 0 0 ${d} ${e} ${f} 0 0 ${g} ${b} ${h} 0 0 0 0 0 1 0"/></filter>')({
						a: 0.2126 + 0.7874 * (1 - amount),
						b: 0.7152 - 0.7152 * (1 - amount),
						c: 0.0722 - 0.0722 * (1 - amount),
						d: 0.2126 - 0.2126 * (1 - amount),
						e: 0.7152 + 0.2848 * (1 - amount),
						f: 0.0722 - 0.0722 * (1 - amount),
						g: 0.2126 - 0.2126 * (1 - amount),
						h: 0.0722 + 0.9278 * (1 - amount)
					});
				},

				// `amount` ... the proportion of the conversion. A value of 1 is completely sepia. A value of 0 leaves the input unchanged.
				sepia: function (args) {

					var amount = Number.isFinite(args.amount) ? args.amount : 1;

					return joint.util.template('<filter><feColorMatrix type="matrix" values="${a} ${b} ${c} 0 0 ${d} ${e} ${f} 0 0 ${g} ${h} ${i} 0 0 0 0 0 1 0"/></filter>')({
						a: 0.393 + 0.607 * (1 - amount),
						b: 0.769 - 0.769 * (1 - amount),
						c: 0.189 - 0.189 * (1 - amount),
						d: 0.349 - 0.349 * (1 - amount),
						e: 0.686 + 0.314 * (1 - amount),
						f: 0.168 - 0.168 * (1 - amount),
						g: 0.272 - 0.272 * (1 - amount),
						h: 0.534 - 0.534 * (1 - amount),
						i: 0.131 + 0.869 * (1 - amount)
					});
				},

				// `amount` ... the proportion of the conversion. A value of 0 is completely un-saturated. A value of 1 leaves the input unchanged.
				saturate: function (args) {

					var amount = Number.isFinite(args.amount) ? args.amount : 1;

					return joint.util.template('<filter><feColorMatrix type="saturate" values="${amount}"/></filter>')({
						amount: 1 - amount
					});
				},

				// `angle` ...  the number of degrees around the color circle the input samples will be adjusted.
				hueRotate: function (args) {

					return joint.util.template('<filter><feColorMatrix type="hueRotate" values="${angle}"/></filter>')({
						angle: args.angle || 0
					});
				},

				// `amount` ... the proportion of the conversion. A value of 1 is completely inverted. A value of 0 leaves the input unchanged.
				invert: function (args) {

					var amount = Number.isFinite(args.amount) ? args.amount : 1;

					return joint.util.template('<filter><feComponentTransfer><feFuncR type="table" tableValues="${amount} ${amount2}"/><feFuncG type="table" tableValues="${amount} ${amount2}"/><feFuncB type="table" tableValues="${amount} ${amount2}"/></feComponentTransfer></filter>')({
						amount: amount,
						amount2: 1 - amount
					});
				},

				// `amount` ... proportion of the conversion. A value of 0 will create an image that is completely black. A value of 1 leaves the input unchanged.
				brightness: function (args) {

					return joint.util.template('<filter><feComponentTransfer><feFuncR type="linear" slope="${amount}"/><feFuncG type="linear" slope="${amount}"/><feFuncB type="linear" slope="${amount}"/></feComponentTransfer></filter>')({
						amount: Number.isFinite(args.amount) ? args.amount : 1
					});
				},

				// `amount` ... proportion of the conversion. A value of 0 will create an image that is completely black. A value of 1 leaves the input unchanged.
				contrast: function (args) {

					var amount = Number.isFinite(args.amount) ? args.amount : 1;

					return joint.util.template('<filter><feComponentTransfer><feFuncR type="linear" slope="${amount}" intercept="${amount2}"/><feFuncG type="linear" slope="${amount}" intercept="${amount2}"/><feFuncB type="linear" slope="${amount}" intercept="${amount2}"/></feComponentTransfer></filter>')({
						amount: amount,
						amount2: .5 - amount / 2
					});
				}
			},

			format: {

				// Formatting numbers via the Python Format Specification Mini-language.
				// See http://docs.python.org/release/3.1.3/library/string.html#format-specification-mini-language.
				// Heavilly inspired by the D3.js library implementation.
				number: function (specifier, value, locale) {

					locale = locale || {

						currency: ['$', ''],
						decimal: '.',
						thousands: ',',
						grouping: [3]
					};

					// See Python format specification mini-language: http://docs.python.org/release/3.1.3/library/string.html#format-specification-mini-language.
					// [[fill]align][sign][symbol][0][width][,][.precision][type]
					var re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;

					var match = re.exec(specifier);
					var fill = match[1] || ' ';
					var align = match[2] || '>';
					var sign = match[3] || '';
					var symbol = match[4] || '';
					var zfill = match[5];
					var width = +match[6];
					var comma = match[7];
					var precision = match[8];
					var type = match[9];
					var scale = 1;
					var prefix = '';
					var suffix = '';
					var integer = false;

					if (precision) precision = +precision.substring(1);

					if (zfill || fill === '0' && align === '=') {
						zfill = fill = '0';
						align = '=';
						if (comma) width -= Math.floor((width - 1) / 4);
					}

					switch (type) {
						case 'n':
							comma = true; type = 'g';
							break;
						case '%':
							scale = 100; suffix = '%'; type = 'f';
							break;
						case 'p':
							scale = 100; suffix = '%'; type = 'r';
							break;
						case 'b':
						case 'o':
						case 'x':
						case 'X':
							if (symbol === '#') prefix = '0' + type.toLowerCase();
							break;
						case 'c':
						case 'd':
							integer = true; precision = 0;
							break;
						case 's':
							scale = -1; type = 'r';
							break;
					}

					if (symbol === '$') {
						prefix = locale.currency[0];
						suffix = locale.currency[1];
					}

					// If no precision is specified for `'r'`, fallback to general notation.
					if (type == 'r' && !precision) type = 'g';

					// Ensure that the requested precision is in the supported range.
					if (precision != null) {
						if (type == 'g') precision = Math.max(1, Math.min(21, precision));
						else if (type == 'e' || type == 'f') precision = Math.max(0, Math.min(20, precision));
					}

					var zcomma = zfill && comma;

					// Return the empty string for floats formatted as ints.
					if (integer && (value % 1)) return '';

					// Convert negative to positive, and record the sign prefix.
					var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, '-') : sign;

					var fullSuffix = suffix;

					// Apply the scale, computing it from the value's exponent for si format.
					// Preserve the existing suffix, if any, such as the currency symbol.
					if (scale < 0) {
						var unit = this.prefix(value, precision);
						value = unit.scale(value);
						fullSuffix = unit.symbol + suffix;
					} else {
						value *= scale;
					}

					// Convert to the desired precision.
					value = this.convert(type, value, precision);

					// Break the value into the integer part (before) and decimal part (after).
					var i = value.lastIndexOf('.');
					var before = i < 0 ? value : value.substring(0, i);
					var after = i < 0 ? '' : locale.decimal + value.substring(i + 1);

					function formatGroup(value) {

						var i = value.length;
						var t = [];
						var j = 0;
						var g = locale.grouping[0];
						while (i > 0 && g > 0) {
							t.push(value.substring(i -= g, i + g));
							g = locale.grouping[j = (j + 1) % locale.grouping.length];
						}
						return t.reverse().join(locale.thousands);
					}

					// If the fill character is not `'0'`, grouping is applied before padding.
					if (!zfill && comma && locale.grouping) {

						before = formatGroup(before);
					}

					var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length);
					var padding = length < width ? new Array(length = width - length + 1).join(fill) : '';

					// If the fill character is `'0'`, grouping is applied after padding.
					if (zcomma) before = formatGroup(padding + before);

					// Apply prefix.
					negative += prefix;

					// Rejoin integer and decimal parts.
					value = before + after;

					return (align === '<' ? negative + value + padding
						: align === '>' ? padding + negative + value
							: align === '^' ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length)
								: negative + (zcomma ? value : padding + value)) + fullSuffix;
				},

				// Formatting string via the Python Format string.
				// See https://docs.python.org/2/library/string.html#format-string-syntax)
				string: function (formatString, value) {

					var fieldDelimiterIndex;
					var fieldDelimiter = '{';
					var endPlaceholder = false;
					var formattedStringArray = [];

					while ((fieldDelimiterIndex = formatString.indexOf(fieldDelimiter)) !== -1) {

						var pieceFormatedString, formatSpec, fieldName;

						pieceFormatedString = formatString.slice(0, fieldDelimiterIndex);

						if (endPlaceholder) {
							formatSpec = pieceFormatedString.split(':');
							fieldName = formatSpec.shift().split('.');
							pieceFormatedString = value;

							for (var i = 0; i < fieldName.length; i++)
								pieceFormatedString = pieceFormatedString[fieldName[i]];

							if (formatSpec.length)
								pieceFormatedString = this.number(formatSpec, pieceFormatedString);
						}

						formattedStringArray.push(pieceFormatedString);

						formatString = formatString.slice(fieldDelimiterIndex + 1);
						fieldDelimiter = (endPlaceholder = !endPlaceholder) ? '}' : '{';
					}
					formattedStringArray.push(formatString);

					return formattedStringArray.join('');
				},

				convert: function (type, value, precision) {

					switch (type) {
						case 'b': return value.toString(2);
						case 'c': return String.fromCharCode(value);
						case 'o': return value.toString(8);
						case 'x': return value.toString(16);
						case 'X': return value.toString(16).toUpperCase();
						case 'g': return value.toPrecision(precision);
						case 'e': return value.toExponential(precision);
						case 'f': return value.toFixed(precision);
						case 'r': return (value = this.round(value, this.precision(value, precision))).toFixed(Math.max(0, Math.min(20, this.precision(value * (1 + 1e-15), precision))));
						default: return value + '';
					}
				},

				round: function (value, precision) {

					return precision
						? Math.round(value * (precision = Math.pow(10, precision))) / precision
						: Math.round(value);
				},

				precision: function (value, precision) {

					return precision - (value ? Math.ceil(Math.log(value) / Math.LN10) : 1);
				},

				prefix: function (value, precision) {

					var prefixes = ['y', 'z', 'a', 'f', 'p', 'n', 'µ', 'm', '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'].map(function (d, i) {
						var k = Math.pow(10, Math.abs(8 - i) * 3);
						return {
							scale: i > 8 ? function (d) { return d / k; } : function (d) { return d * k; },
							symbol: d
						};
					});

					var i = 0;
					if (value) {
						if (value < 0) value *= -1;
						if (precision) value = this.round(value, this.precision(value, precision));
						i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
						i = Math.max(-24, Math.min(24, Math.floor((i <= 0 ? i + 1 : i - 1) / 3) * 3));
					}
					return prefixes[8 + i / 3];
				}
			},

			/*
				Pre-compile the HTML to be used as a template.
			*/
			template: function (html) {

				/*
					Must support the variation in templating syntax found here:
					https://lodash.com/docs#template
				*/
				var regex = /<%= ([^ ]+) %>|\$\{ ?([^\{\} ]+) ?\}|\{\{([^\{\} ]+)\}\}/g;

				return function (data) {

					data = data || {};

					return html.replace(regex, function (match) {

						var args = Array.from(arguments);
						var attr = args.slice(1, 4).find(function (_attr) {
							return !!_attr;
						});

						var attrArray = attr.split('.');
						var value = data[attrArray.shift()];

						while (value !== undefined && attrArray.length) {
							value = value[attrArray.shift()];
						}

						return value !== undefined ? value : '';
					});
				};
			},

			/**
			 * @param {Element=} el Element, which content is intent to display in full-screen mode, 'window.top.document.body' is default.
			 */
			toggleFullScreen: function (el) {

				el = el || window.top.document.body;

				function prefixedResult(el, prop) {

					var prefixes = ['webkit', 'moz', 'ms', 'o', ''];
					for (var i = 0; i < prefixes.length; i++) {
						var prefix = prefixes[i];
						var propName = prefix ? (prefix + prop) : (prop.substr(0, 1).toLowerCase() + prop.substr(1));
						if (el[propName] !== undefined) {
							return joint.util.isFunction(el[propName]) ? el[propName]() : el[propName];
						}
					}
				}

				if (prefixedResult(document, 'FullscreenElement') || prefixedResult(document, 'FullScreenElement')) {
					prefixedResult(document, 'ExitFullscreen') || // Spec.
						prefixedResult(document, 'CancelFullScreen'); // Firefox
				} else {
					prefixedResult(el, 'RequestFullscreen') || // Spec.
						prefixedResult(el, 'RequestFullScreen'); // Firefox
				}
			},

			addClassNamePrefix: function (className) {

				if (!className) return className;

				return className.toString().split(' ').map(function (_className) {

					if (_className.substr(0, joint.config.classNamePrefix.length) !== joint.config.classNamePrefix) {
						_className = joint.config.classNamePrefix + _className;
					}

					return _className;

				}).join(' ');
			},

			removeClassNamePrefix: function (className) {

				if (!className) return className;

				return className.toString().split(' ').map(function (_className) {

					if (_className.substr(0, joint.config.classNamePrefix.length) === joint.config.classNamePrefix) {
						_className = _className.substr(joint.config.classNamePrefix.length);
					}

					return _className;

				}).join(' ');
			},

			wrapWith: function (object, methods, wrapper) {

				if (joint.util.isString(wrapper)) {

					if (!joint.util.wrappers[wrapper]) {
						throw new Error('Unknown wrapper: "' + wrapper + '"');
					}

					wrapper = joint.util.wrappers[wrapper];
				}

				if (!joint.util.isFunction(wrapper)) {
					throw new Error('Wrapper must be a function.');
				}

				this.toArray(methods).forEach(function (method) {
					object[method] = wrapper(object[method]);
				});
			},

			wrappers: {

				/*
					Prepares a function with the following usage:
	
						fn([cell, cell, cell], opt);
						fn([cell, cell, cell]);
						fn(cell, cell, cell, opt);
						fn(cell, cell, cell);
						fn(cell);
				*/
				cells: function (fn) {

					return function () {

						var args = Array.from(arguments);
						var n = args.length;
						var cells = n > 0 && args[0] || [];
						var opt = n > 1 && args[n - 1] || {};

						if (!Array.isArray(cells)) {

							if (opt instanceof joint.dia.Cell) {
								cells = args;
							} else if (cells instanceof joint.dia.Cell) {
								if (args.length > 1) {
									args.pop();
								}
								cells = args;
							}
						}

						if (opt instanceof joint.dia.Cell) {
							opt = {};
						}

						return fn.call(this, cells, opt);
					};
				}
			},
			// lodash 3 vs 4 incompatible
			sortedIndex: _.sortedIndexBy || _.sortedIndex,
			uniq: _.uniqBy || _.uniq,
			uniqueId: _.uniqueId,
			sortBy: _.sortBy,
			isFunction: _.isFunction,
			result: _.result,
			union: _.union,
			invoke: _.invokeMap || _.invoke,
			difference: _.difference,
			intersection: _.intersection,
			omit: _.omit,
			pick: _.pick,
			has: _.has,
			bindAll: _.bindAll,
			assign: _.assign,
			defaults: _.defaults,
			defaultsDeep: _.defaultsDeep,
			isPlainObject: _.isPlainObject,
			isEmpty: _.isEmpty,
			isEqual: _.isEqual,
			noop: function () { },
			cloneDeep: _.cloneDeep,
			toArray: _.toArray,
			flattenDeep: _.flattenDeep,
			camelCase: _.camelCase,
			groupBy: _.groupBy,
			forIn: _.forIn,
			without: _.without,
			debounce: _.debounce,
			clone: _.clone,

			isBoolean: function (value) {
				var toString = Object.prototype.toString;
				return value === true || value === false || (!!value && typeof value === 'object' && toString.call(value) === '[object Boolean]');
			},

			isObject: function (value) {
				return !!value && (typeof value === 'object' || typeof value === 'function');
			},

			isNumber: function (value) {
				var toString = Object.prototype.toString;
				return typeof value === 'number' || (!!value && typeof value === 'object' && toString.call(value) === '[object Number]');
			},

			isString: function (value) {
				var toString = Object.prototype.toString;
				return typeof value === 'string' || (!!value && typeof value === 'object' && toString.call(value) === '[object String]');
			},

			merge: function () {
				if (_.mergeWith) {
					var args = Array.from(arguments);
					var last = args[args.length - 1];

					var customizer = this.isFunction(last) ? last : this.noop;
					args.push(function (a, b) {
						var customResult = customizer(a, b);
						if (customResult !== undefined) {
							return customResult;
						}

						if (Array.isArray(a) && !Array.isArray(b)) {
							return b;
						}
					});

					return _.mergeWith.apply(this, args)
				}
				return _.merge.apply(this, arguments);
			}
		}
	};


	joint.mvc.View = Backbone.View.extend({

		options: {},
		theme: null,
		themeClassNamePrefix: joint.util.addClassNamePrefix('theme-'),
		requireSetThemeOverride: false,
		defaultTheme: joint.config.defaultTheme,

		constructor: function (options) {

			this.requireSetThemeOverride = options && !!options.theme;
			this.options = joint.util.assign({}, this.options, options);

			Backbone.View.call(this, options);
		},

		initialize: function (options) {

			joint.util.bindAll(this, 'setTheme', 'onSetTheme', 'remove', 'onRemove');

			joint.mvc.views[this.cid] = this;

			this.setTheme(this.options.theme || this.defaultTheme);
			this.init();
		},

		// Override the Backbone `_ensureElement()` method in order to create an
		// svg element (e.g., `<g>`) node that wraps all the nodes of the Cell view.
		// Expose class name setter as a separate method.
		_ensureElement: function () {
			if (!this.el) {
				var tagName = joint.util.result(this, 'tagName');
				var attrs = joint.util.assign({}, joint.util.result(this, 'attributes'));
				if (this.id) attrs.id = joint.util.result(this, 'id');
				this.setElement(this._createElement(tagName));
				this._setAttributes(attrs);
			} else {
				this.setElement(joint.util.result(this, 'el'));
			}
			this._ensureElClassName();
		},

		_setAttributes: function (attrs) {
			if (this.svgElement) {
				this.vel.attr(attrs);
			} else {
				this.$el.attr(attrs);
			}
		},

		_createElement: function (tagName) {
			if (this.svgElement) {
				return document.createElementNS(V.namespace.xmlns, tagName);
			} else {
				return document.createElement(tagName);
			}
		},

		// Utilize an alternative DOM manipulation API by
		// adding an element reference wrapped in Vectorizer.
		_setElement: function (el) {
			this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
			this.el = this.$el[0];
			if (this.svgElement) this.vel = V(this.el);
		},

		_ensureElClassName: function () {
			var className = joint.util.result(this, 'className');
			var prefixedClassName = joint.util.addClassNamePrefix(className);
			// Note: className removal here kept for backwards compatibility only
			if (this.svgElement) {
				this.vel.removeClass(className).addClass(prefixedClassName);
			} else {
				this.$el.removeClass(className).addClass(prefixedClassName);
			}
		},

		init: function () {
			// Intentionally empty.
			// This method is meant to be overriden.
		},

		onRender: function () {
			// Intentionally empty.
			// This method is meant to be overriden.
		},

		setTheme: function (theme, opt) {

			opt = opt || {};

			// Theme is already set, override is required, and override has not been set.
			// Don't set the theme.
			if (this.theme && this.requireSetThemeOverride && !opt.override) {
				return this;
			}

			this.removeThemeClassName();
			this.addThemeClassName(theme);
			this.onSetTheme(this.theme/* oldTheme */, theme/* newTheme */);
			this.theme = theme;

			return this;
		},

		addThemeClassName: function (theme) {

			theme = theme || this.theme;

			var className = this.themeClassNamePrefix + theme;

			this.$el.addClass(className);

			return this;
		},

		removeThemeClassName: function (theme) {

			theme = theme || this.theme;

			var className = this.themeClassNamePrefix + theme;

			this.$el.removeClass(className);

			return this;
		},

		onSetTheme: function (oldTheme, newTheme) {
			// Intentionally empty.
			// This method is meant to be overriden.
		},

		remove: function () {

			this.onRemove();

			joint.mvc.views[this.cid] = null;

			Backbone.View.prototype.remove.apply(this, arguments);

			return this;
		},

		onRemove: function () {
			// Intentionally empty.
			// This method is meant to be overriden.
		},

		getEventNamespace: function () {
			// Returns a per-session unique namespace
			return '.joint-event-ns-' + this.cid;
		}

	}, {

			extend: function () {

				var args = Array.from(arguments);

				// Deep clone the prototype and static properties objects.
				// This prevents unexpected behavior where some properties are overwritten outside of this function.
				var protoProps = args[0] && joint.util.assign({}, args[0]) || {};
				var staticProps = args[1] && joint.util.assign({}, args[1]) || {};

				// Need the real render method so that we can wrap it and call it later.
				var renderFn = protoProps.render || (this.prototype && this.prototype.render) || null;

				/*
					Wrap the real render method so that:
						.. `onRender` is always called.
						.. `this` is always returned.
				*/
				protoProps.render = function () {

					if (renderFn) {
						// Call the original render method.
						renderFn.apply(this, arguments);
					}

					// Should always call onRender() method.
					this.onRender();

					// Should always return itself.
					return this;
				};

				return Backbone.View.extend.call(this, protoProps, staticProps);
			}
		});



	joint.dia.GraphCells = Backbone.Collection.extend({

		cellNamespace: joint.shapes,

		initialize: function (models, opt) {

			// Set the optional namespace where all model classes are defined.
			if (opt.cellNamespace) {
				this.cellNamespace = opt.cellNamespace;
			}

			this.graph = opt.graph;
		},

		model: function (attrs, options) {

			var collection = options.collection;
			var namespace = collection.cellNamespace;

			// Find the model class in the namespace or use the default one.
			var ModelClass = (attrs.type === 'link')
				? joint.dia.Link
				: joint.util.getByPath(namespace, attrs.type, '.') || joint.dia.Element;

			var cell = new ModelClass(attrs, options);
			// Add a reference to the graph. It is necessary to do this here because this is the earliest place
			// where a new model is created from a plain JS object. For other objects, see `joint.dia.Graph>>_prepareCell()`.
			cell.graph = collection.graph;

			return cell;
		},

		// `comparator` makes it easy to sort cells based on their `z` index.
		comparator: function (model) {

			return model.get('z') || 0;
		}
	});


	joint.dia.Graph = Backbone.Model.extend({

		_batches: {},

		initialize: function (attrs, opt) {

			opt = opt || {};

			// Passing `cellModel` function in the options object to graph allows for
			// setting models based on attribute objects. This is especially handy
			// when processing JSON graphs that are in a different than JointJS format.
			var cells = new joint.dia.GraphCells([], {
				model: opt.cellModel,
				cellNamespace: opt.cellNamespace,
				graph: this
			});
			Backbone.Model.prototype.set.call(this, 'cells', cells);

			// Make all the events fired in the `cells` collection available.
			// to the outside world.
			cells.on('all', this.trigger, this);

			// Backbone automatically doesn't trigger re-sort if models attributes are changed later when
			// they're already in the collection. Therefore, we're triggering sort manually here.
			this.on('change:z', this._sortOnChangeZ, this);
			this.on('batch:stop', this._onBatchStop, this);

			// `joint.dia.Graph` keeps an internal data structure (an adjacency list)
			// for fast graph queries. All changes that affect the structure of the graph
			// must be reflected in the `al` object. This object provides fast answers to
			// questions such as "what are the neighbours of this node" or "what
			// are the sibling links of this link".

			// Outgoing edges per node. Note that we use a hash-table for the list
			// of outgoing edges for a faster lookup.
			// [node ID] -> Object [edge] -> true
			this._out = {};
			// Ingoing edges per node.
			// [node ID] -> Object [edge] -> true
			this._in = {};
			// `_nodes` is useful for quick lookup of all the elements in the graph, without
			// having to go through the whole cells array.
			// [node ID] -> true
			this._nodes = {};
			// `_edges` is useful for quick lookup of all the links in the graph, without
			// having to go through the whole cells array.
			// [edge ID] -> true
			this._edges = {};

			cells.on('add', this._restructureOnAdd, this);
			cells.on('remove', this._restructureOnRemove, this);
			cells.on('reset', this._restructureOnReset, this);
			cells.on('change:source', this._restructureOnChangeSource, this);
			cells.on('change:target', this._restructureOnChangeTarget, this);
			cells.on('remove', this._removeCell, this);
		},

		_sortOnChangeZ: function () {

			if (!this.hasActiveBatch('to-front') && !this.hasActiveBatch('to-back')) {
				this.get('cells').sort();
			}
		},

		_onBatchStop: function (data) {

			var batchName = data && data.batchName;
			if ((batchName === 'to-front' || batchName === 'to-back') && !this.hasActiveBatch(batchName)) {
				this.get('cells').sort();
			}
		},

		_restructureOnAdd: function (cell) {

			if (cell.isLink()) {
				this._edges[cell.id] = true;
				var source = cell.get('source');
				var target = cell.get('target');
				if (source.id) {
					(this._out[source.id] || (this._out[source.id] = {}))[cell.id] = true;
				}
				if (target.id) {
					(this._in[target.id] || (this._in[target.id] = {}))[cell.id] = true;
				}
			} else {
				this._nodes[cell.id] = true;
			}
		},

		_restructureOnRemove: function (cell) {

			if (cell.isLink()) {
				delete this._edges[cell.id];
				var source = cell.get('source');
				var target = cell.get('target');
				if (source.id && this._out[source.id] && this._out[source.id][cell.id]) {
					delete this._out[source.id][cell.id];
				}
				if (target.id && this._in[target.id] && this._in[target.id][cell.id]) {
					delete this._in[target.id][cell.id];
				}
			} else {
				delete this._nodes[cell.id];
			}
		},

		_restructureOnReset: function (cells) {

			// Normalize into an array of cells. The original `cells` is GraphCells Backbone collection.
			cells = cells.models;

			this._out = {};
			this._in = {};
			this._nodes = {};
			this._edges = {};

			cells.forEach(this._restructureOnAdd, this);
		},

		_restructureOnChangeSource: function (link) {

			var prevSource = link.previous('source');
			if (prevSource.id && this._out[prevSource.id]) {
				delete this._out[prevSource.id][link.id];
			}
			var source = link.get('source');
			if (source.id) {
				(this._out[source.id] || (this._out[source.id] = {}))[link.id] = true;
			}
		},

		_restructureOnChangeTarget: function (link) {

			var prevTarget = link.previous('target');
			if (prevTarget.id && this._in[prevTarget.id]) {
				delete this._in[prevTarget.id][link.id];
			}
			var target = link.get('target');
			if (target.id) {
				(this._in[target.id] || (this._in[target.id] = {}))[link.id] = true;
			}
		},

		// Return all outbound edges for the node. Return value is an object
		// of the form: [edge] -> true
		getOutboundEdges: function (node) {

			return (this._out && this._out[node]) || {};
		},

		// Return all inbound edges for the node. Return value is an object
		// of the form: [edge] -> true
		getInboundEdges: function (node) {

			return (this._in && this._in[node]) || {};
		},

		toJSON: function () {

			// Backbone does not recursively call `toJSON()` on attributes that are themselves models/collections.
			// It just clones the attributes. Therefore, we must call `toJSON()` on the cells collection explicitely.
			var json = Backbone.Model.prototype.toJSON.apply(this, arguments);
			json.cells = this.get('cells').toJSON();
			return json;
		},

		fromJSON: function (json, opt) {

			if (!json.cells) {

				throw new Error('Graph JSON must contain cells array.');
			}

			return this.set(json, opt);
		},

		set: function (key, val, opt) {

			var attrs;

			// Handle both `key`, value and {key: value} style arguments.
			if (typeof key === 'object') {
				attrs = key;
				opt = val;
			} else {
				(attrs = {})[key] = val;
			}

			// Make sure that `cells` attribute is handled separately via resetCells().
			if (attrs.hasOwnProperty('cells')) {
				this.resetCells(attrs.cells, opt);
				attrs = joint.util.omit(attrs, 'cells');
			}

			// The rest of the attributes are applied via original set method.
			return Backbone.Model.prototype.set.call(this, attrs, opt);
		},

		clear: function (opt) {

			opt = joint.util.assign({}, opt, { clear: true });

			var collection = this.get('cells');

			if (collection.length === 0) return this;

			this.startBatch('clear', opt);

			// The elements come after the links.
			var cells = collection.sortBy(function (cell) {
				return cell.isLink() ? 1 : 2;
			});

			do {

				// Remove all the cells one by one.
				// Note that all the links are removed first, so it's
				// safe to remove the elements without removing the connected
				// links first.
				cells.shift().remove(opt);

			} while (cells.length > 0);

			this.stopBatch('clear');

			return this;
		},

		_prepareCell: function (cell, opt) {

			var attrs;
			if (cell instanceof Backbone.Model) {
				attrs = cell.attributes;
				if (!cell.graph && (!opt || !opt.dry)) {
					// An element can not be member of more than one graph.
					// A cell stops being the member of the graph after it's explicitely removed.
					cell.graph = this;
				}
			} else {
				// In case we're dealing with a plain JS object, we have to set the reference
				// to the `graph` right after the actual model is created. This happens in the `model()` function
				// of `joint.dia.GraphCells`.
				attrs = cell;
			}

			if (!joint.util.isString(attrs.type)) {
				throw new TypeError('dia.Graph: cell type must be a string.');
			}

			return cell;
		},

		maxZIndex: function () {

			var lastCell = this.get('cells').last();
			return lastCell ? (lastCell.get('z') || 0) : 0;
		},

		addCell: function (cell, opt) {

			if (Array.isArray(cell)) {

				return this.addCells(cell, opt);
			}

			if (cell instanceof Backbone.Model) {

				if (!cell.has('z')) {
					cell.set('z', this.maxZIndex() + 1);
				}

			} else if (cell.z === undefined) {

				cell.z = this.maxZIndex() + 1;
			}

			this.get('cells').add(this._prepareCell(cell, opt), opt || {});

			return this;
		},

		addCells: function (cells, opt) {

			if (cells.length) {

				cells = joint.util.flattenDeep(cells);
				opt.position = cells.length;

				this.startBatch('add');
				cells.forEach(function (cell) {
					opt.position--;
					this.addCell(cell, opt);
				}, this);
				this.stopBatch('add');
			}

			return this;
		},

		// When adding a lot of cells, it is much more efficient to
		// reset the entire cells collection in one go.
		// Useful for bulk operations and optimizations.
		resetCells: function (cells, opt) {

			var preparedCells = joint.util.toArray(cells).map(function (cell) {
				return this._prepareCell(cell, opt);
			}, this);
			this.get('cells').reset(preparedCells, opt);

			return this;
		},

		removeCells: function (cells, opt) {

			if (cells.length) {

				this.startBatch('remove');
				joint.util.invoke(cells, 'remove', opt);
				this.stopBatch('remove');
			}

			return this;
		},

		_removeCell: function (cell, collection, options) {

			options = options || {};

			if (!options.clear) {
				// Applications might provide a `disconnectLinks` option set to `true` in order to
				// disconnect links when a cell is removed rather then removing them. The default
				// is to remove all the associated links.
				if (options.disconnectLinks) {

					this.disconnectLinks(cell, options);

				} else {

					this.removeLinks(cell, options);
				}
			}
			// Silently remove the cell from the cells collection. Silently, because
			// `joint.dia.Cell.prototype.remove` already triggers the `remove` event which is
			// then propagated to the graph model. If we didn't remove the cell silently, two `remove` events
			// would be triggered on the graph model.
			this.get('cells').remove(cell, { silent: true });

			if (cell.graph === this) {
				// Remove the element graph reference only if the cell is the member of this graph.
				cell.graph = null;
			}
		},

		// Get a cell by `id`.
		getCell: function (id) {

			return this.get('cells').get(id);
		},

		getCells: function () {

			return this.get('cells').toArray();
		},

		getElements: function () {
			return Object.keys(this._nodes).map(this.getCell, this);
		},

		getLinks: function () {
			return Object.keys(this._edges).map(this.getCell, this);
		},

		getFirstCell: function () {

			return this.get('cells').first();
		},

		getLastCell: function () {

			return this.get('cells').last();
		},

		// Get all inbound and outbound links connected to the cell `model`.
		getConnectedLinks: function (model, opt) {

			opt = opt || {};

			var inbound = opt.inbound;
			var outbound = opt.outbound;
			if (inbound === undefined && outbound === undefined) {
				inbound = outbound = true;
			}

			// The final array of connected link models.
			var links = [];
			// Connected edges. This hash table ([edge] -> true) serves only
			// for a quick lookup to check if we already added a link.
			var edges = {};

			if (outbound) {
				joint.util.forIn(this.getOutboundEdges(model.id), function (exists, edge) {
					if (!edges[edge]) {
						links.push(this.getCell(edge));
						edges[edge] = true;
					}
				}.bind(this));
			}
			if (inbound) {
				joint.util.forIn(this.getInboundEdges(model.id), function (exists, edge) {
					// Skip links that were already added. Those must be self-loop links
					// because they are both inbound and outbond edges of the same element.
					if (!edges[edge]) {
						links.push(this.getCell(edge));
						edges[edge] = true;
					}
				}.bind(this));
			}

			// If 'deep' option is 'true', return all the links that are connected to any of the descendent cells
			// and are not descendents themselves.
			if (opt.deep) {

				var embeddedCells = model.getEmbeddedCells({ deep: true });
				// In the first round, we collect all the embedded edges so that we can exclude
				// them from the final result.
				var embeddedEdges = {};
				embeddedCells.forEach(function (cell) {
					if (cell.isLink()) {
						embeddedEdges[cell.id] = true;
					}
				});
				embeddedCells.forEach(function (cell) {
					if (cell.isLink()) return;
					if (outbound) {
						joint.util.forIn(this.getOutboundEdges(cell.id), function (exists, edge) {
							if (!edges[edge] && !embeddedEdges[edge]) {
								links.push(this.getCell(edge));
								edges[edge] = true;
							}
						}.bind(this));
					}
					if (inbound) {
						joint.util.forIn(this.getInboundEdges(cell.id), function (exists, edge) {
							if (!edges[edge] && !embeddedEdges[edge]) {
								links.push(this.getCell(edge));
								edges[edge] = true;
							}
						}.bind(this));
					}
				}, this);
			}

			return links;
		},

		getNeighbors: function (model, opt) {

			opt = opt || {};

			var inbound = opt.inbound;
			var outbound = opt.outbound;
			if (inbound === undefined && outbound === undefined) {
				inbound = outbound = true;
			}

			var neighbors = this.getConnectedLinks(model, opt).reduce(function (res, link) {

				var source = link.get('source');
				var target = link.get('target');
				var loop = link.hasLoop(opt);

				// Discard if it is a point, or if the neighbor was already added.
				if (inbound && joint.util.has(source, 'id') && !res[source.id]) {

					var sourceElement = this.getCell(source.id);

					if (loop || (sourceElement && sourceElement !== model && (!opt.deep || !sourceElement.isEmbeddedIn(model)))) {
						res[source.id] = sourceElement;
					}
				}

				// Discard if it is a point, or if the neighbor was already added.
				if (outbound && joint.util.has(target, 'id') && !res[target.id]) {

					var targetElement = this.getCell(target.id);

					if (loop || (targetElement && targetElement !== model && (!opt.deep || !targetElement.isEmbeddedIn(model)))) {
						res[target.id] = targetElement;
					}
				}

				return res;
			}.bind(this), {});

			return joint.util.toArray(neighbors);
		},

		getCommonAncestor: function (/* cells */) {

			var cellsAncestors = Array.from(arguments).map(function (cell) {

				var ancestors = [];
				var parentId = cell.get('parent');

				while (parentId) {

					ancestors.push(parentId);
					parentId = this.getCell(parentId).get('parent');
				}

				return ancestors;

			}, this);

			cellsAncestors = cellsAncestors.sort(function (a, b) {
				return a.length - b.length;
			});

			var commonAncestor = joint.util.toArray(cellsAncestors.shift()).find(function (ancestor) {
				return cellsAncestors.every(function (cellAncestors) {
					return cellAncestors.includes(ancestor);
				});
			});

			return this.getCell(commonAncestor);
		},

		// Find the whole branch starting at `element`.
		// If `opt.deep` is `true`, take into account embedded elements too.
		// If `opt.breadthFirst` is `true`, use the Breadth-first search algorithm, otherwise use Depth-first search.
		getSuccessors: function (element, opt) {

			opt = opt || {};
			var res = [];
			// Modify the options so that it includes the `outbound` neighbors only. In other words, search forwards.
			this.search(element, function (el) {
				if (el !== element) {
					res.push(el);
				}
			}, joint.util.assign({}, opt, { outbound: true }));
			return res;
		},

		// Clone `cells` returning an object that maps the original cell ID to the clone. The number
		// of clones is exactly the same as the `cells.length`.
		// This function simply clones all the `cells`. However, it also reconstructs
		// all the `source/target` and `parent/embed` references within the `cells`.
		// This is the main difference from the `cell.clone()` method. The
		// `cell.clone()` method works on one single cell only.
		// For example, for a graph: `A --- L ---> B`, `cloneCells([A, L, B])`
		// returns `[A2, L2, B2]` resulting to a graph: `A2 --- L2 ---> B2`, i.e.
		// the source and target of the link `L2` is changed to point to `A2` and `B2`.
		cloneCells: function (cells) {

			cells = joint.util.uniq(cells);

			// A map of the form [original cell ID] -> [clone] helping
			// us to reconstruct references for source/target and parent/embeds.
			// This is also the returned value.
			var cloneMap = joint.util.toArray(cells).reduce(function (map, cell) {
				map[cell.id] = cell.clone();
				return map;
			}, {});

			joint.util.toArray(cells).forEach(function (cell) {

				var clone = cloneMap[cell.id];
				// assert(clone exists)

				if (clone.isLink()) {
					var source = clone.get('source');
					var target = clone.get('target');
					if (source.id && cloneMap[source.id]) {
						// Source points to an element and the element is among the clones.
						// => Update the source of the cloned link.
						clone.prop('source/id', cloneMap[source.id].id);
					}
					if (target.id && cloneMap[target.id]) {
						// Target points to an element and the element is among the clones.
						// => Update the target of the cloned link.
						clone.prop('target/id', cloneMap[target.id].id);
					}
				}

				// Find the parent of the original cell
				var parent = cell.get('parent');
				if (parent && cloneMap[parent]) {
					clone.set('parent', cloneMap[parent].id);
				}

				// Find the embeds of the original cell
				var embeds = joint.util.toArray(cell.get('embeds')).reduce(function (newEmbeds, embed) {
					// Embedded cells that are not being cloned can not be carried
					// over with other embedded cells.
					if (cloneMap[embed]) {
						newEmbeds.push(cloneMap[embed].id);
					}
					return newEmbeds;
				}, []);

				if (!joint.util.isEmpty(embeds)) {
					clone.set('embeds', embeds);
				}
			});

			return cloneMap;
		},

		// Clone the whole subgraph (including all the connected links whose source/target is in the subgraph).
		// If `opt.deep` is `true`, also take into account all the embedded cells of all the subgraph cells.
		// Return a map of the form: [original cell ID] -> [clone].
		cloneSubgraph: function (cells, opt) {

			var subgraph = this.getSubgraph(cells, opt);
			return this.cloneCells(subgraph);
		},

		// Return `cells` and all the connected links that connect cells in the `cells` array.
		// If `opt.deep` is `true`, return all the cells including all their embedded cells
		// and all the links that connect any of the returned cells.
		// For example, for a single shallow element, the result is that very same element.
		// For two elements connected with a link: `A --- L ---> B`, the result for
		// `getSubgraph([A, B])` is `[A, L, B]`. The same goes for `getSubgraph([L])`, the result is again `[A, L, B]`.
		getSubgraph: function (cells, opt) {

			opt = opt || {};

			var subgraph = [];
			// `cellMap` is used for a quick lookup of existance of a cell in the `cells` array.
			var cellMap = {};
			var elements = [];
			var links = [];

			joint.util.toArray(cells).forEach(function (cell) {
				if (!cellMap[cell.id]) {
					subgraph.push(cell);
					cellMap[cell.id] = cell;
					if (cell.isLink()) {
						links.push(cell);
					} else {
						elements.push(cell);
					}
				}

				if (opt.deep) {
					var embeds = cell.getEmbeddedCells({ deep: true });
					embeds.forEach(function (embed) {
						if (!cellMap[embed.id]) {
							subgraph.push(embed);
							cellMap[embed.id] = embed;
							if (embed.isLink()) {
								links.push(embed);
							} else {
								elements.push(embed);
							}
						}
					});
				}
			});

			links.forEach(function (link) {
				// For links, return their source & target (if they are elements - not points).
				var source = link.get('source');
				var target = link.get('target');
				if (source.id && !cellMap[source.id]) {
					var sourceElement = this.getCell(source.id);
					subgraph.push(sourceElement);
					cellMap[sourceElement.id] = sourceElement;
					elements.push(sourceElement);
				}
				if (target.id && !cellMap[target.id]) {
					var targetElement = this.getCell(target.id);
					subgraph.push(this.getCell(target.id));
					cellMap[targetElement.id] = targetElement;
					elements.push(targetElement);
				}
			}, this);

			elements.forEach(function (element) {
				// For elements, include their connected links if their source/target is in the subgraph;
				var links = this.getConnectedLinks(element, opt);
				links.forEach(function (link) {
					var source = link.get('source');
					var target = link.get('target');
					if (!cellMap[link.id] && source.id && cellMap[source.id] && target.id && cellMap[target.id]) {
						subgraph.push(link);
						cellMap[link.id] = link;
					}
				});
			}, this);

			return subgraph;
		},

		// Find all the predecessors of `element`. This is a reverse operation of `getSuccessors()`.
		// If `opt.deep` is `true`, take into account embedded elements too.
		// If `opt.breadthFirst` is `true`, use the Breadth-first search algorithm, otherwise use Depth-first search.
		getPredecessors: function (element, opt) {

			opt = opt || {};
			var res = [];
			// Modify the options so that it includes the `inbound` neighbors only. In other words, search backwards.
			this.search(element, function (el) {
				if (el !== element) {
					res.push(el);
				}
			}, joint.util.assign({}, opt, { inbound: true }));
			return res;
		},

		// Perform search on the graph.
		// If `opt.breadthFirst` is `true`, use the Breadth-first Search algorithm, otherwise use Depth-first search.
		// By setting `opt.inbound` to `true`, you can reverse the direction of the search.
		// If `opt.deep` is `true`, take into account embedded elements too.
		// `iteratee` is a function of the form `function(element) {}`.
		// If `iteratee` explicitely returns `false`, the searching stops.
		search: function (element, iteratee, opt) {

			opt = opt || {};
			if (opt.breadthFirst) {
				this.bfs(element, iteratee, opt);
			} else {
				this.dfs(element, iteratee, opt);
			}
		},

		// Breadth-first search.
		// If `opt.deep` is `true`, take into account embedded elements too.
		// If `opt.inbound` is `true`, reverse the search direction (it's like reversing all the link directions).
		// `iteratee` is a function of the form `function(element, distance) {}`.
		// where `element` is the currently visited element and `distance` is the distance of that element
		// from the root `element` passed the `bfs()`, i.e. the element we started the search from.
		// Note that the `distance` is not the shortest or longest distance, it is simply the number of levels
		// crossed till we visited the `element` for the first time. It is especially useful for tree graphs.
		// If `iteratee` explicitely returns `false`, the searching stops.
		bfs: function (element, iteratee, opt) {

			opt = opt || {};
			var visited = {};
			var distance = {};
			var queue = [];

			queue.push(element);
			distance[element.id] = 0;

			while (queue.length > 0) {
				var next = queue.shift();
				if (!visited[next.id]) {
					visited[next.id] = true;
					if (iteratee(next, distance[next.id]) === false) return;
					this.getNeighbors(next, opt).forEach(function (neighbor) {
						distance[neighbor.id] = distance[next.id] + 1;
						queue.push(neighbor);
					});
				}
			}
		},

		// Depth-first search.
		// If `opt.deep` is `true`, take into account embedded elements too.
		// If `opt.inbound` is `true`, reverse the search direction (it's like reversing all the link directions).
		// `iteratee` is a function of the form `function(element, distance) {}`.
		// If `iteratee` explicitely returns `false`, the search stops.
		dfs: function (element, iteratee, opt, _visited, _distance) {

			opt = opt || {};
			var visited = _visited || {};
			var distance = _distance || 0;
			if (iteratee(element, distance) === false) return;
			visited[element.id] = true;

			this.getNeighbors(element, opt).forEach(function (neighbor) {
				if (!visited[neighbor.id]) {
					this.dfs(neighbor, iteratee, opt, visited, distance + 1);
				}
			}, this);
		},

		// Get all the roots of the graph. Time complexity: O(|V|).
		getSources: function () {

			var sources = [];
			joint.util.forIn(this._nodes, function (exists, node) {
				if (!this._in[node] || joint.util.isEmpty(this._in[node])) {
					sources.push(this.getCell(node));
				}
			}.bind(this));
			return sources;
		},

		// Get all the leafs of the graph. Time complexity: O(|V|).
		getSinks: function () {

			var sinks = [];
			joint.util.forIn(this._nodes, function (exists, node) {
				if (!this._out[node] || joint.util.isEmpty(this._out[node])) {
					sinks.push(this.getCell(node));
				}
			}.bind(this));
			return sinks;
		},

		// Return `true` if `element` is a root. Time complexity: O(1).
		isSource: function (element) {

			return !this._in[element.id] || joint.util.isEmpty(this._in[element.id]);
		},

		// Return `true` if `element` is a leaf. Time complexity: O(1).
		isSink: function (element) {

			return !this._out[element.id] || joint.util.isEmpty(this._out[element.id]);
		},

		// Return `true` is `elementB` is a successor of `elementA`. Return `false` otherwise.
		isSuccessor: function (elementA, elementB) {

			var isSuccessor = false;
			this.search(elementA, function (element) {
				if (element === elementB && element !== elementA) {
					isSuccessor = true;
					return false;
				}
			}, { outbound: true });
			return isSuccessor;
		},

		// Return `true` is `elementB` is a predecessor of `elementA`. Return `false` otherwise.
		isPredecessor: function (elementA, elementB) {

			var isPredecessor = false;
			this.search(elementA, function (element) {
				if (element === elementB && element !== elementA) {
					isPredecessor = true;
					return false;
				}
			}, { inbound: true });
			return isPredecessor;
		},

		// Return `true` is `elementB` is a neighbor of `elementA`. Return `false` otherwise.
		// `opt.deep` controls whether to take into account embedded elements as well. See `getNeighbors()`
		// for more details.
		// If `opt.outbound` is set to `true`, return `true` only if `elementB` is a successor neighbor.
		// Similarly, if `opt.inbound` is set to `true`, return `true` only if `elementB` is a predecessor neighbor.
		isNeighbor: function (elementA, elementB, opt) {

			opt = opt || {};

			var inbound = opt.inbound;
			var outbound = opt.outbound;
			if (inbound === undefined && outbound === undefined) {
				inbound = outbound = true;
			}

			var isNeighbor = false;

			this.getConnectedLinks(elementA, opt).forEach(function (link) {

				var source = link.get('source');
				var target = link.get('target');

				// Discard if it is a point.
				if (inbound && joint.util.has(source, 'id') && source.id === elementB.id) {
					isNeighbor = true;
					return false;
				}

				// Discard if it is a point, or if the neighbor was already added.
				if (outbound && joint.util.has(target, 'id') && target.id === elementB.id) {
					isNeighbor = true;
					return false;
				}
			});

			return isNeighbor;
		},

		// Disconnect links connected to the cell `model`.
		disconnectLinks: function (model, opt) {

			this.getConnectedLinks(model).forEach(function (link) {

				link.set(link.get('source').id === model.id ? 'source' : 'target', { x: 0, y: 0 }, opt);
			});
		},

		// Remove links connected to the cell `model` completely.
		removeLinks: function (model, opt) {

			joint.util.invoke(this.getConnectedLinks(model), 'remove', opt);
		},

		// Find all elements at given point
		findModelsFromPoint: function (p) {

			return this.getElements().filter(function (el) {
				return el.getBBox().containsPoint(p);
			});
		},

		// Find all elements in given area
		findModelsInArea: function (rect, opt) {

			rect = g.rect(rect);
			opt = joint.util.defaults(opt || {}, { strict: false });

			var method = opt.strict ? 'containsRect' : 'intersect';

			return this.getElements().filter(function (el) {
				return rect[method](el.getBBox());
			});
		},

		// Find all elements under the given element.
		findModelsUnderElement: function (element, opt) {

			opt = joint.util.defaults(opt || {}, { searchBy: 'bbox' });

			var bbox = element.getBBox();
			var elements = (opt.searchBy === 'bbox')
				? this.findModelsInArea(bbox)
				: this.findModelsFromPoint(bbox[opt.searchBy]());

			// don't account element itself or any of its descendents
			return elements.filter(function (el) {
				return element.id !== el.id && !el.isEmbeddedIn(element);
			});
		},


		// Return bounding box of all elements.
		getBBox: function (cells, opt) {

			return this.getCellsBBox(cells || this.getElements(), opt);
		},

		// Return the bounding box of all cells in array provided.
		// Links are being ignored.
		getCellsBBox: function (cells, opt) {

			return joint.util.toArray(cells).reduce(function (memo, cell) {
				if (cell.isLink()) return memo;
				if (memo) {
					return memo.union(cell.getBBox(opt));
				} else {
					return cell.getBBox(opt);
				}
			}, null);
		},

		translate: function (dx, dy, opt) {

			// Don't translate cells that are embedded in any other cell.
			var cells = this.getCells().filter(function (cell) {
				return !cell.isEmbedded();
			});

			joint.util.invoke(cells, 'translate', dx, dy, opt);

			return this;
		},

		resize: function (width, height, opt) {

			return this.resizeCells(width, height, this.getCells(), opt);
		},

		resizeCells: function (width, height, cells, opt) {

			// `getBBox` method returns `null` if no elements provided.
			// i.e. cells can be an array of links
			var bbox = this.getCellsBBox(cells);
			if (bbox) {
				var sx = Math.max(width / bbox.width, 0);
				var sy = Math.max(height / bbox.height, 0);
				joint.util.invoke(cells, 'scale', sx, sy, bbox.origin(), opt);
			}

			return this;
		},

		startBatch: function (name, data) {

			data = data || {};
			this._batches[name] = (this._batches[name] || 0) + 1;

			return this.trigger('batch:start', joint.util.assign({}, data, { batchName: name }));
		},

		stopBatch: function (name, data) {

			data = data || {};
			this._batches[name] = (this._batches[name] || 0) - 1;

			return this.trigger('batch:stop', joint.util.assign({}, data, { batchName: name }));
		},

		hasActiveBatch: function (name) {
			if (name) {
				return !!this._batches[name];
			} else {
				return joint.util.toArray(this._batches).some(function (batches) {
					return batches > 0;
				});
			}
		}
	});

	joint.util.wrapWith(joint.dia.Graph.prototype, ['resetCells', 'addCells', 'removeCells'], 'cells');

	(function (joint, _, g, $, util) {

		function isPercentage(val) {
			return util.isString(val) && val.slice(-1) === '%';
		}

		function setWrapper(attrName, dimension) {
			return function (value, refBBox) {
				var isValuePercentage = isPercentage(value);
				value = parseFloat(value);
				if (isValuePercentage) {
					value /= 100;
				}

				var attrs = {};
				if (isFinite(value)) {
					var attrValue = (isValuePercentage || value >= 0 && value <= 1)
						? value * refBBox[dimension]
						: Math.max(value + refBBox[dimension], 0);
					attrs[attrName] = attrValue;
				}

				return attrs;
			};
		}

		function positionWrapper(axis, dimension, origin) {
			return function (value, refBBox) {
				var valuePercentage = isPercentage(value);
				value = parseFloat(value);
				if (valuePercentage) {
					value /= 100;
				}

				var delta;
				if (isFinite(value)) {
					var refOrigin = refBBox[origin]();
					if (valuePercentage || value > 0 && value < 1) {
						delta = refOrigin[axis] + refBBox[dimension] * value;
					} else {
						delta = refOrigin[axis] + value;
					}
				}

				var point = g.Point();
				point[axis] = delta || 0;
				return point;
			};
		}

		function offsetWrapper(axis, dimension, corner) {
			return function (value, nodeBBox) {
				var delta;
				if (value === 'middle') {
					delta = nodeBBox[dimension] / 2;
				} else if (value === corner) {
					delta = nodeBBox[dimension];
				} else if (isFinite(value)) {
					// TODO: or not to do a breaking change?
					delta = (value > -1 && value < 1) ? (-nodeBBox[dimension] * value) : -value;
				} else if (isPercentage(value)) {
					delta = nodeBBox[dimension] * parseFloat(value) / 100;
				} else {
					delta = 0;
				}

				var point = g.Point();
				point[axis] = -(nodeBBox[axis] + delta);
				return point;
			};
		}

		var attributesNS = joint.dia.attributes = {

			xlinkHref: {
				set: 'xlink:href'
			},

			xlinkShow: {
				set: 'xlink:show'
			},

			xlinkRole: {
				set: 'xlink:role'
			},

			xlinkType: {
				set: 'xlink:type'
			},

			xlinkArcrole: {
				set: 'xlink:arcrole'
			},

			xlinkTitle: {
				set: 'xlink:title'
			},

			xlinkActuate: {
				set: 'xlink:actuate'
			},

			xmlSpace: {
				set: 'xml:space'
			},

			xmlBase: {
				set: 'xml:base'
			},

			xmlLang: {
				set: 'xml:lang'
			},

			preserveAspectRatio: {
				set: 'preserveAspectRatio'
			},

			requiredExtension: {
				set: 'requiredExtension'
			},

			requiredFeatures: {
				set: 'requiredFeatures'
			},

			systemLanguage: {
				set: 'systemLanguage'
			},

			externalResourcesRequired: {
				set: 'externalResourceRequired'
			},

			filter: {
				qualify: util.isPlainObject,
				set: function (filter) {
					return 'url(#' + this.paper.defineFilter(filter) + ')';
				}
			},

			fill: {
				qualify: util.isPlainObject,
				set: function (fill) {
					return 'url(#' + this.paper.defineGradient(fill) + ')';
				}
			},

			stroke: {
				qualify: util.isPlainObject,
				set: function (stroke) {
					return 'url(#' + this.paper.defineGradient(stroke) + ')';
				}
			},

			sourceMarker: {
				qualify: util.isPlainObject,
				set: function (marker) {
					return { 'marker-start': 'url(#' + this.paper.defineMarker(marker) + ')' };
				}
			},

			targetMarker: {
				qualify: util.isPlainObject,
				set: function (marker) {
					marker = util.assign({ transform: 'rotate(180)' }, marker);
					return { 'marker-end': 'url(#' + this.paper.defineMarker(marker) + ')' };
				}
			},

			vertexMarker: {
				qualify: util.isPlainObject,
				set: function (marker) {
					return { 'marker-mid': 'url(#' + this.paper.defineMarker(marker) + ')' };
				}
			},

			text: {
				set: function (text, refBBox, node, attrs) {
					var $node = $(node);
					var cacheName = 'joint-text';
					var cache = $node.data(cacheName);
					var textAttrs = joint.util.pick(attrs, 'lineHeight', 'annotations', 'textPath', 'x', 'eol');
					var fontSize = textAttrs.fontSize = attrs['font-size'] || attrs['fontSize'];
					var textHash = JSON.stringify([text, textAttrs]);
					// Update the text only if there was a change in the string
					// or any of its attributes.
					if (cache === undefined || cache !== textHash) {
						// Chrome bug:
						// Tspans positions defined as `em` are not updated
						// when container `font-size` change.
						if (fontSize) {
							node.setAttribute('font-size', fontSize);
						}
						V(node).text('' + text, textAttrs);
						$node.data(cacheName, textHash);
					}
				}
			},

			textWrap: {
				qualify: util.isPlainObject,
				set: function (value, refBBox, node, attrs) {
					// option `width`
					var width = value.width || 0;
					if (isPercentage(width)) {
						refBBox.width *= parseFloat(width) / 100;
					} else if (width <= 0) {
						refBBox.width += width;
					} else {
						refBBox.width = width;
					}
					// option `height`
					var height = value.height || 0;
					if (isPercentage(height)) {
						refBBox.height *= parseFloat(height) / 100;
					} else if (height <= 0) {
						refBBox.height += height;
					} else {
						refBBox.height = height;
					}
					// option `text`
					var wrappedText = joint.util.breakText('' + value.text, refBBox, {
						'font-weight': attrs['font-weight'] || attrs.fontWeight,
						'font-size': attrs['font-size'] || attrs.fontSize,
						'font-family': attrs['font-family'] || attrs.fontFamily
					}, {
							// Provide an existing SVG Document here
							// instead of creating a temporary one over again.
							svgDocument: this.paper.svg
						});

					V(node).text(wrappedText);
				}
			},

			lineHeight: {
				qualify: function (lineHeight, node, attrs) {
					return (attrs.text !== undefined);
				}
			},

			textPath: {
				qualify: function (textPath, node, attrs) {
					return (attrs.text !== undefined);
				}
			},

			annotations: {
				qualify: function (annotations, node, attrs) {
					return (attrs.text !== undefined);
				}
			},

			// `port` attribute contains the `id` of the port that the underlying magnet represents.
			port: {
				set: function (port) {
					return (port === null || port.id === undefined) ? port : port.id;
				}
			},

			// `style` attribute is special in the sense that it sets the CSS style of the subelement.
			style: {
				qualify: util.isPlainObject,
				set: function (styles, refBBox, node) {
					$(node).css(styles);
				}
			},

			html: {
				set: function (html, refBBox, node) {
					$(node).html(html + '');
				}
			},

			ref: {
				// We do not set `ref` attribute directly on an element.
				// The attribute itself does not qualify for relative positioning.
			},

			// if `refX` is in [0, 1] then `refX` is a fraction of bounding box width
			// if `refX` is < 0 then `refX`'s absolute values is the right coordinate of the bounding box
			// otherwise, `refX` is the left coordinate of the bounding box

			refX: {
				position: positionWrapper('x', 'width', 'origin')
			},

			refY: {
				position: positionWrapper('y', 'height', 'origin')
			},

			// `ref-dx` and `ref-dy` define the offset of the subelement relative to the right and/or bottom
			// coordinate of the reference element.

			refDx: {
				position: positionWrapper('x', 'width', 'corner')
			},

			refDy: {
				position: positionWrapper('y', 'height', 'corner')
			},

			// 'ref-width'/'ref-height' defines the width/height of the subelement relatively to
			// the reference element size
			// val in 0..1         ref-width = 0.75 sets the width to 75% of the ref. el. width
			// val < 0 || val > 1  ref-height = -20 sets the height to the the ref. el. height shorter by 20

			refWidth: {
				set: setWrapper('width', 'width')
			},

			refHeight: {
				set: setWrapper('height', 'height')
			},

			refRx: {
				set: setWrapper('rx', 'width')
			},

			refRy: {
				set: setWrapper('ry', 'height')
			},

			refCx: {
				set: setWrapper('cx', 'width')
			},

			refCy: {
				set: setWrapper('cy', 'height')
			},

			// `x-alignment` when set to `middle` causes centering of the subelement around its new x coordinate.
			// `x-alignment` when set to `right` uses the x coordinate as referenced to the right of the bbox.

			xAlignment: {
				offset: offsetWrapper('x', 'width', 'right')
			},

			// `y-alignment` when set to `middle` causes centering of the subelement around its new y coordinate.
			// `y-alignment` when set to `bottom` uses the y coordinate as referenced to the bottom of the bbox.

			yAlignment: {
				offset: offsetWrapper('y', 'height', 'bottom')
			},

			resetOffset: {
				offset: function (val, nodeBBox) {
					return (val)
						? { x: -nodeBBox.x, y: -nodeBBox.y }
						: { x: 0, y: 0 };
				}

			}
		};

		// This allows to combine both absolute and relative positioning
		// refX: 50%, refX2: 20
		attributesNS.refX2 = attributesNS.refX;
		attributesNS.refY2 = attributesNS.refY;

		// Aliases for backwards compatibility
		attributesNS['ref-x'] = attributesNS.refX;
		attributesNS['ref-y'] = attributesNS.refY;
		attributesNS['ref-dy'] = attributesNS.refDy;
		attributesNS['ref-dx'] = attributesNS.refDx;
		attributesNS['ref-width'] = attributesNS.refWidth;
		attributesNS['ref-height'] = attributesNS.refHeight;
		attributesNS['x-alignment'] = attributesNS.xAlignment;
		attributesNS['y-alignment'] = attributesNS.yAlignment;

	})(joint, _, g, $, joint.util);


	// joint.dia.Cell base model.
	// --------------------------

	joint.dia.Cell = Backbone.Model.extend({

		// This is the same as Backbone.Model with the only difference that is uses joint.util.merge
		// instead of just _.extend. The reason is that we want to mixin attributes set in upper classes.
		constructor: function (attributes, options) {

			var defaults;
			var attrs = attributes || {};
			this.cid = joint.util.uniqueId('c');
			this.attributes = {};
			if (options && options.collection) this.collection = options.collection;
			if (options && options.parse) attrs = this.parse(attrs, options) || {};
			if ((defaults = joint.util.result(this, 'defaults'))) {
				//<custom code>
				// Replaced the call to _.defaults with joint.util.merge.
				attrs = joint.util.merge({}, defaults, attrs);
				//</custom code>
			}
			this.set(attrs, options);
			this.changed = {};
			this.initialize.apply(this, arguments);
		},

		translate: function (dx, dy, opt) {

			throw new Error('Must define a translate() method.');
		},

		toJSON: function () {

			var defaultAttrs = this.constructor.prototype.defaults.attrs || {};
			var attrs = this.attributes.attrs;
			var finalAttrs = {};

			// Loop through all the attributes and
			// omit the default attributes as they are implicitly reconstructable by the cell 'type'.
			joint.util.forIn(attrs, function (attr, selector) {

				var defaultAttr = defaultAttrs[selector];

				joint.util.forIn(attr, function (value, name) {

					// attr is mainly flat though it might have one more level (consider the `style` attribute).
					// Check if the `value` is object and if yes, go one level deep.
					if (joint.util.isObject(value) && !Array.isArray(value)) {

						joint.util.forIn(value, function (value2, name2) {

							if (!defaultAttr || !defaultAttr[name] || !joint.util.isEqual(defaultAttr[name][name2], value2)) {

								finalAttrs[selector] = finalAttrs[selector] || {};
								(finalAttrs[selector][name] || (finalAttrs[selector][name] = {}))[name2] = value2;
							}
						});

					} else if (!defaultAttr || !joint.util.isEqual(defaultAttr[name], value)) {
						// `value` is not an object, default attribute for such a selector does not exist
						// or it is different than the attribute value set on the model.

						finalAttrs[selector] = finalAttrs[selector] || {};
						finalAttrs[selector][name] = value;
					}
				});
			});

			var attributes = joint.util.cloneDeep(joint.util.omit(this.attributes, 'attrs'));
			//var attributes = JSON.parse(JSON.stringify(_.omit(this.attributes, 'attrs')));
			attributes.attrs = finalAttrs;

			return attributes;
		},

		initialize: function (options) {

			if (!options || !options.id) {

				this.set('id', joint.util.uuid(), { silent: true });
			}

			this._transitionIds = {};

			// Collect ports defined in `attrs` and keep collecting whenever `attrs` object changes.
			this.processPorts();
			this.on('change:attrs', this.processPorts, this);
		},

		/**
		 * @deprecated
		 */
		processPorts: function () {

			// Whenever `attrs` changes, we extract ports from the `attrs` object and store it
			// in a more accessible way. Also, if any port got removed and there were links that had `target`/`source`
			// set to that port, we remove those links as well (to follow the same behaviour as
			// with a removed element).

			var previousPorts = this.ports;

			// Collect ports from the `attrs` object.
			var ports = {};
			joint.util.forIn(this.get('attrs'), function (attrs, selector) {

				if (attrs && attrs.port) {

					// `port` can either be directly an `id` or an object containing an `id` (and potentially other data).
					if (attrs.port.id !== undefined) {
						ports[attrs.port.id] = attrs.port;
					} else {
						ports[attrs.port] = { id: attrs.port };
					}
				}
			});

			// Collect ports that have been removed (compared to the previous ports) - if any.
			// Use hash table for quick lookup.
			var removedPorts = {};
			joint.util.forIn(previousPorts, function (port, id) {

				if (!ports[id]) removedPorts[id] = true;
			});

			// Remove all the incoming/outgoing links that have source/target port set to any of the removed ports.
			if (this.graph && !joint.util.isEmpty(removedPorts)) {

				var inboundLinks = this.graph.getConnectedLinks(this, { inbound: true });
				inboundLinks.forEach(function (link) {

					if (removedPorts[link.get('target').port]) link.remove();
				});

				var outboundLinks = this.graph.getConnectedLinks(this, { outbound: true });
				outboundLinks.forEach(function (link) {

					if (removedPorts[link.get('source').port]) link.remove();
				});
			}

			// Update the `ports` object.
			this.ports = ports;
		},

		remove: function (opt) {

			opt = opt || {};

			// Store the graph in a variable because `this.graph` won't' be accessbile after `this.trigger('remove', ...)` down below.
			var graph = this.graph;
			if (graph) {
				graph.startBatch('remove');
			}

			// First, unembed this cell from its parent cell if there is one.
			var parentCellId = this.get('parent');
			if (parentCellId) {

				var parentCell = graph && graph.getCell(parentCellId);
				parentCell.unembed(this);
			}

			joint.util.invoke(this.getEmbeddedCells(), 'remove', opt);

			this.trigger('remove', this, this.collection, opt);

			if (graph) {
				graph.stopBatch('remove');
			}

			return this;
		},

		toFront: function (opt) {

			if (this.graph) {

				opt = opt || {};

				var z = (this.graph.getLastCell().get('z') || 0) + 1;

				this.startBatch('to-front').set('z', z, opt);

				if (opt.deep) {

					var cells = this.getEmbeddedCells({ deep: true, breadthFirst: true });
					cells.forEach(function (cell) { cell.set('z', ++z, opt); });

				}

				this.stopBatch('to-front');
			}

			return this;
		},

		toBack: function (opt) {

			if (this.graph) {

				opt = opt || {};

				var z = (this.graph.getFirstCell().get('z') || 0) - 1;

				this.startBatch('to-back');

				if (opt.deep) {

					var cells = this.getEmbeddedCells({ deep: true, breadthFirst: true });
					cells.reverse().forEach(function (cell) { cell.set('z', z--, opt); });
				}

				this.set('z', z, opt).stopBatch('to-back');
			}

			return this;
		},

		embed: function (cell, opt) {

			if (this === cell || this.isEmbeddedIn(cell)) {

				throw new Error('Recursive embedding not allowed.');

			} else {

				this.startBatch('embed');

				var embeds = joint.util.assign([], this.get('embeds'));

				// We keep all element ids after link ids.
				embeds[cell.isLink() ? 'unshift' : 'push'](cell.id);

				cell.set('parent', this.id, opt);
				this.set('embeds', joint.util.uniq(embeds), opt);

				this.stopBatch('embed');
			}

			return this;
		},

		unembed: function (cell, opt) {

			this.startBatch('unembed');

			cell.unset('parent', opt);
			this.set('embeds', joint.util.without(this.get('embeds'), cell.id), opt);

			this.stopBatch('unembed');

			return this;
		},

		// Return an array of ancestor cells.
		// The array is ordered from the parent of the cell
		// to the most distant ancestor.
		getAncestors: function () {

			var ancestors = [];
			var parentId = this.get('parent');

			if (!this.graph) {
				return ancestors;
			}

			while (parentId !== undefined) {
				var parent = this.graph.getCell(parentId);
				if (parent !== undefined) {
					ancestors.push(parent);
					parentId = parent.get('parent');
				} else {
					break;
				}
			}

			return ancestors;
		},

		getEmbeddedCells: function (opt) {

			opt = opt || {};

			// Cell models can only be retrieved when this element is part of a collection.
			// There is no way this element knows about other cells otherwise.
			// This also means that calling e.g. `translate()` on an element with embeds before
			// adding it to a graph does not translate its embeds.
			if (this.graph) {

				var cells;

				if (opt.deep) {

					if (opt.breadthFirst) {

						// breadthFirst algorithm
						cells = [];
						var queue = this.getEmbeddedCells();

						while (queue.length > 0) {

							var parent = queue.shift();
							cells.push(parent);
							queue.push.apply(queue, parent.getEmbeddedCells());
						}

					} else {

						// depthFirst algorithm
						cells = this.getEmbeddedCells();
						cells.forEach(function (cell) {
							cells.push.apply(cells, cell.getEmbeddedCells(opt));
						});
					}

				} else {

					cells = joint.util.toArray(this.get('embeds')).map(this.graph.getCell, this.graph);
				}

				return cells;
			}
			return [];
		},

		isEmbeddedIn: function (cell, opt) {

			var cellId = joint.util.isString(cell) ? cell : cell.id;
			var parentId = this.get('parent');

			opt = joint.util.defaults({ deep: true }, opt);

			// See getEmbeddedCells().
			if (this.graph && opt.deep) {

				while (parentId) {
					if (parentId === cellId) {
						return true;
					}
					parentId = this.graph.getCell(parentId).get('parent');
				}

				return false;

			} else {

				// When this cell is not part of a collection check
				// at least whether it's a direct child of given cell.
				return parentId === cellId;
			}
		},

		// Whether or not the cell is embedded in any other cell.
		isEmbedded: function () {

			return !!this.get('parent');
		},

		// Isolated cloning. Isolated cloning has two versions: shallow and deep (pass `{ deep: true }` in `opt`).
		// Shallow cloning simply clones the cell and returns a new cell with different ID.
		// Deep cloning clones the cell and all its embedded cells recursively.
		clone: function (opt) {

			opt = opt || {};

			if (!opt.deep) {
				// Shallow cloning.

				var clone = Backbone.Model.prototype.clone.apply(this, arguments);
				// We don't want the clone to have the same ID as the original.
				clone.set('id', joint.util.uuid());
				// A shallow cloned element does not carry over the original embeds.
				clone.unset('embeds');
				// And can not be embedded in any cell
				// as the clone is not part of the graph.
				clone.unset('parent');

				return clone;

			} else {
				// Deep cloning.

				// For a deep clone, simply call `graph.cloneCells()` with the cell and all its embedded cells.
				return joint.util.toArray(joint.dia.Graph.prototype.cloneCells.call(null, [this].concat(this.getEmbeddedCells({ deep: true }))));
			}
		},

		// A convenient way to set nested properties.
		// This method merges the properties you'd like to set with the ones
		// stored in the cell and makes sure change events are properly triggered.
		// You can either set a nested property with one object
		// or use a property path.
		// The most simple use case is:
		// `cell.prop('name/first', 'John')` or
		// `cell.prop({ name: { first: 'John' } })`.
		// Nested arrays are supported too:
		// `cell.prop('series/0/data/0/degree', 50)` or
		// `cell.prop({ series: [ { data: [ { degree: 50 } ] } ] })`.
		prop: function (props, value, opt) {

			var delim = '/';
			var isString = joint.util.isString(props);

			if (isString || Array.isArray(props)) {
				// Get/set an attribute by a special path syntax that delimits
				// nested objects by the colon character.

				if (arguments.length > 1) {

					var path;
					var pathArray;

					if (isString) {
						path = props;
						pathArray = path.split('/')
					} else {
						path = props.join(delim);
						pathArray = props.slice();
					}

					var property = pathArray[0];
					var pathArrayLength = pathArray.length;

					opt = opt || {};
					opt.propertyPath = path;
					opt.propertyValue = value;
					opt.propertyPathArray = pathArray;

					if (pathArrayLength === 1) {
						// Property is not nested. We can simply use `set()`.
						return this.set(property, value, opt);
					}

					var update = {};
					// Initialize the nested object. Subobjects are either arrays or objects.
					// An empty array is created if the sub-key is an integer. Otherwise, an empty object is created.
					// Note that this imposes a limitation on object keys one can use with Inspector.
					// Pure integer keys will cause issues and are therefore not allowed.
					var initializer = update;
					var prevProperty = property;

					for (var i = 1; i < pathArrayLength; i++) {
						var pathItem = pathArray[i];
						var isArrayIndex = Number.isFinite(isString ? Number(pathItem) : pathItem);
						initializer = initializer[prevProperty] = isArrayIndex ? [] : {};
						prevProperty = pathItem;
					}

					// Fill update with the `value` on `path`.
					update = joint.util.setByPath(update, pathArray, value, '/');

					var baseAttributes = joint.util.merge({}, this.attributes);
					// if rewrite mode enabled, we replace value referenced by path with
					// the new one (we don't merge).
					opt.rewrite && joint.util.unsetByPath(baseAttributes, path, '/');

					// Merge update with the model attributes.
					var attributes = joint.util.merge(baseAttributes, update);
					// Finally, set the property to the updated attributes.
					return this.set(property, attributes[property], opt);

				} else {

					return joint.util.getByPath(this.attributes, props, delim);
				}
			}

			return this.set(joint.util.merge({}, this.attributes, props), value);
		},

		// A convient way to unset nested properties
		removeProp: function (path, opt) {

			// Once a property is removed from the `attrs` attribute
			// the cellView will recognize a `dirty` flag and rerender itself
			// in order to remove the attribute from SVG element.
			opt = opt || {};
			opt.dirty = true;

			var pathArray = Array.isArray(path) ? path : path.split('/');

			if (pathArray.length === 1) {
				// A top level property
				return this.unset(path, opt);
			}

			// A nested property
			var property = pathArray[0];
			var nestedPath = pathArray.slice(1);
			var propertyValue = joint.util.merge({}, this.get(property));

			joint.util.unsetByPath(propertyValue, nestedPath, '/');

			return this.set(property, propertyValue, opt);
		},

		// A convenient way to set nested attributes.
		attr: function (attrs, value, opt) {

			var args = Array.from(arguments);
			if (args.length === 0) {
				return this.get('attrs');
			}

			if (Array.isArray(attrs)) {
				args[0] = ['attrs'].concat(attrs);
			} else if (joint.util.isString(attrs)) {
				// Get/set an attribute by a special path syntax that delimits
				// nested objects by the colon character.
				args[0] = 'attrs/' + attrs;

			} else {

				args[0] = { 'attrs': attrs };
			}

			return this.prop.apply(this, args);
		},

		// A convenient way to unset nested attributes
		removeAttr: function (path, opt) {

			if (Array.isArray(path)) {

				return this.removeProp(['attrs'].concat(path));
			}

			return this.removeProp('attrs/' + path, opt);
		},

		transition: function (path, value, opt, delim) {

			delim = delim || '/';

			var defaults = {
				duration: 100,
				delay: 10,
				timingFunction: joint.util.timing.linear,
				valueFunction: joint.util.interpolate.number
			};

			opt = joint.util.assign(defaults, opt);

			var firstFrameTime = 0;
			var interpolatingFunction;

			var setter = function (runtime) {

				var id, progress, propertyValue;

				firstFrameTime = firstFrameTime || runtime;
				runtime -= firstFrameTime;
				progress = runtime / opt.duration;

				if (progress < 1) {
					this._transitionIds[path] = id = joint.util.nextFrame(setter);
				} else {
					progress = 1;
					delete this._transitionIds[path];
				}

				propertyValue = interpolatingFunction(opt.timingFunction(progress));

				opt.transitionId = id;

				this.prop(path, propertyValue, opt);

				if (!id) this.trigger('transition:end', this, path);

			}.bind(this);

			var initiator = function (callback) {

				this.stopTransitions(path);

				interpolatingFunction = opt.valueFunction(joint.util.getByPath(this.attributes, path, delim), value);

				this._transitionIds[path] = joint.util.nextFrame(callback);

				this.trigger('transition:start', this, path);

			}.bind(this);

			return setTimeout(initiator, opt.delay, setter);
		},

		getTransitions: function () {
			return Object.keys(this._transitionIds);
		},

		stopTransitions: function (path, delim) {

			delim = delim || '/';

			var pathArray = path && path.split(delim);

			Object.keys(this._transitionIds).filter(pathArray && function (key) {

				return joint.util.isEqual(pathArray, key.split(delim).slice(0, pathArray.length));

			}).forEach(function (key) {

				joint.util.cancelFrame(this._transitionIds[key]);

				delete this._transitionIds[key];

				this.trigger('transition:end', this, key);

			}, this);

			return this;
		},

		// A shorcut making it easy to create constructs like the following:
		// `var el = (new joint.shapes.basic.Rect).addTo(graph)`.
		addTo: function (graph, opt) {

			graph.addCell(this, opt);
			return this;
		},

		// A shortcut for an equivalent call: `paper.findViewByModel(cell)`
		// making it easy to create constructs like the following:
		// `cell.findView(paper).highlight()`
		findView: function (paper) {

			return paper.findViewByModel(this);
		},

		isElement: function () {

			return false;
		},

		isLink: function () {

			return false;
		},

		startBatch: function (name, opt) {
			if (this.graph) { this.graph.startBatch(name, joint.util.assign({}, opt, { cell: this })); }
			return this;
		},

		stopBatch: function (name, opt) {
			if (this.graph) { this.graph.stopBatch(name, joint.util.assign({}, opt, { cell: this })); }
			return this;
		}

	}, {

			getAttributeDefinition: function (attrName) {

				var defNS = this.attributes;
				var globalDefNS = joint.dia.attributes;
				return (defNS && defNS[attrName]) || globalDefNS[attrName];
			},

			define: function (type, defaults, protoProps, staticProps) {

				protoProps = joint.util.assign({
					defaults: joint.util.defaultsDeep({ type: type }, defaults, this.prototype.defaults)
				}, protoProps);

				var Cell = this.extend(protoProps, staticProps);
				joint.util.setByPath(joint.shapes, type, Cell, '.');
				return Cell;
			}
		});

	// joint.dia.CellView base view and controller.
	// --------------------------------------------

	// This is the base view and controller for `joint.dia.ElementView` and `joint.dia.LinkView`.

	joint.dia.CellView = joint.mvc.View.extend({

		tagName: 'g',

		svgElement: true,

		className: function () {

			var classNames = ['cell'];
			var type = this.model.get('type');

			if (type) {

				type.toLowerCase().split('.').forEach(function (value, index, list) {
					classNames.push('type-' + list.slice(0, index + 1).join('-'));
				});
			}

			return classNames.join(' ');
		},

		attributes: function () {

			return { 'model-id': this.model.id };
		},

		constructor: function (options) {

			// Make sure a global unique id is assigned to this view. Store this id also to the properties object.
			// The global unique id makes sure that the same view can be rendered on e.g. different machines and
			// still be associated to the same object among all those clients. This is necessary for real-time
			// collaboration mechanism.
			options.id = options.id || joint.util.guid(this);

			joint.mvc.View.call(this, options);
		},

		init: function () {

			joint.util.bindAll(this, 'remove', 'update');

			// Store reference to this to the <g> DOM element so that the view is accessible through the DOM tree.
			this.$el.data('view', this);

			// Add the cell's type to the view's element as a data attribute.
			this.$el.attr('data-type', this.model.get('type'));

			this.listenTo(this.model, 'change:attrs', this.onChangeAttrs);
		},

		onChangeAttrs: function (cell, attrs, opt) {

			if (opt.dirty) {

				// dirty flag could be set when a model attribute was removed and it needs to be cleared
				// also from the DOM element. See cell.removeAttr().
				return this.render();
			}

			return this.update(cell, attrs, opt);
		},

		// Return `true` if cell link is allowed to perform a certain UI `feature`.
		// Example: `can('vertexMove')`, `can('labelMove')`.
		can: function (feature) {

			var interactive = joint.util.isFunction(this.options.interactive)
				? this.options.interactive(this)
				: this.options.interactive;

			return (joint.util.isObject(interactive) && interactive[feature] !== false) ||
				(joint.util.isBoolean(interactive) && interactive !== false);
		},

		findBySelector: function (selector, root) {

			var $root = $(root || this.el);
			// These are either descendants of `this.$el` of `this.$el` itself.
			// `.` is a special selector used to select the wrapping `<g>` element.
			return (selector === '.') ? $root : $root.find(selector);
		},

		notify: function (eventName) {

			if (this.paper) {

				var args = Array.prototype.slice.call(arguments, 1);

				// Trigger the event on both the element itself and also on the paper.
				this.trigger.apply(this, [eventName].concat(args));

				// Paper event handlers receive the view object as the first argument.
				this.paper.trigger.apply(this.paper, [eventName, this].concat(args));
			}
		},

		getStrokeBBox: function (el) {
			// Return a bounding box rectangle that takes into account stroke.
			// Note that this is a naive and ad-hoc implementation that does not
			// works only in certain cases and should be replaced as soon as browsers will
			// start supporting the getStrokeBBox() SVG method.
			// @TODO any better solution is very welcome!

			var isMagnet = !!el;

			el = el || this.el;
			var bbox = V(el).getBBox({ target: this.paper.viewport });

			var strokeWidth;
			if (isMagnet) {

				strokeWidth = V(el).attr('stroke-width');

			} else {

				strokeWidth = this.model.attr('rect/stroke-width') || this.model.attr('circle/stroke-width') || this.model.attr('ellipse/stroke-width') || this.model.attr('path/stroke-width');
			}

			strokeWidth = parseFloat(strokeWidth) || 0;

			return g.rect(bbox).moveAndExpand({ x: -strokeWidth / 2, y: -strokeWidth / 2, width: strokeWidth, height: strokeWidth });
		},

		getBBox: function () {

			return this.vel.getBBox({ target: this.paper.svg });
		},

		highlight: function (el, opt) {

			el = !el ? this.el : this.$(el)[0] || this.el;

			// set partial flag if the highlighted element is not the entire view.
			opt = opt || {};
			opt.partial = (el !== this.el);

			this.notify('cell:highlight', el, opt);
			return this;
		},

		unhighlight: function (el, opt) {

			el = !el ? this.el : this.$(el)[0] || this.el;

			opt = opt || {};
			opt.partial = el != this.el;

			this.notify('cell:unhighlight', el, opt);
			return this;
		},

		// Find the closest element that has the `magnet` attribute set to `true`. If there was not such
		// an element found, return the root element of the cell view.
		findMagnet: function (el) {

			var $el = this.$(el);
			var $rootEl = this.$el;

			if ($el.length === 0) {
				$el = $rootEl;
			}

			do {

				var magnet = $el.attr('magnet');
				if ((magnet || $el.is($rootEl)) && magnet !== 'false') {
					return $el[0];
				}

				$el = $el.parent();

			} while ($el.length > 0);

			// If the overall cell has set `magnet === false`, then return `undefined` to
			// announce there is no magnet found for this cell.
			// This is especially useful to set on cells that have 'ports'. In this case,
			// only the ports have set `magnet === true` and the overall element has `magnet === false`.
			return undefined;
		},

		// Construct a unique selector for the `el` element within this view.
		// `prevSelector` is being collected through the recursive call.
		// No value for `prevSelector` is expected when using this method.
		getSelector: function (el, prevSelector) {

			if (el === this.el) {
				return prevSelector;
			}

			var selector;

			if (el) {

				var nthChild = V(el).index() + 1;
				selector = el.tagName + ':nth-child(' + nthChild + ')';

				if (prevSelector) {
					selector += ' > ' + prevSelector;
				}

				selector = this.getSelector(el.parentNode, selector);
			}

			return selector;
		},

		getAttributeDefinition: function (attrName) {

			return this.model.constructor.getAttributeDefinition(attrName);
		},

		setNodeAttributes: function (node, attrs) {

			if (!joint.util.isEmpty(attrs)) {
				if (node instanceof SVGElement) {
					V(node).attr(attrs);
				} else {
					$(node).attr(attrs);
				}
			}
		},

		processNodeAttributes: function (node, attrs) {

			var attrName, attrVal, def, i, n;
			var normalAttrs, setAttrs, positionAttrs, offsetAttrs;
			var relatives = [];
			// divide the attributes between normal and special
			for (attrName in attrs) {
				if (!attrs.hasOwnProperty(attrName)) continue;
				attrVal = attrs[attrName];
				def = this.getAttributeDefinition(attrName);
				if (def && (!joint.util.isFunction(def.qualify) || def.qualify.call(this, attrVal, node, attrs))) {
					if (joint.util.isString(def.set)) {
						normalAttrs || (normalAttrs = {});
						normalAttrs[def.set] = attrVal;
					}
					if (attrVal !== null) {
						relatives.push(attrName, def);
					}
				} else {
					normalAttrs || (normalAttrs = {});
					normalAttrs[joint.util.toKebabCase(attrName)] = attrVal;
				}
			}

			// handle the rest of attributes via related method
			// from the special attributes namespace.
			for (i = 0, n = relatives.length; i < n; i += 2) {
				attrName = relatives[i];
				def = relatives[i + 1];
				attrVal = attrs[attrName];
				if (joint.util.isFunction(def.set)) {
					setAttrs || (setAttrs = {});
					setAttrs[attrName] = attrVal;
				}
				if (joint.util.isFunction(def.position)) {
					positionAttrs || (positionAttrs = {});
					positionAttrs[attrName] = attrVal;
				}
				if (joint.util.isFunction(def.offset)) {
					offsetAttrs || (offsetAttrs = {});
					offsetAttrs[attrName] = attrVal;
				}
			}

			return {
				raw: attrs,
				normal: normalAttrs,
				set: setAttrs,
				position: positionAttrs,
				offset: offsetAttrs
			};
		},

		updateRelativeAttributes: function (node, attrs, refBBox, opt) {

			opt || (opt = {});

			var attrName, attrVal, def;
			var rawAttrs = attrs.raw || {};
			var nodeAttrs = attrs.normal || {};
			var setAttrs = attrs.set;
			var positionAttrs = attrs.position;
			var offsetAttrs = attrs.offset;

			for (attrName in setAttrs) {
				attrVal = setAttrs[attrName];
				def = this.getAttributeDefinition(attrName);
				// SET - set function should return attributes to be set on the node,
				// which will affect the node dimensions based on the reference bounding
				// box. e.g. `width`, `height`, `d`, `rx`, `ry`, `points
				var setResult = def.set.call(this, attrVal, refBBox.clone(), node, rawAttrs);
				if (joint.util.isObject(setResult)) {
					joint.util.assign(nodeAttrs, setResult);
				} else if (setResult !== undefined) {
					nodeAttrs[attrName] = setResult;
				}
			}

			if (node instanceof HTMLElement) {
				// TODO: setting the `transform` attribute on HTMLElements
				// via `node.style.transform = 'matrix(...)';` would introduce
				// a breaking change (e.g. basic.TextBlock).
				this.setNodeAttributes(node, nodeAttrs);
				return;
			}

			// The final translation of the subelement.
			var nodeTransform = nodeAttrs.transform;
			var nodeMatrix = V.transformStringToMatrix(nodeTransform);
			var nodePosition = g.Point(nodeMatrix.e, nodeMatrix.f);
			if (nodeTransform) {
				nodeAttrs = joint.util.omit(nodeAttrs, 'transform');
				nodeMatrix.e = nodeMatrix.f = 0;
			}

			// Calculate node scale determined by the scalable group
			// only if later needed.
			var sx, sy, translation;
			if (positionAttrs || offsetAttrs) {
				var nodeScale = this.getNodeScale(node, opt.scalableNode);
				sx = nodeScale.sx;
				sy = nodeScale.sy;
			}

			var positioned = false;
			for (attrName in positionAttrs) {
				attrVal = positionAttrs[attrName];
				def = this.getAttributeDefinition(attrName);
				// POSITION - position function should return a point from the
				// reference bounding box. The default position of the node is x:0, y:0 of
				// the reference bounding box or could be further specify by some
				// SVG attributes e.g. `x`, `y`
				translation = def.position.call(this, attrVal, refBBox.clone(), node, rawAttrs);
				if (translation) {
					nodePosition.offset(g.Point(translation).scale(sx, sy));
					positioned || (positioned = true);
				}
			}

			// The node bounding box could depend on the `size` set from the previous loop.
			// Here we know, that all the size attributes have been already set.
			this.setNodeAttributes(node, nodeAttrs);

			var offseted = false;
			if (offsetAttrs) {
				// Check if the node is visible
				var nodeClientRect = node.getBoundingClientRect();
				if (nodeClientRect.width > 0 && nodeClientRect.height > 0) {
					var nodeBBox = V.transformRect(node.getBBox(), nodeMatrix).scale(1 / sx, 1 / sy);
					for (attrName in offsetAttrs) {
						attrVal = offsetAttrs[attrName];
						def = this.getAttributeDefinition(attrName);
						// OFFSET - offset function should return a point from the element
						// bounding box. The default offset point is x:0, y:0 (origin) or could be further
						// specify with some SVG attributes e.g. `text-anchor`, `cx`, `cy`
						translation = def.offset.call(this, attrVal, nodeBBox, node, rawAttrs);
						if (translation) {
							nodePosition.offset(g.Point(translation).scale(sx, sy));
							offseted || (offseted = true);
						}
					}
				}
			}

			// Do not touch node's transform attribute if there is no transformation applied.
			if (nodeTransform !== undefined || positioned || offseted) {
				// Round the coordinates to 1 decimal point.
				nodePosition.round(1);
				nodeMatrix.e = nodePosition.x;
				nodeMatrix.f = nodePosition.y;
				node.setAttribute('transform', V.matrixToTransformString(nodeMatrix));
			}
		},

		getNodeScale: function (node, scalableNode) {

			// Check if the node is a descendant of the scalable group.
			var sx, sy;
			if (scalableNode && scalableNode.contains(node)) {
				var scale = scalableNode.scale();
				sx = 1 / scale.sx;
				sy = 1 / scale.sy;
			} else {
				sx = 1;
				sy = 1;
			}

			return { sx: sx, sy: sy };
		},

		findNodesAttributes: function (attrs, root, selectorCache) {

			// TODO: merge attributes in order defined by `index` property

			var nodesAttrs = {};

			for (var selector in attrs) {
				if (!attrs.hasOwnProperty(selector)) continue;
				var $selected = selectorCache[selector] = this.findBySelector(selector, root);

				for (var i = 0, n = $selected.length; i < n; i++) {
					var node = $selected[i];
					var nodeId = V.ensureId(node);
					var nodeAttrs = attrs[selector];
					var prevNodeAttrs = nodesAttrs[nodeId];
					if (prevNodeAttrs) {
						if (!prevNodeAttrs.merged) {
							prevNodeAttrs.merged = true;
							prevNodeAttrs.attributes = joint.util.cloneDeep(prevNodeAttrs.attributes);
						}
						joint.util.merge(prevNodeAttrs.attributes, nodeAttrs);
					} else {
						nodesAttrs[nodeId] = {
							attributes: nodeAttrs,
							node: node,
							merged: false
						};
					}
				}
			}

			return nodesAttrs;
		},

		// Default is to process the `model.attributes.attrs` object and set attributes on subelements based on the selectors,
		// unless `attrs` parameter was passed.
		updateDOMSubtreeAttributes: function (rootNode, attrs, opt) {

			opt || (opt = {});
			opt.rootBBox || (opt.rootBBox = g.Rect());

			// Cache table for query results and bounding box calculation.
			// Note that `selectorCache` needs to be invalidated for all
			// `updateAttributes` calls, as the selectors might pointing
			// to nodes designated by an attribute or elements dynamically
			// created.
			var selectorCache = {};
			var bboxCache = {};
			var relativeItems = [];
			var item, node, nodeAttrs, nodeData, processedAttrs;

			var roAttrs = opt.roAttributes;
			var nodesAttrs = this.findNodesAttributes(roAttrs || attrs, rootNode, selectorCache);
			// `nodesAttrs` are different from all attributes, when
			// rendering only  attributes sent to this method.
			var nodesAllAttrs = (roAttrs)
				? nodesAllAttrs = this.findNodesAttributes(attrs, rootNode, selectorCache)
				: nodesAttrs;

			for (var nodeId in nodesAttrs) {
				nodeData = nodesAttrs[nodeId];
				nodeAttrs = nodeData.attributes;
				node = nodeData.node;
				processedAttrs = this.processNodeAttributes(node, nodeAttrs);

				if (!processedAttrs.set && !processedAttrs.position && !processedAttrs.offset) {
					// Set all the normal attributes right on the SVG/HTML element.
					this.setNodeAttributes(node, processedAttrs.normal);

				} else {

					var nodeAllAttrs = nodesAllAttrs[nodeId] && nodesAllAttrs[nodeId].attributes;
					var refSelector = (nodeAllAttrs && (nodeAttrs.ref === undefined))
						? nodeAllAttrs.ref
						: nodeAttrs.ref;

					var refNode;
					if (refSelector) {
						refNode = (selectorCache[refSelector] || this.findBySelector(refSelector, rootNode))[0];
						if (!refNode) {
							throw new Error('dia.ElementView: "' + refSelector + '" reference does not exists.');
						}
					} else {
						refNode = null;
					}

					item = {
						node: node,
						refNode: refNode,
						processedAttributes: processedAttrs,
						allAttributes: nodeAllAttrs
					};

					// If an element in the list is positioned relative to this one, then
					// we want to insert this one before it in the list.
					var itemIndex = relativeItems.findIndex(function (item) {
						return item.refNode === node;
					});

					if (itemIndex > -1) {
						relativeItems.splice(itemIndex, 0, item);
					} else {
						relativeItems.push(item);
					}
				}
			}

			for (var i = 0, n = relativeItems.length; i < n; i++) {
				item = relativeItems[i];
				node = item.node;
				refNode = item.refNode;

				// Find the reference element bounding box. If no reference was provided, we
				// use the optional bounding box.
				var refNodeId = refNode ? V.ensureId(refNode) : '';
				var refBBox = bboxCache[refNodeId];
				if (!refBBox) {
					// Get the bounding box of the reference element relative to the `rotatable` `<g>` (without rotation)
					// or to the root `<g>` element if no rotatable group present if reference node present.
					// Uses the bounding box provided.
					refBBox = bboxCache[refNodeId] = (refNode)
						? V(refNode).getBBox({ target: (opt.rotatableNode || rootNode) })
						: opt.rootBBox;
				}

				if (roAttrs) {
					// if there was a special attribute affecting the position amongst passed-in attributes
					// we have to merge it with the rest of the element's attributes as they are necessary
					// to update the position relatively (i.e `ref-x` && 'ref-dx')
					processedAttrs = this.processNodeAttributes(node, item.allAttributes);
					this.mergeProcessedAttributes(processedAttrs, item.processedAttributes);

				} else {
					processedAttrs = item.processedAttributes;
				}

				this.updateRelativeAttributes(node, processedAttrs, refBBox, opt);
			}
		},

		mergeProcessedAttributes: function (processedAttrs, roProcessedAttrs) {

			processedAttrs.set || (processedAttrs.set = {});
			processedAttrs.position || (processedAttrs.position = {});
			processedAttrs.offset || (processedAttrs.offset = {});

			joint.util.assign(processedAttrs.set, roProcessedAttrs.set);
			joint.util.assign(processedAttrs.position, roProcessedAttrs.position);
			joint.util.assign(processedAttrs.offset, roProcessedAttrs.offset);

			// Handle also the special transform property.
			var transform = processedAttrs.normal && processedAttrs.normal.transform;
			if (transform !== undefined && roProcessedAttrs.normal) {
				roProcessedAttrs.normal.transform = transform;
			}
			processedAttrs.normal = roProcessedAttrs.normal;
		},

		// Interaction. The controller part.
		// ---------------------------------

		// Interaction is handled by the paper and delegated to the view in interest.
		// `x` & `y` parameters passed to these functions represent the coordinates already snapped to the paper grid.
		// If necessary, real coordinates can be obtained from the `evt` event object.

		// These functions are supposed to be overriden by the views that inherit from `joint.dia.Cell`,
		// i.e. `joint.dia.Element` and `joint.dia.Link`.

		pointerdblclick: function (evt, x, y) {

			this.notify('cell:pointerdblclick', evt, x, y);
		},

		pointerclick: function (evt, x, y) {

			this.notify('cell:pointerclick', evt, x, y);
		},

		pointerdown: function (evt, x, y) {

			if (this.model.graph) {
				this.model.startBatch('pointer');
				this._graph = this.model.graph;
			}

			this.notify('cell:pointerdown', evt, x, y);
		},

		pointermove: function (evt, x, y) {

			this.notify('cell:pointermove', evt, x, y);
		},

		pointerup: function (evt, x, y) {

			this.notify('cell:pointerup', evt, x, y);

			if (this._graph) {
				// we don't want to trigger event on model as model doesn't
				// need to be member of collection anymore (remove)
				this._graph.stopBatch('pointer', { cell: this.model });
				delete this._graph;
			}
		},

		mouseover: function (evt) {

			this.notify('cell:mouseover', evt);
		},

		mouseout: function (evt) {

			this.notify('cell:mouseout', evt);
		},

		mouseenter: function (evt) {

			this.notify('cell:mouseenter', evt);
		},

		mouseleave: function (evt) {

			this.notify('cell:mouseleave', evt);
		},

		mousewheel: function (evt, x, y, delta) {

			this.notify('cell:mousewheel', evt, x, y, delta);
		},

		contextmenu: function (evt, x, y) {

			this.notify('cell:contextmenu', evt, x, y);
		},

		event: function (evt, eventName, x, y) {

			this.notify(eventName, evt, x, y);
		},

		setInteractivity: function (value) {

			this.options.interactive = value;
		}
	});

	// joint.dia.Element base model.
	// -----------------------------

	joint.dia.Element = joint.dia.Cell.extend({

		defaults: {
			position: { x: 0, y: 0 },
			size: { width: 1, height: 1 },
			angle: 0
		},

		initialize: function () {

			this._initializePorts();
			joint.dia.Cell.prototype.initialize.apply(this, arguments);
		},

		/**
		 * @abstract
		 */
		_initializePorts: function () {
			// implemented in ports.js
		},

		isElement: function () {

			return true;
		},

		position: function (x, y, opt) {

			var isSetter = joint.util.isNumber(y);

			opt = (isSetter ? opt : x) || {};

			// option `parentRelative` for setting the position relative to the element's parent.
			if (opt.parentRelative) {

				// Getting the parent's position requires the collection.
				// Cell.get('parent') helds cell id only.
				if (!this.graph) throw new Error('Element must be part of a graph.');

				var parent = this.graph.getCell(this.get('parent'));
				var parentPosition = parent && !parent.isLink()
					? parent.get('position')
					: { x: 0, y: 0 };
			}

			if (isSetter) {

				if (opt.parentRelative) {
					x += parentPosition.x;
					y += parentPosition.y;
				}

				if (opt.deep) {
					var currentPosition = this.get('position');
					this.translate(x - currentPosition.x, y - currentPosition.y, opt);
				} else {
					this.set('position', { x: x, y: y }, opt);
				}

				return this;

			} else { // Getter returns a geometry point.

				var elementPosition = g.point(this.get('position'));

				return opt.parentRelative
					? elementPosition.difference(parentPosition)
					: elementPosition;
			}
		},

		translate: function (tx, ty, opt) {

			tx = tx || 0;
			ty = ty || 0;

			if (tx === 0 && ty === 0) {
				// Like nothing has happened.
				return this;
			}

			opt = opt || {};
			// Pass the initiator of the translation.
			opt.translateBy = opt.translateBy || this.id;

			var position = this.get('position') || { x: 0, y: 0 };

			if (opt.restrictedArea && opt.translateBy === this.id) {

				// We are restricting the translation for the element itself only. We get
				// the bounding box of the element including all its embeds.
				// All embeds have to be translated the exact same way as the element.
				var bbox = this.getBBox({ deep: true });
				var ra = opt.restrictedArea;
				//- - - - - - - - - - - - -> ra.x + ra.width
				// - - - -> position.x      |
				// -> bbox.x
				//                ▓▓▓▓▓▓▓   |
				//         ░░░░░░░▓▓▓▓▓▓▓
				//         ░░░░░░░░░        |
				//   ▓▓▓▓▓▓▓▓░░░░░░░
				//   ▓▓▓▓▓▓▓▓               |
				//   <-dx->                     | restricted area right border
				//         <-width->        |   ░ translated element
				//   <- - bbox.width - ->       ▓ embedded element
				var dx = position.x - bbox.x;
				var dy = position.y - bbox.y;
				// Find the maximal/minimal coordinates that the element can be translated
				// while complies the restrictions.
				var x = Math.max(ra.x + dx, Math.min(ra.x + ra.width + dx - bbox.width, position.x + tx));
				var y = Math.max(ra.y + dy, Math.min(ra.y + ra.height + dy - bbox.height, position.y + ty));
				// recalculate the translation taking the resctrictions into account.
				tx = x - position.x;
				ty = y - position.y;
			}

			var translatedPosition = {
				x: position.x + tx,
				y: position.y + ty
			};

			// To find out by how much an element was translated in event 'change:position' handlers.
			opt.tx = tx;
			opt.ty = ty;

			if (opt.transition) {

				if (!joint.util.isObject(opt.transition)) opt.transition = {};

				this.transition('position', translatedPosition, joint.util.assign({}, opt.transition, {
					valueFunction: joint.util.interpolate.object
				}));

			} else {

				this.set('position', translatedPosition, opt);
			}

			// Recursively call `translate()` on all the embeds cells.
			joint.util.invoke(this.getEmbeddedCells(), 'translate', tx, ty, opt);

			return this;
		},

		size: function (width, height, opt) {

			var currentSize = this.get('size');
			// Getter
			// () signature
			if (width === undefined) {
				return {
					width: currentSize.width,
					height: currentSize.height
				};
			}
			// Setter
			// (size, opt) signature
			if (joint.util.isObject(width)) {
				opt = height;
				height = joint.util.isNumber(width.height) ? width.height : currentSize.height;
				width = joint.util.isNumber(width.width) ? width.width : currentSize.width;
			}

			return this.resize(width, height, opt);
		},

		resize: function (width, height, opt) {

			opt = opt || {};

			this.startBatch('resize', opt);

			if (opt.direction) {

				var currentSize = this.get('size');

				switch (opt.direction) {

					case 'left':
					case 'right':
						// Don't change height when resizing horizontally.
						height = currentSize.height;
						break;

					case 'top':
					case 'bottom':
						// Don't change width when resizing vertically.
						width = currentSize.width;
						break;
				}

				// Get the angle and clamp its value between 0 and 360 degrees.
				var angle = g.normalizeAngle(this.get('angle') || 0);

				var quadrant = {
					'top-right': 0,
					'right': 0,
					'top-left': 1,
					'top': 1,
					'bottom-left': 2,
					'left': 2,
					'bottom-right': 3,
					'bottom': 3
				}[opt.direction];

				if (opt.absolute) {

					// We are taking the element's rotation into account
					quadrant += Math.floor((angle + 45) / 90);
					quadrant %= 4;
				}

				// This is a rectangle in size of the unrotated element.
				var bbox = this.getBBox();

				// Pick the corner point on the element, which meant to stay on its place before and
				// after the rotation.
				var fixedPoint = bbox[['bottomLeft', 'corner', 'topRight', 'origin'][quadrant]]();

				// Find  an image of the previous indent point. This is the position, where is the
				// point actually located on the screen.
				var imageFixedPoint = g.point(fixedPoint).rotate(bbox.center(), -angle);

				// Every point on the element rotates around a circle with the centre of rotation
				// in the middle of the element while the whole element is being rotated. That means
				// that the distance from a point in the corner of the element (supposed its always rect) to
				// the center of the element doesn't change during the rotation and therefore it equals
				// to a distance on unrotated element.
				// We can find the distance as DISTANCE = (ELEMENTWIDTH/2)^2 + (ELEMENTHEIGHT/2)^2)^0.5.
				var radius = Math.sqrt((width * width) + (height * height)) / 2;

				// Now we are looking for an angle between x-axis and the line starting at image of fixed point
				// and ending at the center of the element. We call this angle `alpha`.

				// The image of a fixed point is located in n-th quadrant. For each quadrant passed
				// going anti-clockwise we have to add 90 degrees. Note that the first quadrant has index 0.
				//
				// 3 | 2
				// --c-- Quadrant positions around the element's center `c`
				// 0 | 1
				//
				var alpha = quadrant * Math.PI / 2;

				// Add an angle between the beginning of the current quadrant (line parallel with x-axis or y-axis
				// going through the center of the element) and line crossing the indent of the fixed point and the center
				// of the element. This is the angle we need but on the unrotated element.
				alpha += Math.atan(quadrant % 2 == 0 ? height / width : width / height);

				// Lastly we have to deduct the original angle the element was rotated by and that's it.
				alpha -= g.toRad(angle);

				// With this angle and distance we can easily calculate the centre of the unrotated element.
				// Note that fromPolar constructor accepts an angle in radians.
				var center = g.point.fromPolar(radius, alpha, imageFixedPoint);

				// The top left corner on the unrotated element has to be half a width on the left
				// and half a height to the top from the center. This will be the origin of rectangle
				// we were looking for.
				var origin = g.point(center).offset(width / -2, height / -2);

				// Resize the element (before re-positioning it).
				this.set('size', { width: width, height: height }, opt);

				// Finally, re-position the element.
				this.position(origin.x, origin.y, opt);

			} else {

				// Resize the element.
				this.set('size', { width: width, height: height }, opt);
			}

			this.stopBatch('resize', opt);

			return this;
		},

		scale: function (sx, sy, origin, opt) {

			var scaledBBox = this.getBBox().scale(sx, sy, origin);
			this.startBatch('scale', opt);
			this.position(scaledBBox.x, scaledBBox.y, opt);
			this.resize(scaledBBox.width, scaledBBox.height, opt);
			this.stopBatch('scale');
			return this;
		},

		fitEmbeds: function (opt) {

			opt = opt || {};

			// Getting the children's size and position requires the collection.
			// Cell.get('embdes') helds an array of cell ids only.
			if (!this.graph) throw new Error('Element must be part of a graph.');

			var embeddedCells = this.getEmbeddedCells();

			if (embeddedCells.length > 0) {

				this.startBatch('fit-embeds', opt);

				if (opt.deep) {
					// Recursively apply fitEmbeds on all embeds first.
					joint.util.invoke(embeddedCells, 'fitEmbeds', opt);
				}

				// Compute cell's size and position  based on the children bbox
				// and given padding.
				var bbox = this.graph.getCellsBBox(embeddedCells);
				var padding = joint.util.normalizeSides(opt.padding);

				// Apply padding computed above to the bbox.
				bbox.moveAndExpand({
					x: -padding.left,
					y: -padding.top,
					width: padding.right + padding.left,
					height: padding.bottom + padding.top
				});

				// Set new element dimensions finally.
				this.set({
					position: { x: bbox.x, y: bbox.y },
					size: { width: bbox.width, height: bbox.height }
				}, opt);

				this.stopBatch('fit-embeds');
			}

			return this;
		},

		// Rotate element by `angle` degrees, optionally around `origin` point.
		// If `origin` is not provided, it is considered to be the center of the element.
		// If `absolute` is `true`, the `angle` is considered is abslute, i.e. it is not
		// the difference from the previous angle.
		rotate: function (angle, absolute, origin, opt) {

			if (origin) {

				var center = this.getBBox().center();
				var size = this.get('size');
				var position = this.get('position');
				center.rotate(origin, this.get('angle') - angle);
				var dx = center.x - size.width / 2 - position.x;
				var dy = center.y - size.height / 2 - position.y;
				this.startBatch('rotate', { angle: angle, absolute: absolute, origin: origin });
				this.position(position.x + dx, position.y + dy, opt);
				this.rotate(angle, absolute, null, opt);
				this.stopBatch('rotate');

			} else {

				this.set('angle', absolute ? angle : (this.get('angle') + angle) % 360, opt);
			}

			return this;
		},

		getBBox: function (opt) {

			opt = opt || {};

			if (opt.deep && this.graph) {

				// Get all the embedded elements using breadth first algorithm,
				// that doesn't use recursion.
				var elements = this.getEmbeddedCells({ deep: true, breadthFirst: true });
				// Add the model itself.
				elements.push(this);

				return this.graph.getCellsBBox(elements);
			}

			var position = this.get('position');
			var size = this.get('size');

			return g.rect(position.x, position.y, size.width, size.height);
		}
	});

	// joint.dia.Element base view and controller.
	// -------------------------------------------


	joint.dia.ElementView = joint.dia.CellView.extend({

		/**
		 * @abstract
		 */
		_removePorts: function () {
			// implemented in ports.js
		},

		/**
		 *
		 * @abstract
		 */
		_renderPorts: function () {
			// implemented in ports.js
		},

		className: function () {

			var classNames = joint.dia.CellView.prototype.className.apply(this).split(' ');

			classNames.push('element');

			return classNames.join(' ');
		},

		initialize: function () {

			joint.dia.CellView.prototype.initialize.apply(this, arguments);

			var model = this.model;

			this.listenTo(model, 'change:position', this.translate);
			this.listenTo(model, 'change:size', this.resize);
			this.listenTo(model, 'change:angle', this.rotate);
			this.listenTo(model, 'change:markup', this.render);

			this._initializePorts();
		},

		/**
		 * @abstract
		 */
		_initializePorts: function () {

		},

		update: function (cell, renderingOnlyAttrs) {

			this._removePorts();

			var model = this.model;
			var modelAttrs = model.attr();
			this.updateDOMSubtreeAttributes(this.el, modelAttrs, {
				rootBBox: g.Rect(model.size()),
				scalableNode: this.scalableNode,
				rotatableNode: this.rotatableNode,
				// Use rendering only attributes if they differs from the model attributes
				roAttributes: (renderingOnlyAttrs === modelAttrs) ? null : renderingOnlyAttrs
			});

			this._renderPorts();
		},

		// `prototype.markup` is rendered by default. Set the `markup` attribute on the model if the
		// default markup is not desirable.
		renderMarkup: function () {

			var markup = this.model.get('markup') || this.model.markup;

			if (markup) {

				var svg = joint.util.template(markup)();
				var nodes = V(svg);

				this.vel.append(nodes);

			} else {

				throw new Error('properties.markup is missing while the default render() implementation is used.');
			}
		},

		render: function () {

			this.$el.empty();

			this.renderMarkup();
			this.rotatableNode = this.vel.findOne('.rotatable');
			var scalable = this.scalableNode = this.vel.findOne('.scalable');
			if (scalable) {
				// Double update is necessary for elements with the scalable group only
				// Note the resize() triggers the other `update`.
				this.update();
			}
			this.resize();
			this.rotate();
			this.translate();

			return this;
		},

		resize: function (cell, changed, opt) {

			var model = this.model;
			var size = model.get('size') || { width: 1, height: 1 };
			var angle = model.get('angle') || 0;

			var scalable = this.scalableNode;
			if (!scalable) {

				if (angle !== 0) {
					// update the origin of the rotation
					this.rotate();
				}
				// update the ref attributes
				this.update();

				// If there is no scalable elements, than there is nothing to scale.
				return;
			}

			// Getting scalable group's bbox.
			// Due to a bug in webkit's native SVG .getBBox implementation, the bbox of groups with path children includes the paths' control points.
			// To work around the issue, we need to check whether there are any path elements inside the scalable group.
			var recursive = false;
			if (scalable.node.getElementsByTagName('path').length > 0) {
				// If scalable has at least one descendant that is a path, we need to switch to recursive bbox calculation.
				// If there are no path descendants, group bbox calculation works and so we can use the (faster) native function directly.
				recursive = true;
			}
			var scalableBBox = scalable.getBBox({ recursive: recursive });

			// Make sure `scalableBbox.width` and `scalableBbox.height` are not zero which can happen if the element does not have any content. By making
			// the width/height 1, we prevent HTML errors of the type `scale(Infinity, Infinity)`.
			var sx = (size.width / (scalableBBox.width || 1));
			var sy = (size.height / (scalableBBox.height || 1));
			scalable.attr('transform', 'scale(' + sx + ',' + sy + ')');

			// Now the interesting part. The goal is to be able to store the object geometry via just `x`, `y`, `angle`, `width` and `height`
			// Order of transformations is significant but we want to reconstruct the object always in the order:
			// resize(), rotate(), translate() no matter of how the object was transformed. For that to work,
			// we must adjust the `x` and `y` coordinates of the object whenever we resize it (because the origin of the
			// rotation changes). The new `x` and `y` coordinates are computed by canceling the previous rotation
			// around the center of the resized object (which is a different origin then the origin of the previous rotation)
			// and getting the top-left corner of the resulting object. Then we clean up the rotation back to what it originally was.

			// Cancel the rotation but now around a different origin, which is the center of the scaled object.
			var rotatable = this.rotatableNode;
			var rotation = rotatable && rotatable.attr('transform');
			if (rotation && rotation !== 'null') {

				rotatable.attr('transform', rotation + ' rotate(' + (-angle) + ',' + (size.width / 2) + ',' + (size.height / 2) + ')');
				var rotatableBBox = scalable.getBBox({ target: this.paper.viewport });

				// Store new x, y and perform rotate() again against the new rotation origin.
				model.set('position', { x: rotatableBBox.x, y: rotatableBBox.y }, opt);
				this.rotate();
			}

			// Update must always be called on non-rotated element. Otherwise, relative positioning
			// would work with wrong (rotated) bounding boxes.
			this.update();
		},

		translate: function (model, changes, opt) {

			var position = this.model.get('position') || { x: 0, y: 0 };

			this.vel.attr('transform', 'translate(' + position.x + ',' + position.y + ')');
		},

		rotate: function () {

			var rotatable = this.rotatableNode;
			if (!rotatable) {
				// If there is no rotatable elements, then there is nothing to rotate.
				return;
			}

			var angle = this.model.get('angle') || 0;
			var size = this.model.get('size') || { width: 1, height: 1 };

			var ox = size.width / 2;
			var oy = size.height / 2;

			if (angle !== 0) {
				rotatable.attr('transform', 'rotate(' + angle + ',' + ox + ',' + oy + ')');
			} else {
				rotatable.removeAttr('transform');
			}
		},

		getBBox: function (opt) {

			if (opt && opt.useModelGeometry) {
				var bbox = this.model.getBBox().bbox(this.model.get('angle'));
				return this.paper.localToPaperRect(bbox);
			}

			return joint.dia.CellView.prototype.getBBox.apply(this, arguments);
		},

		// Embedding mode methods
		// ----------------------

		prepareEmbedding: function (opt) {

			opt = opt || {};

			var model = opt.model || this.model;
			var paper = opt.paper || this.paper;
			var graph = paper.model;

			model.startBatch('to-front', opt);

			// Bring the model to the front with all his embeds.
			model.toFront({ deep: true, ui: true });

			// Note that at this point cells in the collection are not sorted by z index (it's running in the batch, see
			// the dia.Graph._sortOnChangeZ), so we can't assume that the last cell in the collection has the highest z.
			var maxZ = graph.get('cells').max('z').get('z');
			var connectedLinks = graph.getConnectedLinks(model, { deep: true });

			// Move to front also all the inbound and outbound links that are connected
			// to any of the element descendant. If we bring to front only embedded elements,
			// links connected to them would stay in the background.
			joint.util.invoke(connectedLinks, 'set', 'z', maxZ + 1, { ui: true });

			model.stopBatch('to-front');

			// Before we start looking for suitable parent we remove the current one.
			var parentId = model.get('parent');
			parentId && graph.getCell(parentId).unembed(model, { ui: true });
		},

		processEmbedding: function (opt) {

			opt = opt || {};

			var model = opt.model || this.model;
			var paper = opt.paper || this.paper;

			var paperOptions = paper.options;
			var candidates = paper.model.findModelsUnderElement(model, { searchBy: paperOptions.findParentBy });

			if (paperOptions.frontParentOnly) {
				// pick the element with the highest `z` index
				candidates = candidates.slice(-1);
			}

			var newCandidateView = null;
			var prevCandidateView = this._candidateEmbedView;

			// iterate over all candidates starting from the last one (has the highest z-index).
			for (var i = candidates.length - 1; i >= 0; i--) {

				var candidate = candidates[i];

				if (prevCandidateView && prevCandidateView.model.id == candidate.id) {

					// candidate remains the same
					newCandidateView = prevCandidateView;
					break;

				} else {

					var view = candidate.findView(paper);
					if (paperOptions.validateEmbedding.call(paper, this, view)) {

						// flip to the new candidate
						newCandidateView = view;
						break;
					}
				}
			}

			if (newCandidateView && newCandidateView != prevCandidateView) {
				// A new candidate view found. Highlight the new one.
				this.clearEmbedding();
				this._candidateEmbedView = newCandidateView.highlight(null, { embedding: true });
			}

			if (!newCandidateView && prevCandidateView) {
				// No candidate view found. Unhighlight the previous candidate.
				this.clearEmbedding();
			}
		},

		clearEmbedding: function () {

			var candidateView = this._candidateEmbedView;
			if (candidateView) {
				// No candidate view found. Unhighlight the previous candidate.
				candidateView.unhighlight(null, { embedding: true });
				this._candidateEmbedView = null;
			}
		},

		finalizeEmbedding: function (opt) {

			opt = opt || {};

			var candidateView = this._candidateEmbedView;
			var model = opt.model || this.model;
			var paper = opt.paper || this.paper;

			if (candidateView) {

				// We finished embedding. Candidate view is chosen to become the parent of the model.
				candidateView.model.embed(model, { ui: true });
				candidateView.unhighlight(null, { embedding: true });

				delete this._candidateEmbedView;
			}

			joint.util.invoke(paper.model.getConnectedLinks(model, { deep: true }), 'reparent', { ui: true });
		},

		// Interaction. The controller part.
		// ---------------------------------

		pointerdown: function (evt, x, y) {

			var paper = this.paper;

			if (
				evt.target.getAttribute('magnet') &&
				this.can('addLinkFromMagnet') &&
				paper.options.validateMagnet.call(paper, this, evt.target)
			) {

				this.model.startBatch('add-link');

				var link = paper.getDefaultLink(this, evt.target);

				link.set({
					source: {
						id: this.model.id,
						selector: this.getSelector(evt.target),
						port: evt.target.getAttribute('port')
					},
					target: { x: x, y: y }
				});

				paper.model.addCell(link);

				var linkView = this._linkView = paper.findViewByModel(link);

				linkView.pointerdown(evt, x, y);
				linkView.startArrowheadMove('target', { whenNotAllowed: 'remove' });

			} else {

				this._dx = x;
				this._dy = y;

				this.restrictedArea = paper.getRestrictedArea(this);

				joint.dia.CellView.prototype.pointerdown.apply(this, arguments);
				this.notify('element:pointerdown', evt, x, y);
			}
		},

		pointermove: function (evt, x, y) {

			if (this._linkView) {

				// let the linkview deal with this event
				this._linkView.pointermove(evt, x, y);

			} else {

				var grid = this.paper.options.gridSize;

				if (this.can('elementMove')) {

					var position = this.model.get('position');

					// Make sure the new element's position always snaps to the current grid after
					// translate as the previous one could be calculated with a different grid size.
					var tx = g.snapToGrid(position.x, grid) - position.x + g.snapToGrid(x - this._dx, grid);
					var ty = g.snapToGrid(position.y, grid) - position.y + g.snapToGrid(y - this._dy, grid);

					this.model.translate(tx, ty, { restrictedArea: this.restrictedArea, ui: true });

					if (this.paper.options.embeddingMode) {

						if (!this._inProcessOfEmbedding) {
							// Prepare the element for embedding only if the pointer moves.
							// We don't want to do unnecessary action with the element
							// if an user only clicks/dblclicks on it.
							this.prepareEmbedding();
							this._inProcessOfEmbedding = true;
						}

						this.processEmbedding();
					}
				}

				this._dx = g.snapToGrid(x, grid);
				this._dy = g.snapToGrid(y, grid);

				joint.dia.CellView.prototype.pointermove.apply(this, arguments);
				this.notify('element:pointermove', evt, x, y);
			}
		},

		pointerup: function (evt, x, y) {

			if (this._linkView) {

				// Let the linkview deal with this event.
				this._linkView.pointerup(evt, x, y);
				this._linkView = null;
				this.model.stopBatch('add-link');

			} else {

				if (this._inProcessOfEmbedding) {
					this.finalizeEmbedding();
					this._inProcessOfEmbedding = false;
				}

				this.notify('element:pointerup', evt, x, y);
				joint.dia.CellView.prototype.pointerup.apply(this, arguments);
			}
		},

		mouseenter: function (evt) {

			joint.dia.CellView.prototype.mouseenter.apply(this, arguments);
			this.notify('element:mouseenter', evt);
		},

		mouseleave: function (evt) {

			joint.dia.CellView.prototype.mouseleave.apply(this, arguments);
			this.notify('element:mouseleave', evt);
		}
	});


	// joint.dia.Link base model.
	// --------------------------

	joint.dia.Link = joint.dia.Cell.extend({

		// The default markup for links.
		markup: [
			'<path class="connection" stroke="black" d="M 0 0 0 0"/>',
			'<path class="marker-source" fill="black" stroke="black" d="M 0 0 0 0"/>',
			'<path class="marker-target" fill="black" stroke="black" d="M 0 0 0 0"/>',
			'<path class="connection-wrap" d="M 0 0 0 0"/>',
			'<g class="labels"/>',
			'<g class="marker-vertices"/>',
			'<g class="marker-arrowheads"/>',
			'<g class="link-tools"/>'
		].join(''),

		labelMarkup: [
			'<g class="label">',
			'<rect />',
			'<text />',
			'</g>'
		].join(''),

		toolMarkup: [
			'<g class="link-tool">',
			'<g class="tool-remove" event="remove">',
			'<circle r="11" />',
			'<path transform="scale(.8) translate(-16, -16)" d="M24.778,21.419 19.276,15.917 24.777,10.415 21.949,7.585 16.447,13.087 10.945,7.585 8.117,10.415 13.618,15.917 8.116,21.419 10.946,24.248 16.447,18.746 21.948,24.248z" />',
			'<title>Remove link.</title>',
			'</g>',
			'<g class="tool-options" event="link:options">',
			'<circle r="11" transform="translate(25)"/>',
			'<path fill="white" transform="scale(.55) translate(29, -16)" d="M31.229,17.736c0.064-0.571,0.104-1.148,0.104-1.736s-0.04-1.166-0.104-1.737l-4.377-1.557c-0.218-0.716-0.504-1.401-0.851-2.05l1.993-4.192c-0.725-0.91-1.549-1.734-2.458-2.459l-4.193,1.994c-0.647-0.347-1.334-0.632-2.049-0.849l-1.558-4.378C17.165,0.708,16.588,0.667,16,0.667s-1.166,0.041-1.737,0.105L12.707,5.15c-0.716,0.217-1.401,0.502-2.05,0.849L6.464,4.005C5.554,4.73,4.73,5.554,4.005,6.464l1.994,4.192c-0.347,0.648-0.632,1.334-0.849,2.05l-4.378,1.557C0.708,14.834,0.667,15.412,0.667,16s0.041,1.165,0.105,1.736l4.378,1.558c0.217,0.715,0.502,1.401,0.849,2.049l-1.994,4.193c0.725,0.909,1.549,1.733,2.459,2.458l4.192-1.993c0.648,0.347,1.334,0.633,2.05,0.851l1.557,4.377c0.571,0.064,1.148,0.104,1.737,0.104c0.588,0,1.165-0.04,1.736-0.104l1.558-4.377c0.715-0.218,1.399-0.504,2.049-0.851l4.193,1.993c0.909-0.725,1.733-1.549,2.458-2.458l-1.993-4.193c0.347-0.647,0.633-1.334,0.851-2.049L31.229,17.736zM16,20.871c-2.69,0-4.872-2.182-4.872-4.871c0-2.69,2.182-4.872,4.872-4.872c2.689,0,4.871,2.182,4.871,4.872C20.871,18.689,18.689,20.871,16,20.871z"/>',
			'<title>Link options.</title>',
			'</g>',
			'</g>'
		].join(''),

		// The default markup for showing/removing vertices. These elements are the children of the .marker-vertices element (see `this.markup`).
		// Only .marker-vertex and .marker-vertex-remove element have special meaning. The former is used for
		// dragging vertices (changin their position). The latter is used for removing vertices.
		vertexMarkup: [
			'<g class="marker-vertex-group" transform="translate(<%= x %>, <%= y %>)">',
			'<circle class="marker-vertex" idx="<%= idx %>" r="10" />',
			'<path class="marker-vertex-remove-area" idx="<%= idx %>" d="M16,5.333c-7.732,0-14,4.701-14,10.5c0,1.982,0.741,3.833,2.016,5.414L2,25.667l5.613-1.441c2.339,1.317,5.237,2.107,8.387,2.107c7.732,0,14-4.701,14-10.5C30,10.034,23.732,5.333,16,5.333z" transform="translate(5, -33)"/>',
			'<path class="marker-vertex-remove" idx="<%= idx %>" transform="scale(.8) translate(9.5, -37)" d="M24.778,21.419 19.276,15.917 24.777,10.415 21.949,7.585 16.447,13.087 10.945,7.585 8.117,10.415 13.618,15.917 8.116,21.419 10.946,24.248 16.447,18.746 21.948,24.248z">',
			'<title>Remove vertex.</title>',
			'</path>',
			'</g>'
		].join(''),

		arrowheadMarkup: [
			'<g class="marker-arrowhead-group marker-arrowhead-group-<%= end %>">',
			'<path class="marker-arrowhead" end="<%= end %>" d="M 26 0 L 0 13 L 26 26 z" />',
			'</g>'
		].join(''),

		defaults: {

			type: 'link',
			source: {},
			target: {}
		},

		isLink: function () {

			return true;
		},

		disconnect: function () {

			return this.set({ source: g.point(0, 0), target: g.point(0, 0) });
		},

		// A convenient way to set labels. Currently set values will be mixined with `value` if used as a setter.
		label: function (idx, value, opt) {

			idx = idx || 0;

			// Is it a getter?
			if (arguments.length <= 1) {
				return this.prop(['labels', idx]);
			}

			return this.prop(['labels', idx], value, opt);
		},

		translate: function (tx, ty, opt) {

			// enrich the option object
			opt = opt || {};
			opt.translateBy = opt.translateBy || this.id;
			opt.tx = tx;
			opt.ty = ty;

			return this.applyToPoints(function (p) {
				return { x: (p.x || 0) + tx, y: (p.y || 0) + ty };
			}, opt);
		},

		scale: function (sx, sy, origin, opt) {

			return this.applyToPoints(function (p) {
				return g.point(p).scale(sx, sy, origin).toJSON();
			}, opt);
		},

		applyToPoints: function (fn, opt) {

			if (!joint.util.isFunction(fn)) {
				throw new TypeError('dia.Link: applyToPoints expects its first parameter to be a function.');
			}

			var attrs = {};

			var source = this.get('source');
			if (!source.id) {
				attrs.source = fn(source);
			}

			var target = this.get('target');
			if (!target.id) {
				attrs.target = fn(target);
			}

			var vertices = this.get('vertices');
			if (vertices && vertices.length > 0) {
				attrs.vertices = vertices.map(fn);
			}

			return this.set(attrs, opt);
		},

		reparent: function (opt) {

			var newParent;

			if (this.graph) {

				var source = this.graph.getCell(this.get('source').id);
				var target = this.graph.getCell(this.get('target').id);
				var prevParent = this.graph.getCell(this.get('parent'));

				if (source && target) {
					newParent = this.graph.getCommonAncestor(source, target);
				}

				if (prevParent && (!newParent || newParent.id !== prevParent.id)) {
					// Unembed the link if source and target has no common ancestor
					// or common ancestor changed
					prevParent.unembed(this, opt);
				}

				if (newParent) {
					newParent.embed(this, opt);
				}
			}

			return newParent;
		},

		hasLoop: function (opt) {

			opt = opt || {};

			var sourceId = this.get('source').id;
			var targetId = this.get('target').id;

			if (!sourceId || !targetId) {
				// Link "pinned" to the paper does not have a loop.
				return false;
			}

			var loop = sourceId === targetId;

			// Note that there in the deep mode a link can have a loop,
			// even if it connects only a parent and its embed.
			// A loop "target equals source" is valid in both shallow and deep mode.
			if (!loop && opt.deep && this.graph) {

				var sourceElement = this.graph.getCell(sourceId);
				var targetElement = this.graph.getCell(targetId);

				loop = sourceElement.isEmbeddedIn(targetElement) || targetElement.isEmbeddedIn(sourceElement);
			}

			return loop;
		},

		getSourceElement: function () {

			var source = this.get('source');

			return (source && source.id && this.graph && this.graph.getCell(source.id)) || null;
		},

		getTargetElement: function () {

			var target = this.get('target');

			return (target && target.id && this.graph && this.graph.getCell(target.id)) || null;
		},

		// Returns the common ancestor for the source element,
		// target element and the link itself.
		getRelationshipAncestor: function () {

			var connectionAncestor;

			if (this.graph) {

				var cells = [
					this,
					this.getSourceElement(), // null if source is a point
					this.getTargetElement() // null if target is a point
				].filter(function (item) {
					return !!item;
				});

				connectionAncestor = this.graph.getCommonAncestor.apply(this.graph, cells);
			}

			return connectionAncestor || null;
		},

		// Is source, target and the link itself embedded in a given cell?
		isRelationshipEmbeddedIn: function (cell) {

			var cellId = (joint.util.isString(cell) || joint.util.isNumber(cell)) ? cell : cell.id;
			var ancestor = this.getRelationshipAncestor();

			return !!ancestor && (ancestor.id === cellId || ancestor.isEmbeddedIn(cellId));
		}
	},
		{
			endsEqual: function (a, b) {

				var portsEqual = a.port === b.port || !a.port && !b.port;
				return a.id === b.id && portsEqual;
			}
		});


	// joint.dia.Link base view and controller.
	// ----------------------------------------

	joint.dia.LinkView = joint.dia.CellView.extend({

		className: function () {

			var classNames = joint.dia.CellView.prototype.className.apply(this).split(' ');

			classNames.push('link');

			return classNames.join(' ');
		},

		options: {

			shortLinkLength: 100,
			doubleLinkTools: false,
			longLinkLength: 160,
			linkToolsOffset: 40,
			doubleLinkToolsOffset: 60,
			sampleInterval: 50
		},

		_z: null,

		initialize: function (options) {

			joint.dia.CellView.prototype.initialize.apply(this, arguments);

			// create methods in prototype, so they can be accessed from any instance and
			// don't need to be create over and over
			if (typeof this.constructor.prototype.watchSource !== 'function') {
				this.constructor.prototype.watchSource = this.createWatcher('source');
				this.constructor.prototype.watchTarget = this.createWatcher('target');
			}

			// `_.labelCache` is a mapping of indexes of labels in the `this.get('labels')` array to
			// `<g class="label">` nodes wrapped by Vectorizer. This allows for quick access to the
			// nodes in `updateLabelPosition()` in order to update the label positions.
			this._labelCache = {};

			// keeps markers bboxes and positions again for quicker access
			this._markerCache = {};

			// bind events
			this.startListening();
		},

		startListening: function () {

			var model = this.model;

			this.listenTo(model, 'change:markup', this.render);
			this.listenTo(model, 'change:smooth change:manhattan change:router change:connector', this.update);
			this.listenTo(model, 'change:toolMarkup', this.onToolsChange);
			this.listenTo(model, 'change:labels change:labelMarkup', this.onLabelsChange);
			this.listenTo(model, 'change:vertices change:vertexMarkup', this.onVerticesChange);
			this.listenTo(model, 'change:source', this.onSourceChange);
			this.listenTo(model, 'change:target', this.onTargetChange);
		},

		onSourceChange: function (cell, source, opt) {

			// Start watching the new source model.
			this.watchSource(cell, source);
			// This handler is called when the source attribute is changed.
			// This can happen either when someone reconnects the link (or moves arrowhead),
			// or when an embedded link is translated by its ancestor.
			// 1. Always do update.
			// 2. Do update only if the opposite end ('target') is also a point.
			if (!opt.translateBy || !this.model.get('target').id) {
				opt.updateConnectionOnly = true;
				this.update(this.model, null, opt);
			}
		},

		onTargetChange: function (cell, target, opt) {

			// Start watching the new target model.
			this.watchTarget(cell, target);
			// See `onSourceChange` method.
			if (!opt.translateBy) {
				opt.updateConnectionOnly = true;
				this.update(this.model, null, opt);
			}
		},

		onVerticesChange: function (cell, changed, opt) {

			this.renderVertexMarkers();

			// If the vertices have been changed by a translation we do update only if the link was
			// the only link that was translated. If the link was translated via another element which the link
			// is embedded in, this element will be translated as well and that triggers an update.
			// Note that all embeds in a model are sorted - first comes links, then elements.
			if (!opt.translateBy || opt.translateBy === this.model.id) {
				// Vertices were changed (not as a reaction on translate)
				// or link.translate() was called or
				opt.updateConnectionOnly = true;
				this.update(cell, null, opt);
			}
		},

		onToolsChange: function () {

			this.renderTools().updateToolsPosition();
		},

		onLabelsChange: function (link, labels, opt) {

			var requireRender = true;

			var previousLabels = this.model.previous('labels');

			if (previousLabels) {
				// Here is an optimalization for cases when we know, that change does
				// not require rerendering of all labels.
				if (('propertyPathArray' in opt) && ('propertyValue' in opt)) {
					// The label is setting by `prop()` method
					var pathArray = opt.propertyPathArray || [];
					var pathLength = pathArray.length;
					if (pathLength > 1) {
						// We are changing a single label here e.g. 'labels/0/position'
						var labelExists = !!previousLabels[pathArray[1]];
						if (labelExists) {
							if (pathLength === 2) {
								// We are changing the entire label. Need to check if the
								// markup is also being changed.
								requireRender = ('markup' in Object(opt.propertyValue));
							} else if (pathArray[2] !== 'markup') {
								// We are changing a label property but not the markup
								requireRender = false;
							}
						}
					}
				}
			}

			if (requireRender) {
				this.renderLabels();
			} else {
				this.updateLabels();
			}

			this.updateLabelPositions();
		},

		// Rendering
		//----------

		render: function () {

			this.$el.empty();

			// A special markup can be given in the `properties.markup` property. This might be handy
			// if e.g. arrowhead markers should be `<image>` elements or any other element than `<path>`s.
			// `.connection`, `.connection-wrap`, `.marker-source` and `.marker-target` selectors
			// of elements with special meaning though. Therefore, those classes should be preserved in any
			// special markup passed in `properties.markup`.
			var model = this.model;
			var markup = model.get('markup') || model.markup;
			var children = V(markup);

			// custom markup may contain only one children
			if (!Array.isArray(children)) children = [children];

			// Cache all children elements for quicker access.
			this._V = {}; // vectorized markup;
			children.forEach(function (child) {

				var className = child.attr('class');

				if (className) {
					// Strip the joint class name prefix, if there is one.
					className = joint.util.removeClassNamePrefix(className);
					this._V[$.camelCase(className)] = child;
				}

			}, this);

			// Only the connection path is mandatory
			if (!this._V.connection) throw new Error('link: no connection path in the markup');

			// partial rendering
			this.renderTools();
			this.renderVertexMarkers();
			this.renderArrowheadMarkers();

			this.vel.append(children);

			// rendering labels has to be run after the link is appended to DOM tree. (otherwise <Text> bbox
			// returns zero values)
			this.renderLabels();

			// start watching the ends of the link for changes
			this.watchSource(model, model.get('source'))
				.watchTarget(model, model.get('target'))
				.update();

			return this;
		},

		renderLabels: function () {

			var vLabels = this._V.labels;
			if (!vLabels) {
				return this;
			}

			vLabels.empty();

			var model = this.model;
			var labels = model.get('labels') || [];
			var labelCache = this._labelCache = {};
			var labelsCount = labels.length;
			if (labelsCount === 0) {
				return this;
			}

			var labelTemplate = joint.util.template(model.get('labelMarkup') || model.labelMarkup);
			// This is a prepared instance of a vectorized SVGDOM node for the label element resulting from
			// compilation of the labelTemplate. The purpose is that all labels will just `clone()` this
			// node to create a duplicate.
			var labelNodeInstance = V(labelTemplate());

			for (var i = 0; i < labelsCount; i++) {

				var label = labels[i];
				var labelMarkup = label.markup;
				// Cache label nodes so that the `updateLabels()` can just update the label node positions.
				var vLabelNode = labelCache[i] = (labelMarkup)
					? V('g').append(V(labelMarkup))
					: labelNodeInstance.clone();

				vLabelNode
					.addClass('label')
					.attr('label-idx', i)
					.appendTo(vLabels);
			}

			this.updateLabels();

			return this;
		},

		updateLabels: function () {

			if (!this._V.labels) {
				return this;
			}

			var labels = this.model.get('labels') || [];
			var canLabelMove = this.can('labelMove');

			for (var i = 0, n = labels.length; i < n; i++) {

				var vLabel = this._labelCache[i];
				var label = labels[i];

				vLabel.attr('cursor', (canLabelMove ? 'move' : 'default'));

				var labelAttrs = label.attrs;
				if (!label.markup) {
					// Default attributes to maintain backwards compatibility
					labelAttrs = joint.util.merge({
						text: {
							textAnchor: 'middle',
							fontSize: 14,
							pointerEvents: 'none',
							yAlignment: 'middle'
						},
						rect: {
							ref: 'text',
							fill: 'white',
							rx: 3,
							ry: 3,
							refWidth: 1,
							refHeight: 1,
							refX: 0,
							refY: 0
						}
					}, labelAttrs);
				}

				this.updateDOMSubtreeAttributes(vLabel.node, labelAttrs, {
					rootBBox: g.Rect(label.size)
				});
			}

			return this;
		},

		renderTools: function () {

			if (!this._V.linkTools) return this;

			// Tools are a group of clickable elements that manipulate the whole link.
			// A good example of this is the remove tool that removes the whole link.
			// Tools appear after hovering the link close to the `source` element/point of the link
			// but are offset a bit so that they don't cover the `marker-arrowhead`.

			var $tools = $(this._V.linkTools.node).empty();
			var toolTemplate = joint.util.template(this.model.get('toolMarkup') || this.model.toolMarkup);
			var tool = V(toolTemplate());

			$tools.append(tool.node);

			// Cache the tool node so that the `updateToolsPosition()` can update the tool position quickly.
			this._toolCache = tool;

			// If `doubleLinkTools` is enabled, we render copy of the tools on the other side of the
			// link as well but only if the link is longer than `longLinkLength`.
			if (this.options.doubleLinkTools) {

				var tool2;
				if (this.model.get('doubleToolMarkup') || this.model.doubleToolMarkup) {
					toolTemplate = joint.util.template(this.model.get('doubleToolMarkup') || this.model.doubleToolMarkup);
					tool2 = V(toolTemplate());
				} else {
					tool2 = tool.clone();
				}

				$tools.append(tool2.node);
				this._tool2Cache = tool2;
			}

			return this;
		},

		renderVertexMarkers: function () {

			if (!this._V.markerVertices) return this;

			var $markerVertices = $(this._V.markerVertices.node).empty();

			// A special markup can be given in the `properties.vertexMarkup` property. This might be handy
			// if default styling (elements) are not desired. This makes it possible to use any
			// SVG elements for .marker-vertex and .marker-vertex-remove tools.
			var markupTemplate = joint.util.template(this.model.get('vertexMarkup') || this.model.vertexMarkup);

			joint.util.toArray(this.model.get('vertices')).forEach(function (vertex, idx) {

				$markerVertices.append(V(markupTemplate(joint.util.assign({ idx: idx }, vertex))).node);
			});

			return this;
		},

		renderArrowheadMarkers: function () {

			// Custom markups might not have arrowhead markers. Therefore, jump of this function immediately if that's the case.
			if (!this._V.markerArrowheads) return this;

			var $markerArrowheads = $(this._V.markerArrowheads.node);

			$markerArrowheads.empty();

			// A special markup can be given in the `properties.vertexMarkup` property. This might be handy
			// if default styling (elements) are not desired. This makes it possible to use any
			// SVG elements for .marker-vertex and .marker-vertex-remove tools.
			var markupTemplate = joint.util.template(this.model.get('arrowheadMarkup') || this.model.arrowheadMarkup);

			this._V.sourceArrowhead = V(markupTemplate({ end: 'source' }));
			this._V.targetArrowhead = V(markupTemplate({ end: 'target' }));

			$markerArrowheads.append(this._V.sourceArrowhead.node, this._V.targetArrowhead.node);

			return this;
		},

		// Updating
		//---------

		// Default is to process the `attrs` object and set attributes on subelements based on the selectors.
		update: function (model, attributes, opt) {

			opt = opt || {};

			if (!opt.updateConnectionOnly) {
				// update SVG attributes defined by 'attrs/'.
				this.updateDOMSubtreeAttributes(this.el, this.model.attr());
			}

			// update the link path, label position etc.
			this.updateConnection(opt);
			this.updateLabelPositions();
			this.updateToolsPosition();
			this.updateArrowheadMarkers();

			// Local perpendicular flag (as opposed to one defined on paper).
			// Could be enabled inside a connector/router. It's valid only
			// during the update execution.
			this.options.perpendicular = null;
			// Mark that postponed update has been already executed.
			this.updatePostponed = false;

			return this;
		},

		updateConnection: function (opt) {

			opt = opt || {};

			var model = this.model;
			var route;

			if (opt.translateBy && model.isRelationshipEmbeddedIn(opt.translateBy)) {
				// The link is being translated by an ancestor that will
				// shift source point, target point and all vertices
				// by an equal distance.
				var tx = opt.tx || 0;
				var ty = opt.ty || 0;

				route = this.route = joint.util.toArray(this.route).map(function (point) {
					// translate point by point by delta translation
					return g.point(point).offset(tx, ty);
				});

				// translate source and target connection and marker points.
				this._translateConnectionPoints(tx, ty);

			} else {
				// Necessary path finding
				route = this.route = this.findRoute(model.get('vertices') || [], opt);
				// finds all the connection points taking new vertices into account
				this._findConnectionPoints(route);
			}

			var pathData = this.getPathData(route);

			// The markup needs to contain a `.connection`
			this._V.connection.attr('d', pathData);
			this._V.connectionWrap && this._V.connectionWrap.attr('d', pathData);

			this._translateAndAutoOrientArrows(this._V.markerSource, this._V.markerTarget);
		},

		_findConnectionPoints: function (vertices) {

			// cache source and target points
			var sourcePoint, targetPoint, sourceMarkerPoint, targetMarkerPoint;
			var verticesArr = joint.util.toArray(vertices);

			var firstVertex = verticesArr[0];

			sourcePoint = this.getConnectionPoint(
				'source', this.model.get('source'), firstVertex || this.model.get('target')
			).round();

			var lastVertex = verticesArr[verticesArr.length - 1];

			targetPoint = this.getConnectionPoint(
				'target', this.model.get('target'), lastVertex || sourcePoint
			).round();

			// Move the source point by the width of the marker taking into account
			// its scale around x-axis. Note that scale is the only transform that
			// makes sense to be set in `.marker-source` attributes object
			// as all other transforms (translate/rotate) will be replaced
			// by the `translateAndAutoOrient()` function.
			var cache = this._markerCache;

			if (this._V.markerSource) {

				cache.sourceBBox = cache.sourceBBox || this._V.markerSource.getBBox();

				sourceMarkerPoint = g.point(sourcePoint).move(
					firstVertex || targetPoint,
					cache.sourceBBox.width * this._V.markerSource.scale().sx * -1
				).round();
			}

			if (this._V.markerTarget) {

				cache.targetBBox = cache.targetBBox || this._V.markerTarget.getBBox();

				targetMarkerPoint = g.point(targetPoint).move(
					lastVertex || sourcePoint,
					cache.targetBBox.width * this._V.markerTarget.scale().sx * -1
				).round();
			}

			// if there was no markup for the marker, use the connection point.
			cache.sourcePoint = sourceMarkerPoint || sourcePoint.clone();
			cache.targetPoint = targetMarkerPoint || targetPoint.clone();

			// make connection points public
			this.sourcePoint = sourcePoint;
			this.targetPoint = targetPoint;
		},

		_translateConnectionPoints: function (tx, ty) {

			var cache = this._markerCache;

			cache.sourcePoint.offset(tx, ty);
			cache.targetPoint.offset(tx, ty);
			this.sourcePoint.offset(tx, ty);
			this.targetPoint.offset(tx, ty);
		},

		updateLabelPositions: function () {

			if (!this._V.labels) return this;

			// This method assumes all the label nodes are stored in the `this._labelCache` hash table
			// by their indexes in the `this.get('labels')` array. This is done in the `renderLabels()` method.

			var labels = this.model.get('labels') || [];
			if (!labels.length) return this;

			var samples;
			var connectionElement = this._V.connection.node;
			var connectionLength = connectionElement.getTotalLength();

			// Firefox returns connectionLength=NaN in odd cases (for bezier curves).
			// In that case we won't update labels at all.
			if (Number.isNaN(connectionLength)) {
				return this;
			}

			for (var idx = 0, n = labels.length; idx < n; idx++) {

				var label = labels[idx];
				var position = label.position;
				var isPositionObject = joint.util.isObject(position);
				var labelCoordinates;

				var distance = isPositionObject ? position.distance : position;
				var offset = isPositionObject ? position.offset : { x: 0, y: 0 };

				if (Number.isFinite(distance)) {
					distance = (distance > connectionLength) ? connectionLength : distance; // sanity check
					distance = (distance < 0) ? connectionLength + distance : distance;
					distance = (distance > 1) ? distance : connectionLength * distance;
				} else {
					distance = connectionLength / 2;
				}

				labelCoordinates = connectionElement.getPointAtLength(distance);

				if (joint.util.isObject(offset)) {

					// Just offset the label by the x,y provided in the offset object.
					labelCoordinates = g.point(labelCoordinates).offset(offset);

				} else if (Number.isFinite(offset)) {

					if (!samples) {
						samples = this._samples || this._V.connection.sample(this.options.sampleInterval);
					}

					// Offset the label by the amount provided in `offset` to an either
					// side of the link.

					// 1. Find the closest sample & its left and right neighbours.
					var minSqDistance = Infinity;
					var closestSampleIndex, sample, sqDistance;
					for (var i = 0, m = samples.length; i < m; i++) {
						sample = samples[i];
						sqDistance = g.line(sample, labelCoordinates).squaredLength();
						if (sqDistance < minSqDistance) {
							minSqDistance = sqDistance;
							closestSampleIndex = i;
						}
					}
					var prevSample = samples[closestSampleIndex - 1];
					var nextSample = samples[closestSampleIndex + 1];

					// 2. Offset the label on the perpendicular line between
					// the current label coordinate ("at `distance`") and
					// the next sample.
					var angle = 0;
					if (nextSample) {
						angle = g.point(labelCoordinates).theta(nextSample);
					} else if (prevSample) {
						angle = g.point(prevSample).theta(labelCoordinates);
					}
					labelCoordinates = g.point(labelCoordinates).offset(offset).rotate(labelCoordinates, angle - 90);
				}

				this._labelCache[idx].attr('transform', 'translate(' + labelCoordinates.x + ', ' + labelCoordinates.y + ')');
			}

			return this;
		},


		updateToolsPosition: function () {

			if (!this._V.linkTools) return this;

			// Move the tools a bit to the target position but don't cover the `sourceArrowhead` marker.
			// Note that the offset is hardcoded here. The offset should be always
			// more than the `this.$('.marker-arrowhead[end="source"]')[0].bbox().width` but looking
			// this up all the time would be slow.

			var scale = '';
			var offset = this.options.linkToolsOffset;
			var connectionLength = this.getConnectionLength();

			// Firefox returns connectionLength=NaN in odd cases (for bezier curves).
			// In that case we won't update tools position at all.
			if (!Number.isNaN(connectionLength)) {

				// If the link is too short, make the tools half the size and the offset twice as low.
				if (connectionLength < this.options.shortLinkLength) {
					scale = 'scale(.5)';
					offset /= 2;
				}

				var toolPosition = this.getPointAtLength(offset);

				this._toolCache.attr('transform', 'translate(' + toolPosition.x + ', ' + toolPosition.y + ') ' + scale);

				if (this.options.doubleLinkTools && connectionLength >= this.options.longLinkLength) {

					var doubleLinkToolsOffset = this.options.doubleLinkToolsOffset || offset;

					toolPosition = this.getPointAtLength(connectionLength - doubleLinkToolsOffset);
					this._tool2Cache.attr('transform', 'translate(' + toolPosition.x + ', ' + toolPosition.y + ') ' + scale);
					this._tool2Cache.attr('visibility', 'visible');

				} else if (this.options.doubleLinkTools) {

					this._tool2Cache.attr('visibility', 'hidden');
				}
			}

			return this;
		},


		updateArrowheadMarkers: function () {

			if (!this._V.markerArrowheads) return this;

			// getting bbox of an element with `display="none"` in IE9 ends up with access violation
			if ($.css(this._V.markerArrowheads.node, 'display') === 'none') return this;

			var sx = this.getConnectionLength() < this.options.shortLinkLength ? .5 : 1;
			this._V.sourceArrowhead.scale(sx);
			this._V.targetArrowhead.scale(sx);

			this._translateAndAutoOrientArrows(this._V.sourceArrowhead, this._V.targetArrowhead);

			return this;
		},

		// Returns a function observing changes on an end of the link. If a change happens and new end is a new model,
		// it stops listening on the previous one and starts listening to the new one.
		createWatcher: function (endType) {

			// create handler for specific end type (source|target).
			var onModelChange = function (endModel, opt) {
				this.onEndModelChange(endType, endModel, opt);
			};

			function watchEndModel(link, end) {

				end = end || {};

				var endModel = null;
				var previousEnd = link.previous(endType) || {};

				if (previousEnd.id) {
					this.stopListening(this.paper.getModelById(previousEnd.id), 'change', onModelChange);
				}

				if (end.id) {
					// If the observed model changes, it caches a new bbox and do the link update.
					endModel = this.paper.getModelById(end.id);
					this.listenTo(endModel, 'change', onModelChange);
				}

				onModelChange.call(this, endModel, { cacheOnly: true });

				return this;
			}

			return watchEndModel;
		},

		onEndModelChange: function (endType, endModel, opt) {

			var doUpdate = !opt.cacheOnly;
			var model = this.model;
			var end = model.get(endType) || {};

			if (endModel) {

				var selector = this.constructor.makeSelector(end);
				var oppositeEndType = endType == 'source' ? 'target' : 'source';
				var oppositeEnd = model.get(oppositeEndType) || {};
				var oppositeSelector = oppositeEnd.id && this.constructor.makeSelector(oppositeEnd);

				// Caching end models bounding boxes.
				// If `opt.handleBy` equals the client-side ID of this link view and it is a loop link, then we already cached
				// the bounding boxes in the previous turn (e.g. for loop link, the change:source event is followed
				// by change:target and so on change:source, we already chached the bounding boxes of - the same - element).
				if (opt.handleBy === this.cid && selector == oppositeSelector) {

					// Source and target elements are identical. We're dealing with a loop link. We are handling `change` event for the
					// second time now. There is no need to calculate bbox and find magnet element again.
					// It was calculated already for opposite link end.
					this[endType + 'BBox'] = this[oppositeEndType + 'BBox'];
					this[endType + 'View'] = this[oppositeEndType + 'View'];
					this[endType + 'Magnet'] = this[oppositeEndType + 'Magnet'];

				} else if (opt.translateBy) {
					// `opt.translateBy` optimizes the way we calculate bounding box of the source/target element.
					// If `opt.translateBy` is an ID of the element that was originally translated. This allows us
					// to just offset the cached bounding box by the translation instead of calculating the bounding
					// box from scratch on every translate.

					var bbox = this[endType + 'BBox'];
					bbox.x += opt.tx;
					bbox.y += opt.ty;

				} else {
					// The slowest path, source/target could have been rotated or resized or any attribute
					// that affects the bounding box of the view might have been changed.

					var view = this.paper.findViewByModel(end.id);
					var magnetElement = view.el.querySelector(selector);

					this[endType + 'BBox'] = view.getStrokeBBox(magnetElement);
					this[endType + 'View'] = view;
					this[endType + 'Magnet'] = magnetElement;
				}

				if (opt.handleBy === this.cid && opt.translateBy &&
					model.isEmbeddedIn(endModel) &&
					!joint.util.isEmpty(model.get('vertices'))) {
					// Loop link whose element was translated and that has vertices (that need to be translated with
					// the parent in which my element is embedded).
					// If the link is embedded, has a loop and vertices and the end model
					// has been translated, do not update yet. There are vertices still to be updated (change:vertices
					// event will come in the next turn).
					doUpdate = false;
				}

				if (!this.updatePostponed && oppositeEnd.id) {
					// The update was not postponed (that can happen e.g. on the first change event) and the opposite
					// end is a model (opposite end is the opposite end of the link we're just updating, e.g. if
					// we're reacting on change:source event, the oppositeEnd is the target model).

					var oppositeEndModel = this.paper.getModelById(oppositeEnd.id);

					// Passing `handleBy` flag via event option.
					// Note that if we are listening to the same model for event 'change' twice.
					// The same event will be handled by this method also twice.
					if (end.id === oppositeEnd.id) {
						// We're dealing with a loop link. Tell the handlers in the next turn that they should update
						// the link instead of me. (We know for sure there will be a next turn because
						// loop links react on at least two events: change on the source model followed by a change on
						// the target model).
						opt.handleBy = this.cid;
					}

					if (opt.handleBy === this.cid || (opt.translateBy && oppositeEndModel.isEmbeddedIn(opt.translateBy))) {

						// Here are two options:
						// - Source and target are connected to the same model (not necessarily the same port).
						// - Both end models are translated by the same ancestor. We know that opposite end
						//   model will be translated in the next turn as well.
						// In both situations there will be more changes on the model that trigger an
						// update. So there is no need to update the linkView yet.
						this.updatePostponed = true;
						doUpdate = false;
					}
				}

			} else {

				// the link end is a point ~ rect 1x1
				this[endType + 'BBox'] = g.rect(end.x || 0, end.y || 0, 1, 1);
				this[endType + 'View'] = this[endType + 'Magnet'] = null;
			}

			if (doUpdate) {
				opt.updateConnectionOnly = true;
				this.update(model, null, opt);
			}
		},

		_translateAndAutoOrientArrows: function (sourceArrow, targetArrow) {

			// Make the markers "point" to their sticky points being auto-oriented towards
			// `targetPosition`/`sourcePosition`. And do so only if there is a markup for them.
			var route = joint.util.toArray(this.route);
			if (sourceArrow) {
				sourceArrow.translateAndAutoOrient(
					this.sourcePoint,
					route[0] || this.targetPoint,
					this.paper.viewport
				);
			}

			if (targetArrow) {
				targetArrow.translateAndAutoOrient(
					this.targetPoint,
					route[route.length - 1] || this.sourcePoint,
					this.paper.viewport
				);
			}
		},

		removeVertex: function (idx) {

			var vertices = joint.util.assign([], this.model.get('vertices'));

			if (vertices && vertices.length) {

				vertices.splice(idx, 1);
				this.model.set('vertices', vertices, { ui: true });
			}

			return this;
		},

		// This method ads a new vertex to the `vertices` array of `.connection`. This method
		// uses a heuristic to find the index at which the new `vertex` should be placed at assuming
		// the new vertex is somewhere on the path.
		addVertex: function (vertex) {

			// As it is very hard to find a correct index of the newly created vertex,
			// a little heuristics is taking place here.
			// The heuristics checks if length of the newly created
			// path is lot more than length of the old path. If this is the case,
			// new vertex was probably put into a wrong index.
			// Try to put it into another index and repeat the heuristics again.

			var vertices = (this.model.get('vertices') || []).slice();
			// Store the original vertices for a later revert if needed.
			var originalVertices = vertices.slice();

			// A `<path>` element used to compute the length of the path during heuristics.
			var path = this._V.connection.node.cloneNode(false);

			// Length of the original path.
			var originalPathLength = path.getTotalLength();
			// Current path length.
			var pathLength;
			// Tolerance determines the highest possible difference between the length
			// of the old and new path. The number has been chosen heuristically.
			var pathLengthTolerance = 20;
			// Total number of vertices including source and target points.
			var idx = vertices.length + 1;

			// Loop through all possible indexes and check if the difference between
			// path lengths changes significantly. If not, the found index is
			// most probably the right one.
			while (idx--) {

				vertices.splice(idx, 0, vertex);
				V(path).attr('d', this.getPathData(this.findRoute(vertices)));

				pathLength = path.getTotalLength();

				// Check if the path lengths changed significantly.
				if (pathLength - originalPathLength > pathLengthTolerance) {

					// Revert vertices to the original array. The path length has changed too much
					// so that the index was not found yet.
					vertices = originalVertices.slice();

				} else {

					break;
				}
			}

			if (idx === -1) {
				// If no suitable index was found for such a vertex, make the vertex the first one.
				idx = 0;
				vertices.splice(idx, 0, vertex);
			}

			this.model.set('vertices', vertices, { ui: true });

			return idx;
		},

		// Send a token (an SVG element, usually a circle) along the connection path.
		// Example: `link.findView(paper).sendToken(V('circle', { r: 7, fill: 'green' }).node)`
		// `opt.duration` is optional and is a time in milliseconds that the token travels from the source to the target of the link. Default is `1000`.
		// `opt.directon` is optional and it determines whether the token goes from source to target or other way round (`reverse`)
		// `callback` is optional and is a function to be called once the token reaches the target.
		sendToken: function (token, opt, callback) {

			function onAnimationEnd(vToken, callback) {
				return function () {
					vToken.remove();
					if (typeof callback === 'function') {
						callback();
					}
				};
			}

			var duration, isReversed;
			if (joint.util.isObject(opt)) {
				duration = opt.duration;
				isReversed = (opt.direction === 'reverse');
			} else {
				// Backwards compatibility
				duration = opt;
				isReversed = false;
			}

			duration = duration || 1000;

			var animationAttributes = {
				dur: duration + 'ms',
				repeatCount: 1,
				calcMode: 'linear',
				fill: 'freeze'
			};

			if (isReversed) {
				animationAttributes.keyPoints = '1;0';
				animationAttributes.keyTimes = '0;1';
			}

			var vToken = V(token);
			var vPath = this._V.connection;

			vToken
				.appendTo(this.paper.viewport)
				.animateAlongPath(animationAttributes, vPath);

			setTimeout(onAnimationEnd(vToken, callback), duration);
		},

		findRoute: function (oldVertices) {

			var namespace = joint.routers;
			var router = this.model.get('router');
			var defaultRouter = this.paper.options.defaultRouter;

			if (!router) {

				if (this.model.get('manhattan')) {
					// backwards compability
					router = { name: 'orthogonal' };
				} else if (defaultRouter) {
					router = defaultRouter;
				} else {
					return oldVertices;
				}
			}

			var args = router.args || {};
			var routerFn = joint.util.isFunction(router) ? router : namespace[router.name];

			if (!joint.util.isFunction(routerFn)) {
				throw new Error('unknown router: "' + router.name + '"');
			}

			var newVertices = routerFn.call(this, oldVertices || [], args, this);

			return newVertices;
		},

		// Return the `d` attribute value of the `<path>` element representing the link
		// between `source` and `target`.
		getPathData: function (vertices) {

			var namespace = joint.connectors;
			var connector = this.model.get('connector');
			var defaultConnector = this.paper.options.defaultConnector;

			if (!connector) {

				// backwards compability
				if (this.model.get('smooth')) {
					connector = { name: 'smooth' };
				} else {
					connector = defaultConnector || {};
				}
			}

			var connectorFn = joint.util.isFunction(connector) ? connector : namespace[connector.name];
			var args = connector.args || {};

			if (!joint.util.isFunction(connectorFn)) {
				throw new Error('unknown connector: "' + connector.name + '"');
			}

			var pathData = connectorFn.call(
				this,
				this._markerCache.sourcePoint, // Note that the value is translated by the size
				this._markerCache.targetPoint, // of the marker. (We'r not using this.sourcePoint)
				vertices || (this.model.get('vertices') || {}),
				args, // options
				this
			);

			return pathData;
		},

		// Find a point that is the start of the connection.
		// If `selectorOrPoint` is a point, then we're done and that point is the start of the connection.
		// If the `selectorOrPoint` is an element however, we need to know a reference point (or element)
		// that the link leads to in order to determine the start of the connection on the original element.
		getConnectionPoint: function (end, selectorOrPoint, referenceSelectorOrPoint) {

			var spot;

			// If the `selectorOrPoint` (or `referenceSelectorOrPoint`) is `undefined`, the `source`/`target` of the link model is `undefined`.
			// We want to allow this however so that one can create links such as `var link = new joint.dia.Link` and
			// set the `source`/`target` later.
			joint.util.isEmpty(selectorOrPoint) && (selectorOrPoint = { x: 0, y: 0 });
			joint.util.isEmpty(referenceSelectorOrPoint) && (referenceSelectorOrPoint = { x: 0, y: 0 });

			if (!selectorOrPoint.id) {

				// If the source is a point, we don't need a reference point to find the sticky point of connection.
				spot = g.Point(selectorOrPoint);

			} else {

				// If the source is an element, we need to find a point on the element boundary that is closest
				// to the reference point (or reference element).
				// Get the bounding box of the spot relative to the paper viewport. This is necessary
				// in order to follow paper viewport transformations (scale/rotate).
				// `_sourceBbox` (`_targetBbox`) comes from `_sourceBboxUpdate` (`_sourceBboxUpdate`)
				// method, it exists since first render and are automatically updated
				var spotBBox = g.Rect(end === 'source' ? this.sourceBBox : this.targetBBox);

				var reference;

				if (!referenceSelectorOrPoint.id) {

					// Reference was passed as a point, therefore, we're ready to find the sticky point of connection on the source element.
					reference = g.Point(referenceSelectorOrPoint);

				} else {

					// Reference was passed as an element, therefore we need to find a point on the reference
					// element boundary closest to the source element.
					// Get the bounding box of the spot relative to the paper viewport. This is necessary
					// in order to follow paper viewport transformations (scale/rotate).
					var referenceBBox = g.Rect(end === 'source' ? this.targetBBox : this.sourceBBox);

					reference = referenceBBox.intersectionWithLineFromCenterToPoint(spotBBox.center());
					reference = reference || referenceBBox.center();
				}

				var paperOptions = this.paper.options;
				// If `perpendicularLinks` flag is set on the paper and there are vertices
				// on the link, then try to find a connection point that makes the link perpendicular
				// even though the link won't point to the center of the targeted object.
				if (paperOptions.perpendicularLinks || this.options.perpendicular) {

					var nearestSide;
					var spotOrigin = spotBBox.origin();
					var spotCorner = spotBBox.corner();

					if (spotOrigin.y <= reference.y && reference.y <= spotCorner.y) {

						nearestSide = spotBBox.sideNearestToPoint(reference);
						switch (nearestSide) {
							case 'left':
								spot = g.Point(spotOrigin.x, reference.y);
								break;
							case 'right':
								spot = g.Point(spotCorner.x, reference.y);
								break;
							default:
								spot = spotBBox.center();
								break;
						}

					} else if (spotOrigin.x <= reference.x && reference.x <= spotCorner.x) {

						nearestSide = spotBBox.sideNearestToPoint(reference);
						switch (nearestSide) {
							case 'top':
								spot = g.Point(reference.x, spotOrigin.y);
								break;
							case 'bottom':
								spot = g.Point(reference.x, spotCorner.y);
								break;
							default:
								spot = spotBBox.center();
								break;
						}

					} else {

						// If there is no intersection horizontally or vertically with the object bounding box,
						// then we fall back to the regular situation finding straight line (not perpendicular)
						// between the object and the reference point.
						spot = spotBBox.intersectionWithLineFromCenterToPoint(reference);
						spot = spot || spotBBox.center();
					}

				} else if (paperOptions.linkConnectionPoint) {

					var view = (end === 'target') ? this.targetView : this.sourceView;
					var magnet = (end === 'target') ? this.targetMagnet : this.sourceMagnet;

					spot = paperOptions.linkConnectionPoint(this, view, magnet, reference, end);

				} else {

					spot = spotBBox.intersectionWithLineFromCenterToPoint(reference);
					spot = spot || spotBBox.center();
				}
			}

			return spot;
		},

		// Public API
		// ----------

		getConnectionLength: function () {

			return this._V.connection.node.getTotalLength();
		},

		getPointAtLength: function (length) {

			return this._V.connection.node.getPointAtLength(length);
		},

		// Interaction. The controller part.
		// ---------------------------------

		_beforeArrowheadMove: function () {

			this._z = this.model.get('z');
			this.model.toFront();

			// Let the pointer propagate throught the link view elements so that
			// the `evt.target` is another element under the pointer, not the link itself.
			this.el.style.pointerEvents = 'none';

			if (this.paper.options.markAvailable) {
				this._markAvailableMagnets();
			}
		},

		_afterArrowheadMove: function () {

			if (this._z !== null) {
				this.model.set('z', this._z, { ui: true });
				this._z = null;
			}

			// Put `pointer-events` back to its original value. See `startArrowheadMove()` for explanation.
			// Value `auto` doesn't work in IE9. We force to use `visiblePainted` instead.
			// See `https://developer.mozilla.org/en-US/docs/Web/CSS/pointer-events`.
			this.el.style.pointerEvents = 'visiblePainted';

			if (this.paper.options.markAvailable) {
				this._unmarkAvailableMagnets();
			}
		},

		_createValidateConnectionArgs: function (arrowhead) {
			// It makes sure the arguments for validateConnection have the following form:
			// (source view, source magnet, target view, target magnet and link view)
			var args = [];

			args[4] = arrowhead;
			args[5] = this;

			var oppositeArrowhead;
			var i = 0;
			var j = 0;

			if (arrowhead === 'source') {
				i = 2;
				oppositeArrowhead = 'target';
			} else {
				j = 2;
				oppositeArrowhead = 'source';
			}

			var end = this.model.get(oppositeArrowhead);

			if (end.id) {
				args[i] = this.paper.findViewByModel(end.id);
				args[i + 1] = end.selector && args[i].el.querySelector(end.selector);
			}

			function validateConnectionArgs(cellView, magnet) {
				args[j] = cellView;
				args[j + 1] = cellView.el === magnet ? undefined : magnet;
				return args;
			}

			return validateConnectionArgs;
		},

		_markAvailableMagnets: function () {

			function isMagnetAvailable(view, magnet) {
				var paper = view.paper;
				var validate = paper.options.validateConnection;
				return validate.apply(paper, this._validateConnectionArgs(view, magnet));
			}

			var paper = this.paper;
			var elements = paper.model.getElements();
			this._marked = {};

			for (var i = 0, n = elements.length; i < n; i++) {
				var view = elements[i].findView(paper);

				if (!view) {
					continue;
				}

				var magnets = Array.prototype.slice.call(view.el.querySelectorAll('[magnet]'));
				if (view.el.getAttribute('magnet') !== 'false') {
					// Element wrapping group is also a magnet
					magnets.push(view.el);
				}

				var availableMagnets = magnets.filter(isMagnetAvailable.bind(this, view));

				if (availableMagnets.length > 0) {
					// highlight all available magnets
					for (var j = 0, m = availableMagnets.length; j < m; j++) {
						view.highlight(availableMagnets[j], { magnetAvailability: true });
					}
					// highlight the entire view
					view.highlight(null, { elementAvailability: true });

					this._marked[view.model.id] = availableMagnets;
				}
			}
		},

		_unmarkAvailableMagnets: function () {

			var markedKeys = Object.keys(this._marked);
			var id;
			var markedMagnets;

			for (var i = 0, n = markedKeys.length; i < n; i++) {
				id = markedKeys[i];
				markedMagnets = this._marked[id];

				var view = this.paper.findViewByModel(id);
				if (view) {
					for (var j = 0, m = markedMagnets.length; j < m; j++) {
						view.unhighlight(markedMagnets[j], { magnetAvailability: true });
					}
					view.unhighlight(null, { elementAvailability: true });
				}
			}

			this._marked = null;
		},

		startArrowheadMove: function (end, opt) {

			opt = joint.util.defaults(opt || {}, { whenNotAllowed: 'revert' });
			// Allow to delegate events from an another view to this linkView in order to trigger arrowhead
			// move without need to click on the actual arrowhead dom element.
			this._action = 'arrowhead-move';
			this._whenNotAllowed = opt.whenNotAllowed;
			this._arrowhead = end;
			this._initialMagnet = this[end + 'Magnet'] || (this[end + 'View'] ? this[end + 'View'].el : null);
			this._initialEnd = joint.util.assign({}, this.model.get(end)) || { x: 0, y: 0 };
			this._validateConnectionArgs = this._createValidateConnectionArgs(this._arrowhead);
			this._beforeArrowheadMove();
		},

		pointerdown: function (evt, x, y) {

			joint.dia.CellView.prototype.pointerdown.apply(this, arguments);
			this.notify('link:pointerdown', evt, x, y);

			this._dx = x;
			this._dy = y;

			// if are simulating pointerdown on a link during a magnet click, skip link interactions
			if (evt.target.getAttribute('magnet') != null) return;

			var className = joint.util.removeClassNamePrefix(evt.target.getAttribute('class'));
			var parentClassName = joint.util.removeClassNamePrefix(evt.target.parentNode.getAttribute('class'));
			var labelNode;
			if (parentClassName === 'label') {
				className = parentClassName;
				labelNode = evt.target.parentNode;
			} else {
				labelNode = evt.target;
			}

			switch (className) {

				case 'marker-vertex':
					if (this.can('vertexMove')) {
						this._action = 'vertex-move';
						this._vertexIdx = evt.target.getAttribute('idx');
					}
					break;

				case 'marker-vertex-remove':
				case 'marker-vertex-remove-area':
					if (this.can('vertexRemove')) {
						this.removeVertex(evt.target.getAttribute('idx'));
					}
					break;

				case 'marker-arrowhead':
					if (this.can('arrowheadMove')) {
						this.startArrowheadMove(evt.target.getAttribute('end'));
					}
					break;

				case 'label':
					if (this.can('labelMove')) {
						this._action = 'label-move';
						this._labelIdx = parseInt(V(labelNode).attr('label-idx'), 10);
						// Precalculate samples so that we don't have to do that
						// over and over again while dragging the label.
						this._samples = this._V.connection.sample(1);
						this._linkLength = this._V.connection.node.getTotalLength();
					}
					break;

				default:

					if (this.can('vertexAdd')) {

						// Store the index at which the new vertex has just been placed.
						// We'll be update the very same vertex position in `pointermove()`.
						this._vertexIdx = this.addVertex({ x: x, y: y });
						this._action = 'vertex-move';
					}
			}
		},

		pointermove: function (evt, x, y) {

			switch (this._action) {

				case 'vertex-move':

					var vertices = joint.util.assign([], this.model.get('vertices'));
					vertices[this._vertexIdx] = { x: x, y: y };
					this.model.set('vertices', vertices, { ui: true });
					break;

				case 'label-move':

					var dragPoint = { x: x, y: y };
					var samples = this._samples;
					var minSqDistance = Infinity;
					var closestSample;
					var closestSampleIndex;
					var p;
					var sqDistance;
					for (var i = 0, n = samples.length; i < n; i++) {
						p = samples[i];
						sqDistance = g.line(p, dragPoint).squaredLength();
						if (sqDistance < minSqDistance) {
							minSqDistance = sqDistance;
							closestSample = p;
							closestSampleIndex = i;
						}
					}
					var prevSample = samples[closestSampleIndex - 1];
					var nextSample = samples[closestSampleIndex + 1];
					var offset = 0;
					if (prevSample && nextSample) {
						offset = g.line(prevSample, nextSample).pointOffset(dragPoint);
					} else if (prevSample) {
						offset = g.line(prevSample, closestSample).pointOffset(dragPoint);
					} else if (nextSample) {
						offset = g.line(closestSample, nextSample).pointOffset(dragPoint);
					}

					this.model.label(this._labelIdx, {
						position: {
							distance: closestSample.distance / this._linkLength,
							offset: offset
						}
					});
					break;

				case 'arrowhead-move':

					if (this.paper.options.snapLinks) {

						// checking view in close area of the pointer

						var r = this.paper.options.snapLinks.radius || 50;
						var viewsInArea = this.paper.findViewsInArea({ x: x - r, y: y - r, width: 2 * r, height: 2 * r });

						if (this._closestView) {
							this._closestView.unhighlight(this._closestEnd.selector, {
								connecting: true,
								snapping: true
							});
						}
						this._closestView = this._closestEnd = null;

						var distance;
						var minDistance = Number.MAX_VALUE;
						var pointer = g.point(x, y);

						viewsInArea.forEach(function (view) {

							// skip connecting to the element in case '.': { magnet: false } attribute present
							if (view.el.getAttribute('magnet') !== 'false') {

								// find distance from the center of the model to pointer coordinates
								distance = view.model.getBBox().center().distance(pointer);

								// the connection is looked up in a circle area by `distance < r`
								if (distance < r && distance < minDistance) {

									if (this.paper.options.validateConnection.apply(
										this.paper, this._validateConnectionArgs(view, null)
									)) {
										minDistance = distance;
										this._closestView = view;
										this._closestEnd = { id: view.model.id };
									}
								}
							}

							view.$('[magnet]').each(function (index, magnet) {

								var bbox = V(magnet).getBBox({ target: this.paper.viewport });

								distance = pointer.distance({
									x: bbox.x + bbox.width / 2,
									y: bbox.y + bbox.height / 2
								});

								if (distance < r && distance < minDistance) {

									if (this.paper.options.validateConnection.apply(
										this.paper, this._validateConnectionArgs(view, magnet)
									)) {
										minDistance = distance;
										this._closestView = view;
										this._closestEnd = {
											id: view.model.id,
											selector: view.getSelector(magnet),
											port: magnet.getAttribute('port')
										};
									}
								}

							}.bind(this));

						}, this);

						if (this._closestView) {
							this._closestView.highlight(this._closestEnd.selector, {
								connecting: true,
								snapping: true
							});
						}

						this.model.set(this._arrowhead, this._closestEnd || { x: x, y: y }, { ui: true });

					} else {

						// checking views right under the pointer

						// Touchmove event's target is not reflecting the element under the coordinates as mousemove does.
						// It holds the element when a touchstart triggered.
						var target = (evt.type === 'mousemove')
							? evt.target
							: document.elementFromPoint(evt.clientX, evt.clientY);

						if (this._eventTarget !== target) {
							// Unhighlight the previous view under pointer if there was one.
							if (this._magnetUnderPointer) {
								this._viewUnderPointer.unhighlight(this._magnetUnderPointer, {
									connecting: true
								});
							}

							this._viewUnderPointer = this.paper.findView(target);
							if (this._viewUnderPointer) {
								// If we found a view that is under the pointer, we need to find the closest
								// magnet based on the real target element of the event.
								this._magnetUnderPointer = this._viewUnderPointer.findMagnet(target);

								if (this._magnetUnderPointer && this.paper.options.validateConnection.apply(
									this.paper,
									this._validateConnectionArgs(this._viewUnderPointer, this._magnetUnderPointer)
								)) {
									// If there was no magnet found, do not highlight anything and assume there
									// is no view under pointer we're interested in reconnecting to.
									// This can only happen if the overall element has the attribute `'.': { magnet: false }`.
									if (this._magnetUnderPointer) {
										this._viewUnderPointer.highlight(this._magnetUnderPointer, {
											connecting: true
										});
									}
								} else {
									// This type of connection is not valid. Disregard this magnet.
									this._magnetUnderPointer = null;
								}
							} else {
								// Make sure we'll unset previous magnet.
								this._magnetUnderPointer = null;
							}
						}

						this._eventTarget = target;

						this.model.set(this._arrowhead, { x: x, y: y }, { ui: true });
					}
					break;
			}

			this._dx = x;
			this._dy = y;

			joint.dia.CellView.prototype.pointermove.apply(this, arguments);
			this.notify('link:pointermove', evt, x, y);
		},

		pointerup: function (evt, x, y) {

			if (this._action === 'label-move') {

				this._samples = null;

			} else if (this._action === 'arrowhead-move') {

				var model = this.model;
				var paper = this.paper;
				var paperOptions = paper.options;
				var arrowhead = this._arrowhead;
				var initialEnd = this._initialEnd;
				var magnetUnderPointer;

				if (paperOptions.snapLinks) {

					// Finish off link snapping.
					// Everything except view unhighlighting was already done on pointermove.
					if (this._closestView) {
						this._closestView.unhighlight(this._closestEnd.selector, {
							connecting: true,
							snapping: true
						});

						magnetUnderPointer = this._closestView.findMagnet(this._closestEnd.selector);
					}

					this._closestView = this._closestEnd = null;

				} else {

					var viewUnderPointer = this._viewUnderPointer;
					magnetUnderPointer = this._magnetUnderPointer;

					this._viewUnderPointer = null;
					this._magnetUnderPointer = null;

					if (magnetUnderPointer) {

						viewUnderPointer.unhighlight(magnetUnderPointer, { connecting: true });
						// Find a unique `selector` of the element under pointer that is a magnet. If the
						// `this._magnetUnderPointer` is the root element of the `this._viewUnderPointer` itself,
						// the returned `selector` will be `undefined`. That means we can directly pass it to the
						// `source`/`target` attribute of the link model below.
						var selector = viewUnderPointer.getSelector(magnetUnderPointer);
						var port = magnetUnderPointer.getAttribute('port');
						var arrowheadValue = { id: viewUnderPointer.model.id };
						if (port != null) arrowheadValue.port = port;
						if (selector != null) arrowheadValue.selector = selector;
						model.set(arrowhead, arrowheadValue, { ui: true });
					}
				}

				// If the changed link is not allowed, revert to its previous state.
				if (!paper.linkAllowed(this)) {

					switch (this._whenNotAllowed) {

						case 'remove':
							model.remove({ ui: true });
							break;

						case 'revert':
						default:
							model.set(arrowhead, initialEnd, { ui: true });
							break;
					}

				} else {

					// Reparent the link if embedding is enabled
					if (paperOptions.embeddingMode && model.reparent()) {
						// Make sure we don't reverse to the original 'z' index (see afterArrowheadMove()).
						this._z = null;
					}

					var currentEnd = model.prop(arrowhead);
					var endChanged = currentEnd && !joint.dia.Link.endsEqual(initialEnd, currentEnd);
					if (endChanged) {

						if (initialEnd.id) {
							this.notify('link:disconnect', evt, paper.findViewByModel(initialEnd.id), this._initialMagnet, arrowhead);
						}
						if (currentEnd.id) {
							this.notify('link:connect', evt, paper.findViewByModel(currentEnd.id), magnetUnderPointer, arrowhead);
						}
					}
				}

				this._afterArrowheadMove();
			}

			this._action = null;
			this._whenNotAllowed = null;
			this._initialMagnet = null;
			this._initialEnd = null;
			this._validateConnectionArgs = null;
			this._eventTarget = null;

			this.notify('link:pointerup', evt, x, y);
			joint.dia.CellView.prototype.pointerup.apply(this, arguments);
		},

		mouseenter: function (evt) {

			joint.dia.CellView.prototype.mouseenter.apply(this, arguments);
			this.notify('link:mouseenter', evt);
		},

		mouseleave: function (evt) {

			joint.dia.CellView.prototype.mouseleave.apply(this, arguments);
			this.notify('link:mouseleave', evt);
		},

		event: function (evt, eventName, x, y) {

			// Backwards compatibility
			var linkTool = V(evt.target).findParentByClass('link-tool', this.el);
			if (linkTool) {
				// No further action to be executed
				evt.stopPropagation();
				// Allow `interactive.useLinkTools=false`
				if (this.can('useLinkTools')) {
					if (eventName === 'remove') {
						// Built-in remove event
						this.model.remove({ ui: true });
					} else {
						// link:options and other custom events inside the link tools
						this.notify(eventName, evt, x, y);
					}
				}

			} else {

				joint.dia.CellView.prototype.event.apply(this, arguments);
			}
		}

	}, {

			makeSelector: function (end) {

				var selector = '[model-id="' + end.id + '"]';
				// `port` has a higher precendence over `selector`. This is because the selector to the magnet
				// might change while the name of the port can stay the same.
				if (end.port) {
					selector += ' [port="' + end.port + '"]';
				} else if (end.selector) {
					selector += ' ' + end.selector;
				}

				return selector;
			}

		});


	joint.dia.Paper = joint.mvc.View.extend({

		className: 'paper',

		options: {

			width: 800,
			height: 600,
			origin: { x: 0, y: 0 }, // x,y coordinates in top-left corner
			gridSize: 1,

			// Whether or not to draw the grid lines on the paper's DOM element.
			// e.g drawGrid: true, drawGrid: { color: 'red', thickness: 2 }
			drawGrid: false,

			// Whether or not to draw the background on the paper's DOM element.
			// e.g. background: { color: 'lightblue', image: '/paper-background.png', repeat: 'flip-xy' }
			background: false,

			perpendicularLinks: false,
			elementView: joint.dia.ElementView,
			linkView: joint.dia.LinkView,
			snapLinks: false, // false, true, { radius: value }

			// When set to FALSE, an element may not have more than 1 link with the same source and target element.
			multiLinks: true,

			// For adding custom guard logic.
			guard: function (evt, view) {

				// FALSE means the event isn't guarded.
				return false;
			},

			highlighting: {
				'default': {
					name: 'stroke',
					options: {
						padding: 3
					}
				},
				magnetAvailability: {
					name: 'addClass',
					options: {
						className: 'available-magnet'
					}
				},
				elementAvailability: {
					name: 'addClass',
					options: {
						className: 'available-cell'
					}
				}
			},

			// Prevent the default context menu from being displayed.
			preventContextMenu: true,
			// Prevent the default action for blank:pointer<action>.
			preventDefaultBlankAction: true,
			// Restrict the translation of elements by given bounding box.
			// Option accepts a boolean:
			//  true - the translation is restricted to the paper area
			//  false - no restrictions
			// A method:
			// restrictTranslate: function(elementView) {
			//     var parentId = elementView.model.get('parent');
			//     return parentId && this.model.getCell(parentId).getBBox();
			// },
			// Or a bounding box:
			// restrictTranslate: { x: 10, y: 10, width: 790, height: 590 }
			restrictTranslate: false,
			// Marks all available magnets with 'available-magnet' class name and all available cells with
			// 'available-cell' class name. Marks them when dragging a link is started and unmark
			// when the dragging is stopped.
			markAvailable: false,

			// Defines what link model is added to the graph after an user clicks on an active magnet.
			// Value could be the Backbone.model or a function returning the Backbone.model
			// defaultLink: function(elementView, magnet) { return condition ? new customLink1() : new customLink2() }
			defaultLink: new joint.dia.Link,

			// A connector that is used by links with no connector defined on the model.
			// e.g. { name: 'rounded', args: { radius: 5 }} or a function
			defaultConnector: { name: 'normal' },

			// A router that is used by links with no router defined on the model.
			// e.g. { name: 'oneSide', args: { padding: 10 }} or a function
			defaultRouter: { name: 'normal' },

			/* CONNECTING */

			// Check whether to add a new link to the graph when user clicks on an a magnet.
			validateMagnet: function (cellView, magnet) {
				return magnet.getAttribute('magnet') !== 'passive';
			},

			// Check whether to allow or disallow the link connection while an arrowhead end (source/target)
			// being changed.
			validateConnection: function (cellViewS, magnetS, cellViewT, magnetT, end, linkView) {
				return (end === 'target' ? cellViewT : cellViewS) instanceof joint.dia.ElementView;
			},

			/* EMBEDDING */

			// Enables embedding. Reparents the dragged element with elements under it and makes sure that
			// all links and elements are visible taken the level of embedding into account.
			embeddingMode: false,

			// Check whether to allow or disallow the element embedding while an element being translated.
			validateEmbedding: function (childView, parentView) {
				// by default all elements can be in relation child-parent
				return true;
			},

			// Determines the way how a cell finds a suitable parent when it's dragged over the paper.
			// The cell with the highest z-index (visually on the top) will be choosen.
			findParentBy: 'bbox', // 'bbox'|'center'|'origin'|'corner'|'topRight'|'bottomLeft'

			// If enabled only the element on the very front is taken into account for the embedding.
			// If disabled the elements under the dragged view are tested one by one
			// (from front to back) until a valid parent found.
			frontParentOnly: true,

			// Interactive flags. See online docs for the complete list of interactive flags.
			interactive: {
				labelMove: false
			},

			// When set to true the links can be pinned to the paper.
			// i.e. link source/target can be a point e.g. link.get('source') ==> { x: 100, y: 100 };
			linkPinning: true,

			// Allowed number of mousemove events after which the pointerclick event will be still triggered.
			clickThreshold: 0,

			// Number of required mousemove events before the first pointermove event will be triggered.
			moveThreshold: 0,

			// The namespace, where all the cell views are defined.
			cellViewNamespace: joint.shapes,

			// The namespace, where all the cell views are defined.
			highlighterNamespace: joint.highlighters
		},

		events: {

			'mousedown': 'pointerdown',
			'dblclick': 'mousedblclick',
			'click': 'mouseclick',
			'touchstart': 'pointerdown',
			'touchend': 'mouseclick',
			'touchmove': 'pointermove',
			'mousemove': 'pointermove',
			'mouseover .joint-cell': 'cellMouseover',
			'mouseout .joint-cell': 'cellMouseout',
			'contextmenu': 'contextmenu',
			'mousewheel': 'mousewheel',
			'DOMMouseScroll': 'mousewheel',
			'mouseenter .joint-cell': 'cellMouseenter',
			'mouseleave .joint-cell': 'cellMouseleave',
			'mousedown .joint-cell [event]': 'cellEvent',
			'touchstart .joint-cell [event]': 'cellEvent'
		},

		_highlights: {},

		init: function () {

			joint.util.bindAll(this, 'pointerup');

			var model = this.model = this.options.model || new joint.dia.Graph;

			this.setGrid(this.options.drawGrid);
			this.cloneOptions();
			this.render();
			this.setDimensions();

			this.listenTo(model, 'add', this.onCellAdded)
				.listenTo(model, 'remove', this.removeView)
				.listenTo(model, 'reset', this.resetViews)
				.listenTo(model, 'sort', this._onSort)
				.listenTo(model, 'batch:stop', this._onBatchStop);

			this.on('cell:highlight', this.onCellHighlight)
				.on('cell:unhighlight', this.onCellUnhighlight)
				.on('scale translate', this.update);

			// Hold the value when mouse has been moved: when mouse moved, no click event will be triggered.
			this._mousemoved = 0;
			// Hash of all cell views.
			this._views = {};
			// Reference to the paper owner document
			this.$document = $(this.el.ownerDocument);
		},

		cloneOptions: function () {

			var options = this.options;

			// This is a fix for the case where two papers share the same options.
			// Changing origin.x for one paper would change the value of origin.x for the other.
			// This prevents that behavior.
			options.origin = joint.util.assign({}, options.origin);
			options.defaultConnector = joint.util.assign({}, options.defaultConnector);
			// Return the default highlighting options into the user specified options.
			options.highlighting = joint.util.defaultsDeep(
				{},
				options.highlighting,
				this.constructor.prototype.options.highlighting
			);
		},

		bindDocumentEvents: function () {
			var eventNS = this.getEventNamespace();
			this.$document.on('mouseup' + eventNS + ' touchend' + eventNS, this.pointerup);
		},

		unbindDocumentEvents: function () {
			this.$document.off(this.getEventNamespace());
		},

		render: function () {

			this.$el.empty();

			this.svg = V('svg').attr({ width: '100%', height: '100%' }).node;
			this.viewport = V('g').addClass(joint.util.addClassNamePrefix('viewport')).node;
			this.defs = V('defs').node;

			// Append `<defs>` element to the SVG document. This is useful for filters and gradients.
			V(this.svg).append([this.viewport, this.defs]);

			this.$background = $('<div/>').addClass(joint.util.addClassNamePrefix('paper-background'));
			if (this.options.background) {
				this.drawBackground(this.options.background);
			}

			this.$grid = $('<div/>').addClass(joint.util.addClassNamePrefix('paper-grid'));
			if (this.options.drawGrid) {
				this.drawGrid();
			}

			this.$el.append(this.$background, this.$grid, this.svg);

			return this;
		},

		update: function () {

			if (this.options.drawGrid) {
				this.drawGrid();
			}

			if (this._background) {
				this.updateBackgroundImage(this._background);
			}

			return this;
		},

		// For storing the current transformation matrix (CTM) of the paper's viewport.
		_viewportMatrix: null,
		// For verifying whether the CTM is up-to-date. The viewport transform attribute
		// could have been manipulated directly.
		_viewportTransformString: null,

		matrix: function (ctm) {

			var viewport = this.viewport;

			// Getter:
			if (ctm === undefined) {

				var transformString = viewport.getAttribute('transform');

				if ((this._viewportTransformString || null) === transformString) {
					// It's ok to return the cached matrix. The transform attribute has not changed since
					// the matrix was stored.
					ctm = this._viewportMatrix;
				} else {
					// The viewport transform attribute has changed. Measure the matrix and cache again.
					ctm = viewport.getCTM();
					this._viewportMatrix = ctm;
					this._viewportTransformString = transformString;
				}

				// Clone the cached current transformation matrix.
				// If no matrix previously stored the identity matrix is returned.
				return V.createSVGMatrix(ctm);
			}

			// Setter:
			ctm = V.createSVGMatrix(ctm);
			V(viewport).transform(ctm, { absolute: true });
			this._viewportMatrix = ctm;
			this._viewportTransformString = viewport.getAttribute('transform');

			return this;
		},

		clientMatrix: function () {

			return V.createSVGMatrix(this.viewport.getScreenCTM());
		},

		_onSort: function () {
			if (!this.model.hasActiveBatch('add')) {
				this.sortViews();
			}
		},

		_onBatchStop: function (data) {
			var name = data && data.batchName;
			if (name === 'add' && !this.model.hasActiveBatch('add')) {
				this.sortViews();
			}
		},

		onRemove: function () {

			//clean up all DOM elements/views to prevent memory leaks
			this.removeViews();
			this.unbindDocumentEvents();
		},

		setDimensions: function (width, height) {

			width = this.options.width = width || this.options.width;
			height = this.options.height = height || this.options.height;

			this.$el.css({
				width: Math.round(width),
				height: Math.round(height)
			});

			this.trigger('resize', width, height);
		},

		setOrigin: function (ox, oy) {

			return this.translate(ox || 0, oy || 0, { absolute: true });
		},

		// Expand/shrink the paper to fit the content. Snap the width/height to the grid
		// defined in `gridWidth`, `gridHeight`. `padding` adds to the resulting width/height of the paper.
		// When options { fitNegative: true } it also translates the viewport in order to make all
		// the content visible.
		fitToContent: function (gridWidth, gridHeight, padding, opt) { // alternatively function(opt)

			if (joint.util.isObject(gridWidth)) {
				// first parameter is an option object
				opt = gridWidth;
				gridWidth = opt.gridWidth || 1;
				gridHeight = opt.gridHeight || 1;
				padding = opt.padding || 0;

			} else {

				opt = opt || {};
				gridWidth = gridWidth || 1;
				gridHeight = gridHeight || 1;
				padding = padding || 0;
			}

			padding = joint.util.normalizeSides(padding);

			// Calculate the paper size to accomodate all the graph's elements.
			var bbox = V(this.viewport).getBBox();

			var currentScale = this.scale();
			var currentTranslate = this.translate();

			bbox.x *= currentScale.sx;
			bbox.y *= currentScale.sy;
			bbox.width *= currentScale.sx;
			bbox.height *= currentScale.sy;

			var calcWidth = Math.max(Math.ceil((bbox.width + bbox.x) / gridWidth), 1) * gridWidth;
			var calcHeight = Math.max(Math.ceil((bbox.height + bbox.y) / gridHeight), 1) * gridHeight;

			var tx = 0;
			var ty = 0;

			if ((opt.allowNewOrigin == 'negative' && bbox.x < 0) || (opt.allowNewOrigin == 'positive' && bbox.x >= 0) || opt.allowNewOrigin == 'any') {
				tx = Math.ceil(-bbox.x / gridWidth) * gridWidth;
				tx += padding.left;
				calcWidth += tx;
			}

			if ((opt.allowNewOrigin == 'negative' && bbox.y < 0) || (opt.allowNewOrigin == 'positive' && bbox.y >= 0) || opt.allowNewOrigin == 'any') {
				ty = Math.ceil(-bbox.y / gridHeight) * gridHeight;
				ty += padding.top;
				calcHeight += ty;
			}

			calcWidth += padding.right;
			calcHeight += padding.bottom;

			// Make sure the resulting width and height are greater than minimum.
			calcWidth = Math.max(calcWidth, opt.minWidth || 0);
			calcHeight = Math.max(calcHeight, opt.minHeight || 0);

			// Make sure the resulting width and height are lesser than maximum.
			calcWidth = Math.min(calcWidth, opt.maxWidth || Number.MAX_VALUE);
			calcHeight = Math.min(calcHeight, opt.maxHeight || Number.MAX_VALUE);

			var dimensionChange = calcWidth != this.options.width || calcHeight != this.options.height;
			var originChange = tx != currentTranslate.tx || ty != currentTranslate.ty;

			// Change the dimensions only if there is a size discrepency or an origin change
			if (originChange) {
				this.translate(tx, ty);
			}
			if (dimensionChange) {
				this.setDimensions(calcWidth, calcHeight);
			}
		},

		scaleContentToFit: function (opt) {

			var contentBBox = this.getContentBBox();

			if (!contentBBox.width || !contentBBox.height) return;

			opt = opt || {};

			joint.util.defaults(opt, {
				padding: 0,
				preserveAspectRatio: true,
				scaleGrid: null,
				minScale: 0,
				maxScale: Number.MAX_VALUE
				//minScaleX
				//minScaleY
				//maxScaleX
				//maxScaleY
				//fittingBBox
			});

			var padding = opt.padding;

			var minScaleX = opt.minScaleX || opt.minScale;
			var maxScaleX = opt.maxScaleX || opt.maxScale;
			var minScaleY = opt.minScaleY || opt.minScale;
			var maxScaleY = opt.maxScaleY || opt.maxScale;

			var fittingBBox;
			if (opt.fittingBBox) {
				fittingBBox = opt.fittingBBox;
			} else {
				var currentTranslate = this.translate();
				fittingBBox = {
					x: currentTranslate.tx,
					y: currentTranslate.ty,
					width: this.options.width,
					height: this.options.height
				};
			}

			fittingBBox = g.rect(fittingBBox).moveAndExpand({
				x: padding,
				y: padding,
				width: -2 * padding,
				height: -2 * padding
			});

			var currentScale = this.scale();

			var newSx = fittingBBox.width / contentBBox.width * currentScale.sx;
			var newSy = fittingBBox.height / contentBBox.height * currentScale.sy;

			if (opt.preserveAspectRatio) {
				newSx = newSy = Math.min(newSx, newSy);
			}

			// snap scale to a grid
			if (opt.scaleGrid) {

				var gridSize = opt.scaleGrid;

				newSx = gridSize * Math.floor(newSx / gridSize);
				newSy = gridSize * Math.floor(newSy / gridSize);
			}

			// scale min/max boundaries
			newSx = Math.min(maxScaleX, Math.max(minScaleX, newSx));
			newSy = Math.min(maxScaleY, Math.max(minScaleY, newSy));

			this.scale(newSx, newSy);

			var contentTranslation = this.getContentBBox();

			var newOx = fittingBBox.x - contentTranslation.x;
			var newOy = fittingBBox.y - contentTranslation.y;

			this.translate(newOx, newOy);
		},

		getContentBBox: function () {

			var crect = this.viewport.getBoundingClientRect();

			// Using Screen CTM was the only way to get the real viewport bounding box working in both
			// Google Chrome and Firefox.
			var clientCTM = this.clientMatrix();

			// for non-default origin we need to take the viewport translation into account
			var currentTranslate = this.translate();

			return g.rect({
				x: crect.left - clientCTM.e + currentTranslate.tx,
				y: crect.top - clientCTM.f + currentTranslate.ty,
				width: crect.width,
				height: crect.height
			});
		},

		// Returns a geometry rectangle represeting the entire
		// paper area (coordinates from the left paper border to the right one
		// and the top border to the bottom one).
		getArea: function () {

			return this.paperToLocalRect({
				x: 0,
				y: 0,
				width: this.options.width,
				height: this.options.height
			});
		},

		getRestrictedArea: function () {

			var restrictedArea;

			if (joint.util.isFunction(this.options.restrictTranslate)) {
				// A method returning a bounding box
				restrictedArea = this.options.restrictTranslate.apply(this, arguments);
			} else if (this.options.restrictTranslate === true) {
				// The paper area
				restrictedArea = this.getArea();
			} else {
				// Either false or a bounding box
				restrictedArea = this.options.restrictTranslate || null;
			}

			return restrictedArea;
		},

		createViewForModel: function (cell) {

			// A class taken from the paper options.
			var optionalViewClass;

			// A default basic class (either dia.ElementView or dia.LinkView)
			var defaultViewClass;

			// A special class defined for this model in the corresponding namespace.
			// e.g. joint.shapes.basic.Rect searches for joint.shapes.basic.RectView
			var namespace = this.options.cellViewNamespace;
			var type = cell.get('type') + 'View';
			var namespaceViewClass = joint.util.getByPath(namespace, type, '.');

			if (cell.isLink()) {
				optionalViewClass = this.options.linkView;
				defaultViewClass = joint.dia.LinkView;
			} else {
				optionalViewClass = this.options.elementView;
				defaultViewClass = joint.dia.ElementView;
			}

			// a) the paper options view is a class (deprecated)
			//  1. search the namespace for a view
			//  2. if no view was found, use view from the paper options
			// b) the paper options view is a function
			//  1. call the function from the paper options
			//  2. if no view was return, search the namespace for a view
			//  3. if no view was found, use the default
			var ViewClass = (optionalViewClass.prototype instanceof Backbone.View)
				? namespaceViewClass || optionalViewClass
				: optionalViewClass.call(this, cell) || namespaceViewClass || defaultViewClass;

			return new ViewClass({
				model: cell,
				interactive: this.options.interactive
			});
		},

		onCellAdded: function (cell, graph, opt) {

			if (this.options.async && opt.async !== false && joint.util.isNumber(opt.position)) {

				this._asyncCells = this._asyncCells || [];
				this._asyncCells.push(cell);

				if (opt.position == 0) {

					if (this._frameId) throw new Error('another asynchronous rendering in progress');

					this.asyncRenderViews(this._asyncCells, opt);
					delete this._asyncCells;
				}

			} else {

				this.renderView(cell);
			}
		},

		removeView: function (cell) {

			var view = this._views[cell.id];

			if (view) {
				view.remove();
				delete this._views[cell.id];
			}

			return view;
		},

		renderView: function (cell) {

			var view = this._views[cell.id] = this.createViewForModel(cell);

			V(this.viewport).append(view.el);
			view.paper = this;
			view.render();

			// This is the only way to prevent image dragging in Firefox that works.
			// Setting -moz-user-select: none, draggable="false" attribute or user-drag: none didn't help.
			$(view.el).find('image').on('dragstart', function () { return false; });

			return view;
		},

		beforeRenderViews: function (cells) {

			// Make sure links are always added AFTER elements.
			// They wouldn't find their sources/targets in the DOM otherwise.
			cells.sort(function (a) { return (a.isLink()) ? 1 : -1; });

			return cells;
		},

		afterRenderViews: function () {

			this.sortViews();
		},

		resetViews: function (cellsCollection, opt) {

			// clearing views removes any event listeners
			this.removeViews();

			var cells = cellsCollection.models.slice();

			// `beforeRenderViews()` can return changed cells array (e.g sorted).
			cells = this.beforeRenderViews(cells, opt) || cells;

			this.cancelRenderViews();

			if (this.options.async) {

				this.asyncRenderViews(cells, opt);
				// Sort the cells once all elements rendered (see asyncRenderViews()).

			} else {

				for (var i = 0, n = cells.length; i < n; i++) {
					this.renderView(cells[i]);
				}

				// Sort the cells in the DOM manually as we might have changed the order they
				// were added to the DOM (see above).
				this.sortViews();
			}
		},

		cancelRenderViews: function () {
			if (this._frameId) {
				joint.util.cancelFrame(this._frameId);
				delete this._frameId;
			}
		},

		removeViews: function () {

			joint.util.invoke(this._views, 'remove');

			this._views = {};
		},

		asyncBatchAdded: joint.util.noop,

		asyncRenderViews: function (cells, opt) {

			if (this._frameId) {

				var batchSize = (this.options.async && this.options.async.batchSize) || 50;
				var batchCells = cells.splice(0, batchSize);

				batchCells.forEach(function (cell) {

					// The cell has to be part of the graph.
					// There is a chance in asynchronous rendering
					// that a cell was removed before it's rendered to the paper.
					if (cell.graph === this.model) this.renderView(cell);

				}, this);

				this.asyncBatchAdded();
			}

			if (!cells.length) {

				// No cells left to render.
				delete this._frameId;
				this.afterRenderViews(opt);
				this.trigger('render:done', opt);

			} else {

				// Schedule a next batch to render.
				this._frameId = joint.util.nextFrame(function () {
					this.asyncRenderViews(cells, opt);
				}, this);
			}
		},

		sortViews: function () {

			// Run insertion sort algorithm in order to efficiently sort DOM elements according to their
			// associated model `z` attribute.

			var $cells = $(this.viewport).children('[model-id]');
			var cells = this.model.get('cells');

			joint.util.sortElements($cells, function (a, b) {

				var cellA = cells.get($(a).attr('model-id'));
				var cellB = cells.get($(b).attr('model-id'));

				return (cellA.get('z') || 0) > (cellB.get('z') || 0) ? 1 : -1;
			});
		},

		scale: function (sx, sy, ox, oy) {

			// getter
			if (sx === undefined) {
				return V.matrixToScale(this.matrix());
			}

			// setter
			if (sy === undefined) {
				sy = sx;
			}
			if (ox === undefined) {
				ox = 0;
				oy = 0;
			}

			var translate = this.translate();

			if (ox || oy || translate.tx || translate.ty) {
				var newTx = translate.tx - ox * (sx - 1);
				var newTy = translate.ty - oy * (sy - 1);
				this.translate(newTx, newTy);
			}

			var ctm = this.matrix();
			ctm.a = sx || 0;
			ctm.d = sy || 0;

			this.matrix(ctm);

			this.trigger('scale', sx, sy, ox, oy);

			return this;
		},

		// Experimental - do not use in production.
		rotate: function (angle, cx, cy) {

			// getter
			if (angle === undefined) {
				return V.matrixToRotate(this.matrix());
			}

			// setter

			// If the origin is not set explicitely, rotate around the center. Note that
			// we must use the plain bounding box (`this.el.getBBox()` instead of the one that gives us
			// the real bounding box (`bbox()`) including transformations).
			if (cx === undefined) {
				var bbox = this.viewport.getBBox();
				cx = bbox.width / 2;
				cy = bbox.height / 2;
			}

			var ctm = this.matrix().translate(cx, cy).rotate(angle).translate(-cx, -cy);
			this.matrix(ctm);

			return this;
		},

		translate: function (tx, ty) {

			// getter
			if (tx === undefined) {
				return V.matrixToTranslate(this.matrix());
			}

			// setter

			var ctm = this.matrix();
			ctm.e = tx || 0;
			ctm.f = ty || 0;

			this.matrix(ctm);

			var newTranslate = this.translate();
			var origin = this.options.origin;
			origin.x = newTranslate.tx;
			origin.y = newTranslate.ty;

			this.trigger('translate', newTranslate.tx, newTranslate.ty);

			if (this.options.drawGrid) {
				this.drawGrid();
			}

			return this;
		},

		// Find the first view climbing up the DOM tree starting at element `el`. Note that `el` can also
		// be a selector or a jQuery object.
		findView: function ($el) {

			var el = joint.util.isString($el)
				? this.viewport.querySelector($el)
				: $el instanceof $ ? $el[0] : $el;

			while (el && el !== this.el && el !== document) {

				var id = el.getAttribute('model-id');
				if (id) return this._views[id];

				el = el.parentNode;
			}

			return undefined;
		},

		// Find a view for a model `cell`. `cell` can also be a string or number representing a model `id`.
		findViewByModel: function (cell) {

			var id = (joint.util.isString(cell) || joint.util.isNumber(cell)) ? cell : (cell && cell.id);

			return this._views[id];
		},

		// Find all views at given point
		findViewsFromPoint: function (p) {

			p = g.point(p);

			var views = this.model.getElements().map(this.findViewByModel, this);

			return views.filter(function (view) {
				return view && view.vel.getBBox({ target: this.viewport }).containsPoint(p);
			}, this);
		},

		// Find all views in given area
		findViewsInArea: function (rect, opt) {

			opt = joint.util.defaults(opt || {}, { strict: false });
			rect = g.rect(rect);

			var views = this.model.getElements().map(this.findViewByModel, this);
			var method = opt.strict ? 'containsRect' : 'intersect';

			return views.filter(function (view) {
				return view && rect[method](view.vel.getBBox({ target: this.viewport }));
			}, this);
		},

		getModelById: function (id) {

			return this.model.getCell(id);
		},

		snapToGrid: function (x, y) {

			// Convert global coordinates to the local ones of the `viewport`. Otherwise,
			// improper transformation would be applied when the viewport gets transformed (scaled/rotated).
			return this.clientToLocalPoint(x, y).snapToGrid(this.options.gridSize);
		},

		localToPaperPoint: function (x, y) {
			// allow `x` to be a point and `y` undefined
			var localPoint = g.Point(x, y);
			var paperPoint = V.transformPoint(localPoint, this.matrix());
			return g.Point(paperPoint);
		},

		localToPaperRect: function (x, y, width, height) {
			// allow `x` to be a rectangle and rest arguments undefined
			var localRect = g.Rect(x, y);
			var paperRect = V.transformRect(localRect, this.matrix());
			return g.Rect(paperRect);
		},

		paperToLocalPoint: function (x, y) {
			// allow `x` to be a point and `y` undefined
			var paperPoint = g.Point(x, y);
			var localPoint = V.transformPoint(paperPoint, this.matrix().inverse());
			return g.Point(localPoint);
		},

		paperToLocalRect: function (x, y, width, height) {
			// allow `x` to be a rectangle and rest arguments undefined
			var paperRect = g.Rect(x, y, width, height);
			var localRect = V.transformRect(paperRect, this.matrix().inverse());
			return g.Rect(localRect);
		},

		localToClientPoint: function (x, y) {
			// allow `x` to be a point and `y` undefined
			var localPoint = g.Point(x, y);
			var clientPoint = V.transformPoint(localPoint, this.clientMatrix());
			return g.Point(clientPoint);
		},

		localToClientRect: function (x, y, width, height) {
			// allow `x` to be a point and `y` undefined
			var localRect = g.Rect(x, y, width, height);
			var clientRect = V.transformRect(localRect, this.clientMatrix());
			return g.Rect(clientRect);
		},

		// Transform client coordinates to the paper local coordinates.
		// Useful when you have a mouse event object and you'd like to get coordinates
		// inside the paper that correspond to `evt.clientX` and `evt.clientY` point.
		// Example: var localPoint = paper.clientToLocalPoint({ x: evt.clientX, y: evt.clientY });
		clientToLocalPoint: function (x, y) {
			// allow `x` to be a point and `y` undefined
			var clientPoint = g.Point(x, y);
			var localPoint = V.transformPoint(clientPoint, this.clientMatrix().inverse());
			return g.Point(localPoint);
		},

		clientToLocalRect: function (x, y, width, height) {
			// allow `x` to be a point and `y` undefined
			var clientRect = g.Rect(x, y, width, height);
			var localRect = V.transformRect(clientRect, this.clientMatrix().inverse());
			return g.Rect(localRect);
		},

		localToPagePoint: function (x, y) {
			return this.localToPaperPoint(x, y).offset(this.pageOffset());
		},

		localToPageRect: function (x, y, width, height) {
			return this.localToPaperRect(x, y, width, height).moveAndExpand(this.pageOffset());
		},

		pageToLocalPoint: function (x, y) {
			var pagePoint = g.Point(x, y);
			var paperPoint = pagePoint.difference(this.pageOffset());
			return this.paperToLocalPoint(paperPoint);
		},

		pageToLocalRect: function (x, y, width, height) {
			var pageOffset = this.pageOffset();
			var paperRect = g.Rect(x, y, width, height);
			paperRect.x -= pageOffset.x;
			paperRect.y -= pageOffset.y;
			return this.paperToLocalRect(paperRect);
		},

		clientOffset: function () {
			var clientRect = this.svg.getBoundingClientRect();
			return g.Point(clientRect.left, clientRect.top);
		},

		pageOffset: function () {
			return this.clientOffset().offset(window.scrollX, window.scrollY);
		},

		linkAllowed: function (linkViewOrModel) {

			var link;

			if (linkViewOrModel instanceof joint.dia.Link) {
				link = linkViewOrModel;
			} else if (linkViewOrModel instanceof joint.dia.LinkView) {
				link = linkViewOrModel.model;
			} else {
				throw new Error('Must provide link model or view.');
			}

			if (!this.options.multiLinks) {

				// Do not allow multiple links to have the same source and target.

				var source = link.get('source');
				var target = link.get('target');

				if (source.id && target.id) {

					var sourceModel = link.getSourceElement();

					if (sourceModel) {

						var connectedLinks = this.model.getConnectedLinks(sourceModel, {
							outbound: true,
							inbound: false
						});

						var numSameLinks = connectedLinks.filter(function (_link) {

							var _source = _link.get('source');
							var _target = _link.get('target');

							return _source && _source.id === source.id &&
								(!_source.port || (_source.port === source.port)) &&
								_target && _target.id === target.id &&
								(!_target.port || (_target.port === target.port));

						}).length;

						if (numSameLinks > 1) {
							return false;
						}
					}
				}
			}

			if (
				!this.options.linkPinning &&
				(
					!joint.util.has(link.get('source'), 'id') ||
					!joint.util.has(link.get('target'), 'id')
				)
			) {
				// Link pinning is not allowed and the link is not connected to the target.
				return false;
			}

			return true;
		},

		getDefaultLink: function (cellView, magnet) {

			return joint.util.isFunction(this.options.defaultLink)
				// default link is a function producing link model
				? this.options.defaultLink.call(this, cellView, magnet)
				// default link is the Backbone model
				: this.options.defaultLink.clone();
		},

		// Cell highlighting
		// -----------------
		resolveHighlighter: function (opt) {

			opt = opt || {};
			var highlighterDef = opt.highlighter;
			var paperOpt = this.options;

			/*
				Expecting opt.highlighter to have the following structure:
				{
					name: 'highlighter-name',
					options: {
						some: 'value'
					}
				}
			*/
			if (highlighterDef === undefined) {

				// check for built-in types
				var type = ['embedding', 'connecting', 'magnetAvailability', 'elementAvailability'].find(function (type) {
					return !!opt[type];
				});

				highlighterDef = (type && paperOpt.highlighting[type]) || paperOpt.highlighting['default'];
			}

			// Do nothing if opt.highlighter is falsey.
			// This allows the case to not highlight cell(s) in certain cases.
			// For example, if you want to NOT highlight when embedding elements.
			if (!highlighterDef) return false;

			// Allow specifying a highlighter by name.
			if (joint.util.isString(highlighterDef)) {
				highlighterDef = {
					name: highlighterDef
				};
			}

			var name = highlighterDef.name;
			var highlighter = paperOpt.highlighterNamespace[name];

			// Highlighter validation
			if (!highlighter) {
				throw new Error('Unknown highlighter ("' + name + '")');
			}
			if (typeof highlighter.highlight !== 'function') {
				throw new Error('Highlighter ("' + name + '") is missing required highlight() method');
			}
			if (typeof highlighter.unhighlight !== 'function') {
				throw new Error('Highlighter ("' + name + '") is missing required unhighlight() method');
			}

			return {
				highlighter: highlighter,
				options: highlighterDef.options || {},
				name: name
			};
		},

		onCellHighlight: function (cellView, magnetEl, opt) {

			opt = this.resolveHighlighter(opt);
			if (!opt) return;
			if (!magnetEl.id) {
				magnetEl.id = V.uniqueId();
			}

			var key = opt.name + magnetEl.id + JSON.stringify(opt.options);
			if (!this._highlights[key]) {

				var highlighter = opt.highlighter;
				highlighter.highlight(cellView, magnetEl, joint.util.assign({}, opt.options));

				this._highlights[key] = {
					cellView: cellView,
					magnetEl: magnetEl,
					opt: opt.options,
					highlighter: highlighter
				};
			}
		},

		onCellUnhighlight: function (cellView, magnetEl, opt) {

			opt = this.resolveHighlighter(opt);
			if (!opt) return;

			var key = opt.name + magnetEl.id + JSON.stringify(opt.options);
			var highlight = this._highlights[key];
			if (highlight) {

				// Use the cellView and magnetEl that were used by the highlighter.highlight() method.
				highlight.highlighter.unhighlight(highlight.cellView, highlight.magnetEl, highlight.opt);

				this._highlights[key] = null;
			}
		},

		// Interaction.
		// ------------

		mousedblclick: function (evt) {

			evt.preventDefault();
			evt = joint.util.normalizeEvent(evt);

			var view = this.findView(evt.target);
			if (this.guard(evt, view)) return;

			var localPoint = this.snapToGrid({ x: evt.clientX, y: evt.clientY });

			if (view) {

				view.pointerdblclick(evt, localPoint.x, localPoint.y);

			} else {

				this.trigger('blank:pointerdblclick', evt, localPoint.x, localPoint.y);
			}
		},

		mouseclick: function (evt) {

			// Trigger event when mouse not moved.
			if (this._mousemoved <= this.options.clickThreshold) {

				evt = joint.util.normalizeEvent(evt);

				var view = this.findView(evt.target);
				if (this.guard(evt, view)) return;

				var localPoint = this.snapToGrid({ x: evt.clientX, y: evt.clientY });

				if (view) {

					view.pointerclick(evt, localPoint.x, localPoint.y);

				} else {

					this.trigger('blank:pointerclick', evt, localPoint.x, localPoint.y);
				}
			}
		},

		// Guard guards the event received. If the event is not interesting, guard returns `true`.
		// Otherwise, it return `false`.
		guard: function (evt, view) {

			if (this.options.guard && this.options.guard(evt, view)) {
				return true;
			}

			if (evt.data && evt.data.guarded !== undefined) {
				return evt.data.guarded;
			}

			if (view && view.model && (view.model instanceof joint.dia.Cell)) {
				return false;
			}

			if (this.svg === evt.target || this.el === evt.target || $.contains(this.svg, evt.target)) {
				return false;
			}

			return true;    // Event guarded. Paper should not react on it in any way.
		},

		contextmenu: function (evt) {

			evt = joint.util.normalizeEvent(evt);

			if (this.options.preventContextMenu) {
				evt.preventDefault();
			}

			var view = this.findView(evt.target);
			if (this.guard(evt, view)) return;

			var localPoint = this.snapToGrid({ x: evt.clientX, y: evt.clientY });

			if (view) {

				view.contextmenu(evt, localPoint.x, localPoint.y);

			} else {

				this.trigger('blank:contextmenu', evt, localPoint.x, localPoint.y);
			}
		},

		pointerdown: function (evt) {

			this.bindDocumentEvents();

			evt = joint.util.normalizeEvent(evt);

			var view = this.findView(evt.target);
			if (this.guard(evt, view)) return;

			this._mousemoved = 0;

			var localPoint = this.snapToGrid({ x: evt.clientX, y: evt.clientY });

			if (view) {

				evt.preventDefault();

				this.sourceView = view;

				view.pointerdown(evt, localPoint.x, localPoint.y);

			} else {

				if (this.options.preventDefaultBlankAction) {
					evt.preventDefault();
				}

				this.trigger('blank:pointerdown', evt, localPoint.x, localPoint.y);
			}
		},

		pointermove: function (evt) {

			var view = this.sourceView;
			if (view) {

				evt.preventDefault();

				// Mouse moved counter.
				var mousemoved = ++this._mousemoved;
				if (mousemoved > this.options.moveThreshold) {

					evt = joint.util.normalizeEvent(evt);

					var localPoint = this.snapToGrid({ x: evt.clientX, y: evt.clientY });
					view.pointermove(evt, localPoint.x, localPoint.y);
				}
			}
		},

		pointerup: function (evt) {

			this.unbindDocumentEvents();

			evt = joint.util.normalizeEvent(evt);

			var localPoint = this.snapToGrid({ x: evt.clientX, y: evt.clientY });

			if (this.sourceView) {

				this.sourceView.pointerup(evt, localPoint.x, localPoint.y);

				//"delete sourceView" occasionally throws an error in chrome (illegal access exception)
				this.sourceView = null;

			} else {

				this.trigger('blank:pointerup', evt, localPoint.x, localPoint.y);
			}
		},

		mousewheel: function (evt) {

			evt = joint.util.normalizeEvent(evt);
			var view = this.findView(evt.target);
			if (this.guard(evt, view)) return;

			var originalEvent = evt.originalEvent;
			var localPoint = this.snapToGrid({ x: originalEvent.clientX, y: originalEvent.clientY });
			var delta = Math.max(-1, Math.min(1, (originalEvent.wheelDelta || -originalEvent.detail)));

			if (view) {

				view.mousewheel(evt, localPoint.x, localPoint.y, delta);

			} else {

				this.trigger('blank:mousewheel', evt, localPoint.x, localPoint.y, delta);
			}
		},

		cellMouseover: function (evt) {

			evt = joint.util.normalizeEvent(evt);
			var view = this.findView(evt.target);
			if (view) {
				if (this.guard(evt, view)) return;
				view.mouseover(evt);
			}
		},

		cellMouseout: function (evt) {

			evt = joint.util.normalizeEvent(evt);
			var view = this.findView(evt.target);
			if (view) {
				if (this.guard(evt, view)) return;
				view.mouseout(evt);
			}
		},

		cellMouseenter: function (evt) {

			evt = joint.util.normalizeEvent(evt);
			var view = this.findView(evt.target);
			if (view && !this.guard(evt, view)) {
				view.mouseenter(evt);
			}
		},

		cellMouseleave: function (evt) {

			evt = joint.util.normalizeEvent(evt);
			var view = this.findView(evt.target);
			if (view && !this.guard(evt, view)) {
				view.mouseleave(evt);
			}
		},

		cellEvent: function (evt) {

			evt = joint.util.normalizeEvent(evt);

			var currentTarget = evt.currentTarget;
			var eventName = currentTarget.getAttribute('event');
			if (eventName) {
				var view = this.findView(currentTarget);
				if (view && !this.guard(evt, view)) {
					var localPoint = this.snapToGrid({ x: evt.clientX, y: evt.clientY });
					view.event(evt, eventName, localPoint.x, localPoint.y);
				}
			}
		},

		setGridSize: function (gridSize) {

			this.options.gridSize = gridSize;

			if (this.options.drawGrid) {
				this.drawGrid();
			}

			return this;
		},

		clearGrid: function () {

			if (this.$grid) {
				this.$grid.css('backgroundImage', 'none');
			}
			return this;
		},

		_getGriRefs: function () {

			if (!this._gridCache) {

				this._gridCache = {
					root: V('svg', { width: '100%', height: '100%' }, V('defs')),
					patterns: {},
					add: function (id, vel) {
						V(this.root.node.childNodes[0]).append(vel);
						this.patterns[id] = vel;
						this.root.append(V('rect', { width: "100%", height: "100%", fill: 'url(#' + id + ')' }));
					},
					get: function (id) {
						return this.patterns[id]
					},
					exist: function (id) {
						return this.patterns[id] !== undefined;
					}
				}
			}

			return this._gridCache;
		},

		setGrid: function (drawGrid) {

			this.clearGrid();

			this._gridCache = null;
			this._gridSettings = [];

			var optionsList = Array.isArray(drawGrid) ? drawGrid : [drawGrid || {}];
			optionsList.forEach(function (item) {
				this._gridSettings.push.apply(this._gridSettings, this._resolveDrawGridOption(item));
			}, this);
			return this;
		},

		_resolveDrawGridOption: function (opt) {

			var namespace = this.constructor.gridPatterns;
			if (joint.util.isString(opt) && Array.isArray(namespace[opt])) {
				return namespace[opt].map(function (item) {
					return joint.util.assign({}, item);
				});
			}

			var options = opt || { args: [{}] };
			var isArray = Array.isArray(options);
			var name = options.name;

			if (!isArray && !name && !options.markup) {
				name = 'dot';
			}

			if (name && Array.isArray(namespace[name])) {
				var pattern = namespace[name].map(function (item) {
					return joint.util.assign({}, item);
				});

				var args = Array.isArray(options.args) ? options.args : [options.args || {}];

				joint.util.defaults(args[0], joint.util.omit(opt, 'args'));
				for (var i = 0; i < args.length; i++) {
					if (pattern[i]) {
						joint.util.assign(pattern[i], args[i]);
					}
				}
				return pattern;
			}

			return isArray ? options : [options];
		},

		drawGrid: function (opt) {

			var gridSize = this.options.gridSize;
			if (gridSize <= 1) {
				return this.clearGrid();
			}

			var localOptions = Array.isArray(opt) ? opt : [opt];

			var ctm = this.matrix();
			var refs = this._getGriRefs();

			this._gridSettings.forEach(function (gridLayerSetting, index) {

				var id = 'pattern_' + index;
				var options = joint.util.merge(gridLayerSetting, localOptions[index], {
					sx: ctm.a || 1,
					sy: ctm.d || 1,
					ox: ctm.e || 0,
					oy: ctm.f || 0
				});

				options.width = gridSize * (ctm.a || 1) * (options.scaleFactor || 1);
				options.height = gridSize * (ctm.d || 1) * (options.scaleFactor || 1);

				if (!refs.exist(id)) {
					refs.add(id, V('pattern', { id: id, patternUnits: 'userSpaceOnUse' }, V(options.markup)));
				}

				var patternDefVel = refs.get(id);

				if (joint.util.isFunction(options.update)) {
					options.update(patternDefVel.node.childNodes[0], options);
				}

				var x = options.ox % options.width;
				if (x < 0) x += options.width;

				var y = options.oy % options.height;
				if (y < 0) y += options.height;

				patternDefVel.attr({
					x: x,
					y: y,
					width: options.width,
					height: options.height
				});
			});

			var patternUri = new XMLSerializer().serializeToString(refs.root.node);
			patternUri = 'url(data:image/svg+xml;base64,' + btoa(patternUri) + ')';

			this.$grid.css('backgroundImage', patternUri);

			return this;
		},

		updateBackgroundImage: function (opt) {

			opt = opt || {};

			var backgroundPosition = opt.position || 'center';
			var backgroundSize = opt.size || 'auto auto';

			var currentScale = this.scale();
			var currentTranslate = this.translate();

			// backgroundPosition
			if (joint.util.isObject(backgroundPosition)) {
				var x = currentTranslate.tx + (currentScale.sx * (backgroundPosition.x || 0));
				var y = currentTranslate.ty + (currentScale.sy * (backgroundPosition.y || 0));
				backgroundPosition = x + 'px ' + y + 'px';
			}

			// backgroundSize
			if (joint.util.isObject(backgroundSize)) {
				backgroundSize = g.rect(backgroundSize).scale(currentScale.sx, currentScale.sy);
				backgroundSize = backgroundSize.width + 'px ' + backgroundSize.height + 'px';
			}

			this.$background.css({
				backgroundSize: backgroundSize,
				backgroundPosition: backgroundPosition
			});
		},

		drawBackgroundImage: function (img, opt) {

			// Clear the background image if no image provided
			if (!(img instanceof HTMLImageElement)) {
				this.$background.css('backgroundImage', '');
				return;
			}

			opt = opt || {};

			var backgroundImage;
			var backgroundSize = opt.size;
			var backgroundRepeat = opt.repeat || 'no-repeat';
			var backgroundOpacity = opt.opacity || 1;
			var backgroundQuality = Math.abs(opt.quality) || 1;
			var backgroundPattern = this.constructor.backgroundPatterns[joint.util.camelCase(backgroundRepeat)];

			if (joint.util.isFunction(backgroundPattern)) {
				// 'flip-x', 'flip-y', 'flip-xy', 'watermark' and custom
				img.width *= backgroundQuality;
				img.height *= backgroundQuality;
				var canvas = backgroundPattern(img, opt);
				if (!(canvas instanceof HTMLCanvasElement)) {
					throw new Error('dia.Paper: background pattern must return an HTML Canvas instance');
				}

				backgroundImage = canvas.toDataURL('image/png');
				backgroundRepeat = 'repeat';
				if (joint.util.isObject(backgroundSize)) {
					// recalculate the tile size if an object passed in
					backgroundSize.width *= canvas.width / img.width;
					backgroundSize.height *= canvas.height / img.height;
				} else if (backgroundSize === undefined) {
					// calcule the tile size if no provided
					opt.size = {
						width: canvas.width / backgroundQuality,
						height: canvas.height / backgroundQuality
					};
				}
			} else {
				// backgroundRepeat:
				// no-repeat', 'round', 'space', 'repeat', 'repeat-x', 'repeat-y'
				backgroundImage = img.src;
				if (backgroundSize === undefined) {
					// pass the image size for  the backgroundSize if no size provided
					opt.size = {
						width: img.width,
						height: img.height
					};
				}
			}

			this.$background.css({
				opacity: backgroundOpacity,
				backgroundRepeat: backgroundRepeat,
				backgroundImage: 'url(' + backgroundImage + ')'
			});

			this.updateBackgroundImage(opt);
		},

		updateBackgroundColor: function (color) {

			this.$el.css('backgroundColor', color || '');
		},

		drawBackground: function (opt) {

			opt = opt || {};

			this.updateBackgroundColor(opt.color);

			if (opt.image) {
				opt = this._background = joint.util.cloneDeep(opt);
				var img = document.createElement('img');
				img.onload = this.drawBackgroundImage.bind(this, img, opt);
				img.src = opt.image;
			} else {
				this.drawBackgroundImage(null);
				this._background = null;
			}

			return this;
		},

		setInteractivity: function (value) {

			this.options.interactive = value;

			joint.util.invoke(this._views, 'setInteractivity', value);
		},

		// Paper Defs

		isDefined: function (defId) {
			return !!this.svg.getElementById(defId);
		},

		defineFilter: function (filter) {

			if (!joint.util.isObject(filter)) {
				throw new TypeError('dia.Paper: defineFilter() requires 1. argument to be an object.');
			}

			var filterId = filter.id;
			var name = filter.name;
			// Generate a hash code from the stringified filter definition. This gives us
			// a unique filter ID for different definitions.
			if (!filterId) {
				filterId = name + this.svg.id + joint.util.hashCode(JSON.stringify(filter));
			}
			// If the filter already exists in the document,
			// we're done and we can just use it (reference it using `url()`).
			// If not, create one.
			if (!this.isDefined(filterId)) {

				var namespace = joint.util.filter;
				var filterSVGString = namespace[name] && namespace[name](filter.args || {});
				if (!filterSVGString) {
					throw new Error('Non-existing filter ' + name);
				}

				// Set the filter area to be 3x the bounding box of the cell
				// and center the filter around the cell.
				var filterAttrs = joint.util.assign({
					filterUnits: 'objectBoundingBox',
					x: -1,
					y: -1,
					width: 3,
					height: 3
				}, filter.attrs, {
						id: filterId
					});

				V(filterSVGString, filterAttrs).appendTo(this.defs);
			}

			return filterId;
		},

		defineGradient: function (gradient) {

			if (!joint.util.isObject(gradient)) {
				throw new TypeError('dia.Paper: defineGradient() requires 1. argument to be an object.');
			}

			var gradientId = gradient.id;
			var type = gradient.type;
			var stops = gradient.stops;
			// Generate a hash code from the stringified filter definition. This gives us
			// a unique filter ID for different definitions.
			if (!gradientId) {
				gradientId = type + this.svg.id + joint.util.hashCode(JSON.stringify(gradient));
			}
			// If the gradient already exists in the document,
			// we're done and we can just use it (reference it using `url()`).
			// If not, create one.
			if (!this.isDefined(gradientId)) {

				var stopTemplate = joint.util.template('<stop offset="${offset}" stop-color="${color}" stop-opacity="${opacity}"/>');
				var gradientStopsStrings = joint.util.toArray(stops).map(function (stop) {
					return stopTemplate({
						offset: stop.offset,
						color: stop.color,
						opacity: Number.isFinite(stop.opacity) ? stop.opacity : 1
					});
				});

				var gradientSVGString = [
					'<' + type + '>',
					gradientStopsStrings.join(''),
					'</' + type + '>'
				].join('');

				var gradientAttrs = joint.util.assign({ id: gradientId }, gradient.attrs);

				V(gradientSVGString, gradientAttrs).appendTo(this.defs);
			}

			return gradientId;
		},

		defineMarker: function (marker) {

			if (!joint.util.isObject(marker)) {
				throw new TypeError('dia.Paper: defineMarker() requires 1. argument to be an object.');
			}

			var markerId = marker.id;

			// Generate a hash code from the stringified filter definition. This gives us
			// a unique filter ID for different definitions.
			if (!markerId) {
				markerId = this.svg.id + joint.util.hashCode(JSON.stringify(marker));
			}

			if (!this.isDefined(markerId)) {

				var attrs = joint.util.omit(marker, 'type', 'userSpaceOnUse');
				var pathMarker = V('marker', {
					id: markerId,
					orient: 'auto',
					overflow: 'visible',
					markerUnits: marker.markerUnits || 'userSpaceOnUse'
				}, [
						V(marker.type || 'path', attrs)
					]);

				pathMarker.appendTo(this.defs);
			}

			return markerId;
		}

	}, {

			backgroundPatterns: {

				flipXy: function (img) {
					// d b
					// q p

					var canvas = document.createElement('canvas');
					var imgWidth = img.width;
					var imgHeight = img.height;

					canvas.width = 2 * imgWidth;
					canvas.height = 2 * imgHeight;

					var ctx = canvas.getContext('2d');
					// top-left image
					ctx.drawImage(img, 0, 0, imgWidth, imgHeight);
					// xy-flipped bottom-right image
					ctx.setTransform(-1, 0, 0, -1, canvas.width, canvas.height);
					ctx.drawImage(img, 0, 0, imgWidth, imgHeight);
					// x-flipped top-right image
					ctx.setTransform(-1, 0, 0, 1, canvas.width, 0);
					ctx.drawImage(img, 0, 0, imgWidth, imgHeight);
					// y-flipped bottom-left image
					ctx.setTransform(1, 0, 0, -1, 0, canvas.height);
					ctx.drawImage(img, 0, 0, imgWidth, imgHeight);

					return canvas;
				},

				flipX: function (img) {
					// d b
					// d b

					var canvas = document.createElement('canvas');
					var imgWidth = img.width;
					var imgHeight = img.height;

					canvas.width = imgWidth * 2;
					canvas.height = imgHeight;

					var ctx = canvas.getContext('2d');
					// left image
					ctx.drawImage(img, 0, 0, imgWidth, imgHeight);
					// flipped right image
					ctx.translate(2 * imgWidth, 0);
					ctx.scale(-1, 1);
					ctx.drawImage(img, 0, 0, imgWidth, imgHeight);

					return canvas;
				},

				flipY: function (img) {
					// d d
					// q q

					var canvas = document.createElement('canvas');
					var imgWidth = img.width;
					var imgHeight = img.height;

					canvas.width = imgWidth;
					canvas.height = imgHeight * 2;

					var ctx = canvas.getContext('2d');
					// top image
					ctx.drawImage(img, 0, 0, imgWidth, imgHeight);
					// flipped bottom image
					ctx.translate(0, 2 * imgHeight);
					ctx.scale(1, -1);
					ctx.drawImage(img, 0, 0, imgWidth, imgHeight);

					return canvas;
				},

				watermark: function (img, opt) {
					//   d
					// d

					opt = opt || {};

					var imgWidth = img.width;
					var imgHeight = img.height;

					var canvas = document.createElement('canvas');
					canvas.width = imgWidth * 3;
					canvas.height = imgHeight * 3;

					var ctx = canvas.getContext('2d');
					var angle = joint.util.isNumber(opt.watermarkAngle) ? -opt.watermarkAngle : -20;
					var radians = g.toRad(angle);
					var stepX = canvas.width / 4;
					var stepY = canvas.height / 4;

					for (var i = 0; i < 4; i++) {
						for (var j = 0; j < 4; j++) {
							if ((i + j) % 2 > 0) {
								// reset the current transformations
								ctx.setTransform(1, 0, 0, 1, (2 * i - 1) * stepX, (2 * j - 1) * stepY);
								ctx.rotate(radians);
								ctx.drawImage(img, -imgWidth / 2, -imgHeight / 2, imgWidth, imgHeight);
							}
						}
					}

					return canvas;
				}
			},

			gridPatterns: {
				dot: [{
					color: '#AAAAAA',
					thickness: 1,
					markup: 'rect',
					update: function (el, opt) {
						V(el).attr({
							width: opt.thickness * opt.sx,
							height: opt.thickness * opt.sy,
							fill: opt.color
						});
					}
				}],
				fixedDot: [{
					color: '#AAAAAA',
					thickness: 1,
					markup: 'rect',
					update: function (el, opt) {
						var size = opt.sx <= 1 ? opt.thickness * opt.sx : opt.thickness;
						V(el).attr({ width: size, height: size, fill: opt.color });
					}
				}],
				mesh: [{
					color: '#AAAAAA',
					thickness: 1,
					markup: 'path',
					update: function (el, opt) {

						var d;
						var width = opt.width;
						var height = opt.height;
						var thickness = opt.thickness;

						if (width - thickness >= 0 && height - thickness >= 0) {
							d = ['M', width, 0, 'H0 M0 0 V0', height].join(' ');
						} else {
							d = 'M 0 0 0 0';
						}

						V(el).attr({ 'd': d, stroke: opt.color, 'stroke-width': opt.thickness });
					}
				}],
				doubleMesh: [{
					color: '#AAAAAA',
					thickness: 1,
					markup: 'path',
					update: function (el, opt) {

						var d;
						var width = opt.width;
						var height = opt.height;
						var thickness = opt.thickness;

						if (width - thickness >= 0 && height - thickness >= 0) {
							d = ['M', width, 0, 'H0 M0 0 V0', height].join(' ');
						} else {
							d = 'M 0 0 0 0';
						}

						V(el).attr({ 'd': d, stroke: opt.color, 'stroke-width': opt.thickness });
					}
				}, {
					color: '#000000',
					thickness: 3,
					scaleFactor: 4,
					markup: 'path',
					update: function (el, opt) {

						var d;
						var width = opt.width;
						var height = opt.height;
						var thickness = opt.thickness;

						if (width - thickness >= 0 && height - thickness >= 0) {
							d = ['M', width, 0, 'H0 M0 0 V0', height].join(' ');
						} else {
							d = 'M 0 0 0 0';
						}

						V(el).attr({ 'd': d, stroke: opt.color, 'stroke-width': opt.thickness });
					}
				}]
			}
		});

	(function (joint, _, util) {

		var PortData = function (data) {

			var clonedData = util.cloneDeep(data) || {};
			this.ports = [];
			this.groups = {};
			this.portLayoutNamespace = joint.layout.Port;
			this.portLabelLayoutNamespace = joint.layout.PortLabel;

			this._init(clonedData);
		};

		PortData.prototype = {

			getPorts: function () {
				return this.ports;
			},

			getGroup: function (name) {
				return this.groups[name] || {};
			},

			getPortsByGroup: function (groupName) {

				return this.ports.filter(function (port) {
					return port.group === groupName;
				});
			},

			getGroupPortsMetrics: function (groupName, elBBox) {

				var group = this.getGroup(groupName);
				var ports = this.getPortsByGroup(groupName);

				var groupPosition = group.position || {};
				var groupPositionName = groupPosition.name;
				var namespace = this.portLayoutNamespace;
				if (!namespace[groupPositionName]) {
					groupPositionName = 'left';
				}

				var groupArgs = groupPosition.args || {};
				var portsArgs = ports.map(function (port) {
					return port && port.position && port.position.args;
				});
				var groupPortTransformations = namespace[groupPositionName](portsArgs, elBBox, groupArgs);

				var accumulator = {
					ports: ports,
					result: []
				};

				util.toArray(groupPortTransformations).reduce(function (res, portTransformation, index) {
					var port = res.ports[index];
					res.result.push({
						portId: port.id,
						portTransformation: portTransformation,
						labelTransformation: this._getPortLabelLayout(port, g.Point(portTransformation), elBBox),
						portAttrs: port.attrs,
						portSize: port.size,
						labelSize: port.label.size
					});
					return res;
				}.bind(this), accumulator);

				return accumulator.result;
			},

			_getPortLabelLayout: function (port, portPosition, elBBox) {

				var namespace = this.portLabelLayoutNamespace;
				var labelPosition = port.label.position.name || 'left';

				if (namespace[labelPosition]) {
					return namespace[labelPosition](portPosition, elBBox, port.label.position.args);
				}

				return null;
			},

			_init: function (data) {

				// prepare groups
				if (util.isObject(data.groups)) {
					var groups = Object.keys(data.groups);
					for (var i = 0, n = groups.length; i < n; i++) {
						var key = groups[i];
						this.groups[key] = this._evaluateGroup(data.groups[key]);
					}
				}

				// prepare ports
				var ports = util.toArray(data.items);
				for (var j = 0, m = ports.length; j < m; j++) {
					this.ports.push(this._evaluatePort(ports[j]));
				}
			},

			_evaluateGroup: function (group) {

				return util.merge(group, {
					position: this._getPosition(group.position, true),
					label: this._getLabel(group, true)
				});
			},

			_evaluatePort: function (port) {

				var evaluated = util.assign({}, port);

				var group = this.getGroup(port.group);

				evaluated.markup = evaluated.markup || group.markup;
				evaluated.attrs = util.merge({}, group.attrs, evaluated.attrs);
				evaluated.position = this._createPositionNode(group, evaluated);
				evaluated.label = util.merge({}, group.label, this._getLabel(evaluated));
				evaluated.z = this._getZIndex(group, evaluated);
				evaluated.size = util.assign({}, group.size, evaluated.size);

				return evaluated;
			},

			_getZIndex: function (group, port) {

				if (util.isNumber(port.z)) {
					return port.z;
				}
				if (util.isNumber(group.z) || group.z === 'auto') {
					return group.z;
				}
				return 'auto';
			},

			_createPositionNode: function (group, port) {

				return util.merge({
					name: 'left',
					args: {}
				}, group.position, { args: port.args });
			},

			_getPosition: function (position, setDefault) {

				var args = {};
				var positionName;

				if (util.isFunction(position)) {
					positionName = 'fn';
					args.fn = position;
				} else if (util.isString(position)) {
					positionName = position;
				} else if (position === undefined) {
					positionName = setDefault ? 'left' : null;
				} else if (Array.isArray(position)) {
					positionName = 'absolute';
					args.x = position[0];
					args.y = position[1];
				} else if (util.isObject(position)) {
					positionName = position.name;
					util.assign(args, position.args);
				}

				var result = { args: args };

				if (positionName) {
					result.name = positionName;
				}
				return result;
			},

			_getLabel: function (item, setDefaults) {

				var label = item.label || {};

				var ret = label;
				ret.position = this._getPosition(label.position, setDefaults);

				return ret;
			}
		};

		util.assign(joint.dia.Element.prototype, {

			_initializePorts: function () {

				this._createPortData();
				this.on('change:ports', function () {

					this._processRemovedPort();
					this._createPortData();
				}, this);
			},

			/**
			 * remove links tied wiht just removed element
			 * @private
			 */
			_processRemovedPort: function () {

				var current = this.get('ports') || {};
				var currentItemsMap = {};

				util.toArray(current.items).forEach(function (item) {
					currentItemsMap[item.id] = true;
				});

				var previous = this.previous('ports') || {};
				var removed = {};

				util.toArray(previous.items).forEach(function (item) {
					if (!currentItemsMap[item.id]) {
						removed[item.id] = true;
					}
				});

				var graph = this.graph;
				if (graph && !util.isEmpty(removed)) {

					var inboundLinks = graph.getConnectedLinks(this, { inbound: true });
					inboundLinks.forEach(function (link) {

						if (removed[link.get('target').port]) link.remove();
					});

					var outboundLinks = graph.getConnectedLinks(this, { outbound: true });
					outboundLinks.forEach(function (link) {

						if (removed[link.get('source').port]) link.remove();
					});
				}
			},

			/**
			 * @returns {boolean}
			 */
			hasPorts: function () {

				return this.prop('ports/items').length > 0;
			},

			/**
			 * @param {string} id
			 * @returns {boolean}
			 */
			hasPort: function (id) {

				return this.getPortIndex(id) !== -1;
			},

			/**
			 * @returns {Array<object>}
			 */
			getPorts: function () {

				return util.cloneDeep(this.prop('ports/items')) || [];
			},

			/**
			 * @param {string} id
			 * @returns {object}
			 */
			getPort: function (id) {

				return util.cloneDeep(util.toArray(this.prop('ports/items')).find(function (port) {
					return port.id && port.id === id;
				}));
			},

			/**
			 * @param {string} groupName
			 * @returns {Object<portId, {x: number, y: number, angle: number}>}
			 */
			getPortsPositions: function (groupName) {

				var portsMetrics = this._portSettingsData.getGroupPortsMetrics(groupName, g.Rect(this.size()));

				return portsMetrics.reduce(function (positions, metrics) {
					var transformation = metrics.portTransformation;
					positions[metrics.portId] = {
						x: transformation.x,
						y: transformation.y,
						angle: transformation.angle
					};
					return positions;
				}, {});
			},

			/**
			 * @param {string|Port} port port id or port
			 * @returns {number} port index
			 */
			getPortIndex: function (port) {

				var id = util.isObject(port) ? port.id : port;

				if (!this._isValidPortId(id)) {
					return -1;
				}

				return util.toArray(this.prop('ports/items')).findIndex(function (item) {
					return item.id === id;
				});
			},

			/**
			 * @param {object} port
			 * @param {object} [opt]
			 * @returns {joint.dia.Element}
			 */
			addPort: function (port, opt) {

				if (!util.isObject(port) || Array.isArray(port)) {
					throw new Error('Element: addPort requires an object.');
				}

				var ports = util.assign([], this.prop('ports/items'));
				ports.push(port);
				this.prop('ports/items', ports, opt);

				return this;
			},

			/**
			 * @param {string} portId
			 * @param {string|object=} path
			 * @param {*=} value
			 * @param {object=} opt
			 * @returns {joint.dia.Element}
			 */
			portProp: function (portId, path, value, opt) {

				var index = this.getPortIndex(portId);

				if (index === -1) {
					throw new Error('Element: unable to find port with id ' + portId);
				}

				var args = Array.prototype.slice.call(arguments, 1);
				if (Array.isArray(path)) {
					args[0] = ['ports', 'items', index].concat(path);
				} else if (util.isString(path)) {

					// Get/set an attribute by a special path syntax that delimits
					// nested objects by the colon character.
					args[0] = ['ports/items/', index, '/', path].join('');

				} else {

					args = ['ports/items/' + index];
					if (util.isPlainObject(path)) {
						args.push(path);
						args.push(value);
					}
				}

				return this.prop.apply(this, args);
			},

			_validatePorts: function () {

				var portsAttr = this.get('ports') || {};

				var errorMessages = [];
				portsAttr = portsAttr || {};
				var ports = util.toArray(portsAttr.items);

				ports.forEach(function (p) {

					if (typeof p !== 'object') {
						errorMessages.push('Element: invalid port ', p);
					}

					if (!this._isValidPortId(p.id)) {
						p.id = util.uuid();
					}
				}, this);

				if (joint.util.uniq(ports, 'id').length !== ports.length) {
					errorMessages.push('Element: found id duplicities in ports.');
				}

				return errorMessages;
			},

			/**
			 * @param {string} id port id
			 * @returns {boolean}
			 * @private
			 */
			_isValidPortId: function (id) {

				return id !== null && id !== undefined && !util.isObject(id);
			},

			addPorts: function (ports, opt) {

				if (ports.length) {
					this.prop('ports/items', util.assign([], this.prop('ports/items')).concat(ports), opt);
				}

				return this;
			},

			removePort: function (port, opt) {

				var options = opt || {};
				var ports = util.assign([], this.prop('ports/items'));

				var index = this.getPortIndex(port);

				if (index !== -1) {
					ports.splice(index, 1);
					options.rewrite = true;
					this.prop('ports/items', ports, options);
				}

				return this;
			},

			/**
			 * @private
			 */
			_createPortData: function () {

				var err = this._validatePorts();

				if (err.length > 0) {
					this.set('ports', this.previous('ports'));
					throw new Error(err.join(' '));
				}

				var prevPortData;

				if (this._portSettingsData) {

					prevPortData = this._portSettingsData.getPorts();
				}

				this._portSettingsData = new PortData(this.get('ports'));

				var curPortData = this._portSettingsData.getPorts();

				if (prevPortData) {

					var added = curPortData.filter(function (item) {
						if (!prevPortData.find(function (prevPort) { return prevPort.id === item.id; })) {
							return item;
						}
					});

					var removed = prevPortData.filter(function (item) {
						if (!curPortData.find(function (curPort) { return curPort.id === item.id; })) {
							return item;
						}
					});

					if (removed.length > 0) {
						this.trigger('ports:remove', this, removed);
					}

					if (added.length > 0) {
						this.trigger('ports:add', this, added);
					}
				}
			}
		});

		util.assign(joint.dia.ElementView.prototype, {

			portContainerMarkup: '<g class="joint-port"/>',
			portMarkup: '<circle class="joint-port-body" r="10" fill="#FFFFFF" stroke="#000000"/>',
			portLabelMarkup: '<text class="joint-port-label" fill="#000000"/>',
			/** @type {Object<string, {portElement: Vectorizer, portLabelElement: Vectorizer}>} */
			_portElementsCache: null,

			/**
			 * @private
			 */
			_initializePorts: function () {

				this._portElementsCache = {};

				this.listenTo(this.model, 'change:ports', function () {

					this._refreshPorts();
				});
			},

			/**
			 * @typedef {Object} Port
			 *
			 * @property {string} id
			 * @property {Object} position
			 * @property {Object} label
			 * @property {Object} attrs
			 * @property {string} markup
			 * @property {string} group
			 */

			/**
			 * @private
			 */
			_refreshPorts: function () {

				this._removePorts();
				this._portElementsCache = {};

				this._renderPorts();
			},

			/**
			 * @private
			 */
			_renderPorts: function () {

				// references to rendered elements without z-index
				var elementReferences = [];
				var elem = this._getContainerElement();

				for (var i = 0, count = elem.node.childNodes.length; i < count; i++) {
					elementReferences.push(elem.node.childNodes[i]);
				}

				var portsGropsByZ = util.groupBy(this.model._portSettingsData.getPorts(), 'z');
				var withoutZKey = 'auto';

				// render non-z first
				util.toArray(portsGropsByZ[withoutZKey]).forEach(function (port) {
					var portElement = this._getPortElement(port);
					elem.append(portElement);
					elementReferences.push(portElement);
				}, this);

				var groupNames = Object.keys(portsGropsByZ);
				for (var k = 0; k < groupNames.length; k++) {
					var groupName = groupNames[k];
					if (groupName !== withoutZKey) {
						var z = parseInt(groupName, 10);
						this._appendPorts(portsGropsByZ[groupName], z, elementReferences);
					}
				}

				this._updatePorts();
			},

			/**
			 * @returns {V}
			 * @private
			 */
			_getContainerElement: function () {

				return this.rotatableNode || this.vel;
			},

			/**
			 * @param {Array<Port>}ports
			 * @param {number} z
			 * @param refs
			 * @private
			 */
			_appendPorts: function (ports, z, refs) {

				var containerElement = this._getContainerElement();
				var portElements = util.toArray(ports).map(this._getPortElement, this);

				if (refs[z] || z < 0) {
					V(refs[Math.max(z, 0)]).before(portElements);
				} else {
					containerElement.append(portElements);
				}
			},

			/**
			 * Try to get element from cache,
			 * @param port
			 * @returns {*}
			 * @private
			 */
			_getPortElement: function (port) {

				if (this._portElementsCache[port.id]) {
					return this._portElementsCache[port.id].portElement;
				}
				return this._createPortElement(port);
			},

			/**
			 * @private
			 */
			_updatePorts: function () {

				// layout ports without group
				this._updatePortGroup(undefined);
				// layout ports with explicit group
				var groupsNames = Object.keys(this.model._portSettingsData.groups);
				groupsNames.forEach(this._updatePortGroup, this);
			},

			/**
			 * @private
			 */
			_removePorts: function () {
				util.invoke(this._portElementsCache, 'portElement.remove');
			},

			/**
			 * @param {Port} port
			 * @returns {V}
			 * @private
			 */
			_createPortElement: function (port) {

				var portContentElement = V(this._getPortMarkup(port));
				var portLabelContentElement = V(this._getPortLabelMarkup(port.label));

				if (portContentElement && portContentElement.length > 1) {
					throw new Error('ElementView: Invalid port markup - multiple roots.');
				}

				portContentElement.attr({
					'port': port.id,
					'port-group': port.group
				});

				var portElement = V(this.portContainerMarkup)
					.append(portContentElement)
					.append(portLabelContentElement);

				this._portElementsCache[port.id] = {
					portElement: portElement,
					portLabelElement: portLabelContentElement
				};

				return portElement;
			},

			/**
			 * @param {string=} groupName
			 * @private
			 */
			_updatePortGroup: function (groupName) {

				var elementBBox = g.Rect(this.model.size());
				var portsMetrics = this.model._portSettingsData.getGroupPortsMetrics(groupName, elementBBox);

				for (var i = 0, n = portsMetrics.length; i < n; i++) {
					var metrics = portsMetrics[i];
					var portId = metrics.portId;
					var cached = this._portElementsCache[portId] || {};
					var portTransformation = metrics.portTransformation;
					this.applyPortTransform(cached.portElement, portTransformation);
					this.updateDOMSubtreeAttributes(cached.portElement.node, metrics.portAttrs, {
						rootBBox: g.Rect(metrics.portSize)
					});

					var labelTransformation = metrics.labelTransformation;
					if (labelTransformation) {
						this.applyPortTransform(cached.portLabelElement, labelTransformation, (-portTransformation.angle || 0));
						this.updateDOMSubtreeAttributes(cached.portLabelElement.node, labelTransformation.attrs, {
							rootBBox: g.Rect(metrics.labelSize)
						});
					}
				}
			},

			/**
			 * @param {Vectorizer} element
			 * @param {{dx:number, dy:number, angle: number, attrs: Object, x:number: y:number}} transformData
			 * @param {number=} initialAngle
			 * @constructor
			 */
			applyPortTransform: function (element, transformData, initialAngle) {

				var matrix = V.createSVGMatrix()
					.rotate(initialAngle || 0)
					.translate(transformData.x || 0, transformData.y || 0)
					.rotate(transformData.angle || 0);

				element.transform(matrix, { absolute: true });
			},

			/**
			 * @param {Port} port
			 * @returns {string}
			 * @private
			 */
			_getPortMarkup: function (port) {

				return port.markup || this.model.get('portMarkup') || this.model.portMarkup || this.portMarkup;
			},

			/**
			 * @param {Object} label
			 * @returns {string}
			 * @private
			 */
			_getPortLabelMarkup: function (label) {

				return label.markup || this.model.get('portLabelMarkup') || this.model.portLabelMarkup || this.portLabelMarkup;
			}

		});
	}(joint, _, joint.util));

	joint.dia.Element.define('basic.Generic', {
		attrs: {
			'.': { fill: '#ffffff', stroke: 'none' }
		}
	});

	joint.shapes.basic.Generic.define('basic.Rect', {
		attrs: {
			'rect': {
				fill: '#ffffff',
				stroke: '#000000',
				width: 100,
				height: 60
			},
			'text': {
				fill: '#000000',
				text: '',
				'font-size': 14,
				'ref-x': .5,
				'ref-y': .5,
				'text-anchor': 'middle',
				'y-alignment': 'middle',
				'font-family': 'Arial, helvetica, sans-serif'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><rect/></g><text/></g>'
		});

	joint.shapes.basic.TextView = joint.dia.ElementView.extend({

		initialize: function () {
			joint.dia.ElementView.prototype.initialize.apply(this, arguments);
			// The element view is not automatically rescaled to fit the model size
			// when the attribute 'attrs' is changed.
			this.listenTo(this.model, 'change:attrs', this.resize);
		}
	});

	joint.shapes.basic.Generic.define('basic.Text', {
		attrs: {
			'text': {
				'font-size': 18,
				fill: '#000000'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><text/></g></g>',
		});

	joint.shapes.basic.Generic.define('basic.Circle', {
		size: { width: 60, height: 60 },
		attrs: {
			'circle': {
				fill: '#ffffff',
				stroke: '#000000',
				r: 30,
				cx: 30,
				cy: 30
			},
			'text': {
				'font-size': 14,
				text: '',
				'text-anchor': 'middle',
				'ref-x': .5,
				'ref-y': .5,
				'y-alignment': 'middle',
				fill: '#000000',
				'font-family': 'Arial, helvetica, sans-serif'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><circle/></g><text/></g>',
		});

	joint.shapes.basic.Generic.define('basic.Ellipse', {
		size: { width: 60, height: 40 },
		attrs: {
			'ellipse': {
				fill: '#ffffff',
				stroke: '#000000',
				rx: 30,
				ry: 20,
				cx: 30,
				cy: 20
			},
			'text': {
				'font-size': 14,
				text: '',
				'text-anchor': 'middle',
				'ref-x': .5,
				'ref-y': .5,
				'y-alignment': 'middle',
				fill: '#000000',
				'font-family': 'Arial, helvetica, sans-serif'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><ellipse/></g><text/></g>',
		});

	joint.shapes.basic.Generic.define('basic.Polygon', {
		size: { width: 60, height: 40 },
		attrs: {
			'polygon': {
				fill: '#ffffff',
				stroke: '#000000'
			},
			'text': {
				'font-size': 14,
				text: '',
				'text-anchor': 'middle',
				'ref-x': .5,
				'ref-dy': 20,
				'y-alignment': 'middle',
				fill: '#000000',
				'font-family': 'Arial, helvetica, sans-serif'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><polygon/></g><text/></g>',
		});

	joint.shapes.basic.Generic.define('basic.Polyline', {
		size: { width: 60, height: 40 },
		attrs: {
			'polyline': {
				fill: '#ffffff',
				stroke: '#000000'
			},
			'text': {
				'font-size': 14,
				text: '',
				'text-anchor': 'middle',
				'ref-x': .5,
				'ref-dy': 20,
				'y-alignment': 'middle',
				fill: '#000000',
				'font-family': 'Arial, helvetica, sans-serif'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><polyline/></g><text/></g>',
		});

	joint.shapes.basic.Generic.define('basic.Image', {
		attrs: {
			'text': {
				'font-size': 14,
				text: '',
				'text-anchor': 'middle',
				'ref-x': .5,
				'ref-dy': 20,
				'y-alignment': 'middle',
				fill: '#000000',
				'font-family': 'Arial, helvetica, sans-serif'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><image/></g><text/></g>',
		});

	joint.shapes.basic.Generic.define('basic.Path', {
		size: { width: 60, height: 60 },
		attrs: {
			'path': {
				fill: '#ffffff',
				stroke: '#000000'
			},
			'text': {
				'font-size': 14,
				text: '',
				'text-anchor': 'middle',
				'ref': 'path',
				'ref-x': .5,
				'ref-dy': 10,
				fill: '#000000',
				'font-family': 'Arial, helvetica, sans-serif'
			}
		}

	}, {
			markup: '<g class="rotatable"><g class="scalable"><path/></g><text/></g>',
		});

	joint.shapes.basic.Path.define('basic.Rhombus', {
		attrs: {
			'path': {
				d: 'M 30 0 L 60 30 30 60 0 30 z'
			},
			'text': {
				'ref-y': .5,
				'ref-dy': null,
				'y-alignment': 'middle'
			}
		}
	});


	/**
	 * @deprecated use the port api instead
	 */
	// PortsModelInterface is a common interface for shapes that have ports. This interface makes it easy
	// to create new shapes with ports functionality. It is assumed that the new shapes have
	// `inPorts` and `outPorts` array properties. Only these properties should be used to set ports.
	// In other words, using this interface, it is no longer recommended to set ports directly through the
	// `attrs` object.

	// Usage:
	// joint.shapes.custom.MyElementWithPorts = joint.shapes.basic.Path.extend(_.extend({}, joint.shapes.basic.PortsModelInterface, {
	//     getPortAttrs: function(portName, index, total, selector, type) {
	//         var attrs = {};
	//         var portClass = 'port' + index;
	//         var portSelector = selector + '>.' + portClass;
	//         var portTextSelector = portSelector + '>text';
	//         var portBodySelector = portSelector + '>.port-body';
	//
	//         attrs[portTextSelector] = { text: portName };
	//         attrs[portBodySelector] = { port: { id: portName || _.uniqueId(type) , type: type } };
	//         attrs[portSelector] = { ref: 'rect', 'ref-y': (index + 0.5) * (1 / total) };
	//
	//         if (selector === '.outPorts') { attrs[portSelector]['ref-dx'] = 0; }
	//
	//         return attrs;
	//     }
	//}));
	joint.shapes.basic.PortsModelInterface = {

		initialize: function () {

			this.updatePortsAttrs();
			this.on('change:inPorts change:outPorts', this.updatePortsAttrs, this);

			// Call the `initialize()` of the parent.
			this.constructor.__super__.constructor.__super__.initialize.apply(this, arguments);
		},

		updatePortsAttrs: function (eventName) {

			if (this._portSelectors) {

				var newAttrs = joint.util.omit(this.get('attrs'), this._portSelectors);
				this.set('attrs', newAttrs, { silent: true });
			}

			// This holds keys to the `attrs` object for all the port specific attribute that
			// we set in this method. This is necessary in order to remove previously set
			// attributes for previous ports.
			this._portSelectors = [];

			var attrs = {};

			joint.util.toArray(this.get('inPorts')).forEach(function (portName, index, ports) {
				var portAttributes = this.getPortAttrs(portName, index, ports.length, '.inPorts', 'in');
				this._portSelectors = this._portSelectors.concat(Object.keys(portAttributes));
				joint.util.assign(attrs, portAttributes);
			}, this);

			joint.util.toArray(('outPorts')).forEach(function (portName, index, ports) {
				var portAttributes = this.getPortAttrs(portName, index, ports.length, '.outPorts', 'out');
				this._portSelectors = this._portSelectors.concat(Object.keys(portAttributes));
				joint.util.assign(attrs, portAttributes);
			}, this);

			// Silently set `attrs` on the cell so that noone knows the attrs have changed. This makes sure
			// that, for example, command manager does not register `change:attrs` command but only
			// the important `change:inPorts`/`change:outPorts` command.
			this.attr(attrs, { silent: true });
			// Manually call the `processPorts()` method that is normally called on `change:attrs` (that we just made silent).
			this.processPorts();
			// Let the outside world (mainly the `ModelView`) know that we're done configuring the `attrs` object.
			this.trigger('process:ports');
		},

		getPortSelector: function (name) {

			var selector = '.inPorts';
			var index = this.get('inPorts').indexOf(name);

			if (index < 0) {
				selector = '.outPorts';
				index = this.get('outPorts').indexOf(name);

				if (index < 0) throw new Error("getPortSelector(): Port doesn't exist.");
			}

			return selector + '>g:nth-child(' + (index + 1) + ')>.port-body';
		}
	};

	joint.shapes.basic.PortsViewInterface = {

		initialize: function () {

			// `Model` emits the `process:ports` whenever it's done configuring the `attrs` object for ports.
			this.listenTo(this.model, 'process:ports', this.update);

			joint.dia.ElementView.prototype.initialize.apply(this, arguments);
		},

		update: function () {

			// First render ports so that `attrs` can be applied to those newly created DOM elements
			// in `ElementView.prototype.update()`.
			this.renderPorts();
			joint.dia.ElementView.prototype.update.apply(this, arguments);
		},

		renderPorts: function () {

			var $inPorts = this.$('.inPorts').empty();
			var $outPorts = this.$('.outPorts').empty();

			var portTemplate = joint.util.template(this.model.portMarkup);

			var ports = this.model.ports || [];
			ports.filter(function (p) {
				return p.type === 'in';
			}).forEach(function (port, index) {

				$inPorts.append(V(portTemplate({ id: index, port: port })).node);
			});

			ports.filter(function (p) {
				return p.type === 'out';
			}).forEach(function (port, index) {

				$outPorts.append(V(portTemplate({ id: index, port: port })).node);
			});
		}
	};

	joint.shapes.basic.Generic.define('basic.TextBlock', {
		// see joint.css for more element styles
		attrs: {
			rect: {
				fill: '#ffffff',
				stroke: '#000000',
				width: 80,
				height: 100
			},
			text: {
				fill: '#000000',
				'font-size': 14,
				'font-family': 'Arial, helvetica, sans-serif'
			},
			'.content': {
				text: '',
				'ref-x': .5,
				'ref-y': .5,
				'y-alignment': 'middle',
				'x-alignment': 'middle'
			}
		},

		content: ''
	}, {
			markup: [
				'<g class="rotatable">',
				'<g class="scalable"><rect/></g>',
				joint.env.test('svgforeignobject') ? '<foreignObject class="fobj"><body xmlns="http://www.w3.org/1999/xhtml"><div class="content"/></body></foreignObject>' : '<text class="content"/>',
				'</g>'
			].join(''),

			initialize: function () {

				this.listenTo(this, 'change:size', this.updateSize);
				this.listenTo(this, 'change:content', this.updateContent);
				this.updateSize(this, this.get('size'));
				this.updateContent(this, this.get('content'));
				joint.shapes.basic.Generic.prototype.initialize.apply(this, arguments);
			},

			updateSize: function (cell, size) {

				// Selector `foreignObject' doesn't work accross all browsers, we'r using class selector instead.
				// We have to clone size as we don't want attributes.div.style to be same object as attributes.size.
				this.attr({
					'.fobj': joint.util.assign({}, size),
					div: {
						style: joint.util.assign({}, size)
					}
				});
			},

			updateContent: function (cell, content) {

				if (joint.env.test('svgforeignobject')) {

					// Content element is a <div> element.
					this.attr({
						'.content': {
							html: content
						}
					});

				} else {

					// Content element is a <text> element.
					// SVG elements don't have innerHTML attribute.
					this.attr({
						'.content': {
							text: content
						}
					});
				}
			},

			// Here for backwards compatibility:
			setForeignObjectSize: function () {

				this.updateSize.apply(this, arguments);
			},

			// Here for backwards compatibility:
			setDivContent: function () {

				this.updateContent.apply(this, arguments);
			}
		});

	// TextBlockView implements the fallback for IE when no foreignObject exists and
	// the text needs to be manually broken.
	joint.shapes.basic.TextBlockView = joint.dia.ElementView.extend({

		initialize: function () {

			joint.dia.ElementView.prototype.initialize.apply(this, arguments);

			// Keep this for backwards compatibility:
			this.noSVGForeignObjectElement = !joint.env.test('svgforeignobject');

			if (!joint.env.test('svgforeignobject')) {

				this.listenTo(this.model, 'change:content change:size', function (cell) {
					// avoiding pass of extra paramters
					this.updateContent(cell);
				});
			}
		},

		update: function (cell, renderingOnlyAttrs) {

			var model = this.model;

			if (!joint.env.test('svgforeignobject')) {

				// Update everything but the content first.
				var noTextAttrs = joint.util.omit(renderingOnlyAttrs || model.get('attrs'), '.content');
				joint.dia.ElementView.prototype.update.call(this, model, noTextAttrs);

				if (!renderingOnlyAttrs || joint.util.has(renderingOnlyAttrs, '.content')) {
					// Update the content itself.
					this.updateContent(model, renderingOnlyAttrs);
				}

			} else {

				joint.dia.ElementView.prototype.update.call(this, model, renderingOnlyAttrs);
			}
		},

		updateContent: function (cell, renderingOnlyAttrs) {

			// Create copy of the text attributes
			var textAttrs = joint.util.merge({}, (renderingOnlyAttrs || cell.get('attrs'))['.content']);

			textAttrs = joint.util.omit(textAttrs, 'text');

			// Break the content to fit the element size taking into account the attributes
			// set on the model.
			var text = joint.util.breakText(cell.get('content'), cell.get('size'), textAttrs, {
				// measuring sandbox svg document
				svgDocument: this.paper.svg
			});

			// Create a new attrs with same structure as the model attrs { text: { *textAttributes* }}
			var attrs = joint.util.setByPath({}, '.content', textAttrs, '/');

			// Replace text attribute with the one we just processed.
			attrs['.content'].text = text;

			// Update the view using renderingOnlyAttributes parameter.
			joint.dia.ElementView.prototype.update.call(this, cell, attrs);
		}
	});

	joint.routers.manhattan = (function (g, _, joint, util) {

		'use strict';

		var config = {

			// size of the step to find a route
			step: 10,

			// use of the perpendicular linkView option to connect center of element with first vertex
			perpendicular: true,

			// should be source or target not to be consider as an obstacle
			excludeEnds: [], // 'source', 'target'

			// should be any element with a certain type not to be consider as an obstacle
			excludeTypes: ['basic.Text'],

			// if number of route finding loops exceed the maximum, stops searching and returns
			// fallback route
			maximumLoops: 2000,

			// possible starting directions from an element
			startDirections: ['left', 'right', 'top', 'bottom'],

			// possible ending directions to an element
			endDirections: ['left', 'right', 'top', 'bottom'],

			// specify directions above
			directionMap: {
				right: { x: 1, y: 0 },
				bottom: { x: 0, y: 1 },
				left: { x: -1, y: 0 },
				top: { x: 0, y: -1 }
			},

			// maximum change of the direction
			maxAllowedDirectionChange: 90,

			// padding applied on the element bounding boxes
			paddingBox: function () {

				var step = this.step;

				return {
					x: -step,
					y: -step,
					width: 2 * step,
					height: 2 * step
				};
			},

			// an array of directions to find next points on the route
			directions: function () {

				var step = this.step;

				return [
					{ offsetX: step, offsetY: 0, cost: step },
					{ offsetX: 0, offsetY: step, cost: step },
					{ offsetX: -step, offsetY: 0, cost: step },
					{ offsetX: 0, offsetY: -step, cost: step }
				];
			},

			// a penalty received for direction change
			penalties: function () {

				return {
					0: 0,
					45: this.step / 2,
					90: this.step / 2
				};
			},

			// * Deprecated *
			// a simple route used in situations, when main routing method fails
			// (exceed loops, inaccessible).
			/* i.e.
			  function(from, to, opts) {
				// Find an orthogonal route ignoring obstacles.
				var point = ((opts.previousDirAngle || 0) % 180 === 0)
						? g.point(from.x, to.y)
						: g.point(to.x, from.y);
				return [point, to];
			  },
			*/
			fallbackRoute: function () {
				return null;
			},

			// if a function is provided, it's used to route the link while dragging an end
			// i.e. function(from, to, opts) { return []; }
			draggingRoute: null
		};

		// Map of obstacles
		// Helper structure to identify whether a point lies in an obstacle.
		function ObstacleMap(opt) {

			this.map = {};
			this.options = opt;
			// tells how to divide the paper when creating the elements map
			this.mapGridSize = 100;
		}

		ObstacleMap.prototype.build = function (graph, link) {

			var opt = this.options;


			// source or target element could be excluded from set of obstacles
			var excludedEnds = util.toArray(opt.excludeEnds).reduce(function (res, item) {
				var end = link.get(item);
				if (end) {
					var cell = graph.getCell(end.id);
					if (cell) {
						res.push(cell);
					}
				}
				return res;
			}, []);

			// Exclude any embedded elements from the source and the target element.
			var excludedAncestors = [];

			var source = graph.getCell(link.get('source').id);
			if (source) {
				excludedAncestors = util.union(excludedAncestors, source.getAncestors().map(function (cell) { return cell.id }));
			}

			var target = graph.getCell(link.get('target').id);
			if (target) {
				excludedAncestors = util.union(excludedAncestors, target.getAncestors().map(function (cell) { return cell.id }));
			}

			// builds a map of all elements for quicker obstacle queries (i.e. is a point contained
			// in any obstacle?) (a simplified grid search)
			// The paper is divided to smaller cells, where each of them holds an information which
			// elements belong to it. When we query whether a point is in an obstacle we don't need
			// to go through all obstacles, we check only those in a particular cell.
			var mapGridSize = this.mapGridSize;

			graph.getElements().reduce(function (map, element) {

				var isExcludedType = util.toArray(opt.excludeTypes).includes(element.get('type'));
				var isExcludedEnd = excludedEnds.find(function (excluded) { return excluded.id === element.id });
				var isExcludedAncestor = excludedAncestors.includes(element.id);

				var isExcluded = isExcludedType || isExcludedEnd || isExcludedAncestor;
				if (!isExcluded) {
					var bBox = element.getBBox().moveAndExpand(opt.paddingBox);

					var origin = bBox.origin().snapToGrid(mapGridSize);
					var corner = bBox.corner().snapToGrid(mapGridSize);

					for (var x = origin.x; x <= corner.x; x += mapGridSize) {
						for (var y = origin.y; y <= corner.y; y += mapGridSize) {
							var gridKey = x + '@' + y;
							map[gridKey] = map[gridKey] || [];
							map[gridKey].push(bBox);
						}
					}
				}
				return map;
			}, this.map);

			return this;
		};

		ObstacleMap.prototype.isPointAccessible = function (point) {

			var mapKey = point.clone().snapToGrid(this.mapGridSize).toString();

			return util.toArray(this.map[mapKey]).every(function (obstacle) {
				return !obstacle.containsPoint(point);
			});
		};

		// Sorted Set
		// Set of items sorted by given value.
		function SortedSet() {
			this.items = [];
			this.hash = {};
			this.values = {};
			this.OPEN = 1;
			this.CLOSE = 2;
		}

		SortedSet.prototype.add = function (item, value) {

			if (this.hash[item]) {
				// item removal
				this.items.splice(this.items.indexOf(item), 1);
			} else {
				this.hash[item] = this.OPEN;
			}

			this.values[item] = value;

			var index = joint.util.sortedIndex(this.items, item, function (i) {
				return this.values[i];
			}.bind(this));

			this.items.splice(index, 0, item);
		};

		SortedSet.prototype.remove = function (item) {
			this.hash[item] = this.CLOSE;
		};

		SortedSet.prototype.isOpen = function (item) {
			return this.hash[item] === this.OPEN;
		};

		SortedSet.prototype.isClose = function (item) {
			return this.hash[item] === this.CLOSE;
		};

		SortedSet.prototype.isEmpty = function () {
			return this.items.length === 0;
		};

		SortedSet.prototype.pop = function () {
			var item = this.items.shift();
			this.remove(item);
			return item;
		};

		function normalizePoint(point) {
			return g.point(
				point.x === 0 ? 0 : Math.abs(point.x) / point.x,
				point.y === 0 ? 0 : Math.abs(point.y) / point.y
			);
		}

		// reconstructs a route by concating points with their parents
		function reconstructRoute(parents, point, startCenter, endCenter) {

			var route = [];
			var prevDiff = normalizePoint(endCenter.difference(point));
			var current = point;
			var parent;

			while ((parent = parents[current])) {

				var diff = normalizePoint(current.difference(parent));

				if (!diff.equals(prevDiff)) {

					route.unshift(current);
					prevDiff = diff;
				}

				current = parent;
			}

			var startDiff = normalizePoint(g.point(current).difference(startCenter));
			if (!startDiff.equals(prevDiff)) {
				route.unshift(current);
			}

			return route;
		}

		// find points around the rectangle taking given directions in the account
		function getRectPoints(bbox, directionList, opt) {

			var step = opt.step;
			var center = bbox.center();
			var keys = util.isObject(opt.directionMap) ? Object.keys(opt.directionMap) : [];
			var dirLis = util.toArray(directionList);
			return keys.reduce(function (res, key) {

				if (dirLis.includes(key)) {

					var direction = opt.directionMap[key];

					var x = direction.x * bbox.width / 2;
					var y = direction.y * bbox.height / 2;

					var point = center.clone().offset(x, y);

					if (bbox.containsPoint(point)) {

						point.offset(direction.x * step, direction.y * step);
					}

					res.push(point.snapToGrid(step));
				}
				return res;

			}, []);
		}

		// returns a direction index from start point to end point
		function getDirectionAngle(start, end, dirLen) {

			var q = 360 / dirLen;
			return Math.floor(g.normalizeAngle(start.theta(end) + q / 2) / q) * q;
		}

		function getDirectionChange(angle1, angle2) {

			var dirChange = Math.abs(angle1 - angle2);
			return dirChange > 180 ? 360 - dirChange : dirChange;
		}

		// heurestic method to determine the distance between two points
		function estimateCost(from, endPoints) {

			var min = Infinity;

			for (var i = 0, len = endPoints.length; i < len; i++) {
				var cost = from.manhattanDistance(endPoints[i]);
				if (cost < min) min = cost;
			}

			return min;
		}

		// finds the route between to points/rectangles implementing A* alghoritm
		function findRoute(start, end, map, opt) {

			var step = opt.step;
			var startPoints, endPoints;
			var startCenter, endCenter;

			// set of points we start pathfinding from
			if (start instanceof g.rect) {
				startPoints = getRectPoints(start, opt.startDirections, opt);
				startCenter = start.center().snapToGrid(step);
			} else {
				startCenter = start.clone().snapToGrid(step);
				startPoints = [startCenter];
			}

			// set of points we want the pathfinding to finish at
			if (end instanceof g.rect) {
				endPoints = getRectPoints(end, opt.endDirections, opt);
				endCenter = end.center().snapToGrid(step);
			} else {
				endCenter = end.clone().snapToGrid(step);
				endPoints = [endCenter];
			}

			// take into account only accessible end points
			startPoints = startPoints.filter(map.isPointAccessible, map);
			endPoints = endPoints.filter(map.isPointAccessible, map);

			// Check if there is a accessible end point.
			// We would have to use a fallback route otherwise.
			if (startPoints.length > 0 && endPoints.length > 0) {

				// The set of tentative points to be evaluated, initially containing the start points.
				var openSet = new SortedSet();
				// Keeps reference to a point that is immediate predecessor of given element.
				var parents = {};
				// Cost from start to a point along best known path.
				var costs = {};

				for (var i = 0, n = startPoints.length; i < n; i++) {
					var point = startPoints[i];

					var key = point.toString();
					openSet.add(key, estimateCost(point, endPoints));
					costs[key] = 0;
				}

				// directions
				var dir, dirChange;
				var dirs = opt.directions;
				var dirLen = dirs.length;
				var loopsRemain = opt.maximumLoops;
				var endPointsKeys = util.invoke(endPoints, 'toString');

				// main route finding loop
				while (!openSet.isEmpty() && loopsRemain > 0) {

					// remove current from the open list
					var currentKey = openSet.pop();
					var currentPoint = g.point(currentKey);
					var currentDist = costs[currentKey];
					var previousDirAngle = currentDirAngle;
					var currentDirAngle = parents[currentKey]
						? getDirectionAngle(parents[currentKey], currentPoint, dirLen)
						: opt.previousDirAngle != null ? opt.previousDirAngle : getDirectionAngle(startCenter, currentPoint, dirLen);

					// Check if we reached any endpoint
					if (endPointsKeys.indexOf(currentKey) >= 0) {
						// We don't want to allow route to enter the end point in opposite direction.
						dirChange = getDirectionChange(currentDirAngle, getDirectionAngle(currentPoint, endCenter, dirLen));
						if (currentPoint.equals(endCenter) || dirChange < 180) {
							opt.previousDirAngle = currentDirAngle;
							return reconstructRoute(parents, currentPoint, startCenter, endCenter);
						}
					}

					// Go over all possible directions and find neighbors.
					for (i = 0; i < dirLen; i++) {

						dir = dirs[i];
						dirChange = getDirectionChange(currentDirAngle, dir.angle);
						// if the direction changed rapidly don't use this point
						// Note that check is relevant only for points with previousDirAngle i.e.
						// any direction is allowed for starting points
						if (previousDirAngle && dirChange > opt.maxAllowedDirectionChange) {
							continue;
						}

						var neighborPoint = currentPoint.clone().offset(dir.offsetX, dir.offsetY);
						var neighborKey = neighborPoint.toString();
						// Closed points from the openSet were already evaluated.
						if (openSet.isClose(neighborKey) || !map.isPointAccessible(neighborPoint)) {
							continue;
						}

						// The current direction is ok to proccess.
						var costFromStart = currentDist + dir.cost + opt.penalties[dirChange];

						if (!openSet.isOpen(neighborKey) || costFromStart < costs[neighborKey]) {
							// neighbor point has not been processed yet or the cost of the path
							// from start is lesser than previously calcluated.
							parents[neighborKey] = currentPoint;
							costs[neighborKey] = costFromStart;
							openSet.add(neighborKey, costFromStart + estimateCost(neighborPoint, endPoints));
						}
					}

					loopsRemain--;
				}
			}

			// no route found ('to' point wasn't either accessible or finding route took
			// way to much calculations)
			return opt.fallbackRoute(startCenter, endCenter, opt);
		}

		// resolve some of the options
		function resolveOptions(opt) {

			opt.directions = util.result(opt, 'directions');
			opt.penalties = util.result(opt, 'penalties');
			opt.paddingBox = util.result(opt, 'paddingBox');

			util.toArray(opt.directions).forEach(function (direction) {

				var point1 = g.point(0, 0);
				var point2 = g.point(direction.offsetX, direction.offsetY);

				direction.angle = g.normalizeAngle(point1.theta(point2));
			});
		}

		// initiation of the route finding
		function router(vertices, opt) {

			resolveOptions(opt);

			// enable/disable linkView perpendicular option
			this.options.perpendicular = !!opt.perpendicular;

			// expand boxes by specific padding
			var sourceBBox = g.rect(this.sourceBBox).moveAndExpand(opt.paddingBox);
			var targetBBox = g.rect(this.targetBBox).moveAndExpand(opt.paddingBox);

			// pathfinding
			var map = (new ObstacleMap(opt)).build(this.paper.model, this.model);
			var oldVertices = util.toArray(vertices).map(g.point);
			var newVertices = [];
			var tailPoint = sourceBBox.center().snapToGrid(opt.step);

			// find a route by concating all partial routes (routes need to go through the vertices)
			// startElement -> vertex[1] -> ... -> vertex[n] -> endElement
			for (var i = 0, len = oldVertices.length; i <= len; i++) {

				var partialRoute = null;

				var from = to || sourceBBox;
				var to = oldVertices[i];

				if (!to) {

					to = targetBBox;

					// 'to' is not a vertex. If the target is a point (i.e. it's not an element), we
					// might use dragging route instead of main routing method if that is enabled.
					var endingAtPoint = !this.model.get('source').id || !this.model.get('target').id;

					if (endingAtPoint && util.isFunction(opt.draggingRoute)) {
						// Make sure we passing points only (not rects).
						var dragFrom = from instanceof g.rect ? from.center() : from;
						partialRoute = opt.draggingRoute(dragFrom, to.origin(), opt);
					}
				}

				// if partial route has not been calculated yet use the main routing method to find one
				partialRoute = partialRoute || findRoute(from, to, map, opt);

				if (partialRoute === null) {
					// The partial route could not be found.
					// use orthogonal (do not avoid elements) route instead.
					if (!util.isFunction(joint.routers.orthogonal)) {
						throw new Error('Manhattan requires the orthogonal router.');
					}
					return joint.routers.orthogonal(vertices, opt, this);
				}

				var leadPoint = partialRoute[0];

				if (leadPoint && leadPoint.equals(tailPoint)) {
					// remove the first point if the previous partial route had the same point as last
					partialRoute.shift();
				}

				tailPoint = partialRoute[partialRoute.length - 1] || tailPoint;

				Array.prototype.push.apply(newVertices, partialRoute);
			}

			return newVertices;
		}

		// public function
		return function (vertices, opt, linkView) {

			return router.call(linkView, vertices, util.assign({}, config, opt));
		};

	})(g, _, joint, joint.util);

	joint.routers.metro = (function (util) {

		if (!util.isFunction(joint.routers.manhattan)) {

			throw new Error('Metro requires the manhattan router.');
		}

		var config = {

			// cost of a diagonal step (calculated if not defined).
			diagonalCost: null,

			// an array of directions to find next points on the route
			directions: function () {

				var step = this.step;
				var diagonalCost = this.diagonalCost || Math.ceil(Math.sqrt(step * step << 1));

				return [
					{ offsetX: step, offsetY: 0, cost: step },
					{ offsetX: step, offsetY: step, cost: diagonalCost },
					{ offsetX: 0, offsetY: step, cost: step },
					{ offsetX: -step, offsetY: step, cost: diagonalCost },
					{ offsetX: -step, offsetY: 0, cost: step },
					{ offsetX: -step, offsetY: -step, cost: diagonalCost },
					{ offsetX: 0, offsetY: -step, cost: step },
					{ offsetX: step, offsetY: -step, cost: diagonalCost }
				];
			},
			maxAllowedDirectionChange: 45,
			// a simple route used in situations, when main routing method fails
			// (exceed loops, inaccessible).
			fallbackRoute: function (from, to, opts) {

				// Find a route which breaks by 45 degrees ignoring all obstacles.

				var theta = from.theta(to);

				var a = { x: to.x, y: from.y };
				var b = { x: from.x, y: to.y };

				if (theta % 180 > 90) {
					var t = a;
					a = b;
					b = t;
				}

				var p1 = (theta % 90) < 45 ? a : b;

				var l1 = g.line(from, p1);

				var alpha = 90 * Math.ceil(theta / 90);

				var p2 = g.point.fromPolar(l1.squaredLength(), g.toRad(alpha + 135), p1);

				var l2 = g.line(to, p2);

				var point = l1.intersection(l2);

				return point ? [point.round(), to] : [to];
			}
		};

		// public function
		return function (vertices, opts, linkView) {

			return joint.routers.manhattan(vertices, util.assign({}, config, opts), linkView);
		};

	})(joint.util);

	// Does not make any changes to vertices.
	// Returns the arguments that are passed to it, unchanged.
	joint.routers.normal = function (vertices, opt, linkView) {

		return vertices;
	};

	// Routes the link always to/from a certain side
	//
	// Arguments:
	//   padding ... gap between the element and the first vertex. :: Default 40.
	//   side ... 'left' | 'right' | 'top' | 'bottom' :: Default 'bottom'.
	//
	joint.routers.oneSide = function (vertices, opt, linkView) {

		var side = opt.side || 'bottom';
		var padding = opt.padding || 40;

		// LinkView contains cached source an target bboxes.
		// Note that those are Geometry rectangle objects.
		var sourceBBox = linkView.sourceBBox;
		var targetBBox = linkView.targetBBox;
		var sourcePoint = sourceBBox.center();
		var targetPoint = targetBBox.center();

		var coordinate, dimension, direction;

		switch (side) {
			case 'bottom':
				direction = 1;
				coordinate = 'y';
				dimension = 'height';
				break;
			case 'top':
				direction = -1;
				coordinate = 'y';
				dimension = 'height';
				break;
			case 'left':
				direction = -1;
				coordinate = 'x';
				dimension = 'width';
				break;
			case 'right':
				direction = 1;
				coordinate = 'x';
				dimension = 'width';
				break;
			default:
				throw new Error('Router: invalid side');
		}

		// move the points from the center of the element to outside of it.
		sourcePoint[coordinate] += direction * (sourceBBox[dimension] / 2 + padding);
		targetPoint[coordinate] += direction * (targetBBox[dimension] / 2 + padding);

		// make link orthogonal (at least the first and last vertex).
		if (direction * (sourcePoint[coordinate] - targetPoint[coordinate]) > 0) {
			targetPoint[coordinate] = sourcePoint[coordinate];
		} else {
			sourcePoint[coordinate] = targetPoint[coordinate];
		}

		return [sourcePoint].concat(vertices, targetPoint);
	};

	joint.routers.orthogonal = (function (util) {

		// bearing -> opposite bearing
		var opposite = {
			N: 'S',
			S: 'N',
			E: 'W',
			W: 'E'
		};

		// bearing -> radians
		var radians = {
			N: -Math.PI / 2 * 3,
			S: -Math.PI / 2,
			E: 0,
			W: Math.PI
		};

		// HELPERS //

		// simple bearing method (calculates only orthogonal cardinals)
		function bearing(from, to) {
			if (from.x == to.x) return from.y > to.y ? 'N' : 'S';
			if (from.y == to.y) return from.x > to.x ? 'W' : 'E';
			return null;
		}

		// returns either width or height of a bbox based on the given bearing
		function boxSize(bbox, brng) {
			return bbox[brng == 'W' || brng == 'E' ? 'width' : 'height'];
		}

		// expands a box by specific value
		function expand(bbox, val) {
			return g.rect(bbox).moveAndExpand({ x: -val, y: -val, width: 2 * val, height: 2 * val });
		}

		// transform point to a rect
		function pointBox(p) {
			return g.rect(p.x, p.y, 0, 0);
		}

		// returns a minimal rect which covers the given boxes
		function boundary(bbox1, bbox2) {

			var x1 = Math.min(bbox1.x, bbox2.x);
			var y1 = Math.min(bbox1.y, bbox2.y);
			var x2 = Math.max(bbox1.x + bbox1.width, bbox2.x + bbox2.width);
			var y2 = Math.max(bbox1.y + bbox1.height, bbox2.y + bbox2.height);

			return g.rect(x1, y1, x2 - x1, y2 - y1);
		}

		// returns a point `p` where lines p,p1 and p,p2 are perpendicular and p is not contained
		// in the given box
		function freeJoin(p1, p2, bbox) {

			var p = g.point(p1.x, p2.y);
			if (bbox.containsPoint(p)) p = g.point(p2.x, p1.y);
			// kept for reference
			// if (bbox.containsPoint(p)) p = null;
			return p;
		}

		// PARTIAL ROUTERS //

		function vertexVertex(from, to, brng) {

			var p1 = g.point(from.x, to.y);
			var p2 = g.point(to.x, from.y);
			var d1 = bearing(from, p1);
			var d2 = bearing(from, p2);
			var xBrng = opposite[brng];

			var p = (d1 == brng || (d1 != xBrng && (d2 == xBrng || d2 != brng))) ? p1 : p2;

			return { points: [p], direction: bearing(p, to) };
		}

		function elementVertex(from, to, fromBBox) {

			var p = freeJoin(from, to, fromBBox);

			return { points: [p], direction: bearing(p, to) };
		}

		function vertexElement(from, to, toBBox, brng) {

			var route = {};

			var pts = [g.point(from.x, to.y), g.point(to.x, from.y)];
			var freePts = pts.filter(function (pt) { return !toBBox.containsPoint(pt); });
			var freeBrngPts = freePts.filter(function (pt) { return bearing(pt, from) != brng; });

			var p;

			if (freeBrngPts.length > 0) {

				// try to pick a point which bears the same direction as the previous segment
				p = freeBrngPts.filter(function (pt) { return bearing(from, pt) == brng; }).pop();
				p = p || freeBrngPts[0];

				route.points = [p];
				route.direction = bearing(p, to);

			} else {

				// Here we found only points which are either contained in the element or they would create
				// a link segment going in opposite direction from the previous one.
				// We take the point inside element and move it outside the element in the direction the
				// route is going. Now we can join this point with the current end (using freeJoin).

				p = util.difference(pts, freePts)[0];

				var p2 = g.point(to).move(p, -boxSize(toBBox, brng) / 2);
				var p1 = freeJoin(p2, from, toBBox);

				route.points = [p1, p2];
				route.direction = bearing(p2, to);
			}

			return route;
		}

		function elementElement(from, to, fromBBox, toBBox) {

			var route = elementVertex(to, from, toBBox);
			var p1 = route.points[0];

			if (fromBBox.containsPoint(p1)) {

				route = elementVertex(from, to, fromBBox);
				var p2 = route.points[0];

				if (toBBox.containsPoint(p2)) {

					var fromBorder = g.point(from).move(p2, -boxSize(fromBBox, bearing(from, p2)) / 2);
					var toBorder = g.point(to).move(p1, -boxSize(toBBox, bearing(to, p1)) / 2);
					var mid = g.line(fromBorder, toBorder).midpoint();

					var startRoute = elementVertex(from, mid, fromBBox);
					var endRoute = vertexVertex(mid, to, startRoute.direction);

					route.points = [startRoute.points[0], endRoute.points[0]];
					route.direction = endRoute.direction;
				}
			}

			return route;
		}

		// Finds route for situations where one of end is inside the other.
		// Typically the route is conduct outside the outer element first and
		// let go back to the inner element.
		function insideElement(from, to, fromBBox, toBBox, brng) {

			var route = {};
			var bndry = expand(boundary(fromBBox, toBBox), 1);

			// start from the point which is closer to the boundary
			var reversed = bndry.center().distance(to) > bndry.center().distance(from);
			var start = reversed ? to : from;
			var end = reversed ? from : to;

			var p1, p2, p3;

			if (brng) {
				// Points on circle with radius equals 'W + H` are always outside the rectangle
				// with width W and height H if the center of that circle is the center of that rectangle.
				p1 = g.point.fromPolar(bndry.width + bndry.height, radians[brng], start);
				p1 = bndry.pointNearestToPoint(p1).move(p1, -1);
			} else {
				p1 = bndry.pointNearestToPoint(start).move(start, 1);
			}

			p2 = freeJoin(p1, end, bndry);

			if (p1.round().equals(p2.round())) {
				p2 = g.point.fromPolar(bndry.width + bndry.height, g.toRad(p1.theta(start)) + Math.PI / 2, end);
				p2 = bndry.pointNearestToPoint(p2).move(end, 1).round();
				p3 = freeJoin(p1, p2, bndry);
				route.points = reversed ? [p2, p3, p1] : [p1, p3, p2];
			} else {
				route.points = reversed ? [p2, p1] : [p1, p2];
			}

			route.direction = reversed ? bearing(p1, to) : bearing(p2, to);

			return route;
		}

		// MAIN ROUTER //

		// Return points that one needs to draw a connection through in order to have a orthogonal link
		// routing from source to target going through `vertices`.
		function findOrthogonalRoute(vertices, opt, linkView) {

			var padding = opt.elementPadding || 20;

			var orthogonalVertices = [];
			var sourceBBox = expand(linkView.sourceBBox, padding);
			var targetBBox = expand(linkView.targetBBox, padding);

			vertices = util.toArray(vertices).map(g.point);
			vertices.unshift(sourceBBox.center());
			vertices.push(targetBBox.center());

			var brng;

			for (var i = 0, max = vertices.length - 1; i < max; i++) {

				var route = null;
				var from = vertices[i];
				var to = vertices[i + 1];
				var isOrthogonal = !!bearing(from, to);

				if (i == 0) {

					if (i + 1 == max) { // route source -> target

						// Expand one of elements by 1px so we detect also situations when they
						// are positioned one next other with no gap between.
						if (sourceBBox.intersect(expand(targetBBox, 1))) {
							route = insideElement(from, to, sourceBBox, targetBBox);
						} else if (!isOrthogonal) {
							route = elementElement(from, to, sourceBBox, targetBBox);
						}

					} else { // route source -> vertex

						if (sourceBBox.containsPoint(to)) {
							route = insideElement(from, to, sourceBBox, expand(pointBox(to), padding));
						} else if (!isOrthogonal) {
							route = elementVertex(from, to, sourceBBox);
						}
					}

				} else if (i + 1 == max) { // route vertex -> target

					var orthogonalLoop = isOrthogonal && bearing(to, from) == brng;

					if (targetBBox.containsPoint(from) || orthogonalLoop) {
						route = insideElement(from, to, expand(pointBox(from), padding), targetBBox, brng);
					} else if (!isOrthogonal) {
						route = vertexElement(from, to, targetBBox, brng);
					}

				} else if (!isOrthogonal) { // route vertex -> vertex
					route = vertexVertex(from, to, brng);
				}

				if (route) {
					Array.prototype.push.apply(orthogonalVertices, route.points);
					brng = route.direction;
				} else {
					// orthogonal route and not looped
					brng = bearing(from, to);
				}

				if (i + 1 < max) {
					orthogonalVertices.push(to);
				}
			}

			return orthogonalVertices;
		}

		return findOrthogonalRoute;

	})(joint.util);

	joint.connectors.normal = function (sourcePoint, targetPoint, vertices) {

		// Construct the `d` attribute of the `<path>` element.
		var d = ['M', sourcePoint.x, sourcePoint.y];

		joint.util.toArray(vertices).forEach(function (vertex) {

			d.push(vertex.x, vertex.y);
		});

		d.push(targetPoint.x, targetPoint.y);

		return d.join(' ');
	};

	joint.connectors.rounded = function (sourcePoint, targetPoint, vertices, opts) {

		opts = opts || {};

		var offset = opts.radius || 10;

		var c1, c2, d1, d2, prev, next;

		// Construct the `d` attribute of the `<path>` element.
		var d = ['M', sourcePoint.x, sourcePoint.y];

		joint.util.toArray(vertices).forEach(function (vertex, index) {

			// the closest vertices
			prev = vertices[index - 1] || sourcePoint;
			next = vertices[index + 1] || targetPoint;

			// a half distance to the closest vertex
			d1 = d2 || g.point(vertex).distance(prev) / 2;
			d2 = g.point(vertex).distance(next) / 2;

			// control points
			c1 = g.point(vertex).move(prev, -Math.min(offset, d1)).round();
			c2 = g.point(vertex).move(next, -Math.min(offset, d2)).round();

			d.push(c1.x, c1.y, 'S', vertex.x, vertex.y, c2.x, c2.y, 'L');
		});

		d.push(targetPoint.x, targetPoint.y);

		return d.join(' ');
	};

	joint.connectors.smooth = function (sourcePoint, targetPoint, vertices) {

		var d;

		if (vertices.length) {

			d = g.bezier.curveThroughPoints([sourcePoint].concat(vertices).concat([targetPoint]));

		} else {
			// if we have no vertices use a default cubic bezier curve, cubic bezier requires
			// two control points. The two control points are both defined with X as mid way
			// between the source and target points. SourceControlPoint Y is equal to sourcePoint Y
			// and targetControlPointY being equal to targetPointY.
			var controlPointX = (sourcePoint.x + targetPoint.x) / 2;

			d = [
				'M', sourcePoint.x, sourcePoint.y,
				'C', controlPointX, sourcePoint.y, controlPointX, targetPoint.y,
				targetPoint.x, targetPoint.y
			];
		}

		return d.join(' ');
	};

	joint.connectors.jumpover = (function (_, g, util) {

		// default size of jump if not specified in options
		var JUMP_SIZE = 5;

		// available jump types
		var JUMP_TYPES = ['arc', 'gap', 'cubic'];

		// takes care of math. error for case when jump is too close to end of line
		var CLOSE_PROXIMITY_PADDING = 1;

		// list of connector types not to jump over.
		var IGNORED_CONNECTORS = ['smooth'];

		/**
		 * Transform start/end and vertices into series of lines
		 * @param {g.point} sourcePoint start point
		 * @param {g.point} targetPoint end point
		 * @param {g.point[]} vertices optional list of vertices
		 * @return {g.line[]} [description]
		 */
		function createLines(sourcePoint, targetPoint, vertices) {
			// make a flattened array of all points
			var points = [].concat(sourcePoint, vertices, targetPoint);
			return points.reduce(function (resultLines, point, idx) {
				// if there is a next point, make a line with it
				var nextPoint = points[idx + 1];
				if (nextPoint != null) {
					resultLines[idx] = g.line(point, nextPoint);
				}
				return resultLines;
			}, []);
		}

		function setupUpdating(jumpOverLinkView) {
			var updateList = jumpOverLinkView.paper._jumpOverUpdateList;

			// first time setup for this paper
			if (updateList == null) {
				updateList = jumpOverLinkView.paper._jumpOverUpdateList = [];
				jumpOverLinkView.paper.on('cell:pointerup', updateJumpOver);
				jumpOverLinkView.paper.model.on('reset', function () {
					updateList = jumpOverLinkView.paper._jumpOverUpdateList = [];
				});
			}

			// add this link to a list so it can be updated when some other link is updated
			if (updateList.indexOf(jumpOverLinkView) < 0) {
				updateList.push(jumpOverLinkView);

				// watch for change of connector type or removal of link itself
				// to remove the link from a list of jump over connectors
				jumpOverLinkView.listenToOnce(jumpOverLinkView.model, 'change:connector remove', function () {
					updateList.splice(updateList.indexOf(jumpOverLinkView), 1);
				});
			}
		}

		/**
		 * Handler for a batch:stop event to force
		 * update of all registered links with jump over connector
		 * @param {object} batchEvent optional object with info about batch
		 */
		function updateJumpOver() {
			var updateList = this._jumpOverUpdateList;
			for (var i = 0; i < updateList.length; i++) {
				updateList[i].update();
			}
		}

		/**
		 * Utility function to collect all intersection poinst of a single
		 * line against group of other lines.
		 * @param {g.line} line where to find points
		 * @param {g.line[]} crossCheckLines lines to cross
		 * @return {g.point[]} list of intersection points
		 */
		function findLineIntersections(line, crossCheckLines) {
			return util.toArray(crossCheckLines).reduce(function (res, crossCheckLine) {
				var intersection = line.intersection(crossCheckLine);
				if (intersection) {
					res.push(intersection);
				}
				return res;
			}, []);
		}

		/**
		 * Sorting function for list of points by their distance.
		 * @param {g.point} p1 first point
		 * @param {g.point} p2 second point
		 * @return {number} squared distance between points
		 */
		function sortPoints(p1, p2) {
			return g.line(p1, p2).squaredLength();
		}

		/**
		 * Split input line into multiple based on intersection points.
		 * @param {g.line} line input line to split
		 * @param {g.point[]} intersections poinst where to split the line
		 * @param {number} jumpSize the size of jump arc (length empty spot on a line)
		 * @return {g.line[]} list of lines being split
		 */
		function createJumps(line, intersections, jumpSize) {
			return intersections.reduce(function (resultLines, point, idx) {
				// skipping points that were merged with the previous line
				// to make bigger arc over multiple lines that are close to each other
				if (point.skip === true) {
					return resultLines;
				}

				// always grab the last line from buffer and modify it
				var lastLine = resultLines.pop() || line;

				// calculate start and end of jump by moving by a given size of jump
				var jumpStart = g.point(point).move(lastLine.start, -(jumpSize));
				var jumpEnd = g.point(point).move(lastLine.start, +(jumpSize));

				// now try to look at the next intersection point
				var nextPoint = intersections[idx + 1];
				if (nextPoint != null) {
					var distance = jumpEnd.distance(nextPoint);
					if (distance <= jumpSize) {
						// next point is close enough, move the jump end by this
						// difference and mark the next point to be skipped
						jumpEnd = nextPoint.move(lastLine.start, distance);
						nextPoint.skip = true;
					}
				} else {
					// this block is inside of `else` as an optimization so the distance is
					// not calculated when we know there are no other intersection points
					var endDistance = jumpStart.distance(lastLine.end);
					// if the end is too close to possible jump, draw remaining line instead of a jump
					if (endDistance < jumpSize * 2 + CLOSE_PROXIMITY_PADDING) {
						resultLines.push(lastLine);
						return resultLines;
					}
				}

				var startDistance = jumpEnd.distance(lastLine.start);
				if (startDistance < jumpSize * 2 + CLOSE_PROXIMITY_PADDING) {
					// if the start of line is too close to jump, draw that line instead of a jump
					resultLines.push(lastLine);
					return resultLines;
				}

				// finally create a jump line
				var jumpLine = g.line(jumpStart, jumpEnd);
				// it's just simple line but with a `isJump` property
				jumpLine.isJump = true;

				resultLines.push(
					g.line(lastLine.start, jumpStart),
					jumpLine,
					g.line(jumpEnd, lastLine.end)
				);
				return resultLines;
			}, []);
		}

		/**
		 * Assemble `D` attribute of a SVG path by iterating given lines.
		 * @param {g.line[]} lines source lines to use
		 * @param {number} jumpSize the size of jump arc (length empty spot on a line)
		 * @return {string}
		 */
		function buildPath(lines, jumpSize, jumpType) {
			// first move to the start of a first line
			var start = ['M', lines[0].start.x, lines[0].start.y];

			// make a paths from lines
			var paths = util.toArray(lines).reduce(function (res, line) {
				if (line.isJump) {
					var diff;
					if (jumpType === 'arc') {
						diff = line.start.difference(line.end);
						// determine rotation of arc based on difference between points
						var xAxisRotate = Number(diff.x < 0 && diff.y < 0);
						// for a jump line we create an arc instead
						res.push('A', jumpSize, jumpSize, 0, 0, xAxisRotate, line.end.x, line.end.y);
					} else if (jumpType === 'gap') {
						res = res.concat(['M', line.end.x, line.end.y]);
					} else if (jumpType === 'cubic') {
						diff = line.start.difference(line.end);
						var angle = line.start.theta(line.end);
						var xOffset = jumpSize * 0.6;
						var yOffset = jumpSize * 1.35;
						// determine rotation of curve based on difference between points
						if (diff.x < 0 && diff.y < 0) {
							yOffset *= -1;
						}
						var controlStartPoint = g.point(line.start.x + xOffset, line.start.y + yOffset).rotate(line.start, angle);
						var controlEndPoint = g.point(line.end.x - xOffset, line.end.y + yOffset).rotate(line.end, angle);
						// create a cubic bezier curve
						res.push('C', controlStartPoint.x, controlStartPoint.y, controlEndPoint.x, controlEndPoint.y, line.end.x, line.end.y);
					}
				} else {
					res.push('L', line.end.x, line.end.y);
				}
				return res;
			}, start);

			return paths.join(' ');
		}

		/**
		 * Actual connector function that will be run on every update.
		 * @param {g.point} sourcePoint start point of this link
		 * @param {g.point} targetPoint end point of this link
		 * @param {g.point[]} vertices of this link
		 * @param {object} opts options
		 * @property {number} size optional size of a jump arc
		 * @return {string} created `D` attribute of SVG path
		 */
		return function (sourcePoint, targetPoint, vertices, opts) { // eslint-disable-line max-params

			setupUpdating(this);

			var jumpSize = opts.size || JUMP_SIZE;
			var jumpType = opts.jump && ('' + opts.jump).toLowerCase();
			var ignoreConnectors = opts.ignoreConnectors || IGNORED_CONNECTORS;

			// grab the first jump type as a default if specified one is invalid
			if (JUMP_TYPES.indexOf(jumpType) === -1) {
				jumpType = JUMP_TYPES[0];
			}

			var paper = this.paper;
			var graph = paper.model;
			var allLinks = graph.getLinks();

			// there is just one link, draw it directly
			if (allLinks.length === 1) {
				return buildPath(
					createLines(sourcePoint, targetPoint, vertices),
					jumpSize, jumpType
				);
			}

			var thisModel = this.model;
			var thisIndex = allLinks.indexOf(thisModel);
			var defaultConnector = paper.options.defaultConnector || {};

			// not all links are meant to be jumped over.
			var links = allLinks.filter(function (link, idx) {

				var connector = link.get('connector') || defaultConnector;

				// avoid jumping over links with connector type listed in `ignored connectors`.
				if (util.toArray(ignoreConnectors).includes(connector.name)) {
					return false;
				}
				// filter out links that are above this one and  have the same connector type
				// otherwise there would double hoops for each intersection
				if (idx > thisIndex) {
					return connector.name !== 'jumpover';
				}
				return true;
			});

			// find views for all links
			var linkViews = links.map(function (link) {
				return paper.findViewByModel(link);
			});

			// create lines for this link
			var thisLines = createLines(
				sourcePoint,
				targetPoint,
				vertices
			);

			// create lines for all other links
			var linkLines = linkViews.map(function (linkView) {
				if (linkView == null) {
					return [];
				}
				if (linkView === this) {
					return thisLines;
				}
				return createLines(
					linkView.sourcePoint,
					linkView.targetPoint,
					linkView.route
				);
			}, this);

			// transform lines for this link by splitting with jump lines at
			// points of intersection with other links
			var jumpingLines = thisLines.reduce(function (resultLines, thisLine) {
				// iterate all links and grab the intersections with this line
				// these are then sorted by distance so the line can be split more easily

				var intersections = links.reduce(function (res, link, i) {
					// don't intersection with itself
					if (link !== thisModel) {

						var lineIntersections = findLineIntersections(thisLine, linkLines[i]);
						res.push.apply(res, lineIntersections);
					}
					return res;
				}, []).sort(function (a, b) {
					return sortPoints(thisLine.start, a) - sortPoints(thisLine.start, b);
				});

				if (intersections.length > 0) {
					// split the line based on found intersection points
					resultLines.push.apply(resultLines, createJumps(thisLine, intersections, jumpSize));
				} else {
					// without any intersection the line goes uninterrupted
					resultLines.push(thisLine);
				}
				return resultLines;
			}, []);


			return buildPath(jumpingLines, jumpSize, jumpType);
		};
	}(_, g, joint.util));

	(function (_, g, joint, util) {

		function portTransformAttrs(point, angle, opt) {

			var trans = point.toJSON();

			trans.angle = angle || 0;

			return joint.util.defaults({}, opt, trans);
		}

		function lineLayout(ports, p1, p2) {
			return ports.map(function (port, index, ports) {
				var p = this.pointAt(((index + 0.5) / ports.length));
				// `dx`,`dy` per port offset option
				if (port.dx || port.dy) {
					p.offset(port.dx || 0, port.dy || 0);
				}

				return portTransformAttrs(p.round(), 0, port);
			}, g.line(p1, p2));
		}

		function ellipseLayout(ports, elBBox, startAngle, stepFn) {

			var center = elBBox.center();
			var ratio = elBBox.width / elBBox.height;
			var p1 = elBBox.topMiddle();

			var ellipse = g.Ellipse.fromRect(elBBox);

			return ports.map(function (port, index, ports) {

				var angle = startAngle + stepFn(index, ports.length);
				var p2 = p1.clone()
					.rotate(center, -angle)
					.scale(ratio, 1, center);

				var theta = port.compensateRotation ? -ellipse.tangentTheta(p2) : 0;

				// `dx`,`dy` per port offset option
				if (port.dx || port.dy) {
					p2.offset(port.dx || 0, port.dy || 0);
				}

				// `dr` delta radius option
				if (port.dr) {
					p2.move(center, port.dr);
				}

				return portTransformAttrs(p2.round(), theta, port);
			});
		}

		// Creates a point stored in arguments
		function argPoint(bbox, args) {

			var x = args.x;
			if (util.isString(x)) {
				x = parseFloat(x) / 100 * bbox.width;
			}

			var y = args.y;
			if (util.isString(y)) {
				y = parseFloat(y) / 100 * bbox.height;
			}

			return g.point(x || 0, y || 0);
		}

		joint.layout.Port = {

			/**
			 * @param {Array<Object>} ports
			 * @param {g.Rect} elBBox
			 * @param {Object=} opt opt Group options
			 * @returns {Array<g.Point>}
			 */
			absolute: function (ports, elBBox, opt) {
				//TODO v.talas angle
				return ports.map(argPoint.bind(null, elBBox));
			},

			/**
			 * @param {Array<Object>} ports
			 * @param {g.Rect} elBBox
			 * @param {Object=} opt opt Group options
			 * @returns {Array<g.Point>}
			 */
			fn: function (ports, elBBox, opt) {
				return opt.fn(ports, elBBox, opt);
			},

			/**
			 * @param {Array<Object>} ports
			 * @param {g.Rect} elBBox
			 * @param {Object=} opt opt Group options
			 * @returns {Array<g.Point>}
			 */
			line: function (ports, elBBox, opt) {

				var start = argPoint(elBBox, opt.start || elBBox.origin());
				var end = argPoint(elBBox, opt.end || elBBox.corner());

				return lineLayout(ports, start, end);
			},

			/**
			 * @param {Array<Object>} ports
			 * @param {g.Rect} elBBox
			 * @param {Object=} opt opt Group options
			 * @returns {Array<g.Point>}
			 */
			left: function (ports, elBBox, opt) {
				return lineLayout(ports, elBBox.origin(), elBBox.bottomLeft());
			},

			/**
			 * @param {Array<Object>} ports
			 * @param {g.Rect} elBBox
			 * @param {Object=} opt opt Group options
			 * @returns {Array<g.Point>}
			 */
			right: function (ports, elBBox, opt) {
				return lineLayout(ports, elBBox.topRight(), elBBox.corner());
			},

			/**
			 * @param {Array<Object>} ports
			 * @param {g.Rect} elBBox
			 * @param {Object=} opt opt Group options
			 * @returns {Array<g.Point>}
			 */
			top: function (ports, elBBox, opt) {
				return lineLayout(ports, elBBox.origin(), elBBox.topRight());
			},

			/**
			 * @param {Array<Object>} ports
			 * @param {g.Rect} elBBox
			 * @param {Object=} opt opt Group options
			 * @returns {Array<g.Point>}
			 */
			bottom: function (ports, elBBox, opt) {
				return lineLayout(ports, elBBox.bottomLeft(), elBBox.corner());
			},

			/**
			 * @param {Array<Object>} ports
			 * @param {g.Rect} elBBox
			 * @param {Object=} opt Group options
			 * @returns {Array<g.Point>}
			 */
			ellipseSpread: function (ports, elBBox, opt) {

				var startAngle = opt.startAngle || 0;
				var stepAngle = opt.step || 360 / ports.length;

				return ellipseLayout(ports, elBBox, startAngle, function (index) {
					return index * stepAngle;
				});
			},

			/**
			 * @param {Array<Object>} ports
			 * @param {g.Rect} elBBox
			 * @param {Object=} opt Group options
			 * @returns {Array<g.Point>}
			 */
			ellipse: function (ports, elBBox, opt) {

				var startAngle = opt.startAngle || 0;
				var stepAngle = opt.step || 20;

				return ellipseLayout(ports, elBBox, startAngle, function (index, count) {
					return (index + 0.5 - count / 2) * stepAngle;
				});
			}
		};

	})(_, g, joint, joint.util);

	(function (_, g, joint, util) {

		function labelAttributes(opt1, opt2) {

			return util.defaultsDeep({}, opt1, opt2, {
				x: 0,
				y: 0,
				angle: 0,
				attrs: {
					'.': {
						y: '0',
						'text-anchor': 'start'
					}
				}
			});

		}

		function outsideLayout(portPosition, elBBox, autoOrient, opt) {

			opt = util.defaults({}, opt, { offset: 15 });
			var angle = elBBox.center().theta(portPosition);
			var x = getBBoxAngles(elBBox);

			var tx, ty, y, textAnchor;
			var offset = opt.offset;
			var orientAngle = 0;

			if (angle < x[1] || angle > x[2]) {
				y = '.3em';
				tx = offset;
				ty = 0;
				textAnchor = 'start';
			} else if (angle < x[0]) {
				y = '0';
				tx = 0;
				ty = -offset;
				if (autoOrient) {
					orientAngle = -90;
					textAnchor = 'start';
				} else {
					textAnchor = 'middle';
				}
			} else if (angle < x[3]) {
				y = '.3em';
				tx = -offset;
				ty = 0;
				textAnchor = 'end';
			} else {
				y = '.6em';
				tx = 0;
				ty = offset;
				if (autoOrient) {
					orientAngle = 90;
					textAnchor = 'start';
				} else {
					textAnchor = 'middle';
				}
			}

			var round = Math.round;
			return labelAttributes({
				x: round(tx),
				y: round(ty),
				angle: orientAngle,
				attrs: {
					'.': {
						y: y,
						'text-anchor': textAnchor
					}
				}
			});
		}

		function getBBoxAngles(elBBox) {

			var center = elBBox.center();

			var tl = center.theta(elBBox.origin());
			var bl = center.theta(elBBox.bottomLeft());
			var br = center.theta(elBBox.corner());
			var tr = center.theta(elBBox.topRight());

			return [tl, tr, br, bl];
		}

		function insideLayout(portPosition, elBBox, autoOrient, opt) {

			var angle = elBBox.center().theta(portPosition);
			opt = util.defaults({}, opt, { offset: 15 });

			var tx, ty, y, textAnchor;
			var offset = opt.offset;
			var orientAngle = 0;

			var bBoxAngles = getBBoxAngles(elBBox);

			if (angle < bBoxAngles[1] || angle > bBoxAngles[2]) {
				y = '.3em';
				tx = -offset;
				ty = 0;
				textAnchor = 'end';
			} else if (angle < bBoxAngles[0]) {
				y = '.6em';
				tx = 0;
				ty = offset;
				if (autoOrient) {
					orientAngle = 90;
					textAnchor = 'start';
				} else {
					textAnchor = 'middle';
				}
			} else if (angle < bBoxAngles[3]) {
				y = '.3em';
				tx = offset;
				ty = 0;
				textAnchor = 'start';
			} else {
				y = '0em';
				tx = 0;
				ty = -offset;
				if (autoOrient) {
					orientAngle = -90;
					textAnchor = 'start';
				} else {
					textAnchor = 'middle';
				}
			}

			var round = Math.round;
			return labelAttributes({
				x: round(tx),
				y: round(ty),
				angle: orientAngle,
				attrs: {
					'.': {
						y: y,
						'text-anchor': textAnchor
					}
				}
			});
		}

		function radialLayout(portCenterOffset, autoOrient, opt) {

			opt = util.defaults({}, opt, { offset: 20 });

			var origin = g.point(0, 0);
			var angle = -portCenterOffset.theta(origin);
			var orientAngle = angle;
			var offset = portCenterOffset.clone()
				.move(origin, opt.offset)
				.difference(portCenterOffset)
				.round();

			var y = '.3em';
			var textAnchor;

			if ((angle + 90) % 180 === 0) {
				textAnchor = autoOrient ? 'end' : 'middle';
				if (!autoOrient && angle === -270) {
					y = '0em';
				}
			} else if (angle > -270 && angle < -90) {
				textAnchor = 'start';
				orientAngle = angle - 180;
			} else {
				textAnchor = 'end';
			}

			var round = Math.round;
			return labelAttributes({
				x: round(offset.x),
				y: round(offset.y),
				angle: autoOrient ? orientAngle : 0,
				attrs: {
					'.': {
						y: y,
						'text-anchor': textAnchor
					}
				}
			});
		}

		joint.layout.PortLabel = {

			manual: function (portPosition, elBBox, opt) {
				return labelAttributes(opt, portPosition)
			},

			left: function (portPosition, elBBox, opt) {
				return labelAttributes(opt, { x: -15, attrs: { '.': { y: '.3em', 'text-anchor': 'end' } } });
			},

			right: function (portPosition, elBBox, opt) {
				return labelAttributes(opt, { x: 15, attrs: { '.': { y: '.3em', 'text-anchor': 'start' } } });
			},

			top: function (portPosition, elBBox, opt) {
				return labelAttributes(opt, { y: -15, attrs: { '.': { 'text-anchor': 'middle' } } });
			},

			bottom: function (portPosition, elBBox, opt) {
				return labelAttributes(opt, { y: 15, attrs: { '.': { y: '.6em', 'text-anchor': 'middle' } } });
			},

			outsideOriented: function (portPosition, elBBox, opt) {
				return outsideLayout(portPosition, elBBox, true, opt);
			},

			outside: function (portPosition, elBBox, opt) {
				return outsideLayout(portPosition, elBBox, false, opt);
			},

			insideOriented: function (portPosition, elBBox, opt) {
				return insideLayout(portPosition, elBBox, true, opt);
			},

			inside: function (portPosition, elBBox, opt) {
				return insideLayout(portPosition, elBBox, false, opt);
			},

			radial: function (portPosition, elBBox, opt) {
				return radialLayout(portPosition.difference(elBBox.center()), false, opt);
			},

			radialOriented: function (portPosition, elBBox, opt) {
				return radialLayout(portPosition.difference(elBBox.center()), true, opt);
			}
		};

	})(_, g, joint, joint.util);

	joint.highlighters.addClass = {

		className: joint.util.addClassNamePrefix('highlighted'),

		/**
		 * @param {joint.dia.CellView} cellView
		 * @param {Element} magnetEl
		 * @param {object=} opt
		 */
		highlight: function (cellView, magnetEl, opt) {

			var options = opt || {};
			var className = options.className || this.className;
			V(magnetEl).addClass(className);
		},

		/**
		 * @param {joint.dia.CellView} cellView
		 * @param {Element} magnetEl
		 * @param {object=} opt
		 */
		unhighlight: function (cellView, magnetEl, opt) {

			var options = opt || {};
			var className = options.className || this.className;
			V(magnetEl).removeClass(className);
		}
	};

	joint.highlighters.opacity = {

		/**
		 * @param {joint.dia.CellView} cellView
		 * @param {Element} magnetEl
		 */
		highlight: function (cellView, magnetEl) {

			V(magnetEl).addClass(joint.util.addClassNamePrefix('highlight-opacity'));
		},

		/**
		 * @param {joint.dia.CellView} cellView
		 * @param {Element} magnetEl
		 */
		unhighlight: function (cellView, magnetEl) {

			V(magnetEl).removeClass(joint.util.addClassNamePrefix('highlight-opacity'));
		}
	};

	joint.highlighters.stroke = {

		defaultOptions: {
			padding: 3,
			rx: 0,
			ry: 0,
			attrs: {
				'stroke-width': 3,
				stroke: '#FEB663'
			}
		},

		_views: {},

		getHighlighterId: function (magnetEl, opt) {

			return magnetEl.id + JSON.stringify(opt);
		},

		removeHighlighter: function (id) {
			if (this._views[id]) {
				this._views[id].remove();
				this._views[id] = null;
			}
		},

		/**
		 * @param {joint.dia.CellView} cellView
		 * @param {Element} magnetEl
		 * @param {object=} opt
		 */
		highlight: function (cellView, magnetEl, opt) {

			var id = this.getHighlighterId(magnetEl, opt);

			// Only highlight once.
			if (this._views[id]) return;

			var options = joint.util.defaults(opt || {}, this.defaultOptions);

			var magnetVel = V(magnetEl);
			var magnetBBox;

			try {

				var pathData = magnetVel.convertToPathData();

			} catch (error) {

				// Failed to get path data from magnet element.
				// Draw a rectangle around the entire cell view instead.
				magnetBBox = magnetVel.bbox(true/* without transforms */);
				pathData = V.rectToPath(joint.util.assign({}, options, magnetBBox));
			}

			var highlightVel = V('path').attr({
				d: pathData,
				'pointer-events': 'none',
				'vector-effect': 'non-scaling-stroke',
				'fill': 'none'
			}).attr(options.attrs);

			var highlightMatrix = magnetVel.getTransformToElement(cellView.el);

			// Add padding to the highlight element.
			var padding = options.padding;
			if (padding) {

				magnetBBox || (magnetBBox = magnetVel.bbox(true));

				var cx = magnetBBox.x + (magnetBBox.width / 2);
				var cy = magnetBBox.y + (magnetBBox.height / 2);

				magnetBBox = V.transformRect(magnetBBox, highlightMatrix);

				var width = Math.max(magnetBBox.width, 1);
				var height = Math.max(magnetBBox.height, 1);
				var sx = (width + padding) / width;
				var sy = (height + padding) / height;

				var paddingMatrix = V.createSVGMatrix({
					a: sx,
					b: 0,
					c: 0,
					d: sy,
					e: cx - sx * cx,
					f: cy - sy * cy
				});

				highlightMatrix = highlightMatrix.multiply(paddingMatrix);
			}

			highlightVel.transform(highlightMatrix);

			// joint.mvc.View will handle the theme class name and joint class name prefix.
			var highlightView = this._views[id] = new joint.mvc.View({
				svgElement: true,
				className: 'highlight-stroke',
				el: highlightVel.node
			});

			// Remove the highlight view when the cell is removed from the graph.
			var removeHandler = this.removeHighlighter.bind(this, id);
			var cell = cellView.model;
			highlightView.listenTo(cell, 'remove', removeHandler);
			highlightView.listenTo(cell.graph, 'reset', removeHandler);

			cellView.vel.append(highlightVel);
		},

		/**
		 * @param {joint.dia.CellView} cellView
		 * @param {Element} magnetEl
		 * @param {object=} opt
		 */
		unhighlight: function (cellView, magnetEl, opt) {

			this.removeHighlighter(this.getHighlighterId(magnetEl, opt));
		}
	};

	joint.dia.Element.define('erd.Entity', {
		size: { width: 150, height: 60 },
		attrs: {
			'.outer': {
				fill: '#2ECC71', stroke: '#27AE60', 'stroke-width': 2,
				points: '100,0 100,60 0,60 0,0'
			},
			'.inner': {
				fill: '#2ECC71', stroke: '#27AE60', 'stroke-width': 2,
				points: '95,5 95,55 5,55 5,5',
				display: 'none'
			},
			text: {
				text: 'Entity',
				'font-family': 'Arial', 'font-size': 14,
				'ref-x': .5, 'ref-y': .5,
				'y-alignment': 'middle', 'text-anchor': 'middle'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><polygon class="outer"/><polygon class="inner"/></g><text/></g>',
		});


	joint.shapes.erd.Entity.define('erd.WeakEntity', {
		attrs: {
			'.inner': { display: 'auto' },
			text: { text: 'Weak Entity' }
		}
	});

	joint.dia.Element.define('erd.Relationship', {
		size: { width: 80, height: 80 },
		attrs: {
			'.outer': {
				fill: '#3498DB', stroke: '#2980B9', 'stroke-width': 2,
				points: '40,0 80,40 40,80 0,40'
			},
			'.inner': {
				fill: '#3498DB', stroke: '#2980B9', 'stroke-width': 2,
				points: '40,5 75,40 40,75 5,40',
				display: 'none'
			},
			text: {
				text: 'Relationship',
				'font-family': 'Arial', 'font-size': 12,
				'ref-x': .5, 'ref-y': .5,
				'y-alignment': 'middle', 'text-anchor': 'middle'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><polygon class="outer"/><polygon class="inner"/></g><text/></g>',
		});

	joint.shapes.erd.Relationship.define('erd.IdentifyingRelationship', {
		attrs: {
			'.inner': { display: 'auto' },
			text: { text: 'Identifying' }
		}
	});

	joint.dia.Element.define('erd.Attribute', {
		size: { width: 100, height: 50 },
		attrs: {
			'ellipse': {
				transform: 'translate(50, 25)'
			},
			'.outer': {
				stroke: '#D35400', 'stroke-width': 2,
				cx: 0, cy: 0, rx: 50, ry: 25,
				fill: '#E67E22'
			},
			'.inner': {
				stroke: '#D35400', 'stroke-width': 2,
				cx: 0, cy: 0, rx: 45, ry: 20,
				fill: '#E67E22', display: 'none'
			},
			text: {
				'font-family': 'Arial', 'font-size': 14,
				'ref-x': .5, 'ref-y': .5,
				'y-alignment': 'middle', 'text-anchor': 'middle'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><ellipse class="outer"/><ellipse class="inner"/></g><text/></g>',
		});

	joint.shapes.erd.Attribute.define('erd.Multivalued', {
		attrs: {
			'.inner': { display: 'block' },
			text: { text: 'multivalued' }
		}
	});

	joint.shapes.erd.Attribute.define('erd.Derived', {
		attrs: {
			'.outer': { 'stroke-dasharray': '3,5' },
			text: { text: 'derived' }
		}
	});

	joint.shapes.erd.Attribute.define('erd.Key', {
		attrs: {
			ellipse: { 'stroke-width': 4 },
			text: { text: 'key', 'font-weight': '800', 'text-decoration': 'underline' }
		}
	});

	joint.shapes.erd.Attribute.define('erd.Normal', {
		attrs: { text: { text: 'Normal' } }
	});

	joint.dia.Element.define('erd.ISA', {
		type: 'erd.ISA',
		size: { width: 100, height: 50 },
		attrs: {
			polygon: {
				points: '0,0 50,50 100,0',
				fill: '#F1C40F', stroke: '#F39C12', 'stroke-width': 2
			},
			text: {
				text: 'ISA', 'font-size': 18,
				'ref-x': .5, 'ref-y': .3,
				'y-alignment': 'middle', 'text-anchor': 'middle'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><polygon/></g><text/></g>',
		});

	joint.dia.Link.define('erd.Line', {}, {
		cardinality: function (value) {
			this.set('labels', [{ position: -20, attrs: { text: { dy: -8, text: value } } }]);
		}
	});

	joint.shapes.basic.Circle.define('fsa.State', {
		attrs: {
			circle: { 'stroke-width': 3 },
			text: { 'font-weight': '800' }
		}
	});

	joint.dia.Element.define('fsa.StartState', {
		size: { width: 20, height: 20 },
		attrs: {
			circle: {
				transform: 'translate(10, 10)',
				r: 10,
				fill: '#000000'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><circle/></g></g>',
		});

	joint.dia.Element.define('fsa.EndState', {
		size: { width: 20, height: 20 },
		attrs: {
			'.outer': {
				transform: 'translate(10, 10)',
				r: 10,
				fill: '#ffffff',
				stroke: '#000000'
			},

			'.inner': {
				transform: 'translate(10, 10)',
				r: 6,
				fill: '#000000'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><circle class="outer"/><circle class="inner"/></g></g>',
		});

	joint.dia.Link.define('fsa.Arrow', {
		attrs: { '.marker-target': { d: 'M 10 0 L 0 5 L 10 10 z' } },
		smooth: true
	});

	joint.dia.Element.define('org.Member', {
		size: { width: 180, height: 70 },
		attrs: {
			rect: { width: 170, height: 60 },

			'.card': {
				fill: '#FFFFFF', stroke: '#000000', 'stroke-width': 2,
				'pointer-events': 'visiblePainted', rx: 10, ry: 10
			},

			image: {
				width: 48, height: 48,
				ref: '.card', 'ref-x': 10, 'ref-y': 5
			},

			'.rank': {
				'text-decoration': 'underline',
				ref: '.card', 'ref-x': 0.9, 'ref-y': 0.2,
				'font-family': 'Courier New', 'font-size': 14,
				'text-anchor': 'end'
			},

			'.name': {
				'font-weight': '800',
				ref: '.card', 'ref-x': 0.9, 'ref-y': 0.6,
				'font-family': 'Courier New', 'font-size': 14,
				'text-anchor': 'end'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><rect class="card"/><image/></g><text class="rank"/><text class="name"/></g>',
		});

	joint.dia.Link.define('org.Arrow', {
		source: { selector: '.card' }, target: { selector: '.card' },
		attrs: { '.connection': { stroke: '#585858', 'stroke-width': 3 } },
		z: -1
	});

	joint.shapes.basic.Generic.define('chess.KingWhite', {
		size: { width: 42, height: 38 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><g style="fill:none; fill-opacity:1; fill-rule:evenodd; stroke:#000000; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;"><path      d="M 22.5,11.63 L 22.5,6"      style="fill:none; stroke:#000000; stroke-linejoin:miter;" />    <path      d="M 20,8 L 25,8"      style="fill:none; stroke:#000000; stroke-linejoin:miter;" />    <path      d="M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25"      style="fill:#ffffff; stroke:#000000; stroke-linecap:butt; stroke-linejoin:miter;" />    <path      d="M 11.5,37 C 17,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 19,16 9.5,13 6.5,19.5 C 3.5,25.5 11.5,29.5 11.5,29.5 L 11.5,37 z "      style="fill:#ffffff; stroke:#000000;" />    <path      d="M 11.5,30 C 17,27 27,27 32.5,30"      style="fill:none; stroke:#000000;" />    <path      d="M 11.5,33.5 C 17,30.5 27,30.5 32.5,33.5"      style="fill:none; stroke:#000000;" />    <path      d="M 11.5,37 C 17,34 27,34 32.5,37"      style="fill:none; stroke:#000000;" />  </g></g></g>'
		});

	joint.shapes.basic.Generic.define('chess.KingBlack', {
		size: { width: 42, height: 38 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><g style="fill:none; fill-opacity:1; fill-rule:evenodd; stroke:#000000; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;">    <path       d="M 22.5,11.63 L 22.5,6"       style="fill:none; stroke:#000000; stroke-linejoin:miter;"       id="path6570" />    <path       d="M 22.5,25 C 22.5,25 27,17.5 25.5,14.5 C 25.5,14.5 24.5,12 22.5,12 C 20.5,12 19.5,14.5 19.5,14.5 C 18,17.5 22.5,25 22.5,25"       style="fill:#000000;fill-opacity:1; stroke-linecap:butt; stroke-linejoin:miter;" />    <path       d="M 11.5,37 C 17,40.5 27,40.5 32.5,37 L 32.5,30 C 32.5,30 41.5,25.5 38.5,19.5 C 34.5,13 25,16 22.5,23.5 L 22.5,27 L 22.5,23.5 C 19,16 9.5,13 6.5,19.5 C 3.5,25.5 11.5,29.5 11.5,29.5 L 11.5,37 z "       style="fill:#000000; stroke:#000000;" />    <path       d="M 20,8 L 25,8"       style="fill:none; stroke:#000000; stroke-linejoin:miter;" />    <path       d="M 32,29.5 C 32,29.5 40.5,25.5 38.03,19.85 C 34.15,14 25,18 22.5,24.5 L 22.51,26.6 L 22.5,24.5 C 20,18 9.906,14 6.997,19.85 C 4.5,25.5 11.85,28.85 11.85,28.85"       style="fill:none; stroke:#ffffff;" />    <path       d="M 11.5,30 C 17,27 27,27 32.5,30 M 11.5,33.5 C 17,30.5 27,30.5 32.5,33.5 M 11.5,37 C 17,34 27,34 32.5,37"       style="fill:none; stroke:#ffffff;" />  </g></g></g>'
		});

	joint.shapes.basic.Generic.define('chess.QueenWhite', {
		size: { width: 42, height: 38 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><g style="opacity:1; fill:#ffffff; fill-opacity:1; fill-rule:evenodd; stroke:#000000; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;">    <path      d="M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z"      transform="translate(-1,-1)" />    <path      d="M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z"      transform="translate(15.5,-5.5)" />    <path      d="M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z"      transform="translate(32,-1)" />    <path      d="M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z"      transform="translate(7,-4.5)" />    <path      d="M 9 13 A 2 2 0 1 1  5,13 A 2 2 0 1 1  9 13 z"      transform="translate(24,-4)" />    <path      d="M 9,26 C 17.5,24.5 30,24.5 36,26 L 38,14 L 31,25 L 31,11 L 25.5,24.5 L 22.5,9.5 L 19.5,24.5 L 14,10.5 L 14,25 L 7,14 L 9,26 z "      style="stroke-linecap:butt;" />    <path      d="M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 10.5,36 10.5,36 C 9,37.5 11,38.5 11,38.5 C 17.5,39.5 27.5,39.5 34,38.5 C 34,38.5 35.5,37.5 34,36 C 34,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 z "      style="stroke-linecap:butt;" />    <path      d="M 11.5,30 C 15,29 30,29 33.5,30"      style="fill:none;" />    <path      d="M 12,33.5 C 18,32.5 27,32.5 33,33.5"      style="fill:none;" />  </g></g></g>'
		});

	joint.shapes.basic.Generic.define('chess.QueenBlack', {
		size: { width: 42, height: 38 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><g style="opacity:1; fill:#000000; fill-opacity:1; fill-rule:evenodd; stroke:#000000; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;">    <g style="fill:#000000; stroke:none;">      <circle cx="6"    cy="12" r="2.75" />      <circle cx="14"   cy="9"  r="2.75" />      <circle cx="22.5" cy="8"  r="2.75" />      <circle cx="31"   cy="9"  r="2.75" />      <circle cx="39"   cy="12" r="2.75" />    </g>    <path       d="M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 25.5,24.5 L 22.5,10 L 19.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 z"       style="stroke-linecap:butt; stroke:#000000;" />    <path       d="M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 10.5,36 10.5,36 C 9,37.5 11,38.5 11,38.5 C 17.5,39.5 27.5,39.5 34,38.5 C 34,38.5 35.5,37.5 34,36 C 34,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 z"       style="stroke-linecap:butt;" />    <path       d="M 11,38.5 A 35,35 1 0 0 34,38.5"       style="fill:none; stroke:#000000; stroke-linecap:butt;" />    <path       d="M 11,29 A 35,35 1 0 1 34,29"       style="fill:none; stroke:#ffffff;" />    <path       d="M 12.5,31.5 L 32.5,31.5"       style="fill:none; stroke:#ffffff;" />    <path       d="M 11.5,34.5 A 35,35 1 0 0 33.5,34.5"       style="fill:none; stroke:#ffffff;" />    <path       d="M 10.5,37.5 A 35,35 1 0 0 34.5,37.5"       style="fill:none; stroke:#ffffff;" />  </g></g></g>'
		});

	joint.shapes.basic.Generic.define('chess.RookWhite', {
		size: { width: 32, height: 34 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><g style="opacity:1; fill:#ffffff; fill-opacity:1; fill-rule:evenodd; stroke:#000000; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;">    <path      d="M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z "      style="stroke-linecap:butt;" />    <path      d="M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z "      style="stroke-linecap:butt;" />    <path      d="M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14"      style="stroke-linecap:butt;" />    <path      d="M 34,14 L 31,17 L 14,17 L 11,14" />    <path      d="M 31,17 L 31,29.5 L 14,29.5 L 14,17"      style="stroke-linecap:butt; stroke-linejoin:miter;" />    <path      d="M 31,29.5 L 32.5,32 L 12.5,32 L 14,29.5" />    <path      d="M 11,14 L 34,14"      style="fill:none; stroke:#000000; stroke-linejoin:miter;" />  </g></g></g>'
		});

	joint.shapes.basic.Generic.define('chess.RookBlack', {
		size: { width: 32, height: 34 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><g style="opacity:1; fill:#000000; fill-opacity:1; fill-rule:evenodd; stroke:#000000; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;">    <path      d="M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z "      style="stroke-linecap:butt;" />    <path      d="M 12.5,32 L 14,29.5 L 31,29.5 L 32.5,32 L 12.5,32 z "      style="stroke-linecap:butt;" />    <path      d="M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 z "      style="stroke-linecap:butt;" />    <path      d="M 14,29.5 L 14,16.5 L 31,16.5 L 31,29.5 L 14,29.5 z "      style="stroke-linecap:butt;stroke-linejoin:miter;" />    <path      d="M 14,16.5 L 11,14 L 34,14 L 31,16.5 L 14,16.5 z "      style="stroke-linecap:butt;" />    <path      d="M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14 L 11,14 z "      style="stroke-linecap:butt;" />    <path      d="M 12,35.5 L 33,35.5 L 33,35.5"      style="fill:none; stroke:#ffffff; stroke-width:1; stroke-linejoin:miter;" />    <path      d="M 13,31.5 L 32,31.5"      style="fill:none; stroke:#ffffff; stroke-width:1; stroke-linejoin:miter;" />    <path      d="M 14,29.5 L 31,29.5"      style="fill:none; stroke:#ffffff; stroke-width:1; stroke-linejoin:miter;" />    <path      d="M 14,16.5 L 31,16.5"      style="fill:none; stroke:#ffffff; stroke-width:1; stroke-linejoin:miter;" />    <path      d="M 11,14 L 34,14"      style="fill:none; stroke:#ffffff; stroke-width:1; stroke-linejoin:miter;" />  </g></g></g>'
		});

	joint.shapes.basic.Generic.define('chess.BishopWhite', {
		size: { width: 38, height: 38 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><g style="opacity:1; fill:none; fill-rule:evenodd; fill-opacity:1; stroke:#000000; stroke-width:1.5; stroke-linecap:round; stroke-linejoin:round; stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;">    <g style="fill:#ffffff; stroke:#000000; stroke-linecap:butt;">       <path        d="M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.646,38.99 6.677,38.97 6,38 C 7.354,36.06 9,36 9,36 z" />      <path        d="M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z" />      <path        d="M 25 8 A 2.5 2.5 0 1 1  20,8 A 2.5 2.5 0 1 1  25 8 z" />    </g>    <path      d="M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18"      style="fill:none; stroke:#000000; stroke-linejoin:miter;" />  </g></g></g>'
		});

	joint.shapes.basic.Generic.define('chess.BishopBlack', {
		size: { width: 38, height: 38 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><g style="opacity:1; fill:none; fill-rule:evenodd; fill-opacity:1; stroke:#000000; stroke-width:1.5; stroke-linecap:round; stroke-linejoin:round; stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;">    <g style="fill:#000000; stroke:#000000; stroke-linecap:butt;">       <path        d="M 9,36 C 12.39,35.03 19.11,36.43 22.5,34 C 25.89,36.43 32.61,35.03 36,36 C 36,36 37.65,36.54 39,38 C 38.32,38.97 37.35,38.99 36,38.5 C 32.61,37.53 25.89,38.96 22.5,37.5 C 19.11,38.96 12.39,37.53 9,38.5 C 7.646,38.99 6.677,38.97 6,38 C 7.354,36.06 9,36 9,36 z" />      <path        d="M 15,32 C 17.5,34.5 27.5,34.5 30,32 C 30.5,30.5 30,30 30,30 C 30,27.5 27.5,26 27.5,26 C 33,24.5 33.5,14.5 22.5,10.5 C 11.5,14.5 12,24.5 17.5,26 C 17.5,26 15,27.5 15,30 C 15,30 14.5,30.5 15,32 z" />      <path        d="M 25 8 A 2.5 2.5 0 1 1  20,8 A 2.5 2.5 0 1 1  25 8 z" />    </g>    <path       d="M 17.5,26 L 27.5,26 M 15,30 L 30,30 M 22.5,15.5 L 22.5,20.5 M 20,18 L 25,18"       style="fill:none; stroke:#ffffff; stroke-linejoin:miter;" />  </g></g></g>'
		});

	joint.shapes.basic.Generic.define('chess.KnightWhite', {
		size: { width: 38, height: 37 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><g style="opacity:1; fill:none; fill-opacity:1; fill-rule:evenodd; stroke:#000000; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;">    <path      d="M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18"      style="fill:#ffffff; stroke:#000000;" />    <path      d="M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10"      style="fill:#ffffff; stroke:#000000;" />    <path      d="M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z"      style="fill:#000000; stroke:#000000;" />    <path      d="M 15 15.5 A 0.5 1.5 0 1 1  14,15.5 A 0.5 1.5 0 1 1  15 15.5 z"      transform="matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)"      style="fill:#000000; stroke:#000000;" />  </g></g></g>'
		});

	joint.shapes.basic.Generic.define('chess.KnightBlack', {
		size: { width: 38, height: 37 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><g style="opacity:1; fill:none; fill-opacity:1; fill-rule:evenodd; stroke:#000000; stroke-width:1.5; stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;">    <path      d="M 22,10 C 32.5,11 38.5,18 38,39 L 15,39 C 15,30 25,32.5 23,18"      style="fill:#000000; stroke:#000000;" />    <path      d="M 24,18 C 24.38,20.91 18.45,25.37 16,27 C 13,29 13.18,31.34 11,31 C 9.958,30.06 12.41,27.96 11,28 C 10,28 11.19,29.23 10,30 C 9,30 5.997,31 6,26 C 6,24 12,14 12,14 C 12,14 13.89,12.1 14,10.5 C 13.27,9.506 13.5,8.5 13.5,7.5 C 14.5,6.5 16.5,10 16.5,10 L 18.5,10 C 18.5,10 19.28,8.008 21,7 C 22,7 22,10 22,10"      style="fill:#000000; stroke:#000000;" />    <path      d="M 9.5 25.5 A 0.5 0.5 0 1 1 8.5,25.5 A 0.5 0.5 0 1 1 9.5 25.5 z"      style="fill:#ffffff; stroke:#ffffff;" />    <path      d="M 15 15.5 A 0.5 1.5 0 1 1  14,15.5 A 0.5 1.5 0 1 1  15 15.5 z"      transform="matrix(0.866,0.5,-0.5,0.866,9.693,-5.173)"      style="fill:#ffffff; stroke:#ffffff;" />    <path      d="M 24.55,10.4 L 24.1,11.85 L 24.6,12 C 27.75,13 30.25,14.49 32.5,18.75 C 34.75,23.01 35.75,29.06 35.25,39 L 35.2,39.5 L 37.45,39.5 L 37.5,39 C 38,28.94 36.62,22.15 34.25,17.66 C 31.88,13.17 28.46,11.02 25.06,10.5 L 24.55,10.4 z "      style="fill:#ffffff; stroke:none;" />  </g></g></g>'
		});

	joint.shapes.basic.Generic.define('chess.PawnWhite', {
		size: { width: 28, height: 33 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><path d="M 22,9 C 19.79,9 18,10.79 18,13 C 18,13.89 18.29,14.71 18.78,15.38 C 16.83,16.5 15.5,18.59 15.5,21 C 15.5,23.03 16.44,24.84 17.91,26.03 C 14.91,27.09 10.5,31.58 10.5,39.5 L 33.5,39.5 C 33.5,31.58 29.09,27.09 26.09,26.03 C 27.56,24.84 28.5,23.03 28.5,21 C 28.5,18.59 27.17,16.5 25.22,15.38 C 25.71,14.71 26,13.89 26,13 C 26,10.79 24.21,9 22,9 z "  style="opacity:1; fill:#ffffff; fill-opacity:1; fill-rule:nonzero; stroke:#000000; stroke-width:1.5; stroke-linecap:round; stroke-linejoin:miter; stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;" /></g></g>'
		});

	joint.shapes.basic.Generic.define('chess.PawnBlack', {
		size: { width: 28, height: 33 }
	}, {
			markup: '<g class="rotatable"><g class="scalable"><path d="M 22,9 C 19.79,9 18,10.79 18,13 C 18,13.89 18.29,14.71 18.78,15.38 C 16.83,16.5 15.5,18.59 15.5,21 C 15.5,23.03 16.44,24.84 17.91,26.03 C 14.91,27.09 10.5,31.58 10.5,39.5 L 33.5,39.5 C 33.5,31.58 29.09,27.09 26.09,26.03 C 27.56,24.84 28.5,23.03 28.5,21 C 28.5,18.59 27.17,16.5 25.22,15.38 C 25.71,14.71 26,13.89 26,13 C 26,10.79 24.21,9 22,9 z "  style="opacity:1; fill:#000000; fill-opacity:1; fill-rule:nonzero; stroke:#000000; stroke-width:1.5; stroke-linecap:round; stroke-linejoin:miter; stroke-miterlimit:4; stroke-dasharray:none; stroke-opacity:1;" /></g></g>'
		});

	joint.shapes.basic.Generic.define('pn.Place', {
		size: { width: 50, height: 50 },
		attrs: {
			'.root': {
				r: 25,
				fill: '#ffffff',
				stroke: '#000000',
				transform: 'translate(25, 25)'
			},
			'.label': {
				'text-anchor': 'middle',
				'ref-x': .5,
				'ref-y': -20,
				ref: '.root',
				fill: '#000000',
				'font-size': 12
			},
			'.tokens > circle': {
				fill: '#000000',
				r: 5
			},
			'.tokens.one > circle': { transform: 'translate(25, 25)' },

			'.tokens.two > circle:nth-child(1)': { transform: 'translate(19, 25)' },
			'.tokens.two > circle:nth-child(2)': { transform: 'translate(31, 25)' },

			'.tokens.three > circle:nth-child(1)': { transform: 'translate(18, 29)' },
			'.tokens.three > circle:nth-child(2)': { transform: 'translate(25, 19)' },
			'.tokens.three > circle:nth-child(3)': { transform: 'translate(32, 29)' },

			'.tokens.alot > text': {
				transform: 'translate(25, 18)',
				'text-anchor': 'middle',
				fill: '#000000'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><circle class="root"/><g class="tokens" /></g><text class="label"/></g>',
		});

	joint.shapes.pn.PlaceView = joint.dia.ElementView.extend({}, {

		initialize: function () {

			joint.dia.ElementView.prototype.initialize.apply(this, arguments);

			this.model.on('change:tokens', function () {

				this.renderTokens();
				this.update();

			}, this);
		},

		render: function () {

			joint.dia.ElementView.prototype.render.apply(this, arguments);

			this.renderTokens();
			this.update();
		},

		renderTokens: function () {

			var $tokens = this.$('.tokens').empty();
			$tokens[0].className.baseVal = 'tokens';

			var tokens = this.model.get('tokens');

			if (!tokens) return;

			switch (tokens) {

				case 1:
					$tokens[0].className.baseVal += ' one';
					$tokens.append(V('<circle/>').node);
					break;

				case 2:
					$tokens[0].className.baseVal += ' two';
					$tokens.append(V('<circle/>').node, V('<circle/>').node);
					break;

				case 3:
					$tokens[0].className.baseVal += ' three';
					$tokens.append(V('<circle/>').node, V('<circle/>').node, V('<circle/>').node);
					break;

				default:
					$tokens[0].className.baseVal += ' alot';
					$tokens.append(V('<text/>').text(tokens + '').node);
					break;
			}
		}
	});

	joint.shapes.basic.Generic.define('pn.Transition', {
		size: { width: 12, height: 50 },
		attrs: {
			'rect': {
				width: 12,
				height: 50,
				fill: '#000000',
				stroke: '#000000'
			},
			'.label': {
				'text-anchor': 'middle',
				'ref-x': .5,
				'ref-y': -20,
				ref: 'rect',
				fill: '#000000',
				'font-size': 12
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><rect class="root"/></g></g><text class="label"/>',
		});

	joint.dia.Link.define('pn.Link', {
		attrs: { '.marker-target': { d: 'M 10 0 L 0 5 L 10 10 z' } }
	});

	/**
	 * @deprecated use the port api insteac
	 */
	joint.shapes.basic.Generic.define('devs.Model', {
		inPorts: [],
		outPorts: [],
		size: {
			width: 80,
			height: 80
		},
		attrs: {
			'.': {
				magnet: false
			},
			'.label': {
				text: 'Model',
				'ref-x': .5,
				'ref-y': 10,
				'font-size': 18,
				'text-anchor': 'middle',
				fill: '#000'
			},
			'.body': {
				'ref-width': '100%',
				'ref-height': '100%',
				stroke: '#000'
			}
		},
		ports: {
			groups: {
				'in': {
					position: {
						name: 'left'
					},
					attrs: {
						'.port-label': {
							fill: '#000'
						},
						'.port-body': {
							fill: '#fff',
							stroke: '#000',
							r: 10,
							magnet: true
						}
					},
					label: {
						position: {
							name: 'left',
							args: {
								y: 10
							}
						}
					}
				},
				'out': {
					position: {
						name: 'right'
					},
					attrs: {
						'.port-label': {
							fill: '#000'
						},
						'.port-body': {
							fill: '#fff',
							stroke: '#000',
							r: 10,
							magnet: true
						}
					},
					label: {
						position: {
							name: 'right',
							args: {
								y: 10
							}
						}
					}
				}
			}
		}
	}, {
			markup: '<g class="rotatable"><rect class="body"/><text class="label"/></g>',
			portMarkup: '<circle class="port-body"/>',
			portLabelMarkup: '<text class="port-label"/>',

			initialize: function () {

				joint.shapes.basic.Generic.prototype.initialize.apply(this, arguments);

				this.on('change:inPorts change:outPorts', this.updatePortItems, this);
				this.updatePortItems();
			},

			updatePortItems: function (model, changed, opt) {

				// Make sure all ports are unique.
				var inPorts = joint.util.uniq(this.get('inPorts'));
				var outPorts = joint.util.difference(joint.util.uniq(this.get('outPorts')), inPorts);

				var inPortItems = this.createPortItems('in', inPorts);
				var outPortItems = this.createPortItems('out', outPorts);

				this.prop('ports/items', inPortItems.concat(outPortItems), joint.util.assign({ rewrite: true }, opt));
			},

			createPortItem: function (group, port) {

				return {
					id: port,
					group: group,
					attrs: {
						'.port-label': {
							text: port
						}
					}
				};
			},

			createPortItems: function (group, ports) {

				return joint.util.toArray(ports).map(this.createPortItem.bind(this, group));
			},

			_addGroupPort: function (port, group, opt) {

				var ports = this.get(group);
				return this.set(group, Array.isArray(ports) ? ports.concat(port) : [port], opt);
			},

			addOutPort: function (port, opt) {

				return this._addGroupPort(port, 'outPorts', opt);
			},

			addInPort: function (port, opt) {

				return this._addGroupPort(port, 'inPorts', opt);
			},

			_removeGroupPort: function (port, group, opt) {

				return this.set(group, joint.util.without(this.get(group), port), opt);
			},

			removeOutPort: function (port, opt) {

				return this._removeGroupPort(port, 'outPorts', opt);
			},

			removeInPort: function (port, opt) {

				return this._removeGroupPort(port, 'inPorts', opt);
			},

			_changeGroup: function (group, properties, opt) {

				return this.prop('ports/groups/' + group, joint.util.isObject(properties) ? properties : {}, opt);
			},

			changeInGroup: function (properties, opt) {

				return this._changeGroup('in', properties, opt);
			},

			changeOutGroup: function (properties, opt) {

				return this._changeGroup('out', properties, opt);
			}
		});

	joint.shapes.devs.Model.define('devs.Atomic', {
		size: {
			width: 80,
			height: 80
		},
		attrs: {
			'.label': {
				text: 'Atomic'
			}
		}
	});

	joint.shapes.devs.Model.define('devs.Coupled', {
		size: {
			width: 200,
			height: 300
		},
		attrs: {
			'.label': {
				text: 'Coupled'
			}
		}
	});

	joint.dia.Link.define('devs.Link', {
		attrs: {
			'.connection': {
				'stroke-width': 2
			}
		}
	});

	joint.shapes.basic.Generic.define('uml.Class', {
		attrs: {
			rect: { 'width': 200 },

			'.uml-class-name-rect': { 'stroke': 'black', 'stroke-width': 2, 'fill': '#3498db' },
			'.uml-class-attrs-rect': { 'stroke': 'black', 'stroke-width': 2, 'fill': '#2980b9' },
			'.uml-class-methods-rect': { 'stroke': 'black', 'stroke-width': 2, 'fill': '#2980b9' },

			'.uml-class-name-text': {
				'ref': '.uml-class-name-rect',
				'ref-y': .5,
				'ref-x': .5,
				'text-anchor': 'middle',
				'y-alignment': 'middle',
				'font-weight': 'bold',
				'fill': 'black',
				'font-size': 12,
				'font-family': 'Times New Roman'
			},
			'.uml-class-attrs-text': {
				'ref': '.uml-class-attrs-rect', 'ref-y': 5, 'ref-x': 5,
				'fill': 'black', 'font-size': 12, 'font-family': 'Times New Roman'
			},
			'.uml-class-methods-text': {
				'ref': '.uml-class-methods-rect', 'ref-y': 5, 'ref-x': 5,
				'fill': 'black', 'font-size': 12, 'font-family': 'Times New Roman'
			}
		},

		name: [],
		attributes: [],
		methods: []
	}, {
			markup: [
				'<g class="rotatable">',
				'<g class="scalable">',
				'<rect class="uml-class-name-rect"/><rect class="uml-class-attrs-rect"/><rect class="uml-class-methods-rect"/>',
				'</g>',
				'<text class="uml-class-name-text"/><text class="uml-class-attrs-text"/><text class="uml-class-methods-text"/>',
				'</g>'
			].join(''),

			initialize: function () {

				this.on('change:name change:attributes change:methods', function () {
					this.updateRectangles();
					this.trigger('uml-update');
				}, this);

				this.updateRectangles();

				joint.shapes.basic.Generic.prototype.initialize.apply(this, arguments);
			},

			getClassName: function () {
				return this.get('name');
			},

			updateRectangles: function () {

				var attrs = this.get('attrs');

				var rects = [
					{ type: 'name', text: this.getClassName() },
					{ type: 'attrs', text: this.get('attributes') },
					{ type: 'methods', text: this.get('methods') }
				];

				var offsetY = 0;

				rects.forEach(function (rect) {

					var lines = Array.isArray(rect.text) ? rect.text : [rect.text];
					var rectHeight = lines.length * 20 + 20;

					attrs['.uml-class-' + rect.type + '-text'].text = lines.join('\n');
					attrs['.uml-class-' + rect.type + '-rect'].height = rectHeight;
					attrs['.uml-class-' + rect.type + '-rect'].transform = 'translate(0,' + offsetY + ')';

					offsetY += rectHeight;
				});
			}

		});

	joint.shapes.uml.ClassView = joint.dia.ElementView.extend({}, {

		initialize: function () {

			joint.dia.ElementView.prototype.initialize.apply(this, arguments);

			this.listenTo(this.model, 'uml-update', function () {
				this.update();
				this.resize();
			});
		}
	});

	joint.shapes.uml.Class.define('uml.Abstract', {
		attrs: {
			'.uml-class-name-rect': { fill: '#e74c3c' },
			'.uml-class-attrs-rect': { fill: '#c0392b' },
			'.uml-class-methods-rect': { fill: '#c0392b' }
		}
	}, {

			getClassName: function () {
				return ['<<Abstract>>', this.get('name')];
			}

		});
	joint.shapes.uml.AbstractView = joint.shapes.uml.ClassView;

	joint.shapes.uml.Class.define('uml.Interface', {
		attrs: {
			'.uml-class-name-rect': { fill: '#f1c40f' },
			'.uml-class-attrs-rect': { fill: '#f39c12' },
			'.uml-class-methods-rect': { fill: '#f39c12' }
		}
	}, {
			getClassName: function () {
				return ['<<Interface>>', this.get('name')];
			}
		});
	joint.shapes.uml.InterfaceView = joint.shapes.uml.ClassView;

	joint.dia.Link.define('uml.Generalization', {
		attrs: { '.marker-target': { d: 'M 20 0 L 0 10 L 20 20 z', fill: 'white' } }
	});

	joint.dia.Link.define('uml.Implementation', {
		attrs: {
			'.marker-target': { d: 'M 20 0 L 0 10 L 20 20 z', fill: 'white' },
			'.connection': { 'stroke-dasharray': '3,3' }
		}
	});

	joint.dia.Link.define('uml.Aggregation', {
		attrs: { '.marker-target': { d: 'M 40 10 L 20 20 L 0 10 L 20 0 z', fill: 'white' } }
	});

	joint.dia.Link.define('uml.Composition', {
		attrs: { '.marker-target': { d: 'M 40 10 L 20 20 L 0 10 L 20 0 z', fill: 'black' } }
	});

	joint.dia.Link.define('uml.Association');

	// Statechart

	joint.shapes.basic.Generic.define('uml.State', {
		attrs: {
			'.uml-state-body': {
				'width': 200, 'height': 200, 'rx': 10, 'ry': 10,
				'fill': '#ecf0f1', 'stroke': '#bdc3c7', 'stroke-width': 3
			},
			'.uml-state-separator': {
				'stroke': '#bdc3c7', 'stroke-width': 2
			},
			'.uml-state-name': {
				'ref': '.uml-state-body', 'ref-x': .5, 'ref-y': 5, 'text-anchor': 'middle',
				'fill': '#000000', 'font-family': 'Courier New', 'font-size': 14
			},
			'.uml-state-events': {
				'ref': '.uml-state-separator', 'ref-x': 5, 'ref-y': 5,
				'fill': '#000000', 'font-family': 'Courier New', 'font-size': 14
			}
		},

		name: 'State',
		events: []

	}, {
			markup: [
				'<g class="rotatable">',
				'<g class="scalable">',
				'<rect class="uml-state-body"/>',
				'</g>',
				'<path class="uml-state-separator"/>',
				'<text class="uml-state-name"/>',
				'<text class="uml-state-events"/>',
				'</g>'
			].join(''),

			initialize: function () {

				this.on({
					'change:name': this.updateName,
					'change:events': this.updateEvents,
					'change:size': this.updatePath
				}, this);

				this.updateName();
				this.updateEvents();
				this.updatePath();

				joint.shapes.basic.Generic.prototype.initialize.apply(this, arguments);
			},

			updateName: function () {

				this.attr('.uml-state-name/text', this.get('name'));
			},

			updateEvents: function () {

				this.attr('.uml-state-events/text', this.get('events').join('\n'));
			},

			updatePath: function () {

				var d = 'M 0 20 L ' + this.get('size').width + ' 20';

				// We are using `silent: true` here because updatePath() is meant to be called
				// on resize and there's no need to to update the element twice (`change:size`
				// triggers also an update).
				this.attr('.uml-state-separator/d', d, { silent: true });
			}
		});

	joint.shapes.basic.Circle.define('uml.StartState', {
		type: 'uml.StartState',
		attrs: { circle: { 'fill': '#34495e', 'stroke': '#2c3e50', 'stroke-width': 2, 'rx': 1 } }
	});

	joint.shapes.basic.Generic.define('uml.EndState', {
		size: { width: 20, height: 20 },
		attrs: {
			'circle.outer': {
				transform: 'translate(10, 10)',
				r: 10,
				fill: '#ffffff',
				stroke: '#2c3e50'
			},

			'circle.inner': {
				transform: 'translate(10, 10)',
				r: 6,
				fill: '#34495e'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><circle class="outer"/><circle class="inner"/></g></g>',
		});

	joint.dia.Link.define('uml.Transition', {
		attrs: {
			'.marker-target': { d: 'M 10 0 L 0 5 L 10 10 z', fill: '#34495e', stroke: '#2c3e50' },
			'.connection': { stroke: '#2c3e50' }
		}
	});

	joint.shapes.basic.Generic.define('logic.Gate', {
		size: { width: 80, height: 40 },
		attrs: {
			'.': { magnet: false },
			'.body': { width: 100, height: 50 },
			circle: { r: 7, stroke: 'black', fill: 'transparent', 'stroke-width': 2 }
		}
	}, {
			operation: function () {
				return true;
			}
		});

	joint.shapes.logic.Gate.define('logic.IO', {
		size: { width: 60, height: 30 },
		attrs: {
			'.body': { fill: 'white', stroke: 'black', 'stroke-width': 2 },
			'.wire': { ref: '.body', 'ref-y': .5, stroke: 'black' },
			text: {
				fill: 'black',
				ref: '.body', 'ref-x': .5, 'ref-y': .5, 'y-alignment': 'middle',
				'text-anchor': 'middle',
				'font-weight': 'bold',
				'font-variant': 'small-caps',
				'text-transform': 'capitalize',
				'font-size': '14px'
			}
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><rect class="body"/></g><path class="wire"/><circle/><text/></g>',
		});

	joint.shapes.logic.IO.define('logic.Input', {
		attrs: {
			'.wire': { 'ref-dx': 0, d: 'M 0 0 L 23 0' },
			circle: { ref: '.body', 'ref-dx': 30, 'ref-y': 0.5, magnet: true, 'class': 'output', port: 'out' },
			text: { text: 'input' }
		}
	});

	joint.shapes.logic.IO.define('logic.Output', {
		attrs: {
			'.wire': { 'ref-x': 0, d: 'M 0 0 L -23 0' },
			circle: { ref: '.body', 'ref-x': -30, 'ref-y': 0.5, magnet: 'passive', 'class': 'input', port: 'in' },
			text: { text: 'output' }
		}
	});

	joint.shapes.logic.Gate.define('logic.Gate11', {
		attrs: {
			'.input': { ref: '.body', 'ref-x': -2, 'ref-y': 0.5, magnet: 'passive', port: 'in' },
			'.output': { ref: '.body', 'ref-dx': 2, 'ref-y': 0.5, magnet: true, port: 'out' }
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><image class="body"/></g><circle class="input"/><circle class="output"/></g>',
		});

	joint.shapes.logic.Gate.define('logic.Gate21', {
		attrs: {
			'.input1': { ref: '.body', 'ref-x': -2, 'ref-y': 0.3, magnet: 'passive', port: 'in1' },
			'.input2': { ref: '.body', 'ref-x': -2, 'ref-y': 0.7, magnet: 'passive', port: 'in2' },
			'.output': { ref: '.body', 'ref-dx': 2, 'ref-y': 0.5, magnet: true, port: 'out' }
		}
	}, {
			markup: '<g class="rotatable"><g class="scalable"><image class="body"/></g><circle class="input input1"/><circle  class="input input2"/><circle class="output"/></g>',
		});

	joint.shapes.logic.Gate11.define('logic.Repeater', {
		attrs: { image: { 'xlink:href': 'data:image/svg+xml;base64,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' } }
	}, {
			operation: function (input) {
				return input;
			}
		});

	joint.shapes.logic.Gate11.define('logic.Not', {
		attrs: { image: { 'xlink:href': 'data:image/svg+xml;base64,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' } }
	}, {
			operation: function (input) {
				return !input;
			}
		});

	joint.shapes.logic.Gate21.define('logic.Or', {
		attrs: { image: { 'xlink:href': 'data:image/svg+xml;base64,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' } }
	}, {
			operation: function (input1, input2) {
				return input1 || input2;
			}
		});

	joint.shapes.logic.Gate21.define('logic.And', {
		attrs: { image: { 'xlink:href': 'data:image/svg+xml;base64,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' } }

	}, {
			operation: function (input1, input2) {
				return input1 && input2;
			}
		});

	joint.shapes.logic.Gate21.define('logic.Nor', {
		attrs: { image: { 'xlink:href': 'data:image/svg+xml;base64,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' } }
	}, {
			operation: function (input1, input2) {
				return !(input1 || input2);
			}
		});

	joint.shapes.logic.Gate21.define('logic.Nand', {
		attrs: { image: { 'xlink:href': 'data:image/svg+xml;base64,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' } }
	}, {
			operation: function (input1, input2) {
				return !(input1 && input2);
			}
		});

	joint.shapes.logic.Gate21.define('logic.Xor', {
		attrs: { image: { 'xlink:href': 'data:image/svg+xml;base64,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' } }
	}, {
			operation: function (input1, input2) {
				return (!input1 || input2) && (input1 || !input2);
			}
		});

	joint.shapes.logic.Gate21.define('logic.Xnor', {
		attrs: { image: { 'xlink:href': 'data:image/svg+xml;base64,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' } }
	}, {
			operation: function (input1, input2) {
				return (!input1 || !input2) && (input1 || input2);
			}
		});

	joint.dia.Link.define('logic.Wire', {
		attrs: {
			'.connection': { 'stroke-width': 2 },
			'.marker-vertex': { r: 7 }
		},

		router: { name: 'orthogonal' },
		connector: { name: 'rounded', args: { radius: 10 } }
	}, {
			arrowheadMarkup: [
				'<g class="marker-arrowhead-group marker-arrowhead-group-<%= end %>">',
				'<circle class="marker-arrowhead" end="<%= end %>" r="7"/>',
				'</g>'
			].join(''),

			vertexMarkup: [
				'<g class="marker-vertex-group" transform="translate(<%= x %>, <%= y %>)">',
				'<circle class="marker-vertex" idx="<%= idx %>" r="10" />',
				'<g class="marker-vertex-remove-group">',
				'<path class="marker-vertex-remove-area" idx="<%= idx %>" d="M16,5.333c-7.732,0-14,4.701-14,10.5c0,1.982,0.741,3.833,2.016,5.414L2,25.667l5.613-1.441c2.339,1.317,5.237,2.107,8.387,2.107c7.732,0,14-4.701,14-10.5C30,10.034,23.732,5.333,16,5.333z" transform="translate(5, -33)"/>',
				'<path class="marker-vertex-remove" idx="<%= idx %>" transform="scale(.8) translate(9.5, -37)" d="M24.778,21.419 19.276,15.917 24.777,10.415 21.949,7.585 16.447,13.087 10.945,7.585 8.117,10.415 13.618,15.917 8.116,21.419 10.946,24.248 16.447,18.746 21.948,24.248z">',
				'<title>Remove vertex.</title>',
				'</path>',
				'</g>',
				'</g>'
			].join('')
		});

	if (typeof exports === 'object') {

		var graphlib = require('graphlib');
		var dagre = require('dagre');
	}

	// In the browser, these variables are set to undefined because of JavaScript hoisting.
	// In that case, should grab them from the window object.
	graphlib = graphlib || (typeof window !== 'undefined' && window.graphlib);
	dagre = dagre || (typeof window !== 'undefined' && window.dagre);

	joint.layout.DirectedGraph = {

		exportElement: function (element) {

			// The width and height of the element.
			return element.size();
		},

		exportLink: function (link) {

			var labelSize = link.get('labelSize') || {};
			var edge = {
				// The number of ranks to keep between the source and target of the edge.
				minLen: link.get('minLen') || 1,
				// The weight to assign edges. Higher weight edges are generally
				// made shorter and straighter than lower weight edges.
				weight: link.get('weight') || 1,
				// Where to place the label relative to the edge.
				// l = left, c = center r = right.
				labelpos: link.get('labelPosition') || 'c',
				// How many pixels to move the label away from the edge.
				// Applies only when labelpos is l or r.
				labeloffset: link.get('labelOffset') || 0,
				// The width of the edge label in pixels.
				width: labelSize.width || 0,
				// The height of the edge label in pixels.
				height: labelSize.height || 0
			};

			return edge;
		},

		importElement: function (opt, v, gl) {

			var element = this.getCell(v);
			var glNode = gl.node(v);

			if (opt.setPosition) {
				opt.setPosition(element, glNode);
			} else {
				element.set('position', {
					x: glNode.x - glNode.width / 2,
					y: glNode.y - glNode.height / 2
				});
			}
		},

		importLink: function (opt, edgeObj, gl) {

			var link = this.getCell(edgeObj.name);
			var glEdge = gl.edge(edgeObj);
			var points = glEdge.points || [];

			// check the `setLinkVertices` here for backwards compatibility
			if (opt.setVertices || opt.setLinkVertices) {
				if (joint.util.isFunction(opt.setVertices)) {
					opt.setVertices(link, points);
				} else {
					// Remove the first and last point from points array.
					// Those are source/target element connection points
					// ie. they lies on the edge of connected elements.
					link.set('vertices', points.slice(1, points.length - 1));
				}
			}

			if (opt.setLabels && ('x' in glEdge) && ('y' in glEdge)) {
				var labelPosition = { x: glEdge.x, y: glEdge.y };
				if (joint.util.isFunction(opt.setLabels)) {
					opt.setLabels(link, labelPosition, points);
				} else {
					// Convert the absolute label position to a relative position
					// towards the closest point on the edge
					var polyline = g.Polyline(points);
					var length = polyline.closestPointLength(labelPosition);
					var closestPoint = polyline.pointAtLength(length);
					var distance = length / polyline.length();
					link.label(0, {
						position: {
							distance: distance,
							offset: g.Point(labelPosition).difference(closestPoint).toJSON()
						}
					});
				}
			}
		},

		layout: function (graphOrCells, opt) {

			var graph;

			if (graphOrCells instanceof joint.dia.Graph) {
				graph = graphOrCells;
			} else {
				// Reset cells in dry mode so the graph reference is not stored on the cells.
				graph = (new joint.dia.Graph()).resetCells(graphOrCells, { dry: true });
			}

			// This is not needed anymore.
			graphOrCells = null;

			opt = joint.util.defaults(opt || {}, {
				resizeClusters: true,
				clusterPadding: 10,
				exportElement: this.exportElement,
				exportLink: this.exportLink
			});

			// create a graphlib.Graph that represents the joint.dia.Graph
			var glGraph = graph.toGraphLib({
				directed: true,
				// We are about to use edge naming feature.
				multigraph: true,
				// We are able to layout graphs with embeds.
				compound: true,
				setNodeLabel: opt.exportElement,
				setEdgeLabel: opt.exportLink,
				setEdgeName: function (link) {
					// Graphlib edges have no ids. We use edge name property
					// to store and retrieve ids instead.
					return link.id;
				}
			});

			var glLabel = {};
			var marginX = opt.marginX || 0;
			var marginY = opt.marginY || 0;

			// Dagre layout accepts options as lower case.
			// Direction for rank nodes. Can be TB, BT, LR, or RL
			if (opt.rankDir) glLabel.rankdir = opt.rankDir;
			// Alignment for rank nodes. Can be UL, UR, DL, or DR
			if (opt.align) glLabel.align = opt.align;
			// Number of pixels that separate nodes horizontally in the layout.
			if (opt.nodeSep) glLabel.nodesep = opt.nodeSep;
			// Number of pixels that separate edges horizontally in the layout.
			if (opt.edgeSep) glLabel.edgesep = opt.edgeSep;
			// Number of pixels between each rank in the layout.
			if (opt.rankSep) glLabel.ranksep = opt.rankSep;
			// Type of algorithm to assign a rank to each node in the input graph.
			// Possible values: network-simplex, tight-tree or longest-path
			if (opt.ranker) glLabel.ranker = opt.ranker;
			// Number of pixels to use as a margin around the left and right of the graph.
			if (marginX) glLabel.marginx = marginX;
			// Number of pixels to use as a margin around the top and bottom of the graph.
			if (marginY) glLabel.marginy = marginY;

			// Set the option object for the graph label.
			glGraph.setGraph(glLabel);

			// Executes the layout.
			dagre.layout(glGraph, { debugTiming: !!opt.debugTiming });

			// Wrap all graph changes into a batch.
			graph.startBatch('layout');

			// Update the graph.
			graph.fromGraphLib(glGraph, {
				importNode: this.importElement.bind(graph, opt),
				importEdge: this.importLink.bind(graph, opt)
			});

			if (opt.resizeClusters) {
				// Resize and reposition cluster elements (parents of other elements)
				// to fit their children.
				// 1. filter clusters only
				// 2. map id on cells
				// 3. sort cells by their depth (the deepest first)
				// 4. resize cell to fit their direct children only.
				var clusters = glGraph.nodes()
					.filter(function (v) { return glGraph.children(v).length > 0; })
					.map(graph.getCell.bind(graph))
					.sort(function (aCluster, bCluster) {
						return bCluster.getAncestors().length - aCluster.getAncestors().length;
					});

				joint.util.invoke(clusters, 'fitEmbeds', { padding: opt.clusterPadding });
			}

			graph.stopBatch('layout');

			// Width and height of the graph extended by margins.
			var glSize = glGraph.graph();
			// Return the bounding box of the graph after the layout.
			return g.Rect(
				marginX,
				marginY,
				Math.abs(glSize.width - 2 * marginX),
				Math.abs(glSize.height - 2 * marginY)
			);
		},

		fromGraphLib: function (glGraph, opt) {

			opt = opt || {};

			var importNode = opt.importNode || joint.util.noop;
			var importEdge = opt.importEdge || joint.util.noop;
			var graph = (this instanceof joint.dia.Graph) ? this : new joint.dia.Graph;

			// Import all nodes.
			glGraph.nodes().forEach(function (node) {
				importNode.call(graph, node, glGraph, graph, opt);
			});

			// Import all edges.
			glGraph.edges().forEach(function (edge) {
				importEdge.call(graph, edge, glGraph, graph, opt);
			});

			return graph;
		},

		// Create new graphlib graph from existing JointJS graph.
		toGraphLib: function (graph, opt) {

			opt = opt || {};

			var glGraphType = joint.util.pick(opt, 'directed', 'compound', 'multigraph');
			var glGraph = new graphlib.Graph(glGraphType);
			var setNodeLabel = opt.setNodeLabel || joint.util.noop;
			var setEdgeLabel = opt.setEdgeLabel || joint.util.noop;
			var setEdgeName = opt.setEdgeName || joint.util.noop;
			var collection = graph.get('cells');

			for (var i = 0, n = collection.length; i < n; i++) {

				var cell = collection.at(i);
				if (cell.isLink()) {

					var source = cell.get('source');
					var target = cell.get('target');

					// Links that end at a point are ignored.
					if (!source.id || !target.id) break;

					// Note that if we are creating a multigraph we can name the edges. If
					// we try to name edges on a non-multigraph an exception is thrown.
					glGraph.setEdge(source.id, target.id, setEdgeLabel(cell), setEdgeName(cell));

				} else {

					glGraph.setNode(cell.id, setNodeLabel(cell));

					// For the compound graphs we have to take embeds into account.
					if (glGraph.isCompound() && cell.has('parent')) {
						var parentId = cell.get('parent');
						if (collection.has(parentId)) {
							// Make sure the parent cell is included in the graph (this can
							// happen when the layout is run on part of the graph only).
							glGraph.setParent(cell.id, parentId);
						}
					}
				}
			}

			return glGraph;
		}
	};

	joint.dia.Graph.prototype.toGraphLib = function (opt) {

		return joint.layout.DirectedGraph.toGraphLib(this, opt);
	};

	joint.dia.Graph.prototype.fromGraphLib = function (glGraph, opt) {

		return joint.layout.DirectedGraph.fromGraphLib.call(this, glGraph, opt);
	};

	// Highly inspired by Raphael Library (www.raphael.com).
	if (typeof SVGPathElement !== 'undefined') {
		SVGPathElement.prototype.normalizePath = (function () {

			var spaces = "\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029";
			var pathCommand = new RegExp("([a-z])[" + spaces + ",]*((-?\\d*\\.?\\d*(?:e[\\-+]?\\d+)?[" + spaces + "]*,?[" + spaces + "]*)+)", "ig");
			var pathValues = new RegExp("(-?\\d*\\.?\\d*(?:e[\\-+]?\\d+)?)[" + spaces + "]*,?[" + spaces + "]*", "ig");

			function l2c(x1, y1, x2, y2) {
				return [x1, y1, x2, y2, x2, y2];
			}

			function q2c(x1, y1, ax, ay, x2, y2) {
				var _13 = 1 / 3, _23 = 2 / 3;
				return [_13 * x1 + _23 * ax, _13 * y1 + _23 * ay, _13 * x2 + _23 * ax, _13 * y2 + _23 * ay, x2, y2];
			}

			function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
				// for more information of where this math came from visit:
				// http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
				var _120 = Math.PI * 120 / 180, rad = Math.PI / 180 * (+angle || 0), res = [], xy;

				var rotate = function (x, y, rad) {
					var X = x * Math.cos(rad) - y * Math.sin(rad), Y = x * Math.sin(rad) + y * Math.cos(rad);
					return { x: X, y: Y };
				};

				if (!recursive) {
					xy = rotate(x1, y1, -rad);
					x1 = xy.x;
					y1 = xy.y;
					xy = rotate(x2, y2, -rad);
					x2 = xy.x;
					y2 = xy.y;

					var cos = Math.cos(Math.PI / 180 * angle),
						sin = Math.sin(Math.PI / 180 * angle),
						x = (x1 - x2) / 2,
						y = (y1 - y2) / 2,
						h = (x * x) / (rx * rx) + (y * y) / (ry * ry);

					if (h > 1) {
						h = Math.sqrt(h);
						rx = h * rx;
						ry = h * ry;
					}
					var rx2 = rx * rx,
						ry2 = ry * ry,
						k = (large_arc_flag == sweep_flag ? -1 : 1) * Math.sqrt(Math.abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
						cx = k * rx * y / ry + (x1 + x2) / 2,
						cy = k * -ry * x / rx + (y1 + y2) / 2,
						f1 = Math.asin(((y1 - cy) / ry).toFixed(9)),
						f2 = Math.asin(((y2 - cy) / ry).toFixed(9));

					f1 = x1 < cx ? Math.PI - f1 : f1;
					f2 = x2 < cx ? Math.PI - f2 : f2;
					f1 < 0 && (f1 = Math.PI * 2 + f1);
					f2 < 0 && (f2 = Math.PI * 2 + f2);

					if (sweep_flag && f1 > f2) f1 = f1 - Math.PI * 2;
					if (!sweep_flag && f2 > f1) f2 = f2 - Math.PI * 2;

				} else {
					f1 = recursive[0];
					f2 = recursive[1];
					cx = recursive[2];
					cy = recursive[3];
				}

				var df = f2 - f1;

				if (Math.abs(df) > _120) {

					var f2old = f2,
						x2old = x2,
						y2old = y2;

					f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
					x2 = cx + rx * Math.cos(f2);
					y2 = cy + ry * Math.sin(f2);
					res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
				}
				df = f2 - f1;

				var c1 = Math.cos(f1),
					s1 = Math.sin(f1),
					c2 = Math.cos(f2),
					s2 = Math.sin(f2),
					t = Math.tan(df / 4),
					hx = 4 / 3 * rx * t,
					hy = 4 / 3 * ry * t,
					m1 = [x1, y1],
					m2 = [x1 + hx * s1, y1 - hy * c1],
					m3 = [x2 + hx * s2, y2 - hy * c2],
					m4 = [x2, y2];

				m2[0] = 2 * m1[0] - m2[0];
				m2[1] = 2 * m1[1] - m2[1];

				if (recursive) {
					return [m2, m3, m4].concat(res);
				} else {

					res = [m2, m3, m4].concat(res).join().split(",");
					var newres = [];
					for (var i = 0, ii = res.length; i < ii; i++) {
						newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
					}
					return newres;
				}
			}

			function parsePathString(pathString) {

				if (!pathString) {
					return null;
				}

				var paramCounts = { a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0 }, data = [];

				String(pathString).replace(pathCommand, function (a, b, c) {
					var params = [], name = b.toLowerCase();
					c.replace(pathValues, function (a, b) {
						b && params.push(+b);
					});
					if (name == "m" && params.length > 2) {
						data.push([b].concat(params.splice(0, 2)));
						name = "l";
						b = b == "m" ? "l" : "L";
					}
					while (params.length >= paramCounts[name]) {
						data.push([b].concat(params.splice(0, paramCounts[name])));
						if (!paramCounts[name]) {
							break;
						}
					}
				});

				return data;
			};

			function pathToAbsolute(pathArray) {

				if (!_.isArray(pathArray) || !_.isArray(pathArray && pathArray[0])) { // rough assumption
					pathArray = parsePathString(pathArray);
				}

				if (!pathArray || !pathArray.length) return [["M", 0, 0]];

				var res = [], x = 0, y = 0, mx = 0, my = 0, start = 0, pa0;

				if (pathArray[0][0] == "M") {
					x = +pathArray[0][1];
					y = +pathArray[0][2];
					mx = x;
					my = y;
					start++;
					res[0] = ["M", x, y];
				}

				for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
					res.push(r = []);
					pa = pathArray[i];
					pa0 = pa[0];
					if (pa0 != pa0.toUpperCase()) {
						r[0] = pa0.toUpperCase();
						switch (r[0]) {
							case "A":
								r[1] = pa[1];
								r[2] = pa[2];
								r[3] = pa[3];
								r[4] = pa[4];
								r[5] = pa[5];
								r[6] = +pa[6] + x;
								r[7] = +pa[7] + y;
								break;
							case "V":
								r[1] = +pa[1] + y;
								break;
							case "H":
								r[1] = +pa[1] + x;
								break;
							case "M":
								mx = +pa[1] + x;
								my = +pa[2] + y;
							default:
								for (var j = 1, jj = pa.length; j < jj; j++) {
									r[j] = +pa[j] + ((j % 2) ? x : y);
								}
						}
					} else {
						for (var k = 0, kk = pa.length; k < kk; k++) {
							r[k] = pa[k];
						}
					}

					switch (r[0]) {
						case "Z":
							x = +mx;
							y = +my;
							break;
						case "H":
							x = r[1];
							break;
						case "V":
							y = r[1];
							break;
						case "M":
							mx = r[r.length - 2];
							my = r[r.length - 1];
						default:
							x = r[r.length - 2];
							y = r[r.length - 1];
					}
				}

				return res;
			}

			function normalize(path) {

				var p = pathToAbsolute(path), attrs = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null };

				function processPath(path, d, pcom) {
					var nx, ny;
					if (!path) {
						return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
					}
					!(path[0] in { T: 1, Q: 1 }) && (d.qx = d.qy = null);
					switch (path[0]) {
						case "M":
							d.X = path[1];
							d.Y = path[2];
							break;
						case "A":
							path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
							break;
						case "S":
							if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
								nx = d.x * 2 - d.bx;          // And reflect the previous
								ny = d.y * 2 - d.by;          // command's control point relative to the current point.
							}
							else {                            // or some else or nothing
								nx = d.x;
								ny = d.y;
							}
							path = ["C", nx, ny].concat(path.slice(1));
							break;
						case "T":
							if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
								d.qx = d.x * 2 - d.qx;        // And make a reflection similar
								d.qy = d.y * 2 - d.qy;        // to case "S".
							}
							else {                            // or something else or nothing
								d.qx = d.x;
								d.qy = d.y;
							}
							path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
							break;
						case "Q":
							d.qx = path[1];
							d.qy = path[2];
							path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
							break;
						case "H":
							path = ["L"].concat(path[1], d.y);
							break;
						case "V":
							path = ["L"].concat(d.x, path[1]);
							break;
						case "L":
						case "Z":
							// leave L & Z commands as they were
							break;
					}
					return path;
				}

				function fixArc(pp, i) {
					if (pp[i].length > 7) {
						pp[i].shift();
						var pi = pp[i];
						while (pi.length) {
							pcoms[i] = "A"; // if created multiple C:s, their original seg is saved
							pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
						}
						pp.splice(i, 1);
						ii = p.length;
					}
				}

				var pcoms = [], // path commands of original path p
					pfirst = "", // temporary holder for original path command
					pcom = ""; // holder for previous path command of original path

				for (var i = 0, ii = p.length; i < ii; i++) {
					p[i] && (pfirst = p[i][0]); // save current path command

					if (pfirst != "C") // C is not saved yet, because it may be result of conversion
					{
						pcoms[i] = pfirst; // Save current path command
						i && (pcom = pcoms[i - 1]); // Get previous path command pcom
					}
					p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath

					if (pcoms[i] != "A" && pfirst == "C") pcoms[i] = "C"; // A is the only command
					// which may produce multiple C:s
					// so we have to make sure that C is also C in original path

					fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms

					var seg = p[i], seglen = seg.length;
					attrs.x = seg[seglen - 2];
					attrs.y = seg[seglen - 1];
					attrs.bx = parseFloat(seg[seglen - 4]) || attrs.x;
					attrs.by = parseFloat(seg[seglen - 3]) || attrs.y;
				}

				return p;
			}

			return function () {
				var el = V(this);
				return el.attr('d', normalize(el.attr('d')).join(',').split(',').join(' ')).node;
			};

		})();
	}

	/**
	 * Copyright 2015 The Chromium Authors. All rights reserved.
	 *
	 * The Chromium Authors can be found at
	 * http://src.chromium.org/svn/trunk/src/AUTHORS
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 *    * Redistributions of source code must retain the above copyright
	 * notice, this list of conditions and the following disclaimer.
	 *    * Redistributions in binary form must reproduce the above
	 * copyright notice, this list of conditions and the following disclaimer
	 * in the documentation and/or other materials provided with the
	 * distribution.
	 *    * Neither the name of Google Inc. nor the names of its
	 * contributors may be used to endorse or promote products derived from
	 * this software without specific prior written permission.
	
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */

	// SVGPathSeg API polyfill
	// https://github.com/progers/pathseg
	//
	// This is a drop-in replacement for the SVGPathSeg and SVGPathSegList APIs that were removed from
	// SVG2 (https://lists.w3.org/Archives/Public/www-svg/2015Jun/0044.html), including the latest spec
	// changes which were implemented in Firefox 43 and Chrome 46.

	(function () {
		"use strict";
		if (typeof window !== 'undefined' && !("SVGPathSeg" in window)) {
			// Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSeg
			window.SVGPathSeg = function (type, typeAsLetter, owningPathSegList) {
				this.pathSegType = type;
				this.pathSegTypeAsLetter = typeAsLetter;
				this._owningPathSegList = owningPathSegList;
			}

			window.SVGPathSeg.prototype.classname = "SVGPathSeg";

			window.SVGPathSeg.PATHSEG_UNKNOWN = 0;
			window.SVGPathSeg.PATHSEG_CLOSEPATH = 1;
			window.SVGPathSeg.PATHSEG_MOVETO_ABS = 2;
			window.SVGPathSeg.PATHSEG_MOVETO_REL = 3;
			window.SVGPathSeg.PATHSEG_LINETO_ABS = 4;
			window.SVGPathSeg.PATHSEG_LINETO_REL = 5;
			window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6;
			window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7;
			window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8;
			window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9;
			window.SVGPathSeg.PATHSEG_ARC_ABS = 10;
			window.SVGPathSeg.PATHSEG_ARC_REL = 11;
			window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12;
			window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13;
			window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14;
			window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15;
			window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16;
			window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17;
			window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18;
			window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19;

			// Notify owning PathSegList on any changes so they can be synchronized back to the path element.
			window.SVGPathSeg.prototype._segmentChanged = function () {
				if (this._owningPathSegList)
					this._owningPathSegList.segmentChanged(this);
			}

			window.SVGPathSegClosePath = function (owningPathSegList) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CLOSEPATH, "z", owningPathSegList);
			}
			window.SVGPathSegClosePath.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegClosePath.prototype.toString = function () { return "[object SVGPathSegClosePath]"; }
			window.SVGPathSegClosePath.prototype._asPathString = function () { return this.pathSegTypeAsLetter; }
			window.SVGPathSegClosePath.prototype.clone = function () { return new window.SVGPathSegClosePath(undefined); }

			window.SVGPathSegMovetoAbs = function (owningPathSegList, x, y) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_ABS, "M", owningPathSegList);
				this._x = x;
				this._y = y;
			}
			window.SVGPathSegMovetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegMovetoAbs.prototype.toString = function () { return "[object SVGPathSegMovetoAbs]"; }
			window.SVGPathSegMovetoAbs.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
			window.SVGPathSegMovetoAbs.prototype.clone = function () { return new window.SVGPathSegMovetoAbs(undefined, this._x, this._y); }
			Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegMovetoRel = function (owningPathSegList, x, y) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_REL, "m", owningPathSegList);
				this._x = x;
				this._y = y;
			}
			window.SVGPathSegMovetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegMovetoRel.prototype.toString = function () { return "[object SVGPathSegMovetoRel]"; }
			window.SVGPathSegMovetoRel.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
			window.SVGPathSegMovetoRel.prototype.clone = function () { return new window.SVGPathSegMovetoRel(undefined, this._x, this._y); }
			Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegLinetoAbs = function (owningPathSegList, x, y) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_ABS, "L", owningPathSegList);
				this._x = x;
				this._y = y;
			}
			window.SVGPathSegLinetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegLinetoAbs.prototype.toString = function () { return "[object SVGPathSegLinetoAbs]"; }
			window.SVGPathSegLinetoAbs.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
			window.SVGPathSegLinetoAbs.prototype.clone = function () { return new window.SVGPathSegLinetoAbs(undefined, this._x, this._y); }
			Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegLinetoRel = function (owningPathSegList, x, y) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_REL, "l", owningPathSegList);
				this._x = x;
				this._y = y;
			}
			window.SVGPathSegLinetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegLinetoRel.prototype.toString = function () { return "[object SVGPathSegLinetoRel]"; }
			window.SVGPathSegLinetoRel.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
			window.SVGPathSegLinetoRel.prototype.clone = function () { return new window.SVGPathSegLinetoRel(undefined, this._x, this._y); }
			Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegCurvetoCubicAbs = function (owningPathSegList, x, y, x1, y1, x2, y2) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS, "C", owningPathSegList);
				this._x = x;
				this._y = y;
				this._x1 = x1;
				this._y1 = y1;
				this._x2 = x2;
				this._y2 = y2;
			}
			window.SVGPathSegCurvetoCubicAbs.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegCurvetoCubicAbs.prototype.toString = function () { return "[object SVGPathSegCurvetoCubicAbs]"; }
			window.SVGPathSegCurvetoCubicAbs.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y; }
			window.SVGPathSegCurvetoCubicAbs.prototype.clone = function () { return new window.SVGPathSegCurvetoCubicAbs(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2); }
			Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x1", { get: function () { return this._x1; }, set: function (x1) { this._x1 = x1; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y1", { get: function () { return this._y1; }, set: function (y1) { this._y1 = y1; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x2", { get: function () { return this._x2; }, set: function (x2) { this._x2 = x2; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y2", { get: function () { return this._y2; }, set: function (y2) { this._y2 = y2; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegCurvetoCubicRel = function (owningPathSegList, x, y, x1, y1, x2, y2) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL, "c", owningPathSegList);
				this._x = x;
				this._y = y;
				this._x1 = x1;
				this._y1 = y1;
				this._x2 = x2;
				this._y2 = y2;
			}
			window.SVGPathSegCurvetoCubicRel.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegCurvetoCubicRel.prototype.toString = function () { return "[object SVGPathSegCurvetoCubicRel]"; }
			window.SVGPathSegCurvetoCubicRel.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y; }
			window.SVGPathSegCurvetoCubicRel.prototype.clone = function () { return new window.SVGPathSegCurvetoCubicRel(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2); }
			Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x1", { get: function () { return this._x1; }, set: function (x1) { this._x1 = x1; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y1", { get: function () { return this._y1; }, set: function (y1) { this._y1 = y1; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x2", { get: function () { return this._x2; }, set: function (x2) { this._x2 = x2; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y2", { get: function () { return this._y2; }, set: function (y2) { this._y2 = y2; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegCurvetoQuadraticAbs = function (owningPathSegList, x, y, x1, y1) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS, "Q", owningPathSegList);
				this._x = x;
				this._y = y;
				this._x1 = x1;
				this._y1 = y1;
			}
			window.SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegCurvetoQuadraticAbs.prototype.toString = function () { return "[object SVGPathSegCurvetoQuadraticAbs]"; }
			window.SVGPathSegCurvetoQuadraticAbs.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y; }
			window.SVGPathSegCurvetoQuadraticAbs.prototype.clone = function () { return new window.SVGPathSegCurvetoQuadraticAbs(undefined, this._x, this._y, this._x1, this._y1); }
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x1", { get: function () { return this._x1; }, set: function (x1) { this._x1 = x1; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y1", { get: function () { return this._y1; }, set: function (y1) { this._y1 = y1; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegCurvetoQuadraticRel = function (owningPathSegList, x, y, x1, y1) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL, "q", owningPathSegList);
				this._x = x;
				this._y = y;
				this._x1 = x1;
				this._y1 = y1;
			}
			window.SVGPathSegCurvetoQuadraticRel.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegCurvetoQuadraticRel.prototype.toString = function () { return "[object SVGPathSegCurvetoQuadraticRel]"; }
			window.SVGPathSegCurvetoQuadraticRel.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y; }
			window.SVGPathSegCurvetoQuadraticRel.prototype.clone = function () { return new window.SVGPathSegCurvetoQuadraticRel(undefined, this._x, this._y, this._x1, this._y1); }
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x1", { get: function () { return this._x1; }, set: function (x1) { this._x1 = x1; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y1", { get: function () { return this._y1; }, set: function (y1) { this._y1 = y1; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegArcAbs = function (owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_ABS, "A", owningPathSegList);
				this._x = x;
				this._y = y;
				this._r1 = r1;
				this._r2 = r2;
				this._angle = angle;
				this._largeArcFlag = largeArcFlag;
				this._sweepFlag = sweepFlag;
			}
			window.SVGPathSegArcAbs.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegArcAbs.prototype.toString = function () { return "[object SVGPathSegArcAbs]"; }
			window.SVGPathSegArcAbs.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y; }
			window.SVGPathSegArcAbs.prototype.clone = function () { return new window.SVGPathSegArcAbs(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag); }
			Object.defineProperty(window.SVGPathSegArcAbs.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcAbs.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r1", { get: function () { return this._r1; }, set: function (r1) { this._r1 = r1; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r2", { get: function () { return this._r2; }, set: function (r2) { this._r2 = r2; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcAbs.prototype, "angle", { get: function () { return this._angle; }, set: function (angle) { this._angle = angle; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcAbs.prototype, "largeArcFlag", { get: function () { return this._largeArcFlag; }, set: function (largeArcFlag) { this._largeArcFlag = largeArcFlag; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcAbs.prototype, "sweepFlag", { get: function () { return this._sweepFlag; }, set: function (sweepFlag) { this._sweepFlag = sweepFlag; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegArcRel = function (owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_REL, "a", owningPathSegList);
				this._x = x;
				this._y = y;
				this._r1 = r1;
				this._r2 = r2;
				this._angle = angle;
				this._largeArcFlag = largeArcFlag;
				this._sweepFlag = sweepFlag;
			}
			window.SVGPathSegArcRel.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegArcRel.prototype.toString = function () { return "[object SVGPathSegArcRel]"; }
			window.SVGPathSegArcRel.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y; }
			window.SVGPathSegArcRel.prototype.clone = function () { return new window.SVGPathSegArcRel(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag); }
			Object.defineProperty(window.SVGPathSegArcRel.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcRel.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcRel.prototype, "r1", { get: function () { return this._r1; }, set: function (r1) { this._r1 = r1; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcRel.prototype, "r2", { get: function () { return this._r2; }, set: function (r2) { this._r2 = r2; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcRel.prototype, "angle", { get: function () { return this._angle; }, set: function (angle) { this._angle = angle; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcRel.prototype, "largeArcFlag", { get: function () { return this._largeArcFlag; }, set: function (largeArcFlag) { this._largeArcFlag = largeArcFlag; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegArcRel.prototype, "sweepFlag", { get: function () { return this._sweepFlag; }, set: function (sweepFlag) { this._sweepFlag = sweepFlag; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegLinetoHorizontalAbs = function (owningPathSegList, x) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS, "H", owningPathSegList);
				this._x = x;
			}
			window.SVGPathSegLinetoHorizontalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegLinetoHorizontalAbs.prototype.toString = function () { return "[object SVGPathSegLinetoHorizontalAbs]"; }
			window.SVGPathSegLinetoHorizontalAbs.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x; }
			window.SVGPathSegLinetoHorizontalAbs.prototype.clone = function () { return new window.SVGPathSegLinetoHorizontalAbs(undefined, this._x); }
			Object.defineProperty(window.SVGPathSegLinetoHorizontalAbs.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegLinetoHorizontalRel = function (owningPathSegList, x) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL, "h", owningPathSegList);
				this._x = x;
			}
			window.SVGPathSegLinetoHorizontalRel.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegLinetoHorizontalRel.prototype.toString = function () { return "[object SVGPathSegLinetoHorizontalRel]"; }
			window.SVGPathSegLinetoHorizontalRel.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x; }
			window.SVGPathSegLinetoHorizontalRel.prototype.clone = function () { return new window.SVGPathSegLinetoHorizontalRel(undefined, this._x); }
			Object.defineProperty(window.SVGPathSegLinetoHorizontalRel.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegLinetoVerticalAbs = function (owningPathSegList, y) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS, "V", owningPathSegList);
				this._y = y;
			}
			window.SVGPathSegLinetoVerticalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegLinetoVerticalAbs.prototype.toString = function () { return "[object SVGPathSegLinetoVerticalAbs]"; }
			window.SVGPathSegLinetoVerticalAbs.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._y; }
			window.SVGPathSegLinetoVerticalAbs.prototype.clone = function () { return new window.SVGPathSegLinetoVerticalAbs(undefined, this._y); }
			Object.defineProperty(window.SVGPathSegLinetoVerticalAbs.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegLinetoVerticalRel = function (owningPathSegList, y) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL, "v", owningPathSegList);
				this._y = y;
			}
			window.SVGPathSegLinetoVerticalRel.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegLinetoVerticalRel.prototype.toString = function () { return "[object SVGPathSegLinetoVerticalRel]"; }
			window.SVGPathSegLinetoVerticalRel.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._y; }
			window.SVGPathSegLinetoVerticalRel.prototype.clone = function () { return new window.SVGPathSegLinetoVerticalRel(undefined, this._y); }
			Object.defineProperty(window.SVGPathSegLinetoVerticalRel.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegCurvetoCubicSmoothAbs = function (owningPathSegList, x, y, x2, y2) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS, "S", owningPathSegList);
				this._x = x;
				this._y = y;
				this._x2 = x2;
				this._y2 = y2;
			}
			window.SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegCurvetoCubicSmoothAbs.prototype.toString = function () { return "[object SVGPathSegCurvetoCubicSmoothAbs]"; }
			window.SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y; }
			window.SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function () { return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, this._x, this._y, this._x2, this._y2); }
			Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x2", { get: function () { return this._x2; }, set: function (x2) { this._x2 = x2; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y2", { get: function () { return this._y2; }, set: function (y2) { this._y2 = y2; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegCurvetoCubicSmoothRel = function (owningPathSegList, x, y, x2, y2) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL, "s", owningPathSegList);
				this._x = x;
				this._y = y;
				this._x2 = x2;
				this._y2 = y2;
			}
			window.SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegCurvetoCubicSmoothRel.prototype.toString = function () { return "[object SVGPathSegCurvetoCubicSmoothRel]"; }
			window.SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y; }
			window.SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function () { return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, this._x, this._y, this._x2, this._y2); }
			Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x2", { get: function () { return this._x2; }, set: function (x2) { this._x2 = x2; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y2", { get: function () { return this._y2; }, set: function (y2) { this._y2 = y2; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegCurvetoQuadraticSmoothAbs = function (owningPathSegList, x, y) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS, "T", owningPathSegList);
				this._x = x;
				this._y = y;
			}
			window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString = function () { return "[object SVGPathSegCurvetoQuadraticSmoothAbs]"; }
			window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
			window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone = function () { return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, this._x, this._y); }
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });

			window.SVGPathSegCurvetoQuadraticSmoothRel = function (owningPathSegList, x, y) {
				window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL, "t", owningPathSegList);
				this._x = x;
				this._y = y;
			}
			window.SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
			window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString = function () { return "[object SVGPathSegCurvetoQuadraticSmoothRel]"; }
			window.SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString = function () { return this.pathSegTypeAsLetter + " " + this._x + " " + this._y; }
			window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone = function () { return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, this._x, this._y); }
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "x", { get: function () { return this._x; }, set: function (x) { this._x = x; this._segmentChanged(); }, enumerable: true });
			Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "y", { get: function () { return this._y; }, set: function (y) { this._y = y; this._segmentChanged(); }, enumerable: true });

			// Add createSVGPathSeg* functions to window.SVGPathElement.
			// Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-Interfacewindow.SVGPathElement.
			window.SVGPathElement.prototype.createSVGPathSegClosePath = function () { return new window.SVGPathSegClosePath(undefined); }
			window.SVGPathElement.prototype.createSVGPathSegMovetoAbs = function (x, y) { return new window.SVGPathSegMovetoAbs(undefined, x, y); }
			window.SVGPathElement.prototype.createSVGPathSegMovetoRel = function (x, y) { return new window.SVGPathSegMovetoRel(undefined, x, y); }
			window.SVGPathElement.prototype.createSVGPathSegLinetoAbs = function (x, y) { return new window.SVGPathSegLinetoAbs(undefined, x, y); }
			window.SVGPathElement.prototype.createSVGPathSegLinetoRel = function (x, y) { return new window.SVGPathSegLinetoRel(undefined, x, y); }
			window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs = function (x, y, x1, y1, x2, y2) { return new window.SVGPathSegCurvetoCubicAbs(undefined, x, y, x1, y1, x2, y2); }
			window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel = function (x, y, x1, y1, x2, y2) { return new window.SVGPathSegCurvetoCubicRel(undefined, x, y, x1, y1, x2, y2); }
			window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs = function (x, y, x1, y1) { return new window.SVGPathSegCurvetoQuadraticAbs(undefined, x, y, x1, y1); }
			window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel = function (x, y, x1, y1) { return new window.SVGPathSegCurvetoQuadraticRel(undefined, x, y, x1, y1); }
			window.SVGPathElement.prototype.createSVGPathSegArcAbs = function (x, y, r1, r2, angle, largeArcFlag, sweepFlag) { return new window.SVGPathSegArcAbs(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag); }
			window.SVGPathElement.prototype.createSVGPathSegArcRel = function (x, y, r1, r2, angle, largeArcFlag, sweepFlag) { return new window.SVGPathSegArcRel(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag); }
			window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs = function (x) { return new window.SVGPathSegLinetoHorizontalAbs(undefined, x); }
			window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel = function (x) { return new window.SVGPathSegLinetoHorizontalRel(undefined, x); }
			window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs = function (y) { return new window.SVGPathSegLinetoVerticalAbs(undefined, y); }
			window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel = function (y) { return new window.SVGPathSegLinetoVerticalRel(undefined, y); }
			window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs = function (x, y, x2, y2) { return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, x, y, x2, y2); }
			window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel = function (x, y, x2, y2) { return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, x, y, x2, y2); }
			window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs = function (x, y) { return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, x, y); }
			window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel = function (x, y) { return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, x, y); }
		}

		if (typeof window !== 'undefined' && !("SVGPathSegList" in window)) {
			// Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGPathSegList
			window.SVGPathSegList = function (pathElement) {
				this._pathElement = pathElement;
				this._list = this._parsePath(this._pathElement.getAttribute("d"));

				// Use a MutationObserver to catch changes to the path's "d" attribute.
				this._mutationObserverConfig = { "attributes": true, "attributeFilter": ["d"] };
				this._pathElementMutationObserver = new MutationObserver(this._updateListFromPathMutations.bind(this));
				this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
			}

			window.SVGPathSegList.prototype.classname = "SVGPathSegList";

			Object.defineProperty(window.SVGPathSegList.prototype, "numberOfItems", {
				get: function () {
					this._checkPathSynchronizedToList();
					return this._list.length;
				},
				enumerable: true
			});

			// Add the pathSegList accessors to window.SVGPathElement.
			// Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-InterfaceSVGAnimatedPathData
			Object.defineProperty(window.SVGPathElement.prototype, "pathSegList", {
				get: function () {
					if (!this._pathSegList)
						this._pathSegList = new window.SVGPathSegList(this);
					return this._pathSegList;
				},
				enumerable: true
			});
			// FIXME: The following are not implemented and simply return window.SVGPathElement.pathSegList.
			Object.defineProperty(window.SVGPathElement.prototype, "normalizedPathSegList", { get: function () { return this.pathSegList; }, enumerable: true });
			Object.defineProperty(window.SVGPathElement.prototype, "animatedPathSegList", { get: function () { return this.pathSegList; }, enumerable: true });
			Object.defineProperty(window.SVGPathElement.prototype, "animatedNormalizedPathSegList", { get: function () { return this.pathSegList; }, enumerable: true });

			// Process any pending mutations to the path element and update the list as needed.
			// This should be the first call of all public functions and is needed because
			// MutationObservers are not synchronous so we can have pending asynchronous mutations.
			window.SVGPathSegList.prototype._checkPathSynchronizedToList = function () {
				this._updateListFromPathMutations(this._pathElementMutationObserver.takeRecords());
			}

			window.SVGPathSegList.prototype._updateListFromPathMutations = function (mutationRecords) {
				if (!this._pathElement)
					return;
				var hasPathMutations = false;
				mutationRecords.forEach(function (record) {
					if (record.attributeName == "d")
						hasPathMutations = true;
				});
				if (hasPathMutations)
					this._list = this._parsePath(this._pathElement.getAttribute("d"));
			}

			// Serialize the list and update the path's 'd' attribute.
			window.SVGPathSegList.prototype._writeListToPath = function () {
				this._pathElementMutationObserver.disconnect();
				this._pathElement.setAttribute("d", window.SVGPathSegList._pathSegArrayAsString(this._list));
				this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
			}

			// When a path segment changes the list needs to be synchronized back to the path element.
			window.SVGPathSegList.prototype.segmentChanged = function (pathSeg) {
				this._writeListToPath();
			}

			window.SVGPathSegList.prototype.clear = function () {
				this._checkPathSynchronizedToList();

				this._list.forEach(function (pathSeg) {
					pathSeg._owningPathSegList = null;
				});
				this._list = [];
				this._writeListToPath();
			}

			window.SVGPathSegList.prototype.initialize = function (newItem) {
				this._checkPathSynchronizedToList();

				this._list = [newItem];
				newItem._owningPathSegList = this;
				this._writeListToPath();
				return newItem;
			}

			window.SVGPathSegList.prototype._checkValidIndex = function (index) {
				if (isNaN(index) || index < 0 || index >= this.numberOfItems)
					throw "INDEX_SIZE_ERR";
			}

			window.SVGPathSegList.prototype.getItem = function (index) {
				this._checkPathSynchronizedToList();

				this._checkValidIndex(index);
				return this._list[index];
			}

			window.SVGPathSegList.prototype.insertItemBefore = function (newItem, index) {
				this._checkPathSynchronizedToList();

				// Spec: If the index is greater than or equal to numberOfItems, then the new item is appended to the end of the list.
				if (index > this.numberOfItems)
					index = this.numberOfItems;
				if (newItem._owningPathSegList) {
					// SVG2 spec says to make a copy.
					newItem = newItem.clone();
				}
				this._list.splice(index, 0, newItem);
				newItem._owningPathSegList = this;
				this._writeListToPath();
				return newItem;
			}

			window.SVGPathSegList.prototype.replaceItem = function (newItem, index) {
				this._checkPathSynchronizedToList();

				if (newItem._owningPathSegList) {
					// SVG2 spec says to make a copy.
					newItem = newItem.clone();
				}
				this._checkValidIndex(index);
				this._list[index] = newItem;
				newItem._owningPathSegList = this;
				this._writeListToPath();
				return newItem;
			}

			window.SVGPathSegList.prototype.removeItem = function (index) {
				this._checkPathSynchronizedToList();

				this._checkValidIndex(index);
				var item = this._list[index];
				this._list.splice(index, 1);
				this._writeListToPath();
				return item;
			}

			window.SVGPathSegList.prototype.appendItem = function (newItem) {
				this._checkPathSynchronizedToList();

				if (newItem._owningPathSegList) {
					// SVG2 spec says to make a copy.
					newItem = newItem.clone();
				}
				this._list.push(newItem);
				newItem._owningPathSegList = this;
				// TODO: Optimize this to just append to the existing attribute.
				this._writeListToPath();
				return newItem;
			}

			window.SVGPathSegList._pathSegArrayAsString = function (pathSegArray) {
				var string = "";
				var first = true;
				pathSegArray.forEach(function (pathSeg) {
					if (first) {
						first = false;
						string += pathSeg._asPathString();
					} else {
						string += " " + pathSeg._asPathString();
					}
				});
				return string;
			}

			// This closely follows SVGPathParser::parsePath from Source/core/svg/SVGPathParser.cpp.
			window.SVGPathSegList.prototype._parsePath = function (string) {
				if (!string || string.length == 0)
					return [];

				var owningPathSegList = this;

				var Builder = function () {
					this.pathSegList = [];
				}

				Builder.prototype.appendSegment = function (pathSeg) {
					this.pathSegList.push(pathSeg);
				}

				var Source = function (string) {
					this._string = string;
					this._currentIndex = 0;
					this._endIndex = this._string.length;
					this._previousCommand = window.SVGPathSeg.PATHSEG_UNKNOWN;

					this._skipOptionalSpaces();
				}

				Source.prototype._isCurrentSpace = function () {
					var character = this._string[this._currentIndex];
					return character <= " " && (character == " " || character == "\n" || character == "\t" || character == "\r" || character == "\f");
				}

				Source.prototype._skipOptionalSpaces = function () {
					while (this._currentIndex < this._endIndex && this._isCurrentSpace())
						this._currentIndex++;
					return this._currentIndex < this._endIndex;
				}

				Source.prototype._skipOptionalSpacesOrDelimiter = function () {
					if (this._currentIndex < this._endIndex && !this._isCurrentSpace() && this._string.charAt(this._currentIndex) != ",")
						return false;
					if (this._skipOptionalSpaces()) {
						if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ",") {
							this._currentIndex++;
							this._skipOptionalSpaces();
						}
					}
					return this._currentIndex < this._endIndex;
				}

				Source.prototype.hasMoreData = function () {
					return this._currentIndex < this._endIndex;
				}

				Source.prototype.peekSegmentType = function () {
					var lookahead = this._string[this._currentIndex];
					return this._pathSegTypeFromChar(lookahead);
				}

				Source.prototype._pathSegTypeFromChar = function (lookahead) {
					switch (lookahead) {
						case "Z":
						case "z":
							return window.SVGPathSeg.PATHSEG_CLOSEPATH;
						case "M":
							return window.SVGPathSeg.PATHSEG_MOVETO_ABS;
						case "m":
							return window.SVGPathSeg.PATHSEG_MOVETO_REL;
						case "L":
							return window.SVGPathSeg.PATHSEG_LINETO_ABS;
						case "l":
							return window.SVGPathSeg.PATHSEG_LINETO_REL;
						case "C":
							return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;
						case "c":
							return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;
						case "Q":
							return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;
						case "q":
							return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;
						case "A":
							return window.SVGPathSeg.PATHSEG_ARC_ABS;
						case "a":
							return window.SVGPathSeg.PATHSEG_ARC_REL;
						case "H":
							return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;
						case "h":
							return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;
						case "V":
							return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;
						case "v":
							return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;
						case "S":
							return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;
						case "s":
							return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL;
						case "T":
							return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;
						case "t":
							return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;
						default:
							return window.SVGPathSeg.PATHSEG_UNKNOWN;
					}
				}

				Source.prototype._nextCommandHelper = function (lookahead, previousCommand) {
					// Check for remaining coordinates in the current command.
					if ((lookahead == "+" || lookahead == "-" || lookahead == "." || (lookahead >= "0" && lookahead <= "9")) && previousCommand != window.SVGPathSeg.PATHSEG_CLOSEPATH) {
						if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_ABS)
							return window.SVGPathSeg.PATHSEG_LINETO_ABS;
						if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_REL)
							return window.SVGPathSeg.PATHSEG_LINETO_REL;
						return previousCommand;
					}
					return window.SVGPathSeg.PATHSEG_UNKNOWN;
				}

				Source.prototype.initialCommandIsMoveTo = function () {
					// If the path is empty it is still valid, so return true.
					if (!this.hasMoreData())
						return true;
					var command = this.peekSegmentType();
					// Path must start with moveTo.
					return command == window.SVGPathSeg.PATHSEG_MOVETO_ABS || command == window.SVGPathSeg.PATHSEG_MOVETO_REL;
				}

				// Parse a number from an SVG path. This very closely follows genericParseNumber(...) from Source/core/svg/SVGParserUtilities.cpp.
				// Spec: http://www.w3.org/TR/SVG11/single-page.html#paths-PathDataBNF
				Source.prototype._parseNumber = function () {
					var exponent = 0;
					var integer = 0;
					var frac = 1;
					var decimal = 0;
					var sign = 1;
					var expsign = 1;

					var startIndex = this._currentIndex;

					this._skipOptionalSpaces();

					// Read the sign.
					if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "+")
						this._currentIndex++;
					else if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "-") {
						this._currentIndex++;
						sign = -1;
					}

					if (this._currentIndex == this._endIndex || ((this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") && this._string.charAt(this._currentIndex) != "."))
						// The first character of a number must be one of [0-9+-.].
						return undefined;

					// Read the integer part, build right-to-left.
					var startIntPartIndex = this._currentIndex;
					while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9")
						this._currentIndex++; // Advance to first non-digit.

					if (this._currentIndex != startIntPartIndex) {
						var scanIntPartIndex = this._currentIndex - 1;
						var multiplier = 1;
						while (scanIntPartIndex >= startIntPartIndex) {
							integer += multiplier * (this._string.charAt(scanIntPartIndex--) - "0");
							multiplier *= 10;
						}
					}

					// Read the decimals.
					if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ".") {
						this._currentIndex++;

						// There must be a least one digit following the .
						if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9")
							return undefined;
						while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
							frac *= 10;
							decimal += (this._string.charAt(this._currentIndex) - "0") / frac;
							this._currentIndex += 1;
						}
					}

					// Read the exponent part.
					if (this._currentIndex != startIndex && this._currentIndex + 1 < this._endIndex && (this._string.charAt(this._currentIndex) == "e" || this._string.charAt(this._currentIndex) == "E") && (this._string.charAt(this._currentIndex + 1) != "x" && this._string.charAt(this._currentIndex + 1) != "m")) {
						this._currentIndex++;

						// Read the sign of the exponent.
						if (this._string.charAt(this._currentIndex) == "+") {
							this._currentIndex++;
						} else if (this._string.charAt(this._currentIndex) == "-") {
							this._currentIndex++;
							expsign = -1;
						}

						// There must be an exponent.
						if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9")
							return undefined;

						while (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9") {
							exponent *= 10;
							exponent += (this._string.charAt(this._currentIndex) - "0");
							this._currentIndex++;
						}
					}

					var number = integer + decimal;
					number *= sign;

					if (exponent)
						number *= Math.pow(10, expsign * exponent);

					if (startIndex == this._currentIndex)
						return undefined;

					this._skipOptionalSpacesOrDelimiter();

					return number;
				}

				Source.prototype._parseArcFlag = function () {
					if (this._currentIndex >= this._endIndex)
						return undefined;
					var flag = false;
					var flagChar = this._string.charAt(this._currentIndex++);
					if (flagChar == "0")
						flag = false;
					else if (flagChar == "1")
						flag = true;
					else
						return undefined;

					this._skipOptionalSpacesOrDelimiter();
					return flag;
				}

				Source.prototype.parseSegment = function () {
					var lookahead = this._string[this._currentIndex];
					var command = this._pathSegTypeFromChar(lookahead);
					if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) {
						// Possibly an implicit command. Not allowed if this is the first command.
						if (this._previousCommand == window.SVGPathSeg.PATHSEG_UNKNOWN)
							return null;
						command = this._nextCommandHelper(lookahead, this._previousCommand);
						if (command == window.SVGPathSeg.PATHSEG_UNKNOWN)
							return null;
					} else {
						this._currentIndex++;
					}

					this._previousCommand = command;

					switch (command) {
						case window.SVGPathSeg.PATHSEG_MOVETO_REL:
							return new window.SVGPathSegMovetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
						case window.SVGPathSeg.PATHSEG_MOVETO_ABS:
							return new window.SVGPathSegMovetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
						case window.SVGPathSeg.PATHSEG_LINETO_REL:
							return new window.SVGPathSegLinetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
						case window.SVGPathSeg.PATHSEG_LINETO_ABS:
							return new window.SVGPathSegLinetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
						case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
							return new window.SVGPathSegLinetoHorizontalRel(owningPathSegList, this._parseNumber());
						case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
							return new window.SVGPathSegLinetoHorizontalAbs(owningPathSegList, this._parseNumber());
						case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
							return new window.SVGPathSegLinetoVerticalRel(owningPathSegList, this._parseNumber());
						case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
							return new window.SVGPathSegLinetoVerticalAbs(owningPathSegList, this._parseNumber());
						case window.SVGPathSeg.PATHSEG_CLOSEPATH:
							this._skipOptionalSpaces();
							return new window.SVGPathSegClosePath(owningPathSegList);
						case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
							var points = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
							return new window.SVGPathSegCurvetoCubicRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
						case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
							var points = { x1: this._parseNumber(), y1: this._parseNumber(), x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
							return new window.SVGPathSegCurvetoCubicAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
						case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
							var points = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
							return new window.SVGPathSegCurvetoCubicSmoothRel(owningPathSegList, points.x, points.y, points.x2, points.y2);
						case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
							var points = { x2: this._parseNumber(), y2: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
							return new window.SVGPathSegCurvetoCubicSmoothAbs(owningPathSegList, points.x, points.y, points.x2, points.y2);
						case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
							var points = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
							return new window.SVGPathSegCurvetoQuadraticRel(owningPathSegList, points.x, points.y, points.x1, points.y1);
						case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
							var points = { x1: this._parseNumber(), y1: this._parseNumber(), x: this._parseNumber(), y: this._parseNumber() };
							return new window.SVGPathSegCurvetoQuadraticAbs(owningPathSegList, points.x, points.y, points.x1, points.y1);
						case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
							return new window.SVGPathSegCurvetoQuadraticSmoothRel(owningPathSegList, this._parseNumber(), this._parseNumber());
						case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
							return new window.SVGPathSegCurvetoQuadraticSmoothAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
						case window.SVGPathSeg.PATHSEG_ARC_REL:
							var points = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
							return new window.SVGPathSegArcRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
						case window.SVGPathSeg.PATHSEG_ARC_ABS:
							var points = { x1: this._parseNumber(), y1: this._parseNumber(), arcAngle: this._parseNumber(), arcLarge: this._parseArcFlag(), arcSweep: this._parseArcFlag(), x: this._parseNumber(), y: this._parseNumber() };
							return new window.SVGPathSegArcAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
						default:
							throw "Unknown path seg type."
					}
				}

				var builder = new Builder();
				var source = new Source(string);

				if (!source.initialCommandIsMoveTo())
					return [];
				while (source.hasMoreData()) {
					var pathSeg = source.parseSegment();
					if (!pathSeg)
						return [];
					builder.appendSegment(pathSeg);
				}

				return builder.pathSegList;
			}
		}
	}());

	//      JointJS library (http://jointjs.com)
	//      (c) 2011-2014 client IO. http://client.io.

	joint.shapes.chart = {};

	joint.shapes.chart.Plot = joint.shapes.basic.Generic.extend({

		markup: [
			'<clipPath class="clip"><rect/></clipPath>',
			'<g class="rotatable">',
			'<g class="scalable"></g>',
			'<g class="background"><rect/><text/></g>',
			'<g class="axis">',
			'<g class="y-axis"><path/><g class="ticks"></g></g>',
			'<g class="x-axis"><path/><g class="ticks"></g></g>',
			'<g class="markings"></g>',
			'</g>',
			'<g class="data"><g class="series"></g></g>',
			'<g class="foreground">',
			'<rect/><text class="caption"/><text class="subcaption"/>',
			'<g class="legend"><g class="legend-items"></g></g>',
			'<line class="guideline x-guideline" /><line class="guideline y-guideline" />',
			'</g>',
			'</g>'
		].join(''),
		tickMarkup: '<g class="tick"><line/><text/></g>',
		pointMarkup: '<g class="point"><circle/><text/></g>',
		barMarkup: '<path class="bar"/>',
		markingMarkup: '<g class="marking"><rect/><text/></g>',
		serieMarkup: '<g><clipPath class="serie-clip"><rect/></clipPath><path/><g class="bars"></g><g class="points"></g></g>',
		legendItemMarkup: '<g class="legend-item"><circle/><text/></g>',

		defaults: joint.util.deepSupplement({

			type: 'chart.Plot',
			attrs: {
				'.data path': { fill: 'none', stroke: 'black' },
				'.data .bars rect': { fill: 'none', stroke: 'black' },
				'.background rect': { fill: 'white', stroke: '#e5e5e5', opacity: 1 },
				'.background text': { fill: 'black', text: 'No data available.', ref: '.', 'ref-x': .5, 'ref-y': .5, 'text-anchor': 'middle', 'y-alignment': 'middle', display: 'none' },
				'.foreground > rect': { fill: 'white', stroke: '#e5e5e5', opacity: 0, 'pointer-events': 'none' },
				'.foreground .caption': { fill: 'black', text: '', ref: '.foreground > rect', 'ref-x': .5, 'ref-y': 10, 'text-anchor': 'middle', 'y-alignment': 'middle', 'font-size': 14 },
				'.foreground .subcaption': { fill: 'black', text: '', ref: '.foreground > rect', 'ref-x': .5, 'ref-y': 23, 'text-anchor': 'middle', 'y-alignment': 'middle', 'font-size': 10 },
				'.point': { display: 'inline-block' },
				'.point circle': { r: 2, stroke: 'black', fill: 'black', 'opacity': .3 },
				'.point text': { fill: 'black', 'font-size': 8, 'text-anchor': 'middle', display: 'none' },
				'.axis path': { fill: 'none', stroke: 'black' },
				'.axis .tick': { fill: 'none', stroke: 'black' },
				'.y-axis .tick line': { fill: 'none', stroke: 'black', x2: 2, y2: 0, opacity: 1 },
				'.x-axis .tick line': { fill: 'none', stroke: 'black', x2: 0, y2: -3, opacity: 1 },
				'.y-axis .tick text': { fill: 'black', stroke: 'none', 'font-size': 10, 'text-anchor': 'end' },
				'.x-axis .tick text': { fill: 'black', stroke: 'none', 'font-size': 10, 'text-anchor': 'middle' },
				'.y-axis .tick text > tspan': { dy: '-.5em', x: -5 },
				'.x-axis .tick text > tspan': { dy: '.5em', x: 0 },
				'.axis .markings': { fill: 'black', stroke: 'none', 'fill-opacity': 1 },
				'.axis .markings text': { fill: 'black', 'text-anchor': 'end', 'font-size': 10, dy: -5, dx: -5 },
				'.guideline': { 'pointer-events': 'none', display: 'none' },
				'.x-guideline': { stroke: 'black', visibility: 'hidden' },
				'.y-guideline': { stroke: 'black', visibility: 'hidden' },
				'.legend': { 'ref-x': 10, 'ref-y': 10 },
				'.legend-item text': { fill: 'black', transform: 'translate(14, 0)', 'font-size': 11 },
				'.legend-item circle': { r: 5, transform: 'translate(5,5)' },
				'.legend-item': { cursor: 'pointer' },
				'.legend-item.disabled circle': { fill: 'gray' },
				'.legend-item.disabled text': { opacity: .5 }
			}

		}, joint.shapes.basic.Generic.prototype.defaults),

		legendPosition: function (pos, opt) {

			opt = opt || {};

			this.trigger('batch:start');

			// Clean up previous attributes first. Do it silently so that we don't unncessarilly trigger updates.
			[
				'.legend/ref-x',
				'.legend/ref-y',
				'.legend/ref-dx',
				'.legend/ref-dy',
				'.legend/x-alignment',
				'.legend/y-alignment'
			].forEach(function (item) {
				this.removeAttr(item, { silent: true })
			}, this);

			var padding = opt.padding || 10;

			var attrs = {

				n: { '.legend': { 'ref-x': .5, 'x-alignment': -.5, 'ref-y': padding } },
				ne: { '.legend': { 'ref-dx': -padding, 'x-alignment': -.999, 'ref-y': padding } },
				e: { '.legend': { 'ref-dx': -padding, 'x-alignment': -.999, 'ref-y': .5, 'y-alignment': -.5 } },
				se: { '.legend': { 'ref-dx': -padding, 'ref-dy': -padding, 'x-alignment': -.999, 'y-alignment': -.999 } },
				s: { '.legend': { 'ref-x': .5, 'ref-dy': -padding, 'x-alignment': -.5, 'y-alignment': -.999 } },
				sw: { '.legend': { 'ref-x': padding, 'ref-dy': -padding, 'y-alignment': -.999 } },
				w: { '.legend': { 'ref-x': padding, 'ref-y': .5, 'y-alignment': -.5 } },
				nw: { '.legend': { 'ref-x': padding, 'ref-y': padding } },
				nnw: { '.legend': { 'ref-x': padding, 'ref-y': -padding, 'y-alignment': -.999 } },
				nn: { '.legend': { 'ref-x': .5, 'ref-y': -padding, 'x-alignment': -.5, 'y-alignment': -.999 } },
				nne: { '.legend': { 'ref-dx': -padding, 'ref-y': -padding, 'x-alignment': -.999, 'y-alignment': -.999 } },
				nnee: { '.legend': { 'ref-dx': padding, 'ref-y': -padding, 'y-alignment': -.999 } },
				nee: { '.legend': { 'ref-y': padding, 'ref-dx': padding } },
				ee: { '.legend': { 'ref-dx': padding, 'ref-y': .5, 'y-alignment': -.5 } },
				see: { '.legend': { 'ref-dx': padding, 'ref-dy': -padding, 'y-alignment': -.999 } },
				ssee: { '.legend': { 'ref-dx': padding, 'ref-dy': padding } },
				sse: { '.legend': { 'ref-dx': -padding, 'ref-dy': padding, 'x-alignment': -.999 } },
				ss: { '.legend': { 'ref-x': .5, 'ref-dy': padding, 'x-alignment': -.5 } },
				ssw: { '.legend': { 'ref-x': padding, 'ref-dy': padding } },
				ssww: { '.legend': { 'ref-x': -padding, 'ref-dy': padding, 'x-alignment': -.999 } },
				sww: { '.legend': { 'ref-x': -padding, 'ref-dy': -padding, 'x-alignment': -.999, 'y-alignment': -.999 } },
				ww: { '.legend': { 'ref-x': -padding, 'ref-y': .5, 'x-alignment': -.999, 'y-alignment': -.5 } },
				nww: { '.legend': { 'ref-x': -padding, 'ref-y': padding, 'x-alignment': -.999 } },
				nnww: { '.legend': { 'ref-x': -padding, 'ref-y': -padding, 'x-alignment': -.999, 'y-alignment': -.999 } }
			};

			if (attrs[pos]) {
				this.attr(attrs[pos]);
			}

			this.trigger('batch:stop');
		},

		// Add point `p` as the last point to the serie identified by `serieName`. If `opt.maxLen` is set and
		// the number of points in the serie is higher than `maxLen`, shift the data in the serie.
		addPoint: function (p, serieName, opt) {

			opt = opt || {};

			var series = this.get('series');

			var serieIndex = joint.util.toArray(series).findIndex(function (item) {
				return item.name === serieName;
			});
			if (serieIndex === -1) {
				throw new Error('Serie ' + serieName + ' was not found.');
			}

			// Clone the serie so that the normal Backbone mechanism for `set()` and `prev()` works as expected.
			var serie = joint.util.cloneDeep(series[serieIndex]);
			serie.data.push(p);

			if (Number.isFinite(opt.maxLen) && serie.data.length > opt.maxLen) {

				serie.data.shift();
			}

			// Again, slice the array so that we don't alter the `series` array currently set.
			series = series.slice();
			series[serieIndex] = serie;

			this.set('series', series, opt);
		},

		// Return the last point in the serie identified by `serieName`.
		lastPoint: function (serieName) {

			var serie = joint.util.toArray(this.get('series')).find(function (item) {
				return item && item.name === serieName;
			}).data;

			return serie[serie.length - 1];
		},

		// Return the first point in the serie identified by `serieName`.
		firstPoint: function (serieName) {

			return joint.util.toArray(this.get('series')).find(function (item) {
				return item && item.name === serieName;
			}).data[0];
		}
	});

	joint.shapes.chart.PlotView = joint.dia.ElementView.extend({

		events: {

			'mousemove': 'onMouseMove',
			'mouseout': 'onMouseOut'
		},

		initialize: function () {

			joint.dia.ElementView.prototype.initialize.apply(this, arguments);

			this.listenTo(this.model, 'change:series change:interpolate change:padding change:canvas change:markings change:axis', function () { this.update(); });

			this.on('cell:pointerdown', this.onPointerDown, this);

			// A list of disabled serie names. This is used when toggling series via the legend
			// or programmatically.
			this._disabledSeries = [];
		},

		renderMarkup: function () {

			joint.dia.ElementView.prototype.renderMarkup.apply(this, arguments);

			// Cache important elements for faster access.
			this.elDataClipPath = this.$('.clip')[0];
			this.elDataClipPathRect = this.elDataClipPath.firstChild;
			this.elBackgroundRect = this.$('.background rect')[0];
			this.elBackgroundText = this.$('.background text')[0];
			this.elForeground = this.$('.foreground')[0];
			this.elForegroundRect = this.$('.foreground rect')[0];
			this.elDataSeries = this.$('.data .series')[0];
			this.elYAxisPath = this.$('.y-axis path')[0];
			this.elYAxisTicks = this.$('.y-axis .ticks')[0];
			this.elXAxisPath = this.$('.x-axis path')[0];
			this.elXAxisTicks = this.$('.x-axis .ticks')[0];
			this.elMarkings = this.$('.axis .markings')[0];
			this.elXGuideline = this.$('.x-guideline')[0];
			this.elYGuideline = this.$('.y-guideline')[0];
			this.elLegend = this.$('.legend')[0];
			this.elLegendItems = this.$('.legend-items')[0];

			// An SVG element for repeatable elements. This will be used as an original for future clones.
			this.elTick = V(this.model.tickMarkup);
			this.elMarking = V(this.model.markingMarkup);
			this.elLegendItem = V(this.model.legendItemMarkup);
			this.elPoint = V(this.model.pointMarkup);
			this.elBar = V(this.model.barMarkup);
			this.elSerie = V(this.model.serieMarkup);

			// Create clip region for the chart area and for the markings as they could also be out
			// of the clip region.
			this.elDataClipPath.id = 'clip_' + this.cid;
			V(this.$('.data')[0]).attr('clip-path', 'url(#' + this.elDataClipPath.id + ')');
			V(this.elMarkings).attr('clip-path', 'url(#' + this.elDataClipPath.id + ')');
		},

		update: function () {

			var series = this.filterSeries();

			// Get statistics about the series.
			this.calculateStats(series);

			var size = this.model.get('size');
			var width = size.width;
			var height = size.height;

			// Chart area.
			this.canvas = joint.util.assign({
				x: 0, y: 0,
				width: width, height: height
			}, this.model.get('canvas'));

			// Padding. In theory, padding is not necessary as one can always set the canvas area
			// directly. However, it is much more convenient to be able to set a padding only for
			// a specific dimension(s) (top/right/bottom/left) and let the canvas alone.
			// Note that it is always advisable to set `padding` for bar charts, otherwise
			// some of the bars (or their parts - depending on the `align` option) won't be visible.
			var padding;
			var defaultPadding = { top: 0, right: 0, bottom: 0, left: 0 };
			var modelPadding = this.model.get('padding');
			if (joint.util.isObject(modelPadding)) {

				padding = joint.util.assign({}, defaultPadding, modelPadding);

			} else if (modelPadding !== undefined) {
				// The padding is assumed to be a number. In this case, compensate for the right/bottom coordinates
				// automatically. So that if e.g. `padding` is `10`, the chart area is moved `10px` from the left
				// and the width becomes `2*10px` less so that there is also `10px` padding from the right.
				padding = { top: modelPadding, right: 2 * modelPadding, bottom: 2 * modelPadding, left: modelPadding };

			} else {

				padding = defaultPadding;
			}

			this.canvas = g.rect(this.canvas).moveAndExpand(g.rect(padding.left, padding.top, -padding.right, -padding.bottom));

			var viewRect = { x: 0, y: 0, width: width, height: height };

			V(this.elDataClipPathRect).attr(viewRect);
			V(this.elBackgroundRect).attr(viewRect);
			V(this.elForegroundRect).attr(viewRect);


			this.updateAxis();
			this.updateMarkings();

			if (this.isEmpty()) {
				// No data available.
				// Show the "No data available" label that is hidden by default.
				$(this.elBackgroundText).show();

			} else {

				$(this.elBackgroundText).hide();
			}

			this.updateSeries(series);

			this.updateLegend();

			// Apply attrs.
			joint.dia.ElementView.prototype.update.apply(this, arguments);
		},

		calculateStats: function (series) {

			series = series || this.model.get('series');

			var xValues = [];
			var yValues = [];
			// `xMap` maps x values to an array of series these x values appear in and the corresponding
			// y values. This is useful when we want to, for a given x value, retriev all the corresponding
			// y values from all the series this x value appeared in (especially useful in tooltips).
			var xMap = {};
			var yMap = {};

			var bySerie = {};

			joint.util.toArray(series).forEach(function (serie, idx) {

				var stats = bySerie[serie.name || idx] || (bySerie[serie.name || idx] = {});

				// Initial assumptions.
				stats.decreasingX = true;
				stats.decreasingY = true;
				stats.nonDecreasingX = true;
				stats.nonDecreasingY = true;

				var prev;   // Previous data point.

				joint.util.forIn(serie.data, function (dp) {

					stats.minX = stats.minX === undefined ? dp.x : Math.min(stats.minX, dp.x);
					stats.maxX = stats.maxX === undefined ? dp.x : Math.max(stats.maxX, dp.x);
					stats.minY = stats.minY === undefined ? dp.y : Math.min(stats.minY, dp.y);
					stats.maxY = stats.maxY === undefined ? dp.y : Math.max(stats.maxY, dp.y);

					if (prev) {
						stats.decreasingX = stats.decreasingX && dp.x < prev.x;
						stats.decreasingY = stats.decreasingY && dp.y < prev.y;
						stats.nonDecreasingX = stats.nonDecreasingX && dp.x >= prev.x;
						stats.nonDecreasingY = stats.nonDecreasingY && dp.y >= prev.y;
					}

					if (!xValues.includes(dp.x)) xValues.push(dp.x);
					if (!yValues.includes(dp.y)) yValues.push(dp.y);

					(xMap[dp.x] || (xMap[dp.x] = [])).push({ serie: serie, x: dp.x, y: dp.y });
					(yMap[dp.y] || (yMap[dp.y] = [])).push({ serie: serie, x: dp.x, y: dp.y });

					prev = dp;
				});
			});

			var axis = this.model.get('axis') || {};
			var xAxis = axis['x-axis'] || {};
			var yAxis = axis['y-axis'] || {};

			this.stats = {
				minX: xAxis.min === undefined ? xValues.reduce(function (min, item) {
					return item < min ? item : min;
				}, Infinity) : xAxis.min,
				maxX: xAxis.max === undefined ? xValues.reduce(function (max, item) {
					return item > max ? item : max;
				}, -Infinity) : xAxis.max,
				minY: yAxis.min === undefined ? yValues.reduce(function (min, item) {
					return item < min ? item : min;
				}, Infinity) : yAxis.min,
				maxY: yAxis.max === undefined ? yValues.reduce(function (max, item) {
					return item > max ? item : max;
				}, -Infinity) : yAxis.max,
				bySerie: bySerie,
				xValues: xValues,
				yValues: yValues,
				xMap: xMap,
				yMap: yMap
			};
		},

		isEmpty: function () {

			return !this.stats.xValues.length;
		},

		updateSeries: function (series) {

			series = series || this.model.get('series');

			// Remove all the previously rendered series.
			this.elDataSeries.textContent = '';

			if (this.isEmpty()) return;

			var xDomain = [this.stats.minX, this.stats.maxX];
			var yDomain = [this.stats.minY, this.stats.maxY];
			var xRange = [this.canvas.x, this.canvas.x + this.canvas.width];
			// Note how the `yRange` is inverted. This is because we render points from bottom to top.
			var yRange = [this.canvas.y + this.canvas.height, this.canvas.y];

			var attrs = this.model.get('attrs');

			joint.util.toArray(series).forEach(function (serie, i) {

				var points = serie.data;
				var transformedPoints = [];

				var elSerie = this.elSerie.clone().attr('class', serie.name || ('serie-' + i));
				V(this.elDataSeries).append(elSerie);

				joint.util.forIn(points, function (p) {

					// Transform the data point to the chart area.
					var x = g.scale.linear(xDomain, xRange, p.x);
					var y = g.scale.linear(yDomain, yRange, p.y);

					transformedPoints.push({ x: x, y: y });

					// Set position of the point element circle and label.
					// A little optimization: do not render the points if they're not turned on.
					if (attrs['.point'] && attrs['.point'].display !== 'none') {

						this.renderPoint(p, serie);
					}

					if (serie.bars) {

						this.renderBar(p, serie);
					}

				}.bind(this));

				// Clip the serie path in order to clip the helper continuation of the path
				// that is used to close the path for filling. (see `fixPathForFill()`).
				var elSeriePathClip = elSerie.findOne('.serie-clip');

				var size = this.model.get('size');
				var stats = this.stats.bySerie[serie.name || i];
				var minX = g.scale.linear(xDomain, xRange, stats.minX);
				var maxX = g.scale.linear(xDomain, xRange, stats.maxX);

				var elSeriePathClipRect = elSeriePathClip.findOne('rect');
				elSeriePathClipRect.attr(g.rect(minX, 0, maxX - minX, size.height));

				if (!serie.bars) {
					// Bars were already rendered for each data point.

					var elSeriePath = elSerie.findOne('path');
					elSeriePath.attr({
						d: this.seriePathData(transformedPoints, serie, i),
						'clip-path': 'url(#' + elSeriePathClip.node.id + ')'
					});
				}

			}, this);
		},

		seriePathClipData: function (points, serie) {

			var padding = 10;
			var size = this.model.get('size');
			var firstPoint = points[0];
			var d = ['M', firstPoint.x, firstPoint.y, 'V', size.height + padding];
			return d.join(' ');
		},

		renderBar: function (p, serie) {

			var xDomain = [this.stats.minX, this.stats.maxX];
			var yDomain = [this.stats.minY, this.stats.maxY];
			var xRange = [this.canvas.x, this.canvas.x + this.canvas.width];
			// Note how the `yRange` is inverted. This is because we render points from bottom to top.
			var yRange = [this.canvas.y + this.canvas.height, this.canvas.y];

			// Transform the data point to the chart area.
			var x = g.scale.linear(xDomain, xRange, p.x);
			var y = g.scale.linear(yDomain, yRange, p.y);

			var definedBarWidth = serie.bars.barWidth || .8;
			var barWidth = definedBarWidth > 1 ? definedBarWidth : (this.canvas.width / (this.stats.maxX - this.stats.minX)) * definedBarWidth;
			var barHeight = g.scale.linear(yDomain, yRange, 0) - y;

			// `rx` values can be defined either directly in the data point for a specific bar
			// or on the `serie` object for all the bars.
			var topRx = p['top-rx'] || serie.bars['top-rx'];
			var topRy = p['top-ry'] || serie.bars['top-ry'];
			var bottomRx = p['bottom-rx'] || serie.bars['bottom-rx'];
			var bottomRy = p['bottom-ry'] || serie.bars['bottom-ry'];

			// Alignment of the bar against the x coordinate. `'left'` is the default.
			var barX = ({

				'left': x,
				'middle': x - barWidth / 2,
				'right': x - barWidth

			})[serie.bars.align || 'middle'];

			var elBar = this.elBar.clone();
			elBar.attr({
				'data-serie': serie.name,
				'data-x': p.x,
				'data-y': p.y,
				d: V.rectToPath({ x: barX, y: y, width: barWidth, height: barHeight, 'top-rx': topRx, 'top-ry': topRy, 'bottom-rx': bottomRx, 'bottom-ry': bottomRy })
			});

			var serieSelector = serie.name || ('serie-' + this.model.get('series').indexOf(serie));
			V(this.elDataSeries).findOne('.' + serieSelector + ' .bars').append(elBar);

			return elBar.node;
		},

		renderPoint: function (p, serie) {

			var xDomain = [this.stats.minX, this.stats.maxX];
			var yDomain = [this.stats.minY, this.stats.maxY];
			var xRange = [this.canvas.x, this.canvas.x + this.canvas.width];
			// Note how the `yRange` is inverted. This is because we render points from bottom to top.
			var yRange = [this.canvas.y + this.canvas.height, this.canvas.y];

			// Transform the data point to the chart area.
			var x = g.scale.linear(xDomain, xRange, p.x);
			var y = g.scale.linear(yDomain, yRange, p.y);

			var elPoint = this.elPoint.clone();
			elPoint.attr({
				'data-serie': serie.name,
				'data-x': p.x,
				'data-y': p.y
			});
			elPoint.findOne('circle').attr({ cx: x, cy: y });
			elPoint.findOne('text').attr({ x: x, dy: y }).text(this.pointLabel(p, serie));

			var serieSelector = serie.name || ('serie-' + this.model.get('series').indexOf(serie));
			V(this.elDataSeries).findOne('.' + serieSelector + ' .points').append(elPoint);

			return elPoint.node;
		},

		// Construct an SVG path for the data points. Use interpolation if desired.
		seriePathData: function (points, serie, idx) {

			var interpolate = serie.interpolate === undefined ? this.model.get('interpolate') : serie.interpolate;
			var d;
			var i;
			var p;
			var pointsLength = points.length;

			switch (interpolate) {

				case 'bezier':
					d = g.bezier.curveThroughPoints(points);
					break;

				case 'step':
					p = points[0];
					d = ['M', p.x, p.y];
					for (i = 1; i < pointsLength; i++) {
						d.push('H', (p.x + points[i].x) / 2, 'V', points[i].y);
						p = points[i];
					}
					break;

				case 'stepBefore':
					d = ['M', points[0].x, points[0].y];
					for (i = 1; i < pointsLength; i++) {
						d.push('V', points[i].y, 'H', points[i].x);
					}
					break;

				case 'stepAfter':
					d = ['M', points[0].x, points[0].y];
					for (i = 1; i < pointsLength; i++) {
						d.push('H', points[i].x, 'V', points[i].y);
					}
					break;

				default:        // linear
					d = ['M'];
					for (i = 0; i < pointsLength; i++) {
						d.push(points[i].x, points[i].y);
					}
					break;
			}

			d = this.fixPathForFill(d, points, serie, idx);

			return d.join(' ');
		},

		fixPathForFill: function (d, points, serie, idx) {

			// Nothing needs to be fixed for empty points list.
			if (points.length === 0) return d;

			// If the serie is not non-decreasing (it is an arbitrary function), it is assumed that
			// the author knows what he's doing and handles proper fill himself.
			var stats = this.stats.bySerie[serie.name || idx];
			if (!stats.nonDecreasingX) return d;

			var padding = 10;
			var size = this.model.get('size');
			var firstPoint = points[0];
			var lastPoint = points[points.length - 1];

			// Start a subpath at the level of the last point of the serie but below the visible chart area
			// (i.e. below the clipped region) and continue that path to the level of the first point circling
			// around the bottom of the clipping region. This makes sure that even though the serie
			// has its last x point before another serie in the chart and fill is set on the serie SVG path element
			// the fill will properly fill the region below the serie path. This is nicely visible
			// if you comment out the setting of the `clip-path` attribute on the `.data` group.
			var dPrefix = ['M', lastPoint.x, size.height + padding, 'H', firstPoint.x - padding, 'V', firstPoint.y];
			// The first path command is assumed to be `'M'`. Due to the trick
			// to fully support a proper fill, there is already preceeding a subpath.
			// Therefore, we want to continue that subpath with a line command.
			d[0] = 'L';

			return dPrefix.concat(d);
		},

		updateAxis: function () {

			var size = this.model.get('size');
			var width = size.width;
			var height = size.height;

			var axis = this.model.get('axis');

			// The canvas could be larger or smaller than the actual height of the chart view.
			// This can happen when the chart is zoomed. However, we still want to render the
			// axis along the height of the chart view (not continueing it below or above).
			// The `canvasHeighRatio` helps us adjust the range to which we map the values
			// from the axis domain.
			var canvasHeightRatio = this.canvas.height / height;

			// Axis line.
			V(this.elYAxisPath).attr('d', ['M', 0, 0, 'L', 0, height].join(' '));
			V(this.elXAxisPath).attr('d', ['M', 0, height, 'L', width, height].join(' '));

			// Clean up old ticks.
			this.elXAxisTicks.textContent = '';
			this.elYAxisTicks.textContent = '';

			if (this.isEmpty()) return;

			var xDomain = [this.stats.minX, this.stats.maxX];
			var yDomain = [this.stats.minY, this.stats.maxY];
			var xRange = [this.canvas.x, this.canvas.x + this.canvas.width];
			var yRange = [0, this.canvas.height];
			var yDomainSpan = yDomain[1] - yDomain[0];
			var yAxis = axis && axis['y-axis'] || {};
			var xAxis = axis && axis['x-axis'] || {};

			// Number of ticks. If the length of the domain interval is zero, show at least one tick.
			var ticks = (yDomainSpan) > 0 ? (yAxis.ticks - 1 || 10) : 0;
			// A tick step. We must scale the tick step down by the `canvasHeightRatio`.
			// The tick step becomes smaller if the canvas is larger than the chart view and bigger otherwise.
			var tickStep = (yDomainSpan / ticks) / canvasHeightRatio;

			// Render ticks.
			// Start at `yDomain[0]` and step by `tickStep` `ticks` number of times.
			var y = yDomain[0];

			for (var i = 0; i < ticks + 1; i++) {

				var ty = g.scale.linear(yDomain, yRange, y);

				var elTick = this.elTick.clone();
				elTick.translate(0, ty);
				V(this.elYAxisTicks).append(elTick);

				// Invert the `y` value according to the domain as we're moving from top to bottom but
				// the axis ticks are labeled from bottom to top.
				var tickValue = yDomain[1] - (y - yDomain[0]);
				// The `tickValue` is shifted by the `canvas.y` offset but first we must scale this offset
				// back to the domain of the axis.
				tickValue += g.scale.linear(yRange, yDomain, this.canvas.y) - yDomain[0];

				elTick.findOne('text').text(this.tickLabel(tickValue, yAxis));

				y += tickStep;
			}
			this.stats.xValues.forEach(function (x, i) {

				// Show only every `tickStep` value. Default is to show all the `x` values.
				if (i % (xAxis.tickStep || 1) !== 0) return;

				var tx = g.scale.linear(xDomain, xRange, x);

				// Do not show ticks that are outside the chart view area.
				if (tx > width) return;

				var elTick = this.elTick.clone();
				elTick.translate(tx, height);
				V(this.elXAxisTicks).append(elTick);

				elTick.findOne('text').text(this.tickLabel(x, xAxis));

			}, this);
		},

		tickLabel: function (value, opt) {

			if (joint.util.isFunction(opt.tickFormat)) {

				return opt.tickFormat(value);
			}

			var formatSpecifier = opt.tickFormat || '.1f';
			var label = joint.util.format.number(formatSpecifier, value);
			return label + (joint.util.isFunction(opt.tickSuffix) ? opt.tickSuffix(value) : (opt.tickSuffix || ''));
		},

		pointLabel: function (p, opt) {

			if (joint.util.isFunction(opt.pointFormat)) {

				return opt.pointFormat(p);
			}

			var formatSpecifier = opt.pointFormat || '.1f';
			var label = joint.util.format.number(formatSpecifier, p.y);
			return label + (opt.pointSuffix || '');
		},

		updateMarkings: function () {

			// Clean up old markings.
			this.elMarkings.textContent = '';

			var markings = this.model.get('markings');
			// No need to continue if there are no markings.
			if (!markings || markings.length === 0) return;

			var size = this.model.get('size');
			var width = size.width;
			var height = size.height;

			var xDomain = [this.stats.minX, this.stats.maxX];
			var yDomain = [this.stats.minY, this.stats.maxY];
			var xRange = [this.canvas.x, this.canvas.x + this.canvas.width];
			var yRange = [this.canvas.y, this.canvas.y + this.canvas.height];

			function firstDefined(a, b) {
				return a === undefined ? b : a;
			}

			joint.util.toArray(markings).forEach(function (marking, i) {

				// Start and end of the marking. The following adjustments makes it
				// easier to define the marking. It does not really matter if the `end`
				// is before `start`. Also, if the only thing defined is `start.y`, the marking
				// will be a single line starting at that `y` position crossing the whole chart.
				var start = marking.start || marking.end;
				var end = marking.end || marking.start;

				var startX = Math.min(firstDefined(start.x, this.stats.minX), firstDefined(end.x, this.stats.minX));
				var endX = Math.max(firstDefined(start.x, this.stats.maxX), firstDefined(end.x, this.stats.maxX));
				var startY = Math.min(firstDefined(start.y, this.stats.minY), firstDefined(end.y, this.stats.minY));
				var endY = Math.max(firstDefined(start.y, this.stats.maxY), firstDefined(end.y, this.stats.maxY));

				// Scale `start` and `end` to use for translating the marking rectangle.

				// If the marking is a trendline, i.e. one of the coordinates is missing,
				// (in other words the marking is not an area), we want such line to
				// cover the whole view regardless of the canvas area. The reasoning behind
				// this is that, for example, if we have a bar chart and some of the bars
				// are rendered after the canvas area and we can compensate for this by
				// setting a padding on the canvas area, we still want the trendlines
				// to be rendered for those bars.
				var isTrendLineX = start.x === undefined || end.x === undefined;
				var isTrendLineY = start.y === undefined || end.y === undefined;

				if (isTrendLineX) xRange = [0, width];
				if (isTrendLineY) yRange = [0, height];

				var startTx = g.scale.linear(xDomain, xRange, startX);
				var endTx = g.scale.linear(xDomain, xRange, endX);
				var startTy = g.scale.linear(yDomain, yRange, startY);
				var endTy = g.scale.linear(yDomain, yRange, endY);

				// Marking position and dimensions.
				var mx = startTx;
				var my = yRange[1] - endTy + yRange[0];
				var mw = endTx - startTx;
				var mh = endTy - startTy;

				// Limit the marking to the bounding box of the canvas.
				//if (mx + mw > this.canvas.width + this.canvas.x) mw = this.canvas.width + this.canvas.x - mx;
				//if (my + mh > this.canvas.height + this.canvas.y) mh = this.canvas.height + this.canvas.y - my;

				// Make sure we give the marking a positive width and height, otherwise it's not visible at all.
				mw = Math.max(mw, 1);
				mh = Math.max(mh, 1);

				// Render the marking.
				var elMarking = this.elMarking.clone();
				elMarking.findOne('rect').attr({ x: mx, y: my, width: mw, height: mh });
				elMarking.findOne('text').text(marking.label || '').attr({ x: mx + mw, y: my });
				var className = elMarking.attr('class') + ' ' + (marking.name || ('marking-' + i));
				elMarking.attr(joint.util.assign({ 'class': className }, marking.attrs));
				V(this.elMarkings).append(elMarking);

			}, this);
		},

		updateLegend: function () {

			var series = this.model.get('series');

			this.elLegendItems.textContent = '';

			joint.util.toArray(series).forEach(function (serie, i) {

				// Give the outside world the ability to decide whether a legend item should be shown or not.
				if (joint.util.isFunction(serie.showLegend) && !serie.showLegend(serie, this.stats.bySerie[serie.name || i])) {

					return;

				} else if (serie.showLegend === false) {

					return;
				}

				var elLegendItem = this.elLegendItem.clone();
				if (this._disabledSeries.includes(serie.name)) {
					elLegendItem.addClass('disabled');
				}
				elLegendItem.attr('data-serie', serie.name);
				elLegendItem.findOne('circle').attr({ fill: this.getSerieColor(serie.name) });
				elLegendItem.findOne('text').text(serie.label || serie.name);
				elLegendItem.translate(0, i * (serie.legendLabelLineHeight || 16));
				V(this.elLegendItems).append(elLegendItem);

			}, this);
		},

		getSerieColor: function (serieName) {

			var attrs = this.model.get('attrs');

			var serieAttrs = Object.keys(attrs).find(function (selector) {
				return selector.includes(serieName);
			});

			return serieAttrs ? attrs[serieAttrs].stroke || attrs[serieAttrs].fill : 'black';
		},

		hideSerie: function (serieName) {

			if (!this._disabledSeries.includes(serieName)) {
				this._disabledSeries.push(serieName);
			}

			var series = this.filterSeries();
			this.update(series);
		},

		showSerie: function (serieName) {

			this._disabledSeries = joint.util.without(this._disabledSeries, serieName);

			var series = this.filterSeries();
			this.update(series);
		},

		filterSeries: function (series) {

			series = series || this.model.get('series');

			series = joint.util.toArray(series).filter(function (serie) {
				return !this._disabledSeries.includes(serie.name);
			}, this);

			return series;
		},

		// Interaction.
		// ------------

		onPointerDown: function (evt, x, y) {

			var elLegendItem = $(evt.target).closest('.legend-item')[0];
			if (elLegendItem) {

				V(elLegendItem).toggleClass('disabled');

				if (V(elLegendItem).hasClass('disabled')) {

					this.hideSerie(V(elLegendItem).attr('data-serie'));

				} else {

					this.showSerie(V(elLegendItem).attr('data-serie'));
				}
			}
		},

		onMouseMove: function (evt) {

			this.showGuidelines(evt.clientX, evt.clientY, evt);
		},

		onMouseOut: function (evt) {

			this.hideGuidelines();
			this.trigger('mouseout', evt);
		},

		showGuidelines: function (clientX, clientY, evt) {

			var angle = this.model.get('angle');
			var bbox = this.model.getBBox();
			var localPoint = g.point(V(this.paper.viewport).toLocalPoint(clientX, clientY)).rotate(bbox.center(), angle);

			if (g.rect(bbox).containsPoint(localPoint)) {

				var size = this.model.get('size');

				var x = localPoint.x - bbox.x;
				var y = localPoint.y - bbox.y;

				V(this.elXGuideline).attr({ x1: x, y1: 0, x2: x, y2: size.height, visibility: 'visible' });
				V(this.elYGuideline).attr({ x1: 0, y1: y, x2: size.width, y2: y, visibility: 'visible' });

				var dataX = g.scale.linear([this.canvas.x, this.canvas.x + this.canvas.width], [this.stats.minX, this.stats.maxX], x);
				var dataY = g.scale.linear([this.canvas.y, this.canvas.y + this.canvas.height], [this.stats.minY, this.stats.maxY], y);

				var dataPoint = { x: dataX, y: this.stats.minY + this.stats.maxY - dataY };
				var clientPoint = { x: clientX, y: clientY };
				var closestPoints = this.closestPoints(dataX);

				this.trigger('mouseover', dataPoint, clientPoint, closestPoints, evt);
			}
		},

		// Return the closest points for a given `x` value. The returned array contains objects
		// with `x` and `y` values and a `serie` object this `x` value appeared in.
		closestPoints: function (x) {

			var xValuesIndex = joint.util.sortedIndex(this.stats.xValues, x);

			var xValue = this.stats.xValues[xValuesIndex];
			var xValueBefore = this.stats.xValues[xValuesIndex - 1];

			var xClosest = xValueBefore === undefined ? xValue : (Math.abs(x - xValue) < Math.abs(x - xValueBefore) ? xValue : xValueBefore);

			return this.stats.xMap[xClosest];
		},

		hideGuidelines: function () {

			V(this.elXGuideline).attr('visibility', 'hidden');
			V(this.elYGuideline).attr('visibility', 'hidden');
		}
	});

	joint.shapes.chart.Pie = joint.shapes.basic.Generic.extend({

		markup: [
			'<g class="rotatable">',
			'<g class="scalable"></g>',
			'<g class="background"><rect/><text/></g>',
			'<g class="data"></g>',
			'<g class="foreground">',
			'<rect/><text class="caption"/><text class="subcaption"/>',
			'<g class="legend"><g class="legend-items"></g></g>',
			'</g>',
			'</g>'
		].join(''),

		sliceMarkup: '<g class="slice"/>',
		sliceFillMarkup: '<path class="slice-fill"/>',
		sliceBorderMarkup: '<path class="slice-border"/>',
		sliceInnerLabelMarkup: '<text class="slice-inner-label"/>',
		legendSerieMarkup: '<g class="legend-serie"><text/></g>',
		legendSliceMarkup: '<g class="legend-slice"><circle/><text/></g>',

		defaults: joint.util.deepSupplement({

			type: 'chart.Pie',
			size: { width: 200, height: 200 },

			// work only on first (or alone) serie
			pieHole: 0,

			// serieDefaults.startAngle: pie is draw clockwise from est (right)
			serieDefaults: {
				startAngle: 0,
				degree: 360,
				label: null,
				showLegend: true,
				labelLineHeight: 6
			},

			// onClickEffect/onHoverEffect: effect on click/mouseOver (see this.effectOnSlice for a list and option, ex. onHoverEffect: {type: 'enlarge', scale: 1.05})
			sliceDefaults: {
				innerLabel: '{percentage:.0f}%',
				innerLabelMargin: 6,
				legendLabel: '{label}: {value}',
				legendLabelLineHeight: 6,
				legendLabelMargin: 14,
				offset: 0,
				onClickEffect: { type: 'offset', offset: 20 },
				onHoverEffect: null
			},

			series: [],

			attrs: {
				'.background > rect': { opacity: 0 },
				'.background > text': { fill: 'black', text: 'No data available.', ref: '.background > rect', 'ref-x': .5, 'ref-y': .5, 'text-anchor': 'middle', 'y-alignment': 'middle', display: 'none' },
				'.foreground > rect': { fill: 'white', stroke: '#e5e5e5', opacity: 0, 'pointer-events': 'none' },
				'.foreground .caption': { fill: 'black', text: '', ref: '.foreground > rect', 'ref-x': 2, 'ref-y': 6, 'text-anchor': 'start', 'y-alignment': 'middle', 'font-size': 14 },
				'.foreground .subcaption': { fill: 'black', text: '', ref: '.foreground > rect', 'ref-x': 2, 'ref-y': 18, 'text-anchor': 'start', 'y-alignment': 'middle', 'font-size': 10 },
				'.data': { ref: '.background', 'ref-x': .5, 'ref-y': .5 },
				'.slice': { cursor: 'pointer' },
				'.slice > .slice-fill': { stroke: '#ffffff', 'stroke-width': 1, 'fill-opacity': 1 },
				'.slice.hover > .slice-fill': { 'fill-opacity': .8 },
				'.slice > .slice-border': { 'stroke-width': 6, 'stroke-opacity': .4, 'fill-opacity': 1, fill: 'none', display: 'none' },
				'.slice.hover > .slice-border': { display: 'block' },
				'.slice > .slice-inner-label': { 'text-anchor': 'middle', 'font-size': '12', stroke: 'none', 'stroke-width': '0', fill: '#ffffff' },
				'.slice > .slice-inner-label > tspan': { dy: '-.5em' },
				'.legend': { 'ref-dx': 20, 'ref-y': 5 },
				'.legend-serie text': { fill: 'grey', transform: 'translate(2, 0)', 'font-size': 13 },
				'.legend-slice': { cursor: 'pointer' },
				'.legend-slice text': { 'font-weight': 'normal', fill: 'black', 'font-size': 11 },
				'.legend-slice.hover text': { 'font-weight': 'bold' },
				'.legend-slice circle': { r: 5, transform: 'translate(5,5)' }
			}

		}, joint.shapes.basic.Generic.prototype.defaults),

		addSlice: function (slice, serieIndex, opt) {

			opt = opt || {};
			serieIndex = serieIndex || 0;

			var series = this.get('series');

			// If serie is undefinied (first slice added to serie)
			if (series[serieIndex] === undefined) series[serieIndex] = { data: [] };

			// Clone the serie so that the normal Backbone mechanism for `set()` and `prev()` works as expected.
			var serie = joint.util.cloneDeep(series[serieIndex]);
			serie.data.push(slice);

			// Again, slice the array so that we don't alter the `series` array currently set.
			series = series.slice();
			series[serieIndex] = serie;

			// If it's a new serie (first slice added)
			opt = serie.data.length > 1 ? joint.util.assign(opt, { changedSerieIndex: serieIndex }) : opt;

			// Set in opt the serieIndex that change for update only serieIndex on view (could it be better?)
			this.set('series', series, opt);
		},

		editSlice: function (slice, sliceIndex, serieIndex, opt) {

			opt = opt || {};
			serieIndex = serieIndex || 0;

			var series = this.get('series');

			if (series[serieIndex] === undefined || series[serieIndex].data[sliceIndex] === undefined) {
				throw new Error('Slice ' + sliceIndex + ' on serie ' + serieIndex + ' was not found.');
			}

			// Clone the serie so that the normal Backbone mechanism for `set()` and `prev()` works as expected.
			var serie = joint.util.cloneDeep(series[serieIndex]);
			serie.data[sliceIndex] = joint.util.assign(serie.data[sliceIndex], slice);

			// Again, slice the array so that we don't alter the `series` array currently set.
			series = series.slice();
			series[serieIndex] = serie;

			this.set('series', series, joint.util.assign(opt, { changedSerieIndex: serieIndex }));
		}
	});

	joint.shapes.chart.PieView = joint.dia.ElementView.extend({

		events: {
			'mouseover .slice': 'onMouseOverSlice',
			'mouseout .slice': 'onMouseOverSlice',
			'mousemove .slice': 'onMouseMoveSlice',
			'mouseover .legend-slice': 'onEventLegendItem',
			'mouseout .legend-slice': 'onEventLegendItem'
		},

		initialize: function () {

			joint.dia.ElementView.prototype.initialize.apply(this, arguments);

			// Little optimization that update only the serie changed
			this.listenTo(this.model, 'change:series change:serieDefaults change:sliceDefaults change:pieHole',
				function (model, attr, opt) {
					this.update(null, null, null, opt.changedSerieIndex);
				});

			this.on('cell:pointerclick', this.onClickSlice, this);
			this.on('cell:pointerclick', this.onEventLegendItem, this);
		},

		renderMarkup: function () {

			joint.dia.ElementView.prototype.renderMarkup.apply(this, arguments);

			// Cache important elements for faster access.
			this.elBackgroundRect = this.$('.background rect')[0];
			this.elBackgroundText = this.$('.background text')[0];

			this.elForegroundRect = this.$('.foreground rect')[0];

			this.elLegendItems = this.$('.legend-items')[0];

			this.elPie = this.$('.data')[0];

			// An SVG element for repeatable elements. This will be used as an original for future clones.
			this.elSlice = V(this.model.sliceMarkup);
			this.elSliceFill = V(this.model.sliceFillMarkup);
			this.elSliceBorder = V(this.model.sliceBorderMarkup);
			this.elSliceInnerLabel = V(this.model.sliceInnerLabelMarkup);

			this.elLegendSerie = V(this.model.legendSerieMarkup);
			this.elLegendSlice = V(this.model.legendSliceMarkup);
		},

		update: function (cell, renderingOnlyAttrs, opt, serieIndex) {

			var series = this.calculateSeries(serieIndex);

			if (serieIndex in series) {
				// Remove only the serieIndex for which is request update
				$(this.elPie).find('.serie-' + serieIndex).remove();
			} else {
				// Remove all the previously rendered series.
				$(this.elPie).empty();
			}

			var size = this.model.get('size');
			V(this.elBackgroundRect).attr(size);
			V(this.elForegroundRect).attr(size);

			if (!series.length) {
				// No data available.
				// Show the "No data available" label that is hidden by default.
				$(this.elBackgroundText).show();
			} else {
				$(this.elBackgroundText).hide();
			}

			joint.util.toArray(series).forEach(function (serie, index) {
				// Use serieIndex for update only the requested serie
				if (serieIndex !== undefined && serieIndex !== index) return;

				joint.util.forIn(serie.data, this.updateSlice.bind(this));
			}, this);

			this.updateLegend();

			// Apply attrs.
			joint.dia.ElementView.prototype.update.apply(this, arguments);
		},

		calculateSeries: function (serieIndex) {

			var series = joint.util.cloneDeep(this.model.get('series'));

			var serieDefaults = this.model.get('serieDefaults');
			var sliceDefaults = this.model.get('sliceDefaults');

			// Pie outer radius less margin
			var size = this.model.get('size');
			var radius = Math.min(size.width, size.height) / 2;

			var pieHole = this.model.get('pieHole');
			pieHole = pieHole > 1 ? pieHole : radius * pieHole;

			var outerRadius = radius;
			var radiusStep = (radius - pieHole) / series.length;

			this._series = series.map(function (serie, index) {

				// Use serieIndex for update only the selected serie
				if (serieIndex !== undefined && serieIndex !== index) return serie;

				serie = joint.util.defaults(serie, serieDefaults);

				var startAngle = serie.startAngle;

				// Calculate percentage of each slice
				var total = serie.data.reduce(function (sum, slice) {
					return sum + slice.value;
				}, 0);
				var circleDividedByTotal = serie.degree / total || 0;
				var percentageDividedByTotal = 100 / total;

				serie.data = serie.data.map(function (slice, sliceIndex) {

					// Init default params for all slice (less some attributes valid only for outer slice)
					slice = joint.util.defaults(slice, joint.util.omit(sliceDefaults, 'offset', 'onClickEffect', 'onHoverEffect'));

					slice.outerRadius = outerRadius;
					slice.innerRadius = outerRadius - radiusStep;

					// For outer slice
					if (!index) {
						// Init default params for outer slice
						slice = joint.util.defaults(slice, joint.util.pick(sliceDefaults, 'offset', 'onClickEffect', 'onHoverEffect'));

						slice.isOuter = true;
						slice.offset = slice.offset > 1 ? slice.offset : slice.offset * slice.outerRadius;
						slice.onClickEffect.offset = slice.onClickEffect.offset > 1 ? slice.onClickEffect.offset : slice.onClickEffect.offset * slice.outerRadius;
					}

					slice.serieIndex = index;
					slice.sliceIndex = sliceIndex;
					slice.innerLabelMargin = (slice.innerLabelMargin < -1 || slice.innerLabelMargin > 1) ? slice.innerLabelMargin : slice.innerLabelMargin * slice.outerRadius;
					slice.percentage = slice.value * percentageDividedByTotal;

					var angle = slice.value * circleDividedByTotal;

					slice.degree = {
						angle: angle,
						start: startAngle,
						end: angle + startAngle
					};

					slice.rad = {
						angle: g.toRad(slice.degree.angle, true),
						start: g.toRad(slice.degree.start, true),
						end: g.toRad(slice.degree.end, true)
					};

					slice.middleangle = (slice.rad.start + slice.rad.end) / 2;

					startAngle = slice.degree.end;

					return slice;
				});

				outerRadius -= radiusStep;

				return serie;
			});

			return this._series;
		},

		updateLegend: function () {

			var series = this._series;

			this.elLegendItems.textContent = '';

			var xPadding = 0;
			var fontSizeLegendSerieText = parseInt(this.model.attr('.legend-serie text/font-size'), 10);
			var fontSizeLegendSliceText = parseInt(this.model.attr('.legend-slice text/font-size'), 10);

			joint.util.toArray(series).forEach(function (serie, serieIndex) {

				if (!serie.showLegend) return;

				// Append Serie label
				if (serie.label) {
					var elLegendSerie = this.elLegendSerie.clone();

					if (serie.name) elLegendSerie.addClass(serie.name);
					elLegendSerie.attr({ 'data-serie': serieIndex });

					elLegendSerie.findOne('text').text(serie.label);
					elLegendSerie.translate(0, xPadding);

					V(this.elLegendItems).append(elLegendSerie);

					// 1.5 is the proportional space between the legend items (one and half height of item)
					xPadding += (fontSizeLegendSerieText + serie.labelLineHeight);
				}

				// Append Slices
				joint.util.forIn(serie.data, function (slice, sliceIndex) {

					var elLegendSlice = this.elLegendSlice.clone();

					var slicefillColor = this.getSliceFillColor(sliceIndex, serieIndex);

					if (slice.name) elLegendSlice.addClass(slice.name);
					elLegendSlice.attr({ 'data-serie': serieIndex, 'data-slice': sliceIndex });

					elLegendSlice.findOne('text').text(joint.util.format.string(slice.legendLabel, slice));
					elLegendSlice.findOne('text').translate(slice.legendLabelMargin);
					elLegendSlice.translate(0, xPadding);

					// 1.5 is the proportional space between the legend items (one and half height of item)
					xPadding += (fontSizeLegendSliceText + slice.legendLabelLineHeight);

					// is a gradient
					if (joint.util.isObject(slicefillColor)) {
						this.applyGradient(elLegendSlice.findOne('circle'), 'fill', slicefillColor);
					} else {
						elLegendSlice.findOne('circle').attr({ fill: slicefillColor });
					}

					V(this.elLegendItems).append(elLegendSlice);

				}.bind(this));
			}, this);
		},

		// `selector` is a CSS selector or `'.'`. `attr` is either a `'fill'` or `'stroke'`.
		// `gradient` must be in the special JointJS gradient format:
		// `{ type: <linearGradient|radialGradient>, stops: [ { offset: <offset>, color: <color> }, ... ]`.
		// An example is: `{ fill: { type: 'linearGradient', stops: [ { offset: '10%', color: 'green' }, { offset: '50%', color: 'blue' } ] } }`.
		applyGradient: function (selector, attr, gradient) {

			var $selected = joint.util.isString(selector) ? this.findBySelector(selector) : $(selector);
			var gradientId = this.paper.defineGradient(gradient);

			$selected.each(function () {
				V(this).attr(attr, 'url(#' + gradientId + ')');
			});
		},

		updateSlice: function (slice) {

			var elSlice = this.elSlice.clone();

			// Append slice (at start for use .bbox() later)
			V(this.elPie).append(elSlice);

			// RENDER SLICE
			var elSliceFill = this.elSliceFill.clone();

			var slicefillColor = this.getSliceFillColor(slice.sliceIndex, slice.serieIndex);

			elSliceFill.attr({
				fill: slicefillColor,
				d: V.createSlicePathData(slice.innerRadius, slice.outerRadius, slice.rad.start, slice.rad.end)
			});

			elSlice.append(elSliceFill);

			// is a gradient
			if (joint.util.isObject(slicefillColor)) {

				this.applyGradient('#' + elSliceFill.attr('id'), 'fill', slicefillColor);
			}

			// RENDER BORDER
			var elSliceBorder = this.elSliceBorder.clone();

			// ...with polar coordinate
			var borderStrokeWidth = parseInt(this.model.attr('.slice > .slice-border/stroke-width'), 10);
			var startPoint = g.point.fromPolar(slice.outerRadius + borderStrokeWidth / 2, -slice.rad.start, g.point(0, 0));
			var endPoint = g.point.fromPolar(slice.outerRadius + borderStrokeWidth / 2, -slice.rad.end, g.point(0, 0));

			elSliceBorder.attr({
				stroke: slicefillColor,
				d: this.drawArc(startPoint, endPoint, slice.outerRadius + borderStrokeWidth / 2, slice.rad.start, slice.rad.end)
			});

			elSlice.append(elSliceBorder);

			// is a gradient
			if (joint.util.isObject(slicefillColor)) {

				this.applyGradient('#' + elSliceBorder.attr('id'), 'stroke', slicefillColor);
			}

			// RENDER INNER LABEL
			var elSliceInnerLabel = this.elSliceInnerLabel.clone();

			// Apply inner label text through template
			elSliceInnerLabel.text(joint.util.format.string(slice.innerLabel, slice));

			elSlice.append(elSliceInnerLabel);

			// After the append (inserted in DOM) can calculate bbox of element
			var innerLabelBbox = elSliceInnerLabel.bbox();

			// Translate label: the gap from the middle of the text (bbox) and the pie border is constant
			var radiusLabel = (slice.outerRadius - innerLabelBbox.width / 2) - slice.innerLabelMargin;

			elSliceInnerLabel.translate((radiusLabel * Math.cos(-slice.middleangle)),
				(-radiusLabel * Math.sin(-slice.middleangle)));

			// Add element data attributes
			elSlice.attr({
				'data-serie': slice.serieIndex,
				'data-slice': slice.sliceIndex,
				'data-value': slice.value
			});

			// Add class for styling use
			var nameSerie = this._series[slice.serieIndex].name;

			if (nameSerie) elSlice.addClass(nameSerie);
			if (slice.name) elSlice.addClass(slice.name);

			elSlice.addClass('serie-' + slice.serieIndex + ' slice-' + slice.sliceIndex);

			// Is an outer slice
			if (slice.isOuter) {
				elSlice.addClass('outer');

				// Apply init offset for explode some slices
				if (slice.offset) {
					elSlice.addClass('clicked');

					this.effectOnSlice(elSlice, slice, { type: 'offset', offset: slice.offset });
				}
			}

			return elSlice;
		},

		getSliceFillColor: function (sliceIndex, serieIndex) {

			serieIndex = serieIndex || 0;

			var attrs = this.model.get('attrs');

			// Find if there is customized fill color for selected slice in attrs
			var sliceFillAttr = Object.keys(attrs).find(function (selector) {
				return selector.indexOf('.serie-' + serieIndex + '.slice-' + sliceIndex + ' > .slice-fill') > -1;
			});

			return sliceFillAttr ? attrs[sliceFillAttr].fill : this._series[serieIndex].data[sliceIndex].fill;
		},

		onMouseMoveSlice: function (event) {

			var elSlice = V(event.currentTarget);

			var serieIndex = elSlice.attr('data-serie');
			var sliceIndex = elSlice.attr('data-slice');

			var slice = this._series[serieIndex].data[sliceIndex];

			this.trigger(event.type, slice, event);
		},

		mouseOverSlice: function (sliceIndex, serieIndex) {

			serieIndex = serieIndex || 0;

			var elSlice = V(this.$('.slice[data-serie="' + serieIndex + '"][data-slice="' + sliceIndex + '"]')[0]);

			var slice = this._series[serieIndex].data[sliceIndex];

			elSlice.toggleClass('hover');

			// Do effect if it is an outer slice and requested
			if (slice.isOuter && !joint.util.isEmpty(slice.onHoverEffect)) {
				this.effectOnSlice(elSlice, slice, slice.onHoverEffect, elSlice.hasClass('hover') ? false : true);
			}

			// Add class 'hover' also to legend
			var elLegendSlice = V(this.$('.legend-slice[data-serie="' + serieIndex + '"][data-slice="' + sliceIndex + '"]')[0]);
			if (elLegendSlice) elLegendSlice.toggleClass('hover');

			// Apply only attr style with selector '.slice' or '.legend-slice'
			var attrsForSliceAndLegend = Object.keys(this.model.get('attrs')).filter(function (selector) {
				return (selector.indexOf('.slice') > -1 || selector.indexOf('.legend-slice') > -1);
			});

			joint.dia.ElementView.prototype.update.call(this, this.model, joint.util.pick(this.model.get('attrs'), attrsForSliceAndLegend));
		},

		onMouseOverSlice: function (event) {

			var elSlice = V(event.currentTarget);

			var serieIndex = elSlice.attr('data-serie');
			var sliceIndex = elSlice.attr('data-slice');

			this.mouseOverSlice(sliceIndex, serieIndex);

			var slice = this._series[serieIndex].data[sliceIndex];

			this.trigger(event.type, slice, event);
		},

		clickSlice: function (sliceIndex, serieIndex) {

			serieIndex = serieIndex || 0;

			var elSlice = V(this.$('.slice[data-serie="' + serieIndex + '"][data-slice="' + sliceIndex + '"]')[0]);

			var slice = this._series[serieIndex].data[sliceIndex];

			if (!slice.isOuter) return;

			if (!elSlice.hasClass('clicked')) {
				elSlice.addClass('clicked');

				// Update the model series => resize and clone preserve offset
				this.model.get('series')[serieIndex].data[sliceIndex].offset = slice.onClickEffect.offset;

				this.effectOnSlice(elSlice, slice, slice.onClickEffect);
			} else {
				elSlice.removeClass('clicked');

				// Update the model series => resize and clone preserve offset
				this.model.get('series')[serieIndex].data[sliceIndex].offset = 0;

				this.effectOnSlice(elSlice, slice, slice.onClickEffect, true);
			}
		},

		onClickSlice: function (event) {

			// Only for outer (external slice)
			var elSlice = V($(event.target).closest('.slice.outer')[0]);

			if (elSlice) {

				var serieIndex = elSlice.attr('data-serie');
				var sliceIndex = elSlice.attr('data-slice');

				this.clickSlice(sliceIndex, serieIndex);

				var slice = this._series[serieIndex].data[sliceIndex];

				this.trigger(event.type, slice, event);
			}
		},

		onEventLegendItem: function (event) {

			var elLegendItem = V($(event.target).closest('.legend-slice')[0]);

			if (elLegendItem) {

				var serieIndex = elLegendItem.attr('data-serie');
				var sliceIndex = elLegendItem.attr('data-slice');

				switch (event.type) {
					case 'click':
						this.clickSlice(sliceIndex, serieIndex);
						break;
					case 'mouseover':
					case 'mouseout':
						this.mouseOverSlice(sliceIndex, serieIndex);
						break;
				}
			}
		},

		effectOnSlice: function (elSlice, slice, effect, remove) {

			remove = remove || false;

			switch (effect.type) {
				case 'enlarge':
					if (!remove) elSlice.scale(effect.scale || 1.05);
					else elSlice.scale(1);
					break;
				case 'offset':
					if (!remove) elSlice.translate(effect.offset * Math.cos(-slice.middleangle), -effect.offset * Math.sin(-slice.middleangle));
					else elSlice.translate(0, 0, { absolute: true });
					break;
			}
		},

		svgArcMax: 2 * Math.PI - 1e-6,
		drawArc: function (startPoint, endPoint, radius, startAngle, endAngle) {
			var largeArcFlag = 0;
			var sweepFlag = 1;

			var angle = endAngle - startAngle;

			if (angle > Math.PI) {

				largeArcFlag = 1;

				if (angle >= this.svgArcMax) {
					largeArcFlag = 0;
					sweepFlag = 0;
				}
			}

			return 'M' + startPoint.x + ',' + startPoint.y + ' A' + radius + ','
				+ radius + ' 0 ' + largeArcFlag + ',' + sweepFlag
				+ ' ' + endPoint.x + ',' + endPoint.y;
		}

	});

	// Knob chart.
	// -----------

	// Supports the following properties:
	// `min` and `max` for defining the domain of the `value`.
	// `value` is the final value of the knob.
	// `fill` for the fill color of the knob.
	// Moreover, all of these properties can be arrays in which case the knob
	// displayes more values stacked one on another.
	joint.shapes.chart.Knob = joint.shapes.chart.Pie.extend({

		defaults: joint.util.deepSupplement({
			type: 'chart.Knob',
			sliceDefaults: {
				legendLabel: '{value:.0f}',
				outer: { offsetOnClick: 0 }
			},
			pieHole: .7,
			value: 0,
			attrs: {
				'.legend': { 'ref-x': .5, 'ref-y': .5, 'ref-dx': null, 'x-alignment': -.5, 'y-alignment': -.5 },
				'.legend-slice text': { 'font-size': 30 },
				'.legend-slice circle': { display: 'none' },
				'.slice-inner-label': { display: 'none' },
				'.slice-fill': { stroke: 'none' }
			}
		}, joint.shapes.chart.Pie.prototype.defaults),

		initialize: function () {

			this.set('series', this.getKnobSeries(), { silent: true });
			joint.shapes.chart.Pie.prototype.initialize.apply(this, arguments);
			this.on('change:value change:min change:max change:fill', this.updateKnob, this);
		},

		getKnobSeries: function () {

			// Create one serie with one slice holding the knob value and color.
			var values = Array.isArray(this.get('value')) ? this.get('value') : [this.get('value')];
			var fills = Array.isArray(this.get('fill')) ? this.get('fill') : [this.get('fill')];
			var mins = Array.isArray(this.get('min')) ? this.get('min') : [this.get('min')];
			var maxs = Array.isArray(this.get('max')) ? this.get('max') : [this.get('max')];
			var series = values.map(function (value, i) {

				var min = mins[i] === undefined ? mins[0] : mins[i];
				var max = maxs[i] === undefined ? maxs[0] : maxs[i];
				var fill = fills[i] === undefined ? fills[0] : fills[i];
				return {
					degree: g.scale.linear([min, max], [0, 360], value),
					data: [{ value: value, fill: fill }],
					showLegend: i > 0 ? false : true // Show legend only for the first serie.
				};
			});

			return series;
		},

		updateKnob: function () {

			this.set('series', this.getKnobSeries());
		}
	});

	joint.shapes.chart.KnobView = joint.shapes.chart.PieView;


	// Matrix diagram.
	joint.shapes.chart.Matrix = joint.shapes.basic.Generic.extend({

		markup: [
			'<g class="rotatable">',
			'<g class="scalable">',
			'<g class="background"><rect/></g>',
			'<g class="cells"/>',
			'<g class="foreground"/>',
			'</g>',
			'<g class="labels">',
			'<g class="rows"/>',
			'<g class="columns"/>',
			'</g>',
			'</g>'
		].join(''),

		cellMarkup: '<rect class="cell"/>',
		labelMarkup: '<text class="label"/>',
		gridLineMarkup: '<path class="grid-line"/>',

		defaults: joint.util.deepSupplement({

			type: 'chart.Matrix',

			attrs: {
				'.background rect': { fill: '#eeeeee' },
				'.grid-line': { stroke: 'white', 'stroke-width': 2 },
				'.label': { fill: 'black', 'alignment-baseline': 'middle' },
				'.labels .rows .label': { 'text-anchor': 'end' },
				'.labels .columns .label': { 'text-anchor': 'start' }
			}

		}, joint.shapes.basic.Generic.prototype.defaults)
	});

	joint.shapes.chart.MatrixView = joint.dia.ElementView.extend({

		initialize: function () {

			joint.dia.ElementView.prototype.initialize.apply(this, arguments);
			this.listenTo(this.model, 'change:size', function () { this.renderLabels(); this.update(); });
			this.listenTo(this.model, 'change:cells', function () { this.renderMarkup(); this.update(); });
		},

		renderMarkup: function () {

			joint.dia.ElementView.prototype.renderMarkup.apply(this, arguments);

			this.elCells = this.$('.cells')[0];
			this.elRowLabels = this.$('.labels .rows')[0];
			this.elColumnLabels = this.$('.labels .columns')[0];
			this.elForeground = this.$('.foreground')[0];

			this.elCell = V(this.model.cellMarkup);
			this.elGridLine = V(this.model.gridLineMarkup);

			var cells = this.model.get('cells') || [];
			var size = this.model.get('size');

			this.elBackgroundRect = this.$('.background rect')[0];
			V(this.elBackgroundRect).attr(size);

			var cellHeight = size.height / cells.length;
			var cellWidth = size.width / cells.length;
			var elCellsFragment = document.createDocumentFragment();
			this.elCells.textContent = '';

			this.elForeground.textContent = '';
			var elGridLinesFragment = document.createDocumentFragment();

			// Cells.
			// ------

			var row, j, elGridLine, cell, elCell;

			for (var i = 0; i < cells.length; i++) {

				elGridLine = this.elGridLine.clone();
				elGridLine.addClass('horizontal');
				elGridLine.attr('d', 'M 0 ' + (i * cellHeight) + ' ' + size.width + ' ' + (i * cellHeight));
				elGridLinesFragment.appendChild(elGridLine.node);

				row = cells[i];
				for (j = 0; j < row.length; j++) {

					if (i === 0) {

						elGridLine = this.elGridLine.clone();
						elGridLine.addClass('vertical');
						elGridLine.attr('d', 'M ' + (j * cellWidth) + ' 0 ' + (j * cellWidth) + ' ' + size.height);
						elGridLinesFragment.appendChild(elGridLine.node);
					}

					cell = row[j];
					if (cell) {
						elCell = this.elCell.clone();
						elCell.attr(joint.util.assign({
							x: j * cellWidth,
							y: i * cellHeight,
							width: cellWidth,
							height: cellHeight
						}, cell));

						elCellsFragment.appendChild(elCell.node);
					}
				}
			}

			this.elForeground.appendChild(elGridLinesFragment);
			this.elCells.appendChild(elCellsFragment);

			this.renderLabels();
		},

		renderLabels: function () {

			// Labels are outside the scalables groups. Therefore,
			// we must make sure their position stays correct after resize.

			this.elLabel = V(this.model.labelMarkup);

			var cells = this.model.get('cells') || [];
			var labels = this.model.get('labels') || {};
			var rowLabels = labels.rows || [];
			var columnLabels = labels.columns || [];
			var size = this.model.get('size');
			var cellHeight = size.height / cells.length;
			var cellWidth = size.width / cells.length;
			var label, elLabel;

			this.elRowLabels.textContent = '';
			this.elColumnLabels.textContent = '';

			var elRowLabelsFragment = document.createDocumentFragment();
			for (var i = 0; i < rowLabels.length; i++) {

				label = labels.rows[i];
				elLabel = this.elLabel.clone();
				elLabel.text(label.text);
				elLabel.attr(joint.util.assign({
					x: -(labels.padding || 5),
					y: i * cellHeight + cellHeight / 2,
					'text-anchor': 'end',
					'dominant-baseline': 'central',
					'font-size': cellHeight,
					'data-row': i
				}, joint.util.omit(label, 'text')));
				elRowLabelsFragment.appendChild(elLabel.node);
			}
			this.elRowLabels.appendChild(elRowLabelsFragment);

			var x, y;
			var elColumnLabelsFragment = document.createDocumentFragment();
			for (var j = 0; j < columnLabels.length; j++) {

				label = labels.columns[j];
				elLabel = this.elLabel.clone();
				x = j * cellWidth + cellWidth / 2;
				y = -(labels.padding || 5);
				elLabel.attr('x', x);
				elLabel.text(label.text);
				elLabel.attr(joint.util.assign({
					y: y,
					'text-anchor': 'start',
					'dominant-baseline': 'central',
					'font-size': cellWidth,
					'data-column': j
				}, joint.util.omit(label, 'text')));
				elLabel.rotate(-90, x, y);
				elColumnLabelsFragment.appendChild(elLabel.node);
			}
			this.elColumnLabels.appendChild(elColumnLabelsFragment);
		}
	});

	joint.shapes.bpmn = {};

	joint.shapes.bpmn.icons = {

		none: '',

		message: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDUxMiA1MTIiIGhlaWdodD0iNTEycHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEycHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGQ9Ik00NzkuOTk4LDY0SDMyQzE0LjMyOSw2NCwwLDc4LjMxMiwwLDk2djMyMGMwLDE3LjY4OCwxNC4zMjksMzIsMzIsMzJoNDQ3Ljk5OEM0OTcuNjcxLDQ0OCw1MTIsNDMzLjY4OCw1MTIsNDE2Vjk2ICBDNTEyLDc4LjMxMiw0OTcuNjcxLDY0LDQ3OS45OTgsNjR6IE00MTYsMTI4TDI1NiwyNTZMOTYsMTI4SDQxNnogTTQ0OCwzODRINjRWMTYwbDE5MiwxNjBsMTkyLTE2MFYzODR6Ii8+PC9zdmc+',

		plus: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIyLjUsMTRIMTR2OC41YzAsMC4yNzYtMC4yMjQsMC41LTAuNSwwLjVoLTRDOS4yMjQsMjMsOSwyMi43NzYsOSwyMi41VjE0SDAuNSAgQzAuMjI0LDE0LDAsMTMuNzc2LDAsMTMuNXYtNEMwLDkuMjI0LDAuMjI0LDksMC41LDlIOVYwLjVDOSwwLjIyNCw5LjIyNCwwLDkuNSwwaDRDMTMuNzc2LDAsMTQsMC4yMjQsMTQsMC41VjloOC41ICBDMjIuNzc2LDksMjMsOS4yMjQsMjMsOS41djRDMjMsMTMuNzc2LDIyLjc3NiwxNCwyMi41LDE0eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+',

		cross: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGQ9Ik0yMi4yNDUsNC4wMTVjMC4zMTMsMC4zMTMsMC4zMTMsMC44MjYsMCwxLjEzOWwtNi4yNzYsNi4yN2MtMC4zMTMsMC4zMTItMC4zMTMsMC44MjYsMCwxLjE0bDYuMjczLDYuMjcyICBjMC4zMTMsMC4zMTMsMC4zMTMsMC44MjYsMCwxLjE0bC0yLjI4NSwyLjI3N2MtMC4zMTQsMC4zMTItMC44MjgsMC4zMTItMS4xNDIsMGwtNi4yNzEtNi4yNzFjLTAuMzEzLTAuMzEzLTAuODI4LTAuMzEzLTEuMTQxLDAgIGwtNi4yNzYsNi4yNjdjLTAuMzEzLDAuMzEzLTAuODI4LDAuMzEzLTEuMTQxLDBsLTIuMjgyLTIuMjhjLTAuMzEzLTAuMzEzLTAuMzEzLTAuODI2LDAtMS4xNGw2LjI3OC02LjI2OSAgYzAuMzEzLTAuMzEyLDAuMzEzLTAuODI2LDAtMS4xNEwxLjcwOSw1LjE0N2MtMC4zMTQtMC4zMTMtMC4zMTQtMC44MjcsMC0xLjE0bDIuMjg0LTIuMjc4QzQuMzA4LDEuNDE3LDQuODIxLDEuNDE3LDUuMTM1LDEuNzMgIEwxMS40MDUsOGMwLjMxNCwwLjMxNCwwLjgyOCwwLjMxNCwxLjE0MSwwLjAwMWw2LjI3Ni02LjI2N2MwLjMxMi0wLjMxMiwwLjgyNi0wLjMxMiwxLjE0MSwwTDIyLjI0NSw0LjAxNXoiLz48L3N2Zz4=',

		user: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIyLDIwLjk5OGgtMWMwLDAtMSwwLTEtMVYxNy41YzAtMC4yNzctMC4yMjQtMC41LTAuNS0wLjVTMTksMTcuMjIzLDE5LDE3LjUgIGwtMC4wMDgsNC4yOTVjMCwwLjYwOS0yLjAxLDIuMjA1LTYuNDkyLDIuMjA1cy02LjQ5Mi0xLjU5Ni02LjQ5Mi0yLjIwNUw2LDE3LjVDNiwxNy4yMjMsNS43NzYsMTcsNS41LDE3UzUsMTcuMjIzLDUsMTcuNXYyLjQ5OCAgYzAsMS0xLDEtMSwxSDNjMCwwLTEsMC0xLTFWMTUuNzVjMC0yLjkyMiwyLjg5Mi01LjQwMSw2LjkzLTYuMzQxYzAsMCwxLjIzNCwxLjEwNywzLjU3LDEuMTA3czMuNTctMS4xMDcsMy41Ny0xLjEwNyAgYzQuMDM4LDAuOTQsNi45MywzLjQxOSw2LjkzLDYuMzQxdjQuMjQ4QzIzLDIwLjk5OCwyMiwyMC45OTgsMjIsMjAuOTk4eiBNMTIuNDc3LDljLTIuNDg1LDAtNC41LTIuMDE1LTQuNS00LjVTOS45OTEsMCwxMi40NzcsMCAgczQuNSwyLjAxNSw0LjUsNC41UzE0Ljk2Miw5LDEyLjQ3Nyw5eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+',

		circle: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gULEBE3DEP64QAAAwlJREFUaN7dmktrU0EUx38ZmmBbfEIL2hSjkYKC1EW6EDFudC+404/gE6WKSvGxERQfIH4AX1T9EOKrCrYurVrbgsZWoaBVixDbpC6ci+Fyz9ybZG478cBs7syc+Z+5c86c+c8ksCPrgW1ADtgEbARafG1+AW+AYWAIGADGWUTZAJwHxoD5GssocA7ILiTwLcADoFQHcH8pAfeB7jiBtwO3gLJF4P5S1mO02wa/C5iMEbi/TAI7bYE/Y3m5VLOs+sLAJULqrgKHIxhZBp4DT4FX2jkLGoinq1M7fg7YDmwFVATd14CjFboiy5UIs/QBOAmka/izaeCU1hE2zuVqlZ8IUfgVOAA0WViiTcBBrdM0Zm9UhTuAOYOiRzXOeJh0Ak8M484B+TAlK4BPBiU3gWSMoTqpw6g0fgFYblJww9D5dojT25IEcMeA47rUsdsQLp9FmPmURSNSOqpJS2lzUKd+ocN3IBNx5mz+oXXADwHTXX/jjMFxjy1iwtgrYJoF1lY27BMafozZaaMspYKA7XRlw7f1xt4Y5biA7bXXIGv4TW0OGNCmsQRhzCidlwTJADDlgAFTwAuhLq+AHqHyMe6IhKVHAV1C5ZBDBkhYupThPPreIQNGJTJBGXKLLw4Z8NmQu/Fb8PCkQwakBIxFRWPLvAJmhMpWh4AuFb7PKGBaqFzjkAGrhe/TSjNrQZJ1yAAJy5gCRoTKnEMGSFhGFDBoOBu7IhKWQe8wLRFLHQ6A7zCcFNNK59vvAjoqYK8DBuwTCLBhTUD8Hweahj9S2jjU297VqzrU26BVmi2yEjXRKg1PbHnpqYla7AeWxAi+GbhHHdSit2mYyN2XQQ5kQTJ6Y6qL3PUkCr2+H7v0+jcs0eueRLngGNeKa9mxY73g8JzpEtHusorAQ/7e+e7WUWIl//jSVTrK7QEu6KgW9d7tYr3B44iBWPJfkZZ8pZ4r2VngkC0HywMTLNwN5YSBcKtZWoGzernEBbyox2iJc6Np2KcGfnHisYet1CDouc2yCjbhp07MrD+3+QNxi4JkAscRswAAAABJRU5ErkJggg==',

		service: 'data:image/png;base64,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'
	};

	// Icon Interface

	joint.shapes.bpmn.IconInterface = {

		initialize: function () {

			// In order to be able to use multiple interfaces for one Backbone.model, we need to keep
			// reference to the actual parent class prototype.
			this._parent = (this._parent || this).constructor.__super__;

			this._parent.initialize.apply(this, arguments);

			this.listenTo(this, 'change:icon', this._onIconChange);

			this._onIconChange(this, this.get('icon') || 'none');
		},

		_onIconChange: function (cell, icon) {

			var icons = joint.shapes.bpmn.icons;

			if (joint.util.has(icons, icon)) {

				cell.attr('image/xlink:href', icons[icon]);

			} else {

				throw 'BPMN: Unknown icon: ' + icon;
			}
		}
	};

	// SubProcess Interface

	joint.shapes.bpmn.SubProcessInterface = {

		initialize: function () {

			// See IconInterface.initialize()
			this._parent = (this._parent || this).constructor.__super__;

			this._parent.initialize.apply(this, arguments);

			this.listenTo(this, 'change:subProcess', this._onSubProcessChange);

			this._onSubProcessChange(this, this.get('subProcess') || null);
		},

		_onSubProcessChange: function (cell, subProcess) {

			cell.attr({
				'.sub-process': {
					visibility: subProcess ? 'visible' : 'hidden',
					'data-sub-process': subProcess || ''
				}
			});
		}
	};


	// Task

	joint.shapes.bpmn.ActivityView = joint.shapes.basic.TextBlockView;
	joint.shapes.bpmn.Activity = joint.shapes.basic.TextBlock.extend({

		markup: [
			'<g class="rotatable">',
			'<g class="scalable"><rect class="body outer"/><rect class="body inner"/></g>',
			joint.env.test('svgforeignobject') ? '<foreignObject class="fobj"><body xmlns="http://www.w3.org/1999/xhtml"><div class="content"/></body></foreignObject>' : '<text class="content"/>',
			'<path class="sub-process"/><image class="icon"/></g>'
		].join(''),

		defaults: joint.util.deepSupplement({

			size: { width: 100, height: 100 },
			type: 'bpmn.Activity',
			attrs: {
				rect: {
					rx: 8,
					ry: 8,
					width: 100,
					height: 100
				},
				'.body': {
					fill: '#ffffff',
					stroke: '#000000'
				},
				'.inner': {
					transform: 'scale(0.9,0.9) translate(5,5)'
				},
				path: {
					d: 'M 0 0 L 30 0 30 30 0 30 z M 15 4 L 15 26 M 4 15 L 26 15',
					ref: '.inner',
					'ref-x': 0.5,
					'ref-dy': -30,
					'x-alignment': 'middle',
					stroke: '#000000',
					fill: 'transparent'
				},
				image: {
					ref: '.inner',
					'ref-x': 5,
					width: 20,
					height: 20
				}
			},
			activityType: 'task',
			subProcess: null

		}, joint.shapes.basic.TextBlock.prototype.defaults),

		initialize: function () {

			joint.shapes.basic.TextBlock.prototype.initialize.apply(this, arguments);

			this.listenTo(this, 'change:activityType', this.onActivityTypeChange);
			this.listenTo(this, 'change:subProcess', this.onSubProcessChange);

			this.onSubProcessChange(this, this.get('subProcess'));
			this.onActivityTypeChange(this, this.get('activityType'));
		},

		onActivityTypeChange: function (cell, type) {

			switch (type) {

				case 'task':

					cell.attr({
						'.inner': {
							visibility: 'hidden'
						},
						'.outer': {
							'stroke-width': 1,
							'stroke-dasharray': 'none'
						},
						path: {
							ref: '.outer'
						},
						image: {
							ref: '.outer'
						}
					});

					break;

				case 'transaction':

					cell.attr({
						'.inner': {
							visibility: 'visible'
						},
						'.outer': {
							'stroke-width': 1,
							'stroke-dasharray': 'none'
						},
						path: {
							ref: '.inner'
						},
						image: {
							ref: '.inner'
						}
					});

					break;

				case 'event-sub-process':

					cell.attr({
						'.inner': {
							visibility: 'hidden'
						},
						'.outer': {
							'stroke-width': 1,
							'stroke-dasharray': '1,2'
						},
						path: {
							ref: '.outer'
						},
						image: {
							ref: '.outer'
						}
					});

					break;

				case 'call-activity':

					cell.attr({
						'.inner': {
							visibility: 'hidden'
						},
						'.outer': {
							'stroke-width': 5,
							'stroke-dasharray': 'none'
						},
						path: {
							ref: '.outer'
						},
						image: {
							ref: '.outer'
						}
					});

					break;

				default:

					throw 'BPMN: Unknown Activity Type: ' + type;
			}
		},

		onSubProcessChange: function (cell, subProcess) {

			// Although that displaying sub-process icon is implemented in the interface
			// we want also to reposition text and image when sub-process is shown.

			if (subProcess) {

				cell.attr({
					'.fobj div': {
						style: {
							verticalAlign: 'baseline',
							paddingTop: 10
						}
					},
					image: {
						'ref-dy': -25,
						'ref-y': ''
					},
					text: { // IE fallback only
						'ref-y': 25
					}
				});

			} else {

				cell.attr({
					'.fobj div': {
						style: {
							verticalAlign: 'middle',
							paddingTop: 0
						}
					},
					image: {
						'ref-dy': '',
						'ref-y': 5
					},
					text: { // IE fallback only
						'ref-y': .5
					}
				});
			}
		}

	}).extend(joint.shapes.bpmn.IconInterface).extend(joint.shapes.bpmn.SubProcessInterface);

	// Annotation

	joint.shapes.bpmn.AnnotationView = joint.shapes.basic.TextBlockView;
	joint.shapes.bpmn.Annotation = joint.shapes.basic.TextBlock.extend({

		markup: [
			'<g class="rotatable">',
			'<g class="scalable"><rect class="body"/></g>',
			joint.env.test('svgforeignobject') ? '<foreignObject class="fobj"><body xmlns="http://www.w3.org/1999/xhtml"><div class="content"/></body></foreignObject>' : '<text class="content"/>',
			'<path class="stroke"/></g>'
		].join(''),

		defaults: joint.util.deepSupplement({

			size: { width: 100, height: 100 },
			type: 'bpmn.Annotation',
			attrs: {
				rect: {
					width: 100,
					height: 100
				},
				'.body': {
					'fill-opacity': 0.1,
					fill: '#ffffff',
					stroke: 'none'
				},
				'.fobj div': {
					style: {
						textAlign: 'left',
						paddingLeft: 10
					}
				},
				'.stroke': {
					stroke: '#000000',
					fill: 'none',
					'stroke-width': 3
				}

			},
			wingLength: 20

		}, joint.shapes.basic.TextBlock.prototype.defaults),

		initialize: function () {

			joint.shapes.basic.TextBlock.prototype.initialize.apply(this, arguments);

			this.listenTo(this, 'change:size', this.onSizeChange);

			// calculate dasharray for first time
			this.onSizeChange(this, this.get('size'));
		},

		onSizeChange: function (cell, size) {

			cell.attr('.stroke', {
				'd': cell.getStrokePathData(size.width, size.height, cell.get('wingLength'))
			});
		},

		getStrokePathData: function (width, height, wingLength) {

			// wing length can't be greater than the element width
			wingLength = Math.min(wingLength, width);

			return ['M', wingLength, '0 L 0 0 0', height, wingLength, height].join(' ');
		}

	});

	// Gateway

	joint.shapes.bpmn.Gateway = joint.dia.Element.extend({

		markup: '<g class="rotatable"><g class="scalable"><polygon class="body"/><image/></g></g><text class="label"/>',

		defaults: joint.util.deepSupplement({

			type: 'bpmn.Gateway',
			size: { width: 80, height: 80 },
			attrs: {
				'.body': {
					points: '40,0 80,40 40,80 0,40',
					fill: '#ffffff',
					stroke: '#000000'
				},
				'.label': {
					text: '',
					ref: '.body',
					'ref-x': .5,
					'ref-dy': 20,
					'y-alignment': 'middle',
					'x-alignment': 'middle',
					'font-size': 14,
					'font-family': 'Arial, helvetica, sans-serif',
					fill: '#000000'
				},
				image: {
					width: 40, height: 40, 'xlink:href': '', transform: 'translate(20,20)'
				}
			}

		}, joint.dia.Element.prototype.defaults)

	}).extend(joint.shapes.bpmn.IconInterface);

	// Events

	joint.shapes.bpmn.Event = joint.dia.Element.extend({

		markup: '<g class="rotatable"><g class="scalable"><circle class="body outer"/><circle class="body inner"/><image/></g><text class="label"/></g>',

		defaults: joint.util.deepSupplement({

			type: 'bpmn.Event',
			size: { width: 60, height: 60 },
			attrs: {
				'.body': {
					fill: '#ffffff',
					stroke: '#000000'
				},
				'.outer': {
					'stroke-width': 1, r: 30,
					transform: 'translate(30,30)'
				},
				'.inner': {
					'stroke-width': 1, r: 26,
					transform: 'translate(30,30)'
				},
				image: {
					width: 40, height: 40, 'xlink:href': '', transform: 'translate(10,10)'
				},
				'.label': {
					text: '',
					fill: '#000000',
					'font-family': 'Arial', 'font-size': 14,
					ref: '.outer', 'ref-x': .5, 'ref-dy': 20,
					'x-alignment': 'middle', 'y-alignment': 'middle'
				}
			},
			eventType: 'start'

		}, joint.dia.Element.prototype.defaults),

		initialize: function () {

			joint.dia.Element.prototype.initialize.apply(this, arguments);

			this.listenTo(this, 'change:eventType', this.onEventTypeChange);

			this.onEventTypeChange(this, this.get('eventType'));
		},

		onEventTypeChange: function (cell, type) {

			switch (type) {

				case 'start':

					cell.attr({
						'.inner': {
							visibility: 'hidden'
						},
						'.outer': {
							'stroke-width': 1
						}
					});

					break;

				case 'end':

					cell.attr({
						'.inner': {
							visibility: 'hidden'
						},
						'.outer': {
							'stroke-width': 5
						}
					});

					break;

				case 'intermediate':

					cell.attr({
						'.inner': {
							visibility: 'visible'
						},
						'.outer': {
							'stroke-width': 1
						}
					});

					break;

				default:

					throw 'BPMN: Unknown Event Type: ' + type;
			}
		}

	}).extend(joint.shapes.bpmn.IconInterface);

	// Pool & Lanes

	joint.shapes.bpmn.Pool = joint.dia.Element.extend({

		markup: ['<g class="rotatable">',
			'<g class="scalable"><rect class="body"/></g>',
			'<svg overflow="hidden" class="blackbox-wrap"><text class="blackbox-label"/></svg>',
			'<rect class="header"/><text class="label"/>',
			'<g class="lanes"/>',
			'</g>'].join(''),

		laneMarkup: '<g class="lane"><rect class="lane-body"/><rect class="lane-header"/><text class="lane-label"/></g>',

		defaults: joint.util.deepSupplement({

			type: 'bpmn.Pool',
			size: {
				width: 600,
				height: 300
			},
			attrs: {
				'.body': {
					fill: '#ffffff',
					stroke: '#000000',
					width: 500,
					height: 200,
					'pointer-events': 'stroke'
				},
				'.header': {
					fill: '#ffffff',
					stroke: '#000000',
					width: 20,
					ref: '.body',
					'ref-height': 1,
					'pointer-events': 'visiblePainted'
				},
				'.label': {
					fill: '#000000',
					transform: 'rotate(-90)',
					ref: '.header',
					'ref-x': 10,
					'ref-y': .5,
					'font-family': 'Arial',
					'font-size': 14,
					'x-alignment': 'middle',
					'text-anchor': 'middle'
				},
				'.lane-body': {
					fill: '#ffffff',
					stroke: '#000000',
					'pointer-events': 'stroke'
				},
				'.lane-header': {
					fill: '#ffffff',
					stroke: '#000000',
					'pointer-events': 'visiblePainted'
				},
				'.lane-label': {
					fill: '#000000',
					transform: 'rotate(-90)',
					'text-anchor': 'middle',
					'font-family': 'Arial',
					'font-size': 13
				},
				'.blackbox-wrap': {
					ref: '.body',
					'ref-width': 1,
					'ref-height': 1
				},
				'.blackbox-label': {
					text: 'Black Box',
					'text-anchor': 'middle',
					transform: 'translate(0,-7)'
				},
				'.blackbox-label > tspan': {
					dx: '50%',
					dy: '50%'
				}
			}

		}, joint.dia.Element.prototype.defaults)
	});

	joint.shapes.bpmn.PoolView = joint.dia.ElementView.extend({

		options: {
			headerWidth: 20
		},

		initialize: function () {

			this.listenTo(this.model, 'change:lanes', function (cell, lanes) {

				this.renderLanes(lanes);
			});

			joint.dia.ElementView.prototype.initialize.apply(this, arguments);
		},

		update: function () {

			if (this.lanesAttrs === undefined) {
				// This is the first time update. We render the lanes.
				return this.renderLanes(this.model.get('lanes'));
			}

			return joint.dia.ElementView.prototype.update.call(this, this.model,
				// always update everything including the lanes attributes
				joint.util.merge({}, this.model.get('attrs'), this.lanesAttrs || {})
			);
		},

		renderMarkup: function () {

			joint.dia.ElementView.prototype.renderMarkup.apply(this, arguments);

			// a holder for all the lanes
			this.$lanes = this.$('.lanes');

			// An SVG element for the lane
			this.laneMarkup = V(this.model.laneMarkup);
		},

		renderLanes: function (lanes) {

			lanes = lanes || {};

			// index keeps track on how many lanes we created
			this.index = 0;

			var headerWidth = lanes.headerWidth === undefined ? this.options.headerWidth : lanes.headerWidth;
			this.lanesAttrs = {
				'.header': { width: headerWidth },
				'.label': { text: lanes.label || '' }
			};

			this.$lanes.empty();

			if (lanes.sublanes) {

				// recursion start
				this.renderSublanes(lanes.sublanes, headerWidth, 0, 1, 'lanes');
			}

			// We don't want the lanes attributes to be stored on model.
			// That's why we are using renderingOnlyAttrs parameter in ElementView.update
			this.update(this.model, joint.util.merge({}, this.model.get('attrs'), this.lanesAttrs));
		},

		calculateRatios: function (lanes, ratio) {

			var definedRatio = 0;
			var calculated = [];
			var ratios = [];

			for (var i = 0, n = lanes.length; i < n; i++) {
				var lane = lanes[i];
				var laneRatio = lane.ratio;
				if (Number.isFinite(laneRatio)) {
					definedRatio += laneRatio / 10;
					ratios[i] = laneRatio / 10 / ratio;
				} else {
					calculated.push(i);
				}
			}

			var calculatedRatio = Math.max(1 - definedRatio, 0) * ratio / calculated.length;
			for (var j = 0, m = calculated.length; j < m; j++) {
				ratios[calculated[j]] = calculatedRatio;
			}

			return ratios;
		},

		renderSublanes: function (lanes, prevX, prevY, prevRatio, prevPath) {

			var defaultHeaderWidth = this.options.headerWidth;
			var path = prevPath + '/sublanes/';
			var ratios = this.calculateRatios(lanes, prevRatio);

			joint.util.toArray(lanes).reduce(function (ratioSum, lane, index) {

				var className = 'lane' + this.index;
				var bodySelector = '.' + className + ' .lane-body';
				var headerSelector = '.' + className + ' .lane-header';
				var labelSelector = '.' + className + ' .lane-label';

				if (lane.name) {
					// add custom css class if specified
					className += ' ' + lane.name;
				}

				// append a new lane to the pool
				var lanePath = path + index;
				var svgLane = this.laneMarkup.clone()
					.addClass(className)
					.attr({
						'data-lane-path': lanePath,
						'data-lane-index': this.index
					});

				this.$lanes.append(svgLane.node);

				var ratio = ratios[index];
				var headerWidth = lane.headerWidth === undefined ? defaultHeaderWidth : lane.headerWidth;
				var y = prevY + ratioSum;

				this.lanesAttrs[bodySelector] = {
					ref: '.body',
					'ref-height': ratio,
					'ref-width': -prevX,
					'ref-x': prevX,
					'ref-y': y
				};

				this.lanesAttrs[headerSelector] = {
					width: headerWidth,
					ref: '.body',
					'ref-height': ratio,
					'ref-x': prevX,
					'ref-y': y
				};

				this.lanesAttrs[labelSelector] = {
					text: lane.label,
					ref: headerSelector,
					'ref-x': 10,
					'ref-y': .5,
					'x-alignment': 'middle'
				};

				this.index++;

				if (lane.sublanes) {

					// recursively render any child lanes
					this.renderSublanes(lane.sublanes, prevX + headerWidth, y, ratio, lanePath);
				}

				return ratioSum + ratio;

			}.bind(this), 0);
		}
	});

	// Group

	joint.shapes.bpmn.Group = joint.dia.Element.extend({

		markup: '<g class="rotatable"><g class="scalable"><rect class="body"/></g><rect class="label-rect"/><g class="label-group"><svg overflow="hidden" class="label-wrap"><text class="label"/></svg></g></g>',

		defaults: joint.util.deepSupplement({

			type: 'bpmn.Group',
			size: {
				width: 200,
				height: 200
			},
			attrs: {
				'.body': {
					width: 200,
					height: 200,
					stroke: '#000000',
					'stroke-dasharray': '6,6',
					'stroke-width': 2,
					fill: 'transparent',
					rx: 15,
					ry: 15,
					'pointer-events': 'stroke'
				},
				'.label-rect': {
					ref: '.body',
					'ref-width': 0.6,
					'ref-x': 0.4,
					'ref-y': -30,
					height: 25,
					fill: '#ffffff',
					stroke: '#000000'
				},
				'.label-group': {
					ref: '.label-rect',
					'ref-x': 0,
					'ref-y': 0
				},
				'.label-wrap': {
					ref: '.label-rect',
					'ref-width': 1,
					'ref-height': 1
				},
				'.label': {
					text: '',
					x: '50%',
					y: '1.3em',
					'text-anchor': 'middle',
					'font-family': 'Arial',
					'font-size': 14,
					fill: '#000000'
				}
			}

		}, joint.dia.Element.prototype.defaults)
	});

	// Data Object

	joint.shapes.bpmn.DataObject = joint.dia.Element.extend({

		markup: '<g class="rotatable"><g class="scalable"><polygon class="body"/></g><text class="label"/></g>',

		defaults: joint.util.deepSupplement({

			type: 'bpmn.DataObject',
			size: {
				width: 60,
				height: 80
			},
			attrs: {
				'.body': {
					points: '20,0 60,0 60,80 0,80 0,20 20,0 20,20 0,20',
					stroke: '#000000',
					fill: '#ffffff'
				},
				'.label': {
					ref: '.body',
					'ref-x': .5,
					'ref-dy': 5,
					text: '',
					'text-anchor': 'middle'
				}
			}

		}, joint.dia.Element.prototype.defaults)
	});

	joint.shapes.bpmn.Conversation = joint.dia.Element.extend({

		markup: '<g class="rotatable"><g class="scalable"><polygon class="body"/></g><text class="label"/><path class="sub-process"/></g>',

		defaults: joint.util.deepSupplement({

			type: 'bpmn.Conversation',
			size: {
				width: 100,
				height: 100
			},
			attrs: {
				'.body': {
					points: '25,0 75,0 100,50 75,100 25,100 0,50',
					stroke: '#000000',
					fill: '#ffffff'
				},
				'.label': {
					text: '',
					ref: '.body',
					'ref-x': .5,
					'ref-dy': 5,
					'text-anchor': 'middle'
				},
				path: {
					d: 'M 0 0 L 30 0 30 30 0 30 z M 15 4 L 15 26 M 4 15 L 26 15',
					ref: '.body',
					'ref-x': 0.5,
					'ref-dy': -30,
					'x-alignment': 'middle',
					fill: '#ffffff',
					stroke: '#000000',
					'fill-opacity': 0
				}
			},

			conversationType: 'conversation'

		}, joint.dia.Element.prototype.defaults),

		initialize: function () {

			joint.dia.Element.prototype.initialize.apply(this, arguments);

			this.listenTo(this, 'change:conversationType', this.onConversationTypeChange);

			this.onConversationTypeChange(this, this.get('conversationType'));
		},

		onConversationTypeChange: function (cell, type) {

			switch (type) {

				case 'conversation':

					cell.attr('polygon/stroke-width', 1);

					break;

				case 'call-conversation':

					cell.attr('polygon/stroke-width', 4);

					break;

				default:

					throw 'BPMN: Unknown Conversation Type: ' + type;
			}
		}

	}).extend(joint.shapes.bpmn.SubProcessInterface);

	// Choreograpy

	joint.shapes.bpmn.Choreography = joint.shapes.basic.TextBlock.extend({
		/*
			markup: '<g class="rotatable"><g class="scalable"><rect class="body"/></g><g class="participants"/><text class="label"/><path class="sub-process"/></g>',
	*/
		markup: [
			'<g class="rotatable">',
			'<g class="scalable"><rect class="body"/></g>',
			joint.env.test('svgforeignobject') ? '<foreignObject class="fobj"><body xmlns="http://www.w3.org/1999/xhtml"><div class="content"/></body></foreignObject>' : '<text class="content"/>',
			'<text class="label"/><path class="sub-process"/><g class="participants"/>',
			'</g>'
		].join(''),

		participantMarkup: '<g class="participant"><rect class="participant-rect"/><text class="participant-label"/></g>',

		defaults: joint.util.deepSupplement({

			type: 'bpmn.Choreography',
			size: {
				width: 60,
				height: 80
			},
			attrs: {
				// HACK (TODO!): as we don't have indexes on attributes yet (to determine the order
				// of applying attributes) we have to reintroduce the rect attribute again
				// so it changes the "order" how the attributes are processed.
				// It's necessary to apply all `rect` attributes before we apply '.body' attributes,
				// otherwise our stroke and fill will be overwritten.
				rect: {},
				'.body': {
					width: 60,
					height: 80,
					stroke: '#000000',
					fill: '#ffffff'
				},
				'.label': {
					ref: '.body',
					'ref-x': .5,
					'ref-dy': 5,
					text: '',
					'text-anchor': 'middle'
				},
				'.participant-rect': {
					stroke: '#000000',
					fill: '#aaaaaa',
					ref: '.body',
					'ref-width': 1
				},
				'.participant-label': {
					'text-anchor': 'middle',
					ref: '.participant_0 .participant-rect',
					'ref-x': .5,
					'ref-y': .5,
					'y-alignment': 'middle'
				},
				'.sub-process': {
					d: 'M 0 0 L 30 0 30 30 0 30 z M 15 4 L 15 26 M 4 15 L 26 15',
					ref: '.body',
					'ref-x': 0.5,
					'ref-dy': -30,
					'x-alignment': 'middle',
					fill: 'transparent',
					stroke: '#000000'
				}
			},

			participants: [],
			initiatingParticipant: 0 // index (number) or participant name (string)

		}, joint.shapes.basic.TextBlock.prototype.defaults)

	}).extend(joint.shapes.bpmn.SubProcessInterface);

	joint.shapes.bpmn.ChoreographyView = joint.shapes.basic.TextBlockView.extend({

		options: {
			participantHeight: 20
		},

		initialize: function () {

			this.listenTo(this.model, 'change:participants', function (cell, participants) {
				this.renderParticipants(participants);
			});

			this.listenTo(this.model, 'change:initiatingParticipant', this.layoutAndUpdate);

			joint.shapes.basic.TextBlockView.prototype.initialize.apply(this, arguments);

			if (!joint.env.test('svgforeignobject')) {
				// Attach our own handler for content change.
				// The new one will take the participant attributes into account.
				this.stopListening(this.model, 'change:content').listenTo(this.model, 'change:content', function (cell) {
					this.updateContent(cell, this.participantsAttrs);
				});
			}
		},

		update: function () {

			if (this.participantsAttrs === undefined) {
				// This is the first time update. We render the participants.
				return this.renderParticipants(this.model.get('participants'));
			}

			this.layoutAndUpdate();

			return this;
		},

		render: function () {
			// Reset participants cache when `dirty: true` flag used in `attrs()`.
			this.participantsAttrs = undefined;
			joint.dia.ElementView.prototype.render.apply(this, arguments);
		},

		renderMarkup: function () {

			joint.dia.ElementView.prototype.renderMarkup.apply(this, arguments);

			// a holder for all the lanes
			this.$participants = this.$('.participants');

			// An SVG element for the lane
			this.participantMarkup = V(this.model.participantMarkup);
		},

		renderParticipants: function (participants) {

			this.$participants.empty();
			this.participantsAttrs = {};

			joint.util.toArray(participants).forEach(function (participant, index) {

				var className = 'participant_' + index;
				var selector = '.' + className;

				this.participantsAttrs[selector + ' .participant-rect'] = {
					height: this.options.participantHeight
				};

				this.participantsAttrs[selector + ' .participant-label'] = {
					text: participant
				};

				this.$participants.append(this.participantMarkup.clone().addClass(className).node);

			}, this);

			this.layoutAndUpdate();
		},

		layoutAndUpdate: function () {

			var participants = this.model.get('participants') || [];

			var count = participants.length;

			var pHeight = this.options.participantHeight;
			var eHeight = this.model.get('size').height;
			var bHeight = Math.max(0, eHeight - (pHeight * count));

			var offsetY = 0;

			var initiator = this.model.get('initiatingParticipant');

			// initiator index
			var i = Math.max(joint.util.isNumber(initiator) ? Math.abs(initiator) : participants.indexOf(initiator), 0);

			// body position index
			var b = Math.min(i, count - 2);

			joint.util.toArray(participants).forEach(function (participant, index) {

				var selector = '.participant_' + index;

				this.participantsAttrs[selector] = {
					transform: 'translate(0,' + offsetY + ')'
				};

				this.participantsAttrs[selector + ' .participant-rect'].fill = (i == index)
					? this.model.attr('.body/fill')
					: this.model.attr('.participant-rect/fill');

				this.participantsAttrs[selector + ' .participant-rect'].stroke = (i == index)
					? this.model.attr('.body/stroke')
					: this.model.attr('.participant-rect/stroke');

				offsetY += pHeight + (b == index ? bHeight : 0);

			}, this);

			// set sub-process icon position
			var sp = count < 2 ? 0 : b - count + 1;

			this.participantsAttrs['.sub-process'] = {
				'ref-dy': Math.max(-eHeight, sp * pHeight - 30)
			};

			// Change text content position in the middle of the participant body
			var c = count < 2 ? 0 : b + 1;

			this.participantsAttrs['.fobj div'] = {
				style: {
					height: bHeight,
					paddingTop: pHeight * c
				}
			};
			// Same as above just IE fallback
			this.participantsAttrs['.content'] = {
				'ref-y': pHeight * c + bHeight / 2
			};

			// We don't want the participants attributes to be stored on model.
			// That's why we are using renderingOnlyAttrs parameter in ElementView.update
			var attrs = joint.util.merge({}, this.model.get('attrs'), this.participantsAttrs || {});

			// Backwards compatibility
			// The text is set by `.content/html` now (leaving this in the attrs would result
			// in not being able to change content).
			joint.util.unsetByPath(attrs, 'div/html');

			joint.shapes.basic.TextBlockView.prototype.update.call(this, this.model, attrs);
		}

	});

	// Message

	joint.shapes.bpmn.Message = joint.dia.Element.extend({

		markup: '<g class="rotatable"><g class="scalable"><polygon class="body"/></g><text class="label"/></g>',

		defaults: joint.util.deepSupplement({

			type: 'bpmn.Message',
			size: {
				width: 60,
				height: 40
			},
			attrs: {
				'.body': {
					points: '0,0 60,0 60,40 0,40 0,0 60,0 30,20 0,0',
					stroke: '#000000',
					fill: '#ffffff'
				},
				'.label': {
					ref: '.body',
					'ref-x': .5,
					'ref-dy': 5,
					text: '',
					'text-anchor': 'middle'
				}
			}

		}, joint.dia.Element.prototype.defaults)
	});

	// Sequence Flows

	joint.shapes.bpmn.Flow = joint.dia.Link.extend({

		defaults: {

			type: 'bpmn.Flow',

			attrs: {

				'.marker-source': {
					d: 'M 0 0'
				},
				'.marker-target': {
					d: 'M 10 0 L 0 5 L 10 10 z',
					fill: '#000000'
				},
				'.connection': {
					'stroke-dasharray': ' ',
					'stroke-width': 1
				},
				'.connection-wrap': {
					style: '',
					onMouseOver: '',
					onMouseOut: ''
				}
			},

			flowType: 'normal'
		},

		initialize: function () {

			joint.dia.Link.prototype.initialize.apply(this, arguments);

			this.listenTo(this, 'change:flowType', this.onFlowTypeChange);

			this.onFlowTypeChange(this, this.get('flowType'));
		},

		onFlowTypeChange: function (cell, type) {

			var attrs;

			switch (type) {

				case 'default':

					attrs = {
						'.marker-source': {
							d: 'M 0 5 L 20 5 M 20 0 L 10 10',
							fill: 'none'
						}
					};

					break;

				case 'conditional':

					attrs = {
						'.marker-source': {
							d: 'M 20 8 L 10 0 L 0 8 L 10 16 z',
							fill: '#FFF'
						}
					};

					break;

				case 'normal':

					attrs = {};

					break;

				case 'message':

					attrs = {
						'.marker-target': {
							fill: '#FFF'
						},
						'.connection': {
							'stroke-dasharray': '4,4'
						}
					};

					break;

				case 'association':

					attrs = {
						'.marker-target': {
							d: 'M 0 0'
						},
						'.connection': {
							'stroke-dasharray': '4,4'
						}
					};

					break;

				case 'conversation':

					// The only way how to achieved 'spaghetti insulation effect' on links is to
					// have the .connection-wrap covering the inner part of the .connection.
					// The outer part of the .connection then looks like two parallel lines.
					attrs = {
						'.marker-target': {
							d: 'M 0 0'
						},
						'.connection': {
							'stroke-width': '7px'
						},
						'.connection-wrap': {
							// As the css takes priority over the svg attributes, that's only way
							// how to overwrite default jointjs styling.
							style: 'stroke: #fff; stroke-width: 5px; opacity: 1;',
							onMouseOver: "var s=this.style;s.stroke='#000';s.strokeWidth=15;s.opacity=.4",
							onMouseOut: "var s=this.style;s.stroke='#fff';s.strokeWidth=5;s.opacity=1"
						}
					};

					break;

				default:

					throw 'BPMN: Unknown Flow Type: ' + type;
			}

			cell.attr(joint.util.merge({}, this.defaults.attrs, attrs));
		}
	});

	// Command manager implements undo/redo functionality.

	joint.dia.CommandManager = Backbone.Model.extend({

		defaults: {
			cmdBeforeAdd: null,
			cmdNameRegex: /^(?:add|remove|change:\w+)$/,
			// List of options names that will passed when a command is applied (redone).
			// e.g ['propertyPath', 'propertyValue']
			// See `dia.Cell.prototype.prop()` for more about the `propertyPath` option.
			applyOptionsList: ['propertyPath'],
			// List of options names that will passed when a command is reverted (undone).
			revertOptionsList: ['propertyPath']
		},

		// length of prefix 'change:' in the event name
		PREFIX_LENGTH: 7,

		initialize: function (options) {

			joint.util.bindAll(this, 'initBatchCommand', 'storeBatchCommand');

			this.graph = options.graph;

			this.reset();
			this.listen();
		},

		listen: function () {

			this.listenTo(this.graph, 'all', this.addCommand, this);

			this.listenTo(this.graph, 'batch:start', this.initBatchCommand, this);
			this.listenTo(this.graph, 'batch:stop', this.storeBatchCommand, this);
		},

		createCommand: function (options) {

			var cmd = {
				action: undefined,
				data: { id: undefined, type: undefined, previous: {}, next: {} },
				batch: options && options.batch
			};

			return cmd;
		},

		push: function (cmd) {

			this.redoStack = [];

			if (!cmd.batch) {
				this.undoStack.push(cmd);
				this.trigger('add', cmd);
			} else {
				this.lastCmdIndex = Math.max(this.lastCmdIndex, 0);
				// Commands possible thrown away. Someone might be interested.
				this.trigger('batch', cmd);
			}
		},

		addCommand: function (cmdName, cell, graph, options) {

			// Do not account for changes in `dry` run.
			if (options && options.dry) {
				return;
			}

			if (!this.get('cmdNameRegex').test(cmdName)) {
				return;
			}

			if (typeof this.get('cmdBeforeAdd') == 'function' && !this.get('cmdBeforeAdd').apply(this, arguments)) {
				return;
			}

			var command = undefined;
			var isGraphCommand = (cell instanceof joint.dia.Graph);

			if (this.batchCommand) {
				// set command as the one used last.
				// in most cases we are working with same object, doing same action
				// etc. translate an object piece by piece
				command = this.batchCommand[Math.max(this.lastCmdIndex, 0)];

				// Check if we are start working with new object or performing different action with it.
				// Note, that command is uninitialized when lastCmdIndex equals -1. (see 'initBatchCommand()')
				// in that case we are done, command we were looking for is already set
				var isDifferentModel = ((isGraphCommand && !command.graphChange) || command.data.id !== cell.id);
				var isDifferentAction = (command.action !== cmdName);
				if (this.lastCmdIndex >= 0 && (isDifferentModel || isDifferentAction)) {

					// trying to find command first, which was performing same action with the object
					// as we are doing with the model now
					var similarCommandIndex = this.batchCommand.findIndex(function (cmd, index) {
						return ((isGraphCommand && cmd.graphChange) || cmd.data.id === cell.id) && cmd.action === cmdName;
					});

					if (similarCommandIndex < 0 || (cmdName === 'add' || cmdName === 'remove')) {
						// command with such an id and action was not found. Let's create new one.
						// Adding and Removing is always preserve as new command. e.g.
						// (add1, remove1, add2) can not be changed to (remove1, add2) neither (add2, remove1).
						command = this.createCommand({ batch: true });
					} else {
						// move the command to the end of the batch.
						command = this.batchCommand[similarCommandIndex];
						this.batchCommand.splice(similarCommandIndex, 1);
					}

					this.lastCmdIndex = this.batchCommand.push(command) - 1;
				}

			} else {

				// single command
				command = this.createCommand({ batch: false });
			}

			if (cmdName === 'add' || cmdName === 'remove') {

				command.action = cmdName;
				command.data.id = cell.id;
				command.data.type = cell.attributes.type;
				command.data.attributes = joint.util.merge({}, cell.toJSON());
				command.options = options || {};

				this.push(command);
				return;
			}

			// `changedAttribute` holds the attribute name corresponding
			// to the change event triggered on the model.
			var changedAttribute = cmdName.substr(this.PREFIX_LENGTH);

			if (!command.batch || !command.action) {
				// Do this only once. Set previous box and action (also serves as a flag so that
				// we don't repeat this branche).
				command.action = cmdName;
				command.data.previous[changedAttribute] = joint.util.clone(cell.previous(changedAttribute));
				command.options = options || {};
				if (isGraphCommand) {
					command.graphChange = true;
				} else {
					command.data.id = cell.id;
					command.data.type = cell.attributes.type;
				}
			}

			command.data.next[changedAttribute] = joint.util.clone(cell.get(changedAttribute));

			this.push(command);
		},

		// Batch commands are those that merge certain commands applied in a row (1) and those that
		// hold multiple commands where one action consists of more than one command (2)
		// (1) This is useful for e.g. when the user is dragging an object in the paper which would
		// normally lead to 1px translation commands. Applying undo() on such commands separately is
		// most likely undesirable.
		// (2) e.g When you are removing an element, you don't want all links connected to that element, which
		// are also being removed to be part of different command

		initBatchCommand: function () {

			if (!this.batchCommand) {

				this.batchCommand = [this.createCommand({ batch: true })];
				this.lastCmdIndex = -1;

				// batch level counts how many times has been initBatchCommand executed.
				// It is useful when we doing an operation recursively.
				this.batchLevel = 0;

			} else {

				// batch command is already active
				this.batchLevel++;
			}
		},

		storeBatchCommand: function () {

			// In order to store batch command it is necesary to run storeBatchCommand as many times as
			// initBatchCommand was executed
			if (this.batchCommand && this.batchLevel <= 0) {

				var batchCommand = this.filterBatchCommand(this.batchCommand);
				// checking if there is any valid command in batch
				// for example: calling `initBatchCommand` immediately followed by `storeBatchCommand`
				if (batchCommand.length > 0) {

					this.redoStack = [];

					this.undoStack.push(batchCommand);
					this.trigger('add', batchCommand);
				}

				this.batchCommand = null;
				this.lastCmdIndex = null;
				this.batchLevel = null;

			} else if (this.batchCommand && this.batchLevel > 0) {

				// low down batch command level, but not store it yet
				this.batchLevel--;
			}
		},

		// Takes batch commands and returns only such commands, which when applied in order change the graph.
		filterBatchCommand: function (batchCommand) {

			var commands = batchCommand.slice();
			var filteredCommands = [];

			while (commands.length > 0) {

				var command = commands.shift();
				var id = command.data.id;

				if (command.action == null || (id == null && !command.graphChange)) {
					continue;
				}

				if (command.action === 'add') {

					var removeIndex = commands.findIndex(function (item) {
						return item.action === 'remove' && item.data && item.data.id === id;
					});
					if (removeIndex >= 0) {
						// `add` command followed by `remove` command
						// Lets remove the `remove` command and all other commands related to
						// this cell. Note that no commands can exist after the `remove` command,
						// but some could inbetween `add` and `remove`.
						// e.g.  . ADD . CHNG . REM . => . . . .
						commands = commands.filter(function (cmd, index) {
							return index > removeIndex || cmd.data.id !== id;
						});
						continue;
					}

				} else if (command.action === 'remove') {

					var addIndex = commands.findIndex(function (item) {
						return item.action === 'add' && item.data && item.data.id == id;
					});
					if (addIndex >= 0) {
						// `remove` command followed by `add` command
						// Lets remove only the `add` command. Note that another commands could exist
						// after the `add` command, but not inbetween `remove` and `add`.
						// e.g. . CHNG1 . REM . ADD . CHNG2 . ==> . CHNG1 . . . CHNG2 .
						commands.splice(addIndex, 1);
						continue;
					}

				} else if (command.action.indexOf('change') === 0) {

					if (joint.util.isEqual(command.data.previous, command.data.next)) {
						// This is a command which when applied doesn't actually change anything.
						continue;
					}
				}

				// This is a valid command.
				filteredCommands.push(command);
			}

			return filteredCommands;
		},

		revertCommand: function (command, opt) {

			this.stopListening();

			var batchCommand;
			if (Array.isArray(command)) {
				batchCommand = this.constructor.sortBatchCommands(command);
			} else {
				batchCommand = [command];
			}

			var graph = this.graph;
			for (var i = batchCommand.length - 1; i >= 0; i--) {

				var cmd = batchCommand[i];
				var model = cmd.graphChange ? graph : graph.getCell(cmd.data.id);
				var cmdOpt = joint.util.assign({
					commandManager: this.id || this.cid
				}, opt, joint.util.pick(cmd.options, this.get('revertOptionsList')));

				switch (cmd.action) {
					case 'add':
						model.remove(cmdOpt);
						break;

					case 'remove':
						graph.addCell(cmd.data.attributes, cmdOpt);
						break;

					default:
						var attribute = cmd.action.substr(this.PREFIX_LENGTH);
						model.set(attribute, cmd.data.previous[attribute], cmdOpt);
						break;
				}
			}

			this.listen();
		},

		applyCommand: function (command, opt) {

			this.stopListening();

			var batchCommand;
			if (Array.isArray(command)) {
				batchCommand = this.constructor.sortBatchCommands(command);
			} else {
				batchCommand = [command];
			}

			var graph = this.graph;
			for (var i = 0; i < batchCommand.length; i++) {

				var cmd = batchCommand[i];
				var model = cmd.graphChange ? graph : graph.getCell(cmd.data.id);
				var cmdOpt = joint.util.assign({
					commandManager: this.id || this.cid
				}, opt, joint.util.pick(cmd.options, this.get('applyOptionsList')));

				switch (cmd.action) {

					case 'add':
						graph.addCell(cmd.data.attributes, cmdOpt);
						break;

					case 'remove':
						model.remove(cmdOpt);
						break;

					default:
						var attribute = cmd.action.substr(this.PREFIX_LENGTH);
						model.set(attribute, cmd.data.next[attribute], cmdOpt);
						break;
				}
			}

			this.listen();
		},

		undo: function (opt) {

			var command = this.undoStack.pop();

			if (command) {

				this.revertCommand(command, opt);
				this.redoStack.push(command);
			}
		},

		redo: function (opt) {

			var command = this.redoStack.pop();

			if (command) {

				this.applyCommand(command, opt);
				this.undoStack.push(command);
			}
		},

		cancel: function (opt) {

			if (this.hasUndo()) {

				this.revertCommand(this.undoStack.pop(), opt);
				this.redoStack = [];
			}
		},

		reset: function () {

			this.undoStack = [];
			this.redoStack = [];
		},

		hasUndo: function () {

			return this.undoStack.length > 0;
		},

		hasRedo: function () {

			return this.redoStack.length > 0;
		}
	}, {

			sortBatchCommands: function (commands) {

				// Note that `filterBatchCommand` method makes sure there is no `add` and `remove`
				// command in the same batch for the same element.

				// Here we swap only commands related to the same element, where `change` command
				// is before an `add` command (similary for the `remove` event).

				var commandsSorted = [];
				for (var index = 0; index < commands.length; index++) {

					var command = commands[index];
					var insertPosition = null;

					if (command.action === 'add') {
						var id = command.data.id;

						for (var i = 0; i < index; i++) {

							if (commands[i].data.id === id) {
								// add command should appear before the first change command
								insertPosition = i - 1;
								break;
							}
						}
					}

					if (insertPosition !== null) {
						commandsSorted.splice(insertPosition, 0, command);

					} else {
						commandsSorted.push(command);
					}
				}

				return commandsSorted;
			}

		});

	joint.dia.Validator = Backbone.Model.extend({

		initialize: function (options) {

			this._map = {};
			this._commandManager = options.commandManager;

			this.listenTo(this._commandManager, 'add', this._onCommand);
		},

		defaults: {

			// To cancel (= undo + delete from redo stack) a command if is not valid.
			cancelInvalid: true
		},

		// iterates throught each command, stops on first invalid command.
		_onCommand: function (command) {

			if (Array.isArray(command)) {
				return command.find(function (singleCmd) { return !this._validateCommand(singleCmd); }, this);
			}

			return this._validateCommand(command);
		},

		// check whether the command is not against any rule
		_validateCommand: function (command) {

			// Backbone.model set() and Backbone.collection add() allow to pass an option parameter.
			// That is also kept within the command. It skips validation if requested.
			if (command.options && command.options.validation === false) return true;

			var handoverErr;

			joint.util.toArray(this._map[command.action]).forEach(function (route) {

				var i = 0;

				function callbacks(err) {

					var fn = route[i++];

					try {
						if (fn) {
							fn(err, command, callbacks);
						} else {
							handoverErr = err;
							return;
						}
					} catch (err) {
						callbacks(err);
					}
				}

				callbacks(handoverErr);
			});

			if (handoverErr) {

				if (this.get('cancelInvalid')) this._commandManager.cancel();
				this.trigger('invalid', handoverErr);
				return false;
			}

			//command is valid
			return true;
		},


		validate: function (actions) {

			var callbacks = Array.prototype.slice.call(arguments, 1);

			callbacks.forEach(function (callback) {
				if (joint.util.isFunction(callback)) return;
				throw new Error(actions + ' requires callback functions.');
			});

			actions.split(' ').forEach(function (action) {
				(this._map[action] = this._map[action] || []).push(callbacks);
			}, this);

			return this;
		}

	});

	// Various utility functions for graph construction.
	// =================================================

	// This plugin extends the `joint.dia.Graph` object with additional methods.


	// Construct a tree from JSON structure of the form:
	// `{ name: 'my label', children: [ { name: 'my label 2', children: [...] }, ...] }`
	// `parent` is the tree object, i.e. the top level node.
	// `opt.children` is the property specifying the children array. `'children'` is the default.
	// If `opt.children` is a function, it will called with the current node as an argument and should return an array of its child nodes.
	// `opt.makeElement` is a function that is passed the current tree node and returns a JointJS element for it.
	// `opt.makeLink` is a function that is passed a parent and child nodes and returns a JointJS link for the edge.
	joint.dia.Graph.prototype.constructTree = function (parent, opt, parentElement, collector) {

		collector = collector || [];

		var children = joint.util.isFunction(opt.children) ? opt.children(parent) : parent[opt.children || 'children'];

		if (!parentElement) {

			parentElement = opt.makeElement(parent);
			collector.push(parentElement);
		}

		joint.util.toArray(children).forEach(function (child) {

			var childElement = opt.makeElement(child);
			var link = opt.makeLink(parentElement, childElement);
			collector.push(childElement, link);

			this.constructTree(child, opt, childElement, collector);

		}, this);

		return collector;
	};

	// Returns an array of IDs of nodes on the shortest path between `source` and `target`.
	// `source` and `target` can either be elements or IDs of elemements.
	// `opt.weight` is an optional function returning a distance between two nodes.
	// If `opt.directed` is `true`, the algorithm will take link direction into account.
	joint.dia.Graph.prototype.shortestPath = function (source, target, opt) {

		opt = opt || {};

		var adjacencyList = {};
		this.getLinks().forEach(function (link) {

			var sourceId = link.get('source').id;
			var targetId = link.get('target').id;
			if (!adjacencyList[sourceId]) {
				adjacencyList[sourceId] = [];
			}
			if (!adjacencyList[targetId]) {
				adjacencyList[targetId] = [];
			}

			adjacencyList[sourceId].push(targetId);
			if (!opt.directed) {
				adjacencyList[targetId].push(sourceId);
			}
		});

		var previous = joint.alg.Dijkstra(adjacencyList, source.id || source, opt.weight);

		var path = [];
		var u = target.id || target;
		if (previous[u]) path.push(u);
		while ((u = previous[u])) {
			path.unshift(u);
		}
		return path;
	};

	// PaperScroller
	// =============


	// `PaperScroller` wraps the paper root element and implements panning and centering of the paper.

	// Example usage:

	//      var paperScroller = new joint.ui.PaperScroller;
	//      var paper = new joint.dia.Paper({ el: paperScroller.el });
	//      paperScroller.options.paper = paper;
	//      $appElement.append(paperScroller.render().el);

	//      paperScroller.center();
	//      paper.on('blank:pointerdown', paperScroller.startPanning);

	joint.ui.PaperScroller = joint.mvc.View.extend({

		className: 'paper-scroller',

		options: {
			paper: undefined,
			// Default padding makes sure the paper inside the paperScroller is always panable
			// all the way left, right, bottom and top.
			// It also makes sure that there is always at least a fragment of the paper visible.
			// Example usage:
			//   padding: 10
			//   padding: { left: 20, right: 20 }
			//   padding: function() { return 10; }
			padding: function () {

				var minVisibleSize = Math.max(this.options.minVisiblePaperSize, 1) || 1;
				var padding = {};

				padding.left = padding.right = Math.max(this.el.clientWidth - minVisibleSize, 0);
				padding.top = padding.bottom = Math.max(this.el.clientHeight - minVisibleSize, 0);

				return padding;
			},
			// Minimal size (px) of the paper that has to stay visible.
			// Used by the default padding method only.
			minVisiblePaperSize: 50,
			autoResizePaper: false,
			baseWidth: undefined,
			baseHeight: undefined,
			contentOptions: undefined,
			cursor: 'default'
		},

		// Internal padding storage
		_padding: { left: 0, top: 0 },

		init: function () {

			joint.util.bindAll(this, 'startPanning', 'stopPanning', 'pan', 'onBackgroundEvent');

			var paper = this.options.paper;

			// keep scale values for a quicker access
			var initScale = paper.scale();
			this._sx = initScale.sx;
			this._sy = initScale.sy;

			// if the base paper dimension is not specified use the paper size.
			this.options.baseWidth === undefined && (this.options.baseWidth = paper.options.width);
			this.options.baseHeight === undefined && (this.options.baseHeight = paper.options.height);

			this.$background = $('<div/>').addClass('paper-scroller-background')
				.css({ width: paper.options.width, height: paper.options.height })
				.append(paper.el)
				.appendTo(this.el);

			this.listenTo(paper, 'scale', this.onScale)
				.listenTo(paper, 'resize', this.onResize)
				.listenTo(paper, 'beforeprint beforeexport', this.storeScrollPosition)
				.listenTo(paper, 'afterprint afterexport', this.restoreScrollPosition);

			// automatically resize the paper
			if (this.options.autoResizePaper) {
				this.listenTo(paper.model, 'change add remove reset', this.adjustPaper);
				if (paper.options.async) {
					this.listenTo(paper, 'render:done', this.adjustPaper);
				}
			}

			this.delegateBackgroundEvents();
			this.setCursor(this.options.cursor);
		},

		lock: function () {
			this.$el.css('overflow', 'hidden');
			return this;
		},

		unlock: function () {
			this.$el.css('overflow', 'scroll');
			return this;
		},

		setCursor: function (cursor) {

			switch (cursor) {
				case 'grab':
					// Make a special case for the cursor above
					// due to bad support across browsers.
					// It's handled in `layout.css`.
					this.$el.css('cursor', '');
					break;
				default:
					this.$el.css('cursor', cursor);
					break;
			}

			this.$el.attr('data-cursor', cursor);
			this.options.cursor = cursor;

			return this;
		},

		// Set up listeners for passing events from outside the paper to the paper
		delegateBackgroundEvents: function (events) {

			events || (events = joint.util.result(this.options.paper, 'events'));

			var normalizedEvents = this.paperEvents = Object.keys(events || {}).reduce(normalizeEvents.bind(this), {});

			Object.keys(normalizedEvents).forEach(delegateBackgroundEvent, this);

			function normalizeEvents(res, event) {
				var listener = events[event];
				// skip events with selectors
				if (event.indexOf(' ') === -1) {
					res[event] = joint.util.isFunction(listener) ? listener : this.options.paper[listener];
				}
				return res;
			}

			function delegateBackgroundEvent(event) {
				// Sending event data with `guarded=false` to prevent events from
				// being guarded by the paper.
				this.delegate(event, { guarded: false }, this.onBackgroundEvent);
			}

			return this;
		},

		// Pass the event outside the paper to the paper.
		onBackgroundEvent: function (evt) {

			if (this.$background.is(evt.target)) {
				var listener = this.paperEvents[evt.type];
				if (joint.util.isFunction(listener)) {
					listener.apply(this.options.paper, arguments);
				}
			}
		},

		onResize: function () {

			// Move scroller so the user sees the same area as before the resizing.
			if (this._center) this.center(this._center.x, this._center.y);
		},

		onScale: function (sx, sy, ox, oy) {

			this.adjustScale(sx, sy);

			// update scale values for a quicker access
			this._sx = sx;
			this._sy = sy;

			// Move scroller to scale origin.
			if (ox || oy) this.center(ox, oy);
		},

		storeScrollPosition: function () {

			this._scrollLeftBeforePrint = this.el.scrollLeft;
			this._scrollTopBeforePrint = this.el.scrollTop;
		},

		restoreScrollPosition: function () {

			// Set the paper element to the scroll position before printing.
			this.el.scrollLeft = this._scrollLeftBeforePrint;
			this.el.scrollTop = this._scrollTopBeforePrint;

			// Clean-up.
			this._scrollLeftBeforePrint = null;
			this._scrollTopBeforePrint = null;
		},

		beforePaperManipulation: function () {

			if (joint.env.test('msie') || joint.env.test('msedge')) {
				// IE is trying to show every frame while we manipulate the paper.
				// That makes the viewport kind of jumping while zooming for example.
				// Make the paperScroller invisible fixes this.
				// MSEDGE seems to have a problem with text positions after the animation.
				this.$el.css('visibility', 'hidden');
			}
		},

		afterPaperManipulation: function () {

			if (joint.env.test('msie') || joint.env.test('msedge')) {
				this.$el.css('visibility', 'visible');
			}
		},

		clientToLocalPoint: function (x, y) {

			var ctm = this.options.paper.matrix();

			x += this.el.scrollLeft - this._padding.left - ctm.e;
			x /= ctm.a;


			y += this.el.scrollTop - this._padding.top - ctm.f;
			y /= ctm.d;

			return g.point(x, y);
		},

		localToBackgroundPoint: function (x, y) {

			var localPoint = g.Point(x, y);
			var ctm = this.options.paper.matrix();
			var padding = this._padding;
			return V.transformPoint(localPoint, ctm).offset(padding.left, padding.top);
		},

		adjustPaper: function () {

			// store the current mid point of visible paper area, so we can center the paper
			// to the same point after the resize
			this._center = this.clientToLocalPoint(this.el.clientWidth / 2, this.el.clientHeight / 2);

			var options = joint.util.assign({
				gridWidth: this.options.baseWidth,
				gridHeight: this.options.baseHeight,
				allowNewOrigin: 'negative'
			}, this.options.contentOptions);

			this.options.paper.fitToContent(this.transformContentOptions(options));

			return this;
		},

		adjustScale: function (sx, sy) {

			var paperOptions = this.options.paper.options;
			var fx = sx / this._sx;
			var fy = sy / this._sy;

			this.options.paper.setOrigin(paperOptions.origin.x * fx, paperOptions.origin.y * fy);
			this.options.paper.setDimensions(paperOptions.width * fx, paperOptions.height * fy);
		},

		// Recalculates content options taking the current scale into account.
		transformContentOptions: function (opt) {

			var sx = this._sx;
			var sy = this._sy;

			if (opt.gridWidth) opt.gridWidth *= sx;
			if (opt.gridHeight) opt.gridHeight *= sy;
			if (opt.minWidth) opt.minWidth *= sx;
			if (opt.minHeight) opt.minHeight *= sy;

			if (joint.util.isObject(opt.padding)) {
				opt.padding = {
					left: (opt.padding.left || 0) * sx,
					right: (opt.padding.right || 0) * sx,
					top: (opt.padding.top || 0) * sy,
					bottom: (opt.padding.bottom || 0) * sy
				};
			} else if (joint.util.isNumber(opt.padding)) {
				opt.padding = opt.padding * sx;
			}

			return opt;
		},

		// Adjust the paper position so the point [x,y] is moved to the center of paperScroller element.
		// If no point given [x,y] equals to center of the paper element.
		center: function (x, y, opts) {

			var ctm = this.options.paper.matrix();

			// the paper rectangle
			// x1,y1 ---------
			// |             |
			// ----------- x2,y2
			var x1 = -ctm.e;
			var y1 = -ctm.f;
			var x2 = x1 + this.options.paper.options.width;
			var y2 = y1 + this.options.paper.options.height;

			if (x === undefined || y === undefined) {
				// find center of the paper rect
				x = (x1 + x2) / 2;
				y = (y1 + y2) / 2;
			} else {
				// local coordinates to viewport coordinates
				x *= ctm.a;
				y *= ctm.d;
			}

			var p = this.getPadding();
			var cx = this.el.clientWidth / 2;
			var cy = this.el.clientHeight / 2;

			// calculate paddings
			var left = cx - p.left - x + x1;
			var right = cx - p.right + x - x2;
			var top = cy - p.top - y + y1;
			var bottom = cy - p.bottom + y - y2;

			this.addPadding(
				Math.max(left, 0),
				Math.max(right, 0),
				Math.max(top, 0),
				Math.max(bottom, 0)
			);

			this.scroll(x, y, opts !== undefined ? opts : (x || null));

			return this;
		},

		centerContent: function (opts) {

			var vbox = V(this.options.paper.viewport).bbox(true, this.options.paper.svg);
			this.center(vbox.x + vbox.width / 2, vbox.y + vbox.height / 2, opts);

			return this;
		},

		centerElement: function (element) {

			this.checkElement(element, 'centerElement');
			var center = element.getBBox().center();
			return this.center(center.x, center.y);
		},

		// less aggresive then center as it only changes position of scrollbars
		// without adding paddings - it wont actually move view onto the position
		// if there isn't enough room for it!
		// optionally you can specify `animation` key in option argument
		// to make the scroll animated; object is passed into $.animate
		scroll: function (x, y, opt) {

			var ctm = this.options.paper.matrix();

			var change = {};

			if (joint.util.isNumber(x)) {
				var cx = this.el.clientWidth / 2;
				change['scrollLeft'] = x - cx + ctm.e + (this._padding.left || 0);
			}

			if (joint.util.isNumber(y)) {
				var cy = this.el.clientHeight / 2;
				change['scrollTop'] = y - cy + ctm.f + (this._padding.top || 0);
			}

			if (opt && opt.animation) {
				this.$el.animate(change, opt.animation);
			} else {
				this.$el.prop(change);
			}
		},

		// simple wrapper around scroll method that finds center of specified
		// element and scrolls to it
		// it's possible to pass in opts object that is used in scroll() method (eg. animation)
		scrollToElement: function (element, opts) {

			this.checkElement(element, 'scrollToElement');

			var center = element.getBBox().center();
			var sx = this._sx;
			var sy = this._sy;

			center.x *= sx;
			center.y *= sy;

			return this.scroll(center.x, center.y, opts);
		},

		// Position the paper inside the paper wrapper and resize the wrapper.
		addPadding: function (left, right, top, bottom) {

			var base = this.getPadding();

			var padding = this._padding = {
				left: Math.round(base.left + (left || 0)),
				top: Math.round(base.top + (top || 0)),
				bottom: Math.round(base.bottom + (bottom || 0)),
				right: Math.round(base.right + (right || 0))
			};

			this.$background.css({
				width: padding.left + this.options.paper.options.width + padding.right,
				height: padding.top + this.options.paper.options.height + padding.bottom
			});
			this.options.paper.$el.css({
				left: padding.left,
				top: padding.top
			});

			return this;
		},

		zoom: function (value, opt) {

			if (value === undefined) {
				return this._sx;
			}

			opt = opt || {};

			var center = this.clientToLocalPoint(this.el.clientWidth / 2, this.el.clientHeight / 2);
			var sx = value;
			var sy = value;
			var ox;
			var oy;

			if (!opt.absolute) {
				sx += this._sx;
				sy += this._sy;
			}

			if (opt.grid) {
				sx = Math.round(sx / opt.grid) * opt.grid;
				sy = Math.round(sy / opt.grid) * opt.grid;
			}

			// check if the new scale won't exceed the given boundaries
			if (opt.max) {
				sx = Math.min(opt.max, sx);
				sy = Math.min(opt.max, sy);
			}

			if (opt.min) {
				sx = Math.max(opt.min, sx);
				sy = Math.max(opt.min, sy);
			}

			if (opt.ox === undefined || opt.oy === undefined) {

				// if the origin is not specified find the center of the paper's visible area.
				ox = center.x;
				oy = center.y;

			} else {

				var fsx = sx / this._sx;
				var fsy = sy / this._sy;

				ox = opt.ox - ((opt.ox - center.x) / fsx);
				oy = opt.oy - ((opt.oy - center.y) / fsy);
			}

			this.beforePaperManipulation();

			this.options.paper.scale(sx, sy);
			this.center(ox, oy);

			this.afterPaperManipulation();

			return this;
		},

		zoomToFit: function (opt) {

			opt = opt || {};

			var paper = this.options.paper;
			var paperOrigin = joint.util.assign({}, paper.options.origin);

			// fitting bbox has exact size of the the PaperScroller
			opt.fittingBBox = opt.fittingBBox || joint.util.assign({}, g.point(paperOrigin), {
				width: this.$el.width(),
				height: this.$el.height()
			});

			this.beforePaperManipulation();

			// scale the vieport
			paper.scaleContentToFit(opt);

			// restore original origin
			paper.setOrigin(paperOrigin.x, paperOrigin.y);

			this.adjustPaper().centerContent();

			this.afterPaperManipulation();

			return this;
		},

		transitionClassName: 'transition-in-progress',
		transitionEventName: 'transitionend.paper-scroller-transition',

		transitionToPoint: function (x, y, opt) {

			// Allow both `transition(point, options)` and `transition(x, y, options)`
			if (joint.util.isObject(x)) {
				opt = y;
				y = x.y;
				x = x.x;
			}

			opt || (opt = {});

			var oldScale = this._sx;
			var scale = Math.max(opt.scale || oldScale, 1e-6);

			var localPoint = g.Point(x, y);
			var localCenter = this.clientToLocalPoint(this.el.clientWidth / 2, this.el.clientHeight / 2);
			var transform, transformOrigin;

			if (oldScale === scale) {
				// Tranlate only
				var translate = localCenter.difference(localPoint).scale(oldScale, oldScale).round();
				transform = 'translate(' + translate.x + 'px,' + translate.y + 'px)';

			} else {
				// Translate and scale concurrently
				var distance = scale / (oldScale - scale) * localPoint.distance(localCenter);
				var localOrigin = localCenter.clone().move(localPoint, distance);
				var origin = this.localToBackgroundPoint(localOrigin).round();
				transform = 'scale(' + (scale / oldScale) + ')';
				transformOrigin = origin.x + 'px ' + origin.y + 'px';
			}

			this.$el
				.addClass(this.transitionClassName);
			this.$background
				.off(this.transitionEventName)
				.on(this.transitionEventName, function (evt) {

					var paperScroller = this.paperScroller;
					paperScroller.syncTransition(this.scale, { x: this.x, y: this.y });
					// Trigger a callback
					var onTransitionEnd = this.onTransitionEnd;
					if (joint.util.isFunction(onTransitionEnd)) {
						onTransitionEnd.call(paperScroller, evt);
					}
				}.bind({
					// TransitionEnd handler context
					paperScroller: this,
					scale: scale,
					x: x,
					y: y,
					onTransitionEnd: opt.onTransitionEnd
				}))
				.css({
					transition: 'transform',
					transitionDuration: opt.duration || '1s',
					transitionDelay: opt.delay,
					transitionTimingFunction: opt.timingFunction,
					transformOrigin: transformOrigin,
					transform: transform
				});

			return this;
		},

		syncTransition: function (scale, center) {

			this.beforePaperManipulation();

			this.options.paper.scale(scale);

			this.removeTransition()
				.center(center.x, center.y);

			this.afterPaperManipulation();

			return this;
		},

		removeTransition: function () {

			this.$el
				.removeClass(this.transitionClassName);
			this.$background
				.off(this.transitionEventName)
				.css({
					transition: '',
					transitionDuration: '',
					transitionDelay: '',
					transitionTimingFunction: '',
					transform: '',
					transformOrigin: ''
				});

			return this;
		},

		transitionToRect: function (rect, opt) {

			rect = g.Rect(rect);
			opt || (opt = {});
			var maxScale = opt.maxScale || Infinity;
			var minScale = opt.minScale || Number.MIN_VALUE;
			var scaleGrid = opt.scaleGrid || null;
			var visibility = opt.visibility || 1;
			var center = (opt.center) ? g.Point(opt.center) : rect.center();

			var clientWidth = this.el.clientWidth * visibility;
			var clientHeight = this.el.clientHeight * visibility;
			var clientRect = g.Rect({
				x: center.x - clientWidth / 2,
				y: center.y - clientHeight / 2,
				width: clientWidth,
				height: clientHeight
			});

			// scale the paper so all the corner points are in the viewport.
			var scale = clientRect.maxRectUniformScaleToFit(rect, center);
			scale = Math.min(scale, maxScale);
			if (scaleGrid) {
				scale = Math.floor(scale / scaleGrid) * scaleGrid;
			}
			scale = Math.max(minScale, scale);

			return this.transitionToPoint(center, joint.util.defaults({ scale: scale }, opt));
		},

		startPanning: function (evt) {

			evt = joint.util.normalizeEvent(evt);

			this._clientX = evt.clientX;
			this._clientY = evt.clientY;

			this.$el.addClass('is-panning');
			this.trigger('pan:start', evt);

			$(document.body).on({
				'mousemove.panning touchmove.panning': this.pan,
				'mouseup.panning touchend.panning': this.stopPanning
			});

			$(window).on('mouseup.panning', this.stopPanning);
		},

		pan: function (evt) {

			evt = joint.util.normalizeEvent(evt);

			var dx = evt.clientX - this._clientX;
			var dy = evt.clientY - this._clientY;

			this.el.scrollTop -= dy;
			this.el.scrollLeft -= dx;

			this._clientX = evt.clientX;
			this._clientY = evt.clientY;
		},

		stopPanning: function (evt) {

			$(document.body).off('.panning');
			$(window).off('.panning');
			this.$el.removeClass('is-panning');
			this.trigger('pan:stop', evt);
		},

		getPadding: function () {

			var padding = this.options.padding;
			if (joint.util.isFunction(padding)) {
				padding = padding.call(this);
			}

			return joint.util.normalizeSides(padding);
		},

		getVisibleArea: function () {

			var ctm = this.options.paper.matrix();
			var area = {
				x: this.el.scrollLeft || 0,
				y: this.el.scrollTop || 0,
				width: this.el.clientWidth,
				height: this.el.clientHeight
			};

			var transformedArea = V.transformRect(area, ctm.inverse());

			transformedArea.x -= (this._padding.left || 0) / this._sx;
			transformedArea.y -= (this._padding.top || 0) / this._sy;

			return g.rect(transformedArea);
		},

		isElementVisible: function (element, opt) {

			this.checkElement(element, 'isElementVisible');

			opt = opt || {};
			var method = opt.strict ? 'containsRect' : 'intersect';
			return !!this.getVisibleArea()[method](element.getBBox());
		},

		isPointVisible: function (point) {

			return this.getVisibleArea().containsPoint(point);
		},

		// some method require element only because link is missing some tools (eg. bbox)
		checkElement: function (element, methodName) {

			if (!(element && element instanceof joint.dia.Element)) {
				throw new TypeError('ui.PaperScroller.' + methodName + '() accepts instance of joint.dia.Element only');
			}
		},

		onRemove: function () {

			this.stopPanning();
		}

	});

	joint.env.addTest('msie', function () {
		var userAgent = window.navigator.userAgent;
		return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident') !== -1;
	});

	joint.env.addTest('msedge', function () {
		return /Edge\/\d+/.test(window.navigator.userAgent);
	});

	// Selection
	// =============

	// `Selection` implements selecting group of elements and moving the selected elements in one go.
	// Typically, the selection will be bound to the `Shift` key
	// and selecting/deselecting individual elements to the `Ctrl` key.

	// Example usage:

	// var graph = new joint.dia.Graph;
	// var paper = new joint.dia.Paper({ model: graph });
	// var selectionItems = new Backbone.Collection;
	// var selection = new joint.ui.Selection({ paper: paper, graph: graph, model: selectionItems });

	// // Bulk selecting group of elements by creating a rectangular selection area.
	// paper.on('blank:pointerdown', selection.startSelecting);

	// // Selecting individual elements with click and the `Ctrl`/`Command` key.
	// paper.on('cell:pointerup', function(cellView, evt) {
	//      if ((evt.ctrlKey || evt.metaKey) && !(cellView.model instanceof joint.dia.Link)) {
	//              selectionItems.add(cellView.model);
	//      }
	// });

	// // Deselecting previously selected elements with click and the `Ctrl`/`Command` key.
	// selection.on('selection-box:pointerdown', function(evt) {
	//      if (evt.ctrlKey || evt.metaKey) {
	//              var cell = selectionItems.get($(evt.target).data('model'));
	//              selectionItems.reset(selectionItems.without(cell));
	//              selection.destroySelectionBox(paper.findViewByModel(cell));
	//      }
	// });

	joint.ui.Selection = joint.mvc.View.extend({

		options: {
			paper: undefined,
			graph: undefined,
			boxContent: function (boxElement) {
				return joint.util.template('<%= length %> elements selected.')({
					length: this.model.length
				});
			},
			handles: [{
				name: 'remove',
				position: 'nw',
				events: {
					pointerdown: 'removeElements'
				}
			}, {
				name: 'rotate',
				position: 'sw',
				events: {
					pointerdown: 'startRotating',
					pointermove: 'doRotate',
					pointerup: 'stopBatch'
				}
			}, {
				name: 'resize',
				position: 'se',
				events: {
					pointerdown: 'startResizing',
					pointermove: 'doResize',
					pointerup: 'stopBatch'
				}
			}],
			useModelGeometry: false,
			strictSelection: false,
			rotateAngleGrid: 15,
			allowTranslate: true
		},

		className: 'selection',

		events: {
			'mousedown .selection-box': 'onSelectionBoxPointerDown',
			'touchstart .selection-box': 'onSelectionBoxPointerDown',
			'mousedown .handle': 'onHandlePointerDown',
			'touchstart .handle': 'onHandlePointerDown'
		},

		/**
		 * @private
		 */
		init: function () {

			// For backwards compatibility:
			if (this.options.model) {
				this.options.collection = this.options.model;
			}

			var collection = this.collection = this.options.collection || this.collection || new Backbone.Collection;

			if (!collection.comparator) {
				// Make sure the elements are always sorted from the parents to their childs.
				// That is necessary for translating selected elements.
				collection.comparator = this.constructor.depthComparator;
				collection.sort();
			}

			// For backwards compatibility:
			this.model = collection;

			if (this.options.paper) {
				// Allow selection to be initialized with a paper only.
				joint.util.defaults(this.options, { graph: this.options.paper.model });
			} else {
				throw new Error('Selection: paper required');
			}

			joint.util.bindAll(this, 'startSelecting', 'stopSelecting', 'adjustSelection', 'pointerup');

			$(document.body).on('mousemove.selection touchmove.selection', this.adjustSelection);
			$(document).on('mouseup.selection touchend.selection', this.pointerup);

			var paper = this.options.paper;
			var graph = this.options.graph;

			this.listenTo(graph, 'reset', this.cancelSelection);
			this.listenTo(paper, 'scale translate', this.updateSelectionBoxes);
			this.listenTo(graph, 'remove change', function (cell, opt) {
				// Do not react on changes that happened inside the selection.
				if (opt.selection !== this.cid) {
					this.updateSelectionBoxes();
				}
			});

			this.listenTo(collection, 'remove', this.onRemoveElement);
			this.listenTo(collection, 'reset', this.onResetElements);
			this.listenTo(collection, 'add', this.onAddElement);

			paper.$el.append(this.$el);

			// A counter of existing boxes. We don't want to update selection boxes on
			// each graph change when no selection boxes exist.
			this._boxCount = 0;

			this.$selectionWrapper = this.createSelectionWrapper();

			// Add handles.
			this.handles = [];
			joint.util.toArray(this.options.handles).forEach(this.addHandle, this);
		},

		/**
		 * @private
		 */
		cancelSelection: function () {

			this.model.reset([], { ui: true });
		},

		/**
		 * @public
		 * @param {object} opt
		 * @returns {joint.ui.Selection}
		 */
		addHandle: function (opt) {

			this.handles.push(opt);

			var $handle = $('<div/>', {
				'class': 'handle ' + (opt.position || '') + ' ' + (opt.name || ''),
				'data-action': opt.name
			});
			if (opt.icon) {
				$handle.css('background-image', 'url(' + opt.icon + ')');
			}

			$handle.html(opt.content || '');

			// `opt.attrs` allows for setting arbitrary attributes on the generated HTML.
			// This object is of the form: `<selector> : { <attributeName> : <attributeValue>, ... }`
			joint.util.setAttributesBySelector($handle, opt.attrs);

			this.$selectionWrapper.append($handle);

			joint.util.forIn(opt.events, function (method, event) {

				if (joint.util.isString(method)) {
					this.on('action:' + opt.name + ':' + event, this[method], this);
				} else {
					// Otherwise, it must be a function.
					this.on('action:' + opt.name + ':' + event, method);
				}

			}.bind(this));

			return this;
		},

		/**
		 * @public
		 * @param {jQuery.Event} evt
		 */
		stopSelecting: function (evt) {

			var localPoint;
			var paper = this.options.paper;

			switch (this._action) {

				case 'selecting':

					var offset = this.$el.offset();
					var width = this.$el.width();
					var height = this.$el.height();

					// Convert offset coordinates to the local point of the <svg> root element viewport.
					localPoint = paper.pageToLocalPoint(offset.left, offset.top);

					// Convert width and height to take current viewport scale into account
					var paperScale = paper.scale();
					width /= paperScale.sx;
					height /= paperScale.sy;

					var selectedArea = g.rect(localPoint.x, localPoint.y, width, height);
					var elementViews = this.getElementsInSelectedArea(selectedArea);

					var filter = this.options.filter;
					if (Array.isArray(filter)) {

						elementViews = elementViews.filter(function (view) {
							return !filter.includes(view.model) && !filter.includes(view.model.get('type'));
						});

					} else if (joint.util.isFunction(filter)) {

						elementViews = elementViews.filter(function (view) {
							return !filter(view.model);
						});
					}

					var models = elementViews.map(function (view) {
						return view.model;
					});
					this.model.reset(models, { ui: true });

					break;

				case 'translating':

					this.options.graph.stopBatch('selection-translate');
					localPoint = paper.snapToGrid({ x: evt.clientX, y: evt.clientY });
					this.notify('selection-box:pointerup', evt, localPoint.x, localPoint.y);
					// Everything else is done during the translation.
					break;

				default:
					// Hide selection if the user clicked somehwere else in the document.
					if (!this._action) {
						this.cancelSelection();
					}
					break;
			}

			this._action = null;
		},

		/**
		 * @public
		 * @param {string} name
		 * @returns {joint.ui.Selection}
		 */
		removeHandle: function (name) {

			var handleIdx = joint.util.toArray(this.handles).findIndex(function (item) {
				return item.name === name;
			});

			var handle = this.handles[handleIdx];
			if (handle) {

				joint.util.forIn(handle.events, function (method, event) {
					this.off('action:' + name + ':' + event);
				}.bind(this));

				this.$('.handle.' + name).remove();

				this.handles.splice(handleIdx, 1);
			}

			return this;
		},

		/**
		 * @public
		 * @param {jQuery.Event} evt
		 */
		startSelecting: function (evt) {

			evt = joint.util.normalizeEvent(evt);

			this.cancelSelection();

			var paperElement = this.options.paper.el;
			var offsetX, offsetY;

			if (evt.offsetX != null && evt.offsetY != null && $.contains(paperElement, evt.target)) {

				offsetX = evt.offsetX;
				offsetY = evt.offsetY;

			} else {

				// We do not use `evt.offsetX` and `evt.offsetY` event properties when the event target
				// is not inside the the paper element or properties are not defined (FF).

				var paperOffset = $(paperElement).offset();
				var paperScrollLeft = paperElement.scrollLeft;
				var paperScrollTop = paperElement.scrollTop;

				offsetX = evt.clientX - paperOffset.left + window.pageXOffset + paperScrollLeft;
				offsetY = evt.clientY - paperOffset.top + window.pageYOffset + paperScrollTop;
			}

			this.$el.css({ width: 1, height: 1, left: offsetX, top: offsetY });
			this.showLasso();

			this._action = 'selecting';
			this._clientX = evt.clientX;
			this._clientY = evt.clientY;
			this._offsetX = offsetX;
			this._offsetY = offsetY;
		},

		/**
		 * @param {string} name
		 * @param {Object} opt
		 * @returns {joint.ui.Selection}
		 */
		changeHandle: function (name, opt) {

			var handle = joint.util.toArray(this.handles).find(function (item) {
				return item && item.name === name;
			});

			if (handle) {

				this.removeHandle(name);
				this.addHandle(joint.util.merge({ name: name }, handle, opt));
			}

			return this;
		},

		/**
		 * @private
		 * @param {jQuery.Event} evt
		 */
		onSelectionBoxPointerDown: function (evt) {

			evt.stopPropagation();
			evt = joint.util.normalizeEvent(evt);

			// Start translating selected elements.
			if (this.options.allowTranslate) {
				this.startTranslatingSelection(evt);
			}

			this._activeElementView = this.getCellView(evt.target);
			var localPoint = this.options.paper.snapToGrid({ x: evt.clientX, y: evt.clientY });
			this.notify('selection-box:pointerdown', evt, localPoint.x, localPoint.y);
		},

		/**
		 * @private
		 * @param {jQuery.Event} evt
		 */
		startTranslatingSelection: function (evt) {

			this._action = 'translating';

			this.options.graph.startBatch('selection-translate');

			var snappedClientCoords = this.options.paper.snapToGrid({ x: evt.clientX, y: evt.clientY });
			this._snappedClientX = snappedClientCoords.x;
			this._snappedClientY = snappedClientCoords.y;
		},

		/**
		 * @private
		 * @param {jQuery.Event} evt
		 */
		adjustSelection: function (evt) {

			evt = joint.util.normalizeEvent(evt);

			var dx;
			var dy;

			switch (this._action) {

				case 'selecting':

					dx = evt.clientX - this._clientX;
					dy = evt.clientY - this._clientY;

					var left = parseInt(this.$el.css('left'), 10);
					var top = parseInt(this.$el.css('top'), 10);

					this.$el.css({
						left: dx < 0 ? this._offsetX + dx : left,
						top: dy < 0 ? this._offsetY + dy : top,
						width: Math.abs(dx),
						height: Math.abs(dy)
					});
					break;

				case 'translating':

					var snappedClientCoords = this.options.paper.snapToGrid({ x: evt.clientX, y: evt.clientY });
					var snappedClientX = snappedClientCoords.x;
					var snappedClientY = snappedClientCoords.y;

					dx = snappedClientX - this._snappedClientX;
					dy = snappedClientY - this._snappedClientY;

					if (dx || dy) {

						this.translateSelectedElements(dx, dy);

						if (!this.boxesUpdated) {

							var paperScale = this.options.paper.scale();

							// Translate each of the `selection-box` amd `selection-wrapper`.
							this.$el.children('.selection-box').add(this.$selectionWrapper)
								.css({
									left: '+=' + (dx * paperScale.sx),
									top: '+=' + (dy * paperScale.sy)
								});

						} else if (this.model.length > 1) {

							// If there is more than one cell in the selection, we need to update
							// the selection boxes again. e.g when the first element went over the
							// edge of the paper, a translate event was triggered, which updated the selection
							// boxes. After that all remaining elements were translated but the selection
							// boxes stayed unchanged.
							this.updateSelectionBoxes();
						}

						this._snappedClientX = snappedClientX;
						this._snappedClientY = snappedClientY;
					}
					this.notify('selection-box:pointermove', evt, snappedClientX, snappedClientY);
					break;

				default:
					if (this._action) {
						this.pointermove(evt);
					}
					break;
			}

			this.boxesUpdated = false;
		},

		translateSelectedElements: function (dx, dy) {

			// This hash of flags makes sure we're not adjusting vertices of one link twice.
			// This could happen as one link can be an inbound link of one element in the selection
			// and outbound link of another at the same time.
			var processedCells = {};

			this.model.each(function (element) {

				// TODO: snap to grid.
				if (processedCells[element.id]) return;

				// Make sure that selection won't update itself when not necessary
				var opt = { selection: this.cid };

				// Translate the element itself.
				element.translate(dx, dy, opt);

				element.getEmbeddedCells({ deep: true }).forEach(function (embed) {
					processedCells[embed.id] = true;
				});

				// Translate link vertices as well.
				var connectedLinks = this.options.graph.getConnectedLinks(element);

				connectedLinks.forEach(function (link) {

					if (processedCells[link.id]) return;

					link.translate(dx, dy, opt);

					processedCells[link.id] = true;
				});

			}.bind(this));
		},

		/**
		 * @private
		 * @param {string} eventName
		 * @param {jQuery.Event} event
		 */
		notify: function (eventName, event) {

			var args = Array.prototype.slice.call(arguments, 1);
			this.trigger.apply(this, [eventName, this._activeElementView].concat(args));
		},

		/**
		 * @private
		 * @param {g.rect} selectedArea
		 * @returns {Object.<string, joint.dia.Element>}
		 */
		getElementsInSelectedArea: function (selectedArea) {

			var paper = this.options.paper;

			var filterOpt = {
				strict: this.options.strictSelection
			};

			if (this.options.useModelGeometry) {
				var models = paper.model.findModelsInArea(selectedArea, filterOpt);
				return models.map(paper.findViewByModel, paper).filter(function (item) {
					return !!item;
				});
			}

			return paper.findViewsInArea(selectedArea, filterOpt);
		},

		/**
		 * @private
		 * @param {jQuery.Event} evt
		 */
		pointerup: function (evt) {

			if (!this._action) return;

			this.triggerAction(this._action, 'pointerup', evt);
			this.stopSelecting(evt);

			this._activeElementView = null;
			this._action = null;
		},

		/**
		 * @private
		 * @param {joint.dia.Element} element
		 */
		destroySelectionBox: function (element) {

			this.$('[data-model="' + element.get('id') + '"]').remove();

			if (this.$el.children('.selection-box').length === 0) {
				this.hide();
			}

			this._boxCount = Math.max(0, this._boxCount - 1);
		},

		/**
		 * @private
		 */
		hide: function () {
			this.$el.removeClass('lasso selected');
		},

		/**
		 * @private
		 */
		showSelected: function () {
			this.$el.addClass('selected');
		},

		/**
		 * @private
		 */
		showLasso: function () {
			this.$el.addClass('lasso');
		},

		/**
		 * @private
		 */
		destroyAllSelectionBoxes: function () {

			this.hide();
			this.$el.children('.selection-box').remove();
			this._boxCount = 0;
		},

		/**
		 * @private
		 * @param {joint.dia.Element} element
		 */
		createSelectionBox: function (element) {

			var elementView = element.findView(this.options.paper);
			if (elementView) {
				var viewBBox = elementView.getBBox({ useModelGeometry: this.options.useModelGeometry });
				$('<div/>')
					.addClass('selection-box')
					.attr('data-model', element.get('id'))
					.css({ left: viewBBox.x, top: viewBBox.y, width: viewBBox.width, height: viewBBox.height })
					.appendTo(this.el);
				this.showSelected();
				this._boxCount++;
			}
		},

		/**
		 * @private
		 * @returns {jQuery}
		 */
		createSelectionWrapper: function () {

			var $selectionWrapper = $('<div/>', { 'class': 'selection-wrapper' });
			var $box = $('<div/>', { 'class': 'box' });
			$selectionWrapper.append($box);
			$selectionWrapper.attr('data-selection-length', this.model.length);
			this.$el.prepend($selectionWrapper);
			return $selectionWrapper;
		},

		/**
		 * @private
		 */
		updateSelectionWrapper: function () {

			// Find the position and dimension of the rectangle wrapping
			// all the element views.
			var origin = { x: Infinity, y: Infinity };
			var corner = { x: 0, y: 0 };

			this.model.each(function (cell) {

				var view = this.options.paper.findViewByModel(cell);
				if (view) {
					var bbox = view.getBBox({ useModelGeometry: this.options.useModelGeometry });
					origin.x = Math.min(origin.x, bbox.x);
					origin.y = Math.min(origin.y, bbox.y);
					corner.x = Math.max(corner.x, bbox.x + bbox.width);
					corner.y = Math.max(corner.y, bbox.y + bbox.height);
				}
			}.bind(this));

			this.$selectionWrapper.css({
				left: origin.x,
				top: origin.y,
				width: (corner.x - origin.x),
				height: (corner.y - origin.y)
			}).attr('data-selection-length', this.model.length);

			if (joint.util.isFunction(this.options.boxContent)) {

				var $box = this.$('.box');
				var content = this.options.boxContent.call(this, $box[0]);

				// don't append empty content. (the content might had been created inside boxContent()
				if (content) {
					$box.html(content);
				}
			}
		},

		/**
		 * @private
		 */
		updateSelectionBoxes: function () {

			if (!this._boxCount) return;

			this.hide();

			var children = this.$el.children('.selection-box');
			for (var i = 0, n = children.length; i < n; i++) {
				var element = children[i];

				var removedId = $(element).remove().attr('data-model');

				// try to find an element with the same id in the selection collection and
				// find the view for this model.
				var removedModel = this.model.get(removedId);

				if (removedModel) {
					// The view doesn't need to exist on the paper anymore as we use this method
					// as a handler for element removal.
					this.createSelectionBox(removedModel);
				}
			}
			this.updateSelectionWrapper();

			// When an user drags selection boxes over the edge of the paper and the paper gets resized,
			// we update the selection boxes here (giving them exact position) and we do not want
			// the selection boxes to be shifted again based on the mousemove.
			// See adjustSelection() method.
			this.boxesUpdated = true;
		},

		/**
		 * @private
		 */
		onRemove: function () {

			$(document.body).off('.selection', this.adjustSelection);
			$(document).off('.selection', this.pointerup);
		},

		/**
		 * @private
		 * @param {jQuery.Event} evt
		 */
		onHandlePointerDown: function (evt) {

			this._action = $(evt.target).closest('.handle').attr('data-action');
			if (this._action) {

				evt.preventDefault();
				evt.stopPropagation();
				evt = joint.util.normalizeEvent(evt);

				this._clientX = evt.clientX;
				this._clientY = evt.clientY;
				this._startClientX = this._clientX;
				this._startClientY = this._clientY;

				this.triggerAction(this._action, 'pointerdown', evt);
			}
		},

		/**
		 * @private
		 * @param {HTMLElement} element
		 * @returns {joint.dia.Element}
		 */
		getCellView: function (element) {

			var cell = this.model.get(element.getAttribute('data-model'));
			return cell && cell.findView(this.options.paper);
		},

		/**
		 * @private
		 * @param {jQuery.Event} evt
		 */
		pointermove: function (evt) {

			if (!this._action) return;

			var clientCoords = this.options.paper.snapToGrid({ x: evt.clientX, y: evt.clientY });
			var oldClientCoords = this.options.paper.snapToGrid({ x: this._clientX, y: this._clientY });

			var dx = clientCoords.x - oldClientCoords.x;
			var dy = clientCoords.y - oldClientCoords.y;

			this.triggerAction(this._action, 'pointermove', evt, dx, dy, evt.clientX - this._startClientX, evt.clientY - this._startClientY);

			this._clientX = evt.clientX;
			this._clientY = evt.clientY;
		},

		/**
		 * Trigger an action on the Selection object. `evt` is a DOM event
		 * @private
		 * @param {string} action
		 * @param {string} eventName abstracted JointJS event name (pointerdown, pointermove, pointerup).
		 * @param {jQuery.Event} evt
		 */
		triggerAction: function (action, eventName, evt) {

			var args = Array.prototype.slice.call(arguments, 2);
			args.unshift('action:' + action + ':' + eventName);
			this.trigger.apply(this, args);
		},

		// Handle actions.

		/**
		 * @private
		 * @param {joint.dia.Element} element
		 */
		onRemoveElement: function (element) {

			this.destroySelectionBox(element);
			this.updateSelectionWrapper();
		},

		/**
		 * @private
		 * @param {Backbone.Collection.<joint.dia.Cell>} elements
		 */
		onResetElements: function (elements) {

			this.destroyAllSelectionBoxes();

			elements.each(this.createSelectionBox.bind(this));

			this.updateSelectionWrapper();
		},

		/**
		 * @private
		 * @param {joint.dia.Element} element
		 */
		onAddElement: function (element) {

			this.createSelectionBox(element);
			this.updateSelectionWrapper();
		},

		/**
		 * @private
		 * @param {jQuery.Event} evt
		 */
		removeElements: function (evt) {

			// Store cells before `cancelSelection()` resets the selection collection.
			var cells = this.collection.toArray();
			this.cancelSelection();
			this.options.graph.removeCells(cells, { selection: this.cid });
		},

		/**
		 * @private
		 * @param {jQuery.Event} evt
		 */
		startRotating: function (evt) {

			this.options.graph.trigger('batch:start');

			var center = this.options.graph.getBBox(this.model.models).center();
			var clientCoords = this.options.paper.snapToGrid({ x: evt.clientX, y: evt.clientY });
			var initialAngles = this.model.toArray().reduce(function (res, element) {
				res[element.id] = g.normalizeAngle(element.get('angle') || 0);
				return res;
			}, {});

			this._rotation = {
				center: center,
				clientAngle: g.point(clientCoords).theta(center),
				initialAngles: initialAngles
			};
		},

		/**
		 * @private
		 * @param {jQuery.Event} evt
		 */
		startResizing: function (evt) {

			var paper = this.options.paper;
			var graph = this.options.graph;
			var grid = paper.options.gridSize;
			var elements = this.model.toArray();

			var selectionBBox = graph.getBBox(elements);
			var elBBoxes = joint.util.invoke(elements, 'getBBox');
			var minElWidth = elBBoxes.reduce(function (min, bBox) {
				return bBox.width < min ? bBox.width : min;
			}, Infinity);
			var minElHeight = elBBoxes.reduce(function (min, bBox) {
				return bBox.height < min ? bBox.height : min;
			}, Infinity);

			this._resize = {
				cells: graph.getSubgraph(elements),
				bbox: selectionBBox,
				minWidth: grid * selectionBBox.width / minElWidth,
				minHeight: grid * selectionBBox.height / minElHeight
			};

			graph.trigger('batch:start');
		},

		/**
		 * @param {jQuery.Event} evt
		 * @param {number} dx
		 * @param {number} dy
		 */
		doResize: function (evt, dx, dy) {

			var opt = this._resize;
			var bbox = opt.bbox;
			var prevWidth = bbox.width;
			var prevHeight = bbox.height;
			var width = Math.max(prevWidth + dx, opt.minWidth);
			var height = Math.max(prevHeight + dy, opt.minHeight);

			if (Math.abs(prevWidth - width) > 1e-3 || Math.abs(prevHeight - height) > 1e-3) {

				this.options.graph.resizeCells(width, height, opt.cells, {
					selection: this.cid
				});

				// update selection bbox
				bbox.width = width;
				bbox.height = height;

				this.updateSelectionBoxes();
			}
		},

		/**
		 * @private
		 * @param {jQuery.Event} evt
		 */
		doRotate: function (evt) {

			var rotation = this._rotation;

			// Calculate an angle between the line starting at mouse coordinates, ending at the centre
			// of rotation and y-axis and deduct the angle from the start of rotation.
			var angleGrid = this.options.rotateAngleGrid;
			var clientCoords = this.options.paper.snapToGrid({ x: evt.clientX, y: evt.clientY });
			var theta = rotation.clientAngle - g.point(clientCoords).theta(rotation.center);

			if (Math.abs(theta) > 1e-3) {

				this.model.each(function (element) {
					var newAngle = g.snapToGrid(rotation.initialAngles[element.id] + theta, angleGrid);
					element.rotate(newAngle, true, rotation.center, { selection: this.cid });
				}, this);

				this.updateSelectionBoxes();
			}
		},

		/**
		 * @private
		 */
		stopBatch: function () {

			this.options.graph.trigger('batch:stop');
		},

		/**
		 * @private
		 * Return the current action of the Selection.
		 * This can be one of:
		 * 'translating' | 'selecting' or any custom action.
		 * This is especially useful if you want to prevent from something happening
		 * while the selection is taking place (e.g. in the 'selecting' state and you are
		 * handling the mouseover event).
		 * @returns {string}
		 */
		getAction: function () {

			return this._action;
		}
	}, {

			depthComparator: function (element) {
				// Where depth is a number of ancestors.
				return element.getAncestors().length;
			}
		});

	// An alias for backwards compatibility
	joint.ui.SelectionView = joint.ui.Selection;

	// Implements Clipboard for copy-pasting elements.
	// Note that the clipboard is also able to copy elements and their associated links from one graph
	// and paste them to another.

	// Usage:

	//       var selection = new Backbone.Collection;
	//       var graph = new joint.dia.Graph;
	//       // ... now something that adds elements to the selection ...
	//       var clipboard = new joint.ui.Clipboard;
	//       KeyboardJS.on('ctrl + c', function() { clipboard.copyElements(selection, graph); });
	//       KeyboardJS.on('ctrl + v', function() { clipboard.pasteCells(graph); });
	joint.ui.Clipboard = Backbone.Collection.extend({
		LOCAL_STORAGE_KEY: 'joint.ui.Clipboard.cells',
		defaults: {
			useLocalStorage: true
		},
		/**
		 * @public
		 * This function returns the elements and links from the original graph that were copied. This is useful for implements
		 * the Cut operation where the original cells should be removed from the graph. `selection` contains
		 * elements that should be copied to the clipboard. Note that with these elements, also all the associated
		 * links are copied. That's why we also need the `graph` parameter, to find these links.
		 *
		 * @param {Backbone.Collection} selection
		 * @param {joint.dia.Graph} graph
		 * @param {Object=} opt Used as a default for settings passed through the `pasteCells` method.
		 * @returns {Array.<joint.dia.Cell>}
		 */
		copyElements: function (selection, graph, opt) {

			this.options = joint.util.assign({}, this.defaults, opt);
			opt = this.options;

			var originalElements = selection.toArray();
			var clones = joint.util.sortBy(graph.cloneSubgraph(originalElements, opt), function (cell) {
				return cell.isLink() ? 2 : 1;
			});

			this.reset(clones);

			if (opt.useLocalStorage && window.localStorage) {
				localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(this.toJSON()));
			}

			return originalElements;
		},

		/**
		 * @public
		 * Same logic as per `copyElements`, but elements are removed from the graph
		 * @param {Backbone.Collection} selection
		 * @param {joint.dia.Graph} graph
		 * @param {Object=} opt Used as a default for settings passed through the `pasteCells` method.
		 * @returns {Array.<joint.dia.Cell>} elements removed from graph
		 */
		cutElements: function (selection, graph, opt) {

			var elementsToRemove = this.copyElements(selection, graph, opt);
			graph.trigger('batch:start', { batchName: 'cut' });
			joint.util.invoke(elementsToRemove, 'remove');
			graph.trigger('batch:stop', { batchName: 'cut' });
			return elementsToRemove;
		},

		/**
		 * @public
		 * @param {joint.dia.Graph} graph Where paste to.
		 * @param {Object.<{ translate: {dx: number, dy: number}, useLocalStorage: boolean, link: Object}>=} opt
		 * If `translate` object with `dx` and `dy` properties is passed, the copied elements will be
		 * translated by the specified amount. This is useful for e.g. the 'cut' operation where we'd like to have
		 * the pasted elements moved by an offset to see they were pasted to the paper.
		 *
		 * If `useLocalStorage` is `true`, the copied elements will be saved to the localStorage (if present)
		 * making it possible to copy-paste elements between browser tabs or sessions.
		 *
		 * `link` is attributes that will be set all links before they are added to the `graph`.
		 * This is useful for e.g. setting `z: -1` for links in order to always put them to the bottom of the paper.
		 * @returns {Array.<joint.dia.Cell>}
		 */
		pasteCells: function (graph, opt) {

			//use options passed into copyElements as defaults for paste
			opt = joint.util.defaults(opt || {}, this.options);

			if (opt.useLocalStorage && this.isEmpty() && window.localStorage) {

				var graphJSON = {
					cells: JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_KEY))
				};
				// Note there is a `{ sort: false }` option passed to make sure
				// the temporary graph does not change the order of cells.
				// i.e. elements must stay before links
				var tmpGraph = new joint.dia.Graph().fromJSON(graphJSON, { sort: false });
				this.reset(tmpGraph.getCells());
			}

			//process modification on current data
			var pastedCells = this.map(function (cell) {
				return this.modifyCell(cell, opt);
			}.bind(this));

			graph.trigger('batch:start', { batchName: 'paste' });
			graph.addCells(pastedCells);
			graph.trigger('batch:stop', { batchName: 'paste' });

			this.copyElements(this, graph);

			return pastedCells;
		},

		/**
		 * @public
		 */
		clear: function () {

			this.options = {};
			this.reset([]);

			if (window.localStorage) {
				localStorage.removeItem(this.LOCAL_STORAGE_KEY);
			}
		},

		/**
		 * @private
		 * @param {joint.dia.Cell} cell
		 * @param {Object} opt
		 * @returns {joint.dia.Cell}
		 */
		modifyCell: function (cell, opt) {

			cell.unset('z');
			if (cell.isLink() && opt.link) {
				cell.set(opt.link);
			}

			if (opt.translate) {
				cell.translate(opt.translate.dx || 20, opt.translate.dy || 20);
			}

			// It's necessary to unset the collection reference here. Backbone.Collection adds collection
			// attribute to every new model, except if the model already has one. The pasted elements needs to have
			// collection attribute set to the Graph collection (not the Selection collection).
			cell.collection = null;

			return cell;
		}
	});

	(function (joint) {
		'use strict';

		/**
		 * @constructor
		 */
		var LinkHalo = function () {
			this.options = {
				handles: [
					{
						name: 'remove',
						position: 'nw',
						events: { pointerdown: 'removeElement' },
						icon: null
					},
					{
						name: 'direction',
						position: 'se',
						events: { pointerdown: 'directionSwap' },
						icon: null
					}
				],
				bbox: function (cellView) {

					var linkLength = cellView.getConnectionLength() * 0.5;
					return cellView.getPointAtLength(linkLength);
				},
				typeCssName: 'type-link',
				tinyThreshold: -1,
				smallThreshold: -1,
				boxContent: false
			};
		};

		/**
		 * @private
		 * Swap direction of the link.
		 */
		LinkHalo.prototype.directionSwap = function () {
			var model = this.options.cellView.model;
			model.set({ source: model.get('target'), target: model.get('source') }, { halo: this.cid });
		};

		/**
		 * @constructor
		 */
		var ElementHalo = function () {
			this.options = {
				handles: [
					{
						name: 'remove',
						position: 'nw',
						events: { pointerdown: 'removeElement' },
						icon: null
					},
					{
						name: 'resize',
						position: 'se',
						events: { pointerdown: 'startResizing', pointermove: 'doResize', pointerup: 'stopBatch' },
						icon: null
					},
					{
						name: 'clone',
						position: 'n',
						events: { pointerdown: 'startCloning', pointermove: 'doClone', pointerup: 'stopCloning' },
						icon: null
					},
					{
						name: 'link',
						position: 'e',
						events: { pointerdown: 'startLinking', pointermove: 'doLink', pointerup: 'stopLinking' },
						icon: null
					},
					{
						name: 'fork',
						position: 'ne',
						events: { pointerdown: 'startForking', pointermove: 'doFork', pointerup: 'stopForking' },
						icon: null
					},
					{
						name: 'unlink',
						position: 'w',
						events: { pointerdown: 'unlinkElement' },
						icon: null
					},
					{
						name: 'rotate',
						position: 'sw',
						events: { pointerdown: 'startRotating', pointermove: 'doRotate', pointerup: 'stopBatch' },
						icon: null
					}
				],

				/**
				 * @param {joint.dia.CellView} cellView
				 * @param {joint.ui.Halo} halo
				 * @returns {g.rect}
				 */
				bbox: function (cellView, halo) {
					return cellView.getBBox({ useModelGeometry: halo.options.useModelGeometry });
				},
				typeCssName: 'type-element',
				tinyThreshold: 40,
				smallThreshold: 80,

				// a function returning a html string, which will be used as the halo box content
				boxContent: function (elementView, boxElement) {
					var tmpl = joint.util.template('x: <%= x %>, y: <%= y %>, width: <%= width %>, height: <%= height %>, angle: <%= angle %>');
					var element = elementView.model;
					var bbox = element.getBBox();

					return tmpl({
						x: Math.floor(bbox.x),
						y: Math.floor(bbox.y),
						width: Math.floor(bbox.width),
						height: Math.floor(bbox.height),
						angle: Math.floor(element.get('angle') || 0)
					});
				},

				magnet: function (elementView) {
					// elementView root element by default
					return elementView.el;
				},

				loopLinkPreferredSide: 'top',
				loopLinkWidth: 40,
				rotateAngleGrid: 15,

				// Rest of options are deprecated (better use joint.dia.Paper.options.linkModel)
				linkAttributes: {},
				smoothLinks: undefined
			};
		};

		ElementHalo.prototype.startLinking = function (evt, x, y) {

			this.startBatch();

			var options = this.options;
			var paper = options.paper;
			var graph = options.graph;

			var link = this.createLinkConnectedToSource();

			// add link to graph but don't validate
			link.set({
				target: { x: x, y: y }
			}).addTo(graph, {
				validation: false,
				halo: this.cid,
				async: false
			});

			var linkView = this._linkView = link.findView(paper);
			linkView.startArrowheadMove('target', { whenNotAllowed: 'remove' });
		};

		ElementHalo.prototype.startForking = function (evt, x, y) {

			var options = this.options;
			var paper = options.paper;
			var graph = options.graph;

			this.startBatch();

			var clone = options.clone(options.cellView.model, { fork: true });
			if (!(clone instanceof joint.dia.Cell)) {
				throw new Error('ui.Halo: option "clone" has to return a cell.');
			}

			this.centerElementAtCursor(clone, x, y);
			clone.addTo(graph, {
				halo: this.cid,
				async: false
			});

			var link = this.createLinkConnectedToSource();
			var cloneView = this._cloneView = clone.findView(paper);
			var targetMagnet = this.getElementMagnet(cloneView, 'target');
			var linkTarget = this.getLinkEnd(cloneView, targetMagnet);

			link.set('target', linkTarget).addTo(graph, {
				halo: this.cid,
				async: false
			});

			cloneView.pointerdown(evt, x, y);
		};

		ElementHalo.prototype.getElementMagnet = function (elementView, endAttribute) {
			var fn = this.options.magnet;
			if (joint.util.isFunction(fn)) {
				var magnet = fn.call(this, elementView, endAttribute);
				if (magnet instanceof SVGElement) {
					return magnet;
				}
			}
			throw new Error('ui.Halo: magnet() has to return an SVGElement.');
		},

			ElementHalo.prototype.getLinkEnd = function (elementView, magnet) {
				var end = { id: elementView.model.id };
				if (magnet !== elementView.el) {
					var port = magnet.getAttribute('port');
					if (port) {
						end.port = port;
					} else {
						end.selector = elementView.getSelector(magnet);
					}
				}
				return end;
			},

			ElementHalo.prototype.createLinkConnectedToSource = function () {

				var options = this.options;
				var paper = options.paper;
				var elementView = options.cellView;
				var sourceMagnet = this.getElementMagnet(elementView, 'source');
				var linkSource = this.getLinkEnd(elementView, sourceMagnet);
				var link = paper.getDefaultLink(elementView, sourceMagnet).set('source', linkSource);

				// Backwards compatibility
				link.attr(options.linkAttributes);
				if (joint.util.isBoolean(options.smoothLinks)) {
					link.set('smooth', options.smoothLinks);
				}

				return link;
			},

			ElementHalo.prototype.startResizing = function (evt) {

				this.startBatch();

				// determine whether to flip x,y mouse coordinates while resizing or not
				this._flip = [1, 0, 0, 1, 1, 0, 0, 1][Math.floor(g.normalizeAngle(this.options.cellView.model.get('angle')) / 45)];
			};

		ElementHalo.prototype.startRotating = function (evt, x, y) {

			this.startBatch();

			var center = this.options.cellView.model.getBBox().center();
			var angle = g.normalizeAngle(this.options.cellView.model.get('angle'));

			this._center = center;
			this._rotationStartAngle = angle || 0;
			this._clientStartAngle = g.point(x, y).theta(center);
		};

		ElementHalo.prototype.doResize = function (evt, x, y, dx, dy) {

			var size = this.options.cellView.model.get('size');

			var width = Math.max(size.width + ((this._flip ? dx : dy)), 1);
			var height = Math.max(size.height + ((this._flip ? dy : dx)), 1);

			this.options.cellView.model.resize(width, height, { absolute: true });
		};

		ElementHalo.prototype.doRotate = function (evt, x, y) {

			// Calculate an angle between the line starting at mouse coordinates, ending at the centre
			// of rotation and y-axis and deduct the angle from the start of rotation.
			var theta = this._clientStartAngle - g.point(x, y).theta(this._center);
			var newAngle = g.snapToGrid(this._rotationStartAngle + theta, this.options.rotateAngleGrid);

			this.options.cellView.model.rotate(newAngle, true);
		};

		ElementHalo.prototype.doClone = function (evt, x, y) {

			var cloneView = this._cloneView;
			if (cloneView) {
				cloneView.pointermove(evt, x, y);
			}
		};

		ElementHalo.prototype.startCloning = function (evt, x, y) {

			var options = this.options;

			this.startBatch();

			var clone = options.clone(options.cellView.model, { clone: true });

			if (!(clone instanceof joint.dia.Cell)) {
				throw new Error('ui.Halo: option "clone" has to return a cell.');
			}

			this.centerElementAtCursor(clone, x, y);
			clone.addTo(options.graph, { halo: this.cid, async: false });

			this._cloneView = clone.findView(options.paper);
			this._cloneView.pointerdown(evt, x, y);
		};

		ElementHalo.prototype.centerElementAtCursor = function (element, x, y) {

			var center = element.getBBox().center();
			var tx = x - center.x;
			var ty = y - center.y;

			element.translate(tx, ty);
		};

		ElementHalo.prototype.doFork = function (evt, x, y) {

			var cloneView = this._cloneView;
			if (cloneView) {
				cloneView.pointermove(evt, x, y);
			}
		};

		ElementHalo.prototype.doLink = function (evt, x, y) {

			if (this._linkView) {
				this._linkView.pointermove(evt, x, y);
			}
		};

		ElementHalo.prototype.stopLinking = function (evt) {

			if (this._linkView) {

				this._linkView.pointerup(evt);

				if (this._linkView.model.hasLoop()) {
					this.makeLoopLink(this._linkView.model);
				}

				this.stopBatch();
				this.triggerAction('link', 'add', this._linkView.model);
				this._linkView = null;
			}
		};

		ElementHalo.prototype.stopForking = function (evt, x, y) {

			var cloneView = this._cloneView;
			if (cloneView) {
				cloneView.pointerup(evt, x, y);
			}
			this.stopBatch();
		};

		ElementHalo.prototype.stopCloning = function (evt, x, y) {

			var cloneView = this._cloneView;
			if (cloneView) {
				cloneView.pointerup(evt, x, y);
			}
			this.stopBatch();
		};

		ElementHalo.prototype.unlinkElement = function (evt) {

			this.startBatch();
			this.options.graph.removeLinks(this.options.cellView.model);
			this.stopBatch();
		};

		ElementHalo.prototype.makeLoopLink = function (link) {
			var linkWidth = this.options.loopLinkWidth;
			var paperOpt = this.options.paper.options;
			var paperRect = g.rect({ x: 0, y: 0, width: paperOpt.width, height: paperOpt.height });
			var bbox = V(this.options.cellView.el).bbox(false, this.options.paper.viewport);
			var p1, p2;

			var sides = joint.util.uniq([this.options.loopLinkPreferredSide, 'top', 'bottom', 'left', 'right']);
			var sideFound = sides.find(function (side) {

				var centre;
				var dx = 0;
				var dy = 0;

				switch (side) {

					case 'top':
						centre = g.point(bbox.x + bbox.width / 2, bbox.y - linkWidth);
						dx = linkWidth / 2;
						break;

					case 'bottom':
						centre = g.point(bbox.x + bbox.width / 2, bbox.y + bbox.height + linkWidth);
						dx = linkWidth / 2;
						break;

					case 'left':
						centre = g.point(bbox.x - linkWidth, bbox.y + bbox.height / 2);
						dy = linkWidth / 2;
						break;

					case 'right':
						centre = g.point(bbox.x + bbox.width + linkWidth, bbox.y + bbox.height / 2);
						dy = linkWidth / 2;
						break;
				}

				p1 = g.point(centre).offset(-dx, -dy);
				p2 = g.point(centre).offset(dx, dy);

				return paperRect.containsPoint(p1) && paperRect.containsPoint(p2);

			}, this);

			if (sideFound) link.set('vertices', [p1, p2]);

		};

		joint.ui.Halo = joint.mvc.View.extend({

			PIE_INNER_RADIUS: 20,
			PIE_OUTER_RADIUS: 50,

			className: 'halo',

			events: {
				'mousedown .handle': 'onHandlePointerDown',
				'touchstart .handle': 'onHandlePointerDown',
				'mousedown .pie-toggle': 'onPieTogglePointerDown',
				'touchstart .pie-toggle': 'onPieTogglePointerDown'
			},

			options: {
				clearAll: true,
				clearOnBlankPointerdown: true,
				// This option allows you to compute bbox from the model. The view bbox can sometimes return
				// an unwanted result e.g when an element uses SVG filters or clipPaths. Note that downside
				// of computing a bbox is that it takes no relative subelements into account (e.g ports).
				useModelGeometry: false,
				// A function returning a copy of given cell used in cloning and forking.
				// Useful e.g. when you wish to translate the clone after it's created.
				// Note that clone is not in the graph when the function is invoked.
				clone: function (cell, opt) {
					return cell.clone().unset('z');
				},
				// Type of the halo. Determines the look of the halo (esp. positioning of handles).
				type: 'surrounding',
				// Various options for a specific types.
				pieSliceAngle: 45,
				pieStartAngleOffset: 0,
				pieIconSize: 14,
				// Pie toggle buttons. Usually, there is only one but in general, there can be
				// many. Each button can have a position (e ... east, w ... west, s ... south, n ... north)
				// and name. This name is then used when triggering events when the pie toggle button
				// is clicked (pie:open:default / pie:close:default).
				pieToggles: [{ name: 'default', position: 'e' }]
			},

			/**
			 * @protected
			 */
			init: function () {

				var options = this.options;
				var cellView = options.cellView;
				var cell = cellView.model;
				var cellViewAbstract = cell.isLink() ? new LinkHalo() : new ElementHalo();

				joint.util.assign(this, joint.util.omit(cellViewAbstract, 'options'));

				var paper = cellView.paper;
				var graph = paper.model;

				joint.util.defaults(options, cellViewAbstract.options, {
					paper: paper,
					graph: graph
				});

				joint.util.bindAll(this, 'pointermove', 'pointerup', 'render', 'update');

				if (options.clearAll) {
					// Clear a previous halo if there was one for the paper.
					this.constructor.clear(paper);
				}

				// Update halo when the graph changed.
				this.listenTo(graph, 'reset', this.remove);
				this.listenTo(cell, 'remove', this.remove);
				this.listenTo(paper, 'halo:create', this.remove);
				if (options.clearOnBlankPointerdown) {
					// Hide Halo when the user clicks anywhere in the paper
					this.listenTo(paper, 'blank:pointerdown', this.remove);
				}

				this.listenTo(graph, 'all', this.update);
				this.listenTo(paper, 'scale translate', this.update);

				$(document.body).on('mousemove touchmove', this.pointermove);
				$(document).on('mouseup touchend', this.pointerup);

				// Add all default handles first.
				this.handles = [];

				joint.util.toArray(options.handles).forEach(this.addHandle, this);
			},

			/**
			 * @public
			 * @returns {joint.ui.Halo}
			 */
			render: function () {

				var options = this.options;

				this.$el.empty();
				this.$handles = $('<div/>').addClass('handles').appendTo(this.el);
				this.$box = $('<label/>').addClass('box').appendTo(this.el);
				// A cache for pie toggle buttons in the form [toggleName] -> [$pieToggle].
				this.$pieToggles = {};

				// Add halo type for css styling purposes.
				this.$el.addClass(options.type);
				this.$el.addClass(this.cellTypeCssClass());

				// Add the `data-type` attribute with the `type` of the cell to the root element.
				// This makes it possible to style the halo (including hiding/showing actions) based
				// on the type of the cell.
				this.$el.attr('data-type', options.cellView.model.get('type'));

				// Render handles.
				this.$handles.append(joint.util.toArray(this.handles).map(this.renderHandle, this));

				switch (options.type) {

					case 'toolbar':
					case 'surrounding':

						// If the cell can not connect itself with the clone of
						// itself due to the validate connection method, don't
						// display fork handle at all.
						if (this.hasHandle('fork')) {
							this.toggleFork();
						}

						break;

					case 'pie':

						// Pie halo has a button to toggle visibility of the
						// menu, that is not a handle (can't be added or removed).
						joint.util.toArray(this.options.pieToggles).forEach(function (opt) {
							var $pieToggle = $('<div/>');
							$pieToggle.addClass('pie-toggle ' + (opt.position || 'e'));
							$pieToggle.attr('data-name', opt.name);
							joint.util.setAttributesBySelector($pieToggle, opt.attrs);
							$pieToggle.appendTo(this.el);
							this.$pieToggles[opt.name] = $pieToggle;
						}, this);

						break;

					default:
						throw new Error('ui.Halo: unknown type');
				}

				this.update();
				this.$el.addClass('animate').appendTo(options.paper.el);
				this.setPieIcons();

				return this;
			},

			// For pie halos we must set the "xlink:href" attribute of the <image> SVG element.
			// Because we cannot set it via CSS.
			setPieIcons: function () {

				if (this.options.type !== 'pie') return;

				this.$el.find('.handle').each(function (index, handleEl) {

					var $sliceIcon;
					var $handle = $(handleEl);
					var name = $handle.attr('data-action');
					var handle = this.getHandle(name);

					// Don't override the image icon.
					if (handle && handle.icon) return;

					var content = window.getComputedStyle(handleEl, ':before').getPropertyValue('content');

					if (content && content !== 'none') {

						$sliceIcon = $handle.find('.slice-text-icon');
						if ($sliceIcon.length > 0) {
							V($sliceIcon[0]).text(content.replace(/['"]/g, ''));
						}
					}

					var bgImage = $handle.css('background-image');

					if (bgImage) {

						var match = bgImage.match(/url\(['"]?([^'"]+)['"]?\)/);

						if (match) {

							var imageUrl = match[1];
							$sliceIcon = $handle.find('.slice-img-icon');

							if ($sliceIcon.length > 0) {
								V($sliceIcon[0]).attr('xlink:href', imageUrl);
							}
						}
					}

				}.bind(this));
			},

			/**
			 * @protected
			 */
			update: function () {

				if (!this.isRendered()) {
					return;
				}

				this.updateBoxContent();

				var bbox = this.getBBox();

				this.$el.toggleClass('tiny', bbox.width < this.options.tinyThreshold && bbox.height < this.options.tinyThreshold);
				this.$el.toggleClass('small', !this.$el.hasClass('tiny') && (bbox.width < this.options.smallThreshold && bbox.height < this.options.smallThreshold));

				this.$el.css({
					width: bbox.width,
					height: bbox.height,
					left: bbox.x,
					top: bbox.y
				});

				if (this.hasHandle('unlink')) {
					this.toggleUnlink();
				}
			},

			/**
			 * @private
			 * @returns {g.rect}
			 */
			getBBox: function () {

				var cellView = this.options.cellView;
				var bbox = this.options.bbox;
				var rect = (joint.util.isFunction(bbox)) ? bbox(cellView, this) : bbox;

				rect = joint.util.defaults({}, rect, { x: 0, y: 0, width: 1, height: 1 });

				return g.rect(rect);
			},

			/**
			 * @private
			 * Add halo type for css styling purposes.
			 * @returns {string}
			 */
			cellTypeCssClass: function () {
				return this.options.typeCssName;
			},

			/**
			 * Updates the box content.
			 * @private
			 */
			updateBoxContent: function () {

				var boxContent = this.options.boxContent;
				var cellView = this.options.cellView;

				if (joint.util.isFunction(boxContent)) {

					var content = boxContent.call(this, cellView, this.$box[0]);

					// don't append empty content. (the content might had been created inside boxContent()
					if (content) {
						this.$box.html(content);
					}

				} else if (boxContent) {

					this.$box.html(boxContent);

				} else {

					this.$box.remove();
				}
			},

			/**
			 * @public
			 * @param {Object} handleTooltips
			 */
			extendHandles: function (handleTooltips) {

				joint.util.forIn(handleTooltips, function (item) {

					var handle = this.getHandle(item.name);
					if (handle) {
						joint.util.assign(handle, item);
					}
				}.bind(this));
			},

			/**
			 * Add multiple handles in one go. This is just a syntactic sugar
			 * to looping over `handles` and calling `addHandle()`.
			 * @public
			 * @param {Array.<Object>}handles
			 * @returns {joint.ui.Halo}
			 */
			addHandles: function (handles) {

				joint.util.toArray(handles).forEach(this.addHandle, this);
				return this;
			},

			/**
			 * @public
			 * @param {Object} opt
			 * @returns {joint.ui.Halo}
			 */
			addHandle: function (opt) {

				var handle = this.getHandle(opt.name);

				/// Add new handle only if this does not exist yet.
				if (!handle) {

					this.handles.push(opt);

					joint.util.forIn(opt.events, function (method, event) {

						if (joint.util.isString(method)) {

							this.on('action:' + opt.name + ':' + event, this[method], this);

						} else {

							// Otherwise, it must be a function.
							this.on('action:' + opt.name + ':' + event, method);
						}

					}.bind(this));

					if (this.$handles) {
						// Render the new handle only if the entire halo has been rendered.
						// Otherwise `render()` takes care about it.
						this.renderHandle(opt).appendTo(this.$handles);
					}
				}

				return this;
			},

			/**
			 * @private
			 * @param {Object} opt
			 * @returns {jQuery}
			 */
			renderHandle: function (opt) {

				// basic handle element
				var handleIdx = this.getHandleIdx(opt.name);
				var $handle = $('<div/>')
					.addClass('handle')
					.addClass(opt.name)
					.attr('data-action', opt.name)
					.prop('draggable', false);

				switch (this.options.type) {

					case 'toolbar':
					case 'surrounding':

						// add direction to the handle, so the handle
						// can be positioned via css
						$handle.addClass(opt.position);

						if (opt.content) {
							$handle.html(opt.content);
						}

						break;

					case 'pie':

						var outerRadius = this.PIE_OUTER_RADIUS;
						var innerRadius = this.PIE_INNER_RADIUS;
						var iconRadius = (outerRadius + innerRadius) / 2;
						var center = g.point(outerRadius, outerRadius);
						var sliceRadian = g.toRad(this.options.pieSliceAngle);
						var startRadian = handleIdx * sliceRadian + g.toRad(this.options.pieStartAngleOffset);
						var stopRadian = startRadian + sliceRadian;
						var slicePathData = V.createSlicePathData(innerRadius, outerRadius, startRadian, stopRadian);

						// Create SVG elements for the slice.
						var svgRoot = V('svg').addClass('slice-svg');
						// Note that css transformation on svg elements do not work in IE.
						var svgSlice = V('path').attr('d', slicePathData).translate(outerRadius, outerRadius).addClass('slice');

						// Position the icon in the center of the slice.
						var iconPosition = g.point.fromPolar(iconRadius, -startRadian - sliceRadian / 2, center);
						var iconSize = this.options.pieIconSize;
						var svgIcon = V('image').attr(iconPosition).addClass('slice-img-icon');
						iconPosition.y = iconPosition.y + iconSize - 2;
						var svgTextIcon = V('text', { 'font-size': iconSize }).attr(iconPosition).addClass('slice-text-icon');

						// Setting the size of an SVG image via css is possible only in chrome.
						svgIcon.attr({
							width: iconSize,
							height: iconSize
						});

						// Setting a `transform` css rule on an element with a value as
						// a percentage is not possible in firefox.
						svgIcon.translate(-iconSize / 2, -iconSize / 2);
						svgTextIcon.translate(-iconSize / 2, -iconSize / 2);

						svgRoot.append([svgSlice, svgIcon, svgTextIcon]);
						$handle.append(svgRoot.node);
						break;
				}

				if (opt.icon) {
					this.setHandleIcon($handle, opt.icon);
				}

				// `opt.attrs` allows for setting arbitrary attributes on the generated HTML.
				// This object is of the form: `<selector> : { <attributeName> : <attributeValue>, ... }`
				joint.util.setAttributesBySelector($handle, opt.attrs);

				return $handle;
			},

			/**
			 * @private
			 */
			setHandleIcon: function ($handle, icon) {

				switch (this.options.type) {

					case 'pie':
						var $icon = $handle.find('.slice-img-icon');
						V($icon[0]).attr('xlink:href', icon);
						break;

					case 'toolbar':
					case 'surrounding':
						$handle.css('background-image', 'url(' + icon + ')');
						break;
				}
			},

			/**
			 * Remove all the handles from the Halo.
			 * @public
			 * @returns {joint.ui.Halo}
			 */
			removeHandles: function () {

				// Note that we cannot use `_.each()` here because `removeHandle()`
				// changes the length of the `handles` array.
				while (this.handles.length) {
					this.removeHandle(this.handles[0].name);
				}

				return this;
			},

			/**
			 * @public
			 * @param {string} name
			 * @returns {joint.ui.Halo}
			 */
			removeHandle: function (name) {

				var handleIdx = this.getHandleIdx(name);
				var handle = this.handles[handleIdx];
				if (handle) {

					joint.util.forIn(handle.events, function (method, event) {

						this.off('action:' + name + ':' + event);

					}.bind(this));

					this.$('.handle.' + name).remove();

					this.handles.splice(handleIdx, 1);
				}

				return this;
			},

			/**
			 * @public
			 * @param {string} name
			 * @param {Object} opt
			 * @returns {joint.ui.Halo}
			 */
			changeHandle: function (name, opt) {

				var handle = this.getHandle(name);
				if (handle) {

					this.removeHandle(name);
					this.addHandle(joint.util.merge({ name: name }, handle, opt));
				}

				return this;
			},

			/**
			 * @public
			 * @param {string} name
			 * @returns {boolean}
			 */
			hasHandle: function (name) {

				return this.getHandleIdx(name) !== -1;
			},

			/**
			 * @public
			 * @param {string} name
			 * @returns {string}
			 */
			getHandleIdx: function (name) {

				return joint.util.toArray(this.handles).findIndex(function (item) {
					return item.name === name;
				});
			},

			/**
			 * @public
			 * @param {string} name
			 * @returns {Object}
			 */
			getHandle: function (name) {

				return joint.util.toArray(this.handles).find(function (item) {
					return item.name === name;
				});
			},

			/**
			 * Handle selection
			 * ----------------
			 * Adds 'selected' class on certain handle.
			 * Replace the icon based on the selected state.
			 * change the selected state of a handle.
			 * selected / unselected
			 * @public
			 * @param {string} name
			 * @param {boolean} selected
			 * @returns {joint.ui.Halo}
			 */
			toggleHandle: function (name, selected) {

				var handle = this.getHandle(name);

				if (handle) {

					var $handle = this.$('.handle.' + name);

					if (selected === undefined) {
						// If no selected state is requested
						// change the current state to the opposite one.
						selected = !$handle.hasClass('selected');
					}

					$handle.toggleClass('selected', selected);

					var icon = selected ? handle.iconSelected : handle.icon;

					if (icon) {
						this.setHandleIcon($handle, icon);
					}
				}

				return this;
			},

			/**
			 * a helper to select handle
			 * @public
			 * @param {string} name
			 */
			selectHandle: function (name) {

				return this.toggleHandle(name, true);
			},

			/**
			 * a helper to unselect handle
			 * @public
			 * @param {string} name
			 */
			deselectHandle: function (name) {

				return this.toggleHandle(name, false);
			},

			/**
			 * a helper to deselect all selected handles
			 * @public
			 */
			deselectAllHandles: function () {

				joint.util.toArray(this.handles).forEach(function (handle) {
					this.deselectHandle(handle.name);
				}, this);

				return this;
			},

			/**
			 * @private
			 */
			onHandlePointerDown: function (evt) {

				this._action = $(evt.target).closest('.handle').attr('data-action');
				if (this._action) {

					evt.preventDefault();
					evt.stopPropagation();
					evt = joint.util.normalizeEvent(evt);

					var clientCoords = this.options.paper.snapToGrid({ x: evt.clientX, y: evt.clientY });
					this._localX = clientCoords.x;
					this._localY = clientCoords.y;
					this._evt = evt;

					this.triggerAction(this._action, 'pointerdown', evt, clientCoords.x, clientCoords.y);
				}
			},

			/**
			 * @private
			 */
			onPieTogglePointerDown: function (evt) {

				evt.stopPropagation();
				var $pieToggle = $(evt.target).closest('.pie-toggle');
				var toggleName = $pieToggle.attr('data-name');
				if (this.isOpen(toggleName)) {
					// The pie menu was opened with the same toggle button, toggle the state
					// for the same button which effectively closes the pie menu.
					this.toggleState(toggleName);
				} else if (this.isOpen()) {
					// If the pie menu was open by a different toggle button, close it first,
					// then open it for a different toggle button.
					this.toggleState();
					this.toggleState(toggleName);
				} else {
					// Otherwise, just open the pie menu for with that toggle button.
					this.toggleState(toggleName);
				}
			},

			/**
			 * Trigger an action on the Halo object.
			 * @private
			 * @param {string} action
			 * @param {string} eventName Abstracted JointJS event name (pointerdown, pointermove, pointerup
			 * @param {object} evt DOM event
			 */
			triggerAction: function (action, eventName, evt) {

				var args = Array.prototype.slice.call(arguments, 2);
				args.unshift('action:' + action + ':' + eventName);
				this.trigger.apply(this, args);
			},

			/**
			 * @private
			 */
			stopBatch: function () {
				this.options.graph.stopBatch('halo', { halo: this.cid });
			},

			/**
			 * @private
			 */
			startBatch: function () {
				this.options.graph.startBatch('halo', { halo: this.cid });
			},

			/**
			 * @private
			 */
			pointermove: function (evt) {

				if (!this._action) return;

				evt.preventDefault();
				evt.stopPropagation();
				evt = joint.util.normalizeEvent(evt);

				var clientCoords = this.options.paper.snapToGrid({ x: evt.clientX, y: evt.clientY });
				var dx = clientCoords.x - this._localX;
				var dy = clientCoords.y - this._localY;
				this._localX = clientCoords.x;
				this._localY = clientCoords.y;
				this._evt = evt;

				this.triggerAction(this._action, 'pointermove', evt, clientCoords.x, clientCoords.y, dx, dy);
			},

			/**
			 * @private
			 */
			pointerup: function (evt) {

				var action = this._action;
				if (!action) return;

				this._action = null;
				this._evt = null;

				var clientCoords = this.options.paper.snapToGrid({ x: evt.clientX, y: evt.clientY });
				this.triggerAction(action, 'pointerup', evt, clientCoords.x, clientCoords.y);
			},

			/**
			 * @private
			 */
			onRemove: function () {

				$(document.body).off('mousemove touchmove', this.pointermove);
				$(document).off('mouseup touchend', this.pointerup);

				if (this._action && this._evt) {
					// Finish the action if there an ongoing one exists.
					this.pointerup(this._evt);
				}

				if (this.options.graph.hasActiveBatch('halo')) {
					this.stopBatch();
				}
			},

			onSetTheme: function () {

				this.setPieIcons();
			},

			/**
			 * @private
			 */
			removeElement: function () {

				this.options.cellView.model.remove();
			},

			/**
			 * @private
			 */
			toggleUnlink: function () {

				var canUnlink = this.options.graph.getConnectedLinks(this.options.cellView.model).length > 0;

				this.$handles.children('.unlink').toggleClass('hidden', !canUnlink);
			},

			/**
			 * @private
			 */
			toggleFork: function () {

				// temporary create a clone model and its view
				var clone = this.options.cellView.model.clone();
				var cloneView = this.options.paper.createViewForModel(clone);

				// if a connection after forking would not be valid, hide the fork icon
				var canFork = this.options.paper.options.validateConnection(this.options.cellView, null, cloneView, null, 'target');

				this.$handles.children('.fork').toggleClass('hidden', !canFork);

				cloneView.remove();
				clone = null;
			},

			/**
			 * Toggles open/closed state of the halo.
			 * `toggleName` is the name of the pie toggle button as defined in `options.pieToggles`.
			 * @public
			 * @param {string} toggleName
			 */
			toggleState: function (toggleName) {

				if (!this.isRendered()) {
					return;
				}

				var $el = this.$el;

				joint.util.forIn(this.$pieToggles, function ($pieToggle) {
					$pieToggle.removeClass('open');
				});

				if (this.isOpen()) {
					this.trigger('state:close', toggleName);
					$el.removeClass('open');

				} else {
					// Note that we trigger the `state:open` event BEFORE we add
					// the `'open'` class name to the halo. The reason
					// is to give the programmer a chance to add/remove/change handles
					// in the handler for the state:open event before the handles
					// are actually made visible in the DOM.
					this.trigger('state:open', toggleName);
					if (toggleName) {

						var pieToggle = joint.util.toArray(this.options.pieToggles).find(function (toggle) {
							return toggle.name === toggleName;
						});
						if (pieToggle) {
							// Add the pie toggle position
							// to the halo container so that we can position the handles
							// based on the position of the toggle that opened it.
							// Add also the pie toggle name so that handles can be styled
							// differently based on the pie toggle that was used to open them.
							$el.attr({
								'data-pie-toggle-position': pieToggle.position,
								'data-pie-toggle-name': pieToggle.name
							});
						}
						this.$pieToggles[toggleName].addClass('open');
					}
					$el.addClass('open');
				}
			},

			/**
			 * Return true if the Halo is open. This makes sense (similar to toggleState())
			 * only for the 'pie' type of Halo.
			 * If `toggleName` is passed, return true only if the halo was opened by that specific toggle button.
			 * @public
			 * @param {string} toggleName
			 * @returns {boolean}
			 */
			isOpen: function (toggleName) {

				if (!this.isRendered()) {
					return false;
				}

				return toggleName ? this.$pieToggles[toggleName].hasClass('open') : this.$el.hasClass('open');
			},

			/**
			 * @public
			 * @returns {boolean}
			 */
			isRendered: function () {
				return this.$box !== undefined;
			}

		}, {

				// removes a halo from a paper
				clear: function (paper) {

					paper.trigger('halo:create');
				}
			});
	}(joint));


	(function (joint, _) {

		/**
		 * @typedef {{items: Array.<Object>, group: Object}} GroupedItems
		 */
		joint.ui.Toolbar = joint.mvc.View.extend({

			options: {
				/*
				 tools: [
					{group: 'groupName'}
				 ],
				 groups: {
					'name': {
						index: number,
						align: 'left' | 'right'
					}
	
				 }
				 references: {}
				 */
			},
			align: ['left', 'right'],
			className: 'toolbar',
			defaultGroup: 'default',
			widgets: [],
			groupViews: [],

			init: function () {

				this.tools = joint.util.toArray(this.options.tools);
				this.groups = this.options.groups || {};
			},

			/**
			 * @public
			 * @param {string} name
			 * @returns {Array.<joint.ui.Widget>}
			 */
			getWidgetByName: function (name) {

				return this.widgets.find(function (item) {
					return item.options.name === name;
				});
			},

			/**
			 * @public
			 * @returns {Array.<joint.ui.Widget>}
			 */
			getWidgets: function () {

				return this.widgets;
			},

			/**
			 * @private
			 * @typedef {{items: Array.<Object>, group: Object}} GroupedItems
			 * @returns {Array.<[string, GroupedItems]>}
			 */
			groupsWithItemsPairs: function () {

				var groupedItems = {};

				this.tools.forEach(function (item) {

					var group = item.group || this.defaultGroup;
					groupedItems[group] = groupedItems[group] || { items: [], group: {} };
					groupedItems[group].items.push(item);
					groupedItems[group].group = this.groups[group] || {};

				}, this);

				var keys = Object.keys(groupedItems);

				var pairs = [];
				for (var i = 0, n = keys.length; i < n; i++) {
					var key = keys[i];
					pairs.push([key, groupedItems[key]]);
				}

				var byIndex = joint.util.sortBy(pairs, function (pair) {
					return pair[1].group.index;
				});

				return joint.util.sortBy(byIndex, function (pair) {
					return pair[1].group.align || 'left';
				});
			},

			/**
			 * @public
			 * @returns {joint.ui.Toolbar}
			 */
			render: function () {

				var sortedGroups = this.groupsWithItemsPairs();
				var firstAlignRight = false;

				sortedGroups.forEach(function (groupArray) {

					var name = groupArray[0];
					var grouped = groupArray[1];
					var $group = this.renderGroup(name, grouped);

					if (!firstAlignRight && grouped.group.align && grouped.group.align === 'right') {
						firstAlignRight = true;
						$group.addClass('group-first');
					}

					$group.appendTo(this.el);

				}, this);

				return this;
			},

			/**
			 * @private
			 * @param {string} name
			 * @param {GroupedItems} grouped
			 * @returns {jQuery}
			 */
			renderGroup: function (name, grouped) {

				var groupView = new ToolbarGroupView({
					name: name,
					align: grouped.group.align,
					items: grouped.items,
					references: this.options.references
				});

				this.groupViews.push(groupView);

				groupView.on('all', function () {
					this.trigger.apply(this, arguments);
				}.bind(this));

				groupView.render();

				this.widgets = this.widgets.concat(groupView.widgets);

				return groupView.$el;
			},

			onRemove: function () {

				joint.util.invoke(this.groupViews, 'off');
				joint.util.invoke(this.groupViews, 'remove');
			}
		});

		var ToolbarGroupView = joint.mvc.View.extend({

			className: 'toolbar-group',

			init: function () {

				this.widgets = [];
			},

			onRender: function () {

				this.$el.attr('data-group', this.options.name);
				this.$el.addClass(this.options.align);
				this.renderItems();
			},

			renderItems: function () {

				joint.util.toArray(this.options.items).forEach(function (item) {
					var widget = this.createWidget(item);
					this.$el.append(widget.$el);
				}, this);
			},

			createWidget: function (item) {

				var widget = joint.ui.Widget.create(item, this.options.references);
				widget.on('all', function (eventName) {
					var data = Array.prototype.slice.call(arguments, 1);
					this.trigger.apply(this, [item.name + ':' + eventName].concat(data));
				}.bind(this));
				this.widgets.push(widget);
				return widget;
			},

			onRemove: function () {

				joint.util.invoke(this.widgets, 'off');
				joint.util.invoke(this.widgets, 'remove');
			}
		});

	}(joint, _));

	(function (joint, $) {

		joint.ui.Widget = joint.mvc.View.extend({

			className: 'widget',
			/** @type {Array.<string>} List of mandatory references, widget cannot be created if any of the reference from list
			 * is not defined in options */
			references: [],

			constructor: function (options, refs) {

				this.availableReferences = refs || {};
				joint.mvc.View.prototype.constructor.call(this, options);
			},
			/**
			 * @private
			 * Apply attributes data onto widget elements.
			 * @param {Object.<string, Object>} attrs
			 * @returns {jQuery}
			 */
			updateAttrs: function (attrs) {

				joint.util.setAttributesBySelector(this.$el, attrs);
			},

			/**
			 * @protected
			 * Override in specific widget.
			 */
			bindEvents: function () {

			},

			/**
			 * @private
			 */
			validateReferences: function () {
				var refs = this.references || [];
				var ret = [];

				refs.forEach(function (ref) {

					if (this.availableReferences[ref] === undefined) {
						ret.push(ref);
					}

				}, this);

				return ret;
			},

			/**
			 * @protected
			 * @param {string} name
			 * @returns {*}
			 */
			getReference: function (name) {
				return this.availableReferences[name];
			},

			/**
			 * @protected
			 * @returns {Array.<*>}
			 */
			getReferences: function () {
				return this.availableReferences;
			}

		}, {
				/**
				 * @param {Object} opt
				 * @param {Object?} refs references
				 * @returns {joint.ui.Widget}
				 */
				create: function (opt, refs) {

					var type = joint.util.camelCase(joint.util.isString(opt) ? opt : opt.type);

					if (!joint.util.isFunction(joint.ui.widgets[type])) {
						throw new Error('Widget: unable to find widget: "' + type + '"');
					}

					var widget = new joint.ui.widgets[type](opt, refs);

					var invalidRefs = widget.validateReferences(refs);
					if (invalidRefs.length > 0) {
						throw new Error('Widget: "' + type + '" missing dependency: ' + invalidRefs.join(', '));
					}

					widget.render();
					widget.updateAttrs(opt.attrs);
					widget.bindEvents();
					widget.$el.attr('data-type', type);

					if (opt.name) {
						widget.$el.attr('data-name', opt.name);
					}

					return widget;
				}
			});

		joint.ui.widgets = {

			checkbox: joint.ui.Widget.extend({

				tagName: 'label',
				events: {
					'change .input': 'onChange',
					'mousedown': 'pointerdown',
					'touchstart': 'pointerdown',
					'mouseup': 'pointerup',
					'touchend': 'pointerup'
				},

				init: function () {
					joint.util.bindAll(this, 'pointerup');
				},

				render: function () {

					var opt = this.options;

					var $label = $('<span/>').text(opt.label || '');
					this.$input = $('<input/>', { type: 'checkbox', 'class': 'input' }).prop('checked', !!opt.value);
					this.$span = $('<span/>');

					this.$el.append([$label, this.$input, this.$span]);

					return this;
				},

				onChange: function (evt) {
					this.trigger('change', !!evt.target.checked, evt);
				},

				pointerdown: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.$el.addClass('is-in-action');
					this.trigger('pointerdown', evt);
					$(document).on('mouseup.checkbox touchend.checkbox', this.pointerup);
				},

				pointerup: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					$(document).off('mouseup.checkbox touchend.checkbox');
					this.trigger('pointerdown', evt);
					this.$el.removeClass('is-in-action');
				}
			}),

			toggle: joint.ui.Widget.extend({
				tagName: 'label',
				events: {
					'change input.toggle': 'onChange',
					'mousedown': 'pointerdown',
					'touchstart': 'pointerdown',
					'mouseup': 'pointerup',
					'touchend': 'pointerup'
				},

				init: function () {
					joint.util.bindAll(this, 'pointerup');
				},

				render: function () {
					var opt = this.options;

					var $label = $('<span/>').text(opt.label || '');
					var $button = $('<span><i/></span>');
					var $input = $('<input/>', { type: 'checkbox', class: 'toggle' }).prop('checked', !!opt.value);
					var $wrapper = $('<div/>').addClass(opt.type);

					this.$el.append([$label, $wrapper.append($input, $button)]);

					return this;
				},

				onChange: function (evt) {
					this.trigger('change', !!evt.target.checked, evt);
				},

				pointerdown: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.$el.addClass('is-in-action');
					this.trigger('pointerdown', evt);
					$(document).on('mouseup.toggle touchend.toggle', this.pointerup);
				},

				pointerup: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					$(document).off('mouseup.toggle touchend.toggle');
					this.$el.removeClass('is-in-action');
					this.trigger('pointerup', evt);
				}
			}),

			separator: joint.ui.Widget.extend({

				render: function () {

					if (this.options.width) {
						this.$el.css({ width: this.options.width });
					}

					return this;
				}
			}),

			label: joint.ui.Widget.extend({

				tagName: 'label',

				render: function () {

					this.$el.text(this.options.text);

					return this;
				}
			}),

			range: joint.ui.Widget.extend({

				events: {
					'change .input': 'onChange',
					'input .input': 'onChange'
				},

				render: function () {

					var opt = this.options;
					var $units;

					this.$output = $('<output/>').text(opt.value);
					$units = $('<span/>').addClass('units').text(opt.unit);
					this.$input = $('<input/>', {
						type: 'range',
						name: opt.type,
						min: opt.min,
						max: opt.max,
						step: opt.step,
						'class': 'input'
					}).val(opt.value);

					this.$el.append([this.$input, this.$output, $units]);

					return this;
				},

				onChange: function (evt) {

					var value = parseInt(this.$input.val(), 10);
					if (value === this.currentValue) {
						return;
					}

					this.currentValue = value;
					this.$output.text(value);
					this.trigger('change', value, evt);
				},

				setValue: function (value) {
					this.$input.val(value);
					this.$input.trigger('change');
				}
			}),

			selectBox: joint.ui.Widget.extend({

				render: function () {

					var selectBoxOptions = joint.util.omit(this.options, 'type', 'group', 'index');

					this.selectBox = new joint.ui.SelectBox(selectBoxOptions);
					this.selectBox.render().$el.appendTo(this.el);

					return this;
				},

				bindEvents: function () {
					this.selectBox.on('all', this.trigger, this);
				}
			}),

			button: joint.ui.Widget.extend({

				events: {
					'mousedown': 'pointerdown',
					'touchstart': 'pointerdown',
					'click': 'pointerclick',
					'touchend': 'pointerclick'
				},
				tagName: 'button',

				render: function () {

					var opt = this.options;

					this.$el.text(opt.text);

					return this;
				},

				pointerclick: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.trigger('pointerclick', evt);
				},

				pointerdown: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.trigger('pointerdown', evt);
				}
			}),

			inputText: joint.ui.Widget.extend({

				events: {
					'mousedown': 'pointerdown',
					'touchstart': 'pointerdown',
					'mouseup': 'pointerup',
					'touchend': 'pointerup',
					'click': 'pointerclick',
					'focusin': 'pointerfocusin',
					'focusout': 'pointerfocusout'
				},
				tagName: 'div',

				render: function () {

					var opt = this.options;

					this.$label = $('<label/>').text(opt.label);
					this.$input = $('<div/>').addClass('input-wrapper').append($('<input/>', {
						type: 'text',
						'class': 'input'
					}).val(opt.value));

					this.$el.append([this.$label, this.$input]);

					return this;
				},

				pointerclick: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.trigger('pointerclick', evt);
				},

				pointerdown: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.trigger('pointerdown', evt);
				},

				pointerup: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.trigger('pointerup', evt);
				},

				pointerfocusin: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.$el.addClass('is-focused');
					this.trigger('pointerfocusin', evt);
				},

				pointerfocusout: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.$el.removeClass('is-focused');
					this.trigger('pointerfocusout', evt);
				}
			}),

			inputNumber: joint.ui.Widget.extend({

				events: {
					'mousedown': 'pointerdown',
					'touchstart': 'pointerdown',
					'mouseup': 'pointerup',
					'touchend': 'pointerup',
					'click': 'pointerclick',
					'focusin': 'pointerfocusin',
					'focusout': 'pointerfocusout'
				},
				tagName: 'div',

				render: function () {

					var opt = this.options;

					this.$label = $('<label/>').text(opt.label);
					this.$input = $('<div/>').addClass('input-wrapper').append($('<input/>', {
						type: 'number',
						'class': 'number',
						max: opt.max,
						min: opt.min
					}).val(opt.value));

					this.$el.append([this.$label, this.$input]);

					return this;
				},

				pointerclick: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.trigger('pointerclick', evt);
				},

				pointerdown: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.trigger('pointerdown', evt);
				},

				pointerup: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.trigger('pointerup', evt);
				},

				pointerfocusin: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.$el.addClass('is-focused');
					this.trigger('pointerfocusin', evt);
				},

				pointerfocusout: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.$el.removeClass('is-focused');
					this.trigger('pointerfocusout', evt);
				}
			}),

			textarea: joint.ui.Widget.extend({

				events: {
					'mousedown': 'pointerdown',
					'touchstart': 'pointerdown',
					'mouseup': 'pointerup',
					'touchend': 'pointerup',
					'click': 'pointerclick',
					'focusin': 'pointerfocusin',
					'focusout': 'pointerfocusout'
				},
				tagName: 'div',

				render: function () {

					var opt = this.options;

					this.$label = $('<label/>').text(opt.label);
					this.$input = $('<div/>').addClass('input-wrapper').append($('<textarea/>', {
						'class': 'textarea'
					}).text(opt.value));

					this.$el.append([this.$label, this.$input]);

					return this;
				},

				pointerclick: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.trigger('pointerclick', evt);
				},

				pointerdown: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.trigger('pointerdown', evt);
				},

				pointerup: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.trigger('pointerup', evt);
				},

				pointerfocusin: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.$el.addClass('is-focused');
					this.trigger('pointerfocusin', evt);
				},

				pointerfocusout: function (evt) {
					evt = joint.util.normalizeEvent(evt);
					this.$el.removeClass('is-focused');
					this.trigger('pointerfocusout', evt);
				}
			}),

			selectButtonGroup: joint.ui.Widget.extend({

				render: function () {

					var selectButtonGroupOptions = joint.util.omit(this.options, 'type', 'group', 'index');

					this.selectButtonGroup = new joint.ui.SelectButtonGroup(selectButtonGroupOptions);
					this.selectButtonGroup.render().$el.appendTo(this.el);

					return this;
				},

				bindEvents: function () {
					this.selectButtonGroup.on('all', this.trigger, this);
				}
			})
		};

		joint.ui.widgets.zoomIn = joint.ui.widgets.button.extend({

			references: ['paperScroller'],
			options: {
				min: 0.2,
				max: 5,
				step: 0.2
			},

			pointerdown: function (evt) {

				var opt = this.options;

				this.getReferences().paperScroller.zoom(opt.step, { max: opt.max, grid: opt.step });
				joint.ui.widgets.button.prototype.pointerdown.call(this, evt);
			}
		});

		joint.ui.widgets.zoomOut = joint.ui.widgets.button.extend({

			references: ['paperScroller'],
			options: {
				min: 0.2,
				max: 5,
				step: 0.2
			},

			pointerdown: function (evt) {

				var opt = this.options;

				this.getReferences().paperScroller.zoom(-opt.step, { min: opt.min, grid: opt.step });
				joint.ui.widgets.button.prototype.pointerdown.call(this, evt);
			}
		});

		joint.ui.widgets.zoomToFit = joint.ui.widgets.button.extend({

			references: ['paperScroller'],
			options: {
				min: 0.2,
				max: 5,
				step: 0.2
			},

			pointerdown: function (evt) {

				var opt = this.options;

				this.getReferences().paperScroller.zoomToFit({
					padding: 20,
					scaleGrid: opt.step,
					minScale: opt.min,
					maxScale: opt.max
				});
				joint.ui.widgets.button.prototype.pointerdown.call(this, evt);
			}
		});

		joint.ui.widgets.zoomSlider = joint.ui.widgets.range.extend({

			references: ['paperScroller'],
			options: {
				min: 20,
				max: 500,
				step: 20,
				value: 100,
				unit: ' %'
			},

			bindEvents: function () {

				this.on('change', function (value) {
					this.getReferences().paperScroller.zoom(value / 100, { absolute: true, grid: this.options.step / 100 });
				}, this);

				this.getReferences().paperScroller.options.paper.on('scale', function (value) {
					this.setValue(Math.floor(value * 100));
				}, this);
			}
		});

		joint.ui.widgets.undo = joint.ui.widgets.button.extend({

			references: ['commandManager'],

			pointerclick: function () {
				this.getReferences().commandManager.undo();
			}
		});

		joint.ui.widgets.redo = joint.ui.widgets.button.extend({

			references: ['commandManager'],

			pointerclick: function () {
				this.getReferences().commandManager.redo();
			}
		});

		joint.ui.widgets.fullscreen = joint.ui.widgets.button.extend({

			onRender: function () {
				var target = this.target = $(this.options.target)[0];
				if (target && !$.contains(window.top.document, target)) {
					// The fullscreen feature is available only if the target is not displayed within an iframe.
					this.$el.hide();
				}
			},

			pointerclick: function () {
				joint.util.toggleFullScreen(this.target);
			}
		});

	}(joint, $));

	// JointJS Stencil ui plugin.
	// --------------------------

	// USAGE:
	// var graph = new joint.dia.Graph;
	// var paper = new joint.dia.Paper({
	//    el: $('#paper'),
	//    width: 500,
	//    height: 300,
	//    gridSize: 20,
	//    perpendicularLinks: true,
	//    model: graph
	// });
	//
	// var stencil = new joint.ui.Stencil({ graph: graph, paper: paper });
	// $('#stencil-holder').append(stencil.render().el);


	(function (joint, util) {

		var layoutDefaults = {

			options: function () {
				return {
					columnWidth: this.options.width / 2 - 10,
					columns: 2,
					rowHeight: 80,
					resizeToFit: true,
					dy: 10,
					dx: 10
				};
			},

			/**
			 * @param {joint.dia.Graph} graph
			 * @param {Object} group Group
			 */
			layoutGroup: function (graph, group) {

				var opts = this.options.layout;
				group = group || {};

				if (!joint.layout.GridLayout) {
					throw new Error('joint.ui.Stencil: joint.layout.GridLayout is not available.');
				}

				joint.layout.GridLayout.layout(graph, util.assign({}, opts, group.layout));
			}
		};

		joint.ui.Stencil = joint.mvc.View.extend({
			className: 'stencil',
			events: {
				'click .btn-expand': 'openGroups',
				'click .btn-collapse': 'closeGroups',
				'click .groups-toggle > .group-label': 'openGroups',
				'click .group > .group-label': 'onGroupLabelClick',
				'touchstart .group > .group-label': 'onGroupLabelClick',
				'input .search': 'onSearch',
				'focusin .search': 'pointerFocusIn',
				'focusout .search': 'pointerFocusOut'
			},
			options: {
				width: 200,
				height: 800,
				label: 'Stencil',
				groups: null,
				groupsToggleButtons: false,
				dropAnimation: false,
				search: null,
				layout: null,
				// An instance of Snapline plugin which should display
				// snaplines while dragging an element from the stencil
				snaplines: null,
				// When set to `true` clone views are automatically
				// scaled based on the current paper transformations.
				// Note: this option is ignored when `snaplines` provided.
				scaleClones: false,
				/**
				 * @param {joint.dia.Cell} cell
				 * @returns {joint.dia.Cell}
				 */
				dragStartClone: function (cell) {

					return cell.clone();
				},

				/**
				 * @param {joint.dia.Cell} cell
				 * @returns {joint.dia.Cell}
				 */
				dragEndClone: function (cell) {

					return cell.clone();
				},
				/** @type {function|null} */
				layoutGroup: null,
				// The options passed into the stencil papers.
				// e.g. { elementView: CustomElementView }
				paperOptions: null
			},

			init: function () {

				this.setPaper(this.options.paperScroller || this.options.paper);

				/** @type {Object.<string, joint.dia.Graph>} */
				this.graphs = {};
				/** @type {Object.<string, joint.dia.Paper>} */
				this.papers = {};
				/** @type {Object.<string, jQuery>} */
				this.$groups = {};

				util.bindAll(this, 'onDrag', 'onDragEnd', 'onDropEnd');

				$(document.body).on('mousemove.stencil touchmove.stencil', this.onDrag);
				$(window).on('mouseup.stencil touchend.stencil', this.onDragEnd);

				this.onSearch = util.debounce(this.onSearch, 200);
				// re-delegate the debounced onSearch handler.
				this.delegateEvents();

				this.initializeLayout();
			},

			/**
			 * @private
			 */
			initializeLayout: function () {

				var layout = this.options.layout;

				if (layout) {

					if (util.isFunction(layout)) {
						this.layoutGroup = layout;
					} else {
						this.layoutGroup = layoutDefaults.layoutGroup.bind(this);
						this.options.layout = util.isObject(layout) ? layout : {};
						util.defaults(this.options.layout, layoutDefaults.options.call(this));
					}
				}
			},

			/**
			 * @public
			 * @param {joint.dia.Paper | joint.ui.PaperScroller} paper
			 */
			setPaper: function (paper) {

				var options = this.options;

				if (paper instanceof joint.dia.Paper) {

					// Allow Stencil to be initialized with a paper only.
					options.paperScroller = null;
					options.paper = paper;
					options.graph = paper.model;

				} else if (typeof joint.ui.PaperScroller === 'function' && paper instanceof joint.ui.PaperScroller) {

					// Paper is a PaperScroller
					options.paperScroller = paper;
					options.paper = paper.options.paper;
					options.graph = paper.options.paper.model;

				} else {

					throw new Error('Stencil: paper required');
				}
			},

			/**
			 * @private
			 * @returns {jQuery}
			 */
			renderContent: function () {

				return $('<div/>').addClass('content');
			},

			/**
			 * @private
			 * @returns {jQuery}
			 */
			renderPaperDrag: function () {

				return $('<div/>').addClass('stencil-paper-drag');
			},

			/**
			 * @private
			 * @returns {jQuery}
			 */
			renderSearch: function () {

				return $('<div/>').addClass('search-wrap').append($('<input/>', { type: 'search', placeholder: 'search' }).addClass('search'));
			},

			/**
			 * @private
			 * @returns {Array.<jQuery>}
			 */
			renderToggleAll: function () {

				return [
					$('<div/>').addClass('groups-toggle')
						.append($('<label/>').addClass('group-label').html(this.options.label))
						.append($('<button/>', { text: '+' }).addClass('btn btn-expand'))
						.append($('<button/>', { text: '-' }).addClass('btn btn-collapse'))
				];
			},

			/**
			 * @private
			 * @returns {jQuery}
			 */
			renderElementsContainer: function () {

				return $('<div/>').addClass('elements');
			},

			/**
			 * @private
			 * @param {Object} opt
			 * @returns {jQuery}
			 */
			renderGroup: function (opt) {

				opt = opt || {};

				var $group = $('<div/>')
					.addClass('group')
					.attr('data-name', opt.name)
					.toggleClass('closed', !!opt.closed);

				var $label = $('<h3/>')
					.addClass('group-label')
					.html(opt.label || opt.name);

				var $elements = this.renderElementsContainer();

				return $group.append($label, $elements);
			},

			/**
			 * @public
			 * @returns {joint.ui.Stencil}
			 */
			render: function () {

				var options = this.options;

				this.$content = this.renderContent();
				this.$paperDrag = this.renderPaperDrag();

				this.$el.empty().append(this.$paperDrag, this.$content);

				if (options.search) {
					this.$el.addClass('searchable').prepend(this.renderSearch());
				}

				if (options.groupsToggleButtons) {
					this.$el.addClass('collapsible').prepend(this.renderToggleAll());
				}

				var paperOptions = util.defaults({
					interactive: false,
					preventDefaultBlankAction: false
				}, options.paperOptions);

				var groups = Object.keys(options.groups || {});

				if (groups.length > 0) {

					// Render as many papers as there are groups.
					var sortedGroups = util.sortBy(groups, function (key) {
						return this[key].index;
					}.bind(options.groups));

					sortedGroups.forEach(function (name) {

						var group = this.options.groups[name];

						var $group = this.$groups[name] = this.renderGroup({
							name: name,
							label: group.label,
							closed: group.closed
						}).appendTo(this.$content);

						var groupGraph = new joint.dia.Graph;
						var groupPaperOption = util.assign({}, paperOptions, group.paperOptions, {
							el: $group.find('.elements'),
							model: groupGraph,
							width: group.width || options.width,
							height: group.height || options.height
						});
						var groupPaper = new joint.dia.Paper(groupPaperOption);

						this.graphs[name] = groupGraph;
						this.papers[name] = groupPaper;

					}, this);

				} else {

					// Groups are not used. Render just one paper for the whole stencil.
					var $elements = this.renderElementsContainer().appendTo(this.$content);

					var graph = new joint.dia.Graph;
					var paper = new joint.dia.Paper(util.assign(paperOptions, {
						el: $elements,
						model: graph,
						width: options.width,
						height: options.height
					}));

					// `this.graphs` object contains only one graph in this case that we store under the key `'__default__'`.
					this.graphs['__default__'] = graph;
					this.papers['__default__'] = paper;
				}

				// Create graph and paper objects for the, temporary, dragging phase.
				// Elements travel the following way when the user drags an element from the stencil and drops
				// it into the main, associated, paper: `[One of the Stencil graphs] -> [_graphDrag] -> [this.options.graph]`.
				this._graphDrag = new joint.dia.Graph;
				this._paperDrag = new joint.dia.Paper({

					el: this.$paperDrag,
					width: 1,
					height: 1,
					model: this._graphDrag
				});

				this.startListening();

				return this;
			},

			startListening: function () {

				this.stopListening();

				// `cell:pointerdown` on any of the Stencil papers triggers element dragging.
				util.forIn(this.papers, function (paper) {
					this.listenTo(paper, 'cell:pointerdown', this.onDragStart);
				}.bind(this));
			},

			/**
			 * @public
			 * @param {Array.<joint.dia.Element>|Object.<string, Array.<joint.dia.Element>>} cells Array of cells or hash-map
			 * of cells where key is group name.
			 * @param {string=} group
			 */
			load: function (cells, group) {

				if (Array.isArray(cells)) {

					this.loadGroup(cells, group);

				} else if (util.isObject(cells)) {

					util.forIn(this.options.groups, function (group, name) {
						if (cells[name]) {
							this.loadGroup(cells[name], name);
						}
					}.bind(this));
				}
			},

			/**
			 * @public
			 * Populate stencil with `cells`. If `group` is passed, only the graph in the named group
			 * will be populated
			 * @param {Array.<joint.dia.Element>} cells
			 * @param {string=} group Mandatory in 'group' mode  - 'options.groups' property is defined
			 */
			loadGroup: function (cells, group) {

				var graph = this.getGraph(group);

				graph.resetCells(cells);
				// If height is not defined in neither the global `options.height` or local
				// `height` for this specific group, fit the paper to the content automatically.
				var paperHeight = this.options.height;

				if (group) {
					paperHeight = this.getGroup(group).height;
				}

				if (this.isLayoutEnabled()) {
					this.layoutGroup(graph, this.getGroup(group));
				}

				if (!paperHeight) {
					var paper = this.getPaper(group);
					paper.fitToContent({
						minWidth: paper.options.width,
						gridHeight: 1,
						padding: this.options.paperPadding || 10
					});
				}
			},

			/**
			 * @private
			 * @returns {boolean}
			 */
			isLayoutEnabled: function () {

				return !!(this.options.layout);
			},

			/**
			 * @public
			 * @param {string=} group
			 * @returns {joint.dia.Graph}
			 */
			getGraph: function (group) {

				var graph = this.graphs[group || '__default__'];
				if (!graph) {
					throw new Error('Stencil: group ' + group + ' does not exist.');
				}

				return graph;
			},

			/**
			 * @public
			 * @param {string} group
			 * @returns {joint.dia.Paper}
			 */
			getPaper: function (group) {

				return this.papers[group || '__default__'];
			},

			preparePaperForDragging: function (cellView, clientX, clientY) {

				var paperDrag = this._paperDrag;
				var graphDrag = this._graphDrag;

				// Move the .stencil-paper-drag element to the document body so that even though
				// the stencil is set to overflow: hidden or auto, the .stencil-paper-drag will
				// be visible.
				paperDrag.$el.addClass('dragging').appendTo(document.body);

				var clone = this.options.dragStartClone(cellView.model).position(0, 0);

				// Leave some padding so that e.g. the cell shadow or thick border is visible.
				// This workaround can be removed once browsers start supporting getStrokeBBox() (http://www.w3.org/TR/SVG2/types.html#__svg__SVGGraphicsElement__getStrokeBBox).
				var padding = 5;

				var snaplines = this.options.snaplines;
				if (snaplines) {
					padding += snaplines.options.distance;
				}

				if (snaplines || this.options.scaleClones) {
					// Scaling the paper drag, so the clone view match the
					// size of the resulting size as would be placed in the paper.
					var paperScale = this.options.paper.scale();
					paperDrag.scale(paperScale.sx, paperScale.sy);
					padding *= Math.max(paperScale.sx, paperScale.sy);
				} else {
					// restore scale
					paperDrag.scale(1, 1);
				}

				// Make sure the previous clone has been removed before we add a new one.
				this.clearClone();
				if (this.options.dropAnimation) {
					// clear the animation after previous onDropInvalid
					this._paperDrag.$el.stop(true, true);
				}

				graphDrag.resetCells([clone.position(0, 0)]);

				var cloneView = clone.findView(paperDrag);

				// Do not automatically update the cell view while dragging.
				cloneView.stopListening();
				paperDrag.fitToContent({ padding: padding, allowNewOrigin: 'any' });

				var cloneViewBBox = cloneView.getBBox();
				var cloneGeometryBBox = this._cloneGeometryBBox = cloneView.getBBox({ useModelGeometry: true });
				this._cloneViewDeltaOrigin = cloneGeometryBBox.origin().difference(cloneViewBBox.origin());
				this._cloneBBox = clone.getBBox();
				this._clone = clone;
				this._cloneView = cloneView;
				this._paperDragPadding = padding;
				this._paperDragInitialOffset = this.setPaperDragOffset(clientX, clientY);
			},

			setPaperDragOffset: function (clientX, clientY) {

				// Safari uses `document.body.scrollTop` only while Firefox uses `document.documentElement.scrollTop` only.
				// Google Chrome is the winner here as it uses both.
				var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

				// Offset the paper so that the mouse cursor points to the center of the stencil element.
				// Also, store the original coordinates so that we know where to return if `dropAnimation` is enabled.
				var cloneViewDeltaOrigin = this._cloneViewDeltaOrigin;
				var cloneGeometryBBox = this._cloneGeometryBBox;
				var padding = this._paperDragPadding || 5;
				var paperDragOffset = {
					left: clientX - cloneViewDeltaOrigin.x - cloneGeometryBBox.width / 2 - padding,
					top: clientY - cloneViewDeltaOrigin.y - cloneGeometryBBox.height / 2 - padding + scrollTop
				};
				this._paperDrag.$el.offset(paperDragOffset);

				return paperDragOffset;
			},

			setCloneLocalPosition: function (clientX, clientY) {

				var localPosition = this.options.paper.clientToLocalPoint({ x: clientX, y: clientY });
				var cloneBBox = this._cloneBBox;

				localPosition.x -= cloneBBox.width / 2;
				localPosition.y -= cloneBBox.height / 2;

				// We don't want the clone view react on change:position change.
				// But we want processEmbedding to take the clone new position into account,
				// when it looks for models for which the clone can be embedded in.
				this._clone.set('position', localPosition);

				return localPosition;
			},

			onDragStart: function (cellView, evt) {

				evt.preventDefault();
				// Start the dragging batch
				// Batch might contain `add`, `change:parent`, `change:embeds` events.
				this.options.graph.startBatch('stencil-drag');

				this.$el.addClass('dragging');
				this.preparePaperForDragging(cellView, evt.clientX, evt.clientY);

				var localPoint = this.setCloneLocalPosition(evt.clientX, evt.clientY);
				var cloneView = this._cloneView;

				// snaplines
				var snaplines = this.options.snaplines;
				if (snaplines) {

					snaplines.captureCursorOffset(this._cloneView, evt, localPoint.x, localPoint.y);

					cloneView.listenTo(this._clone, 'change:position', this.onCloneSnapped.bind(this));
				}
			},

			onCloneSnapped: function (clone, position, opt) {
				// Snapline plugin adds `snapped` flag when changing element's position
				if (opt.snapped) {
					var cloneBBox = this._cloneBBox;
					// Set the position of the element to it's original drag paper position
					// and add the snapped offset. This is required by the view `translate` method,
					// which updates the element view position based on the model values.
					clone.position(cloneBBox.x + opt.tx, cloneBBox.y + opt.ty, { silent: true });
					this._cloneView.translate();
					// Restore the element's local position
					clone.set('position', position, { silent: true });

					this._cloneSnapOffset = { x: opt.tx, y: opt.ty };

				} else {

					this._cloneSnapOffset = null;
				}
			},

			onDrag: function (evt) {

				var cloneView = this._cloneView;
				if (cloneView) {
					evt.preventDefault();
					evt = util.normalizeEvent(evt);

					var clientX = evt.clientX;
					var clientY = evt.clientY;
					this.setPaperDragOffset(clientX, clientY);

					var localPoint = this.setCloneLocalPosition(clientX, clientY);

					var embedding = this.options.paper.options.embeddingMode;
					var snaplines = this.options.snaplines;
					var insideValidArea = (embedding || snaplines) && this.insideValidArea({ x: clientX, y: clientY });

					if (embedding) {
						if (insideValidArea) {
							cloneView.processEmbedding({ paper: this.options.paper });
						} else {
							cloneView.clearEmbedding();
						}
					}

					if (snaplines) {
						if (insideValidArea) {
							snaplines.snapWhileMoving(cloneView, evt, localPoint.x, localPoint.y);
						} else {
							snaplines.hide();
						}
					}
				}
			},

			onDragEnd: function (evt) {

				var dragClone = this._clone;
				if (dragClone) {

					evt = util.normalizeEvent(evt);

					var cloneView = this._cloneView;
					var cloneBBox = this._cloneBBox;
					var snapOffset = this._cloneSnapOffset;

					var x = cloneBBox.x;
					var y = cloneBBox.y;
					// add the element offset caused by the snaplines
					if (snapOffset) {
						x += snapOffset.x;
						y += snapOffset.y;
					}

					// Restore the original clone position if this was changed during the embedding.
					dragClone.position(x, y, { silent: true });

					var cellClone = this.options.dragEndClone(dragClone);
					var dropped = this.drop(evt, cellClone);

					if (!dropped) {

						this.onDropInvalid(evt, cellClone);

					} else {

						this.onDropEnd(dragClone);
					}

					// embedding
					if (this.options.paper.options.embeddingMode && cloneView) {
						cloneView.finalizeEmbedding({ model: cellClone, paper: this.options.paper });
					}

					// snaplines
					// it's hide on document mouseup by the plugin itself

					// End the dragging batch.
					this.options.graph.stopBatch('stencil-drag');
				}
			},

			onDropEnd: function (cellClone) {

				if (this._clone === cellClone) {

					this.clearClone();

					// Move the .stencil-paper-drag from the document body back to the stencil element.
					this.$el.append(this._paperDrag.$el);

					this.$el.removeClass('dragging');
					this._paperDrag.$el.removeClass('dragging');
				}
			},

			clearClone: function () {

				if (this._clone) {
					this._clone.remove();
					this._clone = null;
					this._cloneView = null;
					this._cloneSnapOffset = null;
					this._paperDragInitialOffset = null;
					this._paperDragPadding = null;
				}
			},

			onDropInvalid: function (evt, cellClone) {

				var clone = this._clone;
				if (clone) {

					evt = util.normalizeEvent(evt);

					cellClone = cellClone || this.options.dragEndClone(clone);

					// Tell the outside world that the drop was not successful.
					this.trigger('drop:invalid', evt, cellClone);

					var dropAnimation = this.options.dropAnimation;
					if (dropAnimation) {

						var duration = util.isObject(dropAnimation) ? dropAnimation.duration : 150;
						var easing = util.isObject(dropAnimation) ? dropAnimation.easing : 'swing';

						// clear the view immediately to prevent user's interaction on the returning shape
						this._cloneView = null;
						this._paperDrag.$el.animate(this._paperDragInitialOffset, duration, easing, this.onDropEnd.bind(this, clone));

					} else {

						this.onDropEnd(clone);
					}
				}
			},

			// Return `true` if the point `p` falls into the valid area for dropping.
			insideValidArea: function (p) {

				var paper = this.options.paper;
				var paperScroller = this.options.paperScroller;

				var stencilArea = this.getDropArea(this.$el);
				var validArea;

				if (!paperScroller) {

					// No paper scroller used. Use entire paper area.
					validArea = this.getDropArea(paper.$el);

				} else if (paperScroller.options.autoResizePaper) {

					// Paper scroller used with auto-resize enabled.
					// We can use the entire paperScroller area for drop.
					validArea = this.getDropArea(paperScroller.$el);

				} else {

					// Paper scroller used with auto-resize disabled.
					// The element can be dropped only into the visible part of the paper.
					var scrollerArea = this.getDropArea(paperScroller.$el);
					var paperArea = this.getDropArea(paper.$el);

					validArea = paperArea.intersect(scrollerArea);
				}

				// Check if the cell is dropped inside the paper but not inside the stencil.
				// Check for the stencil is here because the paper can go "below" the stencil
				// if the paper is larger than the ui.PaperScroller area.
				if (validArea && validArea.containsPoint(p) && !stencilArea.containsPoint(p)) return true;

				return false;
			},

			getDropArea: function ($el) {

				var position = $el.offset();
				var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
				var scrollLeft = document.body.scrollLeft || document.documentElement.scrollLeft;

				return g.rect({
					x: position.left + parseInt($el.css('border-left-width'), 10) - scrollLeft,
					y: position.top + parseInt($el.css('border-top-width'), 10) - scrollTop,
					width: $el.innerWidth(),
					height: $el.innerHeight()
				});
			},

			drop: function (evt, cell) {

				var paper = this.options.paper;
				var graph = this.options.graph;
				var p = { x: evt.clientX, y: evt.clientY };

				// Check if the cell is dropped inside the paper.
				if (this.insideValidArea(p)) {

					var pointTransformed = paper.clientToLocalPoint(p);
					var cellBBox = cell.getBBox();

					pointTransformed.x += cellBBox.x - cellBBox.width / 2;
					pointTransformed.y += cellBBox.y - cellBBox.height / 2;

					// Do not snap to grid if the element was previously snapped to certain position.
					var gridSize = (this._cloneSnapOffset) ? 1 : paper.options.gridSize;

					cell.set('position', {
						x: g.snapToGrid(pointTransformed.x, gridSize),
						y: g.snapToGrid(pointTransformed.y, gridSize)
					});

					// `z` level will be set automatically in the `this.graph.addCell()` method.
					// We don't want the cell to have the same `z` level as it had in the temporary paper.
					cell.unset('z');

					graph.addCell(cell, { stencil: this.cid });
					return true;
				}

				return false;
			},

			filter: function (keyword, cellAttributesMap) {

				// a searching mode when the keyword consists of lowercase only
				// e.g 'keyword' matches 'Keyword' but not other way round
				var lowerCaseOnly = keyword.toLowerCase() == keyword;

				// We go through each paper.model, filter its cells and watch whether we found a match
				// yet or not.

				var match = Object.keys(this.papers).reduce(function (wasMatch, group) {

					var paper = this.papers[group];
					// an array of cells that matches a search criteria
					var matchedCells = paper.model.get('cells').filter(function (cell) {

						var cellView = paper.findViewByModel(cell);

						// check whether the currect cell matches a search criteria
						var cellMatch = !keyword || Object.keys(cellAttributesMap).some(function (type) {
							var paths = cellAttributesMap[type];

							if (type != '*' && cell.get('type') != type) {
								// type is not universal and doesn't match the current cell
								return false;
							}

							// find out if any of specific cell attributes matches a search criteria
							var attributeMatch = paths.some(function (path) {

								var value = util.getByPath(cell.attributes, path, '/');

								if (value === undefined || value === null) {
									// if value undefined than current attribute doesn't match
									return false;
								}

								// convert values to string first (e.g value could be a number)
								value = value.toString();

								if (lowerCaseOnly) {
									value = value.toLowerCase();
								}

								return value.indexOf(keyword) >= 0;
							});

							return attributeMatch;
						});

						// each element that does not match a search has 'unmatched' css class
						V(cellView.el).toggleClass('unmatched', !cellMatch);

						return cellMatch;

					}, this);

					var isMatch = !util.isEmpty(matchedCells);

					// create a graph contains only filtered elements.
					var filteredGraph = (new joint.dia.Graph).resetCells(matchedCells);

					// let the outside world know that the group was filtered
					this.trigger('filter', filteredGraph, group, keyword);

					if (this.isLayoutEnabled()) {
						this.layoutGroup(filteredGraph, this.getGroup(group));
					}

					if (this.$groups[group]) {
						// add 'unmatched' class when filter matches no elements in the group
						this.$groups[group].toggleClass('unmatched', !isMatch);
					}

					paper.fitToContent({
						gridWidth: 1,
						gridHeight: 1,
						padding: this.options.paperPadding || 10
					});

					return wasMatch || isMatch;

				}.bind(this), false);

				// When no match found we add 'not-found' class on the stencil element
				this.$el.toggleClass('not-found', !match);
			},

			/**
			 * @private
			 * @param {string} name
			 * @returns {Object}
			 */
			getGroup: function (name) {

				return this.options.groups && this.options.groups[name] || {};
			},

			/**
			 * @private
			 * @param {jQuery.Event} evt
			 */
			onSearch: function (evt) {

				this.filter(evt.target.value, this.options.search);
			},

			/**
			 * @private
			 */
			pointerFocusIn: function () {
				this.$el.addClass('is-focused');
			},

			/**
			 * @private
			 */
			pointerFocusOut: function () {
				this.$el.removeClass('is-focused');
			},

			/**
			 * @private
			 * @param {jQuery.Event} evt
			 */
			onGroupLabelClick: function (evt) {

				// Prevent touch devices not to handle this event twice.
				// Note that both touchstart and click (evt mousedown) are fired.
				if (evt.type === 'touchstart') {
					this._groupLabelClicked = true;
				} else if (this._groupLabelClicked && evt.type === 'click') {
					this._groupLabelClicked = false;
					return;
				}

				var $group = $(evt.target).closest('.group');
				this.toggleGroup($group.data('name'));
			},

			/**
			 * @public
			 * @param {string} name
			 */
			toggleGroup: function (name) {

				this.$('.group[data-name="' + name + '"]').toggleClass('closed');
			},

			/**
			 * @public
			 * @param {string} name
			 */
			closeGroup: function (name) {

				this.$('.group[data-name="' + name + '"]').addClass('closed');
			},

			/**
			 * @public
			 * @param {string} name
			 */
			openGroup: function (name) {

				this.$('.group[data-name="' + name + '"]').removeClass('closed');
			},

			/**
			 * @public
			 * @param {string} name
			 */
			isGroupOpen: function (name) {

				return !this.$('.group[data-name="' + name + '"]').hasClass('closed');
			},

			/**
			 * @public
			 */
			closeGroups: function () {

				this.$('.group').addClass('closed');
			},

			/**
			 * @public
			 */
			openGroups: function () {

				this.$('.group').removeClass('closed');
			},

			/**
			 * @private
			 */
			onRemove: function () {

				util.invoke(this.papers, 'remove');
				this.papers = {};

				if (this._paperDrag) {
					this._paperDrag.remove();
					this._paperDrag = null;
				}

				$(document.body)
					.off('.stencil', this.onDrag)
					.off('.stencil', this.onDragEnd);
				$(window)
					.off('.stencil', this.onDragEnd);
			}
		});

	}(joint, joint.util));

	// Inspector plugin.
	// -----------------

	// This plugin creates a two-way data-binding between the cell model and a generated
	// HTML form with input fields of a type declaratively specified in an options object passed
	// into the element inspector.

	/*
	USAGE:
	
	var inspector = new joint.ui.Inspector({
		cellView: cellView,
		inputs: {
				attrs: {
					text: {
						'font-size': { type: 'number', min: 5, max: 80, group: 'text', index: 2 },
						'text': { type: 'textarea', group: 'text', index: 1 }
					}
				},
				position: {
					x: { type: 'number', group: 'geometry', index: 1 },
					y: { type: 'number', group: 'geometry', index: 2 }
				},
				size: {
					width: { type: 'number', min: 1, max: 500, group: 'geometry', index: 3 },
					height: { type: 'number', min: 1, max: 500, group: 'geometry', index: 4 }
				},
				mydata: {
					foo: { type: 'textarea', group: 'data' }
				}
	   },
	   groups: {
			   text: { label: 'Text', index: 1 },
			   geometry: { label: 'Geometry', index: 2, closed: true },
			   data: { label: 'data', index: 3 }
	   }
	});
	
	$('.inspector-container').append(inspector.render().el);
	*/

	(function (joint, util) {
		'use strict';

		joint.ui.Inspector = joint.mvc.View.extend({

			className: 'inspector',

			options: {
				cellView: undefined,    // One can pass either a cell view ...
				cell: undefined,        // ... or the cell itself.
				live: true,      // By default, we enabled live changes from the inspector inputs.
				validateInput: function (input, path, type) {
					return input.validity ? input.validity.valid : true;
				},
				renderFieldContent: undefined, // function(options, path, value) { return html }
				// Custom operators can be defined here as `function(cell, value, argument*) { return boolean; }`
				// e.g. { longerThan: function (cell, value, prop) { return value.length > cell.prop(prop); }}
				operators: {},
				multiOpenGroups: true,   // `true` if the Inspector is supposed to allow multiple open groups at the same time. Set to `false` for classical accordion.

				/**
				 * Used for logic of store/restore currently opened/stored groups.
				 * @params {joint.dia.Cell} model
				 * @returns {string}
				 * */
				stateKey: function (model) {
					return model.id;
				}
			},

			events: {
				// Custom fields need to call updateCell() explicitely
				'change [data-attribute]:not([data-custom-field])': 'onChangeInput',
				'click .group-label': 'onGroupLabelClick',
				'click .btn-list-add': 'addListItem',
				'click .btn-list-del': 'deleteListItem',
				'mousedown .field': 'pointerdown',
				'touchstart .field': 'pointerdown',
				'focusin .field': 'pointerfocusin',
				'focusout .field': 'pointerfocusout'
			},

			HTMLEntities: {
				'lt': '<',
				'gt': '>',
				'amp': '&',
				'nbsp': ' ',
				'quot': '"',
				'cent': '¢',
				'pound': '£',
				'euro': '€',
				'yen': '¥',
				'copy': '©',
				'reg': '®'
			},

			init: function () {

				var groups = this.options.groups = this.options.groups || {};

				joint.util.bindAll(this, 'stopBatchCommand', 'pointerup', 'onContentEditableBlur', 'replaceHTMLEntity');

				// List of built-in widgets (references to their views). This allows
				// us to clean up the views (call `remove()` method on them) whenever the
				// inspector need to re-render.
				this.widgets = {};

				this._attributeKeysInUse = [];

				// Flatten the `inputs` object until the level where the options object is.
				// This produces an object with this structure: { <path>: <options> }, e.g. { 'attrs/rect/fill': { type: 'color' } }
				this.flatAttributes = this.flattenInputs(this.options.inputs);

				// `_when` object maps path to a set of conditions (either `eq` or `regex`).
				// When an input under the path changes to
				// the value that equals all the `eq` values or matches all the `regex` regular expressions,
				// the inspector rerenders itself and this time includes all the
				// inputs that met the conditions.
				this._when = {};

				// `_bound` object maps a slave path to a master path (A slave is using master's data).
				// When an input under the master path changes, the inspector re-renders the input under the
				// slave path
				this._bound = {};

				// Add the attributes path the options object as we're converting the flat object to an array
				// and so we would loose the keys otherwise.
				var attributesArray = Object.keys(this.flatAttributes).map(function (path) {

					var options = this.flatAttributes[path];

					if (options.when) {

						var dependant = { expression: options.when, path: path };

						this.extractExpressionPaths(dependant.expression).forEach(function (condPath) {
							(this._when[condPath] || (this._when[condPath] = [])).push(dependant);
						}, this);
					}

					// If the option type is 'select' and its options needs resolving (is defined by path)
					// we bind the select (slave) and the input under the path (master) together.
					if (this.needsResolving(options)) {
						// slave : master
						this._bound[path] = options.options;
					}

					options.path = path;
					return options;

				}, this);

				// Add dependency paths from the groups `when` expressions. We are making sure here,
				// they are added as a key only (we're not adding them to array of inputs!)
				for (var groupName in groups) {
					var groupOptions = groups[groupName];
					if (groupOptions && groups.hasOwnProperty(groupName)) {
						this.extractExpressionPaths(groupOptions.when).forEach(function (condPath) {
							if (!this._when[condPath]) this._when[condPath] = [];
						}, this);
					}
				}

				// Sort the flat attributes object by two criteria: group first, then index inside that group.
				// As underscore 'sortBy' is a stable sort algorithm we can sort by index first and then
				// by group again.
				var sortedByIndexAttributes = util.sortBy(attributesArray, 'index');
				this.groupedFlatAttributes = util.sortBy(sortedByIndexAttributes, function (options) {
					var groupOptions = this.options.groups[options.group];
					return (groupOptions && groupOptions.index) || Number.MAX_VALUE;
				}.bind(this));

				// Listen on events on the cell.
				this.listenTo(this.getModel(), 'all', this.onCellChange, this);
			},

			// Cache all the attributes (inputs, lists and objects) with every change to the DOM tree.
			// Chache it by its path.
			cacheInputs: function () {

				var byPath = {};

				Array.from(this.$('[data-attribute]')).forEach(function (attribute) {
					var $attribute = $(attribute);
					var path = $attribute.attr('data-attribute');
					byPath[path] = $attribute;
				}, this);

				this._byPath = byPath;
				this._attributeKeysInUse = this.getAttributeKeysInUse();
			},

			updateGroupsVisibility: function () {

				var $groups = this.$groups;

				for (var i = 0, n = $groups.length; i < n; i++) {

					var $group = $($groups[i]);
					var groupName = $group.attr('data-name');
					var options = this.options.groups[groupName];

					// If a group fields are all hidden mark the group with 'empty' class name.
					var isGroupEmpty = ($group.find('> .field:not(.hidden)').length === 0);
					$group.toggleClass('empty', isGroupEmpty);

					var isGroupHidden = !!(options && options.when && !this.isExpressionValid(options.when));
					$group.toggleClass('hidden', isGroupHidden);
				}
			},

			flattenInputs: function (inputs) {
				return joint.util.flattenObject(inputs, '/', function (obj) {
					// Stop flattening when we reach an object that contains the `type` string property . We assume
					// that this is our options object.
					return (typeof obj.type === 'string');
				});
			},

			getModel: function () {
				return this.options.cell || this.options.cellView.model;
			},

			onCellChange: function (eventName, cell, change, opt) {

				opt = opt || {};

				// Do not react on changes that happened inside this inspector. This would
				// cause a re-render of the same inspector triggered by an input change in this inspector.
				if (opt.inspector == this.cid) return;

				// Note that special care is taken for all the transformation attribute changes
				// (`position`, `size` and `angle`). See below for details.

				switch (eventName) {

					case 'remove':
						// Make sure the element inspector gets removed when the cell is removed from the graph.
						// Otherwise, a zombie cell could possibly be updated.
						this.remove();
						break;
					case 'change:position':
						// Make a special case for `position` as this one is performance critical.
						// There is no need to rerender the whole inspector but only update the position input.
						this.updateInputPosition();
						break;
					case 'change:size':
						// Make a special case also for the `size` attribute for the same reasons as for `position`.
						this.updateInputSize();
						break;
					case 'change:angle':
						// Make a special case also for the `angle` attribute for the same reasons as for `position`.
						this.updateInputAngle();
						break;
					case 'change:source':
					case 'change:target':
					case 'change:vertices':
						// Make a special case also for the 'source' and 'target' of a link for the same reasons
						// as for 'position'. We don't expect source or target to be configurable.
						// That's why we do nothing here.
						break;
					default:
						// Re-render only on specific attributes changes. These are all events that starts with `'change:'`.
						// Otherwise, the re-render would be called unnecessarily (consider generic `'change'` event, `'bach:start'`, ...).
						var changeAttributeEvent = 'change:';
						if (eventName.slice(0, changeAttributeEvent.length) === changeAttributeEvent) {
							// re-render the inspector only if the changed atrribute is displayed by the inspector
							var attributeKey = eventName.slice(changeAttributeEvent.length);
							if (this._attributeKeysInUse.includes(attributeKey)) {
								this.render({ refresh: true });
							}
						}
						break;
				}
			},

			render: function (opt) {

				var refresh = (opt && opt.refresh);
				if (refresh && this.options.storeGroupsState) {
					this.storeGroupsState();
				}

				this.$el.empty();
				this.removeWidgets();

				var lastGroup;
				var groups = [];
				var $group;

				this.groupedFlatAttributes.forEach(function (options) {

					if (lastGroup !== options.group) {
						// A new group should be created.

						var groupOptions = this.options.groups[options.group];

						$group = this.renderGroup({
							name: options.group,
							label: groupOptions && groupOptions.label
						});

						if (!refresh) {
							if (groupOptions && groupOptions.closed) {
								this.closeGroup($group, { init: true });
							} else {
								this.openGroup($group, { init: true });
							}
						}

						groups.push($group);
					}

					this.renderTemplate($group, options, options.path);

					lastGroup = options.group;

				}, this);

				// cache groups

				this.$document = $(this.el.ownerDocument);
				this.$groups = $(groups);

				this.$el.append(groups);

				if (refresh && this.options.restoreGroupsState) {
					this.restoreGroupsState();
				}

				this.afterRender();

				return this;
			},

			getAttributeKeysInUse: function () {

				// all attributes used explicitely in the `inputs` definition
				var inputsAttributeKeys = Object.keys(this._byPath).map(function (path) {
					return path.substring(0, path.indexOf('/')) || path;
				});

				// all attributes that are bound by the selection `options` reference
				var boundedAttributeKeys = util.toArray(this._bound);

				// all attributes that are part of the `when` expression
				var dependantAttributeKeys = Object.keys(this._when);

				return util.uniq([].concat(inputsAttributeKeys, boundedAttributeKeys, dependantAttributeKeys));
			},

			// Get the value of the attribute at `path` based on the `options.defaultValue`,
			// and `options.valueRegExp` if present.
			getCellAttributeValue: function (path, options) {

				var cell = this.getModel();
				var value = joint.util.getByPath(cell.attributes, path, '/');

				options = options || this.flatAttributes[path];
				if (!options) return value;

				if (value === undefined && options.defaultValue !== undefined) {
					value = options.defaultValue;
				}

				if (options.valueRegExp) {

					if (value === undefined) {

						throw new Error('Inspector: defaultValue must be present when valueRegExp is used.');
					}

					var valueMatch = value.match(new RegExp(options.valueRegExp));
					value = valueMatch && valueMatch[2];
				}

				return value;
			},

			resolvableTypes: ['select', 'select-box', 'color-palette', 'select-button-group'],

			needsResolving: function (options) {

				return !!options && this.resolvableTypes.indexOf(options.type) > -1 && joint.util.isString(options.options);
			},

			resolveBindings: function (options) {

				if (this.resolvableTypes.indexOf(options.type) > -1) {

					// options['options'] are transformed here to options['items']
					var items = options.options || [];

					// resolve items if the options are defined indirectly as a reference to a model property
					if (joint.util.isString(items)) {

						items = joint.util.getByPath(this.getModel().attributes, items, '/') || [];
					}

					// Check if items array has incorrect format (i.e an array of strings).
					if (!joint.util.isObject(items[0])) {
						// Transform each array item into the { value: [value], content: [content] } object.
						items = util.toArray(items).map(function (item) {
							return { value: item, content: item };
						});
					}

					// export result as 'items'
					options.items = items;
				}

			},

			updateBindings: function (path) {

				// Find all inputs which are bound to the current input (i.e find all slaves).
				var slaves = Object.keys(this._bound).reduce(function (result, slave) {

					var master = this._bound[slave];
					// Does the current input path starts with a master path?
					if (path.indexOf(master) === 0) result.push(slave);
					return result;
				}.bind(this), []);

				if (!joint.util.isEmpty(slaves)) {

					// Re-render all slave inputs
					slaves.forEach(function (slave) {
						this.renderTemplate(null, this.flatAttributes[slave], slave, { replace: true });
					}, this);

					this.afterRender();
				}
			},

			renderFieldContent: function (options, path, value) {

				var fieldHtml;

				// Give the outside world a chance to render the field.
				// It is the responsibility of the programmer to call `updateCell()` whenever the custom field changes value.
				if (joint.util.isFunction(this.options.renderFieldContent)) {

					fieldHtml = this.options.renderFieldContent(options, path, value);
					if (fieldHtml) {
						return $(fieldHtml).attr({
							'data-attribute': path,
							'data-type': options.type,
							'data-custom-field': true
						});
					}
				}

				var widget;
				var selectedIndex;
				var originalSelection;
				var $label;

				// Note that widgets might also have special ways of reporting changed values.
				switch (options.type) {

					case 'select-box':
						selectedIndex = joint.util.toArray(options.items).findIndex(function (option) {
							if (option.value === undefined && option.content === value) return true;
							if (joint.util.isEqual(option.value, value)) return true;
							return false;
						});
						var selectBoxOptions = joint.util.assign({
							theme: this.options.theme
						}, joint.util.omit(options, 'type', 'group', 'index', 'selectBoxOptionsClass', 'options'), {
								options: options.items,
								selected: selectedIndex,
								// add special class name on select-box options that originates from the inspector
								selectBoxOptionsClass: [
									joint.util.addClassNamePrefix('inspector-select-box-options'),
									options.selectBoxOptionsClass
								].filter(function (item) {
									return !!item;
								}).join(' ')
							});
						widget = new joint.ui.SelectBox(selectBoxOptions);
						widget.$el.attr({
							'data-attribute': path,
							'data-type': options.type
						});
						widget.render();
						$label = $('<label/>', { html: options.label || path });
						fieldHtml = $('<div/>').append($label, widget.el);

						// In `previewMode`, cell gets updated when the user hovers
						// over the options in the select box. However, the final
						// value is reset only when the user selects an option.
						if (options.previewMode) {

							originalSelection = widget.selection;

							widget.on('options:mouseout close', function () {
								widget.selection = originalSelection;
								this.processInput(widget.$el, { previewCancel: true, dry: true });
							}, this);

							widget.on('option:hover', function (option, index) {
								widget.selection = option;
								// Update the cell in `dry` run. `dry` run gives hint to the
								// outside application that even though the model updated,
								// we don't have to e.g. store the change into DB.
								this.processInput(widget.$el, { dry: true });
							}, this);

							widget.on('option:select', function (option, index) {
								var originalValue = originalSelection === undefined ? undefined : widget.getSelectionValue(originalSelection);
								var newValue = widget.getSelectionValue(option);
								// If the original value equals the new value, run the update
								// in `dry` mode as there is no need to tell the outside application
								// that the model has changed (and possibly needs to be updated in e.g. a DB).
								var dry = originalValue === newValue;
								// `previewDone` is only used internally inside ui.Inspector
								// to tell the `setProperty()` method that it should trigger
								// a change event.
								this.processInput(widget.$el, {
									previewDone: true,
									dry: dry,
									originalValue: originalValue
								});
								originalSelection = option;
							}, this);

						} else {

							widget.on('option:select', function (option, index) {
								this.processInput(widget.$el);
							}, this);
						}

						this.widgets[path] = widget;
						break;

					case 'color-palette':
						selectedIndex = joint.util.toArray(options.items).findIndex(function (option) {
							if (option.value === value) return true;
							if (option.value === undefined && option.content === value) return true;
							return false;
						});
						var colorPalletteOptions = joint.util.assign({
							theme: this.options.theme
						}, joint.util.omit(options, 'type', 'group', 'index', 'options'), {
								options: options.items,
								selected: selectedIndex
							});
						widget = new joint.ui.ColorPalette(colorPalletteOptions);
						widget.$el.attr({
							'data-attribute': path,
							'data-type': options.type
						});
						widget.render();
						$label = $('<label/>', { html: options.label || path });
						fieldHtml = $('<div/>').append($label, widget.el);

						// In `previewMode`, cell gets updated when the user hovers
						// over the options in the color palette. However, the final
						// value is reset only when the user selects an option.
						if (options.previewMode) {

							originalSelection = widget.selection;

							widget.on('options:mouseout close', function () {
								widget.selection = originalSelection;
								this.processInput(widget.$el, { previewCancel: true, dry: true });
							}, this);

							widget.on('option:hover', function (option, index) {
								widget.selection = option;
								this.processInput(widget.$el, { dry: true });
							}, this);

							widget.on('option:select', function (option, index) {
								var originalValue = originalSelection === undefined ? undefined : widget.getSelectionValue(originalSelection);
								var newValue = widget.getSelectionValue(option);
								// If the original value equals the new value, run the update
								// in `dry` mode as there is no need to tell the outside application
								// that the model has changed (and possibly needs to be updated in e.g. a DB).
								var dry = (originalValue === newValue);
								// `previewDone` is only used internally inside ui.Inspector
								// to tell the `setProperty()` method that it should trigger
								// a change event.
								this.processInput(widget.$el, {
									previewDone: true,
									dry: dry,
									originalValue: originalValue
								});
								originalSelection = option;
							}, this);

						} else {

							widget.on('option:select', function (option, index) {
								this.processInput(widget.$el);
							}, this);
						}

						this.widgets[path] = widget;
						break;

					case 'select-button-group':
						if (options.multi) {
							selectedIndex = [];
							joint.util.toArray(options.items).forEach(function (option, idx) {
								var val1 = option.value === undefined ? option.content : option.value;
								var containsOption = joint.util.toArray(value).find(function (val2) {
									return joint.util.isEqual(val1, val2);
								});
								if (containsOption) {
									selectedIndex.push(idx);
								}
							});
						} else {
							selectedIndex = joint.util.toArray(options.items).findIndex(function (option) {
								if (joint.util.isEqual(option.value, value)) return true;
								if (option.value === undefined && option.content === value) return true;
								return false;
							});
						}
						var selectButtonGroupOptions = joint.util.assign({
							theme: this.options.theme
						}, joint.util.omit(options, 'type', 'group', 'index', 'options'), {
								options: options.items,
								selected: selectedIndex
							});
						widget = new joint.ui.SelectButtonGroup(selectButtonGroupOptions);
						widget.$el.attr({
							'data-attribute': path,
							'data-type': options.type
						});
						widget.render();
						$label = $('<label/>', { html: options.label || path });
						fieldHtml = $('<div/>').append($label, widget.el);

						// In `previewMode`, cell gets updated when the user hovers
						// over the options in the color palette. However, the final
						// value is reset only when the user selects an option.
						if (options.previewMode) {

							originalSelection = widget.selection;

							widget.on('mouseout', function () {
								widget.selection = originalSelection;
								this.processInput(widget.$el, { previewCancel: true, dry: true });
							}, this);

							widget.on('option:hover', function (option, index) {
								if (options.multi) {
									widget.selection = util.uniq(widget.selection.concat([option]));
								} else {
									widget.selection = option;
								}
								this.processInput(widget.$el, { dry: true });
							}, this);

							widget.on('option:select', function (selection, index) {
								var originalValue = originalSelection === undefined ? undefined : widget.getSelectionValue(originalSelection);
								var newValue = widget.getSelectionValue(selection);
								// If the original value equals the new value, run the update
								// in `dry` mode as there is no need to tell the outside application
								// that the model has changed (and possibly needs to be updated in e.g. a DB).

								var dry = joint.util.isEqual(originalValue, newValue);
								// `previewDone` is only used internally inside ui.Inspector
								// to tell the `setProperty()` method that it should trigger
								// a change event.
								this.processInput(widget.$el, {
									previewDone: true,
									dry: dry,
									originalValue: originalValue
								});
								originalSelection = selection;
							}, this);

						} else {

							widget.on('option:select', function (option, index) {
								this.processInput(widget.$el);
							}, this);
						}

						this.widgets[path] = widget;
						break;

					default:
						fieldHtml = this.renderOwnFieldContent({
							options: options,
							type: options.type,
							label: options.label || path,
							attribute: path,
							value: value
						});
				}

				return fieldHtml;
			},

			renderGroup: function (opt) {

				opt = opt || {};

				var $group = $('<div/>')
					.addClass('group')
					.attr('data-name', opt.name);

				var $label = $('<h3/>')
					.addClass('group-label')
					.text(opt.label || opt.name);

				return $group.append($label);
			},

			renderOwnFieldContent: function (opt) {

				var content, $input, $wrapper, $output, $units, $button, $nest, $label;

				$label = $('<label/>').text(opt.label);

				switch (opt.type) {

					case 'number':

						$input = $('<input/>', {
							type: 'number',
							min: opt.options.min,
							max: opt.options.max,
							step: opt.options.step
						}).val(opt.value);

						content = [$label, $('<div/>').addClass('input-wrapper').append($input)];
						break;

					case 'range':

						$label.addClass('with-output');
						$output = $('<output/>').text(opt.value);
						$units = $('<span/>').addClass('units').text(opt.options.unit);
						$input = $('<input/>', {
							type: 'range',
							name: opt.type,
							min: opt.options.min,
							max: opt.options.max,
							step: opt.options.step
						}).val(opt.value);

						$input.on('change input', function () {
							$output.text($input.val());
						});

						content = [$label, $output, $units, $input];
						break;

					case 'textarea':

						$input = $('<textarea/>').text(opt.value);

						content = [$label, $('<div/>').addClass('input-wrapper').append($input)];
						break;

					case 'content-editable':

						// replace new lines characters with new lines tags
						// and white spaces with non-breaking space
						var editableContent = joint.util.isString(opt.value)
							? opt.value.replace(/\n/g, '<br>').replace(/ /g, '&nbsp;')
							: '';

						$input = $('<div/>')
							.prop('contenteditable', true)
							.css('display', 'inline-block') // Chrome would use <div> instead of <p> for the new line otherwise.
							.html(editableContent)
							.on('blur', this.onContentEditableBlur);

						content = [$label, $('<div/>').addClass('input-wrapper').append($input)];
						break;

					case 'select':

						var items = opt.options.items;
						$input = $('<select/>');

						if (opt.options.multiple) {
							// multiple select allows specify via `size` number of items
							// to be displayed in the scrollable list.
							$input.prop({
								size: opt.options.size || items.length,
								multiple: true
							});
						}

						var selected = function (itemValue) {

							if (opt.options.multiple) {
								return joint.util.toArray(opt.value).find(function (val) {
									return joint.util.isEqual(itemValue, val);
								});
							}
							return joint.util.isEqual(itemValue, opt.value);

						};

						joint.util.toArray(items).forEach(function (item) {

							var $option = $('<option/>', { value: item.value }).text(item.content);

							if (selected(item.value)) {
								$option.attr('selected', 'selected');
							}

							$input.append($option);
						});

						content = [$label, $input];
						break;

					case 'toggle':

						$button = $('<span><i/></span>');
						$input = $('<input/>', { type: 'checkbox' }).prop('checked', !!opt.value);
						$wrapper = $('<div/>').addClass(opt.type);

						content = [$label, $wrapper.append($input, $button)];
						break;

					case 'color':

						$input = $('<input/>', { type: 'color' }).val(opt.value);

						content = [$label, $input];
						break;

					case 'text':

						$input = $('<input/>', { type: 'text' }).val(opt.value);

						content = [$label, $('<div/>').addClass('input-wrapper').append($input)];
						break;

					case 'object':

						$input = $('<div/>');
						$nest = $('<div/>').addClass('object-properties');

						content = [$label, $input.append($nest)];
						break;

					case 'list':

						$button = $('<button/>').addClass('btn-list-add').text(opt.options.addButtonLabel || '+');
						$nest = $('<div/>').addClass('list-items');
						$input = $('<div/>');

						content = [$label, $input.append($button, $nest)];
						break;
				}

				if ($input) {
					$input.addClass(opt.type).attr({
						'data-type': opt.type,
						'data-attribute': opt.attribute
					});
				}

				// A little trick how to convert an array of jQuery elements
				// to a jQuery object.
				return $.fn.append.apply($('<div>'), content).children();
			},

			onContentEditableBlur: function (evt) {

				// Workaround for Webkit content editable focus bug
				// https://gist.github.com/shimondoodkin/1081133

				var $editableFix = $('<input/>', {
					disabled: true,
					tabIndex: -1,
					style: {
						width: '1px',
						height: '1px',
						border: 'none',
						margin: 0,
						padding: 0
					}
				}).appendTo(this.$el);

				$editableFix.focus();
				$editableFix[0].setSelectionRange(0, 0);
				$editableFix.blur().remove();

				$(evt.target).trigger('change');
			},

			replaceHTMLEntity: function (entity, code) {

				return this.HTMLEntities[code] || '';
			},

			renderObjectProperty: function (opt) {

				opt = opt || {};

				var $objectProperty = $('<div/>', {
					'data-property': opt.property,
					'class': 'object-property'
				});

				return $objectProperty;
			},

			renderListItem: function (opt) {

				opt = opt || {};

				var $button = $('<button/>').addClass('btn-list-del').text(opt.options.removeButtonLabel || '-');
				var $listItem = $('<div/>', {
					'data-index': opt.index,
					'class': 'list-item'
				});

				return $listItem.append($button);
			},

			renderFieldContainer: function (opt) {

				opt = opt || {};

				var $field = $('<div/>', {
					'data-field': opt.path,
					'class': 'field ' + opt.type + '-field'
				});

				return $field;
			},

			renderTemplate: function ($el, options, path, opt) {

				$el = $el || this.$el;
				opt = opt || {};

				this.resolveBindings(options);

				// Wrap the input into a `.field` classed element so that we can easilly hide and show
				// the entire block.
				var $field = this.renderFieldContainer({ path: path, type: options.type });

				if (options.when && !this.isExpressionValid(options.when)) {
					$field.addClass('hidden');
					if (options.when.otherwise) {
						if (options.when.otherwise.unset) this.unsetProperty(path);
					}
				}

				var value = this.getCellAttributeValue(path, options);
				var $input = this.renderFieldContent(options, path, value);

				$field.append($input);

				// `options.attrs` allows for setting arbitrary attributes on the generated HTML.
				// This object is of the form: `<selector> : { <attributeName> : <attributeValue>, ... }`
				joint.util.setAttributesBySelector($field, options.attrs);

				if (options.type === 'list') {

					joint.util.toArray(value).forEach(function (itemValue, idx) {

						var $listItem = this.renderListItem({ index: idx, options: options });

						this.renderTemplate($listItem, options.item, path + '/' + idx);
						$input.children('.list-items').append($listItem);

					}, this);

				} else if (options.type === 'object') {

					options.flatAttributes = this.flattenInputs(options.properties);

					var attributesArray = Object.keys(options.flatAttributes).map(function (path) {
						var options = this[path];
						options.path = path;
						return options;
					}, options.flatAttributes);
					// Sort the attributes by `index` and assign the `path` to the `options` object
					// so that we can acess it later.
					attributesArray = util.sortBy(attributesArray, function (options) {

						return options.index;
					});

					attributesArray.forEach(function (propertyOptions) {

						var $objectProperty = this.renderObjectProperty({ property: propertyOptions.path });

						this.renderTemplate($objectProperty, propertyOptions, path + '/' + propertyOptions.path);

						$input.children('.object-properties').append($objectProperty);

					}, this);
				}

				if (opt.replace) {

					$el.find('[data-field="' + path + '"]').replaceWith($field);

				} else {

					$el.append($field);
				}
			},

			updateInputPosition: function () {

				var $inputX = this._byPath['position/x'];
				var $inputY = this._byPath['position/y'];

				var position = this.getModel().get('position');

				if ($inputX) {
					$inputX.val(position.x);
				}
				if ($inputY) {
					$inputY.val(position.y);
				}
			},

			updateInputSize: function () {

				var $inputWidth = this._byPath['size/width'];
				var $inputHeight = this._byPath['size/height'];

				var size = this.getModel().get('size');

				if ($inputWidth) {
					$inputWidth.val(size.width);
				}
				if ($inputHeight) {
					$inputHeight.val(size.height);
				}
			},

			updateInputAngle: function () {

				var $inputAngle = this._byPath['angle'];

				var angle = this.getModel().get('angle');

				if ($inputAngle) {
					$inputAngle.val(angle);
				}
			},

			validateInput: function (type, input, path) {

				// It is assumed custom widgets have their own validation setup.
				switch (type) {

					case 'select-box':
					case 'color-palette':
					case 'select-button-group':
						return true;
					default:
						return this.options.validateInput(input, path, type);
				}
			},

			onChangeInput: function (evt) {

				this.processInput($(evt.target));
			},

			processInput: function ($input, opt) {

				var path = $input.attr('data-attribute');
				var type = $input.attr('data-type');

				if (!this.validateInput(type, $input[0], path)) {
					// The input value is not valid. Do nothing.
					return;
				}

				if (this.options.live) {
					this.updateCell($input, path, opt);
				}

				var rawValue = this.getFieldValue($input[0], type);
				var value = this.parse(type, rawValue, $input[0]);

				// Notify the outside world that an input has changed.
				this.trigger('change:' + path, value, $input[0], opt);
			},

			updateDependants: function (path) {

				// Go through all the inputs that are dependent on the value of the changed input.
				// Show them if the 'when' expression is evaluated to 'true'. Hide them otherwise.
				joint.util.toArray(this._when[path]).forEach(function (dependant) {

					var $attribute = this._byPath[dependant.path];
					var $field = $attribute.closest('.field');
					var previouslyHidden = $field.hasClass('hidden');

					var valid = this.isExpressionValid(dependant.expression);

					$field.toggleClass('hidden', !valid);

					if (dependant.expression.otherwise) {
						// unset option - works only with 'live' inspector.
						if (dependant.expression.otherwise.unset && this.options.live) {

							if (!valid) {

								// When an attribute is hidden in the inspector unset its value in the model.
								this.unsetProperty(dependant.path);
								this.renderTemplate(null, this.flatAttributes[dependant.path], dependant.path, { replace: true });
								this.afterRender();

							} else if (previouslyHidden) {

								// The attribute just switched from hidden to visible. We set its value
								// to the cell again in case it was unset earlier.
								this.updateCell($attribute, dependant.path);
							}
						}
					}

				}, this);
			},

			// unset a model property
			unsetProperty: function (path, opt) {

				var cell = this.getModel();
				var pathArray = path.split('/');
				var attribute = pathArray[0];
				var nestedAttrPath = pathArray.slice(1).join('/');

				opt = opt || {};
				opt.inspector = this.cid;
				opt['inspector_' + this.cid] = true; // kept for backwards compatibility

				if (path == 'attrs') {
					// Unsetting an attrs property requires to re-render the view. The cell.removeAttr() does
					// it for us.
					cell.removeAttr(nestedAttrPath, opt);
				} else if (path == attribute) {
					// Unsetting a primitive object. Fast path.
					cell.unset(attribute, opt);
				} else {
					// Unsetting a nested property.
					var oldAttrValue = joint.util.merge({}, cell.get(attribute));
					var newAttrValue = joint.util.unsetByPath(oldAttrValue, nestedAttrPath, '/');
					cell.set(attribute, newAttrValue, opt);
				}
			},

			getOptions: function ($attribute) {

				if ($attribute.length === 0) return undefined;

				var path = $attribute.attr('data-attribute');
				var options = this.flatAttributes[path];
				if (!options) {
					var $parentAttribute = $attribute.parent().closest('[data-attribute]');
					var parentPath = $parentAttribute.attr('data-attribute');
					options = this.getOptions($parentAttribute);
					var childPath = path.replace(parentPath + '/', '');
					var parent = options;
					options = parent.item || parent.flatAttributes[childPath];
					options.parent = parent;
				}
				return options;
			},

			updateCell: function ($attr, attrPath, opt) {

				var cell = this.getModel();

				var byPath = {};

				if ($attr) {
					// We are updating only one specific attribute
					byPath[attrPath] = $attr;
				} else {
					// No parameters given. We are updating all attributes
					byPath = this._byPath;
				}

				this.startBatchCommand();

				var listsByPath = {};
				var valuesByPath = {};

				joint.util.forIn(byPath, function ($attribute, path) {

					if ($attribute.closest('.field').hasClass('hidden')) return;

					var type = $attribute.attr('data-type');
					var itemPath;
					var listPath;

					switch (type) {

						case 'list':

							// TODO: this is wrong! There could have been other properties not
							// defined in the inspector which we delete by this! We should only remove
							// those items that disappeared from DOM.

							// Do not empty the list (and trigger change event) if we have at
							// least one item in the list. It is not only desirable but necessary.
							// An example is when an element has ports. If we emptied the list
							// and then reconstructed it again, all the links connected to the ports
							// will get lost as the element with ports will think the ports disappeared
							// first.
							listPath = this.findParentListByPath(path);
							if (listPath) {
								itemPath = path.substr(listPath.length + 1);
								joint.util.setByPath(listsByPath[listPath], itemPath, [], '/');
							} else {
								listsByPath[path] = [];
							}
							break;

						case 'object':
							// For objects, all is handled in the actual inputs.
							break;

						default:

							if (!this.validateInput(type, $attribute[0], path)) return;

							var rawValue = this.getFieldValue($attribute[0], type);
							var value = this.parse(type, rawValue, $attribute[0]);
							var options = this.getOptions($attribute);

							if (options.valueRegExp) {
								var oldValue = joint.util.getByPath(cell.attributes, path, '/') || options.defaultValue;
								value = oldValue.replace(new RegExp(options.valueRegExp), '$1' + value + '$3');
							}

							listPath = this.findParentListByPath(path);

							// if the `listPath` doesn't exist the input is not nested in an array.
							// if the temporary list doesn't exist we are changing the input value only
							if (listPath && listsByPath[listPath]) {
								itemPath = path.substr(listPath.length + 1);
								joint.util.setByPath(listsByPath[listPath], itemPath, value, '/');
								return;
							}

							valuesByPath[path] = value;
							break;
					}

				}.bind(this));

				// Set all the values on the model.
				joint.util.forIn(valuesByPath, function (value, path) {
					this.setProperty(path, value, opt);
					this.updateBindings(path);
					this.updateDependants(path);
				}.bind(this));

				// Set all the arrays with all its items on the model now.
				joint.util.forIn(listsByPath, function (value, path) {
					this.setProperty(path, value, joint.util.assign({ rewrite: true }, opt));
					this.updateBindings(path);
					this.updateDependants(path);
				}.bind(this));

				this.updateGroupsVisibility();
				this.stopBatchCommand();
			},

			// Find the first list on the given path (exclude the list determined by the path itself).
			// @return path
			findParentListByPath: function (path) {

				var pathArray = path.split('/');
				var index = 0;
				var currentPath = pathArray[index];
				var currentOptions = this.flatAttributes[currentPath];
				var currentObject;
				var currentItem;

				while ((index < pathArray.length - 1) && (!currentOptions || currentOptions.type !== 'list')) {

					if (currentOptions && currentOptions.type === 'object') {
						currentObject = currentOptions.properties;
					}

					currentItem = pathArray[++index];
					currentPath += '/' + currentItem;

					// Object properties are not listed in flatAttributes array.
					// We keep the reference to the last object properties and
					// search inside that object only.
					if (currentObject) {
						currentOptions = currentObject[currentItem];
					} else {
						currentOptions = this.flatAttributes[currentPath];
					}
				}

				return currentPath !== path ? currentPath : null;
			},

			getFieldValue: function (attribute, type) {

				if (joint.util.isFunction(this.options.getFieldValue)) {

					var fieldValue = this.options.getFieldValue(attribute, type);
					if (fieldValue) {
						return fieldValue.value;
					}
				}

				var $attribute = $(attribute);

				switch (type) {
					case 'select-box':
					case 'color-palette':
					case 'select-button-group':
						var path = $attribute.attr('data-attribute');
						var view = this.widgets[path];
						if (!view) {
							// Inspector was removed. Return the current value from the model.
							return joint.dia.Cell.prototype.prop.call(this.getModel(), path);
						}
						return view.getSelectionValue();
					case 'content-editable':
						return $attribute.html()
							.replace(/<br(\s*)\/*>/ig, '\n') // replace single line-breaks
							.replace(/<[p|div]\s/ig, '\n$0') // add a line break before all div and p tags
							.replace(/(<([^>]+)>)/ig, '')    // remove any remaining tags
							.replace(/&(\w+);/ig, this.replaceHTMLEntity) // replace html entities with a plain text
							.replace(/\n$/, '');             // remove the last line-break
					default:
						return $attribute.val();
				}
			},

			setProperty: function (path, value, opt) {

				opt = opt || {};
				opt.inspector = this.cid;

				// The model doesn't have to be a JointJS cell necessarily. It could be
				// an ordinary Backbone.Model and such would have no method 'prop'.
				var prop = joint.dia.Cell.prototype.prop;
				var model = this.getModel();

				if (opt.previewDone) {
					// If we're finished with the preview mode, first set silently the model property to the value
					// before the preview mode has started. This is because we want the outside application
					// to be able to handle the end of the preview (useful when you don't want to
					// store value changes caused by preview to a DB but only want to store the
					// final value after the preview mode has finished).
					prop.call(model, path, opt.originalValue, { rewrite: true, silent: true });
				}

				if (value === undefined) {

					// Method prop can't handle undefined values in right way.
					// The model attributes would stay untouched if try to
					// set a nested property to undefined.
					joint.dia.Cell.prototype.removeProp.call(model, path, opt);

				} else {

					prop.call(model, path, joint.util.clone(value), opt);
				}
			},

			// Parse the input `value` based on the input `type`.
			// Override this method if you need your own specific parsing.
			parse: function (type, value, targetElement) {

				switch (type) {
					case 'number':
					case 'range':
						value = parseFloat(value);
						break;
					case 'toggle':
						value = targetElement.checked;
						break;
				}

				return value;
			},

			startBatchCommand: function () {

				if (!this.inBatch) {
					this.inBatch = true;
					this.getModel().startBatch('inspector', { cid: this.cid });
				}
			},

			stopBatchCommand: function () {

				if (this.inBatch) {
					this.getModel().stopBatch('inspector', { cid: this.cid });
					this.inBatch = false;
				}
			},

			afterRender: function () {
				this.cacheInputs();
				this.updateGroupsVisibility();
				this.trigger('render');
			},

			addListItem: function (evt) {

				var $target = $(evt.target);
				var $attribute = $target.closest('[data-attribute]');
				var path = $attribute.attr('data-attribute');
				var options = this.getOptions($attribute);

				// Take the index of the last list item and increase it by one.
				var $lastListItem = $attribute.children('.list-items').children('.list-item').last();
				var lastIndex = $lastListItem.length === 0 ? -1 : parseInt($lastListItem.attr('data-index'), 10);
				var index = lastIndex + 1;

				var $listItem = this.renderListItem({ index: index, options: options });

				this.renderTemplate($listItem, options.item, path + '/' + index);

				$target.parent().children('.list-items').append($listItem);
				$listItem.find('input:first').focus();

				this.afterRender();

				if (this.options.live) {
					this.updateCell();
				}
			},

			deleteListItem: function (evt) {

				var $listItem = $(evt.target).closest('.list-item');

				// Update indexes of all the following list items and their inputs.
				$listItem.nextAll('.list-item').each(function () {

					var index = parseInt($(this).attr('data-index'), 10);
					var newIndex = index - 1;

					// TODO: if field labels are not defined and the paths string are used
					// for labels instead, these are not rewritten.

					// Find all the nested inputs and update their path so that it contains the new index.
					$(this).find('[data-field]').each(function () {
						$(this).attr('data-field', $(this).attr('data-field').replace('/' + index, '/' + newIndex));
					});

					// Find all the nested inputs and update their path so that it contains the new index.
					$(this).find('[data-attribute]').each(function () {
						$(this).attr('data-attribute', $(this).attr('data-attribute').replace('/' + index, '/' + newIndex));
					});

					// Update the index of the list item itself.
					$(this).attr('data-index', newIndex);
				});

				$listItem.remove();
				this.afterRender();

				if (this.options.live) {
					this.updateCell();
				}
			},

			bindDocumentEvents: function () {
				var ns = this.getEventNamespace();
				this.$document.on('mouseup' + ns + ' touchend' + ns, this.pointerup);
			},

			unbindDocumentEvents: function () {
				this.$document.off(this.getEventNamespace());
			},

			pointerdown: function (evt) {
				this.bindDocumentEvents();
				this.startBatchCommand();
				this._$activeField = $(evt.currentTarget).addClass('is-in-action');
			},

			pointerup: function () {
				this.unbindDocumentEvents();
				// Start a batch command on `mousedown` over the inspector and stop it when the mouse is
				// released anywhere in the document. This prevents setting attributes in tiny steps
				// when e.g. a value is being adjusted through a slider. This gives other parts
				// of the application a chance to treat the serveral little changes as one change.
				// Consider e.g. the CommandManager plugin.
				this.stopBatchCommand();

				if (this._$activeField) {
					this._$activeField.removeClass('is-in-action');
					this._$activeField = null;
				}
			},

			pointerfocusin: function (evt) {
				evt.stopPropagation();
				$(evt.currentTarget).addClass('is-focused');
			},

			pointerfocusout: function (evt) {
				evt.stopPropagation();
				$(evt.currentTarget).removeClass('is-focused');
			},

			onRemove: function () {

				this.unbindDocumentEvents();
				this.removeWidgets();
				if (this === this.constructor.instance) {
					this.constructor.instance = null;
				}
			},

			removeWidgets: function () {

				var widgets = this.widgets;
				for (var path in widgets) {
					widgets[path].remove();
				}

				this.widgets = {};
			},

			onGroupLabelClick: function (evt) {

				// Prevent default action for iPad not to handle this event twice.
				evt.preventDefault();

				if (!this.options.multiOpenGroups) {
					this.closeGroups();
				}

				var $group = $(evt.target).closest('.group');
				this.toggleGroup($group);
			},

			toggleGroup: function (name) {

				var $group = joint.util.isString(name) ? this.$('.group[data-name="' + name + '"]') : $(name);

				if ($group.hasClass('closed')) {
					this.openGroup($group);
				} else {
					this.closeGroup($group);
				}
			},

			closeGroup: function (name, opt) {

				opt = opt || {};
				var $group = joint.util.isString(name) ? this.$('.group[data-name="' + name + '"]') : $(name);

				if (opt.init || !$group.hasClass('closed')) {
					$group.addClass('closed');
					this.trigger('group:close', $group.data('name'), opt);
				}
			},

			openGroup: function (name, opt) {

				opt = opt || {};
				var $group = joint.util.isString(name) ? this.$('.group[data-name="' + name + '"]') : $(name);

				if (opt.init || $group.hasClass('closed')) {
					$group.removeClass('closed');
					this.trigger('group:open', $group.data('name'), opt);
				}
			},

			closeGroups: function () {

				for (var i = 0, n = this.$groups.length; i < n; i++) {
					this.closeGroup(this.$groups[i]);
				}
			},

			openGroups: function () {

				for (var i = 0, n = this.$groups.length; i < n; i++) {
					this.openGroup(this.$groups[i]);
				}
			},

			// Expressions

			COMPOSITE_OPERATORS: ['not', 'and', 'or', 'nor'],
			PRIMITIVE_OPERATORS: ['eq', 'ne', 'regex', 'text', 'lt', 'lte', 'gt', 'gte', 'in', 'nin', 'equal'],

			_isComposite: function (expr) {

				return util.intersection(this.COMPOSITE_OPERATORS, Object.keys(expr)).length > 0;
			},

			_isPrimitive: function (expr) {

				var operators = Object.keys(this.options.operators).concat(this.PRIMITIVE_OPERATORS);
				return util.intersection(operators, Object.keys(expr)).length > 0;
			},

			_evalCustomPrimitive: function (name, value, args) {

				// Operator signature --> function(cell, value, argument*) {}
				return !!this.options.operators[name].apply(this, [this.getModel(), value].concat(args));
			},

			_evalPrimitive: function (expr) {

				return Object.keys(expr).reduce(function (res, operator) {
					var condition = expr[operator];

					return Object.keys(condition).reduce(function (res, condPath) {
						var condValue = condition[condPath];
						var val = this.getCellAttributeValue(condPath);

						// Let's check if this is a custom operator.
						if (joint.util.isFunction(this.options.operators[operator])) {
							// Note that custom operators can replace the existing primitives.
							return this._evalCustomPrimitive(operator, val, condValue);
						}

						switch (operator) {
							case 'eq':
								return condValue == val;
							case 'ne':
								return condValue != val;
							case 'regex':
								return (new RegExp(condValue)).test(val);
							case 'text':
								return !condValue || (joint.util.isString(val) && val.toLowerCase().indexOf(condValue) > -1);
							case 'lt':
								return val < condValue;
							case 'lte':
								return val <= condValue;
							case 'gt':
								return val > condValue;
							case 'gte':
								return val >= condValue;
							case 'in':
								return Array.isArray(condValue) && condValue.includes(val);
							case 'nin':
								return Array.isArray(condValue) && !condValue.includes(val);
							case 'equal':
								return joint.util.isEqual(condValue, val);
							default:
								return res;
						}

					}.bind(this), false);
				}.bind(this), false);
			},

			_evalExpression: function (expr) {

				if (this._isPrimitive(expr)) {
					return this._evalPrimitive(expr);
				}

				return Object.keys(expr).reduce(function (res, operator) {

					var childExpr = expr[operator];

					if (operator == 'not') return !this._evalExpression(childExpr);

					var childExprRes = util.toArray(childExpr).map(this._evalExpression, this);

					switch (operator) {
						case 'and':
							return childExprRes.every(function (e) {
								return !!e;
							});
						case 'or':
							return childExprRes.some(function (e) {
								return !!e;
							});
						case 'nor':
							return !childExprRes.some(function (e) {
								return !!e;
							});
						default:
							return res;
					}

				}.bind(this), false);
			},

			_extractVariables: function (expr) {

				if (Array.isArray(expr) || this._isComposite(expr)) {

					return util.toArray(expr).reduce(function (res, childExpr) {
						return res.concat(this._extractVariables(childExpr));
					}.bind(this), []);
				}

				return util.toArray(expr).reduce(function (res, primitive) {
					return Object.keys(primitive);
				}, []);
			},

			isExpressionValid: function (expr) {
				expr = joint.util.omit(expr, 'otherwise', 'dependencies');
				return this._evalExpression(expr);
			},

			extractExpressionPaths: function (expr) {

				// Additional dependencies can be defined. Useful when we using custom operators and
				// we want the input to be displayed/showed also if this dependency change.
				var dependencies = (expr && expr.dependencies) || [];

				// All other dependencies are already in the expression definition.
				expr = util.omit(expr, 'otherwise', 'dependencies');
				return util.uniq(this._extractVariables(expr).concat(dependencies));
			},

			/**
			 * @private
			 * @returns {string}
			 */
			getGroupsStateKey: function () {

				if (joint.util.isFunction(this.options.stateKey)) {
					return this.options.stateKey(this.getModel());
				}

				throw new Error('Inspector: Option stateKey must be a function');
			},

			/**
			 * @public
			 * store the current state of groups.
			 */
			storeGroupsState: function () {

				var key = this.getGroupsStateKey();
				var closedGroups = util.toArray(this.$('.group.closed'));

				joint.ui.Inspector.groupStates[key] = closedGroups.map(function (g) {
					return $(g).attr('data-name');
				});
			},

			/**
			 * @public
			 * get groups which are actually stored as closed in state. This could differ from currently rendered state.
			 * @returns {Array.<string>}
			 */
			getGroupsState: function () {

				return joint.ui.Inspector.groupStates[this.getGroupsStateKey()];
			},

			/**
			 * @public
			 * Opens/closes groups regards to the stored state.
			 */
			restoreGroupsState: function () {

				var processGroups = function (isClosed, context) {
					joint.util.forIn(context.options.groups, function (group, groupName) {
						isClosed(group, groupName) ? this.closeGroup(groupName) : this.openGroup(groupName);
					}.bind(context));
				};

				var key = this.getGroupsStateKey();

				if (joint.ui.Inspector.groupStates[key]) {
					processGroups(function (group, groupName) {
						return joint.ui.Inspector.groupStates[key].includes(groupName);
					}, this);
				} else {
					processGroups(function (group) {
						return group.closed;
					}, this);
				}
			}

		}, {

				/** @type {Object.<string, Array.<string>>} */
				groupStates: {},

				/** @type joint.ui.Inspector */
				instance: null,

				/**
				 * @param {Element|string} container Element or selector
				 * @param {Object} opt Inspector options
				 * @returns {joint.ui.Inspector}
				 */
				create: function (container, opt) {

					opt = opt || {};
					joint.util.defaults(opt, {
						restoreGroupsState: true,
						storeGroupsState: true
					});

					var cell = opt.cell || opt.cellView.model;
					var inspector = this.instance;

					// No need to re-render inspector if the cellView didn't change.
					if (!inspector || inspector.options.cell !== cell) {

						// Is there an inspector that has not been removed yet.
						// Note that an inspector can be also removed when the underlying cell is removed.
						if (inspector && inspector.el.parentNode) {

							if (opt.storeGroupsState) {
								inspector.storeGroupsState();
							}

							// Clean up the old inspector.
							inspector.updateCell();
							inspector.remove();
						}

						inspector = new this(opt).render();
						this.instance = inspector;
						$(container).html(inspector.el);

						if (opt.restoreGroupsState) {
							inspector.restoreGroupsState();
						}
					}

					return inspector;
				},

				close: function () {

					var inspector = this.instance;
					if (inspector) {
						inspector.remove();
					}
				}
			});
	}(joint, joint.util));

	joint.ui.FreeTransform = joint.mvc.View.extend({

		className: 'free-transform',

		events: {
			'mousedown .resize': 'startResizing',
			'mousedown .rotate': 'startRotating',
			'touchstart .resize': 'startResizing',
			'touchstart .rotate': 'startRotating'
		},

		DIRECTIONS: ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'],
		POSITIONS: ['top-left', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left'],

		options: {
			cellView: undefined,
			rotateAngleGrid: 15,
			preserveAspectRatio: false,
			minWidth: 0,
			minHeight: 0,
			maxWidth: Infinity,
			maxHeight: Infinity,
			allowOrthogonalResize: true,
			allowRotation: true,
			clearAll: true,
			clearOnBlankPointerdown: true
		},

		init: function () {

			var options = this.options;
			if (options.cellView) {
				// The freetransform can be initalized by passing a single cellView option or
				// historically by passing all required references (cell, paper & graph).
				joint.util.defaults(options, {
					cell: options.cellView.model,
					paper: options.cellView.paper,
					graph: options.cellView.paper.model
				});
			}

			joint.util.bindAll(this, 'update', 'remove', 'pointerup', 'pointermove');

			var paper = options.paper;
			var graph = options.graph;

			if (options.clearAll) {
				// Remove any existing freetransforms.
				this.constructor.clear(paper);
			}

			// Register mouse events.
			$(document.body).on('mousemove touchmove', this.pointermove);
			$(document).on('mouseup touchend', this.pointerup);

			// Update the freeTransform when the graph is changed.
			this.listenTo(graph, 'all', this.update);
			this.listenTo(paper, 'scale translate', this.update);

			// Remove the freeTransform when the model is removed.
			this.listenTo(graph, 'reset', this.remove);
			this.listenTo(options.cell, 'remove', this.remove);

			if (options.clearOnBlankPointerdown) {
				// Hide the freeTransform when the user clicks anywhere in the paper
				this.listenTo(paper, 'blank:pointerdown', this.remove);
			}

			paper.$el.append(this.el);

			// Register this freetransform instance.
			this.constructor.registerInstanceToPaper(this, paper);
		},

		renderHandles: function () {

			var $handleTemplate = $('<div/>').prop('draggable', false);
			var $rotateHandle = $handleTemplate.clone().addClass('rotate');
			var $resizeHandles = this.POSITIONS.map(function (position) {
				return $handleTemplate.clone().addClass('resize').attr('data-position', position);
			});

			this.$el.empty().append($resizeHandles, $rotateHandle);
		},

		render: function () {

			this.renderHandles();

			// We have to use `attr` as jQuery `data` doesn't update DOM
			this.$el.attr('data-type', this.options.cell.get('type'));

			// Note that preserve aspect ratio option enabled implicates no resize handles on the sides.
			this.$el.toggleClass('no-orthogonal-resize', this.options.preserveAspectRatio || !this.options.allowOrthogonalResize);

			this.$el.toggleClass('no-rotation', !this.options.allowRotation);

			this.update();
		},

		update: function () {

			var viewportCTM = this.options.paper.matrix();

			var bbox = this.options.cell.getBBox();

			// Calculate the free transform size and position in viewport coordinate system.
			// TODO: take a viewport rotation in account.
			bbox.x *= viewportCTM.a;
			bbox.x += viewportCTM.e;
			bbox.y *= viewportCTM.d;
			bbox.y += viewportCTM.f;
			bbox.width *= viewportCTM.a;
			bbox.height *= viewportCTM.d;

			var angle = g.normalizeAngle(this.options.cell.get('angle') || 0);

			var transformVal = 'rotate(' + angle + 'deg)';

			this.$el.css({
				'width': bbox.width + 4,
				'height': bbox.height + 4,
				'left': bbox.x - 3,
				'top': bbox.y - 3,
				'transform': transformVal,
				'-webkit-transform': transformVal, // chrome + safari
				'-ms-transform': transformVal // IE 9
			});

			// Update the directions on the halo divs while the element being rotated. The directions are represented
			// by cardinal points (N,S,E,W). For example the div originally pointed to north needs to be changed
			// to point to south if the element was rotated by 180 degrees.
			var shift = Math.floor(angle * (this.DIRECTIONS.length / 360));

			if (shift != this._previousDirectionsShift) {

				// Create the current directions array based on the calculated shift.
				var directions = this.DIRECTIONS.slice(shift).concat(this.DIRECTIONS.slice(0, shift));

				// Apply the array on the halo divs.
				this.$('.resize').removeClass(this.DIRECTIONS.join(' ')).each(function (index, el) {
					$(el).addClass(directions[index]);
				});

				this._previousDirectionsShift = shift;
			}
		},

		calculateTrueDirection: function (relativeDirection) {

			var cell = this.options.cell;
			var normalizedAngle = g.normalizeAngle(cell.get('angle'));
			var trueDirectionIndex = this.POSITIONS.indexOf(relativeDirection);

			trueDirectionIndex += Math.floor(normalizedAngle * (this.POSITIONS.length / 360));
			trueDirectionIndex %= this.POSITIONS.length;

			return this.POSITIONS[trueDirectionIndex];
		},

		startResizing: function (evt) {

			evt.stopPropagation();

			this.options.graph.startBatch('free-transform', { freeTransform: this.cid });

			// Target's data attribute can contain one of 8 positions. Each position defines the way how to
			// resize an element. Whether to change the size on x-axis, on y-axis or on both.

			// The direction relative to itself.
			var relativeDirection = $(evt.target).data('position');
			var trueDirection = this.calculateTrueDirection(relativeDirection);
			var rx = 0;
			var ry = 0;

			relativeDirection.split('-').forEach(function (singleDirection) {

				rx = { 'left': -1, 'right': 1 }[singleDirection] || rx;
				ry = { 'top': -1, 'bottom': 1 }[singleDirection] || ry;
			});

			// The direction has to be one of the 4 directions the element's resize method would accept (TL,BR,BL,TR).
			var direction = this.toValidResizeDirection(relativeDirection);

			// The selector holds a function name to pick a corner point on a rectangle.
			// See object `rect` in `src/geometry.js`.
			var selector = {
				'top-right': 'bottomLeft',
				'top-left': 'corner',
				'bottom-left': 'topRight',
				'bottom-right': 'origin'
			}[direction];

			// Expose the initial setup, so `pointermove` method can access it.
			this._initial = {
				angle: g.normalizeAngle(this.options.cell.get('angle') || 0),
				resizeX: rx, // to resize, not to resize or flip coordinates on x-axis (1,0,-1)
				resizeY: ry, // to resize, not to resize or flip coordinates on y-axis (1,0,-1)
				selector: selector,
				direction: direction,
				relativeDirection: relativeDirection,
				trueDirection: trueDirection
			};

			this._action = 'resize';

			this.startOp(evt.target);
		},

		toValidResizeDirection: function (direction) {

			return {
				'top': 'top-left',
				'bottom': 'bottom-right',
				'left': 'bottom-left',
				'right': 'top-right'
			}[direction] || direction;
		},

		startRotating: function (evt) {

			evt.stopPropagation();

			this.options.graph.startBatch('free-transform', { freeTransform: this.cid });

			var center = this.options.cell.getBBox().center();

			var clientCoords = this.options.paper.snapToGrid({ x: evt.clientX, y: evt.clientY });

			// Expose the initial setup, so `pointermove` method can acess it.
			this._initial = {
				// the centre of the element is the centre of the rotation
				centerRotation: center,
				// an angle of the element before the rotating starts
				modelAngle: g.normalizeAngle(this.options.cell.get('angle') || 0),
				// an angle between the line starting at mouse coordinates, ending at the center of rotation
				// and y-axis
				startAngle: g.point(clientCoords).theta(center)
			};

			this._action = 'rotate';

			this.startOp(evt.target);
		},

		pointermove: function (evt) {

			if (!this._action) return;

			evt = joint.util.normalizeEvent(evt);

			var options = this.options;
			var clientCoords = options.paper.snapToGrid({ x: evt.clientX, y: evt.clientY });
			var gridSize = options.paper.options.gridSize;
			var model = options.cell;
			var i = this._initial;

			switch (this._action) {

				case 'resize':
					var currentRect = model.getBBox();

					// The requested element's size has to be find on the unrotated element. Therefore we
					// are rotating a mouse coordinates back (coimageCoords) by an angle the element is rotated by and
					// with the center of rotation equals to the center of the unrotated element.
					var coimageCoords = g.point(clientCoords).rotate(currentRect.center(), i.angle);

					// The requested size is the difference between the fixed point and coimaged coordinates.
					var requestedSize = coimageCoords.difference(currentRect[i.selector]());

					// Calculate the new dimensions. `resizeX`/`resizeY` can hold a zero value if the resizing
					// on x-axis/y-axis is not allowed.
					var width = i.resizeX ? requestedSize.x * i.resizeX : currentRect.width;
					var height = i.resizeY ? requestedSize.y * i.resizeY : currentRect.height;

					// Fitting into a grid
					width = g.snapToGrid(width, gridSize);
					height = g.snapToGrid(height, gridSize);
					// Minimum
					width = Math.max(width, options.minWidth || gridSize);
					height = Math.max(height, options.minHeight || gridSize);
					// Maximum
					width = Math.min(width, options.maxWidth);
					height = Math.min(height, options.maxHeight);

					if (options.preserveAspectRatio) {

						var candidateWidth = currentRect.width * height / currentRect.height;
						var candidateHeight = currentRect.height * width / currentRect.width;

						candidateWidth > width ? (height = candidateHeight) : (width = candidateWidth);
					}

					// Resize the element only if the dimensions are changed.
					if (currentRect.width != width || currentRect.height != height) {

						model.resize(width, height, {
							freeTransform: this.cid,
							direction: i.direction,
							relativeDirection: i.relativeDirection,
							trueDirection: i.trueDirection,
							ui: true,
							// The rest of properties are important for the Snapline plugin.
							minWidth: options.minWidth,
							minHeight: options.minHeight,
							maxWidth: options.maxWidth,
							maxHeight: options.maxHeight,
							preserveAspectRatio: options.preserveAspectRatio
						});
					}
					break;

				case 'rotate':
					// Calculate an angle between the line starting at mouse coordinates, ending at the centre
					// of rotation and y-axis and deduct the angle from the start of rotation.
					var theta = i.startAngle - g.point(clientCoords).theta(i.centerRotation);

					model.rotate(g.snapToGrid(i.modelAngle + theta, options.rotateAngleGrid), true);
					break;
			}
		},

		pointerup: function (evt) {

			if (!this._action) return;

			this.stopOp();

			this.options.graph.stopBatch('free-transform', { freeTransform: this.cid });

			this._action = null;
			this._initial = null;
		},

		onRemove: function () {

			$(document.body).off('mousemove touchmove', this.pointermove);
			$(document).off('mouseup touchend', this.pointerup);

			joint.ui.FreeTransform.unregisterInstanceFromPaper(this, this.options.paper);
		},

		startOp: function (el) {

			if (el) {
				// Add a class to the element we are operating with
				$(el).addClass('in-operation');
				this._elementOp = el;
			}

			this.$el.addClass('in-operation');
		},

		stopOp: function () {

			if (this._elementOp) {
				// Remove a class from the element we were operating with
				$(this._elementOp).removeClass('in-operation');
				this._elementOp = null;
			}

			this.$el.removeClass('in-operation');
		}

	}, {

			instancesByPaper: {},

			// Removes all freetransforms from the paper.
			clear: function (paper) {

				// Keep this for backwards compatibility.
				paper.trigger('freetransform:create');

				this.removeInstancesForPaper(paper);
			},

			removeInstancesForPaper: function (paper) {

				joint.util.invoke(this.getInstancesForPaper(paper), 'remove');
			},

			getInstancesForPaper: function (paper) {

				return this.instancesByPaper[paper.cid] || {};
			},

			registerInstanceToPaper: function (instance, paper) {

				this.instancesByPaper[paper.cid] || (this.instancesByPaper[paper.cid] = {});
				this.instancesByPaper[paper.cid][instance.cid] = instance;
			},

			unregisterInstanceFromPaper: function (instance, paper) {

				if (this.instancesByPaper[paper.cid]) {
					this.instancesByPaper[paper.cid][instance.cid] = null;
				}
			}
		});

	joint.ui.Tooltip = joint.mvc.View.extend({

		className: 'tooltip',

		options: {
			// `left` allows you to set a selector (or DOM element) that
			// will be used as the left edge of the tooltip. This is useful when configuring a tooltip
			// that should be shown "after" some other element. Other sides are analogous.
			/** @deprecated use position: 'left' instead. This value is used when 'position' is not defined. Ignored if defined on element.  */
			left: undefined,
			/** @deprecated use position: 'right' instead. This value is used when 'position' is not defined. Ignored if defined on element.  */
			right: undefined,
			/** @deprecated use position: 'top' instead. This value is used when 'position' is not defined. Ignored if defined on element. */
			top: undefined,
			/** @deprecated use position: 'bottom' instead. This value is used when 'position' is not defined. Ignored if defined on element. */
			bottom: undefined,

			/** @type {string|function(element)} */
			position: undefined,

			/** @type {string|function(element)} */
			positionSelector: undefined,

			/** @type {string|function(element)} Tooltip arrow direction, could be 'left', 'right', 'top', 'bottom' and 'auto'.
			 * 'auto' sets the arrow accordingly 'position' property.
			 * Arrows are disabled if 'direction' is 'undefined', 'null' or 'off'.
			 * */
			direction: 'auto',

			/**
			 * Minimal width of the tooltip. Tooltip width can be resized down to the `minResizedWidth`. If available space is smaller
			 * than `minResizedWidth`, direction of the tooltip is changed to its opposite direction (left tooltip is swapped to right,
			 * top to bottom and vice versa). `minResizedWidth:0` means no resizing, no direction swapping.
			 * @type {number}
			 */
			minResizedWidth: 100,

			/** @type {number|function(element)} */
			padding: 0,

			/** @type {String} */
			rootTarget: null,

			/** @type {String} */
			target: null,

			/** @type {string} */
			trigger: 'hover',

			/** @type {{selector: String, padding: number}} */
			viewport: {
				selector: null,
				padding: 0
			},

			/** @type {string} */
			dataAttributePrefix: 'tooltip',

			/** @type {string} */
			template: '<div class="tooltip-arrow"/><div class="tooltip-arrow-mask"/><div class="tooltip-content"/>'
		},

		init: function () {

			this.eventNamespace = ('.' + this.className + this.cid).replace(/ /g, '_');

			/**
			 * Specific for each tooltip - merged global options with tooltip's options from html attrs.
			 * @type {object}
			 */
			this.settings = {};

			var triggers = this.options.trigger.split(' ');

			joint.util.bindAll(this, 'render', 'hide', 'show', 'toggle', 'isVisible', 'position');

			if (this.options.rootTarget) {

				this.$rootTarget = $(this.options.rootTarget);

				triggers.forEach(function (trigger) {

					switch (trigger) {

						case 'click':
							this.$rootTarget.on('click' + this.eventNamespace, this.options.target, this.toggle);
							break;

						case 'hover':
							this.$rootTarget.on('mouseover' + this.eventNamespace, this.options.target, this.render);
							break;

						case 'focus':
							this.$rootTarget.on('focusin' + this.eventNamespace, this.options.target, this.render);
							break;
					}

				}, this);

			} else {

				this.$target = $(this.options.target);

				triggers.forEach(function (trigger) {

					switch (trigger) {

						case 'click':
							this.$target.on('click' + this.eventNamespace, this.toggle);
							break;

						case 'hover':
							this.$target.on('mouseover' + this.eventNamespace, this.render);
							break;

						case 'focus':
							this.$target.on('focusin' + this.eventNamespace, this.render);
							break;

					}
				}, this);
			}

			this.$el.append(this.options.template);
		},

		/**
		 * @private
		 */
		onRemove: function () {

			// Detach events listeners
			if (this.options.rootTarget) {
				this.$rootTarget.off(this.eventNamespace);
			} else {
				this.$target.off(this.eventNamespace);
			}
		},

		/**
		 * @public
		 */
		hide: function () {

			var settings = this.settings;

			if (!settings) {
				return;
			}

			this.unbindHideActions(settings.currentTarget);

			this.$el.removeClass(settings.className);
			this.$el.remove();
		},

		/**
		 * @public
		 * @param {jQuery.Event=} evt
		 */
		show: function (evt) {

			this.render(evt || { target: this.options.target });
		},

		/**
		 * @public
		 * @param {jQuery.Event=} evt
		 */
		toggle: function (evt) {

			if (this.isVisible()) {
				this.hide();
			} else {
				this.show(evt);
			}
		},

		/**
		 * @public
		 */
		isVisible: function () {

			// Check if tooltip is in the DOM
			return document.body.contains(this.el);
		},

		/**
		 * @public
		 * @param {{target: string|Element}|{x:number, y:number}} evt
		 */
		render: function (evt) {

			var point = evt.x !== undefined && evt.y !== undefined ? evt : null;
			var element = $(evt.target).closest(this.options.target)[0];

			var settings = this.settings = this.getTooltipSettings(element);
			settings.currentTarget = element;

			this.bindHideActions(element);

			var targetBBox;
			if (point) {
				targetBBox = { x: point.x, y: point.y, width: 1, height: 1 };
			} else {
				targetBBox = joint.util.getElementBBox(element);
			}

			this.$('.tooltip-content').html(settings.content);

			// Hide the element first so that we don't get a jumping effect during the image loading.
			this.$el.hide();
			this.$el.removeClass('left right top bottom');
			this.$el.addClass(settings.className);

			$(document.body).append(this.$el);

			// If there is an image in the `content`, wait till it's loaded as only after that
			// we know the dimension of the tooltip.
			var $images = this.$('img');
			if ($images.length) {

				$images.on('load', function () {
					this.position(targetBBox);
					this.$el.addClass('rendered');
				}.bind(this));

			} else {
				this.position(targetBBox);
				this.$el.addClass('rendered');
			}
		},

		/**
		 * @param el {Element}
		 * @returns {Object}
		 */
		getTooltipSettings: function (el) {

			var elementDefinition = this.loadDefinitionFromElementData(el);
			return this.evaluateOptions(el, elementDefinition);
		},

		/**
		 * @private
		 * @param {Element} element
		 */
		unbindHideActions: function (element) {

			var hideActionsNamespace = this.eventNamespace + '.remove';

			$(element).off(hideActionsNamespace);
			clearInterval(this.interval);
		},

		/**
		 * @private
		 * Checks if tooltip's target element is still in dom. Hides tooltip when target element is removed.
		 * @param {Element} element
		 */
		bindHideOnRemoveTarget: function (element) {

			clearInterval(this.interval);
			this.interval = setInterval(function () {

				if (!$.contains(document, element)) {
					clearInterval(this.interval);
					this.hide();
				}
			}.bind(this), 500);
		},

		/**
		 * @private
		 * @param {Element} element
		 */
		bindHideActions: function (element) {

			var settings = this.settings;

			var $element = $(element);
			var hideActionsNamespace = this.eventNamespace + '.remove';

			this.bindHideOnRemoveTarget(element);

			this.options.trigger.split(' ').forEach(function (trigger) {

				var hideEvents = {
					'hover': ['mouseout', 'mousedown'],
					'focus': ['focusout']
				};

				var events = hideEvents[trigger] || [];
				if (settings.hideTrigger) {
					events = settings.hideTrigger.split(' ') || [];
				}

				events.forEach(function (eventName) {
					$element.on(eventName + hideActionsNamespace, this.hide);
				}, this);

			}, this);
		},

		/**
		 * @private
		 * get options from element data, normalize deprecated definition.
		 * @param {Element} element
		 * @param {Object} elementDefinition
		 * @returns {Object}
		 */
		evaluateOptions: function (element, elementDefinition) {

			elementDefinition = elementDefinition || {};

			var settings = joint.util.assign({}, elementDefinition, this.options);

			joint.util.forIn(settings, function (value, key) {
				var evaluated = joint.util.isFunction(value) ? value(element) : value;
				settings[key] = evaluated === undefined || evaluated === null ? elementDefinition[key] : evaluated;
			});

			this.normalizePosition(settings);
			return settings;
		},

		/**
		 * @private
		 * @param {Element} element
		 * @returns {Object}
		 */
		loadDefinitionFromElementData: function (element) {

			if (!element) {
				return {};
			}

			var isIgnored = function (key) {

				return key === 'left' || key === 'bottom' || key === 'top' || key === 'right';
			};

			var data = this.getAllAttrs(element, 'data-' + this.options.dataAttributePrefix);
			var options = {};

			joint.util.forIn(data, function (value, key) {

				if (key === '') {
					key = 'content';
				}

				if (!isIgnored(key)) {
					options[key] = value;
				}
			});

			return options;
		},

		/**
		 * @private
		 * @param {Element} element
		 * @param {string} namePrefix
		 * @returns {{string:*}}
		 */
		getAllAttrs: function (element, namePrefix) {

			var prefix = namePrefix || '';
			var attrs = element.attributes;
			var dataAttrs = {};


			for (var i = 0, n = attrs.length; i < n; i++) {
				var attr = attrs[i];

				if (attr && attr.name.startsWith(prefix)) {
					var name = joint.util.camelCase(attr.name.slice(prefix.length));
					dataAttrs[name] = attr.value;
				}
			}
			return dataAttrs;
		},

		/**
		 * @private
		 * modifies the options, use deprecated properties if needed.
		 * @param {Object} options
		 */
		normalizePosition: function (options) {

			var deprecatedDefinition = options.left || options.right || options.top || options.bottom;

			if (!options.position && deprecatedDefinition) {
				if (options.left) {
					options.position = 'left';
				}
				if (options.right) {
					options.position = 'right';
				}
				if (options.top) {
					options.position = 'top';
				}
				if (options.bottom) {
					options.position = 'bottom';
				}
			}

			if (!options.positionSelector && deprecatedDefinition) {
				options.positionSelector = deprecatedDefinition;
			}
		},

		/**
		 * @private
		 * @param {rect} targetBBox
		 */
		position: function (targetBBox) {

			var settings = this.settings;

			// Show the tooltip. Do this before we ask for its dimension, otherwise they won't be defined yet.
			this.$el.show();
			this.$el.css('width', 'auto');

			// No Selector => Get BBox of the body element.
			var viewport = this.getViewportViewBBox();

			var tooltipBBox = this.getTooltipBBox(targetBBox, viewport);

			var arrowPosition = {};

			//Arrow to the middle (vertical/horizontal) of the targetElement
			if (settings.position === 'left' || settings.position === 'right') {
				arrowPosition.top = targetBBox.y + targetBBox.height / 2 - tooltipBBox.y;
			} else if (settings.position === 'top' || settings.position === 'bottom') {
				arrowPosition.left = targetBBox.x + targetBBox.width / 2 - tooltipBBox.x;
			} else {
				//As if `options.left` was set to the target element.
				arrowPosition.top = targetBBox.y + targetBBox.height / 2 - tooltipBBox.y;
			}

			// Move the tooltip to the right position
			this.$el.css({
				left: tooltipBBox.x,
				top: tooltipBBox.y,
				width: tooltipBBox.width || 'auto'
			});

			var $arrows = this.$('.tooltip-arrow, .tooltip-arrow-mask');

			// Reset style of previous tooltip
			$arrows.removeAttr('style');
			// Move the arrow
			$arrows.css(arrowPosition);

			if (settings.direction && settings.direction !== 'off') {
				this.$el.addClass(settings.direction === 'auto' ? (settings.position || 'left') : settings.direction);
			}
		},

		getViewportViewBBox: function () {

			var settings = this.settings;

			var el = settings.viewport.selector ? $(settings.currentTarget).closest(settings.viewport.selector) : 'html';

			var viewportBBox = joint.util.getElementBBox(el);

			// No Selector => Get browser window size.
			// note: 'html' doesn't return a full window height.
			// but returns 0 if body elements have position: absolute.
			var $window = $(window);
			if (!settings.viewport.selector) {
				viewportBBox.width = $window.width() + $window.scrollLeft();
				viewportBBox.height = $window.height() + $window.scrollTop();
			}

			var viewportPadding = settings.viewport.padding || 0;
			viewportBBox.x += viewportPadding;
			viewportBBox.y += viewportPadding;
			viewportBBox.width -= 2 * viewportPadding;
			viewportBBox.height -= 2 * viewportPadding;

			return viewportBBox;
		},

		getPosition: function (positionedBBox, targetBBox, bBox, viewport) {

			var settings = this.settings;
			var type = settings.position || 'left';
			var padding = settings.padding;
			var minWidth = Math.min(settings.minResizedWidth, bBox.width + padding);

			var map = {
				left: function (manipulable) {

					var position = {
						x: positionedBBox.x + positionedBBox.width + padding,
						y: targetBBox.y + targetBBox.height / 2 - bBox.height / 2
					};

					if (manipulable) {

						var availableSize = viewport.x + viewport.width - (position.x);

						if (availableSize > minWidth && availableSize < bBox.width + padding) {
							position.width = availableSize;
						}

						if (availableSize < minWidth) {
							settings.position = 'right';
							return this.right(false);
						}
					}

					return position;
				},
				right: function (manipulable) {

					var position = {
						x: positionedBBox.x - bBox.width - padding,
						y: targetBBox.y + targetBBox.height / 2 - bBox.height / 2
					};

					if (manipulable) {

						var availableSize = positionedBBox.x - padding - viewport.x;

						if (availableSize > minWidth && availableSize < bBox.width + padding) {
							position.width = availableSize;
							position.x = viewport.x;
						}

						if (availableSize < minWidth) {
							settings.position = 'left';
							return this.left(false);
						}
					}

					return position;

				},
				top: function (manipulable) {

					var position = {
						x: targetBBox.x + targetBBox.width / 2 - bBox.width / 2,
						y: positionedBBox.y + positionedBBox.height + padding
					};

					if (manipulable) {

						var availableSize = (viewport.y + viewport.height) - (positionedBBox.y + positionedBBox.height + padding);

						if (availableSize < bBox.height) {
							settings.position = 'bottom';
							return this.bottom(false);
						}
					}

					return position;
				},
				bottom: function (manipulable) {

					var position = {
						x: targetBBox.x + targetBBox.width / 2 - bBox.width / 2,
						y: positionedBBox.y - bBox.height - padding
					};
					if (manipulable) {

						var availableSize = (positionedBBox.y - padding) - viewport.y;

						if (availableSize < bBox.height) {
							settings.position = 'top';
							return this.top(false);
						}
					}

					return position;
				}
			};

			return map[type](minWidth > 0);
		},


		/**
		 * @private
		 * @param {rect} targetBBox
		 * @param {rect} viewport
		 * @returns {{width: number, height: number}}
		 */
		getTooltipBBox: function (targetBBox, viewport) {

			var $element;
			var positionedBBox;
			var dimensions = this.measureTooltipElement();

			$element = $(this.settings.positionSelector);
			positionedBBox = $element[0] ? joint.util.getElementBBox($element[0]) : targetBBox;

			var bBox = this.getPosition(positionedBBox, targetBBox, dimensions, viewport);
			// If the tooltip overflows the viewport on top and bottom sides (the top side wins).
			if (bBox.y < viewport.y) {
				bBox.y = viewport.y;
			} else if (bBox.y + dimensions.height > viewport.y + viewport.height) {
				bBox.y = viewport.y + viewport.height - dimensions.height;
			}

			var bBoxWidth = bBox.width || dimensions.width;
			// If the tooltip overflows the viewport on the left and right sides (the left side wins).
			if (bBox.x < viewport.x) {
				bBox.x = viewport.x;
			} else if (bBox.x + bBoxWidth > viewport.x + viewport.width) {
				bBox.x = viewport.x + viewport.width - bBoxWidth;
			}

			return bBox;
		},

		/**
		 * @private
		 * @returns {{width: number, height: number}}
		 */
		measureTooltipElement: function () {

			var $measure = this.$el.clone().appendTo($('body')).css({ 'left': -1000, top: -500 });

			var dimensions = {
				width: $measure.outerWidth(),
				height: $measure.outerHeight()
			};
			$measure.remove();

			return dimensions;
		}
	});

	//  Snaplines plugin
	//-------------------

	// Snaplines plugin helps creating diagramms by snapping elements to better-looking positions
	// (aligned with other elements) while they are dragged. It's an alternative to layout algorithms.

	joint.ui.Snaplines = joint.mvc.View.extend({

		options: {
			paper: undefined,
			distance: 10
		},

		className: 'snaplines',

		init: function () {

			joint.util.bindAll(this, 'hide');

			this.$horizontal = $('<div>').addClass('snapline horizontal').appendTo(this.el);
			this.$vertical = $('<div>').addClass('snapline vertical').appendTo(this.el);

			this.$el.hide().appendTo(this.options.paper.el);

			this.startListening();
		},

		startListening: function () {

			this.stopListening();

			this.listenTo(this.options.paper, 'cell:pointerdown', this.captureCursorOffset);
			this.listenTo(this.options.paper, 'cell:pointermove', this.snapWhileMoving);
			this.listenTo(this.options.paper.model, 'batch:stop', this.onBatchStop);

			$(document).on('mouseup touchend', this.hide);

			// Cache filters and make tham a hash table for easier and faster access.
			// `options.filter` can contain either strings in which case they are considered
			// cell types that should be filtered out or objects in which case they must
			// be cells that should be filtered out from snapping. Alternatively,
			// `options.filter` can be a function that is passed an element and must
			// return `true` if the element should be filtered out of the snapping.
			this.filterTypes = {};
			this.filterCells = {};
			this.filterFunction = undefined;

			if (Array.isArray(this.options.filter)) {

				this.options.filter.forEach(function (item) {

					if (joint.util.isString(item)) {
						this.filterTypes[item] = true;
					} else {
						this.filterCells[item.id] = true;
					}

				}, this);

			} else if (joint.util.isFunction(this.options.filter)) {

				this.filterFunction = this.options.filter;
			}
		},

		onBatchStop: function (data) {

			data = data || {};

			if (data.batchName === 'resize') {

				this.snapWhileResizing(data.cell, data);
			}
		},

		captureCursorOffset: function (cellView, evt, x, y) {

			if (!this.canElementMove(cellView)) {
				return;
			}

			var cellPosition = cellView.model.get('position');

			// store the difference between top-left corner and pointer coordinates
			this._cursorOffset = {
				x: x - cellPosition.x,
				y: y - cellPosition.y
			};
		},

		snapWhileResizing: function (cell, opt) {

			if (!opt.ui || opt.snapped || !opt.direction || !opt.trueDirection) return;

			var cellView = this.options.paper.findViewByModel(cell);

			if (!cellView || !cellView.model.isElement()) {
				return;
			}

			var cellBBox = cell.getBBox();
			var cellBBoxRotated = cellBBox.bbox(cell.get('angle'));
			var cellTopLeft = cellBBoxRotated.origin();
			var cellBottomRight = cellBBoxRotated.corner();
			var normalizedAngle = g.normalizeAngle(cell.get('angle'));
			var distance = this.options.distance;
			var vertical = null;
			var horizontal = null;

			// The vertical and horizontal lines to use when checking for snaplines.
			var cellLine = { vertical: 0, horizontal: 0 };

			var direction = opt.direction;
			var trueDirection = opt.trueDirection;
			var relativeDirection = opt.relativeDirection;

			if (trueDirection.indexOf('right') !== -1) {
				cellLine.vertical = cellBottomRight.x;
			} else {
				cellLine.vertical = cellTopLeft.x;
			}

			if (trueDirection.indexOf('bottom') !== -1) {
				cellLine.horizontal = cellBottomRight.y;
			} else {
				cellLine.horizontal = cellTopLeft.y;
			}

			this.options.paper.model.getElements().find(function (snapElement) {

				if (
					snapElement.id === cell.id ||
					snapElement.isEmbeddedIn(cell) ||
					this.filterTypes[snapElement.get('type')] ||
					this.filterCells[snapElement.id] ||
					(this.filterFunction && this.filterFunction(snapElement))
				) {
					return false;
				}

				var snapBBox = snapElement.getBBox().bbox(snapElement.get('angle'));
				var snapTopLeft = snapBBox.origin();
				var snapBottomRight = snapBBox.corner();

				var snapLinesByAxis = {
					vertical: [
						snapTopLeft.x,
						snapBottomRight.x
					],
					horizontal: [
						snapTopLeft.y,
						snapBottomRight.y
					]
				};

				joint.util.forIn(snapLinesByAxis, function (snapLines, axis) {

					snapLines = snapLines.map(function (snapLine) {

						return {
							position: snapLine,
							// Calculate the distance to each snapline.
							distance: Math.abs(snapLine - cellLine[axis])
						};
					});

					// Filter out snaplines that are too far away.
					snapLines = snapLines.filter(function (snapLine) {
						return snapLine.distance < distance;
					});

					// Sort by distance.
					snapLines = joint.util.sortBy(snapLines, function (snapLine) {
						return snapLine.distance
					});

					snapLinesByAxis[axis] = snapLines;
				});

				if (vertical === null && snapLinesByAxis.vertical.length > 0) {

					vertical = snapLinesByAxis.vertical[0].position;
				}

				if (horizontal === null && snapLinesByAxis.horizontal.length > 0) {

					horizontal = snapLinesByAxis.horizontal[0].position;
				}

				// keeps looking until all elements processed or both vertical and horizontal line found
				return joint.util.isNumber(vertical) && joint.util.isNumber(horizontal);

			}, this);

			this.hide();

			if (joint.util.isNumber(vertical) || joint.util.isNumber(horizontal)) {

				var diffX = 0;

				if (joint.util.isNumber(vertical)) {

					if (trueDirection.indexOf('right') !== -1) {
						diffX = vertical - cellBBoxRotated.corner().x;
					} else {
						diffX = cellBBoxRotated.origin().x - vertical;
					}
				}

				var diffY = 0;

				if (joint.util.isNumber(horizontal)) {

					if (trueDirection.indexOf('bottom') !== -1) {
						diffY = horizontal - cellBBoxRotated.corner().y;
					} else {
						diffY = cellBBoxRotated.origin().y - horizontal;
					}
				}

				var diffWidth = 0;
				var diffHeight = 0;
				var isAtRightAngle = !(normalizedAngle % 90);

				if (isAtRightAngle) {

					if (normalizedAngle === 90 || normalizedAngle === 270) {

						diffWidth = diffY;
						diffHeight = diffX;

					} else {

						diffWidth = diffX;
						diffHeight = diffY;
					}

				} else {

					// A little bit more complicated.

					// See:
					// https://www.mathsisfun.com/algebra/trig-four-quadrants.html
					var quadrant;

					if (normalizedAngle >= 0 && normalizedAngle < 90) {
						quadrant = 1;
					} else if (normalizedAngle >= 90 && normalizedAngle < 180) {
						quadrant = 4;
					} else if (normalizedAngle >= 180 && normalizedAngle < 270) {
						quadrant = 3;
					} else {
						quadrant = 2;
					}

					if (horizontal && vertical) {

						// Use only one of the snaplines.
						// Pick the closest snapline.
						if (diffY > diffX) {
							diffY = 0;
							horizontal = null;
						} else {
							diffX = 0;
							vertical = null;
						}
					}

					var angleInRadians = g.toRad(normalizedAngle % 90);

					if (diffX) {
						if (quadrant === 3) {
							diffWidth = diffX / Math.cos(angleInRadians);
						} else {
							diffWidth = diffX / Math.sin(angleInRadians);
						}
					}

					if (diffY) {
						if (quadrant === 3) {
							diffHeight = diffY / Math.cos(angleInRadians);
						} else {
							diffHeight = diffY / Math.sin(angleInRadians);
						}
					}

					var isQuadrantOneOrThree = quadrant === 1 || quadrant === 3;

					switch (relativeDirection) {

						case 'top':
						case 'bottom':

							if (diffY) {
								diffHeight = diffY / (isQuadrantOneOrThree ? Math.cos(angleInRadians) : Math.sin(angleInRadians));
							} else {
								diffHeight = diffX / (isQuadrantOneOrThree ? Math.sin(angleInRadians) : Math.cos(angleInRadians));
							}
							break;

						case 'left':
						case 'right':

							if (diffX) {
								diffWidth = diffX / (isQuadrantOneOrThree ? Math.cos(angleInRadians) : Math.sin(angleInRadians));
							} else {
								diffWidth = diffY / (isQuadrantOneOrThree ? Math.sin(angleInRadians) : Math.cos(angleInRadians));
							}
							break;
					}
				}

				switch (relativeDirection) {

					case 'top':
					case 'bottom':
						// Keep the width the same.
						diffWidth = 0;
						break;

					case 'left':
					case 'right':
						// Keep the height the same.
						diffHeight = 0;
						break;
				}

				var gridSize = this.options.paper.options.gridSize;
				var newWidth = Math.max(cellBBox.width + diffWidth, gridSize);
				var newHeight = Math.max(cellBBox.height + diffHeight, gridSize);

				if (opt.minWidth && opt.minWidth > gridSize) {
					newWidth = Math.max(newWidth, opt.minWidth);
				}

				if (opt.minHeight && opt.minHeight > gridSize) {
					newHeight = Math.max(newHeight, opt.minHeight);
				}

				if (opt.maxWidth) {
					newWidth = Math.min(newWidth, opt.maxWidth);
				}

				if (opt.maxHeight) {
					newHeight = Math.min(newHeight, opt.maxHeight);
				}

				if (opt.preserveAspectRatio) {

					if (diffWidth > diffHeight) {
						newHeight = newWidth * (cellBBox.height / cellBBox.width);
					} else {
						newWidth = newHeight * (cellBBox.width / cellBBox.height);
					}
				}

				if (newWidth !== cellBBox.width || newHeight !== cellBBox.height) {

					cell.resize(newWidth, newHeight, {
						snaplines: this.cid,
						restrictedArea: this.options.paper.getRestrictedArea(cellView),
						direction: direction,
						relativeDirection: relativeDirection,
						trueDirection: trueDirection,
						// backwards compatibility
						snapped: true
					});
				}

				// Due to the applying minimal/maximal width/height the element might not be
				// snapped to a snapline in the end. We need to check this.
				var resBBox = cell.getBBox().bbox(normalizedAngle);
				var precision = 1;
				if (
					vertical &&
					(Math.abs(resBBox.x - vertical) > precision) &&
					(Math.abs(resBBox.width + resBBox.x - vertical) > precision)
				) {
					vertical = null;
				}
				if (
					horizontal &&
					(Math.abs(resBBox.y - horizontal) > precision) &&
					(Math.abs(resBBox.height + resBBox.y - horizontal) > precision)
				) {
					horizontal = null;
				}

				this.show({ vertical: vertical, horizontal: horizontal });
			}
		},

		canElementMove: function (cellView) {

			return cellView && cellView.model.isElement() && cellView.can('elementMove');
		},

		snapWhileMoving: function (cellView, evt, x, y) {

			if (!this.canElementMove(cellView)) {
				return;
			}

			var cell = cellView.model;
			var currentPosition = cell.get('position');
			var currentSize = cell.get('size');
			var cellBBox = g.rect(joint.util.assign({
				x: x - this._cursorOffset.x,
				y: y - this._cursorOffset.y
			}, currentSize));
			var cellCenter = cellBBox.center();
			var cellBBoxRotated = cellBBox.bbox(cell.get('angle'));
			var cellTopLeft = cellBBoxRotated.origin();
			var cellBottomRight = cellBBoxRotated.corner();

			var distance = this.options.distance;
			var vertical = null;
			var horizontal = null;
			var verticalFix = 0;
			var horizontalFix = 0;

			// find vertical and horizontal lines by comparing top-left, bottom-right and center bbox points
			this.options.paper.model.getElements().find(function (snapElement) {

				if (
					snapElement === cell ||
					snapElement.isEmbeddedIn(cell) ||
					this.filterTypes[snapElement.get('type')] ||
					this.filterCells[snapElement.id] ||
					(this.filterFunction && this.filterFunction(snapElement))
				) {
					return false;
				}

				var snapBBox = snapElement.getBBox().bbox(snapElement.get('angle'));
				var snapCenter = snapBBox.center();
				var snapTopLeft = snapBBox.origin();
				var snapBottomRight = snapBBox.corner();

				if (vertical === null) {

					if (Math.abs(snapCenter.x - cellCenter.x) < distance) {
						vertical = snapCenter.x;
						verticalFix = 0.5;
					} else if (Math.abs(snapTopLeft.x - cellTopLeft.x) < distance) {
						vertical = snapTopLeft.x;
					} else if (Math.abs(snapTopLeft.x - cellBottomRight.x) < distance) {
						vertical = snapTopLeft.x;
						verticalFix = 1;
					} else if (Math.abs(snapBottomRight.x - cellBottomRight.x) < distance) {
						vertical = snapBottomRight.x;
						verticalFix = 1;
					} else if (Math.abs(snapBottomRight.x - cellTopLeft.x) < distance) {
						vertical = snapBottomRight.x;
					}
				}

				if (horizontal === null) {

					if (Math.abs(snapCenter.y - cellCenter.y) < distance) {
						horizontal = snapCenter.y;
						horizontalFix = 0.5;
					} else if (Math.abs(snapTopLeft.y - cellTopLeft.y) < distance) {
						horizontal = snapTopLeft.y;
					} else if (Math.abs(snapTopLeft.y - cellBottomRight.y) < distance) {
						horizontal = snapTopLeft.y;
						horizontalFix = 1;
					} else if (Math.abs(snapBottomRight.y - cellBottomRight.y) < distance) {
						horizontal = snapBottomRight.y;
						horizontalFix = 1;
					} else if (Math.abs(snapBottomRight.y - cellTopLeft.y) < distance) {
						horizontal = snapBottomRight.y;
					}
				}

				// keeps looking until all elements processed or both vertical and horizontal line found
				return joint.util.isNumber(vertical) && joint.util.isNumber(horizontal);

			}, this);

			this.hide();

			if (joint.util.isNumber(vertical) || joint.util.isNumber(horizontal)) {

				if (joint.util.isNumber(vertical)) {
					cellBBoxRotated.x = vertical - (verticalFix * cellBBoxRotated.width);
				}

				if (joint.util.isNumber(horizontal)) {
					cellBBoxRotated.y = horizontal - (horizontalFix * cellBBoxRotated.height);
				}

				// find x and y of the unrotated cell
				var newCellCenter = cellBBoxRotated.center();
				var newX = newCellCenter.x - (cellBBox.width / 2);
				var newY = newCellCenter.y - (cellBBox.height / 2);

				cell.translate(newX - currentPosition.x, newY - currentPosition.y, {
					restrictedArea: this.options.paper.getRestrictedArea(cellView),
					snapped: true
				});

				this.show({ vertical: vertical, horizontal: horizontal });
			}
		},

		show: function (opt) {

			opt = opt || {};

			var ctm = this.options.paper.matrix();

			if (opt.horizontal) {
				this.$horizontal.css('top', opt.horizontal * ctm.d + ctm.f).show();
			} else {
				this.$horizontal.hide();
			}

			if (opt.vertical) {
				this.$vertical.css('left', opt.vertical * ctm.a + ctm.e).show();
			} else {
				this.$vertical.hide();
			}

			this.$el.show();
		},

		hide: function () {

			this.$el.hide();
		},

		onRemove: function () {

			$(document).off('mouseup', this.hide);
		}
	});

	// ui.TextEditor
	// =============

	// Inline SVG text editing that is nearly identical to the native text
	// editing inside the HTML textarea element.

	// Features:
	// ---------

	// - Rich text editing.
	// - Selections.
	// - Caret.
	// - Caret positioning left or right based on the distance to
	//   the left/right edge of the clicked character.
	// - Handles newlines seamlessly.
	// - Selections, both all-text and portions of text.
	// - Word selection by double-click.
	// - Whole text selection by triple-click.
	// - Keyboard navigation native to the underlying OS.
	// - API for programmatic access (selections, caret, word boundary, ...).
	// - Selections and caret can be styled in CSS.
	// - Supports editing of a rotated text.
	// - Supports editing of a scaled text.

	// Important note: The ui.TextEditor assumes the SVG `<text>` element
	// contains a `<tspan>` element for each line. Lines are ordered as they
	// appear in the DOM. If a line is empty, it is assumed the `<tspan>`
	// element contains a space character.
	// This is in line with how Vectorizer renders text.

	joint.ui.TextEditor = joint.mvc.View.extend({

		options: {
			text: undefined, // The SVG text element on which we want to enable inline text editing.
			newlineCharacterBBoxWidth: 10, // The width of the new line character. Used for selection of a newline.
			placeholder: undefined,  // The placeholder in case the text gets emptied.
			focus: true, // Determines if the textarea should gain focus. In some cases, this is not intentional - e.g. if we use the ui.TextEditor for displaying remote cursor.
			debug: false,
			useNativeSelection: true,
			annotateUrls: false,
			urlAnnotation: {
				attrs: {
					'class': 'url-annotation',
					fill: 'lightblue',
					'text-decoration': 'underline'
				}
			},
			textareaAttributes: {
				autocorrect: 'off',
				autocomplete: 'off',
				autocapitalize: 'off',
				spellcheck: 'false',
				tabindex: '0'
			}
		},

		className: 'text-editor',

		events: {
			'keyup textarea': 'onKeyup',
			'input textarea': 'onInput',
			'copy textarea': 'onCopy',
			'cut textarea': 'onCut',
			'paste textarea': 'onPaste',
			'mousedown .char-selection-box': 'onMousedown',
			'dblclick .char-selection-box': 'onDoubleClick',
			'click .char-selection-box': 'onTripleClick'
		},

		selection: {
			start: null,
			end: null
		},

		selecting: false,

		init: function () {

			joint.util.bindAll(this, 'onMousedown', 'onMousemove', 'onMouseup', 'onDoubleClick', 'onTripleClick', 'onKeydown', 'onAfterPaste', 'onAfterKeydown');

			this.setTextElement(this.options.text);

			$(document.body).on('mousemove', this.onMousemove);
			$(document.body).on('mouseup', this.onMouseup);
			$(document.body).on('keydown', this.onKeydown);

			if (this.options.cellView) {
				this.$viewport = $(this.options.cellView.paper.viewport);
			} else {
				// If cellView is not passed, the viewport (text-selectable area) is the text element itself.
				// If $viewport is not set, Chrome prints a warning about "Discontiguous Selection" and selections are not rendered.
				this.$viewport = $(this.options.text);
			}

			if (this.options.annotations) {
				this.setAnnotations(this.options.annotations);
			}
		},

		setTextElement: function (textElement) {

			if (this.$elText) {
				this.unbindTextElement();
			}

			this.options.text = textElement;

			this.$elText = $(textElement);
			this.$elText.on('mousedown', this.onMousedown);
			this.$elText.on('dblclick', this.onDoubleClick);
			this.$elText.on('click', this.onTripleClick);
		},

		// @public
		render: function (root) {

			// The caret (cursor), displayed as a thin <div> styled in CSS.
			this.$caret = $('<div>', { 'class': 'caret' });

			// The container for selection boxes.
			this.$selection = $('<div>');
			// One selection box covering one character.
			this.$selectionBox = $('<div>', { 'class': 'char-selection-box' });
			this.$el.append(this.$caret, this.$selection);

			this.$textareaContainer = $('<div>', { 'class': 'textarea-container' });

			this.$textarea = $('<textarea>', this.options.textareaAttributes);
			this.textarea = this.$textarea[0];
			this._textContent = this.textarea.value = this.getTextContent();

			this._textareaValueBeforeInput = this.textarea.value;
			this.$textareaContainer.append(this.textarea);

			if (this.options.focus) {
				this.$el.append(this.$textareaContainer);
			}

			// First add the container element to the `<body>`, otherwise
			// the `focus()` called afterwords would not work.
			$(root || document.body).append(this.$el);

			var bbox = V(this.options.text).bbox();

			this.$textareaContainer.css({
				left: bbox.x,
				top: bbox.y
			});

			this.focus();

			// TODO: This should be optional?
			V(this.options.text).attr('cursor', 'text');

			this.selectAll();

			return this;
		},

		annotateURLBeforeCaret: function (selectionStart) {

			// If whitespace character was added, check if there is not a URL
			// before the inserted text. If yes, annotate it.
			var urlBoundary = this.getURLBoundary(Math.max(selectionStart - 1, 0));
			if (urlBoundary) {
				this.annotateURL(this.getAnnotations() || [], urlBoundary[0], urlBoundary[1]);
				return true;
			}

			return false;
		},

		hasSelection: function () {

			return joint.util.isNumber(this.selection.start) &&
				joint.util.isNumber(this.selection.end) &&
				this.selection.start !== this.selection.end;
		},

		textContentHasChanged: function () {

			return this._textContent !== this.textarea.value;
		},

		restoreTextAreaSelectionDirection: function () {

			if (this._selectionDirection) {
				this.textarea.selectionDirection = this._selectionDirection;
			}
		},

		storeSelectionDirection: function () {

			this._selectionDirection = this.textarea.selectionDirection;
		},

		onKeydown: function (evt) {

			if (this.options.debug) {
				console.log('onKeydown(): ', evt.keyCode);
			}

			if (this.hasSelection()) {
				this.deselect();
				// Restore the textarea.selectionDirection so that the textarea knows in what direction
				// it should select in case Shift+Arrow keys are used.
				this.restoreTextAreaSelectionDirection();
			}

			// The stream of events when typing something to the textarea is:
			// keydown -> keypress/paste -> letter typed in textarea -> keyup.
			// Therefore, in keydown, we can store the selectionStart
			// value of the textarea before it is adjusted based on the input.
			// Also note that we use keydown and not keypress because
			// e.g. BACKSPACE key is not handled in keypress.

			// We want the navigation keys to be reflected in the UI immediately on keydown.
			// However, at that time, the textarea's selectionStart/End does not yet
			// take into account this very keydown action. Hence we need to
			// defer the `setCaret()` to the next turn. Note that there is no other way
			// as keypress is not triggered for arrow keys and when keyup is triggered, it's too late.
			setTimeout(this.onAfterKeydown, 0);

			this._copied = false;
			this._selectionStartBeforeInput = this.textarea.selectionStart;
			this._selectionEndBeforeInput = this.textarea.selectionEnd;
		},

		// Called after the textarea handled the keydown. Remember the order of events:
		// onKeydown -> textarea receives keydown -> onAfterKeydown
		onAfterKeydown: function () {

			if (this.$textarea.is(':focus')) {

				// Remember the textarea.selectionDirection because select() wipes it out (by clearning selections).
				// We will restore it just before the keydown is received by the textarea so that the
				// textarea selects in the right direction (using the Shift+Arrow keys).
				this.storeSelectionDirection();

				if (this.textarea.selectionStart === this.textarea.selectionEnd) {
					this.setCaret(this.textarea.selectionStart);
				} else {
					this.select(this.textarea.selectionStart, this.textarea.selectionEnd);
				}
			}
		},

		onKeyup: function (evt) {

			if (this.textContentHasChanged()) {
				this.onInput(evt);
			}
		},

		onCopy: function (evt) {

			if (!this._copied) {
				this.copyToClipboard();
			}
		},

		onCut: function (evt) {

			if (!this._copied) {
				this.copyToClipboard();
			}
		},

		copyToClipboard: function () {

			var copySupported = document.queryCommandSupported && document.queryCommandSupported('copy');

			if (copySupported) {
				this._copied = true;
				document.execCommand('copy');
			}
		},

		onInput: function (evt) {

			if (!this.textContentHasChanged()) return;

			var diffLength = this.textarea.value.length - this._textareaValueBeforeInput.length;

			var selectionBeforeInput = {
				start: this._selectionStartBeforeInput,
				end: this._selectionEndBeforeInput
			};

			var selectionAfterInput = {
				start: this.textarea.selectionStart,
				end: this.textarea.selectionEnd
			};

			if (this.options.debug) {
				console.log('onInput()', evt, 'selectionBeforeInput', selectionBeforeInput, 'selectionAfterInput', selectionAfterInput, 'diffLength', diffLength);
			}

			var opType = this.inferTextOperationType(selectionBeforeInput, selectionAfterInput, diffLength);
			var annotated = false;

			var annotations = this.getAnnotations();

			// If URL annotation is enabled and the user inserts a whitespace character,
			// try to detect a URL before the whitespace character. If one was found,
			// annotate it using the `urlAnnotation` option.
			if (this.options.annotateUrls && opType === 'insert') {

				var insertedText = this.textarea.value.substr(selectionBeforeInput.start, diffLength);
				if (this.options.debug) {
					console.log('onInput()', 'inserted text', insertedText);
				}

				if (/\s/.test(insertedText)) {

					annotated = this.annotateURLBeforeCaret(selectionBeforeInput.start);
					if (annotated) {
						// Now we have to shift all the annotations after the inserted whitespace by one to the right.
						annotations = this.shiftAnnotations(annotations, selectionAfterInput.end, diffLength);
					}
				}
			}

			if (annotations) {

				// Annotate only if it wasn't already annotated. This can happen if
				// URL annotation is enabled and we did indeed detect a URL. In this case,
				// the annotation is handed over to `annotateURL()` and not to the
				// generic annotation mechanism - based on the previous character.
				if (!annotated) {

					annotations = this.annotate(annotations, selectionBeforeInput, selectionAfterInput, diffLength);
				}

				if (this.options.debug) {
					console.log('onInput()', 'modified annotations', annotations);
				}

				// Take into account annotation attributes set from outside the text editor.
				// For example, if the user changes text to bold in the toolbar, the programmer
				// should call `setCurrentAnnotation()`. Then when the user starts typing ('insert' operation),
				// we want to create a new annotation with the desired attributes.
				if (this._currentAnnotationAttributes) {

					if (opType === 'insert') {

						var insertAnnotation = {
							start: selectionBeforeInput.start,
							end: selectionAfterInput.end,
							attrs: this._currentAnnotationAttributes
						};
						annotations.push(insertAnnotation);

						// Current annotations are removed right after the very next input which is now.
						// This is because the annotation already become part of the `annotations` array
						// and so if the user continues typing, the next characters will inherit
						// attributes of the previous one (which has our `insertAnnotation` applied).
						this._currentAnnotationAttributes = undefined;

						if (this.options.debug) {
							console.log('onInput()', 'insert annotation', insertAnnotation, 'final annotations', annotations);
						}
					}
				}
			}

			this._annotations = annotations;

			this.trigger('text:change', this.textarea.value, this._textareaValueBeforeInput, annotations, selectionBeforeInput, selectionAfterInput);

			// Store the previous textarea value.
			this._selectionBeforeInput = selectionAfterInput;
			this._textareaValueBeforeInput = this.textarea.value;
			this._textContent = this.textarea.value;
		},

		onPaste: function (evt) {

			if (this.options.debug) {
				console.log('onPaste()');
			}

			this._textareaValueBeforeInput = this.textarea.value;

			// Give chance to react on when the text was actually pasted to the textarea
			// and the textarea adjusted its selectionStart/End.
			setTimeout(this.onAfterPaste, 0);
		},

		// Called after the textarea handled the paste. Remember the order of events:
		// onPaste -> textarea receives paste -> onAfterPaste
		onAfterPaste: function () {

			this.setCaret(this.textarea.selectionStart);
		},

		onMousedown: function (evt) {

			// Do not deselect the text if it is a triple-click in order to prevent
			// the "blinking effect" (deselect all -> select all). See `onTripleClick()`.
			if (evt.originalEvent.detail === 3) return;

			if (this.options.debug) {
				console.log('onMousedown()');
			}

			var selectionStart = this.getCharNumFromEvent(evt);

			this.startSelecting();
			this.select(selectionStart);

			// Prevent default action that could set focus
			// on the text element and therefore the textarea
			// inside the editor would loose it.
			evt.preventDefault();
			// Stop propagation, the active text editor takes over mousedown.
			evt.stopPropagation();
		},

		onMousemove: function (evt) {

			if (this.selectionInProgress()) {

				if (this.options.debug) {
					console.log('onMousemove()');
				}

				var selectionEnd = this.getCharNumFromEvent(evt);

				// Remember the textarea.selectionDirection so that we can restore it later.
				// The reason is that select() internally clears the selection (removes all ranges)
				// which then wipes out the selectionDirection. To make sure that
				// Shift+Arrow keys select in the right direction, we have to remember it and
				// restore it later.
				this.storeSelectionDirection();

				// This will keep the start of the selection and change only the end.
				this.select(null, selectionEnd);

				// The active text editor takes over mousemove during selection.
				evt.preventDefault();
				evt.stopPropagation();
			}
		},

		onMouseup: function (evt) {

			if (this.selectionInProgress()) {

				if (this.options.debug) {
					console.log('onMouseup()');
				}

				this.stopSelecting();
				this.trigger('select:changed', this.selection.start, this.selection.end);
			}
		},

		onDoubleClick: function (evt) {

			if (this.options.debug) {
				console.log('onDoubleClick()');
			}

			var charNum = this.getCharNumFromEvent(evt);
			var wordBoundary = this.getWordBoundary(charNum);
			this.select(wordBoundary[0], wordBoundary[1]);

			evt.preventDefault();
			evt.stopPropagation();
		},

		onTripleClick: function (evt) {

			if (evt.originalEvent.detail !== 3) return;

			if (this.options.debug) {
				console.log('onTripleClick()');
			}

			this.hideCaret();
			this.selectAll();

			evt.preventDefault();
			evt.stopPropagation();
		},

		// @public
		// Find all the annotations in the `annotations` array that the
		// cursor at `selectionStart` position falls into.
		findAnnotationsUnderCursor: function (annotations, selectionStart) {

			return V.findAnnotationsAtIndex(annotations, selectionStart);
		},

		// @public
		// Find all the annotations that fall into the selection range specified by `selectionStart` and `selectionEnd`.
		// This method assumes the selection range is normalized.
		findAnnotationsInSelection: function (annotations, selectionStart, selectionEnd) {

			return V.findAnnotationsBetweenIndexes(annotations, selectionStart, selectionEnd);
		},

		// @private
		// This function infers the type of a text operation based solely on the selection indices
		// before and after the text input changed.
		inferTextOperationType: function (selectionBeforeInput, selectionAfterInput, diffLength) {

			if (selectionBeforeInput.start === selectionBeforeInput.end && selectionAfterInput.start === selectionAfterInput.end && diffLength > 0) {

				return 'insert';

			} else if (selectionBeforeInput.start === selectionBeforeInput.end && selectionAfterInput.start === selectionAfterInput.end && diffLength <= 0) {

				return 'delete-single';

			} else if (selectionBeforeInput.start !== selectionBeforeInput.end && selectionAfterInput.start === selectionAfterInput.end && selectionAfterInput.start === selectionBeforeInput.start) {

				return 'delete';

			} else if (selectionBeforeInput.start !== selectionBeforeInput.end && selectionAfterInput.start !== selectionBeforeInput.start) {

				// Delete followed by insert. The user might have selected a range and then started typing or pasting.
				return 'delete-insert';
			}

			return undefined;
		},

		// @private
		// Modify `annotations` (indices of all the affected annotations)
		// based on the user action defined by `selectionBeforeInput`, `selectionAfterInput` and `diffLength`.
		// For example, when the user inserts a new character, we want the new character to inherit
		// styling attributes (annotation) from the previous character (extend the affected annotation end index) and shift
		// all the following annotations by one to the right.
		// Note that this function modifies the original `annotations` array and returns it.
		annotate: function (annotations, selectionBeforeInput, selectionAfterInput, diffLength) {

			var newAnnotations = [];

			var opType = this.inferTextOperationType(selectionBeforeInput, selectionAfterInput, diffLength);

			joint.util.toArray(annotations).forEach(function (annotation) {

				var inAnnotation, removedInAnnotation;

				switch (opType) {

					case 'insert':
						if (annotation.start < selectionBeforeInput.start && selectionBeforeInput.start <= annotation.end) {
							annotation.end += diffLength;
						} else if (annotation.start >= selectionBeforeInput.start) {
							// We're writting before the annotated portion, move the
							// all the following annotations to the right.
							annotation.start += diffLength;
							annotation.end += diffLength;
						}
						break;

					case 'delete-single':
						// TODO: backspace and delete are two different operations.
						// It depends on the selectionAfterInput which one was used.
						if (annotation.start < selectionBeforeInput.start && selectionBeforeInput.start <= annotation.end && selectionBeforeInput.start !== selectionAfterInput.start) {
							// Backspace.
							annotation.end += diffLength;
						} else if (annotation.start <= selectionBeforeInput.start && selectionBeforeInput.start < annotation.end && selectionBeforeInput.start === selectionAfterInput.start) {
							// Delete.
							annotation.end += diffLength;
						} else if (annotation.start >= selectionBeforeInput.start) {
							// We're deleting before the annotated portion, move
							// all the following annotations by diff length.
							annotation.start += diffLength;
							annotation.end += diffLength;
						}
						break;

					case 'delete':
						if (annotation.start <= selectionBeforeInput.start && selectionBeforeInput.start <= annotation.end) {
							if (selectionBeforeInput.end <= annotation.end) {
								annotation.end += diffLength;
							} else {
								annotation.end += selectionAfterInput.start - annotation.end;
							}
						} else if (annotation.start >= selectionBeforeInput.start && annotation.start < selectionBeforeInput.end) {

							// Part of the annotation is deleted.
							inAnnotation = annotation.end - annotation.start;
							removedInAnnotation = selectionBeforeInput.end - annotation.start;
							annotation.start = selectionBeforeInput.start;
							annotation.end = annotation.start + inAnnotation - removedInAnnotation;

						} else if (annotation.start >= selectionBeforeInput.end) {
							// Shift all the following annotations by the diff length.
							annotation.start += diffLength;
							annotation.end += diffLength;
						}
						break;


					case 'delete-insert':
						// Delete followed by insert. The user might have selected a range and then started typing or pasting.

						if (annotation.start <= selectionBeforeInput.start && selectionBeforeInput.start <= annotation.end) {
							// If we're deleting something AFTER the annotation, we do now
							// want the inserting characters to inherit the annotated properties.
							// aBC[d]e -> aBCe   (not aBCE)
							if (selectionBeforeInput.start < annotation.end) {

								if (selectionBeforeInput.end > annotation.end) {
									annotation.end = selectionAfterInput.end;
								} else {
									annotation.end = selectionAfterInput.end + (annotation.end - selectionBeforeInput.end);
								}
							}
						} else if (annotation.start >= selectionBeforeInput.start && annotation.start <= selectionBeforeInput.end) {

							// Part of the annotation is affected.
							var addedChars = selectionAfterInput.start - selectionBeforeInput.start;
							removedInAnnotation = selectionBeforeInput.end - annotation.start;
							inAnnotation = annotation.end - annotation.start;
							annotation.start = selectionBeforeInput.start + addedChars;
							annotation.end = annotation.start + inAnnotation - removedInAnnotation;

						} else if (annotation.start >= selectionBeforeInput.start && annotation.end <= selectionBeforeInput.end) {

							// This annotation will be removed.
							annotation.start = annotation.end = 0;

						} else if (annotation.start >= selectionBeforeInput.end) {
							// Shift all the following annotations by the diff length.
							annotation.start += diffLength;
							annotation.end += diffLength;
						}
						break;

					default:
						// Unknown operation. Should never happen!
						if (this.options.debug) {
							console.log('ui.TextEditor: Unknown text operation.');
						}
						break;
				}

				if (annotation.end > annotation.start) {
					newAnnotations.push(annotation);
				}

			}, this);

			return newAnnotations;
		},

		shiftAnnotations: function (annotations, selectionStart, offset) {

			return V.shiftAnnotations(annotations, selectionStart, offset);
		},

		// @public
		// This method stores annotation attributes that will be used for the very next insert operation.
		// This is useful, for example, when we have a toolbar and the user changes text to e.g. bold.
		// At this point, we can just call `setCurrentAnnotation({ 'font-weight': 'bold' })` and let the
		// text editor know that once the user starts typing, the text should be bold.
		// Note that the current annotation will be removed right after the first text operation to come.
		// This is becase after that, the next inserted character will already inherit properties
		// from the previous character which is our 'bold' text.
		setCurrentAnnotation: function (attrs) {

			this._currentAnnotationAttributes = attrs;
		},

		// @public
		// Set annotations of the text inside the text editor.
		// These annotations will be modified during the course of using the text editor.
		setAnnotations: function (annotations) {

			this._annotations = annotations;
		},

		// @public
		getAnnotations: function () {

			return this._annotations;
		},

		// @public
		// Get the combined (merged) attributes for a character at the position `selectionStart`
		// taking into account all the `annotations` that apply.
		getCombinedAnnotationAttrsAtIndex: function (selectionStart, annotations) {

			var attrs = {};
			joint.util.toArray(annotations).forEach(function (annotation) {
				if (annotation.start === undefined && annotation.end === undefined) {
					// The annotation does not have `start` and `end`. Assume it spans
					// the whole text. This allows us to pass default annotations
					// for text that is not spanned by any regular annotation.
					V.mergeAttrs(attrs, annotation.attrs);
				} else if (selectionStart >= annotation.start && selectionStart < annotation.end) {
					V.mergeAttrs(attrs, annotation.attrs);
				}
			});
			return attrs;
		},

		// @public
		// Find a common annotation among all the `annotations` that fall into the
		// `range` (an object with `start` and `end` properties - *normalized*).
		// For characters that don't fall into any of the `annotations`, assume
		// `defaultAnnotation` (default annotation does not need `start` and `end` properties).
		// The common annotation denotes the attributes that all the characters in the `range` share.
		// If any of the attributes for any character inside `range` differ, `undefined` is returned.
		// This is useful e.g. when your toolbar needs to reflect the text attributes of a selection.
		getSelectionAttrs: function (range, annotations) {

			var start = range.start;
			var end = range.end;

			if (start === end && start === 0) {
				// If the cursor is right at the beginning of the text (and there is *some* text), take
				// attributes from the first character.
				return this.getCombinedAnnotationAttrsAtIndex(start, annotations);

			} else if (start === end) {
				// Nothing is selected. We take attributes of the character before the current caret position.
				return this.getCombinedAnnotationAttrsAtIndex(start - 1, annotations);

			} else {

				var commonAttrs;
				for (var i = start; i < end; i++) {
					var attrs = this.getCombinedAnnotationAttrsAtIndex(i, annotations);
					if (commonAttrs && !joint.util.isEqual(commonAttrs, attrs)) {
						// Attributes differ. Remove those that differ from commonAttrs.
						commonAttrs = joint.util.flattenObject(V.mergeAttrs({}, commonAttrs));
						attrs = joint.util.flattenObject(V.mergeAttrs({}, attrs));
						var result = {};
						joint.util.forIn(attrs, function (value, key) {
							if (commonAttrs[key] === attrs[key]) {
								joint.util.setByPath(result, key, value);
							}
						});
						commonAttrs = result;
					} else {
						commonAttrs = attrs;
					}
				}
				return commonAttrs;
			}
		},

		// @public
		// Return the text content (including new line characters) inside the `<text>` SVG element.
		// We assume that each <tspan> represents a new line in the order in which
		// they were added to the DOM.
		getTextContent: function () {

			// Add a newline character for every <tspan> that is a line. Such
			// tspans must be marked with the `line` class.
			var elText = this.options.text;
			var tspans = V(elText).find('.v-line');
			return tspans.length === 0 ? elText.textContent : tspans.reduce(function (memo, tspan, i, tspans) {
				var line = tspan.node.textContent;
				// Empty lines are assumed to be marked with the `empty-line` class.
				if (tspan.hasClass('v-empty-line')) line = '';
				// Last line does not need a new line (\n) character at the end.
				return (i === tspans.length - 1) ? memo + line : memo + line + '\n';
			}, '');
		},

		startSelecting: function () {

			this.selecting = true;
		},

		stopSelecting: function () {

			this.selecting = false;
		},

		selectionInProgress: function () {

			return this.selecting === true;
		},

		// @public
		// Select the whole text.
		selectAll: function () {

			return this.select(0, this.getNumberOfChars());
		},

		// @public
		// Select a portion of the text starting at `startCharNum`
		// character position ending at `selectionEnd` character position.
		// This method automatically swaps `startCharNum` and `endCharNum`
		// if they are in the wrong order.
		select: function (startCharNum, endCharNum) {

			if (this.options.debug) {
				console.log('select(', startCharNum, endCharNum, ')');
			}

			if (endCharNum === undefined) {
				endCharNum = startCharNum;
			}

			if (joint.util.isNumber(startCharNum)) {
				this.selection.start = startCharNum;
			}

			if (joint.util.isNumber(endCharNum)) {
				this.selection.end = endCharNum;
			}

			if (!joint.util.isNumber(this.selection.end)) {
				this.selection.end = this.selection.start;
			}

			if (joint.util.isNumber(this.selection.start) && joint.util.isNumber(this.selection.end)) {

				if (this.selection.start === this.selection.end) {
					this.clearSelection();
					this.focus();
					this.setCaret(this.selection.start);
				} else {
					this.hideCaret();
					this.renderSelection(this.selection.start, this.selection.end);
				}

				this.trigger('select:change', this.selection.start, this.selection.end);
			}

			return this;
		},

		setTextAreaSelection: function (start, end) {

			var selection = {
				start: start,
				end: end
			};

			selection = this.normalizeSelectionRange(selection);

			this.textarea.focus();
			this.textarea.selectionStart = selection.start;
			this.textarea.selectionEnd = selection.end;
		},

		renderSelection: function (start, end) {

			if (this.options.debug) {
				console.log('renderSelection()');
			}

			var selection = {
				start: start,
				end: end
			};

			selection = this.normalizeSelectionRange(selection);

			this.clearSelection();

			if (this.options.useNativeSelection) {

				// Use native selection.

				// Allow selection of elements in the paper.
				if (this.$viewport) {

					// Save this so that it can be reverted later.
					this._viewportUserSelectBefore = this.$viewport.css('user-select');

					this.$viewport.css({
						'-webkit-user-select': 'all',
						'-moz-user-select': 'all',
						'user-select': 'all'
					});
				}

				var length = (selection.end - selection.start);

				this.selectTextInElement(this.options.text, selection.start, length);

			} else {

				// Fallback to the old method of rendering the selection box using a <div> for each character.

				this.renderSelectionBoxes(selection.start, selection.end);
			}
		},

		normalizeSelectionStartAndLength: function (text, start, length) {

			var textBefore = text.substr(0, start);
			var textSelected = text.substr(start, length);

			// Linebreaks aren't counted by the selectSubString() method.
			var numLineBreaksBefore = this.countLineBreaks(textBefore);
			var numLineBreaksInSelection = this.countLineBreaks(textSelected);

			start -= numLineBreaksBefore;
			length -= numLineBreaksInSelection;

			// "Empty lines" contain a hidden hyphen symbol, which are counted.
			var numEmptyLinesBefore = this.countEmptyLines(textBefore);
			var numEmptyLinesInSelection = this.countEmptyLines(textSelected);

			start += numEmptyLinesBefore;
			length += numEmptyLinesBefore;
			length -= numEmptyLinesBefore;
			length += numEmptyLinesInSelection;

			return {
				start: start,
				length: length
			};
		},

		selectTextInElement: function (element, start, length) {

			if (joint.util.isFunction(element.selectSubString)) {

				// Try using selectSubString().
				this.selectTextInElementUsingSelectSubString(element, start, length);
			}

			// Is the expected selected content is different from the actual selected content?
			if (!this.actualSelectionMatchesExpectedSelection(start, length)) {

				// Fallback to using ranges.

				try {

					this.selectTextInElementUsingRanges(element, start, length);

				} catch (error) {

					if (this.options.debug) {
						console.log(error);
					}

					if (joint.util.isFunction(element.selectSubString)) {
						// Try again using selectSubString().
						this.selectTextInElementUsingSelectSubString(element, start, length);
					}
				}
			}
		},

		selectTextInElementUsingSelectSubString: function (element, start, length) {

			// Note:
			// When using this method, Firefox doesn't do well when the selection spans multiple <tspan> elements.
			// In that case only the first <tspan> is selected.

			var normalized = this.normalizeSelectionStartAndLength(this.getTextContent(), start, length);

			try {

				element.selectSubString(normalized.start, normalized.length);

			} catch (error) {

				if (this.options.debug) {
					console.log(error);
				}
			}
		},

		selectTextInElementUsingRanges: function (element, start, length) {

			// Some browsers (Chrome) don't allow "discontiguous" ranges.
			// A "discontiguous" range is a range that includes multiple elements.
			// This isn't a problem for Firefox.

			var selection = window.getSelection();

			selection.removeAllRanges();

			var normalized = this.normalizeSelectionStartAndLength(this.getTextContent(), start, length);

			start = 0 + normalized.start;
			length = 0 + normalized.length;

			var textNodes = this.getTextNodesFromDomElement(element);
			var textNode;
			var range;
			var textNodeStart;
			var textNodeEnd;
			var setStart;
			var setEnd;
			var offset = 0;
			var end = start + length;

			while (length > 0 && textNodes.length > 0) {

				textNode = textNodes.shift();
				textNodeStart = offset;
				textNodeEnd = offset + textNode.length;

				if (
					(textNodeStart >= start && textNodeStart < end) ||
					(textNodeEnd > start && textNodeEnd <= end) ||
					(start >= textNodeStart && start < textNodeEnd) ||
					(end > textNodeStart && end <= textNodeEnd)
				) {

					setStart = Math.max(start - textNodeStart, 0);
					setEnd = Math.min(setStart + Math.min(length, textNode.length), textNodeEnd);
					range = document.createRange();
					range.setStart(textNode, setStart);
					range.setEnd(textNode, setEnd);
					selection.addRange(range);
					length -= (setEnd - setStart);
				}

				offset += textNode.length;
			}
		},

		actualSelectionMatchesExpectedSelection: function (start, length) {

			var selection = window.getSelection();
			var actualSelectedContent = selection.toString();
			var expectedSelectedContent = this.getExpectedSelectedContent(start, length);

			// Replace tab characters with space characters.
			actualSelectedContent = actualSelectedContent.replace(/\s/g, ' ');

			return expectedSelectedContent === actualSelectedContent;
		},

		getExpectedSelectedContent: function (start, length) {

			var textContent = this.getTextContent();
			var expectedSelectedContent = textContent.substr(start, length);

			// Replace empty lines with a hyphen character.
			expectedSelectedContent = expectedSelectedContent.replace(/(\n\r|\r|\n){2,}/g, '-');

			// Remove single line break characters.
			expectedSelectedContent = expectedSelectedContent.replace(/\n\r|\r|\n/g, '');

			// Replace tab characters with space characters.
			expectedSelectedContent = expectedSelectedContent.replace(/\s/g, ' ');

			return expectedSelectedContent;
		},

		getTextNodesFromDomElement: function (element) {

			var textNodes = [];

			for (var i = 0, n = element.childNodes.length; i < n; i++) {
				var childNode = element.childNodes[i];
				if (childNode.tagName !== undefined) {

					// Not a text node.

					textNodes = textNodes.concat(this.getTextNodesFromDomElement(childNode));

				} else {

					textNodes.push(childNode);
				}
			}

			return textNodes;
		},

		renderSelectionBoxes: function (start, end) {

			if (this.options.debug) {
				console.log('renderSelectionBoxes()');
			}

			this.$selection.empty();

			var fontSize = this.getFontSize();
			var t = this.getTextTransforms();
			var angle = t.rotation;

			// Cache of a previous selection box element.
			var $prevBox;
			// Cache for a bounding box of a previous character.
			var prevBbox;

			var bbox;
			for (var i = start; i < end; i++) {

				var $box = this.$selectionBox.clone();

				// `getCharBBox()` can throw an exception in situations where
				// the character position is outside the range where
				// the `getStartPositionOfChar()` and `getEndPositionOfChar()`
				// methods can operate. An example of this is a text along a path
				// that is shorter than that of the text. In this case,
				// we fail silently. This is safe because the result of this
				// is selection boxes not being rendered for characters
				// outside of the visible text area - which is actually desired.
				try {
					bbox = this.getCharBBox(i);
				} catch (e) {
					this.trigger('select:out-of-range', start, end);
					break;
				}

				// A small optimization for the number of char-selection-box div elements.
				// If one box is right after the other, there is no need to render them both.
				// Instead, simply adjust the width of the previous one.
				if (prevBbox && angle === 0 && Math.round(bbox.y) === Math.round(prevBbox.y) &&
					Math.round(bbox.height) === Math.round(prevBbox.height) &&
					Math.round(bbox.x) === Math.round(prevBbox.x + prevBbox.width)) {

					$prevBox.css({ width: '+=' + bbox.width });

				} else {

					// Using font size instead of bbox.height makes the bounding box
					// of the character more precise. Unfortunately, getting an accurate
					// bounding box of a character in SVG is not easy.
					$box.css({
						left: bbox.x,
						top: bbox.y - bbox.height,
						width: bbox.width,
						height: bbox.height,
						'-webkit-transform': 'rotate(' + angle + 'deg)',
						'-webkit-transform-origin': '0% 100%',
						'-moz-transform': 'rotate(' + angle + 'deg)',
						'-moz-transform-origin': '0% 100%'
					});
					this.$selection.append($box);
					$prevBox = $box;
				}
				prevBbox = bbox;
			}

			if (bbox) {

				this.$textareaContainer.css({
					left: bbox.x,
					top: bbox.y - fontSize * t.scaleY
				});
			}
		},

		clearSelection: function () {

			if (this.options.debug) {
				console.log('clearSelection()');
			}

			this.$selection.empty();

			if (this.options.text.selectSubString) {

				if (this.$viewport && this._viewportUserSelectBefore) {
					this.$viewport.css({
						'-webkit-user-select': this._viewportUserSelectBefore,
						'-moz-user-select': this._viewportUserSelectBefore,
						'user-select': this._viewportUserSelectBefore
					});
				}

				window.getSelection().removeAllRanges();
			}

			return this;
		},

		// @public
		// Cancel selection of the text.
		deselect: function () {

			if (this.options.debug) {
				console.log('deselect()');
			}

			this.stopSelecting();
			this.clearSelection();
			this.setTextAreaSelection(this.selection.start, this.selection.end);

			return this;
		},

		// @public
		// Return the start character position of the current selection.
		getSelectionStart: function () {

			return this.selection.start;
		},

		// @public
		// Return the end character position of the current selection.
		getSelectionEnd: function () {

			return this.selection.end;
		},

		// @public
		// Return an object with `start` and `end` properties describing
		// the *normalized* selection range.
		getSelectionRange: function () {

			return this.normalizeSelectionRange(this.selection);
		},

		normalizeSelectionRange: function (selection) {

			selection = joint.util.clone(selection);

			// Normalize.
			if (selection.start > selection.end) {
				selection.end = [selection.start, selection.start = selection.end][0];
			}

			return selection;
		},

		// @public
		// Return the length of the selection.
		getSelectionLength: function () {

			var range = this.getSelectionRange();
			return range.end - range.start;
		},

		// @public
		// Return the selected text.
		getSelection: function () {

			var range = this.getSelectionRange();
			return this.getTextContent().slice(range.start, range.end);
		},

		// @public
		// Return the start and end character positions for a word
		// under `charNum` character position.
		getWordBoundary: function (charNum) {

			var text = this.textarea.value;
			var re = /\W/;

			var start = charNum;
			while (start) {
				if (re.test(text[start])) {
					start += 1;
					break;
				}
				start -= 1;
			}

			var numberOfChars = this.getNumberOfChars();
			var end = charNum;
			while (end <= numberOfChars) {
				if (re.test(text[end])) {
					break;
				}
				end += 1;
			}

			// Normalize before returning.
			return (start < end) ? [start, end] : [end, start];
		},

		getURLBoundary: function (charNum) {

			var text = this.textarea.value;

			var whitespaceRegEx = /\s/;
			var weburlRegEx = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/;
			var start = charNum;
			while (start) {
				if (whitespaceRegEx.test(text[start])) {
					start += 1;
					break;
				}
				start -= 1;
			}

			var numberOfChars = this.getNumberOfChars();
			var end = charNum;
			while (end <= numberOfChars) {
				if (whitespaceRegEx.test(text[end])) {
					break;
				}
				end += 1;
			}

			if (weburlRegEx.test(text.substring(start, end))) {
				return [start, end];
			}
			return undefined;
		},

		annotateURL: function (annotations, selectionStart, selectionEnd) {

			// Include the actual URL with the annotation object. This is very useful to
			// have for cases where the text does not reflect the URL but rather only the title of the URL.
			// In this case, we still want to know what was the original URL.
			var url = this.textarea.value.substring(selectionStart, selectionEnd);
			var urlAnnotation = joint.util.assign({ url: url }, this.options.urlAnnotation);

			urlAnnotation.start = selectionStart;
			urlAnnotation.end = selectionEnd;
			// Do not add the annotation if there was the exact same
			// one at the end already.
			if (!joint.util.isEqual(urlAnnotation, annotations[annotations.length - 1])) {
				annotations.push(urlAnnotation);
			}

			return annotations;
		},

		// Get the bounding box (in screen coordinates) of the character
		// under `charNum` position (the real one, not the SVG one).
		getCharBBox: function (charNum) {

			// For a newline character (line ending), return a bounding box
			// that is derived from the previous - non newline - character
			// and move it to the right of that character.
			if (this.isLineEnding(charNum)) {
				var bbox = this.getCharBBox(charNum - 1);
				//bbox.x = bbox.x + bbox.width + -7;
				bbox.x = bbox.x2;
				bbox.y = bbox.y2;
				bbox.width = this.options.newlineCharacterBBoxWidth || 10;
				return bbox;
			}

			var svgCharNum = this.realToSvgCharNum(charNum);
			var elText = this.options.text;
			var startPosition = elText.getStartPositionOfChar(svgCharNum);
			var endPosition = elText.getEndPositionOfChar(svgCharNum);
			var extent = elText.getExtentOfChar(svgCharNum);

			startPosition = this.localToScreenCoordinates(startPosition);
			endPosition = this.localToScreenCoordinates(endPosition);

			var t = this.getTextTransforms();
			var x = startPosition.x;
			var y = startPosition.y;
			var w = extent.width * t.scaleX;
			var h = extent.height * t.scaleY;

			return { x: x, y: y, width: w, height: h, x2: endPosition.x, y2: endPosition.y };
		},

		realToSvgCharNum: function (charNum) {
			// Calculate the position of the character in the SVG `<text>` element.
			// The reason why those two don't match (`charNum` and `svgCharNum`) is
			// because in the SVG `<text>` element, there are no newline characters.
			var lineEndings = 0;
			for (var i = 0; i <= charNum; i++) {
				if (this.isLineEnding(i)) {
					lineEndings += 1;
				}
			}

			return charNum - lineEndings;
		},

		selectionStartToSvgCharNum: function (selectionStart) {

			return selectionStart - this.nonEmptyLinesBefore(selectionStart);
		},

		// Return `true` if the character at the position `charNum` is
		// a newline character but does not denote an empty line.
		// In other words, the newline character under `charNum` is
		// ending a non-empty line.
		isLineEnding: function (charNum) {

			var text = this.textarea.value;

			return text[charNum] === '\n' && charNum > 0 && text[charNum - 1] !== '\n';
		},

		svgToRealCharNum: function (svgCharNum) {

			var newLinesBefore = 0;
			for (var i = 0; i <= svgCharNum + newLinesBefore; i++) {
				if (this.isLineEnding(i)) {
					newLinesBefore += 1;
				}
			}
			return svgCharNum + newLinesBefore;
		},

		localToScreenCoordinates: function (p) {

			// [IE fix] The text element must be visible, otherwise getCTM() doesn't work.
			// See:
			// http://stackoverflow.com/questions/10714779/svgs-node-getscreenctm-method-failing-in-ie-9/10731378#10731378
			$(this.options.text).show();

			return V.transformPoint(p, this.options.text.getCTM());
		},

		// @public
		// Return the number of characters in the text.
		getNumberOfChars: function () {

			return this.getTextContent().length;
		},

		// @public
		// Return the character position (the real one) the user clicked on.
		// If there is no such a position found, return the last one.
		getCharNumFromEvent: function (evt) {

			var elText = this.options.text;
			var clientX = evt.clientX;
			var clientY = evt.clientY;
			var localClientPoint = V(elText).toLocalPoint(clientX, clientY);
			var svgCharNum = elText.getCharNumAtPosition(localClientPoint);

			// The user clicked somewhere outside, always return the last char num.
			if (svgCharNum < 0) {

				return this.getNumberOfChars();
			}

			var clientScreen = this.localToScreenCoordinates(localClientPoint);

			// If the user clicked on the "left" side of the character,
			// return the character position of the clicked character, otherwise
			// return the character position of the character after the clicked one.
			var bbox = this.getCharBBox(this.svgToRealCharNum(svgCharNum));
			if (Math.abs(bbox.x - clientScreen.x) < Math.abs(bbox.x + bbox.width - clientScreen.x)) {

				return this.svgToRealCharNum(svgCharNum);
			}

			return this.svgToRealCharNum(svgCharNum) + 1;
		},

		lineNumber: function (selectionStart) {

			var text = this.textarea.value.substr(0, selectionStart);

			return this.countLineBreaks(text);
		},

		emptyLinesBefore: function (selectionStart) {

			var lines = this.textarea.value.split(/\n\r|\r|\n/g);
			var lineNumber = this.lineNumber(selectionStart);
			var n = 0;
			for (var i = lineNumber - 1; i >= 0; i--) {
				if (!lines[i]) {
					n += 1;
				}
			}
			return n;
		},

		countLineBreaks: function (text) {

			return (text.match(/\n\r|\r|\n/g) || []).length;
		},

		countEmptyLines: function (text) {

			return (text.match(/(\n\r|\r|\n){2,}/g) || []).length;
		},

		nonEmptyLinesBefore: function (selectionStart) {

			return this.lineNumber(selectionStart) - this.emptyLinesBefore(selectionStart);
		},

		isEmptyLine: function (lineNumber) {

			var lines = this.textarea.value.split(/\n\r|\r|\n/g);
			return !lines[lineNumber];
		},

		isEmptyLineUnderSelection: function (selectionStart) {

			var lineNumber = this.lineNumber(selectionStart);
			return this.isEmptyLine(lineNumber);
		},

		getTextTransforms: function () {

			var screenCTM = this.options.text.getCTM();
			return V.decomposeMatrix(screenCTM);
		},

		getFontSize: function () {

			return parseInt(V(this.options.text).attr('font-size'), 10);
		},

		getTextAnchor: function () {

			return V(this.options.text).attr('text-anchor') || '';
		},

		// @public
		// Set the caret position based on the selectionStart of the textarea unless
		// `charNum` is provided in which case the caret will be set just before the
		// character at `charNum` position (starting from 0).
		setCaret: function (charNum, opt) {

			if (joint.util.isObject(charNum)) {
				opt = charNum;
				charNum = undefined;
			}

			opt = opt || {};

			var elText = this.options.text;
			var numberOfChars = this.getNumberOfChars();
			var selectionStart = this.selection.start;
			var text = this.textarea.value;

			if (typeof charNum !== 'undefined') {

				// Keep the character number within the valid range of characters.
				charNum = Math.min(Math.max(charNum, 0), numberOfChars);

				selectionStart = this.selection.start = this.selection.end = charNum;
			}

			if (!opt.silent) {
				this.trigger('caret:change', selectionStart);
			}

			this.setTextAreaSelection(selectionStart, selectionStart);

			if (this.options.debug) {
				console.log('setCaret(', charNum, opt, ')', 'selectionStart', selectionStart, 'isLineEnding', this.isLineEnding(selectionStart), 'isEmptyLineUnderSelection', this.isEmptyLineUnderSelection(selectionStart), 'svgCharNum', this.selectionStartToSvgCharNum(selectionStart), 'nonEmptyLinesBefore', this.nonEmptyLinesBefore(selectionStart));
			}

			var caretPosition;

			// `getStartPositionOfChar()` or `getEndPositionOfChar()` can throw an exception
			// in situations where the character position is outside the range of
			// the visible text area. In this case, we just hide the caret altogether -
			// which is desired because the user is editing a text that is not visible.
			// An example of this is a text along a path that is shorter than that of the text.
			try {

				var charIndex;

				// - If we're on an empty line, always take the start position of the
				//   SVG space character on that line.
				// - If we're at the end of the line, take the end position of the SVG character before.
				// - If we're at the end of the text, also take the end position of the character before.
				// - For all other cases, take the start position of the SVG character before the selection.
				if (!this.isEmptyLineUnderSelection(selectionStart) && (this.isLineEnding(selectionStart) || text.length === selectionStart)) {

					charIndex = this.selectionStartToSvgCharNum(selectionStart) - 1;
					caretPosition = elText.getEndPositionOfChar(charIndex);

				} else {

					charIndex = this.selectionStartToSvgCharNum(selectionStart);
					caretPosition = elText.getStartPositionOfChar(charIndex);
				}

			} catch (e) {

				this.trigger('caret:out-of-range', selectionStart);

				caretPosition = {
					x: 0,
					y: 0
				};
			}

			// Convert the caret local position (in the coordinate system of the SVG `<text>`)
			// into screen coordinates.
			var caretScreenPosition = this.localToScreenCoordinates(caretPosition);

			// Set the position of the caret. If the number of characters is zero, the caretPosition
			// is `{ x: 0, y: 0 }`, therefore it is not the the bottom right corner of the character but
			// the top left. Therefore, we do not want to shift the caret up using the `margin-top` property.
			var t = this.getTextTransforms();
			var angle = t.rotation;
			// TODO: fontSize should be based on the actual font size of the character
			// under the cursor, not the text global font size. This will improve
			// UX for rich text.
			var fontSize = this.getFontSize() * t.scaleY;

			if (this.options.placeholder) {
				this.$caret.toggleClass('placeholder', numberOfChars === 0);
			}

			this.$caret.css({
				left: caretScreenPosition.x,
				top: caretScreenPosition.y + (numberOfChars ? -fontSize : 0),
				height: fontSize,
				'line-height': fontSize + 'px',
				'font-size': fontSize + 'px',
				'-webkit-transform': 'rotate(' + angle + 'deg)',
				'-webkit-transform-origin': '0% 100%',
				'-moz-transform': 'rotate(' + angle + 'deg)',
				'-moz-transform-origin': '0% 100%'
			}).attr({
				'text-anchor': this.getTextAnchor()
			}).show();

			this.$textareaContainer.css({
				left: caretScreenPosition.x,
				top: caretScreenPosition.y + (numberOfChars ? -fontSize : 0)
			});

			// Always focus. If the caret was set as a reaction on
			// mouse click, the textarea looses focus in FF.
			this.focus();

			return this;
		},

		focus: function () {

			if (this.options.debug) {
				console.log('focus()');
			}

			this.showCaret();

			return this;
		},

		blur: function () {

			if (this.options.debug) {
				console.log('blur()');
			}

			this.hideCaret();

			return this;
		},

		showCaret: function () {

			if (this.options.debug) {
				console.log('showCaret()');
			}

			this.$caret.show();

			return this;
		},

		// @public
		// Hide the caret (cursor).
		hideCaret: function () {

			if (this.options.debug) {
				console.log('hideCaret()');
			}

			this.$caret.hide();

			return this;
		},

		unbindTextElement: function () {

			this.$elText.off('mousedown', this.onMousedown);
			this.$elText.off('dblclick', this.onDoubleClick);
			this.$elText.off('click', this.onTripleClick);
		},

		onRemove: function () {

			this.deselect();
			this.unbindTextElement();

			$(document.body).off('mousemove', this.onMousemove);
			$(document.body).off('mouseup', this.onMouseup);
			$(document.body).off('keydown', this.onKeydown);

			// TODO: Optional?
			V(this.options.text).attr('cursor', '');
		}

	}, joint.util.assign({

		// A tiny helper that checks if `el` is an SVG `<text>` or `<tspan>` element
		// and returns it if yes, otherwise it returns `undefined`.
		// Especially useful when working with events, e.g.:
		// $(document.body).on('click', function(evt) {
		//     var t = joint.ui.TextEditor.getTextElement(evt.target);
		//     if (t) { ... } else { ... }
		// })
		getTextElement: function (el) {

			var tagName = el.tagName.toUpperCase();

			if (tagName === 'TEXT' || tagName === 'TSPAN' || tagName === 'TEXTPATH') {

				if (tagName === 'TEXT') return el;
				return this.getTextElement(el.parentNode);
			}

			return undefined;
		},

		// @public
		// Start inline editing an SVG text element. Therefore, `el` should always
		// be either an SVG `<text>` element directly or any of its descendants
		// `<tspan>` or `<textpath>` in which case the text editor automatically
		// finds the nearest `<text>` element climbing up the DOM tree.
		// If it can't find any `<text>` element, an error is printed to the console
		// and `undefined` is returned. Otherwise, the instance of the `ui.TextEditor`
		// is returned.
		// Options:
		// `opt.placeholder` ... Placeholder that will be passed to the `ui.TextEditor` instance.
		// `opt.annotations` ... Annotations that will be set on the `ui.TextEditor` instance.
		// `opt.cellView` ... For simplicity, we add direct support for JointJS cells.
		// `opt.annotationsProperty` ... If `opt.cellView` is used, annotations will be looked up and set from/to the cellView model by this property name.
		// `opt.textProperty` ... If `opt.cellView` is used, text will be set to the cellView model to this property name.
		edit: function (el, opt) {

			opt = opt || {};

			// By default, the text editor automatically updates either the cellView text string
			// and annotations (if `opt.cellView` is used) or the SVG text element via Vectorizer.
			// This behaviour can be supressed by passing `update: false` in the options.
			// In that case, it is the responsibility of the programmer to update the text and annotations.
			var update = opt.update !== false;

			this.options = joint.util.assign({}, opt, { update: update });

			var textElement = this.getTextElement(el);

			if (!textElement) {

				if (this.options.debug) {
					console.log('ui.TextEditor: cannot find a text element.');
				}

				return undefined;
			}

			// If there was another active text editor open, close it first.
			this.close();

			this.ed = new joint.ui.TextEditor(joint.util.assign({ text: textElement }, opt));

			// Proxy all events triggered by the `ui.TextEditor` to all the listeners
			// on the `ui.TextEditor` class singleton.
			this.ed.on('all', this.trigger, this);

			// The target container to render the `ui.TextEditor` instance into.
			// If `opt.cellView` is used, the `paper.el` will be used, otherwise the parent node
			// of the SVG document which our `textElement` resides will be used.
			var target;

			// Add support for JointJS cells to make integration easier.
			if (opt.cellView) {

				target = opt.cellView.paper.el;

				this.cellViewUnderEdit = opt.cellView;
				// Prevent dragging during inline editing.
				this.cellViewUnderEditInteractiveOption = this.cellViewUnderEdit.options.interactive;
				this.cellViewUnderEdit.options.interactive = false;

				// Set annotations by the property name. Look them up from the cellView model.
				if (opt.annotationsProperty && !this.ed.getAnnotations()) {

					var annotations = this.cellViewUnderEdit.model.prop(opt.annotationsProperty);
					if (annotations) {
						// Note that we have to deep clone the annotations so that
						// all the backbone `changed` mechanism works. This is because
						// the text editor modifies the `annotations` array in-place.
						this.ed.setAnnotations(this.deepCloneAnnotations(annotations));
					}
				}

			} else {

				var svg = V(textElement).svg();
				target = svg.parentNode;
			}

			if (update) {

				this.ed.on('text:change', function (newText, oldText, annotations) {

					if (opt.cellView) {

						// The index of a link label in the DOM. The problem with links is that
						// when we update through prop() below, all the old labels are removed from DOM
						// and replaced with new SVG text elements. This, however, causes the text editor
						// to hold (and work with) the old SVG text element. To solve this, we remember
						// the index of the label under edit and reset the text element on the text
						// editor to point to the newly rendered label SVG text. (see below)
						var originalLabelIndex = null;

						// If `opt.cellView` is used, we automatically set the new text and
						// annotations to the property defined in our options.
						if (opt.textProperty) {

							if (opt.cellView.model.isLink() && opt.textProperty.substr(0, 'labels'.length) === 'labels') {
								originalLabelIndex = V($(V(textElement).node).closest('.label')[0]).index();
							}

							opt.cellView.model.prop(opt.textProperty, newText, { textEditor: this.ed.cid });

						}
						if (opt.annotationsProperty) {
							// Note that we have to deep clone the annotations so that
							// all the backbone `changed` mechanism works. This is because
							// the text editor modifies the `annotations` array in-place.
							opt.cellView.model.prop(opt.annotationsProperty, this.deepCloneAnnotations(annotations), { rewrite: true, textEditor: this.ed.cid });
						}

						if (originalLabelIndex !== null) {
							// Now we replace the text element stored in the text editor with the
							// newly rendered SVG text element.
							var labelElements = V(opt.cellView.el).find('.label');
							textElement = labelElements[originalLabelIndex].findOne('text');
							this.ed.setTextElement(textElement.node);
						}

					} else {

						V(textElement).text(newText, annotations);
					}
				}, this);
			}

			this.ed.render(target);

			return this;
		},

		close: function () {

			if (this.ed) {

				if (this.ed.options.annotateUrls) {
					// If there is a URL detected before we leave the text-editing,
					// annotate it. The only exception is if there was already a URL annotation
					// at the cursor. In this case, we don't create another one.
					var selectionStart = this.ed.getSelectionStart();
					var annotationsUnderCursor = this.findAnnotationsUnderCursor();
					var containsURLAnnotation = annotationsUnderCursor.find(function (annotation) {
						if (annotation.url) return annotation;
						return false;
					});
					if (!containsURLAnnotation) {
						var annotated = this.ed.annotateURLBeforeCaret(selectionStart);
						if (annotated) {
							this.applyAnnotations(this.getAnnotations());
						}
					}
				}

				this.ed.remove();

				if (this.cellViewUnderEdit) {
					// Re-enable dragging after inline editing.
					this.cellViewUnderEdit.options.interactive = this.cellViewUnderEditInteractiveOption;
				}
				this.ed = this.cellViewUnderEdit = this.cellViewUnderEditInteractiveOption = undefined;
			}
		},

		applyAnnotations: function (annotations) {

			var opt = this.options;

			if (this.ed && opt.update) {

				if (opt.cellView && opt.annotationsProperty) {

					// Note that we have to deep clone the annotations so that
					// all the backbone `changed` mechanism works. This is because
					// the text editor modifies the `annotations` array in-place.
					opt.cellView.model.prop(opt.annotationsProperty, this.deepCloneAnnotations(annotations), { rewrite: true });
					this.ed.setAnnotations(annotations);

				} else {

					V(this.ed.options.text).text(this.ed.getTextContent(), annotations);
				}

				// Refresh the selection boxes or the caret position after
				// the annotations are applied.
				var range = this.getSelectionRange();
				var selectionLength = this.getSelectionLength();
				if (selectionLength > 0) {
					this.ed.select(range.start, range.end);
				} else {
					this.ed.setCaret();
				}
			}
		},

		// @private
		deepCloneAnnotations: function (annotations) {

			// JSON.parse/stringify is still the fastest
			// way of deep cloning objects. See http://jsperf.com/lodash-deepclone-vs-jquery-extend-deep/5.
			try {
				return JSON.parse(JSON.stringify(annotations));
			} catch (e) {
				return undefined;
			}
		},

		// Proxy useful methods to the active `ui.TextEditor` instance.

		proxy: function (method, args) {

			if (this.ed) {
				return this.ed[method].apply(this.ed, args);
			}
		},

		setCurrentAnnotation: function (attributes) {

			return this.proxy('setCurrentAnnotation', arguments);
		},

		getAnnotations: function () {

			return this.proxy('getAnnotations', arguments);
		},

		setCaret: function () {

			return this.proxy('setCaret', arguments);
		},

		deselect: function () {

			return this.proxy('deselect', arguments);
		},

		selectAll: function () {

			return this.proxy('selectAll', arguments);
		},

		select: function () {

			return this.proxy('select', arguments);
		},

		getNumberOfChars: function () {

			return this.proxy('getNumberOfChars', arguments);
		},

		getCharNumFromEvent: function () {

			return this.proxy('getCharNumFromEvent', arguments);
		},

		getWordBoundary: function () {

			return this.proxy('getWordBoundary', arguments);
		},

		// A proxy to our active `ui.TextEditor` instance.
		findAnnotationsUnderCursor: function () {

			return this.proxy('findAnnotationsUnderCursor', [this.ed.getAnnotations(), this.ed.getSelectionStart()]);
		},

		findAnnotationsInSelection: function () {

			if (!this.ed) return;

			// Get the *normalized* selection range.
			var range = this.ed.getSelectionRange();
			return this.proxy('findAnnotationsInSelection', [this.ed.getAnnotations(), range.start, range.end]);
		},

		getSelectionAttrs: function (annotations) {

			if (!this.ed) return;
			var range = this.ed.getSelectionRange();
			return this.proxy('getSelectionAttrs', [range, annotations]);
		},

		getSelectionLength: function () {

			return this.proxy('getSelectionLength', arguments);
		},

		getSelectionRange: function () {

			return this.proxy('getSelectionRange', arguments);
		}

	}, Backbone.Events));

	joint.ui.Dialog = joint.mvc.View.extend({

		className: 'dialog',

		events: {
			'click .bg': 'action',
			'click .btn-close': 'action',
			'click .controls button': 'action',
			'mousedown .titlebar': 'onDragStart',
			'touchstart .titlebar': 'onDragStart'
		},

		options: {
			draggable: false,
			closeButtonContent: '&times;',
			closeButton: true,
			inlined: false,
			modal: true
		},

		init: function () {

			joint.util.bindAll(this, 'onDrag', 'onDragEnd');
		},

		render: function () {

			var $bg = $('<div/>', { 'class': 'bg', 'data-action': 'close' });
			var $fg = $('<div/>', { 'class': 'fg' });
			var $titlebar = $('<div/>', { 'class': 'titlebar' });
			var $body = $('<div/>', { 'class': 'body' });
			var $btnClose = $('<button/>', { 'class': 'btn-close', 'data-action': 'close', html: this.options.closeButtonContent });
			var $controls = $('<div/>', { 'class': 'controls' });

			this.$el.toggleClass('draggable', !!this.options.draggable);

			if (this.options.type) {
				this.$el.attr('data-type', this.options.type);
			}

			if (this.options.inlined) {
				this.$el.addClass('inlined');
			}

			if (this.options.modal) {
				this.$el.addClass('modal');
			}

			if (this.options.width) {
				$fg.width(this.options.width);
			}

			if (this.options.title) {
				$titlebar.append(this.options.title);
			} else {
				$titlebar.addClass('empty');
			}

			if (this.options.content) {
				$body.append(this.options.content);
			}

			if (this.options.buttons) {

				this.options.buttons.reverse().forEach(function (button) {

					var $button = $('<button/>', {
						'class': 'control-button',
						html: button.content,
						'data-action': button.action
					});

					// Currently only `'left'` position is supported. If
					// no position is passed, it is considered to be `'right'`.
					if (button.position) {
						$button.addClass(button.position);
					}

					$controls.append($button);
				});
			}

			$fg.append($titlebar, $body, $controls);

			if (this.options.closeButton) {
				$fg.append($btnClose);
			}

			this.$el.empty().append($bg, $fg);

			return this;
		},

		open: function (el) {

			// Events might have been undelegated by a previous `close()` call.
			this.delegateEvents();

			this.on('action:close', this.close, this);

			$(document.body).on({
				'mousemove.dialog touchmove.dialog': this.onDrag,
				'mouseup.dialog touchend.dialog': this.onDragEnd
			});

			$(el || document.body).append(this.render().el);

			this.$el.addClass('rendered');
			return this;
		},

		close: function () {

			this.remove();
			return this;
		},

		onRemove: function () {

			$(document.body).off('.dialog', this.onDrag).off('.dialog', this.onDragStart);
		},

		action: function (evt) {

			var $button = $(evt.target).closest('[data-action]');
			var action = $button.attr('data-action');
			if (action) {

				this.trigger('action:' + action);
			}
		},

		onDragStart: function (evt) {

			if (this.options.draggable) {

				evt = joint.util.normalizeEvent(evt);

				this._dx = evt.clientX;
				this._dy = evt.clientY;
				this._dragging = true;
			}
		},

		onDrag: function (evt) {

			if (this._dragging) {

				evt = joint.util.normalizeEvent(evt);

				var $fg = this.$('.fg');
				var offset = $fg.offset();
				$fg.css({
					top: offset.top + (evt.clientY - this._dy),
					left: offset.left + (evt.clientX - this._dx),
					margin: 0
				});

				this._dx = evt.clientX;
				this._dy = evt.clientY;
			}
		},

		onDragEnd: function () {

			this._dragging = false;
		}

	});

	joint.ui.FlashMessage = joint.ui.Dialog.extend({

		className: joint.ui.Dialog.prototype.className + ' flash-message',

		options: joint.util.merge({}, joint.ui.Dialog.prototype.options, {
			closeButton: true,
			modal: false,
			cascade: true,
			closeAnimation: {
				delay: 2000,
				duration: 200,
				easing: 'swing',
				properties: {
					opacity: 0
				}
			},
			openAnimation: {
				duration: 200,
				easing: 'swing',
				properties: {
					opacity: 1
				}
			}
		}),

		init: function () {

			joint.util.bindAll(this, 'startCloseAnimation');

			joint.ui.Dialog.prototype.init.apply(this, arguments);

			this.on('close:animation:complete', this.close, this);
		},

		open: function () {

			joint.ui.Dialog.prototype.open.apply(this, arguments);

			// Store foreground height for later use.
			var $fg = this.$('.fg');
			this._foregroundHeight = $fg.height();

			this.addToCascade();

			$fg.css('height', 0);
			this.startOpenAnimation();

			if (this.options.closeAnimation && this.options.closeAnimation.delay) {

				setTimeout(this.startCloseAnimation, this.options.closeAnimation.delay);
			}

			return this;
		},

		close: function () {

			joint.ui.Dialog.prototype.close.apply(this, arguments);

			this.removeFromCascade();

			return this;
		},

		addToCascade: function () {

			if (this.options.cascade) {

				var top = this.constructor.top;
				this.$('.fg').css('top', top);
				this.constructor.top += this._foregroundHeight + this.constructor.padding;
			}

			this.constructor.opened.push(this);
		},

		removeFromCascade: function () {

			if (this.options.cascade) {

				// Update top coordinate of all the cascading flash messages after me.
				var openedFlashMessages = this.constructor.opened;
				var isAfter = false;
				for (var i = 0; i < openedFlashMessages.length; i++) {
					var opened = openedFlashMessages[i];
					if (opened.options.cascade && isAfter) {
						var openedTop = parseInt(opened.$('.fg').css('top'), 10);
						opened.$('.fg').css('top', openedTop - this._foregroundHeight - this.constructor.padding);
					}
					if (opened === this) {
						isAfter = true;
					}
				}

				if (isAfter) {
					// Only decrease the height if this flash messages is in the
					// opened list. It could be that someone called close() multiple times
					// and that would take `top` to negative numbers.
					this.constructor.top -= (this._foregroundHeight + this.constructor.padding);
				}
			}

			this.constructor.opened = joint.util.without(this.constructor.opened, this);
		},

		startCloseAnimation: function () {

			this.$('.fg').animate(this.options.closeAnimation.properties, joint.util.assign({

				complete: function () {

					this.trigger('close:animation:complete');

				}.bind(this)

			}, this.options.closeAnimation));
		},

		startOpenAnimation: function () {

			var $fg = this.$('.fg');
			$fg.animate(joint.util.assign({}, this.options.openAnimation.properties, { height: this._foregroundHeight }), joint.util.assign({

				complete: function () {

					this.trigger('open:animation:complete');

				}.bind(this)

			}, this.options.openAnimation));
		}
	}, {

			// @private Top coordinate of the next flash message. If they are configured as `cascade`, they will stack on top of the other.
			top: 20,

			// @public Global padding between flash messages.
			padding: 15,

			// @private List of all opened flash messages.
			opened: [],

			// @public
			open: function (content, title, opt) {

				opt = opt || {};

				return new joint.ui.FlashMessage(joint.util.assign({
					title: title,
					type: 'info',
					content: content
				}, opt)).open(opt.target);
			},

			close: function () {

				joint.util.invoke(this.opened, 'close');
			}
		});

	(function (joint, Backbone, _) {
		'use strict';

		/**
		 * @constructor
		 */
		var Keyboard = function () {

			joint.util.bindAll(this, 'handleKey');
			this.parser = new KeyboardParser();
			this.enable();
		};

		joint.util.assign(Keyboard.prototype, Backbone.Events);

		/**
		 * Bind a callback function to an object. Same logic as [Backbone.Events.on](http://backbonejs.org/#Events-on)
		 * @public
		 * @param {string|object} evt shortcut definition
		 *  * string:  [type:]value,
		 *
		 * where event is defined as [type:]value
		 * * type: keypress, keydown, keyup
		 * * value: modifier+char
		 *
		 * supported modifiers definition:
		 * '⇧', 'shift', '⌥', 'alt', 'option', '⌃', 'ctrl', 'control', '⌘', 'command', 'meta'
		 *
		 * for special characters use this definitions:
		 * **backspace, tab, clear, enter, return, esc, escape, space, left, up, right, down, del, delete, home, end, pageup, pagedown, plus**
		 * ```javascript
		 *  //simple shortcut
		 *  keyboardInstance.on('backspace', handleDelete, this);
		 *  // more multiple shortcut definition
		 *  keyboardInstance.on('ctr+c command+c', copy);
		 *  //event as object
		 *  keyboardInstance.on({
		 *      'keyup:a': handlerA
		 *      'b': handlerB
		 *  }, copy);
		 * ```
		 * @param {function} callback Ignored when event is defined as an object
		 * @param {Object=} context
		 * @returns {Keyboard}
		 */
		Keyboard.prototype.on = function (evt, callback, context) {

			Backbone.Events.on.call(this, this.normalizeEvent(evt), callback, context);
			return this;
		};

		/**
		 * Remove a previously-bound callback function from an object. Same logic as [Backbone.Events.off](http://backbonejs.org/#Events-off)
		 * @public
		 * @param {string|Object} evt
		 * @param {function} callback
		 * @param {Object=} context
		 * @returns {Keyboard}
		 */
		Keyboard.prototype.off = function (evt, callback, context) {

			var remove = evt ? this.normalizeEvent(evt) : null;
			Backbone.Events.off.call(this, remove, callback, context);
			return this;
		};

		/**
		 * @private
		 * @param {string|Object} evt
		 * @returns {*}
		 */
		Keyboard.prototype.normalizeEvent = function (evt) {

			if (typeof evt === 'object') {

				var keys = Object.keys(evt);
				var res = {};
				for (var i = 0, n = keys.length; i < n; i++) {
					var key = keys[i];
					res[this.normalizeEvent(key)] = evt[key]
				}

				return res;
			}

			return this.normalizeShortcut(evt);
		};

		/**
		 * Normalize shortcut definition:
		 * split multiple shortcut definition into parts  'ctrl+c alt+a' => 'ctrl+c', 'alt+a'
		 * normalize parts: ctr +c, ctrl + c, c+ctrl => ctrl+c
		 * hash parts
		 * @private
		 * @param {string} shortcut
		 * @returns {string}
		 */
		Keyboard.prototype.normalizeShortcut = function (shortcut) {

			if (shortcut.toLowerCase() === 'all') {
				return shortcut;
			}

			var eventsToBind = this.parser.toEventObjectList(shortcut);
			var result = [];

			for (var i = 0; i < eventsToBind.length; i++) {
				result.push(this.hash(eventsToBind[i]));
			}

			return result.join(' ');
		};

		/**
		 * Starts tracking keyboard events.
		 * @public
		 */
		Keyboard.prototype.enable = function () {

			if (window.addEventListener) {
				document.addEventListener('keydown', this.handleKey, false);
				document.addEventListener('keypress', this.handleKey, false);
				document.addEventListener('keyup', this.handleKey, false);
			} else if (window.attachEvent) {
				document.attachEvent('keydown', this.handleKey, false);
				document.attachEvent('keypress', this.handleKey, false);
				document.attachEvent('keyup', this.handleKey, false);
			}
		};

		/**
		 * Stops tracking keyboard events.
		 * @public
		 */
		Keyboard.prototype.disable = function () {

			if (window.removeEventListener) {
				document.removeEventListener('keydown', this.handleKey, false);
				document.removeEventListener('keypress', this.handleKey, false);
				document.removeEventListener('keyup', this.handleKey, false);
			} else if (window.detachEvent) {
				document.detachEvent('keydown', this.handleKey, false);
				document.detachEvent('keypress', this.handleKey, false);
				document.detachEvent('keyup', this.handleKey, false);
			}
		};

		/**
		 * Checks if key 'name' is actually pressed.
		 * Limitation: available for modifiers only - 'alt', 'ctrl', 'shift', 'command'
		 * @public
		 * @param {string} name
		 * @param {KeyboardEvent} evt
		 * @returns {boolean}
		 */
		Keyboard.prototype.isActive = function (name, evt) {
			return this.isModifierActive(name, evt);
		};

		/**
		 * @private
		 * @param {string} key
		 * @param {KeyboardEvent} evt
		 * @returns {boolean}
		 */
		Keyboard.prototype.isModifierActive = function (key, evt) {

			var events = this.parser.toEventObjectList(key);

			for (var i = 0; i < events.length; i++) {
				if (events[i].modifiersCompare(evt)) {
					return true;
				}
			}

			return false;
		};

		/**
		 * @private
		 * @param {KeyboardEvent} evt
		 * @returns {string}
		 */
		Keyboard.prototype.hash = function (evt) {

			var toInt = function (value) {
				return value ? 1 : 0;
			};

			var parts = [
				evt.type, ':',
				evt.which,
				toInt(evt.shiftKey),
				toInt(evt.ctrlKey),
				toInt(evt.altKey),
				toInt(evt.metaKey)
			];

			return parts.join('');
		};

		/**
		 * @private
		 * @param {KeyboardEvent} evt
		 */
		Keyboard.prototype.handleKey = function (evt) {

			if (this.isUnsupportedElement(evt)) {
				return;
			}

			var ev = KeyboardEvent.fromNative(evt);
			Backbone.Events.trigger.call(this, this.hash(ev), evt);
		};

		/**
		 * @private
		 * @param {KeyboardEvent} evt
		 * @returns {boolean}
		 */
		Keyboard.prototype.isUnsupportedElement = function (evt) {

			var element = evt.target || evt.srcElement;
			if (element) {
				var tagName = element.tagName.toUpperCase();
				return tagName === 'INPUT' || tagName === 'SELECT' || tagName === 'TEXTAREA' || element.isContentEditable;
			}

			return false;
		};

		/**
		 * @constructor
		 * @private
		 */
		var KeyboardParser = function () {

		};

		KeyboardParser.prototype = {

			constructor: KeyboardParser,


			/**
			 * @public
			 * @param {string} str
			 * @returns {Object}
			 */
			parseEventString: function (str) {

				str = str || '';
				var parts = str.split('+');
				var strPart;
				var event = new KeyboardEvent(0);
				var i;

				for (i = 0; i < parts.length; i++) {
					strPart = parts[i];
					var modifierName = this.getModifierPropertyName(strPart);

					if (modifierName) {
						event[modifierName] = true;
					}

					if (parts.length === 1 || modifierName === undefined) {
						event.which = KeyboardParser.getCode(strPart);
					}
				}
				return event;
			},

			/**
			 * @public
			 * @param {string} str
			 */
			toEventObjectList: function (str) {

				//remove white space(s) surrounding '+'
				// ctrl +   c => ctrl+c
				var rawEventsParts = str.replace(/\s*\+\s*/gi, '+').split(' ');

				return rawEventsParts.map(this.composeEventObject, this);
			},

			/**
			 * @private
			 * @param {string} rawEvent
			 * @returns {Object}
			 */
			composeEventObject: function (rawEvent) {

				var parts = rawEvent.split(':');
				var type = Types.KEYDOWN;
				var shortcutValue = parts[0];

				if (parts.length > 1) {
					shortcutValue = parts[1];
					type = parts[0];
				}

				if (AvailableEventTypes.indexOf(type) === -1) {
					throw rawEvent + ': invalid shortcut definition';
				}

				var ev = this.parseEventString(shortcutValue);

				// to treat modifier also as a regular keystroke we need to switch of the modifier activity flag for the keyup event.
				if (type === Types.KEYUP && modifierMap[ev.which]) {
					ev[modifierMap[ev.which]] = false;
				}

				return ev.setType(type);
			},

			/**
			 * @private
			 * @param {string} key
			 * @returns {*}
			 */
			getModifierPropertyName: function (key) {

				var code = modifier[key];
				return modifierMap[code];
			}
		};

		/**
		 * @static
		 * @param {string} char
		 * @returns {number}
		 */
		KeyboardParser.getCode = function (char) {
			return keyMap[char] || char.toUpperCase().charCodeAt(0);
		};

		var modifier = {
			'⇧': 16, shift: 16,
			'⌥': 18, alt: 18, option: 18,
			'⌃': 17, ctrl: 17, control: 17,
			'⌘': 91, command: 91, meta: 91
		};

		var modifierMap = {
			16: 'shiftKey',
			18: 'altKey',
			17: 'ctrlKey',
			91: 'metaKey'
		};

		var charCodeAlternatives = {

			226: '\\',

			// Opera
			57392: 'ctrl',
			63289: 'num',
			// Firefox
			59: ';',
			61: '=',
			173: '-'
		};

		var keyMap = {
			backspace: 8,
			tab: 9,

			shift: 16,
			ctrl: 17,
			alt: 18,
			meta: 91,

			clear: 12,
			enter: 13,
			'return': 13,
			esc: 27,
			escape: 27,
			capslock: 20,
			space: 32,
			left: 37,
			up: 38,
			right: 39, down: 40,
			del: 46,
			'delete': 46,
			home: 36,
			end: 35,
			insert: 45,
			ins: 45,
			pageup: 33, pagedown: 34,
			plus: 187,
			minus: 189,

			'-': 189,
			',': 188, '.': 190, '/': 191,
			'`': 192, '=': 187,
			';': 186, '\'': 222,
			'[': 219, ']': 221, '\\': 220,

			'F1': 112,
			'F2': 113,
			'F3': 114,
			'F4': 115,
			'F5': 116,
			'F6': 117,
			'F7': 118,
			'F8': 119,
			'F9': 120,
			'F10': 121,
			'F11': 122,
			'F12': 123
		};

		/**
		 * @enum {string}
		 */
		var Types = {
			KEYPRESS: 'keypress',
			KEYDOWN: 'keydown',
			KEYUP: 'keyup'
		};

		/**
		 * @Array<Types>
		 */
		var AvailableEventTypes = [
			Types.KEYPRESS,
			Types.KEYDOWN,
			Types.KEYUP
		];

		/**
		 * @param {number} charCode
		 * @param {boolean=} isShift
		 * @param {boolean=} isCtrl
		 * @param {boolean=} isAlt
		 * @param {boolean=} isMeta
		 * @param {Types} type
		 * @constructor
		 * @private
		 */
		var KeyboardEvent = function (charCode, isShift, isCtrl, isAlt, isMeta, type) {
			this.which = charCode;
			this.shiftKey = isShift || false;
			this.ctrlKey = isCtrl || false;
			this.altKey = isAlt || false;
			this.metaKey = isMeta || false;
			this.type = type || Types.KEYDOWN;
		};

		/**
		 * @public
		 * @param {KeyboardEvent} e
		 * @returns {KeyboardEvent}
		 */
		KeyboardEvent.fromNative = function (e) {

			var normalizedCharCode = e.which;

			if (e.type === Types.KEYPRESS) {
				normalizedCharCode = String.fromCharCode(e.which).toUpperCase().charCodeAt(0);
			}

			if (charCodeAlternatives[normalizedCharCode]) {
				normalizedCharCode = KeyboardParser.getCode(charCodeAlternatives[normalizedCharCode]);
			}

			var event = new KeyboardEvent(normalizedCharCode, e.shiftKey, e.ctrlKey, e.altKey, e.metaKey, e.type);

			// to treat modifier as a regular keystroke we need to switch of the modifier activity flag for the keyup event.
			if (e.type === Types.KEYUP && modifierMap[normalizedCharCode]) {
				event[modifierMap[normalizedCharCode]] = false;
			}

			return event
		};

		/**
		 * @public
		 * @param {KeyboardEvent} eventToCompare
		 */
		KeyboardEvent.prototype.modifiersCompare = function (eventToCompare) {

			return (this.shiftKey ? this.shiftKey === eventToCompare.shiftKey : true) &&
				(this.ctrlKey ? this.ctrlKey === eventToCompare.ctrlKey : true) &&
				(this.altKey ? this.altKey === eventToCompare.altKey : true) &&
				(this.metaKey ? this.metaKey === eventToCompare.metaKey : true);
		};

		/**
		 *
		 * @param {Types} type
		 */
		KeyboardEvent.prototype.setType = function (type) {
			this.type = type;
			return this;
		};

		joint.ui.Keyboard = Keyboard;

	}(joint, Backbone, _));

	joint.ui.Lightbox = joint.ui.Dialog.extend({

		className: joint.ui.Dialog.prototype.className + ' lightbox',

		options: joint.util.merge({}, joint.ui.Dialog.prototype.options, {
			closeButton: true,
			modal: true,
			closeAnimation: {
				delay: 2000,
				duration: 200,
				easing: 'swing',
				properties: {
					opacity: 0
				}
			},
			top: 100,// The distance from the image to the top of the screen.
			windowArea: .8,// The maxium percentage of the window that is covered by lightbox.
			openAnimation: false
		}),

		init: function () {

			joint.util.bindAll(this, 'startCloseAnimation', 'positionAndScale');

			joint.ui.Dialog.prototype.init.apply(this, arguments);

			if (this.options.image) {
				this.$image = $('<img/>').on('load', this.positionAndScale);
				this.options.content = this.$image;
			}

			$(window).on('resize', this.positionAndScale);
			this.on('close:animation:complete', this.remove, this);
		},

		open: function () {

			joint.ui.Dialog.prototype.open.apply(this, arguments);

			// Load the image content when the dialog element is already in the DOM - IE is not able
			// to measure the element if it's not previously rendered.
			if (this.$image) {
				this.$image.attr('src', this.options.image);
			}

			this.positionAndScale();
			this.startOpenAnimation();
			return this;
		},

		positionAndScale: function () {

			// We do our best to show both the image and the titlebar text in the window
			// without any scrolling.
			var $fg = this.$('.fg');
			var $img = this.$('.body > img');
			var ratio = this.options.windowArea;
			var width = window.innerWidth * ratio;

			// Offset the whole lightbox by the `options.top` coordinate.
			this.$el.css('margin-top', this.options.top);

			// Get the height of the titlbar taking into account its final width.
			var $titlebar = this.$('.titlebar');
			$titlebar.css('width', width);
			var titlebarHeight = $titlebar.height();

			// Calculate the height of the whole lightbox foreground, without the titlebar.
			var height = window.innerHeight * ratio - titlebarHeight - this.options.top;
			$titlebar.css('width', 'auto');

			// Set maximum area for the image and let the image scale via CSS (max-width/max-height).
			$fg.css({ width: width, height: height });

			// Now set the foreground bbox according to the image size. so that
			// controls (titlebar and close button) can be positioned in CSS relative
			// to the foreground.
			var imageWidth = $img.width();
			var imageHeight = $img.height();

			$fg.css({ width: imageWidth, height: imageHeight });
		},

		close: function () {

			if (this.options.closeAnimation) {
				this.startCloseAnimation();
			} else {
				joint.ui.Dialog.prototype.close.apply(this, arguments);
			}

			return this;
		},

		onRemove: function () {

			joint.ui.Dialog.prototype.onRemove.apply(this, arguments);
			$(window).off('resize', this.positionAndScale);

			if (this.$image) {
				this.$image.off('load', this.positionAndScale);
			}
		},

		startCloseAnimation: function () {

			this.$el.animate(this.options.closeAnimation.properties, joint.util.assign({

				complete: function () {

					this.trigger('close:animation:complete');

				}.bind(this)

			}, this.options.closeAnimation));
		},

		startOpenAnimation: function () {

			this.$el.animate(joint.util.assign({}, this.options.openAnimation.properties, { height: this._foregroundHeight }), joint.util.assign({

				complete: function () {

					this.trigger('open:animation:complete');

				}.bind(this)

			}, this.options.openAnimation));
		}
	});

	// A context toolbar.
	// Context toolbar contains tools (usually buttons) that should be displayed below a certain target element.
	// Only one context toolbar can be opened at a time. This simplifies the process and makes sure you don't have to
	// keep track of opened context toolbars.

	joint.ui.ContextToolbar = joint.mvc.View.extend({

		className: 'context-toolbar',

		eventNamespace: 'context-toolbar',

		events: {
			'click .tool': 'onToolPointerdown'
		},

		options: {
			padding: 20,
			autoClose: true
		},

		init: function () {

			joint.util.bindAll(this, 'onDocumentMousedown');
		},

		render: function () {

			if (this.constructor.opened) {
				// Only one context toolbar can be opened at a time.

				this.constructor.close();
			}

			this.bind();

			if (this.options.type) {
				this.$el.attr('data-type', this.options.type);
			}

			$(this.getRoot()).append(this.$el);

			this.renderContent();

			this.position();

			this.constructor.opened = this;

			return this;
		},

		renderContent: function () {

			var $tools = $('<div/>', { 'class': 'tools' });

			if (this.options.tools) {

				joint.util.toArray(this.options.tools).forEach(function (tool) {

					var $html;
					if (tool.icon) {
						$html = $('<img/>', { src: tool.icon });
					} else {
						$html = tool.content;
					}

					var $tool = $('<button/>', {
						'class': 'tool',
						html: $html,
						'data-action': tool.action
					});

					if (tool.attrs) {
						$tool.attr(tool.attrs);
					}

					$tools.append($tool);
				});
			}

			this.$el.append($tools);
		},

		getRoot: function () {

			return this.options.root || document.documentElement;
		},

		position: function () {

			var bbox = joint.util.getElementBBox(this.options.target);
			var rootBbox = joint.util.getElementBBox(this.getRoot());
			var width = this.$el.outerWidth();

			var left = bbox.x + bbox.width / 2 - width / 2;
			var top = bbox.y + bbox.height + this.options.padding;

			left -= rootBbox.x;
			top -= rootBbox.y;

			this.$el.css({ left: left, top: top });
		},

		onRemove: function () {

			this.unbind();
			this.constructor.opened = undefined;
		},

		bind: function () {

			// It is important to have the toolbar opened on `mousedown` event instead
			// of `click`. This is because we want to handle the earliest event possible.
			// Imagine you want to show the context toolbar when the user clicks an element.
			// We render the toolbar. If we were to register a handler for click,
			// the user would at some point release its mouse, this toolbar would
			// catch the click event outside of both the target and the toolbar
			// itself and would remove itself immediately.
			$(document).on('mousedown.' + this.eventNamespace, this.onDocumentMousedown);
		},

		unbind: function () {

			$(document).off('mousedown.' + this.eventNamespace, this.onDocumentMousedown);
			return this;
		},

		onToolPointerdown: function (evt) {

			var $tool = $(evt.target).closest('[data-action]');
			var action = $tool.attr('data-action');
			if (action) {

				this.trigger('action:' + action, evt);
			}
		},

		onDocumentMousedown: function (evt) {

			if (this.options.autoClose) {
				var target = this.options.target;
				if (!this.el.contains(evt.target) && !target.contains(evt.target) && target !== evt.target) {
					// Check if the user clicked outside the context toolbar and hide it if yes.
					this.constructor.close();
					this.remove();
				}
			}
		}

	}, {

			opened: undefined,  // The currently opened context toolbar.

			close: function () {

				if (this.opened) {
					this.opened.remove();
					this.opened = undefined;
				}
			},

			// Call whenever the `options.target` changes its position.
			update: function () {

				if (this.opened) {
					this.opened.position();
				}
			}

		});

	// ui.Popup is like ui.ContextToolbar except that it can contain any HTML.
	// This is useful for displaying a contextual widget that contains forms or other
	// HTML. Popups also have an arrow pointing up.

	// @import ui.ContextToolbar

	joint.ui.Popup = joint.ui.ContextToolbar.extend({

		className: 'popup',

		eventNamespace: 'popup',

		events: {},

		renderContent: function () {

			var content = joint.util.isFunction(this.options.content) ? this.options.content(this.el) : this.options.content;
			if (content) {
				this.$el.html(content);
			}
		}
	});

	joint.ui.SelectBox = joint.mvc.View.extend({

		className: 'select-box',

		events: {
			'click .select-box-selection': 'onToggle'
		},

		options: {
			options: [],    // Example: `{ content: '<b>foo</b><br/><small>bar</small>', value: 'foo', selected: true }`
			width: undefined,   // Set the width of the select box in JS. If `undefined`, it is assumed the width is set in CSS.
			openPolicy: 'auto', // Determines where the options panel will be displayed.
			target: null,
			keyboardNavigation: true,
			selected: undefined,  // selected value can either be defined directly in the options array or here as an index to it.
			selectBoxOptionsClass: undefined,
			disabled: false
		},

		init: function () {

			this.options.target = this.options.target || document.body;

			joint.util.bindAll(this, 'onOutsideClick', 'onOptionSelect');

			$(document).on('click.selectBox', this.onOutsideClick);

			this.$el.data('view', this);

			if (this.options.selected === undefined) {

				// If there is no selection at the beginning, we assume it is the first
				// option in the options array. This behaviour copies the behaviour
				// of the native `<select>` HTML element.
				this.selection = joint.util.toArray(this.options.options).find(function (item) {
					return item.selected === true;
				}) || this.options.options[0];

			} else {

				this.selection = this.options.options[this.options.selected];
			}
		},

		render: function () {

			this.$el.empty();
			this.$selection = null;

			this.renderSelection(this.selection);

			if (this.options.width) {
				this.$el.css('width', this.options.width);
			}

			if (this.options.disabled) {
				this.disable();
			}

			this.$el.append(this.$options);

			return this;
		},

		renderOptions: function () {

			this.removeOptions();

			var options = this.options;
			var config = {
				selectBoxView: this,
				parentClassName: joint.util.result(this, 'className') || null,
				extraClassName: joint.util.result(options, 'selectBoxOptionsClass') || null,
				options: options.options
			};

			if (options.width) {
				config.width = options.width;
			}
			if (options.theme) {
				config.theme = options.theme;
			}

			var optionsView = this.optionsView = new this.constructor.OptionsView(config);
			optionsView.render();
			this.listenTo(optionsView, 'option:select', this.onOptionSelect);
			this.listenTo(optionsView, 'option:hover', this.onOptionHover);
			this.listenTo(optionsView, 'options:mouseout', this.onOptionsMouseOut);
			this.$options = optionsView.$el;
			this.$optionsArrow = optionsView.$arrow;
			this.$target = $(options.target);
		},

		onOptionHover: function (option, idx) {

			this.trigger('option:hover', option, idx);
		},

		onOptionsMouseOut: function (evt) {

			this.trigger('options:mouseout', evt);
		},

		onOptionSelect: function (idx, opt) {

			this.select(idx, opt);
		},

		removeOptions: function () {

			if (this.optionsView) {
				this.stopListening(this.optionsView);
				this.optionsView.remove();
				this.optionsView = null;
			}
		},

		renderSelection: function (option) {

			if (!this.$selection) {
				this.$selection = $('<div/>', { 'class': 'select-box-selection' });
				this.$el.append(this.$selection);
			}

			this.$selection.empty();

			if (option) {

				var $option = this.constructor.OptionsView.prototype.renderOptionContent.call(undefined, option);
				this.$selection.append($option);

			} else if (this.options.placeholder) {

				var $placeholder = $('<div/>', { 'class': 'select-box-placeholder', html: this.options.placeholder });
				this.$selection.append($placeholder);
			}
		},

		onToggle: function (evt) {

			this.toggle();
		},

		onOutsideClick: function (evt) {

			// Check the clicked element is really outside our select box.
			if (!this.el.contains(evt.target) && this.$el.hasClass('opened')) {
				this.close();
			}
		},

		getSelection: function () {

			return this.selection;
		},

		getSelectionValue: function (selection) {

			selection = selection || this.selection;

			return selection && (selection.value === undefined ? selection.content : selection.value);
		},

		getSelectionIndex: function () {

			return joint.util.toArray(this.options.options).findIndex(function (item) {
				return item === this.selection;
			});
		},

		select: function (idx, opt) {

			this.selection = this.options.options[idx];
			this.renderSelection(this.selection);
			this.trigger('option:select', this.selection, idx, opt);
			this.close();
		},

		selectByValue: function (value, opt) {

			var options = this.options.options || [];
			for (var i = 0; i < options.length; i++) {
				var option = options[i];
				if (option.value === undefined && option.content === value) {
					return this.select(i, opt);
				} else if (option.value !== undefined && joint.util.isEqual(option.value, value)) {
					return this.select(i, opt);
				}
			}
		},

		isOpen: function () {

			return this.$el.hasClass('opened');
		},

		toggle: function () {

			if (this.isOpen()) {
				this.close();
			} else {
				this.open();
			}
		},

		position: function () {

			var $selection = this.$('.select-box-selection');

			var selectionHeight = $selection.outerHeight();
			var selectionOffset = $selection.offset();
			var selectionLeft = selectionOffset.left;
			var selectionTop = selectionOffset.top;

			var optionsHeight = this.$options.outerHeight();

			var targetBBox = { left: 0, top: 0 };

			if (this.options.target !== document.body) {

				targetBBox = this.$target.offset();

				targetBBox.width = this.$target.outerWidth();
				targetBBox.height = this.$target.outerHeight();
				targetBBox.left -= this.$target.scrollLeft();
				targetBBox.top -= this.$target.scrollTop();
			} else {

				targetBBox.width = $(window).width();
				targetBBox.height = $(window).height();
			}

			var left = selectionLeft;
			var top = 'auto';
			var openPolicy = this.options.openPolicy;

			// For a selected open policy and no selection, we fallback to the
			// 'auto' open policy. This is because we don't know the position of the
			// selected option as there is no.
			if (openPolicy === 'selected' && !this.selection) {
				openPolicy = 'auto';
			}

			switch (openPolicy) {
				case 'above':
					top = selectionTop - optionsHeight;
					break;
				case 'coverAbove':
					top = selectionTop - optionsHeight + selectionHeight;
					break;
				case 'below':
					top = selectionTop + selectionHeight;
					break;
				case 'coverBelow': // default
					top = selectionTop;
					break;
				case 'selected':
					var selectedOptionPosition = this.$options.find('.selected').position();
					top = selectionTop - selectedOptionPosition.top;
					break;
				default: // 'auto'
					// It's like coverBelow but it tries to find the best spot. If the
					// select box does not fit to the screen (goes below the screen edge),
					// display it as coverAbove.

					var isOptionsOverBottomEdge = (selectionTop - this.$target.scrollTop() + optionsHeight > targetBBox.top + targetBBox.height);
					top = isOptionsOverBottomEdge ? selectionTop - optionsHeight + selectionHeight : selectionTop;

					break;
			}

			// Position relative to target element
			left -= targetBBox.left;
			top -= targetBBox.top;

			this.$options.css({ left: left, top: top });
		},

		open: function () {

			if (this.isDisabled()) return;
			this.renderOptions();
			this.$options.appendTo(this.options.target);
			this.$options.addClass('rendered');
			this.position();
			this.$el.addClass('opened');
			this.respectWindowBoundaries();
			this.alignOptionsArrow();
		},

		respectWindowBoundaries: function () {

			var overflow = this.calculateElOverflow(this.$options);
			var increment = {
				left: 0,
				top: 0
			};

			if (this.$options.outerWidth() <= this.$target.innerWidth()) {

				// Only adjust for left/right overflow if options element fits within target element.

				if (overflow.left && overflow.right) {
					// Do nothing if overflowing both the left and right.
				} else if (overflow.left) {
					increment.left = overflow.left;
				} else if (overflow.right) {
					increment.left = -overflow.right;
				}
			}

			if (this.$options.outerHeight() <= this.$target.innerHeight()) {

				// Only adjust for top/bottom overflow if options element fits within target element.

				if (overflow.top && overflow.bottom) {
					// Do nothing if overflowing both the top and bottom.
				} else if (overflow.top) {
					increment.top = overflow.top;
				} else if (overflow.bottom) {
					increment.top = -overflow.bottom;
				}
			}

			this.$options.css({
				left: '+=' + increment.left,
				top: '+=' + increment.top
			});
		},

		alignOptionsArrow: function () {

			var elBBox = this.$el[0].getBoundingClientRect();
			var optionsBBox = this.$options[0].getBoundingClientRect();
			var newLeft = elBBox.left + (elBBox.width / 2);

			newLeft -= optionsBBox.left;
			newLeft -= this.$optionsArrow.outerWidth() / 2;

			this.$optionsArrow.css({
				left: newLeft
			});
		},

		close: function () {

			this.removeOptions();
			this.$el.removeClass('opened');

			this.trigger('close');
		},

		onRemove: function () {

			this.removeOptions();
			$(document).off('.selectBox', this.onOutsideClick);
		},

		isDisabled: function () {

			return this.$el.hasClass('disabled');
		},

		enable: function () {

			this.$el.removeClass('disabled');
		},

		disable: function () {

			this.close();
			this.$el.addClass('disabled');
		},

		onSetTheme: function (oldTheme, newTheme) {

			if (this.$options) {

				if (oldTheme) {
					this.$options.removeClass(this.themeClassNamePrefix + oldTheme);
				}

				this.$options.addClass(this.themeClassNamePrefix + newTheme);
			}
		},

		/*
			Calculate the number of pixels an element is overflowing the target container.
		*/
		calculateElOverflow: function (el, target) {

			if (!target) {
				target = window;
			}

			if (el instanceof $) {
				el = el[0];
			}

			if (target instanceof $) {
				target = target[0];
			}

			var overflow = {};
			var elBBox = el.getBoundingClientRect();
			var targetBBox;

			if (target === window) {

				// Window doesn't have getBoundingClientRect method.

				var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

				targetBBox = {
					width: windowWidth,
					height: windowHeight,
					left: 0,
					top: 0,
					right: windowWidth,
					bottom: windowHeight
				};

			} else {
				targetBBox = target.getBoundingClientRect();
			}

			['left', 'top'].forEach(function (side) {
				overflow[side] = Math.min(0, elBBox[side] - targetBBox[side]);
			});

			['right', 'bottom'].forEach(function (side) {
				overflow[side] = Math.min(0, targetBBox[side] - elBBox[side]);
			});

			joint.util.forIn(overflow, function (value, key) {
				overflow[key] = Math.abs(Math.round(value));
			});

			return overflow;
		}

	}, {

			// Statics

			OptionsView: joint.mvc.View.extend({

				events: {
					'mouseover .select-box-option': 'onOptionHover',
					'click .select-box-option': 'onOptionClick'
				},

				className: function () {

					var classNames = ['select-box-options'];
					var parentClassName = this.options.parentClassName;

					if (parentClassName) {
						classNames.push(parentClassName);
					}

					return classNames.join(' ');
				},

				init: function () {

					joint.util.bindAll(this, 'onMouseout', 'onKeydown');

					$(document).on({
						'keydown.selectBoxOptions': this.onKeydown,
						'mouseleave.selectBoxOptions mouseout.selectBoxOptions': this.onMouseout
					});
				},

				render: function () {

					var extraClassName = this.options.extraClassName;
					if (extraClassName) {
						this.$el.addClass(extraClassName);
					}

					if (this.options.width) {
						this.$el.css('width', this.options.width);
					}
					joint.util.toArray(this.options.options).forEach(function (option, idx) {

						var $option = this.renderOption(option, idx);

						if (this.options.selectBoxView.selection === option) {
							$option.addClass('selected hover');
						}

						this.$el.append($option);

					}, this);

					this.$arrow = $('<div/>').addClass('select-box-options-arrow').appendTo(this.$el);

					return this;
				},

				renderOption: function (option, idx) {

					var $option = this.renderOptionContent(option);
					$option.addClass('select-box-option');
					$option.data('index', idx);
					return $option;
				},

				renderOptionContent: function (option) {

					var $option = $('<div/>', { 'class': 'select-box-option-content', html: option.content });

					if (option.icon) {
						$option.prepend($('<img/>', {
							'class': 'select-box-option-icon',
							src: option.icon
						}));
					}

					return $option;
				},

				select: function (idx, opt) {

					this.trigger('option:select', idx, opt);
				},

				hover: function (idx) {

					var option = this.options.options[idx];
					this.markOptionHover(idx);
					this.trigger('option:hover', option, idx);
				},

				onOptionClick: function (evt) {

					var idx = this.getOptionIndex(evt.target);
					this.select(idx, { ui: true });
				},

				onOptionHover: function (evt) {

					var idx = this.getOptionIndex(evt.target);
					this.hover(idx);
				},

				onMouseout: function (evt) {

					this.trigger('options:mouseout', evt);
				},

				onKeydown: function (evt) {

					var selectBoxView = this.options.selectBoxView;

					if (!selectBoxView.options.keyboardNavigation) return;
					if (!selectBoxView.isOpen()) return;

					var dir;

					switch (evt.which) {

						case 39:    // right
						case 40:    // down
							dir = 1;
							break;
						case 38:    // up
						case 37:    // left
							dir = -1;
							break;
						case 13:    // enter
							var hoverIndex = this.getOptionHoverIndex();
							// `hoverIndex === -1` means no option has been hovered yet.
							if (hoverIndex >= 0) {
								this.select(hoverIndex);
							}
							return;
						case 27:    // esc
							return selectBoxView.close();
						default:
							return; // noop; Unsupported key.
					}

					// Prevent page scrolling.
					evt.preventDefault();

					var idx = this.getOptionHoverIndex();
					var nextIdx = idx + dir;
					var options = this.options.options;

					// Normalize and cycle if necessary.
					if (nextIdx < 0) { nextIdx = options.length - 1; }
					if (nextIdx >= options.length) { nextIdx = 0; }

					this.hover(nextIdx);
				},

				onRemove: function () {

					$(document).off('.selectBoxOptions');
				},

				markOptionHover: function (idx) {

					this.$el.find('.hover').removeClass('hover');
					$(this.$el.find('.select-box-option')[idx]).addClass('hover');
				},

				getOptionHoverIndex: function () {

					return this.$el.find('.select-box-option.hover').index();
				},

				getOptionIndex: function (el) {

					return $(el).closest('.select-box-option').data('index');
				}
			})
		});

	joint.ui.ColorPalette = joint.ui.SelectBox.extend({

		className: 'select-box color-palette',

		position: function () {

			var $selection = this.$('.select-box-selection');
			var selectionHeight = $selection.outerHeight();
			var selectionOffset = $selection.offset();

			var left = selectionOffset.left;
			var top = selectionOffset.top + selectionHeight;

			if (this.options.target !== document.body) {

				this.$target = this.$target || $(this.options.target);

				// Position relative to target element
				var targetOffset = this.$target.offset();
				left -= targetOffset.left - this.$target.scrollLeft();
				top -= targetOffset.top - this.$target.scrollTop();
			}

			this.$options.css({ left: left, top: top });
		}

	}, {

			// Statics

			OptionsView: joint.ui.SelectBox.OptionsView.extend({

				renderOptionContent: function (option) {

					var $option = $('<div/>', { 'class': 'select-box-option-content' });

					$option.css('background-color', option.content);

					if (option.icon) {
						$option.prepend($('<img/>', {
							'class': 'select-box-option-icon',
							src: option.icon
						}));
					}

					return $option;
				}
			})

		});

	joint.ui.SelectButtonGroup = joint.mvc.View.extend({

		className: 'select-button-group',

		events: {
			'click .select-button-group-button': 'onSelect',
			'mouseover .select-button-group-button': 'onOptionHover',
			'mouseleave': 'onMouseOut',
			'mousedown .select-button-group-button': 'pointerdown',
			'touchstart .select-button-group-button': 'pointerdown',
			'mouseup .select-button-group-button': 'pointerup',
			'touchend .select-button-group-button': 'pointerup'
		},

		options: {
			buttonWidth: undefined,
			buttonHeight: undefined,
			options: [],
			disabled: false,
			multi: false,   // Are multiple selections allowed?
			selected: undefined  // selected value can either be defined directly in the options array or here as an index to it.
		},

		init: function () {

			joint.util.bindAll(this, 'onSelect', 'pointerup');

			this.$el.data('view', this);

			var multi = this.options.multi;

			var optionsItems = this.options.options;
			var selected = this.options.selected;
			if (selected === undefined) {

				var selectedOptions = joint.util.toArray(optionsItems).filter(function (item) {
					return item && item.selected === true;
				});
				this.selection = (multi) ? selectedOptions : selectedOptions[0];

			} else {

				if (multi) {

					this.selection = Array.isArray(selected) ? optionsItems.filter(function (option, idx) {
						return selected.includes(idx);
					}) : [optionsItems[selected]];

				} else {

					this.selection = optionsItems[selected];
				}
			}
		},

		render: function () {

			this.renderOptions(this.selection);

			if (this.options.width) {
				this.$el.css('width', this.options.width);
			}

			if (this.options.disabled) {
				this.disable();
			}

			this.$el.append(this.$options);

			return this;
		},

		renderOptions: function () {

			this.removeOptions();

			var multi = this.options.multi;

			joint.util.toArray(this.options.options).forEach(function (option, idx) {

				var isSelected = (multi ? this.selection.includes(option) : this.selection === option);

				var $option = this.renderOption(option, idx, isSelected);
				this.$el.append($option);

				if (isSelected) {

					$option.addClass('selected');
				}
			}, this);
		},

		removeOptions: function () {

			this.$el.empty();
		},

		renderOption: function (option, idx, isSelected) {

			var $option = this.renderOptionContent(option, isSelected);
			$option.data('index', idx);
			var buttonWidth = option.buttonWidth || this.options.buttonWidth;
			if (buttonWidth) {
				$option.css('width', buttonWidth);
			}
			var buttonHeight = option.buttonHeight || this.options.buttonHeight;
			if (buttonHeight) {
				$option.css('height', buttonHeight);
			}
			return $option;
		},

		renderOptionContent: function (option, isSelected) {

			var $option = $('<div/>', { 'class': 'select-button-group-button', html: option.content });
			if (option.icon || (isSelected && option.iconSelected)) {
				var $icon = $('<img/>', {
					'class': 'select-button-group-button-icon',
					src: isSelected && option.iconSelected ? option.iconSelected : option.icon
				});
				var iconWidth = option.iconWidth || this.options.iconWidth;
				if (iconWidth) {
					$icon.css('width', iconWidth);
				}
				var iconHeight = option.iconHeight || this.options.iconHeight;
				if (iconHeight) {
					$icon.css('height', iconHeight);
				}
				$option.prepend($icon);
			}
			// `option.attrs` allows for setting arbitrary attributes on the generated HTML.
			// This object is of the form: `<selector> : { <attributeName> : <attributeValue>, ... }`
			joint.util.setAttributesBySelector($option, option.attrs);

			return $option;
		},

		getOptionIndex: function (el) {

			return $(el).closest('.select-button-group-button').data('index');
		},

		onSelect: function (evt) {

			if (this.isDisabled()) return;
			var idx = this.getOptionIndex(evt.target);
			this.select(idx, { ui: true });
		},

		onOptionHover: function (evt) {

			if (this.isDisabled()) return;
			var idx = this.getOptionIndex(evt.target);
			this.trigger('option:hover', this.options.options[idx], idx);
		},

		onMouseOut: function (evt) {

			if (this.isDisabled()) return;
			this.trigger('mouseout', evt);
		},

		getSelection: function () {

			return this.selection;
		},

		getSelectionValue: function (selection) {

			selection = selection || this.selection;

			if (!selection) return undefined;

			if (this.options.multi) {
				return joint.util.toArray(selection).map(function (option) {
					return option.value === undefined ? option.content : option.value;
				});
			}
			return selection.value === undefined ? selection.content : selection.value;
		},

		select: function (index, opt) {

			var option = this.options.options[index];
			var $option = $(this.$('.select-button-group-button')[index]);
			var multi = this.options.multi;

			if (multi) {

				$option.toggleClass('selected');
				var isSelected = $option.hasClass('selected');

				if (isSelected) {

					if (this.selection.indexOf(option) === -1) {
						this.selection.push(option);
					}

				} else {

					this.selection = joint.util.without(this.selection, option);
				}

				if (option.iconSelected) {

					$option.find('.select-button-group-button-icon').attr('src', isSelected ? option.iconSelected : option.icon);
				}

			} else {

				this.selection = option;
				var $prevSelected = this.$('.selected');
				var prevSelection = this.options.options[$prevSelected.index()];
				$prevSelected.removeClass('selected');
				$option.addClass('selected');

				if (prevSelection && prevSelection.iconSelected) {
					$prevSelected.find('.select-button-group-button-icon').attr('src', prevSelection.icon);
				}
				if (this.selection.iconSelected) {
					$option.find('.select-button-group-button-icon').attr('src', this.selection.iconSelected);
				}
			}

			this.trigger('option:select', this.selection, index, opt);
		},

		selectByValue: function (value, opt) {

			if (!Array.isArray(value)) {
				value = [value];
			}

			var options = this.options.options || [];
			for (var i = 0; i < options.length; i++) {
				var option = options[i];
				if (option.value === undefined && value.includes(option.content)) {
					this.select(i, opt);
				} else if (option.value !== undefined) {
					var containsOption = value.find(function (val) {
						return joint.util.isEqual(val, option.value);
					});
					if (containsOption) {
						this.select(i, opt);
					}
				}
			}
		},

		deselect: function () {

			this.$('.selected').removeClass('selected');
			if (this.options.multi) {
				this.selection = [];
			} else {
				this.selection = undefined;
			}
		},

		isDisabled: function () {

			return this.$el.hasClass('disabled');
		},

		enable: function () {

			this.$el.removeClass('disabled');
		},

		disable: function () {

			this.$el.addClass('disabled');
		},

		pointerdown: function (evt) {

			var index = this.getOptionIndex(evt.target);
			var $option = $(this.$('.select-button-group-button')[index]);
			$option.addClass('is-in-action');
			$(document).on('mouseup.select-button-group touchend.select-button-group', this.pointerup);
		},

		pointerup: function () {

			this.$('.is-in-action').removeClass('is-in-action');
			$(document).off('mouseup.select-button-group touchend.select-button-group');
		}
	});

	// Navigator
	// =========

	// 'Navigator' creates a new paper (usually smaller) that helps select what part
	// of the diagram is shown (especially for a larger diagram) and provides
	// a different way how to zoom.

	// Example usage:
	//
	// var nav = new joint.ui.Navigator({
	//     paperScroller: paperScroller,
	//     width: 200,
	//     height: 200,
	// });
	//
	// nav.$el.appendTo('#navigator');
	// nav.render();
	joint.ui.Navigator = joint.mvc.View.extend({

		className: 'navigator',

		events: {
			'mousedown': 'startAction',
			'touchstart': 'startAction'
		},

		options: {
			paperConstructor: joint.dia.Paper,
			paperOptions: {},
			/**
			 * @deprecated use zoom instead
			 */
			zoomOptions: null,
			zoom: { min: 0.5, max: 2 },
			width: 300,
			height: 200,
			padding: 10
		},

		init: function () {

			if (this.options.zoomOptions) {
				// backward compatibility
				this.options.zoom = joint.util.assign({}, this.options.zoom, this.options.zoomOptions);
			} else if (this.options.zoom) {
				this.options.zoom = joint.util.defaults({}, this.options.zoom, this.constructor.prototype.options.zoom);
			}

			joint.util.bindAll(this, 'updateCurrentView', 'doAction', 'stopAction', 'scrollTo');

			// The updateCurrentView is called everytime paperScroller's scrollbars change
			// or the paper is resized. Resize of the paper is normally also acompanied
			// by a scrollbar change (but doesn't have to be). An event is triggered for
			// the vertical and horizontal scrollbar change. That leads to the updateCurrentView
			// to be called upto 4 times per one paperScroller action. Debouncing the method solves
			// this issue but there is definitely room for improvement.
			// + it solves an issue with wrong target paper position while zooming out a paper with
			// negative x-origin
			this.updateCurrentView = joint.util.debounce(this.updateCurrentView, 0);

			var paperScroller = this.options.paperScroller;
			paperScroller.$el.on('scroll.navigator', this.updateCurrentView);

			var sourcePaper = this.sourcePaper = paperScroller.options.paper;
			this.listenTo(sourcePaper, 'resize', this.updatePaper);

			var targetPaper = this.targetPaper = new this.options.paperConstructor(joint.util.merge({
				model: sourcePaper.model,
				interactive: false
			}, this.options.paperOptions));

			targetPaper.$el.on({
				'mousedown.navigator': this.scrollTo,
				'touchstart.navigator': this.scrollTo
			});

			$(document.body).on({
				'mousemove.navigator touchmove.navigator': this.doAction,
				'mouseup.navigator touchend.navigator': this.stopAction
			});
		},

		render: function () {

			this.targetPaper.$el.appendTo(this.el);

			// Adding cell views requires the paper element to be appended to the DOM.
			// Make sure the elements are rendered before links.
			var sourceGraph = this.sourcePaper.model;
			var sourceCells = sourceGraph.getElements().concat(sourceGraph.getLinks());

			sourceCells.forEach(this.targetPaper.renderView, this.targetPaper);

			this.$currentView = $('<div>').addClass('current-view');

			if (this.options.zoom) {
				var $currentViewControl = $('<div>').addClass('current-view-control');
				this.$currentView.append($currentViewControl);
			}

			this.$el.append(this.$currentView).css({
				width: this.options.width,
				height: this.options.height,
				padding: this.options.padding
			});

			// setting right target paper dimension for the first time.
			this.updatePaper(this.sourcePaper.options.width, this.sourcePaper.options.height);

			return this;
		},

		// Updates the navigator's paper size and transformations
		updatePaper: function (width, height) {

			var sourceOrigin = this.sourcePaper.options.origin;
			var sourceScale = this.sourcePaper.scale();
			var navigatorWidth = this.options.width - 2 * this.options.padding;
			var navigatorHeight = this.options.height - 2 * this.options.padding;

			width /= sourceScale.sx;
			height /= sourceScale.sy;

			var ratio = this.ratio = Math.min(navigatorWidth / width, navigatorHeight / height);
			var ox = sourceOrigin.x * ratio / sourceScale.sx;
			var oy = sourceOrigin.y * ratio / sourceScale.sy;

			width *= ratio;
			height *= ratio;

			this.targetPaper.setDimensions(width, height);
			this.targetPaper.setOrigin(ox, oy);
			this.targetPaper.scale(ratio, ratio);

			this.updateCurrentView();
		},

		// Updates the position and size of the navigator's current view rectangle.
		updateCurrentView: function () {

			var ratio = this.ratio;
			var sourceScale = this.sourcePaper.scale();
			var paperScroller = this.options.paperScroller;
			var topLeftCoordinates = paperScroller.clientToLocalPoint(0, 0);
			var paperPosition = this.targetPaper.$el.position();
			var paperOrigin = this.targetPaper.translate();

			// IE returns translate.ty = NaN when ty = 0. It sets transform attribute to 'translate(tx)'.
			// TODO: handle this in the vectorizer
			paperOrigin.ty = paperOrigin.ty || 0;

			this.currentViewGeometry = {
				top: paperPosition.top + topLeftCoordinates.y * ratio + paperOrigin.ty,
				left: paperPosition.left + topLeftCoordinates.x * ratio + paperOrigin.tx,
				width: paperScroller.$el.innerWidth() * ratio / sourceScale.sx,
				height: paperScroller.$el.innerHeight() * ratio / sourceScale.sy
			};

			this.$currentView.css(this.currentViewGeometry);
		},

		startAction: function (evt) {

			evt = joint.util.normalizeEvent(evt);

			// click on current-view control starts zooming
			// otherwise paper panning is initated.
			this._action = $(evt.target).hasClass('current-view-control')
				? 'zooming'
				: 'panning';

			this._clientX = evt.clientX;
			this._clientY = evt.clientY;
		},

		doAction: function (evt) {

			if (!this._action) return;

			evt = joint.util.normalizeEvent(evt);

			var sourceScale = this.sourcePaper.scale();
			var dx = (evt.clientX - this._clientX) * sourceScale.sx;
			var dy = (evt.clientY - this._clientY) * sourceScale.sy;

			switch (this._action) {

				case 'panning':
					this.options.paperScroller.el.scrollLeft += dx / this.ratio;
					this.options.paperScroller.el.scrollTop += dy / this.ratio;
					break;

				case 'zooming':

					// dx/width is the ratio of the original width and the requested width
					var levelDiff = - dx / this.currentViewGeometry.width;
					this.options.paperScroller.zoom(levelDiff, this.options.zoom);
					break;
			}

			this._clientX = evt.clientX;
			this._clientY = evt.clientY;
		},

		stopAction: function () {

			this._action = null;
		},

		// Scrolls the view to the position determined by the event.
		scrollTo: function (evt) {

			evt = joint.util.normalizeEvent(evt);

			var paperOrigin = this.targetPaper.translate();
			// TODO: see updateCurrentView method
			paperOrigin.ty = paperOrigin.ty || 0;

			var offsetX, offsetY;
			// There is no offsetX/offsetY property in the Firefox event
			if (evt.offsetX === undefined) {
				var targetPaperOffset = this.targetPaper.$el.offset();
				offsetX = evt.pageX - targetPaperOffset.left;
				offsetY = evt.pageY - targetPaperOffset.top;
			} else {
				offsetX = evt.offsetX;
				offsetY = evt.offsetY;
			}

			var cx = (offsetX - paperOrigin.tx) / this.ratio;
			var cy = (offsetY - paperOrigin.ty) / this.ratio;

			this.options.paperScroller.center(cx, cy);
		},

		onRemove: function () {

			this.targetPaper.$el.off('.navigator');
			this.targetPaper.remove();
			this.options.paperScroller.$el.off('.navigator');
			$(document.body).off('.navigator');
		}

	});

	// Tree Graph Layout View.
	// =======================

	// An user interface for the tree layout manipulation.

	joint.ui.TreeLayoutView = joint.mvc.View.extend({

		MINIMAL_PREVIEW_SIZE: 10,
		className: 'tree-layout',

		options: {

			// SVG attributes for the child and parent preview SVG elements.
			previewAttrs: {
				parent: { rx: 2, ry: 2 }
			},

			// Compute the bounding boxes for elements either from the DOM or based
			// on the model size.
			useModelGeometry: false,

			// clone method used when an element preview is created.
			clone: function (cell) {
				return cell.clone();
			},

			// Specify what elements can be interacted with.
			// e.g function(element) { return !element.get('disabled'); }
			canInteract: function () {
				return true;
			}
		},

		init: function () {

			joint.util.bindAll(this, 'onPointermove', 'onPointerup');

			this.toggleDefaultInteraction(false);
			this.startListening();
			this.render();
			this.onSetTheme(null, this.theme);
		},

		// @public
		startListening: function () {

			var paper = this.options.paper;

			this.listenTo(paper, 'element:pointerdown', this.canInteract(this.onPointerdown));
		},

		// @public
		// Enable/Disable the default paper interactions.
		toggleDefaultInteraction: function (interactive) {

			this.options.paper.setInteractivity(interactive);
		},

		render: function () {

			var paper = this.options.paper;

			this.$activeBox = $('<div>')
				.addClass('tree-layout-box active hidden')
				.appendTo(this.el);

			this.draggingPaper = new joint.dia.Paper({
				model: new joint.dia.Graph,
				interactive: false,
				width: '100%',
				height: '100%'
			});

			this.$translateBox = $('<div>')
				.addClass('tree-layout-box translate hidden')
				.append(this.draggingPaper.render().el)
				.appendTo(this.el);

			this.$mask = $('<div>').addClass('tree-layout-mask');

			this.svgViewport = V(paper.viewport);
			this.svgPreviewChild = V('circle')
				.attr(this.options.previewAttrs.child || {})
				.addClass('tree-layout-preview child');
			this.svgPreviewConnection = V('path')
				.attr(this.options.previewAttrs.link || {})
				.addClass('tree-layout-preview link');
			this.svgPreviewParent = V('rect')
				.attr(this.options.previewAttrs.parent || {})
				.addClass('tree-layout-preview parent');
			this.svgPreview = V('g').addClass('tree-layout-preview-group').append([
				this.svgPreviewConnection,
				this.svgPreviewParent,
				this.svgPreviewChild
			]);

			this.$el.appendTo(paper.el);

			return this;
		},

		onSetTheme: function (oldTheme, newTheme) {

			var $elsWithThemeClass = [
				this.svgPreview,
				this.$mask
			];

			$elsWithThemeClass.forEach(function ($elWithThemeClass) {

				if ($elWithThemeClass) {

					if (oldTheme) {
						$elWithThemeClass.removeClass(this.themeClassNamePrefix + oldTheme);
					}

					$elWithThemeClass.addClass(this.themeClassNamePrefix + newTheme);
				}
			}, this);
		},

		onRemove: function () {

			this.svgPreview.remove();
		},

		toggleDropping: function (state) {

			// allows setting various cursor on the paper
			this.$mask.toggleClass('dropping-not-allowed', !state);
			// allows coloring of the translate box based on the state
			this.$translateBox.toggleClass('no-drop', !state);
		},

		canDrop: function () {

			return this.isActive() && !this.$translateBox.hasClass('no-drop');
		},

		isActive: function () {

			return !this.$translateBox.hasClass('hidden');
		},

		_startDrag: function (elements, x, y) {

			var paper = this.options.paper;

			this.$mask.appendTo(paper.el);
			this.toggleDropping(false);

			this.ctm = paper.matrix();

			var element = elements[0];
			var elementView = element.findView(paper);
			var bbox = elementView.getBBox({ useModelGeometry: this.options.useModelGeometry });

			// showing box around active element
			this.updateBox(this.$translateBox, joint.util.defaults({ x: x, y: y }, bbox));
			this.updateBox(this.$activeBox, bbox);

			this.$activeBox.removeClass('hidden');
			this.$translateBox.removeClass('hidden');

			this.prepareDraggingPaper(element);
		},

		updateBox: function ($box, bbox) {

			$box.css({
				width: bbox.width,
				height: bbox.height,
				left: bbox.x,
				top: bbox.y
			});
		},

		positionTranslateBox: function (position) {

			var transformedPosition = V.transformPoint(position, this.ctm);

			this.$translateBox.css({
				left: transformedPosition.x,
				top: transformedPosition.y
			});
		},

		prepareDraggingPaper: function (draggedElement) {

			var clone = this.options.clone(draggedElement).position(0, 0);

			// Zoom the dragging paper the same way as the main paper.
			this.draggingPaper.scale(this.ctm.a, this.ctm.d);
			this.draggingPaper.model.resetCells([clone]);
		},

		_doDrag: function (elements, x, y) {

			var layout = this.model;
			var coordinates = { x: x, y: y };
			var rootLayoutArea;
			var layoutArea;

			if (this.candidate) {
				this.candidate = null;
				this.hidePreview();
			}

			this.positionTranslateBox(coordinates);

			rootLayoutArea = layout.getMinimalRootAreaByPoint(coordinates);
			if (rootLayoutArea) {
				layoutArea = rootLayoutArea.findMinimalAreaByPoint(coordinates, {
					expandBy: Math.min(layout.get('siblingGap'), layout.get('gap')) / 2
				});
			}

			if (layoutArea) {

				var direction = this.findDirection(layoutArea, coordinates);
				var siblings = layoutArea.getLayoutSiblings(direction);
				var siblingRank = siblings.getSiblingRankByPoint(coordinates);

				var isConnectionValid = joint.util.toArray(elements).every(function (item) {
					return this.isConnectionValid(item, siblings, siblingRank);
				}, this);
				if (isConnectionValid) {

					this.candidate = {
						id: layoutArea.root.id,
						direction: direction,
						siblingRank: siblingRank + 0.5
					};

					this.updatePreview(siblings, siblingRank);
					this.showPreview();

					this.toggleDropping(true);

				} else {
					this.toggleDropping(false);
				}

			} else {

				this.toggleDropping(true);
			}
		},

		_finishDrag: function (elements, x, y) {

			this.$mask.remove().removeClass('dropping-not-allowed');

			if (this.candidate) {

				elements.forEach(function (item) {
					this.reconnectElement(item, this.candidate);
				}, this);
				this.candidate = null;
				this.model.layout({ ui: true });

			} else if (this.canDrop()) {

				elements.forEach(function (item) {
					this.translateElement(item, x, y);
				}, this);

				this.model.layout({ ui: true });
			}

			this.$activeBox.addClass('hidden');
			this.$translateBox.addClass('hidden');

			this.hidePreview();
		},

		reconnectElement: function (element, candidate) {

			var opt = {
				direction: candidate.direction,
				siblingRank: candidate.siblingRank,
				ui: true
			};

			var canReconnect = this.model.reconnectElement(element, candidate.id, opt);
			if (!canReconnect) {

				var paper = this.options.paper;
				var link = paper.getDefaultLink(element.findView(paper));

				link.set({ source: { id: candidate.id }, target: { id: element.id } });
				link.addTo(paper.model, opt);

				this.model.changeSiblingRank(element, candidate.siblingRank, opt);
				this.model.changeDirection(element, candidate.direction, opt);

				var prevDirection = this.model.getAttribute(element, 'direction');

				this.model.updateDirections(element, [prevDirection, candidate.direction], opt);
			}
		},

		translateElement: function (element, x, y) {

			var inboundLinks = this.model.graph.getConnectedLinks(element, { inbound: true });

			joint.util.invoke(inboundLinks, 'remove');

			var elementSize = element.get('size');

			element.set('position', {
				x: x - elementSize.width / 2,
				y: y - elementSize.height / 2
			}, { ui: true });
		},

		updatePreview: function (siblings, siblingRank) {

			var parent = siblings.parentArea.root;
			var childWidth = Math.max(this.model.get('siblingGap') / 2, this.MINIMAL_PREVIEW_SIZE);
			var childSize = { width: childWidth, height: childWidth };
			var childPosition = siblings.getNeighborPointFromRank(siblingRank);
			var points = siblings.getConnectionPoints(childPosition, { ignoreSiblings: true });
			var parentPoint = siblings.getParentConnectionPoint();
			var childPoint = siblings.getChildConnectionPoint(childPosition, childSize);

			this.updateParentPreview(parent.get('position'), parent.get('size'));
			this.updateChildPreview(childPosition, childSize);
			this.updateConnectionPreview(parentPoint, childPoint, points);
		},

		showPreview: function () {

			this.svgViewport.append(this.svgPreview);
		},

		hidePreview: function () {

			this.svgPreview.remove();
		},

		updateParentPreview: function (position, size) {

			this.svgPreviewParent.attr({
				x: position.x,
				y: position.y,
				width: size.width,
				height: size.height
			});
		},

		updateChildPreview: function (position, size) {

			this.svgPreviewChild.attr({
				cx: position.x,
				cy: position.y,
				r: size.width / 2
			});
		},

		updateConnectionPreview: function (source, target, vertices) {

			this.svgPreviewConnection.attr({
				d: joint.connectors.rounded(source, target, vertices, {})
			});
		},

		findDirection: function (layoutArea, point) {

			var directions;
			var type = layoutArea.root.get('layout') || layoutArea.getType();
			switch (type) {
				case 'BL-BR':
				case 'TL-TR':
				case 'L-R':
					directions = type.split('-');
					return (point.x > layoutArea.rootCX) ? directions[1] : directions[0];
				case 'BL-TL':
				case 'BR-TR':
				case 'B-T':
					directions = type.split('-');
					return (point.y > layoutArea.rootCY) ? directions[0] : directions[1];
				case 'L':
				case 'R':
				case 'T':
				case 'B':
				case 'TR':
				case 'TL':
				case 'BR':
				case 'BL':
					return type;
				default:
					return layoutArea.direction;
			}
		},

		// @private
		isConnectionValid: function (element, siblings, siblingRank) {

			// Banning a loop connection
			if (element.id == siblings.parentArea.root.id) return false;

			// If the element is ancestor of parent, there would be a loop after connection.
			if (this.model.graph.isSuccessor(element, siblings.parentArea.root)) return false;

			// If we have same parent, same rank direction an we changing only the siblingRank
			// we allow only changes that actually changes the order of siblings.
			var elementArea = this.model.getLayoutArea(element);
			if (elementArea.parentArea && elementArea.parentArea == siblings.parentArea && elementArea.direction == siblings.direction) {
				var rankChange = elementArea.siblingRank - siblingRank;
				if (rankChange === 0 || rankChange === 1) return false;
			}

			return true;
		},

		// Interaction
		canInteract: function (handler) {

			return function (cellView) {
				if (this.options.canInteract(cellView)) {
					handler.apply(this, arguments);
				}
			}.bind(this);
		},

		startDragging: function (elements) {

			var draggedElements = Array.isArray(elements) ? elements : [elements];
			if (!joint.util.isEmpty(draggedElements)) {
				this._registerPointerEvents();
				this._moveCounter = 0;
				this._draggedElements = draggedElements;
			}
		},

		onPointerdown: function (elementView) {

			this.startDragging(elementView.model);
		},

		onPointermove: function (evt) {

			var paper = this.options.paper;
			var localPoint = paper.clientToLocalPoint({ x: evt.clientX, y: evt.clientY });

			if (this._moveCounter === paper.options.clickThreshold) {

				this._startDrag(this._draggedElements, localPoint.x, localPoint.y);

			} else if (this._moveCounter > paper.options.clickThreshold) {

				this._doDrag(this._draggedElements, localPoint.x, localPoint.y);
			}

			this._moveCounter++;
		},

		onPointerup: function (evt) {

			var paper = this.options.paper;

			if (this._moveCounter >= paper.options.clickThreshold) {

				var localPoint = paper.clientToLocalPoint({ x: evt.clientX, y: evt.clientY });

				this._finishDrag(this._draggedElements, localPoint.x, localPoint.y);
			}

			this._draggedElements = null;
			this._unregisterPointerEvents();
		},

		_registerPointerEvents: function () {

			var namespace = this.getEventNamespace();

			$(document)
				.on('mousemove' + namespace + ' touchmove' + namespace, this.onPointermove)
				.on('mouseup' + namespace + ' touchend' + namespace, this.onPointerup);
		},

		_unregisterPointerEvents: function () {

			$(document).off(this.getEventNamespace());
		}

	});

	joint.ui.PathDrawer = joint.mvc.View.extend({

		tagName: 'g',

		svgElement: true,

		className: 'path-drawer',

		events: {
			'mousedown .start-point': 'onStartPointPointerDown',
			'mousedown': 'onPointerDown',
			//'mousemove': 'onPointerMove',
			//'mouseup': 'onPointerUp',
			'touchstart .start-point': 'onStartPointPointerDown',
			'touchstart': 'onPointerDown',
			//'touchmove': 'onPointerMove',
			//'touchend': 'onPointerUp',
			'dblclick': 'onDoubleClick',
			'contextmenu': 'onContextMenu'
		},

		options: {
			pathAttributes: {
				'class': null,
				'fill': '#ffffff',
				'stroke': '#000000',
				'stroke-width': 1,
				'pointer-events': 'none'
			},
			startPointMarkup: '<circle r="5"/>'
		},

		init: function () {

			var svgTarget = this.svgTarget = V(this.options.target);

			this.$document = $(svgTarget.node.ownerDocument);

			this.action = 'awaiting-input';

			this.render();
		},

		bindDocumentEvents: function () {

			var eventNS = this.getEventNamespace();

			this.$document.on('mousemove' + eventNS + ' touchmove' + eventNS, _.bind(this.onPointerMove, this));
			this.$document.on('mouseup' + eventNS + ' touchend' + eventNS, _.bind(this.onPointerUp, this));
		},

		unbindDocumentEvents: function () {

			this.$document.off(this.getEventNamespace());
		},

		onRemove: function () {

			var pathNode = this.pathNode;

			if (pathNode) {
				V(pathNode).remove();
			}

			this.clear();
		},

		clear: function () {

			var pathNode = this.pathNode;

			if (pathNode && pathNode.pathSegList.numberOfItems <= 1) {
				V(pathNode).remove();
			}

			this.svgStart.remove();
			this.svgControl.remove();

			this.pathNode = null;

			this.unbindDocumentEvents();
			this.action = 'awaiting-input';

			this.trigger('clear');
		},

		render: function () {

			var options = this.options;

			this.svgPathTemplate = V('path').attr(options.pathAttributes);

			this.svgStart = V(options.startPointMarkup).addClass('start-point');
			this.svgControl = V('path').addClass('control-path');

			this.vel.append(V('rect', { x: 0, y: 0, width: '100%', height: '100%', fill: 'transparent', stroke: 'none' }));

			this.svgTarget.append(this.el)

			return this;
		},

		createPath: function (x, y) {

			var path = this.svgPathTemplate.clone();
			var pathNode = this.pathNode = path.node;
			var start = this.svgStart.translate(x, y, { absolute: true });

			this.trigger('path:create', pathNode);

			this.addMoveSegment(x, y);

			this.vel.before(path);
			this.vel.append(start);
		},

		closePath: function () {

			var el = this.pathNode;

			var first = el.pathSegList.getItem(0);
			var last = el.pathSegList.getItem(el.pathSegList.numberOfItems - 1);

			if (last.pathSegType == SVGPathSeg.PATHSEG_LINETO_ABS) {

				// if last segment is lineto
				// replace with closepath
				el.pathSegList.replaceItem(el.createSVGPathSegClosePath(), el.pathSegList.numberOfItems - 1);

			} else {

				// if last segment is curveto
				// make sure that last segment ends exactly at beginning of path
				last.x = first.x;
				last.y = first.y;

				// add closepath behind it
				el.pathSegList.appendItem(el.createSVGPathSegClosePath());

			}

			this.finishPath('path:close');
		},

		finishPath: function (pathFinishedEventType) {

			var el = this.pathNode;

			if (el && this.numberOfVisibleSegments() > 0) {

				// the new path is not just a single point; users can see it
				this.trigger('path:finish', el);
				this.trigger(pathFinishedEventType, el);

			} else {

				// the path is just a single point; users cannot see it
				// different event is triggered
				this.trigger('path:abort', el);

			}

			this.clear();
		},

		numberOfVisibleSegments: function () {

			var el = this.pathNode;

			var numberOfVisibleSegments = el.pathSegList.numberOfItems;

			numberOfVisibleSegments -= 1; // the initial moveto segment
			if (el.pathSegList.getItem(el.pathSegList.numberOfItems - 1).pathSegType == SVGPathSeg.PATHSEG_CLOSEPATH) {
				numberOfVisibleSegments -= 1; // if path is invisible, adding Z does not make it visible
			}

			return numberOfVisibleSegments;
		},

		addMoveSegment: function (x, y) {

			var el = this.pathNode;

			var move = el.createSVGPathSegMovetoAbs(x, y);

			el.pathSegList.appendItem(move);

			this.trigger('path:segment:add', el);
			this.trigger('path:move-segment:add', el);
		},

		addLineSegment: function (x, y) {

			var el = this.pathNode;

			var line = el.createSVGPathSegLinetoAbs(x, y);

			el.pathSegList.appendItem(line);

			this.trigger('path:segment:add', el);
			this.trigger('path:line-segment:add', el);
		},

		addCurveSegment: function (x, y, x1, y1, x2, y2) {

			var el = this.pathNode;

			var curve = el.createSVGPathSegCurvetoCubicAbs(x, y, x1, y1, x2 || x, y2 || y);

			el.pathSegList.appendItem(curve);

			this.trigger('path:segment:add', el);
			this.trigger('path:curve-segment:add', el);
		},

		adjustLastSegment: function (x, y, x1, y1, x2, y2) {

			var el = this.pathNode;

			var segment = el.pathSegList.getItem(el.pathSegList.numberOfItems - 1);

			if (x !== null) segment.x = x;
			if (y !== null) segment.y = y;
			if (x1 !== null) segment.x1 = x1;
			if (y1 !== null) segment.y1 = y1;
			if (x2 !== null) segment.x2 = x2;
			if (y2 !== null) segment.y2 = y2;

			this.trigger('path:edit', el);
			this.trigger('path:last-segment:adjust', el);
		},

		removeLastSegment: function () {

			var el = this.pathNode;

			el.pathSegList.removeItem(el.pathSegList.numberOfItems - 1);

			this.trigger('path:edit', el);
			this.trigger('path:last-segment:remove', el);
		},

		findControlPoint: function (x, y) {

			var el = this.pathNode;
			var last = el.pathSegList.getItem(el.pathSegList.numberOfItems - 1);

			return g.point(x, y).reflection(last);
		},

		replaceLastSegmentWithCurve: function () {

			var el = this.pathNode;

			var last = el.pathSegList.getItem(el.pathSegList.numberOfItems - 1);
			var prev = el.pathSegList.getItem(el.pathSegList.numberOfItems - 2);

			var curve = el.createSVGPathSegCurvetoCubicAbs(last.x, last.y, prev.x, prev.y, last.x, last.y);

			el.pathSegList.replaceItem(curve, el.pathSegList.numberOfItems - 1);

			this.trigger('path:edit', el);
			this.trigger('path:last-segment:replace-with-curve', el);
		},

		adjustControlPath: function (x1, y1, x2, y2) {

			var el = this.pathNode;
			var control = this.svgControl.node;

			control.pathSegList.initialize(control.createSVGPathSegMovetoAbs(x1, y1));
			control.pathSegList.appendItem(control.createSVGPathSegLinetoAbs(x2, y2));

			this.vel.append(control);

			this.trigger('path:interact', el);
			this.trigger('path:control:adjust', el);
		},

		removeControlPath: function () {

			var el = this.pathNode;
			var control = this.svgControl.node;

			control.pathSegList.clear();

			this.vel.append(control);

			this.trigger('path:interact', el);
			this.trigger('path:control:remove', el);
		},

		//////////////
		// Handlers //
		//////////////

		onPointerDown: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();

			// left button only (or touch)
			if (evt.which > 1) return;

			// first click only (if this was part of a double click)
			if (evt.originalEvent.detail > 1) return;

			// check if we are in the DOM (after remove)
			if (!this.el.parentNode) return;

			var coordinates = this.vel.toLocalPoint(evt.clientX, evt.clientY);

			switch (this.action) {

				case 'awaiting-input':
					this.createPath(coordinates.x, coordinates.y);
					this.action = 'path-created';
					this.bindDocumentEvents();
					break;

				case 'adjusting-line-end':
					this.action = 'awaiting-line-end';
					break;

				case 'adjusting-curve-end':
					this.action = 'awaiting-curve-control-2';
					break;
			}

			this._timeStamp = evt.timeStamp;
		},

		MOVEMENT_DETECTION_THRESHOLD: 150,

		onPointerMove: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();

			if (this.action == 'awaiting-input') return;

			var start;
			var control;

			var end = this.vel.toLocalPoint(evt.clientX, evt.clientY);

			var timeStamp = this._timeStamp;

			if (!timeStamp) {
				// mouse button is not pressed

				switch (this.action) {

					case 'adjusting-line-end':
						this.adjustLastSegment(end.x, end.y);
						break;

					case 'adjusting-curve-end':
						this.adjustLastSegment(end.x, end.y, null, null, end.x, end.y);
						break;
				}

			} else if (timeStamp && ((evt.timeStamp - timeStamp) < this.MOVEMENT_DETECTION_THRESHOLD)) {
				// mouse button is pressed but threshold for detecting movement has not been reached yet
				// keep following user pointer to prevent jumpy interface effects

				switch (this.action) {

					case 'path-created':
						start = this.svgStart.translate();
						this.adjustControlPath(start.tx, start.ty, end.x, end.y);
						break;

					case 'awaiting-line-end':
					case 'adjusting-curve-control-1':
						this.adjustLastSegment(end.x, end.y);
						break;

					case 'awaiting-curve-control-2':
						this.adjustLastSegment(end.x, end.y, null, null, end.x, end.y);
						break;
				}

			} else {
				// mouse button is pressed and movement is being detected

				switch (this.action) {

					case 'path-created':
						this.action = 'adjusting-curve-control-1';
						break;

					case 'awaiting-line-end':
						this.replaceLastSegmentWithCurve();
						this.action = 'adjusting-curve-control-2';
						break;

					case 'awaiting-curve-control-2':
						this.action = 'adjusting-curve-control-2';
						break;

					case 'adjusting-curve-control-1':
						start = this.svgStart.translate();
						this.adjustControlPath(start.tx, start.ty, end.x, end.y);
						break;

					case 'adjusting-curve-control-2':
						control = this.findControlPoint(end.x, end.y);
						this.adjustLastSegment(null, null, null, null, control.x, control.y);
						this.adjustControlPath(control.x, control.y, end.x, end.y);
						break;
				}
			}
		},

		onPointerUp: function (e) {

			this._timeStamp = null;

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();

			// left button only (or touch)
			if (evt.which > 1) return;

			// first click only (if this was part of a double click)
			if (evt.originalEvent.detail > 1) return;

			var end = this.vel.toLocalPoint(evt.clientX, evt.clientY);

			switch (this.action) {

				case 'path-created':
				case 'awaiting-line-end':
					this.addLineSegment(end.x, end.y);
					this.action = 'adjusting-line-end';
					break;

				case 'awaiting-curve-control-2':
					this.removeControlPath();
					this.addLineSegment(end.x, end.y);
					this.action = 'adjusting-line-end';
					break;

				case 'adjusting-curve-control-1':
				case 'adjusting-curve-control-2':
					this.addCurveSegment(end.x, end.y, end.x, end.y);
					this.action = 'adjusting-curve-end';
					break;
			}
		},

		onStartPointPointerDown: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();

			// left button only (or touch)
			if (evt.which > 1) return;

			// first click only (if this was part of a double click)
			if (evt.originalEvent.detail > 1) return;

			this.closePath();
		},

		onDoubleClick: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.preventDefault();
			evt.stopPropagation();

			// left button only (or touch)
			if (evt.which > 1) return;

			if (this.pathNode && this.numberOfVisibleSegments() > 0) {

				// remove the path element created by first click's mousedown
				this.removeLastSegment();

				this.finishPath('path:stop');
			}
		},

		onContextMenu: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.preventDefault();
			evt.stopPropagation();

			// first click only (if this was part of a double click)
			if (evt.originalEvent.detail > 1) return;

			if (this.pathNode && this.numberOfVisibleSegments() > 0) {

				// remove currently edited path segment
				this.removeLastSegment();

				this.finishPath('path:stop');
			}
		}

	});

	joint.ui.PathEditor = joint.mvc.View.extend({

		tagName: 'g',

		svgElement: true,

		className: 'path-editor',

		events: {
			'mousedown .anchor-point': 'onAnchorPointPointerDown',
			'mousedown .control-point': 'onControlPointPointerDown',
			'mousedown .segment-path': 'onSegmentPathPointerDown',
			//'mousemove': 'onPointerMove', // only bound (while mousedown)
			//'mouseup': 'onPointerUp', // only bound (ends mousedown)
			'touchstart .anchor-point': 'onAnchorPointPointerDown',
			'touchstart .control-point': 'onControlPointPointerDown',
			'touchstart .segment-path': 'onSegmentPathPointerDown',
			//'touchmove': 'onPointerMove', // only bound (while touch)
			//'touchup': 'onPointerUp', // only bound (ends touch)
			'dblclick .anchor-point': 'onAnchorPointDoubleClick',
			'dblclick .control-point': 'onControlPointDoubleClick',
			'dblclick .segment-path': 'onSegmentPathDoubleClick'
		},

		options: {
			anchorPointMarkup: '<circle r="2.5"/>',
			controlPointMarkup: '<circle r="2.5"/>'
		},

		init: function () {

			var pathNode = this.pathNode = V.toNode(this.options.pathElement).normalizePath();

			this.segList = pathNode.pathSegList;
			this.svgRoot = V(pathNode.ownerSVGElement);
			this.$document = $(pathNode.ownerDocument);

			this.render();
		},

		bindDocumentEvents: function () {

			var eventNS = this.getEventNamespace();
			this.$document.on('mousemove' + eventNS + ' touchmove' + eventNS, _.bind(this.onPointerMove, this));
			this.$document.on('mouseup' + eventNS + ' touchend' + eventNS, _.bind(this.onPointerUp, this));
		},

		unbindDocumentEvents: function () {

			this.$document.off(this.getEventNamespace());
		},

		onRemove: function () {

			this.unbindDocumentEvents();
			this.clear();
		},

		clear: function () {

			var vel = this.vel;
			vel.empty();

			this.directionPaths = [];
			this.segmentPaths = [];
			this.controlPoints = [];
			this.anchorPoints = [];

			// first subPath always start at index '0'
			this._subPathIndices = [0];

			this.trigger('clear', this.pathNode);
		},

		_transformPoint: function (x, y, matrix) {
			return V.transformPoint(g.Point(x, y), matrix);
		},

		render: function () {

			this.clear();

			var vel = this.vel;

			var ctm = this.pathNode.getCTM();

			var anchorTpl = V(this.options.anchorPointMarkup).addClass('anchor-point');
			var controlTpl = V(this.options.controlPointMarkup).addClass('control-point');
			var directionPathTpl = V('<path class="direction-path"/>');
			var segPathTpl = V('<path class="segment-path"/>');

			var segList = this.segList;

			var anchorPoints = this.anchorPoints;
			var controlPoints = this.controlPoints;
			var directionPaths = this.directionPaths;
			var segmentPaths = this.segmentPaths;

			var _subPathIndices = this._subPathIndices;

			var index;
			var prevX;
			var prevY;
			for (index = 0, prevX = 0, prevY = 0; index < segList.numberOfItems; index++) {

				var seg = segList.getItem(index);

				var segPoint = this._transformPoint(seg.x, seg.y, ctm);
				var x = segPoint.x;
				var y = segPoint.y;

				if (seg.pathSegType != SVGPathSeg.PATHSEG_CLOSEPATH) {

					anchorPoints[index] = anchorTpl.clone().attr({
						index: index,
						cx: x,
						cy: y
					});
				}

				if (seg.pathSegType != SVGPathSeg.PATHSEG_MOVETO_ABS) {

					var segPath = segPathTpl.clone().attr('index', index).node;
					segPath.pathSegList.initialize(segPath.createSVGPathSegMovetoAbs(prevX, prevY));

					switch (seg.pathSegType) {

						case SVGPathSeg.PATHSEG_CLOSEPATH:
							var subPathStartSeg = segList.getItem(_subPathIndices[0]);

							var subPathStartSegPoint = this._transformPoint(subPathStartSeg.x, subPathStartSeg.y, ctm);
							x = subPathStartSegPoint.x;
							y = subPathStartSegPoint.y;

							segPath.pathSegList.appendItem(segPath.createSVGPathSegLinetoAbs(x, y));
							_subPathIndices.unshift(index + 1);
							break;

						case SVGPathSeg.PATHSEG_LINETO_ABS:
							segPath.pathSegList.appendItem(segPath.createSVGPathSegLinetoAbs(x, y));
							break;

						case SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
							var controlSegPoint1 = this._transformPoint(seg.x1, seg.y1, ctm);
							var controlPt1 = controlTpl.clone().attr({
								index: index,
								'attribute-index': 1,
								cx: controlSegPoint1.x,
								cy: controlSegPoint1.y
							});

							var controlSegPoint2 = this._transformPoint(seg.x2, seg.y2, ctm);
							var controlPt2 = controlTpl.clone().attr({
								index: index,
								'attribute-index': 2,
								cx: controlSegPoint2.x,
								cy: controlSegPoint2.y
							});

							controlPoints[index] = [controlPt1, controlPt2];

							segPath.pathSegList.appendItem(segPath.createSVGPathSegCurvetoCubicAbs(x, y, controlSegPoint1.x, controlSegPoint1.y, controlSegPoint2.x, controlSegPoint2.y));

							directionPaths[index] = [
								directionPathTpl.clone().attr('d', ['M', prevX, prevY, 'L', controlSegPoint1.x, controlSegPoint1.y].join(' ')),
								directionPathTpl.clone().attr('d', ['M', x, y, 'L', controlSegPoint2.x, controlSegPoint2.y].join(' '))
							];
							break;
					}

					segmentPaths[index] = segPath;
				}

				prevX = x;
				prevY = y;

			}

			vel.append(_.filter(segmentPaths))
				.append(_.flatten(_.filter(directionPaths)))
				.append(_.filter(anchorPoints))
				.append(_.flatten(_.filter(controlPoints)));

			this.svgRoot.append(vel);
		},

		startMoving: function (e) {

			var evt = joint.util.normalizeEvent(e);

			var $point = this.$point = $(evt.target);

			this.prevClientX = evt.clientX;
			this.prevClientY = evt.clientY;

			var index = parseInt(this.$point.attr('index'), 10);

			if ($point.hasClass('anchor-point')) {

				this.trigger('path:interact');
				this.trigger('path:anchor-point:select', index);
				// first clickable anchor point is 0

			} else if ($point.hasClass('control-point')) {

				var controlPointIndex = this.$point.attr('attribute-index');
				this.trigger('path:interact');
				this.trigger('path:control-point:select', index, controlPointIndex);
				// the index refers to the index of the curveto segment this control point belongs to
				// curveto path's control point 1 has index 1, control point 2 has index 2
				// first clickable control point is at 1, 1 (even though the point has a direction path connected to anchor point 0)

			} else {

				this.trigger('path:interact');
				this.trigger('path:segment:select', index);
				// first clickable segment is segment 1
				// segment 0 is the first M segment (which has no path)

			}

			evt.stopPropagation();
			evt.preventDefault();

			this.pathEditedEventType = null;
		},

		move: function (e) {

			var $point = this.$point;

			if (!$point) return;

			// move anchor and control points
			var evt = joint.util.normalizeEvent(e);
			var dx = evt.clientX - this.prevClientX;
			var dy = evt.clientY - this.prevClientY;

			var index = parseInt($point.attr('index'), 10);

			if ($point.hasClass('anchor-point')) {

				// move anchor point
				this.adjustAnchorPoint(index, dx, dy);

			} else if ($point.hasClass('control-point')) {

				// move control point
				var controlPointIndex = $point.attr('attribute-index');
				this.adjustControlPoint(index, controlPointIndex, dx, dy);

			} else {

				// move segment path
				this.adjustAnchorPoint(index - 1, dx, dy);
				this.adjustAnchorPoint(index, dx, dy);

			}

			// move the direction paths

			this.prevClientX = evt.clientX;
			this.prevClientY = evt.clientY;
		},

		adjustControlPoint: function (index, controlPointIndex, dx, dy) {

			// get the path transformation matrix
			var ctm = this.pathNode.getCTM();

			var segList = this.segList;

			// the raw path data is not transformed
			var seg = segList.getItem(index);

			var controlPoints = this.controlPoints;

			// the client movement data is transformed because it comes from interaction events in a transformed viewport
			// convert to untransformed coordinates to match the path's underlying representation (untransformed)
			var inverseCTM = ctm.inverse();
			// translations are ignored since we are interested in differences in position
			inverseCTM.e = 0;
			inverseCTM.f = 0;
			var movePoint = this._transformPoint(dx, dy, inverseCTM);

			// apply untransformed client movement data to untransformed path data
			var xA = 'x' + controlPointIndex;
			var yA = 'y' + controlPointIndex;
			seg[xA] += movePoint.x;
			seg[yA] += movePoint.y;

			// convert to transformed coordinates to match how path is rendered on screen
			var controlSegPoint = this._transformPoint(seg[xA], seg[yA], ctm);
			var controlPt = controlPoints[index][controlPointIndex - 1].attr({
				cx: controlSegPoint.x,
				cy: controlSegPoint.y
			});

			if (controlPt.hasClass('locked')) {

				// this control point is locked with another control point
				// we also need to modify the bound control point
				var boundIndex = ((controlPointIndex == 1) ? (index - 1) : (index + 1));
				var boundControlPointIndex = ((controlPointIndex == 1) ? 2 : 1);
				var bindSeg = segList.getItem(boundIndex);

				// recalculate bound point with untransformed coordinates
				var xB = 'x' + boundControlPointIndex;
				var yB = 'y' + boundControlPointIndex;
				var center = g.point(((controlPointIndex == 1) ? bindSeg.x : seg.x), ((controlPointIndex == 1) ? bindSeg.y : seg.y));
				var controlPos = g.point(seg[xA], seg[yA]);
				var distance = center.distance(g.Point(bindSeg[xB], bindSeg[yB]));
				var bindControlPos = center.move(controlPos, distance);
				bindSeg[xB] = bindControlPos.x;
				bindSeg[yB] = bindControlPos.y;

				// convert to transformed coodinates 
				var bindControlSegPoint = this._transformPoint(bindSeg[xB], bindSeg[yB], ctm);
				controlPoints[boundIndex][boundControlPointIndex - 1].attr({
					cx: bindControlSegPoint.x,
					cy: bindControlSegPoint.y
				});

				// update paths involving bound control point
				this.updateDirectionPaths(boundIndex);
				this.updateSegmentPath(boundIndex);
			}

			// update paths involving control point
			this.updateDirectionPaths(index);
			this.updateSegmentPath(index);

			this.pathEditedEventType = 'path:control-point:adjust';
		},

		adjustAnchorPoint: function (index, dx, dy) {

			// get the path transformation matrix
			var ctm = this.pathNode.getCTM();

			var segList = this.segList;

			// the raw path data is not transformed
			var seg = segList.getItem(index);
			var _subPathIndices = this._subPathIndices;
			if (seg.pathSegType == SVGPathSeg.PATHSEG_CLOSEPATH) {
				index = _.find(_subPathIndices, function (i) { return i < index; });
				seg = segList.getItem(index);
			}

			var anchorPoints = this.anchorPoints;
			var controlPoints = this.controlPoints;

			// the client movement data is transformed because it comes from interaction events in a transformed viewport
			// convert to untransformed coordinates to match the path's underlying representation (untransformed)
			var inverseCTM = ctm.inverse();
			// translations are ignored since we are interested in differences in position
			inverseCTM.e = 0;
			inverseCTM.f = 0;
			var movePoint = this._transformPoint(dx, dy, inverseCTM);

			// apply untransformed client movement data to untransformed path data
			seg.x += movePoint.x;
			seg.y += movePoint.y;

			// convert to transformed coordinates to match how path is rendered on screen
			var segPoint = this._transformPoint(seg.x, seg.y, ctm);
			anchorPoints[index].attr({
				cx: segPoint.x,
				cy: segPoint.y
			});

			if (seg.pathSegType == SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS) {
				// apply untransformed client movement data to untransformed path data
				seg.x2 += movePoint.x;
				seg.y2 += movePoint.y;

				// convert to transformed coordinates
				var controlSegPoint = this._transformPoint(seg.x2, seg.y2, ctm);
				controlPoints[index][1].attr({
					cx: controlSegPoint.x,
					cy: controlSegPoint.y
				});
			}

			var nextSeg = ((index + 1) < segList.numberOfItems) ? segList.getItem(index + 1) : 0;

			if (nextSeg) {
				if (nextSeg.pathSegType == SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS) {
					// apply untransformed client movement data to untransformed path data
					nextSeg.x1 += movePoint.x;
					nextSeg.y1 += movePoint.y;

					// convert to transformed coordinates
					var nextControlSegPoint = this._transformPoint(nextSeg.x1, nextSeg.y1, ctm);
					controlPoints[index + 1][0].attr({
						cx: nextControlSegPoint.x,
						cy: nextControlSegPoint.y
					});

					// update control paths involving next anchor point
					this.updateDirectionPaths(index + 1);
				}

				// update segment path involving next anchor point 
				this.updateSegmentPath(index + 1);
			}

			// update paths involving this anchor point
			this.updateDirectionPaths(index);
			this.updateSegmentPath(index);

			this.pathEditedEventType = 'path:anchor-point:adjust';
		},

		// updates paths from a given segment to control points
		updateDirectionPaths: function (index) {

			// get the path transformation matrix
			var ctm = this.pathNode.getCTM();

			var segList = this.segList;

			// raw path data is unconverted
			// convert to transformed coordinates to match how path is rendered on screen
			var seg = segList.getItem(index);
			var segPoint = this._transformPoint(seg.x, seg.y, ctm);

			// make sure that previous segment exists
			var prevSeg = (index > 0) ? segList.getItem(index - 1) : null;
			var prevSegPoint = prevSeg ? this._transformPoint(prevSeg.x, prevSeg.y, ctm) : null;

			// for each direction path from this anchor point
			_.each(this.directionPaths[index], function (directionPath, i) {

				i++;

				var controlSegPoint = this._transformPoint(seg['x' + i], seg['y' + i], ctm);

				// update the path with transformed coordinates
				directionPath.attr('d', [
					'M',
					(i > 1 || !prevSeg) ? segPoint.x : prevSegPoint.x,
					(i > 1 || !prevSeg) ? segPoint.y : prevSegPoint.y,
					controlSegPoint.x,
					controlSegPoint.y
				].join(' '));

			}, this);
		},

		// updates given path
		updateSegmentPath: function (index) {

			var segList = this.segList;

			var _subPathIndices = this._subPathIndices;

			if (_subPathIndices.includes(index)) {

				var segMaxIndex = _.find(_subPathIndices.slice().reverse(), function (i) { return (i > index); }) || segList.numberOfItems;

				segMaxIndex--;

				if (segList.getItem(segMaxIndex).pathSegType != SVGPathSeg.PATHSEG_CLOSEPATH) return;

				index = segMaxIndex;
			}

			// first segment (index = 0) is always 'M' and such it has no segmentPath
			var segPath = this.segmentPaths[index];
			if (!segPath) return;

			// get the path transformation matrix
			var ctm = this.pathNode.getCTM();

			// there is always a previous segment because we are skipping over the first segment
			// raw path data is untransformed
			// convert to transformed coordinates to match how path is rendered on screen
			var prevSeg = segList.getItem(index - 1);
			var prevSegPoint = this._transformPoint(prevSeg.x, prevSeg.y, ctm);
			// create the updated path
			var item = segPath.createSVGPathSegMovetoAbs(prevSegPoint.x, prevSegPoint.y);
			segPath.pathSegList.initialize(item);

			// transform path data to match path rendering
			var seg = segList.getItem(index);
			var segPoint = this._transformPoint(seg.x, seg.y, ctm);

			switch (seg.pathSegType) {

				case SVGPathSeg.PATHSEG_CLOSEPATH:
					// transform path data to match path rendering
					var nextSeg = segList.getItem(_.find(_subPathIndices, function (i) { return (i < index); }));
					var nextSegPoint = this._transformPoint(nextSeg.x, nextSeg.y, ctm);
					item = segPath.createSVGPathSegLinetoAbs(nextSegPoint.x, nextSegPoint.y);
					break;

				case SVGPathSeg.PATHSEG_LINETO_ABS:
					item = segPath.createSVGPathSegLinetoAbs(segPoint.x, segPoint.y);
					break;

				case SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
					// transform control point data to match path rendering
					var controlSegPoint1 = this._transformPoint(seg.x1, seg.y1, ctm);
					var controlSegPoint2 = this._transformPoint(seg.x2, seg.y2, ctm);
					item = segPath.createSVGPathSegCurvetoCubicAbs(segPoint.x, segPoint.y, controlSegPoint1.x, controlSegPoint1.y, controlSegPoint2.x, controlSegPoint2.y);
					break;
			}

			segPath.pathSegList.appendItem(item);
		},

		stopMoving: function () {

			this.$point = null;

			// only trigger events after the moving stops
			if (this.pathEditedEventType) {
				var pathNode = this.pathNode;

				this.trigger('path:edit', pathNode);
				this.trigger(this.pathEditedEventType, pathNode);
			}

			this.pathEditedEventType = null;
		},

		createAnchorPoint: function (e) {

			var evt = joint.util.normalizeEvent(e);
			var index = V(evt.target).attr('index');
			var pathNode = this.pathNode;
			var segList = this.segList;

			var pt = V(pathNode).toLocalPoint(evt.pageX, evt.pageY);
			var seg = segList.getItem(index);

			switch (seg.pathSegType) {

				case SVGPathSeg.PATHSEG_CLOSEPATH:
				case SVGPathSeg.PATHSEG_LINETO_ABS:
					segList.insertItemBefore(pathNode.createSVGPathSegLinetoAbs(pt.x, pt.y), index);
					break;

				case SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
					var pseg = segList.getItem(index - 1);
					var p0 = g.point(pseg.x, pseg.y);
					var p1 = g.point(seg.x1, seg.y1);
					var p2 = g.point(seg.x2, seg.y2);
					var p3 = g.point(seg.x, seg.y);

					// Inversion of Bezier curve
					var t = g.bezier.getInversionSolver(p0, p1, p2, p3)(pt);

					// TODO: wen a curve is a straight line we will get inaccurate results
					if (t < 0) return;

					// Divide a Bezier curve into two
					var curves = g.bezier.getCurveDivider(p0, p1, p2, p3)(t);

					segList.insertItemBefore(pathNode.createSVGPathSegCurvetoCubicAbs(
						curves[0].p3.x,
						curves[0].p3.y,
						curves[0].p1.x,
						curves[0].p1.y,
						curves[0].p2.x,
						curves[0].p2.y
					), index);

					seg.x1 = curves[1].p1.x;
					seg.y1 = curves[1].p1.y;
					seg.x2 = curves[1].p2.x;
					seg.y2 = curves[1].p2.y;
					break;
			}

			this.render();

			this.trigger('path:edit', pathNode);
			this.trigger('path:anchor-point:create', pathNode);
		},

		removeAnchorPoint: function (e) {

			var evt = joint.util.normalizeEvent(e);
			var index = parseInt($(evt.target).attr('index'), 10);

			var pathNode = this.pathNode;
			var segList = this.segList;

			var seg = segList.getItem(index);

			var nseg;
			var rseg;

			switch (seg.pathSegType) {

				case SVGPathSeg.PATHSEG_MOVETO_ABS:
					// replace following segment with moveto
					// then delete this moveto
					nseg = segList.getItem(index + 1);
					rseg = pathNode.createSVGPathSegMovetoAbs(nseg.x, nseg.y);
					segList.replaceItem(rseg, index + 1);
					segList.removeItem(index);
					break;

				case SVGPathSeg.PATHSEG_LINETO_ABS:
					// just remove this segment
					segList.removeItem(index);
					break;

				case SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
					// replace following curve's control point 1 with this curve's control point 1
					// if not followed by a curve, then discard the curve information
					// then delete this curveto
					if ((index + 1) <= (segList.numberOfItems - 1)) {
						nseg = segList.getItem(index + 1);
						if (nseg.pathSegType == SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS) {
							nseg.x1 = seg.x1;
							nseg.y1 = seg.y1;
						}
					}
					segList.removeItem(index);
					break;
			}

			this.trigger('path:edit', pathNode);
			this.trigger('path:anchor-point:remove', pathNode);

			var numAnchorPoints = segList.numberOfItems;
			if (segList.getItem(segList.numberOfItems - 1).pathSegType == SVGPathSeg.PATHSEG_CLOSEPATH) {
				numAnchorPoints -= 1;
			}

			if (numAnchorPoints < 2) {
				// the path has too few points to be seen
				this.trigger('path:invalid', pathNode);
			}
		},

		lockControlPoint: function (e) {

			var evt = joint.util.normalizeEvent(e);
			var evtTarget = $(evt.target);

			var pathNode = this.pathNode;

			var index = parseInt(evtTarget.attr('index'));
			var controlPointIndex = evtTarget.attr('attribute-index');

			var boundIndex = (controlPointIndex == 1) ? (index - 1) : (index + 1);
			var boundControlPointIndex = (controlPointIndex == 1) ? 2 : 1;

			var boundControlPoint = this.controlPoints[boundIndex];

			if (boundControlPoint) {

				var isLocked = evtTarget.hasClass('locked');

				evtTarget.toggleClass('locked');
				boundControlPoint[boundControlPointIndex - 1].toggleClass('locked');

				this.trigger('path:interact');
				if (!isLocked) this.trigger('path:control-point:lock', index, controlPointIndex);
				else this.trigger('path:control-point:unlock', index, controlPointIndex);

				this.adjustControlPoint(index, controlPointIndex, 0, 0); // updates pathEditedEventType
				this.trigger('path:edit', pathNode);
				this.trigger(this.pathEditedEventType, pathNode);
				this.pathEditedEventType = null;
			}
		},

		convertSegmentPath: function (e) {

			var evt = joint.util.normalizeEvent(e);
			var index = V(evt.target).attr('index');

			var pathNode = this.pathNode;
			var segList = this.segList;

			var seg = segList.getItem(index);

			var pseg;
			var nseg;

			switch (seg.pathSegType) {

				case SVGPathSeg.PATHSEG_CLOSEPATH:
					// converts closepath to curveto path
					// takes the coordinates of the initial point as destination coordinates
					// creates a duplicate point at initial point (no way around this in svg)
					// no way to reverse this duplication
					// reconnects with another closepath
					pseg = segList.getItem(index - 1);
					nseg = segList.getItem(0);
					segList.insertItemBefore(pathNode.createSVGPathSegCurvetoCubicAbs(nseg.x, nseg.y, pseg.x, pseg.y, nseg.x, nseg.y), index);
					break;

				case SVGPathSeg.PATHSEG_LINETO_ABS:
					// converts lineto path to curveto path
					// puts control points at the locations of the two endpoints of the line
					pseg = segList.getItem(index - 1);
					segList.replaceItem(pathNode.createSVGPathSegCurvetoCubicAbs(seg.x, seg.y, pseg.x, pseg.y, seg.x, seg.y), index);
					break;

				case SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
					// converts curveto path to lineto path
					// endpoints stay endpoints, but curve information discarded
					segList.replaceItem(pathNode.createSVGPathSegLinetoAbs(seg.x, seg.y), index);
					break;
			}

			this.render();

			this.trigger('path:edit', pathNode);
			this.trigger('path:segment:convert', pathNode);
		},

		addClosePathSegment: function (e) {

			var evt = joint.util.normalizeEvent(e);
			var index = parseInt($(evt.target).attr('index'), 10);

			var segList = this.segList;

			if (index === 0 || index === segList.numberOfItems - 1) {

				// if the first or last anchor was selected
				var seg = segList.getItem(segList.numberOfItems - 1);
				if (seg.pathSegType != SVGPathSeg.PATHSEG_CLOSEPATH) {
					var pathNode = this.pathNode;

					// if the last segment of path is not closepath
					// add closepath at the end of path
					segList.appendItem(pathNode.createSVGPathSegClosePath());

					this.render();

					this.trigger('path:edit', pathNode);
					this.trigger('path:closepath-segment:add', pathNode);
				}
			}
		},

		removeClosePathSegment: function (e) {

			var evt = joint.util.normalizeEvent(e);
			var index = V(evt.target).attr('index');

			var segList = this.segList;

			var seg = segList.getItem(index);

			if (seg.pathSegType == SVGPathSeg.PATHSEG_CLOSEPATH) {
				var pathNode = this.pathNode;

				segList.removeItem(index);

				this.render();

				this.trigger('path:edit', pathNode);
				this.trigger('path:closepath-segment:remove', pathNode);
			}
		},

		//////////////
		// Handlers //
		//////////////

		onAnchorPointPointerDown: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();

			// left button only
			if (evt.which !== 1) return;

			// first click only (if this was part of a double click)
			if (evt.originalEvent.detail > 1) return;

			this.startMoving(evt);

			this.bindDocumentEvents();
		},

		onControlPointPointerDown: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();

			// left button only
			if (evt.which !== 1) return;

			// first click only (if this was part of a double click)
			if (evt.originalEvent.detail > 1) return;

			this.startMoving(evt);

			this.bindDocumentEvents();
		},

		onSegmentPathPointerDown: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();

			// left button only
			if (evt.which !== 1) return;

			// first click only (if this was part of a double click)
			if (evt.originalEvent.detail > 1) return;

			this.startMoving(evt);

			this.bindDocumentEvents();
		},

		onPointerMove: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();

			this.move(evt);

		},

		onPointerUp: function (e) {

			this.unbindDocumentEvents();

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();

			this.stopMoving();

		},

		onAnchorPointDoubleClick: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();
			evt.preventDefault();

			// left button only
			if (evt.which !== 1) return;

			this.removeAnchorPoint(evt); // default user interaction method

			// alternative method that could be called by this interaction:
			//this.addClosePathSegment(evt);
		},

		onControlPointDoubleClick: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();
			evt.preventDefault();

			// left button only
			if (evt.which !== 1) return;

			this.lockControlPoint(evt);
		},

		onSegmentPathDoubleClick: function (e) {

			var evt = joint.util.normalizeEvent(e);

			evt.stopPropagation();
			evt.preventDefault();

			// left button only
			if (evt.which !== 1) return;

			this.createAnchorPoint(evt); // default user interaction method

			// alternative methods that could be called by this interaction:
			//this.convertSegmentPath(evt);
			//this.removeClosePathSegment(evt);
		}
	});

	// Force Directed layout implementation.
	// =====================================

	// Resources:
	//      Efficient and High Quality Force-Directed Graph Drawing, Yifan Hu
	//      Simple Algorithms for Network Visualization: A Tutorial, Michael J. McGufﬁn
	//      Graph Drawing by Force-directed Placement, Thomas M. J. Fruchterman and Edward M. Reingold
	//      D3.js, http://d3js.org

	joint.layout.ForceDirected = Backbone.Model.extend({

		defaults: {

			linkDistance: 10,
			linkStrength: 1,
			charge: 10
		},

		initialize: function (opt) {

			this.elements = this.get('graph').getElements();
			this.links = this.get('graph').getLinks();
			this.cells = this.get('graph').get('cells');
			this.width = this.get('width');
			this.height = this.get('height');
			this.gravityCenter = this.get('gravityCenter');

			this.t = 1;
			this.energy = Infinity;
			this.progress = 0;
		},

		start: function () {

			var w = this.get('width');
			var h = this.get('height');

			// Random layout.
			this.elements.forEach(function (el) {

				el.set('position', {
					x: Math.random() * w,
					y: Math.random() * h
				});

				// Cache important values for much quick access.
				el.charge = el.get('charge') || this.get('charge');
				el.weight = el.get('weight') || 1;
				var pos = el.get('position');
				el.x = pos.x;
				el.y = pos.y;

				// Previous position.
				el.px = el.x;
				el.py = el.y;

				el.fx = 0;
				el.fy = 0;

			}, this);

			this.links.forEach(function (link) {

				// Cache important values for quick access.
				link.strength = link.get('strength') || this.get('linkStrength');
				link.distance = link.get('distance') || this.get('linkDistance');

				link.source = this.cells.get(link.get('source').id);
				link.target = this.cells.get(link.get('target').id);

			}, this);
		},

		step: function () {

			if ((this.t * .99) < 0.005) return this.notifyEnd();

			var w = this.width;
			var h = this.height;

			var gravity = .1;
			var gravityCenter = this.gravityCenter;

			var energyBefore = this.energy;
			this.energy = 0;

			// Global positions update. Sum of all the position updates to elements.
			var xBefore = 0;
			var yBefore = 0;
			var xAfter = 0;
			var yAfter = 0;

			var i, j;
			var nElements = this.elements.length;
			var nLinks = this.links.length;

			var v, u, dx, dy, distanceSquared, distance, fr, fx, fy;

			// Calculate repulsive forces.
			for (i = 0; i < nElements - 1; i++) {

				v = this.elements[i];
				xBefore += v.x;
				yBefore += v.y;

				for (j = i + 1; j < nElements; j++) {

					u = this.elements[j];
					dx = u.x - v.x;
					dy = u.y - v.y;
					distanceSquared = dx * dx + dy * dy;
					distance = Math.sqrt(distanceSquared);

					fr = this.t * v.charge / distanceSquared;
					fx = fr * dx;
					fy = fr * dy;

					v.fx -= fx;
					v.fy -= fy;
					u.fx += fx;
					u.fy += fy;

					this.energy += fx * fx + fy * fy;
				}
			}

			// Add the last element positions as it couldn't be done in the loops above.
			xBefore += this.elements[nElements - 1].x;
			yBefore += this.elements[nElements - 1].y;

			var link, fa, k;

			// Calculate attractive forces.
			for (i = 0; i < nLinks; i++) {

				link = this.links[i];
				v = link.source;
				u = link.target;

				dx = u.x - v.x;
				dy = u.y - v.y;
				distanceSquared = dx * dx + dy * dy;
				distance = Math.sqrt(distanceSquared);

				fa = this.t * link.strength * (distance - link.distance) / distance;
				fx = fa * dx;
				fy = fa * dy;
				k = v.weight / (v.weight + u.weight);

				// Gauss-seidel. Changing positions directly so that other iterations work with the new positions.
				v.x += fx * (1 - k);
				v.y += fy * (1 - k);
				u.x -= fx * k;
				u.y -= fy * k;

				this.energy += fx * fx + fy * fy;
			}

			var el, pos;

			// Set positions on elements.
			for (i = 0; i < nElements; i++) {

				el = this.elements[i];
				pos = { x: el.x, y: el.y };

				// Gravity force.
				if (gravityCenter) {

					pos.x += (gravityCenter.x - pos.x) * this.t * gravity;
					pos.y += (gravityCenter.y - pos.y) * this.t * gravity;
				}

				pos.x += el.fx;
				pos.y += el.fy;

				// Make sure positions don't go out of the paper area.
				pos.x = Math.max(0, Math.min(w, pos.x));
				pos.y = Math.max(0, Math.min(h, pos.y));

				// Position Verlet integration.
				var friction = .9;
				pos.x += (el.px - pos.x) * friction;
				pos.y += (el.py - pos.y) * friction;

				el.px = pos.x;
				el.py = pos.y;

				el.fx = el.fy = 0;
				el.x = pos.x;
				el.y = pos.y;

				xAfter += el.x;
				yAfter += el.y;

				this.notify(el, i, pos);
			}

			this.t = this.cool(this.t, this.energy, energyBefore);

			// If the global distance hasn't change much, the layout converged and therefore trigger the `end` event.
			var gdx = xBefore - xAfter;
			var gdy = yBefore - yAfter;
			var gd = Math.sqrt(gdx * gdx + gdy * gdy);
			if (gd < 1) {
				this.notifyEnd();
			}
		},

		cool: function (t, energy, energyBefore) {

			// Adaptive cooling scheme (as per Yifan Hu). The temperature can also increase depending on the progress made.
			if (energy < energyBefore) {

				this.progress += 1;
				if (this.progress >= 5) {

					this.progress = 0;
					return t / .99;// Warm up.
				}
			} else {

				this.progress = 0;
				return t * .99;// Cool down.
			}
			return t;// Keep the same temperature.
		},

		notify: function (el, i, pos) {

			el.set('position', pos);
		},

		notifyEnd: function () {

			this.trigger('end');
		}
	});

	joint.layout = joint.layout || {};

	joint.layout.GridLayout = {

		layout: function (graphOrCells, opt) {

			var graph;

			if (graphOrCells instanceof joint.dia.Graph) {
				graph = graphOrCells;
			} else {
				graph = (new joint.dia.Graph()).resetCells(graphOrCells, { dry: true });
			}

			// This is not needed anymore.
			graphOrCells = null;

			opt = opt || {};

			var elements = graph.getElements();

			// number of columns
			var columns = opt.columns || 1;
			var rows = Math.ceil(elements.length / columns);
			// shift the element horizontally by a given amount
			var dx = opt.dx || 0;

			// shift the element vertically by a given amount
			var dy = opt.dy || 0;
			// position the elements in the centre of a grid cell
			var centre = opt.centre === undefined || opt.centre !== false;

			// resize the elements to fit a grid cell & preserves ratio
			var resizeToFit = !!opt.resizeToFit;

			// coordinates of the most top-left element.
			var marginX = opt.marginX || 0;
			var marginY = opt.marginY || 0;

			// width of a column
			var columnWidths = [];
			var columnWidth = opt.columnWidth;
			if (columnWidth === 'compact') {

				for (var cIndex = 0; cIndex < columns; cIndex++) {
					var elementsAtColumn = this._elementsAtColumn(elements, cIndex, columns);
					columnWidths.push(this._maxDim(elementsAtColumn, 'width') + dx);
				}
			} else {
				if (!columnWidth || joint.util.isString(columnWidth)) {
					columnWidth = this._maxDim(elements, 'width') + dx;
				}
				for (var i = 0; i < columns; i++) {
					columnWidths.push(columnWidth);
				}
			}

			var columnsX = this._accumulate(columnWidths, marginX);

			// height of a row
			var rowHeights = [];
			var rowHeight = opt.rowHeight;
			if (rowHeight === 'compact') {
				for (var rIndex = 0; rIndex < rows; rIndex++) {
					var elementsAtRow = this._elementsAtRow(elements, rIndex, columns);
					rowHeights.push(this._maxDim(elementsAtRow, 'height') + dy);
				}
			} else {
				if (!rowHeight || joint.util.isString(rowHeight)) {
					rowHeight = this._maxDim(elements, 'height') + dy;
				}

				for (var j = 0; j < rows; j++) {
					rowHeights.push(rowHeight);
				}
			}

			var rowsY = this._accumulate(rowHeights, marginY);

			// Wrap all graph changes into a batch.
			graph.startBatch('layout');

			// iterate the elements and position them accordingly
			elements.forEach(function (element, index) {

				var cIndex = index % columns;
				var rIndex = Math.floor(index / columns);
				var cWidth = columnWidths[cIndex];
				var rHeight = rowHeights[rIndex];

				var cx = 0;
				var cy = 0;
				var elementSize = element.get('size');

				if (resizeToFit) {

					var elementWidth = cWidth - 2 * dx;
					var elementHeight = rHeight - 2 * dy;

					var calcElHeight = elementSize.height * (elementSize.width ? elementWidth / elementSize.width : 1);
					var calcElWidth = elementSize.width * (elementSize.height ? elementHeight / elementSize.height : 1);

					if (calcElHeight > rHeight) {
						elementWidth = calcElWidth;
					} else {
						elementHeight = calcElHeight;
					}

					elementSize = { width: elementWidth, height: elementHeight };
					element.set('size', elementSize, opt);
				}

				if (centre) {
					cx = (cWidth - elementSize.width) / 2;
					cy = (rHeight - elementSize.height) / 2;
				}

				element.position(columnsX[cIndex] + dx + cx, rowsY[rIndex] + dy + cy, opt);
			});

			graph.stopBatch('layout');
		},

		// find maximal dimension (width/height) in an array of the elements
		_maxDim: function (elements, dimension) {
			return elements.reduce(function (max, el) {
				return Math.max(el.get('size')[dimension], max);
			}, 0);
		},

		_elementsAtRow: function (elements, rowIndex, numberOfColumns) {
			var elementsAtRow = [];
			var i = numberOfColumns * rowIndex;
			var n = i + numberOfColumns;
			for (; i < n; i++) {
				elementsAtRow.push(elements[i]);
			}
			return elementsAtRow;
		},

		_elementsAtColumn: function (elements, columnIndex, numberOfColumns) {
			var elementsAtColumn = [];
			var i = columnIndex;
			var n = elements.length;
			for (; i < n; i += numberOfColumns) {
				elementsAtColumn.push(elements[i]);
			}
			return elementsAtColumn;
		},

		_accumulate: function (array, baseVal) {
			return array.reduce(function (res, val, i) {
				res.push(res[i] + val);
				return res;
			}, [baseVal || 0]);
		}
	};

	// Tree Graph Layout.
	// ==================

	(function (joint, Backbone, _, g) {

		// Layout Siblings
		// ===============
		// a group of sibling layout areas

		function LayoutSiblings(layoutAreas, parentArea, opt) {

			opt = joint.util.defaults(opt || {}, { siblingGap: 0 });

			this.width = 0;
			this.height = 0;
			this.layoutAreas = this.sortLayoutAreas(layoutAreas);
			this.parentArea = parentArea;
			this.siblingGap = opt.siblingGap;
			if (this.exists()) {
				this.computeSize(opt);
			}
		}

		joint.util.assign(LayoutSiblings.prototype, {

			sortLayoutAreas: function (layoutAreas) {

				var areas = joint.util.sortBy(layoutAreas, 'siblingRank');

				// re-number the sibling ranks
				areas.forEach(function (area, index) {
					area.siblingRank = index;
				});

				return areas;
			},

			move: function (dx, dy) {
				for (var i = 0, n = this.layoutAreas.length; i < n; i++) {
					this.layoutAreas[i].dx += dx;
					this.layoutAreas[i].dy += dy;
				}
			},

			exists: function () {
				return this.layoutAreas.length > 0;
			},

			sumGaps: function (gap) {
				var gapCount = Math.max(this.layoutAreas.length - 1, 0);
				return gapCount * gap;
			},

			getSiblingRankByPoint: function (point) {

				if (!this.exists()) {
					// minimal extreme
					return -1;
				}

				var closestArea = this.findAreaByPoint(point);
				if (!closestArea) {
					// maximal extreme
					return this.layoutAreas.length - 1;
				}

				return closestArea.siblingRank - 1;
			},

			getFirstChildConnectionPoints: function () {

				return [];
			},

			getConnectionPoints: function (point, opt) {

				if (!this.exists()) {
					return this.getFirstChildConnectionPoints(point);
				}

				var deltaCoordinates = {
					dx: point.x - this.parentArea.rootCX,
					dy: point.y - this.parentArea.rootCY
				};

				return this.layoutAreas[0].getRootVertices(deltaCoordinates, opt);
			},

			getParentConnectionPoint: function () {

				var parentArea = this.parentArea;
				var offset = this.proxyLayoutArea('getConnectionPoint', parentArea.rootSize);
				var connectionPoint = g.point(parentArea.rootCX, parentArea.rootCY);

				return connectionPoint.offset(offset.x, offset.y);
			},

			getChildConnectionPoint: function (point, rootSize) {

				var offset = this.proxyLayoutArea('getConnectionPoint', rootSize);
				return g.point(point).difference(offset);
			},

			proxyLayoutArea: function (method) {

				var args = Array.prototype.slice.call(arguments, 1);
				return LayoutArea.fromDirection(this.direction).prototype[method].apply(this.parentArea, args);
			}
		});

		LayoutSiblings.extend = Backbone.Model.extend;

		var VerticalLayoutSiblings = LayoutSiblings.extend({

			// Y coordinate of the most top sibling
			getTopDY: function () {
				return -this.height / 2;
			},

			findAreaByPoint: function (point) {

				return this.layoutAreas.find(function (area) {
					return area.rootCY > point.y;
				});
			},

			computeSize: function (opt) {

				// compute height of all the siblings
				this.height = this.sumGaps(opt.siblingGap);
				var layoutAreas = this.layoutAreas;

				this.height += layoutAreas.reduce(function (res, area) {
					return res + area.height + area.prevSiblingGap + area.nextSiblingGap;
				}, 0);

				layoutAreas.reduce(function (y, area) {
					// check if the current siblings width changed
					this.width = Math.max(this.width, area.getExtendedWidth());
					// set the shift of the area
					area.dy += y + area.getCY();
					// return the y-coordinate of the next sibling
					return y + area.prevSiblingGap + area.height + area.nextSiblingGap + opt.siblingGap;
				}.bind(this), this.getTopDY());
			},

			getYTowardsParent: function () {

				return this.parentArea.rootCY;
			},

			getXTowardsParent: function () {

				var parentArea = this.parentArea;
				return parentArea.rootCX + this.LRSign * (parentArea.rootSize.width / 2 + parentArea.gap);
			},

			getNeighborPointFromRank: function (rank) {

				var y;
				var siblingGap = this.siblingGap;

				if (!this.exists()) {

					y = this.getYTowardsParent();

				} else {

					var prevArea = this.layoutAreas[rank];
					var nextArea = this.layoutAreas[rank + 1];

					if (!prevArea) {
						y = nextArea.y - siblingGap / 2;
					} else if (!nextArea) {
						y = prevArea.y + prevArea.height + siblingGap / 2;
					} else {
						y = (prevArea.y + prevArea.height + nextArea.y) / 2;
					}
				}

				return {
					x: this.getXTowardsParent(),
					y: y
				};
			}

		});

		var LeftLayoutSiblings = VerticalLayoutSiblings.extend({

			direction: 'L',
			LRSign: -1
		});

		var RightLayoutSiblings = VerticalLayoutSiblings.extend({

			direction: 'R',
			LRSign: 1
		});

		// Vertical Tree Layout Siblings

		var treeLayoutSiblings = {

			getXTowardsParent: function () {

				var parentArea = this.parentArea;
				return parentArea.rootCX + this.LRSign * parentArea.gap;
			},

			getYTowardsParent: function () {

				var parentArea = this.parentArea;
				var dy = parentArea.getLRHeight(parentArea.siblings) / 2;
				dy += Math.min(parentArea.firstChildGap, this.siblingGap / 2);

				return parentArea.rootCY + this.TBSign * dy;
			},

			getFirstChildConnectionPoints: function (point) {

				return [g.point(this.parentArea.rootCX, point.y)];
			},

			getChildConnectionPoint: function (point, rootSize) {

				return g.point(point).offset(-this.LRSign * rootSize.width / 2, 0);
			},

			getParentConnectionPoint: function () {

				var parentArea = this.parentArea;
				var connectionPoint = g.point(parentArea.rootCX, parentArea.rootCY);
				return connectionPoint.offset(0, this.TBSign * parentArea.rootSize.height / 2);
			}
		};

		var bottomTreeLayoutSiblings = {

			getTopDY: function () {
				return 0;
			}
		};

		var topTreeLayoutSiblings = {

			getTopDY: function () {
				return -this.height;
			}
		};

		var BottomRightLayoutSiblings = VerticalLayoutSiblings.extend({

			direction: 'BR',
			LRSign: 1,
			TBSign: 1
		});
		joint.util.assign(BottomRightLayoutSiblings.prototype, treeLayoutSiblings, bottomTreeLayoutSiblings);

		var BottomLeftLayoutSiblings = VerticalLayoutSiblings.extend({

			direction: 'BL',
			LRSign: -1,
			TBSign: 1
		});
		joint.util.assign(BottomLeftLayoutSiblings.prototype, treeLayoutSiblings, bottomTreeLayoutSiblings);

		var TopRightLayoutSiblings = VerticalLayoutSiblings.extend({

			direction: 'TR',
			LRSign: 1,
			TBSign: -1
		});
		joint.util.assign(TopRightLayoutSiblings.prototype, treeLayoutSiblings, topTreeLayoutSiblings);

		var TopLeftLayoutSiblings = VerticalLayoutSiblings.extend({

			direction: 'TL',
			LRSign: -1,
			TBSign: -1
		});
		joint.util.assign(TopLeftLayoutSiblings.prototype, treeLayoutSiblings, topTreeLayoutSiblings);


		// Horizontal Layout Siblings

		var HorizontalLayoutSiblings = LayoutSiblings.extend({

			// X coordinate of the most left sibling
			getLeftDX: function () {
				return -this.width / 2;
			},

			findAreaByPoint: function (point) {

				return this.layoutAreas.find(function (area) {
					return area.rootCX > point.x;
				});
			},

			computeSize: function (opt) {

				this.width = this.sumGaps(opt.siblingGap);
				var layoutAreas = this.layoutAreas;

				this.width += layoutAreas.reduce(function (res, area) {
					return res + area.width + area.prevSiblingGap + area.nextSiblingGap;
				}, 0);

				layoutAreas.reduce(function (x, area) {
					// check if the current siblings height changed
					this.height = Math.max(this.height, area.getExtendedHeight());
					// set the shift of the area
					area.dx += x + area.getCX();
					// return the x-coordinate of the next sibling
					return x + area.prevSiblingGap + area.width + area.nextSiblingGap + opt.siblingGap;
				}.bind(this), this.getLeftDX());
			},

			getNeighborPointFromRank: function (rank) {

				var x;

				if (!this.exists()) {

					x = this.parentArea.rootCX;

				} else {

					var prevArea = this.layoutAreas[rank];
					var nextArea = this.layoutAreas[rank + 1];

					if (!prevArea) {
						x = nextArea.x - this.siblingGap / 2;
					} else if (!nextArea) {
						x = prevArea.x + prevArea.width + this.siblingGap / 2;
					} else {
						x = (prevArea.x + prevArea.width + nextArea.x) / 2;
					}
				}

				return {
					x: x,
					y: this.getYTowardsParent()
				};
			}
		});

		var TopLayoutSiblings = HorizontalLayoutSiblings.extend({

			direction: 'T',

			getYTowardsParent: function () {

				var parentArea = this.parentArea;
				return parentArea.rootCY - parentArea.getLRHeight() / 2 - parentArea.gap;
			}
		});

		var BottomLayoutSiblings = HorizontalLayoutSiblings.extend({

			direction: 'B',

			getYTowardsParent: function () {

				var parentArea = this.parentArea;
				return parentArea.rootCY + parentArea.getLRHeight() / 2 + parentArea.gap;
			}
		});

		// Layout Area
		// ===========

		function LayoutArea(root, opt) {

			this.root = root;

			var options = joint.util.assign({}, opt, this.getRootAttributes(root, opt.attributeNames));
			var globalGap = opt.gap || 0;

			joint.util.defaults(options, {
				parentGap: globalGap,
				siblingGap: globalGap,
				firstChildGap: globalGap
			});

			this.siblingRank = options.siblingRank;
			this.rootOffset = options.rootOffset;
			this.rootMargin = options.rootMargin;
			// Gaps
			this.siblingGap = options.siblingGap;
			this.gap = this.parentGap = options.parentGap;
			this.nextSiblingGap = options.nextSiblingGap;
			this.prevSiblingGap = options.prevSiblingGap;
			this.firstChildGap = options.firstChildGap;
			// metrics
			this.dx = 0;
			this.dy = 0;
			this.width = 0;
			this.height = 0;
		}

		joint.util.assign(LayoutArea, {

			create: function (direction, root, opt) {

				var constructor = LayoutArea.fromDirection(direction, opt);
				return new constructor(root, opt);
			},

			fromDirection: function (direction, opt) {

				var constructor;

				switch (direction) {
					case 'L':
						constructor = LeftLayoutArea;
						break;
					case 'T':
						constructor = TopLayoutArea;
						break;
					case 'R':
						constructor = RightLayoutArea;
						break;
					case 'B':
						constructor = BottomLayoutArea;
						break;
					case 'BR':
						constructor = BottomRightLayoutArea;
						break;
					case 'BL':
						constructor = BottomLeftLayoutArea;
						break;
					case 'TR':
						constructor = TopRightLayoutArea;
						break;
					case 'TL':
						constructor = TopLeftLayoutArea;
						break;
					default:
						constructor = LayoutArea;
				}

				return constructor;
			}

		});

		joint.util.assign(LayoutArea.prototype, {

			direction: null,

			compute: function (childLayoutAreas) {
				this.childAreas = childLayoutAreas;
				this.computeRelativePosition(this.root, childLayoutAreas);
			},

			// Returs height of the layout area
			getHeight: function (siblings, rootSize) {

				return this.getTHeight(siblings) + this.getBHeight(siblings) + this.getLRHeight();
			},

			// Returs width of the layout area
			getWidth: function (siblings, rootSize) {

				var tbWidth = Math.max(siblings.T.width, siblings.B.width) / 2;

				var lWidth = Math.max(
					this.getLWidth(siblings, rootSize) + rootSize.width / 2,
					tbWidth
				);

				var rWidth = Math.max(
					this.getRWidth(siblings, rootSize) + rootSize.width / 2,
					tbWidth
				);

				return lWidth + rWidth;
			},

			// Returns height of layout area taken only L,R siblings into account
			getLRHeight: function () {

				return Math.max(this.rootSize.height, this.siblings.L.height, this.siblings.R.height);
			},

			// Returns height of the all top siblings (T,TR,TL)
			getTHeight: function (siblings) {

				return siblings.T.height + this.getTXHeight(siblings);
			},

			// Returns height of the all bottom siblings (B,BR,BL)
			getBHeight: function (siblings) {

				return siblings.B.height + this.getBXHeight(siblings);
			},

			// Returns width of layout area without T,B siblings
			getXLRWidth: function (siblings, rootSize) {

				return this.getLWidth(siblings, rootSize) + rootSize.width + this.getRWidth(siblings, rootSize);
			},

			// Returns width of both right tree siblings (TR,BR)
			getXRWidth: function (siblings, rootSize) {

				var xrWidth = Math.max(siblings.BR.width, siblings.TR.width);
				if (xrWidth > 0) {
					xrWidth -= rootSize.width / 2;
				}

				return xrWidth;
			},

			// Returns height of both top tree siblings (TR,TL)
			getTXHeight: function (siblings) {

				var txHeight = Math.max(siblings.TR.height, siblings.TL.height);
				if (txHeight > 0) {
					txHeight += this.firstChildGap;
				}

				return txHeight;
			},

			// Returns height of both bottom tree siblings (BR,BL)
			getBXHeight: function (siblings) {

				var bxHeight = Math.max(siblings.BR.height, siblings.BL.height);
				if (bxHeight > 0) {
					bxHeight += this.firstChildGap;
				}

				return bxHeight;
			},

			// Returns width of both right tree siblings (BL,TL)
			getXLWidth: function (siblings, rootSize) {

				var xlWidth = Math.max(siblings.BL.width, siblings.TL.width);
				if (xlWidth > 0) {
					xlWidth -= rootSize.width / 2;
				}

				return xlWidth;
			},

			// Returs width of all the right siblings (R, TR, BR)
			getRWidth: function (siblings, rootSize) {

				return Math.max(siblings.R.width, this.getXRWidth(siblings, rootSize));
			},

			// Returs width of all the left siblings (L, TL, BL)
			getLWidth: function (siblings, rootSize) {

				return Math.max(siblings.L.width, this.getXLWidth(siblings, rootSize));
			},

			// Returns T,B siblings width that overlaps root element.
			getTBOverlap: function (siblings, rootSize) {

				var tbOverlap = Math.max(siblings.T.width, siblings.B.width);
				if (tbOverlap > 0) {
					tbOverlap -= rootSize.width;
					tbOverlap /= 2;
				}

				return tbOverlap;
			},

			getRootDX: function (siblings, rootSize) {

				var tbOverlap = this.getTBOverlap(siblings, rootSize);

				var dx = Math.max(this.getLWidth(siblings, rootSize), tbOverlap);
				dx -= Math.max(this.getRWidth(siblings, rootSize), tbOverlap);

				return dx / 2;
			},

			// Returns the minimum amnogst various gaps.
			getMinimalGap: function (siblings) {

				return Math.min(siblings.siblingGap, this.firstChildGap, this.parentGap);
			},

			getBBox: function (opt) {

				var bbox = g.rect(this);
				var pad = opt && opt.expandBy;

				if (pad) {

					bbox.moveAndExpand({
						x: - pad,
						y: - pad,
						width: pad * 2,
						height: pad * 2
					});
				}

				return bbox;
			},

			containsPoint: function (point, opt) {

				return this.getBBox(opt).containsPoint(point);
			},

			getLayoutSiblings: function (direction) {

				return this.siblings[direction];
			},

			getExtendedWidth: function () {

				return this.width + this.gap + this.rootOffset;
			},

			getExtendedHeight: function () {

				return this.height + this.gap + this.rootOffset;
			},

			findMinimalAreaByPoint: function (point, opt) {

				if (!this.containsPoint(point, opt)) {
					return null;
				}

				var minimalArea;

				this.childAreas.some(function (area) {
					minimalArea = area.findMinimalAreaByPoint(point, opt);
					return !!minimalArea;
				});

				return minimalArea || this;
			},

			getType: function () {

				return Object.keys(this.siblings).reduce(function (memo, direction) {
					var siblingGroup = this.siblings[direction];
					return siblingGroup.exists() ? memo.concat(direction) : memo;
				}.bind(this), []).sort().join('-');
			},

			getRootAttributes: function (root, attributeNames) {

				var attributes = {
					rootOffset: root.get(attributeNames.offset || 'offset') || 0,
					rootMargin: root.get(attributeNames.margin || 'margin') || 0,
					prevSiblingGap: root.get(attributeNames.prevSiblingGap || 'prevSiblingGap') || 0,
					nextSiblingGap: root.get(attributeNames.nextSiblingGap || 'nextSiblingGap') || 0
				};

				var siblingRank = root.get(attributeNames.siblingRank || 'siblingRank');
				if (joint.util.isNumber(siblingRank)) {
					attributes.siblingRank = siblingRank;
				}

				var firstChildGap = root.get(attributeNames.firstChildGap || 'firstChildGap');
				if (joint.util.isNumber(firstChildGap)) {
					attributes.firstChildGap = firstChildGap;
				}

				return attributes;
			},

			getRootSize: function (root, rootMargin) {

				var rootSize = root.size();

				rootSize[this.marginDimension] += rootMargin;

				return rootSize;
			},

			createSiblings: function (childAreas, opt) {

				var groupedAreas = joint.util.groupBy(childAreas, 'direction');

				return {
					L: new LeftLayoutSiblings(groupedAreas.L, this, opt),
					T: new TopLayoutSiblings(groupedAreas.T, this, opt),
					R: new RightLayoutSiblings(groupedAreas.R, this, opt),
					B: new BottomLayoutSiblings(groupedAreas.B, this, opt),
					BR: new BottomRightLayoutSiblings(groupedAreas.BR, this, opt),
					BL: new BottomLeftLayoutSiblings(groupedAreas.BL, this, opt),
					TR: new TopRightLayoutSiblings(groupedAreas.TR, this, opt),
					TL: new TopLeftLayoutSiblings(groupedAreas.TL, this, opt)
				};
			},

			computeSize: function (siblings, rootSize) {

				return {
					width: this.getWidth(siblings, rootSize),
					height: this.getHeight(siblings, rootSize)
				};
			},

			computeOrigin: function () {

				var siblings = this.siblings;
				var rootSize = this.rootSize;
				var maxWidth = Math.max(
					this.getLWidth(siblings, rootSize) + rootSize.width / 2,
					this.getXLWidth(siblings, rootSize) + rootSize.width / 2,
					siblings.T.width / 2,
					siblings.B.width / 2
				);

				return {
					x: this.rootCX - maxWidth,
					y: this.rootCY - this.getTHeight(siblings) - this.getLRHeight() / 2
				};
			},

			moveSiblings: function (siblings, rootSize) {

				if (this.hasHorizontalSiblings(siblings)) {

					var dx = rootSize.width / 2;
					siblings.L.move(-dx, 0);
					siblings.R.move(dx, 0);
				}

				if (this.hasVerticalSiblings(siblings)) {

					var dy = this.getLRHeight() / 2;
					siblings.T.move(0, -dy);
					siblings.B.move(0, dy);
					siblings.BR.move(0, dy);
					siblings.BL.move(0, dy);
					siblings.B.move(0, this.getBXHeight(siblings));
					siblings.TR.move(0, -dy);
					siblings.TL.move(0, -dy);
					siblings.T.move(0, -this.getTXHeight(siblings));
				}
			},

			moveRootToConnectionPoint: function (rootSize) {

				var connectionPoint = this.getConnectionPoint(rootSize);

				this.dx += connectionPoint.x;
				this.dy += connectionPoint.y;
			},

			computeRelativePosition: function (root, childAreas) {

				var siblings = this.siblings = this.createSiblings(childAreas, { siblingGap: this.siblingGap });
				var rootSize = this.rootSize = this.getRootSize(root, this.rootMargin);

				joint.util.assign(this, this.computeSize(siblings, rootSize));

				this.moveSiblings(siblings, rootSize);
				this.moveRootToConnectionPoint(rootSize);
				this.moveRootBehindSiblings(siblings, rootSize);
				this.moveRootFromParent();
			},

			computeAbsolutePosition: function () {

				if (this.parentArea) {
					this.rootCX = this.parentArea.rootCX + this.dx;
					this.rootCY = this.parentArea.rootCY + this.dy;
					this.level = this.parentArea.level + 1;
				} else {
					var rootCenter = this.root.getBBox().center();
					this.rootCX = rootCenter.x;
					this.rootCY = rootCenter.y;
					this.level = 0;
				}

				joint.util.assign(this, this.computeOrigin());
			},

			hasVerticalSiblings: function (siblings) {

				return siblings.T.exists() || siblings.B.exists() || siblings.BR.exists() || siblings.BL.exists() || siblings.TR.exists() || siblings.TL.exists();
			},

			hasHorizontalSiblings: function (siblings) {

				return siblings.L.exists() || siblings.R.exists();
			},

			isSourceArea: function () {

				return !this.parentArea;
			},

			isSinkArea: function () {

				return this.childAreas.length === 0;
			},

			getRootPosition: function () {

				var rootSize = this.root.get('size');

				return {
					x: this.rootCX - rootSize.width / 2,
					y: this.rootCY - rootSize.height / 2
				};
			},

			getRootVertices: function (deltaCoordinates, opt) {

				opt = opt || {};
				deltaCoordinates = deltaCoordinates || this;

				if (deltaCoordinates[this.deltaCoordinate] === 0 || !this.parentArea) {
					// Pure horizontal/vertical link has no vertices.
					return [];
				}

				var parentInnerSize = this.parentArea.getInnerSize();
				var relativeVertices;

				if (!opt.ignoreSiblings && this.hasSiblingsBetweenParent()) {
					// vertices avoids the elements between the root and its parent.
					var oppositeSiblings = this.siblings[this.oppositeDirection];
					relativeVertices = this.getRelativeVerticesAvoidingSiblings(
						parentInnerSize,
						deltaCoordinates,
						oppositeSiblings
					);
				} else {
					relativeVertices = this.getRelativeVertices(parentInnerSize, deltaCoordinates);
				}

				return joint.util.invoke(relativeVertices, 'offset', this.parentArea.rootCX, this.parentArea.rootCY);
			},

			getInnerSize: function () {

				return {
					width: this.rootSize.width,
					height: this.getLRHeight()
				};
			},

			getConnectionPoint: function () {

				// root area has no connection point
				return null;
			},

			getRelativeVertices: function () {

				// root area has no inbound link
				return null;
			},

			moveRootFromParent: function () {

				// root area has no parent
			},

			moveRootBehindSiblings: function () {

				// root area dx, dy are always 0,0
			},

			// Is there an element between the root of the area and the parent.
			hasSiblingsBetweenParent: function () {

				return !this.isSourceArea() && this.siblings[this.oppositeDirection].exists();
			},

			getCY: function () {
				return this.height / 2 + this.prevSiblingGap;
			},

			getCX: function () {
				return this.width / 2 + this.prevSiblingGap;
			}

		});

		LayoutArea.extend = Backbone.Model.extend;

		var RightLayoutArea = LayoutArea.extend({

			direction: 'R',
			oppositeDirection: 'L',
			deltaCoordinate: 'dx',
			marginDimension: 'height',

			getConnectionPoint: function (rootSize) {

				return g.point(rootSize.width / 2, 0);
			},

			moveRootBehindSiblings: function (siblings, rootSize) {

				this.dx += Math.max(
					this.getLWidth(siblings, rootSize),
					this.getTBOverlap(siblings, rootSize)
				);

				this.dy += (this.getTHeight(siblings) - this.getBHeight(siblings)) / 2;
			},

			moveRootFromParent: function () {

				this.dx += this.parentGap + this.rootOffset;
			},

			getRelativeVertices: function (parentRootSize, deltaCoordinates) {

				var connectionPoint = this.getConnectionPoint(parentRootSize);
				var dx = this.parentGap / 2;
				return [
					connectionPoint.clone().offset(dx, 0),
					connectionPoint.clone().offset(dx, deltaCoordinates.dy)
				];
			},

			getRelativeVerticesAvoidingSiblings: function (parentRootSize, deltaCoordinates, lSiblings) {

				var connectionPoint = this.getConnectionPoint(parentRootSize);
				var gap = lSiblings.siblingGap / 2;

				var signY = this.dx > 0 ? -1 : 1;
				var y1 = deltaCoordinates.dy + signY * (lSiblings.height + gap) / 2;
				var y2 = deltaCoordinates.dy + signY * this.rootSize.height / 4;
				var x1 = this.gap / 2;
				var x2 = 1.5 * x1 + Math.max(
					this.getLWidth(this.siblings, this.rootSize),
					this.getTBOverlap(this.siblings, this.rootSize)
				);

				return [
					connectionPoint.clone().offset(x1, 0),
					connectionPoint.clone().offset(x1, y1),
					connectionPoint.clone().offset(x2, y1),
					connectionPoint.clone().offset(x2, y2)
				];
			}
		});

		var LeftLayoutArea = LayoutArea.extend({

			direction: 'L',
			oppositeDirection: 'R',
			deltaCoordinate: 'dx',
			marginDimension: 'height',

			getConnectionPoint: function (rootSize) {

				return g.point(- rootSize.width / 2, 0);
			},

			moveRootBehindSiblings: function (siblings, rootSize) {

				this.dx -= Math.max(
					this.getRWidth(siblings, rootSize),
					this.getTBOverlap(siblings, rootSize)
				);

				this.dy += (this.getTHeight(siblings) - this.getBHeight(siblings)) / 2;
			},

			moveRootFromParent: function () {

				this.dx -= this.parentGap + this.rootOffset;
			},

			getRelativeVertices: function (parentRootSize, deltaCoordinates) {

				var connectionPoint = this.getConnectionPoint(parentRootSize);
				var dx = -this.parentGap / 2;
				return [
					connectionPoint.clone().offset(dx, 0),
					connectionPoint.clone().offset(dx, deltaCoordinates.dy)
				];
			},

			getRelativeVerticesAvoidingSiblings: function (parentRootSize, deltaCoordinates, rSiblings) {

				var connectionPoint = this.getConnectionPoint(parentRootSize);

				var signY = this.dx > 0 ? -1 : 1;
				var y1 = deltaCoordinates.dy + signY * (rSiblings.height + rSiblings.siblingGap / 2) / 2;
				var y2 = deltaCoordinates.dy + signY * this.rootSize.height / 4;
				var x1 = this.gap / 2;
				var x2 = 1.5 * x1 + Math.max(
					this.getRWidth(this.siblings, this.rootSize),
					this.getTBOverlap(this.siblings, this.rootSize)
				);

				return [
					connectionPoint.clone().offset(-x1, 0),
					connectionPoint.clone().offset(-x1, y1),
					connectionPoint.clone().offset(-x2, y1),
					connectionPoint.clone().offset(-x2, y2)
				];
			}
		});

		var TopLayoutArea = LayoutArea.extend({

			direction: 'T',
			oppositeDirection: 'B',
			deltaCoordinate: 'dy',
			marginDimension: 'width',

			getConnectionPoint: function (rootSize) {

				return g.point(0, - rootSize.height / 2);
			},

			moveRootBehindSiblings: function (siblings, rootSize) {

				this.dx += this.getRootDX(siblings, rootSize);

				if (this.hasHorizontalSiblings(siblings)) {
					this.dy -= (this.getLRHeight() - rootSize.height) / 2;
				}
				this.dy -= this.getBHeight(siblings);
			},

			moveRootFromParent: function () {

				this.dy -= this.parentGap + this.rootOffset;
			},

			getRelativeVertices: function (parentRootSize, deltaCoordinates) {
				var connectionPoint = this.getConnectionPoint(parentRootSize);
				var dy = -this.getTXHeight(this.parentArea.siblings) - this.parentGap / 2;
				return [
					connectionPoint.clone().offset(0, dy),
					connectionPoint.clone().offset(deltaCoordinates.dx, dy)
				];
			},

			getRelativeVerticesAvoidingSiblings: function (parentRootSize, deltaCoordinates) {

				var connectionPoint = this.getConnectionPoint(parentRootSize);

				var siblings = this.siblings;
				var bSiblings = siblings.B;

				// Jump the Top-Right and Top-Left siblings of the parent element
				var y1 = this.getTXHeight(this.parentArea.siblings) + this.parentGap / 2;
				var y2 = y1 + bSiblings.height;
				// Jump the Bottom-Right and Bottom-Left siblings of the child element
				y2 += this.getBXHeight(this.siblings) + this.parentGap / 4;

				// x1 lies far from the element center
				var signX = this.dy < 0 ? -1 : 1;
				var bxWidth = siblings[signX > 0 ? 'BR' : 'BL'].width;
				var x1 = deltaCoordinates.dx;
				x1 += signX * (Math.max(bxWidth, bSiblings.width / 2) + bSiblings.siblingGap / 4);
				// x2 lies closer to the element center
				var x2 = deltaCoordinates.dx + signX * this.rootSize.width / 4;

				return [
					connectionPoint.clone().offset(0, -y1),
					connectionPoint.clone().offset(x1, -y1),
					connectionPoint.clone().offset(x1, -y2),
					connectionPoint.clone().offset(x2, -y2)
				];
			}
		});

		var BottomLayoutArea = LayoutArea.extend({

			direction: 'B',
			oppositeDirection: 'T',
			deltaCoordinate: 'dy',
			marginDimension: 'width',

			getConnectionPoint: function (rootSize) {

				return g.point(0, rootSize.height / 2);
			},

			moveRootBehindSiblings: function (siblings, rootSize) {

				this.dx += this.getRootDX(siblings, rootSize);

				this.dy += this.getTHeight(siblings);
				if (this.hasHorizontalSiblings(siblings)) {
					this.dy += (this.getLRHeight() - rootSize.height) / 2;
				}
			},

			moveRootFromParent: function () {

				this.dy += this.parentGap + this.rootOffset;
			},

			getRelativeVertices: function (parentRootSize, deltaCoordinates) {

				var connectionPoint = this.getConnectionPoint(parentRootSize);
				var dy = this.getBXHeight(this.parentArea.siblings) + this.parentGap / 2;
				return [
					connectionPoint.clone().offset(0, dy),
					connectionPoint.clone().offset(deltaCoordinates.dx, dy)
				];
			},

			getRelativeVerticesAvoidingSiblings: function (parentRootSize, deltaCoordinates) {

				var connectionPoint = this.getConnectionPoint(parentRootSize);
				var siblings = this.siblings;
				var tSiblings = siblings.T;

				// Jump the Bottom-Right and Bottom-Left siblings of the parent element
				var y1 = this.getBXHeight(this.parentArea.siblings) + this.parentGap / 2;
				var y2 = y1 + tSiblings.height;
				// Jump the Top-Right and Top-Left siblings of the child element
				y2 += this.getTXHeight(siblings) + this.parentGap / 4;

				// x1 lies far from the element center
				var signX = this.dy < 0 ? -1 : 1;
				var txWidth = siblings[signX > 0 ? 'TR' : 'TL'].width;
				var x1 = deltaCoordinates.dx;
				x1 += signX * (Math.max(txWidth, tSiblings.width / 2) + tSiblings.siblingGap / 4);
				// x2 lies close to the element center
				var x2 = deltaCoordinates.dx + signX * this.rootSize.width / 4;

				return [
					connectionPoint.clone().offset(0, y1),
					connectionPoint.clone().offset(x1, y1),
					connectionPoint.clone().offset(x1, y2),
					connectionPoint.clone().offset(x2, y2)
				];
			}
		});

		var BottomRightLayoutArea = LayoutArea.extend({

			direction: 'BR',
			oppositeDirection: 'L',
			deltaCoordinate: 'dy',
			marginDimension: 'height',

			getConnectionPoint: function (rootSize) {

				return g.point(0, rootSize.height / 2);
			},

			getCY: function () {

				return this.prevSiblingGap;
			},

			moveRootBehindSiblings: function (siblings, rootSize) {

				var btWidth = Math.max(siblings.T.width, siblings.B.width);
				this.dx += Math.max(this.getLWidth(siblings, rootSize), (btWidth - rootSize.width) / 2);

				this.dy += this.getTHeight(siblings);
				if (this.hasHorizontalSiblings(siblings)) {
					this.dy += (this.getLRHeight() - rootSize.height) / 2;
				}
			},

			moveRootFromParent: function () {

				var parentArea = this.parentArea;
				if (parentArea) {
					this.dy += parentArea.firstChildGap;
				}
				this.dx += this.rootSize.width / 2 + this.rootOffset + this.parentGap;
			},

			getRelativeVertices: function (parentRootSize, deltaCoordinates) {

				var connectionPoint = this.getConnectionPoint(parentRootSize);

				return [
					connectionPoint
						.clone()
						.offset(0, deltaCoordinates.dy - parentRootSize.height / 2)
				];
			},

			getRelativeVerticesAvoidingSiblings: function (parentRootSize, deltaCoordinates, siblings) {

				var x = deltaCoordinates.dx - this.rootSize.width / 4;
				var y = deltaCoordinates.dy;
				y += Math.max(siblings.height, this.rootSize.height) / 2;
				y += this.getMinimalGap(siblings) / 2;

				return [
					g.point(0, y),
					g.point(x, y)
				];
			}
		});

		var BottomLeftLayoutArea = LayoutArea.extend({

			direction: 'BL',
			oppositeDirection: 'R',
			deltaCoordinate: 'dy',
			marginDimension: 'height',

			getConnectionPoint: function (rootSize) {

				return g.point(0, rootSize.height / 2);
			},

			getCY: function () {

				return this.prevSiblingGap;
			},

			moveRootBehindSiblings: function (siblings, rootSize) {

				var btWidth = Math.max(siblings.T.width, siblings.B.width);
				this.dx -= Math.max(this.getRWidth(siblings, rootSize), (btWidth - rootSize.width) / 2);

				this.dy += this.getTHeight(siblings);
				if (this.hasHorizontalSiblings(siblings)) {
					this.dy += (this.getLRHeight() - rootSize.height) / 2;
				}
			},

			moveRootFromParent: function () {

				var parentArea = this.parentArea;
				if (parentArea) {
					this.dy += parentArea.firstChildGap;
				}
				this.dx -= this.rootSize.width / 2 + this.rootOffset + this.parentGap;
			},

			getRelativeVertices: function (parentRootSize, deltaCoordinates) {

				var connectionPoint = this.getConnectionPoint(parentRootSize);

				return [
					connectionPoint
						.clone()
						.offset(0, deltaCoordinates.dy - parentRootSize.height / 2)
				];
			},

			getRelativeVerticesAvoidingSiblings: function (parentRootSize, deltaCoordinates, siblings) {

				var x = deltaCoordinates.dx + this.rootSize.width / 4;
				var y = deltaCoordinates.dy;
				y += Math.max(siblings.height, this.rootSize.height) / 2;
				y += this.getMinimalGap(siblings) / 2;

				return [
					g.point(0, y),
					g.point(x, y)
				];
			}
		});

		var TopRightLayoutArea = LayoutArea.extend({

			direction: 'TR',
			oppositeDirection: 'L',
			deltaCoordinate: 'dy',
			marginDimension: 'height',

			getConnectionPoint: function (rootSize) {

				return g.point(0, rootSize.height / 2);
			},

			getCY: function () {

				return (this.height - this.rootSize.height) + this.prevSiblingGap;
			},

			moveRootBehindSiblings: function (siblings, rootSize) {

				this.dx += Math.max(
					this.getLWidth(siblings, rootSize),
					this.getTBOverlap(siblings, rootSize)
				);

				this.dy -= this.getBHeight(siblings);
				if (this.hasHorizontalSiblings(siblings)) {
					this.dy -= (this.getLRHeight() - rootSize.height) / 2;
				}
			},

			moveRootFromParent: function () {

				var parentArea = this.parentArea;
				if (parentArea) {
					this.dy -= parentArea.firstChildGap;
				}
				this.dx += this.rootSize.width / 2 + this.rootOffset + this.parentGap;
			},

			getRelativeVertices: function (parentRootSize, deltaCoordinates) {

				var connectionPoint = this.getConnectionPoint(parentRootSize);

				return [
					connectionPoint
						.clone()
						.offset(0, deltaCoordinates.dy - parentRootSize.height / 2)
				];
			},

			getRelativeVerticesAvoidingSiblings: function (parentRootSize, deltaCoordinates, siblings) {

				var x = deltaCoordinates.dx - this.rootSize.width / 4;
				var y = deltaCoordinates.dy;
				y -= Math.max(siblings.height, this.rootSize.height) / 2;
				y -= this.getMinimalGap(siblings) / 2;

				return [
					g.point(0, y),
					g.point(x, y)
				];
			}
		});

		var TopLeftLayoutArea = LayoutArea.extend({

			direction: 'TL',
			oppositeDirection: 'R',
			deltaCoordinate: 'dy',
			marginDimension: 'height',

			getConnectionPoint: function (rootSize) {

				return g.point(0, rootSize.height / 2);
			},

			getCY: function () {

				return (this.height - this.rootSize.height) + this.prevSiblingGap;
			},

			moveRootBehindSiblings: function (siblings, rootSize) {

				this.dx -= Math.max(
					this.getRWidth(siblings, rootSize),
					this.getTBOverlap(siblings, rootSize)
				);

				this.dy -= this.getBHeight(siblings);
				if (this.hasHorizontalSiblings(siblings)) {
					this.dy -= (this.getLRHeight() - rootSize.height) / 2;
				}
			},

			moveRootFromParent: function () {

				var parentArea = this.parentArea;
				if (parentArea) {
					this.dy -= parentArea.firstChildGap;
				}
				this.dx -= this.rootSize.width / 2 + this.rootOffset + this.parentGap;
			},

			getRelativeVertices: function (parentRootSize, deltaCoordinates) {

				var connectionPoint = this.getConnectionPoint(parentRootSize);

				return [
					connectionPoint
						.clone()
						.offset(0, deltaCoordinates.dy - parentRootSize.height / 2)
				];
			},

			getRelativeVerticesAvoidingSiblings: function (parentRootSize, deltaCoordinates, siblings) {

				var x = deltaCoordinates.dx + this.rootSize.width / 4;
				var y = deltaCoordinates.dy;
				y -= Math.max(siblings.height, this.rootSize.height) / 2;
				y -= this.getMinimalGap(siblings) / 2;

				return [
					g.point(0, y),
					g.point(x, y)
				];
			}
		});

		var directionRules = {

			rotate: function (rule) {
				var directions = 'LRBT';
				var directionChange = directions.indexOf(rule[0]) - directions.indexOf(rule[1]);
				return function (direction) {
					var directionIndex = directions.indexOf(direction);
					return (directionIndex >= 0)
						? directions[(4 + directionIndex - directionChange) % 4]
						: direction;
				};
			},

			flip: function (rule) {
				var from = rule[0];
				var to = rule[1];
				return function (direction) {
					if (direction === from) return to;
					if (direction === to) return from;
					return direction;
				};
			},

			straighten: function (rule) {
				return function () {
					return rule[1];
				};
			}

		};

		var TreeLayout = Backbone.Model.extend({

			defaults: {

				// A graph to perform the layout on.
				graph: undefined,

				// Global gap. Could be overriden via parentGap, siblingGap and childrenGap
				gap: 20,

				// Gap between a child and its parent.
				parentGap: 20,

				// Gap between two siblings.
				siblingGap: 20,

				// Gap between parent and its first children
				// Applicable for BR,BL,TR,TL
				firstChildGap: 20,

				// Default direction used when elements
				// doesn't explicitelly specify their direction.
				direction: 'R',

				// A rule telling how to reorganize a branch after reconnect.
				// The root of the branch can change the `direction` so
				// it migth be desirable to change also the directions of
				// its descendants.
				directionRule: directionRules.straighten,

				// Allows elements to be positioned in animated manner.
				//
				// element.transition('position', position, {
				//   delay: 300,
				//   valueFunction: joint.util.interpolate.object,
				// });
				updatePosition: function (element, position, opt) {
					element.set('position', position, opt);
				},

				// Allows vertices to be positioned in animated manner.
				// Please see `updatePosition` option.
				updateVertices: function (link, vertices, opt) {
					link.set('vertices', vertices, opt);
				},

				// Allows setting arbitrary (usually layout-related) attributes
				// on the cells as part of the layout.
				//
				// function(layoutArea, root, rootLink, opt) {
				//   /* update root and rootLink cells. */
				// }
				updateAttributes: null,

				// Arbitrary subtree can be skipped in the layout computation.
				// e.g. a collapse branch is not visible in the paper but present
				// in the graph.
				//
				// function(children, parent, opt) {
				//   /* returns filtered children */
				// }
				filter: null,

				// The element attributes that control layout
				// can be customized here.
				// e.g { direction: 'rankDir' }
				attributeNames: {
					// siblingRank: 'siblingRank',
					// direction: 'direction',
					// margin: 'margin',
					// offset: 'offset'
					// prevSiblingGap: 'prevSibilingGap'
					// nextSiblingGap: 'prevSibilingGap',
					// firstChildGap: 'firstChildGap'
				}
			},

			initialize: function () {

				// Caching the graph and the other options for a quicker access.
				this._cacheOptions(this.attributes);

				// Layout areas cache.
				this.layoutAreas = {};
			},

			// Auto layout the entire graph
			// Each root is treated separately.
			layout: function (opt) {

				// delete the previous layout areas
				this.layoutAreas = {};

				var graphSources = this.getGraphSources(opt);
				for (var i = 0, n = graphSources.length; i < n; i++) {
					this.layoutTree(graphSources[i], opt);
				}

				// COMPAT: backwards compatibility
				this.trigger('layout:done', opt);

				return this;
			},

			// Auto layout a single tree.
			layoutTree: function (root, opt) {

				opt = opt || {};
				opt.treeLayout = true;

				// create layout areas and compute relative positions
				var rootArea = this._computeLayoutAreas(root, null, opt);

				this._computeAbsolutePositions(rootArea);
				this._updateCells(rootArea, opt);

				return this;
			},

			getLayoutArea: function (element) {

				return this.layoutAreas[element.id || element] || null;
			},

			getRootLayoutAreas: function () {

				return this.getGraphSources().map(this.getLayoutArea, this);
			},

			// Returns filtered source elements from the graph
			getGraphSources: function (opt) {

				var sources = this.graph.getSources();
				if (this.filter && sources.length > 0) {
					sources = this.filter(sources, null, opt) || sources;
				}

				return sources;
			},

			// Returns a layout area with minimal size containing the given point.
			getMinimalRootAreaByPoint: function (point) {

				var rootLayoutAreas = this.getRootLayoutAreas().filter(function (layoutArea) {
					return layoutArea.containsPoint(point);
				});

				if (joint.util.isEmpty(rootLayoutAreas)) {
					return null;
				}

				return rootLayoutAreas.reduce(function (res, layoutArea) {
					if (layoutArea.width * layoutArea.height < res.min) {
						res.min = layoutArea.width * layoutArea.height;
						res.item = layoutArea;
					}
					return res;
				}, { min: Infinity, item: undefined }).item;
			},

			// Recursively (in top-down fashion) computes the layout areas
			// for every single element in the current tree.
			_computeLayoutAreas: function (element, prevLayoutArea, opt) {

				// PHASE 1: Going from the root down to the leaves.
				var prevDirection = (prevLayoutArea) ? prevLayoutArea.direction : this.get('direction');
				var direction = element.get(this.getAttributeName('direction')) || prevDirection;
				var layoutArea = LayoutArea.create(direction, element, this.attributes);
				// Link to parent layout area
				layoutArea.parentArea = prevLayoutArea;
				// Find the element inbound link.
				layoutArea.link = this.graph.getConnectedLinks(element, { inbound: true })[0];
				// Recursion start.
				var children = this._getChildren(element, opt);
				var childLayoutAreas = [];
				for (var i = 0, n = children.length; i < n; i++) {
					childLayoutAreas.push(this._computeLayoutAreas(children[i], layoutArea, opt));
				}

				// PHASE 2: Going from the leaves up to the root.
				layoutArea.compute(childLayoutAreas);
				// Store the layout area on the tree layout instance.
				this.layoutAreas[element.id] = layoutArea;

				return layoutArea;
			},

			// Cache options on the instance object for quicker access.
			_cacheOptions: function (options) {

				var functionNames = [
					'updateAttributes',
					'updateVertices',
					'updatePosition',
					'filter'
				];

				// cache functions
				functionNames.forEach(function (name) {
					this[name] = joint.util.isFunction(options[name]) ? options[name] : null;
				}, this);

				// cache graph
				this.graph = options.graph;
			},

			// Returns filtered children for the given parent.
			_getChildren: function (parent, opt) {

				var children = this.graph.getNeighbors(parent, { outbound: true });
				if (this.filter && children.length > 0) {
					children = this.filter(children, parent, opt) || children;
				}

				return children;
			},

			// Recursively computes the elements absolute positions based on
			// the relative position and absolute position of the parent element.
			_computeAbsolutePositions: function (layoutArea) {

				layoutArea.computeAbsolutePosition(layoutArea);
				for (var i = 0, n = layoutArea.childAreas.length; i < n; i++) {
					this._computeAbsolutePositions(layoutArea.childAreas[i]);
				}
			},

			// Applies computed values on the tree cells.
			_updateCells: function (layoutArea, opt) {

				var rootElement = layoutArea.root;
				var rootLink = layoutArea.link || null;

				if (rootLink) {

					// update the position of the current root.
					if (this.updatePosition) {
						this.updatePosition(rootElement, layoutArea.getRootPosition(), opt);
					}

					// update the vertices of the link connected to the current root.
					if (this.updateVertices) {
						this.updateVertices(rootLink, layoutArea.getRootVertices(), opt);
					}
				}

				this.changeSiblingRank(rootElement, layoutArea.siblingRank, opt);

				// update the attributes of the current root and the associated link
				if (this.updateAttributes) {
					this.updateAttributes(layoutArea, rootElement, rootLink, opt);
				}

				for (var i = 0, n = layoutArea.childAreas.length; i < n; i++) {
					this._updateCells(layoutArea.childAreas[i], opt);
				}
			},

			updateDirections: function (root, rule, opt) {

				opt = opt || {};

				var directionAttribute = this.getAttributeName('direction');
				var getDirection = this.get('directionRule')(rule);

				this.graph.search(root, function (element, level) {

					if (level === 0) return;
					var newDirection = getDirection(element.get(directionAttribute));
					this.changeDirection(element, newDirection, opt);

				}.bind(this), { outbound: true });
			},

			reconnectElement: function (element, targetElement, opt) {

				opt = opt || {};

				var layoutArea = this.getLayoutArea(element);
				var link = layoutArea.link;

				if (link) {

					link.set('source', { id: targetElement.id || targetElement }, opt);

					var oldDirection = layoutArea.direction;
					var newDirection = opt.direction || oldDirection;
					var newSiblingRank = opt.siblingRank || undefined;

					this.changeSiblingRank(element, newSiblingRank, opt);
					this.changeDirection(element, newDirection, opt);

					if (oldDirection !== newDirection) {
						this.updateDirections(element, [oldDirection, opt.direction], opt);
					}

					return true;
				}

				return false;
			},

			// A convenient way how to get/set cells attributes
			// as the attribute names can vary based on the tree layout settings.

			changeSiblingRank: function (element, siblingRank, opt) {

				element.set(this.getAttributeName('siblingRank'), siblingRank, opt);
			},

			changeDirection: function (element, direction, opt) {

				element.set(this.getAttributeName('direction'), direction, opt);
			},

			getAttributeName: function (attribute) {

				return this.get('attributeNames')[attribute] || attribute;
			},

			getAttribute: function (element, attribute) {

				return element.get(this.getAttributeName(attribute));
			},

			// COMPAT: backwards compatibilty

			prepare: function () {

				// This method built the adjacency table originally.
				// No need for this now as the graph build one internally.
				return this;
			}

		}, {

				directionRules: directionRules

			});

		// Export
		joint.layout.TreeLayout = TreeLayout;

	})(joint, Backbone, _, g);

	joint.format.gexf = {};

	joint.format.gexf.toCellsArray = function (xmlString, makeElement, makeLink) {

		// Parse the `xmlString` into a DOM tree.
		var parser = new DOMParser();
		var dom = parser.parseFromString(xmlString, 'text/xml');
		if (dom.documentElement.nodeName == 'parsererror') {
			throw new Error('Error while parsing GEXF file.');
		}

		// Get all nodes and edges.
		var nodes = Array.from(dom.documentElement.querySelectorAll('node'));
		var edges = Array.from(dom.documentElement.querySelectorAll('edge'));

		// Return value.
		var cells = [];

		nodes.forEach(function (node) {

			var size = parseFloat(node.querySelector('size').getAttribute('value'));

			var element = makeElement({
				id: node.getAttribute('id'),
				width: size,
				height: size,
				label: node.getAttribute('label')
			});

			cells.push(element);
		});

		edges.forEach(function (edge) {

			var link = makeLink({ source: edge.getAttribute('source'), target: edge.getAttribute('target') });
			cells.unshift(link);
		});

		return cells;
	};

	(function (joint, V, $, util) {

		joint.dia.Paper.prototype.toSVG = function (callback, opt) {

			opt = opt || {};

			this.trigger('beforeexport', opt);

			// We'll be modifying `style` attribute of elements/nodes. Therefore,
			// we're making a deep clone of the whole SVG document.
			var exportSVG = V(this.svg).clone();
			var exportViewport = exportSVG.findOne('.' + util.addClassNamePrefix('viewport'));
			var viewportBBox = opt.area || this.paperToLocalRect(this.getContentBBox());
			// Make the SVG dimensions as small as the viewport.
			// Note that those are set in the `viewBox` attribute rather then in the
			// `width`/`height` attributes. This allows for fitting the svg element inside containers.
			var dimensions = opt.preserveDimensions;
			if (dimensions) {
				exportSVG.attr({
					width: dimensions.width || viewportBBox.width,
					height: dimensions.height || viewportBBox.height
				});
			}
			// We're removing css styles from the svg container. (i.e backround-image)
			// Set SVG viewBox starting at top-leftmost element's position (viewportBbox.x|y).
			// We're doing this because we want to trim the `whitespace` areas of the SVG making its size
			// as small as necessary.
			exportSVG.removeAttr('style').attr('viewBox', [
				viewportBBox.x,
				viewportBBox.y,
				viewportBBox.width,
				viewportBBox.height
			].join(' '));
			// Remove the viewport transformation.
			// We do not want the resulting SVG to be scaled or translated.
			exportViewport.removeAttr('transform');

			if (opt.useComputedStyles !== false) {
				// Default branch (for backwards compatibility)
				copyExternalStyles(this.svg, exportSVG.node);
			}

			var stylesheet = opt.stylesheet;
			if (util.isString(stylesheet)) {
				// e.g [
				//     '.connection { fill: none }',
				//     '.connection-wrap, .marker-vertices, .marker-arrowheads, .link-tools { display: none }'
				// ].join('');
				addExternalStyles(exportSVG.node, stylesheet);
			}


			this.trigger('afterexport', opt);

			if (opt.convertImagesToDataUris) {

				var exportImages = exportSVG.find('image');
				var deffereds = exportImages.map(convertImage);
				$.when.apply($, deffereds).then(function () {
					callback(serialize(exportSVG.node));
				});

			} else {
				// Now, when our `exportSVG` is ready, serialize it to a string and return it.
				callback(serialize(exportSVG.node));
			}
		};

		function convertImage(image) {

			var deffered = $.Deferred();
			// Firefox uses `href`, all the others 'xlink:href'
			var url = image.attr('xlink:href') || image.attr('href');
			util.imageToDataUri(url, function (err, dataUri) {
				if (!err && dataUri) {
					image.attr('xlink:href', dataUri);
				}
				deffered.resolve();
			});

			return deffered.promise();
		}

		function serialize(node) {
			// fix for invalid XML entities (no-break spaces) in Safari
			return (new XMLSerializer()).serializeToString(node).replace(/&nbsp;/g, '\u00A0');
		}

		function addExternalStyles(toNode, styles) {
			var doc = toNode.ownerDocument;
			var xml = doc.implementation.createDocument(null, 'xml', null);
			V(toNode).prepend(V('style', { type: 'text/css' }, [
				xml.createCDATASection(styles)
			]));
		}

		function copyExternalStyles(fromNode, toNode) {

			var fromElements = Array.from(fromNode.querySelectorAll('*'));
			var toElements = Array.from(toNode.querySelectorAll('*'));

			// Now the fun part. The code below has one purpuse and i.e. store all the CSS declarations
			// from external stylesheets to the `style` attribute of the SVG document nodes.
			// This is achieved in three steps.

			// 1. Disabling all the stylesheets in the page and therefore collecting only default style values.
			//    This, together with the step 2, makes it possible to discard default CSS property values
			//    and store only those that differ.
			// 2. Enabling back all the stylesheets in the page and collecting styles that differ from the default values.
			// 3. Applying the difference between default values and the ones set by custom stylesheets
			//    onto the `style` attribute of each of the nodes in SVG.

			// Note that all of this would be much more simplified if `window.getMatchedCSSRules()` worked
			// in all the supported browsers. Pity is that it doesn't even work in WebKit that
			// has it (https://bugzilla.mozilla.org/show_bug.cgi?id=438278).
			// Pollyfil for Firefox can be https://gist.github.com/ydaniv/3033012;

			var doc = fromNode.ownerDocument;
			var styleSheetsCount = doc.styleSheets.length;
			var styleSheetsCopy = [];

			// 1.
			for (var i = styleSheetsCount - 1; i >= 0; i--) {

				// There is a bug (bugSS) in Chrome 14 and Safari. When you set stylesheet.disable = true it will
				// also remove it from document.styleSheets. So we need to store all stylesheets before
				// we disable them. Later on we put them back to document.styleSheets if needed.
				// See the bug `https://code.google.com/p/chromium/issues/detail?id=88310`.
				styleSheetsCopy[i] = doc.styleSheets[i];
				doc.styleSheets[i].disabled = true;
			}

			var defaultComputedStyles = {};

			fromElements.forEach(function (el, idx) {

				var computedStyle = window.getComputedStyle(el, null);
				// We're making a deep copy of the `computedStyle` so that it's not affected
				// by that next step when all the stylesheets are re-enabled again.
				var defaultComputedStyle = {};
				joint.util.forIn(computedStyle, function (property) {
					defaultComputedStyle[property] = computedStyle.getPropertyValue(property);
				});

				defaultComputedStyles[idx] = defaultComputedStyle;
			});


			// bugSS: Check whether the stylesheets have been removed from document.styleSheets
			if (styleSheetsCount != doc.styleSheets.length) {
				// bugSS: Copy all stylesheets back
				styleSheetsCopy.forEach(function (copy, i) {
					doc.styleSheets[i] = copy;
				});
			}

			// 2.
			// bugSS: Note that if stylesheet bug happen the document.styleSheets.length is still 0.
			for (var j = 0; j < styleSheetsCount; j++) {
				doc.styleSheets[j].disabled = false;
			}
			// bugSS: Now is document.styleSheets.length = number of stylesheets again.

			var customStyles = {};

			fromElements.forEach(function (el, idx) {

				var computedStyle = window.getComputedStyle(el, null);
				var defaultComputedStyle = defaultComputedStyles[idx];
				var customStyle = {};

				joint.util.forIn(computedStyle, function (property) {
					// Store only those that differ from the default styles applied by the browser.
					// TODO: Problem will arise with browser specific properties (browser prefixed ones).
					if (computedStyle.getPropertyValue(property) !== defaultComputedStyle[property]) {
						customStyle[property] = computedStyle.getPropertyValue(property);
					}
				});

				customStyles[idx] = customStyle;
			});

			// 3.
			toElements.forEach(function (el, idx) {
				$(el).css(customStyles[idx]);
			});
		}

		// Just a little helper for quick-opening the paper as data-uri SVG in a new browser window.
		joint.dia.Paper.prototype.openAsSVG = function (opt) {

			var windowFeatures = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes';
			var windowName = util.uniqueId('svg_output');

			this.toSVG(function (svg) {

				var imageWindow = window.open('', windowName, windowFeatures);
				var dataImageUri = 'data:image/svg+xml,' + encodeURIComponent(svg);
				imageWindow.document.write('<img src="' + dataImageUri + '" style="max-height:100%" />');

			}, util.assign({ convertImagesToDataUris: true }, opt));
		};

	})(joint, V, $, joint.util);

	/*
	
	StackBlur - a fast almost Gaussian Blur For Canvas
	
	Version: 	0.5
	Author:		Mario Klingemann
	Contact: 	mario@quasimondo.com
	Website:	http://www.quasimondo.com/StackBlurForCanvas
	Twitter:	@quasimondo
	
	In case you find this class useful - especially in commercial projects -
	I am not totally unhappy for a small donation to my PayPal account
	mario@quasimondo.de
	
	Or support me on flattr: 
	https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript
	
	Copyright (c) 2010 Mario Klingemann
	
	Permission is hereby granted, free of charge, to any person
	obtaining a copy of this software and associated documentation
	files (the "Software"), to deal in the Software without
	restriction, including without limitation the rights to use,
	copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the
	Software is furnished to do so, subject to the following
	conditions:
	
	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	OTHER DEALINGS IN THE SOFTWARE.
	*/

	(function (global) {

		var mul_table = [
			512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512,
			454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512,
			482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456,
			437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512,
			497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328,
			320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456,
			446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335,
			329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512,
			505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405,
			399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328,
			324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271,
			268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456,
			451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388,
			385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335,
			332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292,
			289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259];


		var shg_table = [
			9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17,
			17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19,
			19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20,
			20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21,
			21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21,
			21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22,
			22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22,
			22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23,
			23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
			23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
			23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
			23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
			24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
			24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
			24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
			24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];

		function premultiplyAlpha(imageData) {
			var pixels = imageData.data;
			var size = imageData.width * imageData.height * 4;

			for (var i = 0; i < size; i += 4) {
				var a = pixels[i + 3] / 255;
				pixels[i] *= a;
				pixels[i + 1] *= a;
				pixels[i + 2] *= a;
			}
		}

		function unpremultiplyAlpha(imageData) {
			var pixels = imageData.data;
			var size = imageData.width * imageData.height * 4;

			for (var i = 0; i < size; i += 4) {
				var a = pixels[i + 3];
				if (a != 0) {
					a = 255 / a;
					pixels[i] *= a;
					pixels[i + 1] *= a;
					pixels[i + 2] *= a;
				}
			}
		}

		function stackBlurImage(imageID, canvasID, radius, blurAlphaChannel) {

			var img = document.getElementById(imageID);
			var w = img.naturalWidth;
			var h = img.naturalHeight;

			var canvas = document.getElementById(canvasID);

			canvas.style.width = w + "px";
			canvas.style.height = h + "px";
			canvas.width = w;
			canvas.height = h;

			var context = canvas.getContext("2d");
			context.clearRect(0, 0, w, h);
			context.drawImage(img, 0, 0);

			if (isNaN(radius) || radius < 1) return;

			if (blurAlphaChannel)
				stackBlurCanvasRGBA(canvasID, 0, 0, w, h, radius);
			else
				stackBlurCanvasRGB(canvasID, 0, 0, w, h, radius);
		}


		function stackBlurCanvasRGBA(id, top_x, top_y, width, height, radius) {
			if (isNaN(radius) || radius < 1) return;
			radius |= 0;

			var canvas = document.getElementById(id);
			var context = canvas.getContext("2d");
			var imageData;

			try {
				try {
					imageData = context.getImageData(top_x, top_y, width, height);
				} catch (e) {

					// NOTE: this part is supposedly only needed if you want to work with local files
					// so it might be okay to remove the whole try/catch block and just use
					// imageData = context.getImageData( top_x, top_y, width, height );
					try {
						netscape.security.PrivilegeManager.enablePrivilege("UniversalBrowserRead");
						imageData = context.getImageData(top_x, top_y, width, height);
					} catch (e) {
						alert("Cannot access local image");
						throw new Error("unable to access local image data: " + e);
						return;
					}
				}
			} catch (e) {
				alert("Cannot access image");
				throw new Error("unable to access image data: " + e);
			}

			premultiplyAlpha(imageData);

			var pixels = imageData.data;

			var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum,
				r_out_sum, g_out_sum, b_out_sum, a_out_sum,
				r_in_sum, g_in_sum, b_in_sum, a_in_sum,
				pr, pg, pb, pa, rbs;

			var div = radius + radius + 1;
			var w4 = width << 2;
			var widthMinus1 = width - 1;
			var heightMinus1 = height - 1;
			var radiusPlus1 = radius + 1;
			var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;

			var stackStart = new BlurStack();
			var stack = stackStart;
			for (i = 1; i < div; i++) {
				stack = stack.next = new BlurStack();
				if (i == radiusPlus1) var stackEnd = stack;
			}
			stack.next = stackStart;
			var stackIn = null;
			var stackOut = null;

			yw = yi = 0;

			var mul_sum = mul_table[radius];
			var shg_sum = shg_table[radius];

			for (y = 0; y < height; y++) {
				r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;

				r_out_sum = radiusPlus1 * (pr = pixels[yi]);
				g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
				b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
				a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);

				r_sum += sumFactor * pr;
				g_sum += sumFactor * pg;
				b_sum += sumFactor * pb;
				a_sum += sumFactor * pa;

				stack = stackStart;

				for (i = 0; i < radiusPlus1; i++) {
					stack.r = pr;
					stack.g = pg;
					stack.b = pb;
					stack.a = pa;
					stack = stack.next;
				}

				for (i = 1; i < radiusPlus1; i++) {
					p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
					r_sum += (stack.r = (pr = pixels[p])) * (rbs = radiusPlus1 - i);
					g_sum += (stack.g = (pg = pixels[p + 1])) * rbs;
					b_sum += (stack.b = (pb = pixels[p + 2])) * rbs;
					a_sum += (stack.a = (pa = pixels[p + 3])) * rbs;

					r_in_sum += pr;
					g_in_sum += pg;
					b_in_sum += pb;
					a_in_sum += pa;

					stack = stack.next;
				}

				stackIn = stackStart;
				stackOut = stackEnd;
				for (x = 0; x < width; x++) {
					pixels[yi] = (r_sum * mul_sum) >> shg_sum;
					pixels[yi + 1] = (g_sum * mul_sum) >> shg_sum;
					pixels[yi + 2] = (b_sum * mul_sum) >> shg_sum;
					pixels[yi + 3] = (a_sum * mul_sum) >> shg_sum;

					r_sum -= r_out_sum;
					g_sum -= g_out_sum;
					b_sum -= b_out_sum;
					a_sum -= a_out_sum;

					r_out_sum -= stackIn.r;
					g_out_sum -= stackIn.g;
					b_out_sum -= stackIn.b;
					a_out_sum -= stackIn.a;

					p = (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2;

					r_in_sum += (stackIn.r = pixels[p]);
					g_in_sum += (stackIn.g = pixels[p + 1]);
					b_in_sum += (stackIn.b = pixels[p + 2]);
					a_in_sum += (stackIn.a = pixels[p + 3]);

					r_sum += r_in_sum;
					g_sum += g_in_sum;
					b_sum += b_in_sum;
					a_sum += a_in_sum;

					stackIn = stackIn.next;

					r_out_sum += (pr = stackOut.r);
					g_out_sum += (pg = stackOut.g);
					b_out_sum += (pb = stackOut.b);
					a_out_sum += (pa = stackOut.a);

					r_in_sum -= pr;
					g_in_sum -= pg;
					b_in_sum -= pb;
					a_in_sum -= pa;

					stackOut = stackOut.next;

					yi += 4;
				}
				yw += width;
			}


			for (x = 0; x < width; x++) {
				g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;

				yi = x << 2;
				r_out_sum = radiusPlus1 * (pr = pixels[yi]);
				g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
				b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
				a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);

				r_sum += sumFactor * pr;
				g_sum += sumFactor * pg;
				b_sum += sumFactor * pb;
				a_sum += sumFactor * pa;

				stack = stackStart;

				for (i = 0; i < radiusPlus1; i++) {
					stack.r = pr;
					stack.g = pg;
					stack.b = pb;
					stack.a = pa;
					stack = stack.next;
				}

				yp = width;

				for (i = 1; i <= radius; i++) {
					yi = (yp + x) << 2;

					r_sum += (stack.r = (pr = pixels[yi])) * (rbs = radiusPlus1 - i);
					g_sum += (stack.g = (pg = pixels[yi + 1])) * rbs;
					b_sum += (stack.b = (pb = pixels[yi + 2])) * rbs;
					a_sum += (stack.a = (pa = pixels[yi + 3])) * rbs;

					r_in_sum += pr;
					g_in_sum += pg;
					b_in_sum += pb;
					a_in_sum += pa;

					stack = stack.next;

					if (i < heightMinus1) {
						yp += width;
					}
				}

				yi = x;
				stackIn = stackStart;
				stackOut = stackEnd;
				for (y = 0; y < height; y++) {
					p = yi << 2;
					pixels[p] = (r_sum * mul_sum) >> shg_sum;
					pixels[p + 1] = (g_sum * mul_sum) >> shg_sum;
					pixels[p + 2] = (b_sum * mul_sum) >> shg_sum;
					pixels[p + 3] = (a_sum * mul_sum) >> shg_sum;

					r_sum -= r_out_sum;
					g_sum -= g_out_sum;
					b_sum -= b_out_sum;
					a_sum -= a_out_sum;

					r_out_sum -= stackIn.r;
					g_out_sum -= stackIn.g;
					b_out_sum -= stackIn.b;
					a_out_sum -= stackIn.a;

					p = (x + (((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width)) << 2;

					r_sum += (r_in_sum += (stackIn.r = pixels[p]));
					g_sum += (g_in_sum += (stackIn.g = pixels[p + 1]));
					b_sum += (b_in_sum += (stackIn.b = pixels[p + 2]));
					a_sum += (a_in_sum += (stackIn.a = pixels[p + 3]));

					stackIn = stackIn.next;

					r_out_sum += (pr = stackOut.r);
					g_out_sum += (pg = stackOut.g);
					b_out_sum += (pb = stackOut.b);
					a_out_sum += (pa = stackOut.a);

					r_in_sum -= pr;
					g_in_sum -= pg;
					b_in_sum -= pb;
					a_in_sum -= pa;

					stackOut = stackOut.next;

					yi += width;
				}
			}

			unpremultiplyAlpha(imageData);

			context.putImageData(imageData, top_x, top_y);
		}


		function stackBlurCanvasRGB(id, top_x, top_y, width, height, radius) {
			if (isNaN(radius) || radius < 1) return;
			radius |= 0;

			var canvas = document.getElementById(id);
			var context = canvas.getContext("2d");
			var imageData;

			try {
				try {
					imageData = context.getImageData(top_x, top_y, width, height);
				} catch (e) {

					// NOTE: this part is supposedly only needed if you want to work with local files
					// so it might be okay to remove the whole try/catch block and just use
					// imageData = context.getImageData( top_x, top_y, width, height );
					try {
						netscape.security.PrivilegeManager.enablePrivilege("UniversalBrowserRead");
						imageData = context.getImageData(top_x, top_y, width, height);
					} catch (e) {
						alert("Cannot access local image");
						throw new Error("unable to access local image data: " + e);
						return;
					}
				}
			} catch (e) {
				alert("Cannot access image");
				throw new Error("unable to access image data: " + e);
			}

			var pixels = imageData.data;

			var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum,
				r_out_sum, g_out_sum, b_out_sum,
				r_in_sum, g_in_sum, b_in_sum,
				pr, pg, pb, rbs;

			var div = radius + radius + 1;
			var w4 = width << 2;
			var widthMinus1 = width - 1;
			var heightMinus1 = height - 1;
			var radiusPlus1 = radius + 1;
			var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;

			var stackStart = new BlurStack();
			var stack = stackStart;
			for (i = 1; i < div; i++) {
				stack = stack.next = new BlurStack();
				if (i == radiusPlus1) var stackEnd = stack;
			}
			stack.next = stackStart;
			var stackIn = null;
			var stackOut = null;

			yw = yi = 0;

			var mul_sum = mul_table[radius];
			var shg_sum = shg_table[radius];

			for (y = 0; y < height; y++) {
				r_in_sum = g_in_sum = b_in_sum = r_sum = g_sum = b_sum = 0;

				r_out_sum = radiusPlus1 * (pr = pixels[yi]);
				g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
				b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);

				r_sum += sumFactor * pr;
				g_sum += sumFactor * pg;
				b_sum += sumFactor * pb;

				stack = stackStart;

				for (i = 0; i < radiusPlus1; i++) {
					stack.r = pr;
					stack.g = pg;
					stack.b = pb;
					stack = stack.next;
				}

				for (i = 1; i < radiusPlus1; i++) {
					p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
					r_sum += (stack.r = (pr = pixels[p])) * (rbs = radiusPlus1 - i);
					g_sum += (stack.g = (pg = pixels[p + 1])) * rbs;
					b_sum += (stack.b = (pb = pixels[p + 2])) * rbs;

					r_in_sum += pr;
					g_in_sum += pg;
					b_in_sum += pb;

					stack = stack.next;
				}


				stackIn = stackStart;
				stackOut = stackEnd;
				for (x = 0; x < width; x++) {
					pixels[yi] = (r_sum * mul_sum) >> shg_sum;
					pixels[yi + 1] = (g_sum * mul_sum) >> shg_sum;
					pixels[yi + 2] = (b_sum * mul_sum) >> shg_sum;

					r_sum -= r_out_sum;
					g_sum -= g_out_sum;
					b_sum -= b_out_sum;

					r_out_sum -= stackIn.r;
					g_out_sum -= stackIn.g;
					b_out_sum -= stackIn.b;

					p = (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2;

					r_in_sum += (stackIn.r = pixels[p]);
					g_in_sum += (stackIn.g = pixels[p + 1]);
					b_in_sum += (stackIn.b = pixels[p + 2]);

					r_sum += r_in_sum;
					g_sum += g_in_sum;
					b_sum += b_in_sum;

					stackIn = stackIn.next;

					r_out_sum += (pr = stackOut.r);
					g_out_sum += (pg = stackOut.g);
					b_out_sum += (pb = stackOut.b);

					r_in_sum -= pr;
					g_in_sum -= pg;
					b_in_sum -= pb;

					stackOut = stackOut.next;

					yi += 4;
				}
				yw += width;
			}


			for (x = 0; x < width; x++) {
				g_in_sum = b_in_sum = r_in_sum = g_sum = b_sum = r_sum = 0;

				yi = x << 2;
				r_out_sum = radiusPlus1 * (pr = pixels[yi]);
				g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
				b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);

				r_sum += sumFactor * pr;
				g_sum += sumFactor * pg;
				b_sum += sumFactor * pb;

				stack = stackStart;

				for (i = 0; i < radiusPlus1; i++) {
					stack.r = pr;
					stack.g = pg;
					stack.b = pb;
					stack = stack.next;
				}

				yp = width;

				for (i = 1; i <= radius; i++) {
					yi = (yp + x) << 2;

					r_sum += (stack.r = (pr = pixels[yi])) * (rbs = radiusPlus1 - i);
					g_sum += (stack.g = (pg = pixels[yi + 1])) * rbs;
					b_sum += (stack.b = (pb = pixels[yi + 2])) * rbs;

					r_in_sum += pr;
					g_in_sum += pg;
					b_in_sum += pb;

					stack = stack.next;

					if (i < heightMinus1) {
						yp += width;
					}
				}

				yi = x;
				stackIn = stackStart;
				stackOut = stackEnd;
				for (y = 0; y < height; y++) {
					p = yi << 2;
					pixels[p] = (r_sum * mul_sum) >> shg_sum;
					pixels[p + 1] = (g_sum * mul_sum) >> shg_sum;
					pixels[p + 2] = (b_sum * mul_sum) >> shg_sum;

					r_sum -= r_out_sum;
					g_sum -= g_out_sum;
					b_sum -= b_out_sum;

					r_out_sum -= stackIn.r;
					g_out_sum -= stackIn.g;
					b_out_sum -= stackIn.b;

					p = (x + (((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width)) << 2;

					r_sum += (r_in_sum += (stackIn.r = pixels[p]));
					g_sum += (g_in_sum += (stackIn.g = pixels[p + 1]));
					b_sum += (b_in_sum += (stackIn.b = pixels[p + 2]));

					stackIn = stackIn.next;

					r_out_sum += (pr = stackOut.r);
					g_out_sum += (pg = stackOut.g);
					b_out_sum += (pb = stackOut.b);

					r_in_sum -= pr;
					g_in_sum -= pg;
					b_in_sum -= pb;

					stackOut = stackOut.next;

					yi += width;
				}
			}

			context.putImageData(imageData, top_x, top_y);

		}

		function BlurStack() {
			this.r = 0;
			this.g = 0;
			this.b = 0;
			this.a = 0;
			this.next = null;
		}

		var stackBlur = {
			image: stackBlurImage,
			canvasRGBA: stackBlurCanvasRGBA,
			canvasRGB: stackBlurCanvasRGB
		};

		//// export as AMD...
		//if (typeof define !== 'undefined' && define.amd) {
		//	define(function () { return stackBlur; });
		//} else

		// ...or as browserify
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = stackBlur;
		}

		global.stackBlur = stackBlur;

	}(typeof window !== 'undefined' ? window : this));
	/**
	 * A class to parse color values
	 * @author Stoyan Stefanov <sstoo@gmail.com>
	 * @link   http://www.phpied.com/rgb-color-parser-in-javascript/
	 * @license Use it if you like it
	 */

	(function (global) {

		function RGBColor(color_string) {
			this.ok = false;

			// strip any leading #
			if (color_string.charAt(0) == '#') { // remove # if any
				color_string = color_string.substr(1, 6);
			}

			color_string = color_string.replace(/ /g, '');
			color_string = color_string.toLowerCase();

			// before getting into regexps, try simple matches
			// and overwrite the input
			var simple_colors = {
				aliceblue: 'f0f8ff',
				antiquewhite: 'faebd7',
				aqua: '00ffff',
				aquamarine: '7fffd4',
				azure: 'f0ffff',
				beige: 'f5f5dc',
				bisque: 'ffe4c4',
				black: '000000',
				blanchedalmond: 'ffebcd',
				blue: '0000ff',
				blueviolet: '8a2be2',
				brown: 'a52a2a',
				burlywood: 'deb887',
				cadetblue: '5f9ea0',
				chartreuse: '7fff00',
				chocolate: 'd2691e',
				coral: 'ff7f50',
				cornflowerblue: '6495ed',
				cornsilk: 'fff8dc',
				crimson: 'dc143c',
				cyan: '00ffff',
				darkblue: '00008b',
				darkcyan: '008b8b',
				darkgoldenrod: 'b8860b',
				darkgray: 'a9a9a9',
				darkgreen: '006400',
				darkkhaki: 'bdb76b',
				darkmagenta: '8b008b',
				darkolivegreen: '556b2f',
				darkorange: 'ff8c00',
				darkorchid: '9932cc',
				darkred: '8b0000',
				darksalmon: 'e9967a',
				darkseagreen: '8fbc8f',
				darkslateblue: '483d8b',
				darkslategray: '2f4f4f',
				darkturquoise: '00ced1',
				darkviolet: '9400d3',
				deeppink: 'ff1493',
				deepskyblue: '00bfff',
				dimgray: '696969',
				dodgerblue: '1e90ff',
				feldspar: 'd19275',
				firebrick: 'b22222',
				floralwhite: 'fffaf0',
				forestgreen: '228b22',
				fuchsia: 'ff00ff',
				gainsboro: 'dcdcdc',
				ghostwhite: 'f8f8ff',
				gold: 'ffd700',
				goldenrod: 'daa520',
				gray: '808080',
				green: '008000',
				greenyellow: 'adff2f',
				honeydew: 'f0fff0',
				hotpink: 'ff69b4',
				indianred: 'cd5c5c',
				indigo: '4b0082',
				ivory: 'fffff0',
				khaki: 'f0e68c',
				lavender: 'e6e6fa',
				lavenderblush: 'fff0f5',
				lawngreen: '7cfc00',
				lemonchiffon: 'fffacd',
				lightblue: 'add8e6',
				lightcoral: 'f08080',
				lightcyan: 'e0ffff',
				lightgoldenrodyellow: 'fafad2',
				lightgrey: 'd3d3d3',
				lightgreen: '90ee90',
				lightpink: 'ffb6c1',
				lightsalmon: 'ffa07a',
				lightseagreen: '20b2aa',
				lightskyblue: '87cefa',
				lightslateblue: '8470ff',
				lightslategray: '778899',
				lightsteelblue: 'b0c4de',
				lightyellow: 'ffffe0',
				lime: '00ff00',
				limegreen: '32cd32',
				linen: 'faf0e6',
				magenta: 'ff00ff',
				maroon: '800000',
				mediumaquamarine: '66cdaa',
				mediumblue: '0000cd',
				mediumorchid: 'ba55d3',
				mediumpurple: '9370d8',
				mediumseagreen: '3cb371',
				mediumslateblue: '7b68ee',
				mediumspringgreen: '00fa9a',
				mediumturquoise: '48d1cc',
				mediumvioletred: 'c71585',
				midnightblue: '191970',
				mintcream: 'f5fffa',
				mistyrose: 'ffe4e1',
				moccasin: 'ffe4b5',
				navajowhite: 'ffdead',
				navy: '000080',
				oldlace: 'fdf5e6',
				olive: '808000',
				olivedrab: '6b8e23',
				orange: 'ffa500',
				orangered: 'ff4500',
				orchid: 'da70d6',
				palegoldenrod: 'eee8aa',
				palegreen: '98fb98',
				paleturquoise: 'afeeee',
				palevioletred: 'd87093',
				papayawhip: 'ffefd5',
				peachpuff: 'ffdab9',
				peru: 'cd853f',
				pink: 'ffc0cb',
				plum: 'dda0dd',
				powderblue: 'b0e0e6',
				purple: '800080',
				red: 'ff0000',
				rosybrown: 'bc8f8f',
				royalblue: '4169e1',
				saddlebrown: '8b4513',
				salmon: 'fa8072',
				sandybrown: 'f4a460',
				seagreen: '2e8b57',
				seashell: 'fff5ee',
				sienna: 'a0522d',
				silver: 'c0c0c0',
				skyblue: '87ceeb',
				slateblue: '6a5acd',
				slategray: '708090',
				snow: 'fffafa',
				springgreen: '00ff7f',
				steelblue: '4682b4',
				tan: 'd2b48c',
				teal: '008080',
				thistle: 'd8bfd8',
				tomato: 'ff6347',
				turquoise: '40e0d0',
				violet: 'ee82ee',
				violetred: 'd02090',
				wheat: 'f5deb3',
				white: 'ffffff',
				whitesmoke: 'f5f5f5',
				yellow: 'ffff00',
				yellowgreen: '9acd32'
			};
			for (var key in simple_colors) {
				if (color_string == key) {
					color_string = simple_colors[key];
				}
			}
			// emd of simple type-in colors

			// array of color definition objects
			var color_defs = [
				{
					re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
					example: ['rgb(123, 234, 45)', 'rgb(255,234,245)'],
					process: function (bits) {
						return [
							parseInt(bits[1]),
							parseInt(bits[2]),
							parseInt(bits[3])
						];
					}
				},
				{
					re: /^(\w{2})(\w{2})(\w{2})$/,
					example: ['#00ff00', '336699'],
					process: function (bits) {
						return [
							parseInt(bits[1], 16),
							parseInt(bits[2], 16),
							parseInt(bits[3], 16)
						];
					}
				},
				{
					re: /^(\w{1})(\w{1})(\w{1})$/,
					example: ['#fb0', 'f0f'],
					process: function (bits) {
						return [
							parseInt(bits[1] + bits[1], 16),
							parseInt(bits[2] + bits[2], 16),
							parseInt(bits[3] + bits[3], 16)
						];
					}
				}
			];

			// search through the definitions to find a match
			for (var i = 0; i < color_defs.length; i++) {
				var re = color_defs[i].re;
				var processor = color_defs[i].process;
				var bits = re.exec(color_string);
				if (bits) {
					channels = processor(bits);
					this.r = channels[0];
					this.g = channels[1];
					this.b = channels[2];
					this.ok = true;
				}

			}

			// validate/cleanup values
			this.r = (this.r < 0 || isNaN(this.r)) ? 0 : ((this.r > 255) ? 255 : this.r);
			this.g = (this.g < 0 || isNaN(this.g)) ? 0 : ((this.g > 255) ? 255 : this.g);
			this.b = (this.b < 0 || isNaN(this.b)) ? 0 : ((this.b > 255) ? 255 : this.b);

			// some getters
			this.toRGB = function () {
				return 'rgb(' + this.r + ', ' + this.g + ', ' + this.b + ')';
			}
			this.toHex = function () {
				var r = this.r.toString(16);
				var g = this.g.toString(16);
				var b = this.b.toString(16);
				if (r.length == 1) r = '0' + r;
				if (g.length == 1) g = '0' + g;
				if (b.length == 1) b = '0' + b;
				return '#' + r + g + b;
			}

			// help
			this.getHelpXML = function () {

				var examples = new Array();
				// add regexps
				for (var i = 0; i < color_defs.length; i++) {
					var example = color_defs[i].example;
					for (var j = 0; j < example.length; j++) {
						examples[examples.length] = example[j];
					}
				}
				// add type-in colors
				for (var sc in simple_colors) {
					examples[examples.length] = sc;
				}

				var xml = document.createElement('ul');
				xml.setAttribute('id', 'rgbcolor-examples');
				for (var i = 0; i < examples.length; i++) {
					try {
						var list_item = document.createElement('li');
						var list_color = new RGBColor(examples[i]);
						var example_div = document.createElement('div');
						example_div.style.cssText =
							'margin: 3px; '
							+ 'border: 1px solid black; '
							+ 'background:' + list_color.toHex() + '; '
							+ 'color:' + list_color.toHex()
							;
						example_div.appendChild(document.createTextNode('test'));
						var list_item_value = document.createTextNode(
							' ' + examples[i] + ' -> ' + list_color.toRGB() + ' -> ' + list_color.toHex()
						);
						list_item.appendChild(example_div);
						list_item.appendChild(list_item_value);
						xml.appendChild(list_item);

					} catch (e) { }
				}
				return xml;

			}

		}

		//// export as AMD...
		//if (typeof define !== 'undefined' && define.amd) {
		//	define(function () { return RGBColor; });
		//} else 

		// ...or as browserify
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = RGBColor;
		}

		global.RGBColor = RGBColor;

	}(typeof window !== 'undefined' ? window : this));
	/*
	 * canvg.js - Javascript SVG parser and renderer on Canvas
	 * MIT Licensed
	 * Gabe Lerner (gabelerner@gmail.com)
	 * http://code.google.com/p/canvg/
	 *
	 * Requires: rgbcolor.js - http://www.phpied.com/rgb-color-parser-in-javascript/
	 */
	(function (global, factory) {

		'use strict';

		// export as AMD...
		//if (typeof define !== 'undefined' && define.amd) {
		//	define('canvgModule', ['rgbcolor', 'stackblur'], factory);
		//}

		//// ...or as browserify
		//else if (typeof module !== 'undefined' && module.exports) {
		//	module.exports = factory(require('rgbcolor'), require('stackblur'));
		//}

		global.canvg = factory(global.RGBColor, global.stackBlur);

	}(typeof window !== 'undefined' ? window : this, function (RGBColor, stackBlur) {

		if (typeof Element === 'undefined') {
			return undefined;
		}

		// canvg(target, s)
		// empty parameters: replace all 'svg' elements on page with 'canvas' elements
		// target: canvas element or the id of a canvas element
		// s: svg string, url to svg file, or xml document
		// opts: optional hash of options
		//		 ignoreMouse: true => ignore mouse events
		//		 ignoreAnimation: true => ignore animations
		//		 ignoreDimensions: true => does not try to resize canvas
		//		 ignoreClear: true => does not clear canvas
		//		 offsetX: int => draws at a x offset
		//		 offsetY: int => draws at a y offset
		//		 scaleWidth: int => scales horizontally to width
		//		 scaleHeight: int => scales vertically to height
		//		 renderCallback: function => will call the function after the first render is completed
		//		 forceRedraw: function => will call the function on every frame, if it returns true, will redraw
		var canvg = function (target, s, opts) {
			// no parameters
			if (target == null && s == null && opts == null) {
				var svgTags = document.querySelectorAll('svg');
				for (var i = 0; i < svgTags.length; i++) {
					var svgTag = svgTags[i];
					var c = document.createElement('canvas');
					c.width = svgTag.clientWidth;
					c.height = svgTag.clientHeight;
					svgTag.parentNode.insertBefore(c, svgTag);
					svgTag.parentNode.removeChild(svgTag);
					var div = document.createElement('div');
					div.appendChild(svgTag);
					canvg(c, div.innerHTML);
				}
				return;
			}

			if (typeof target == 'string') {
				target = document.getElementById(target);
			}

			// store class on canvas
			if (target.svg != null) target.svg.stop();
			var svg = build(opts || {});
			// on i.e. 8 for flash canvas, we can't assign the property so check for it
			if (!(target.childNodes.length == 1 && target.childNodes[0].nodeName == 'OBJECT')) target.svg = svg;

			var ctx = target.getContext('2d');
			if (typeof s.documentElement != 'undefined') {
				// load from xml doc
				svg.loadXmlDoc(ctx, s);
			}
			else if (s.substr(0, 1) == '<') {
				// load from xml string
				svg.loadXml(ctx, s);
			}
			else {
				// load from url
				svg.load(ctx, s);
			}
		}

		// see https://developer.mozilla.org/en-US/docs/Web/API/Element.matches
		var matchesSelector;
		if (typeof Element.prototype.matches != 'undefined') {
			matchesSelector = function (node, selector) {
				return node.matches(selector);
			};
		} else if (typeof Element.prototype.webkitMatchesSelector != 'undefined') {
			matchesSelector = function (node, selector) {
				return node.webkitMatchesSelector(selector);
			};
		} else if (typeof Element.prototype.mozMatchesSelector != 'undefined') {
			matchesSelector = function (node, selector) {
				return node.mozMatchesSelector(selector);
			};
		} else if (typeof Element.prototype.msMatchesSelector != 'undefined') {
			matchesSelector = function (node, selector) {
				return node.msMatchesSelector(selector);
			};
		} else if (typeof Element.prototype.oMatchesSelector != 'undefined') {
			matchesSelector = function (node, selector) {
				return node.oMatchesSelector(selector);
			};
		} else {
			// requires Sizzle: https://github.com/jquery/sizzle/wiki/Sizzle-Documentation
			// or jQuery: http://jquery.com/download/
			// or Zepto: http://zeptojs.com/#
			// without it, this is a ReferenceError

			if (typeof jQuery === 'function' || typeof Zepto === 'function') {
				matchesSelector = function (node, selector) {
					return $(node).is(selector);
				};
			}

			if (typeof matchesSelector === 'undefined') {
				matchesSelector = Sizzle.matchesSelector;
			}
		}

		// slightly modified version of https://github.com/keeganstreet/specificity/blob/master/specificity.js
		var attributeRegex = /(\[[^\]]+\])/g;
		var idRegex = /(#[^\s\+>~\.\[:]+)/g;
		var classRegex = /(\.[^\s\+>~\.\[:]+)/g;
		var pseudoElementRegex = /(::[^\s\+>~\.\[:]+|:first-line|:first-letter|:before|:after)/gi;
		var pseudoClassWithBracketsRegex = /(:[\w-]+\([^\)]*\))/gi;
		var pseudoClassRegex = /(:[^\s\+>~\.\[:]+)/g;
		var elementRegex = /([^\s\+>~\.\[:]+)/g;
		function getSelectorSpecificity(selector) {
			var typeCount = [0, 0, 0];
			var findMatch = function (regex, type) {
				var matches = selector.match(regex);
				if (matches == null) {
					return;
				}
				typeCount[type] += matches.length;
				selector = selector.replace(regex, ' ');
			};

			selector = selector.replace(/:not\(([^\)]*)\)/g, '     $1 ');
			selector = selector.replace(/{[\s\S]*/gm, ' ');
			findMatch(attributeRegex, 1);
			findMatch(idRegex, 0);
			findMatch(classRegex, 1);
			findMatch(pseudoElementRegex, 2);
			findMatch(pseudoClassWithBracketsRegex, 1);
			findMatch(pseudoClassRegex, 1);
			selector = selector.replace(/[\*\s\+>~]/g, ' ');
			selector = selector.replace(/[#\.]/g, ' ');
			findMatch(elementRegex, 2);
			return typeCount.join('');
		}

		function build(opts) {
			var svg = { opts: opts };

			svg.FRAMERATE = 30;
			svg.MAX_VIRTUAL_PIXELS = 30000;

			svg.log = function (msg) { };
			if (svg.opts['log'] == true && typeof console != 'undefined') {
				svg.log = function (msg) { console.log(msg); };
			};

			// globals
			svg.init = function (ctx) {
				var uniqueId = 0;
				svg.UniqueId = function () { uniqueId++; return 'canvg' + uniqueId; };
				svg.Definitions = {};
				svg.Styles = {};
				svg.StylesSpecificity = {};
				svg.Animations = [];
				svg.Images = [];
				svg.ctx = ctx;
				svg.ViewPort = new (function () {
					this.viewPorts = [];
					this.Clear = function () { this.viewPorts = []; }
					this.SetCurrent = function (width, height) { this.viewPorts.push({ width: width, height: height }); }
					this.RemoveCurrent = function () { this.viewPorts.pop(); }
					this.Current = function () { return this.viewPorts[this.viewPorts.length - 1]; }
					this.width = function () { return this.Current().width; }
					this.height = function () { return this.Current().height; }
					this.ComputeSize = function (d) {
						if (d != null && typeof d == 'number') return d;
						if (d == 'x') return this.width();
						if (d == 'y') return this.height();
						return Math.sqrt(Math.pow(this.width(), 2) + Math.pow(this.height(), 2)) / Math.sqrt(2);
					}
				});
			}
			svg.init();

			// images loaded
			svg.ImagesLoaded = function () {
				for (var i = 0; i < svg.Images.length; i++) {
					if (!svg.Images[i].loaded) return false;
				}
				return true;
			}

			// trim
			svg.trim = function (s) { return s.replace(/^\s+|\s+$/g, ''); }

			// compress spaces
			svg.compressSpaces = function (s) { return s.replace(/[\s\r\t\n]+/gm, ' '); }

			// ajax
			svg.ajax = function (url) {
				var AJAX;
				if (window.XMLHttpRequest) { AJAX = new XMLHttpRequest(); }
				else { AJAX = new ActiveXObject('Microsoft.XMLHTTP'); }
				if (AJAX) {
					AJAX.open('GET', url, false);
					AJAX.send(null);
					return AJAX.responseText;
				}
				return null;
			}

			// parse xml
			svg.parseXml = function (xml) {
				if (typeof Windows != 'undefined' && typeof Windows.Data != 'undefined' && typeof Windows.Data.Xml != 'undefined') {
					var xmlDoc = new Windows.Data.Xml.Dom.XmlDocument();
					var settings = new Windows.Data.Xml.Dom.XmlLoadSettings();
					settings.prohibitDtd = false;
					xmlDoc.loadXml(xml, settings);
					return xmlDoc;
				}
				else if (window.DOMParser) {
					try {
						var parser = new DOMParser();
						return parser.parseFromString(xml, 'image/svg+xml');
					}
					catch (e) {
						parser = new DOMParser();
						return parser.parseFromString(xml, 'text/xml');
					}
				}
				else {
					xml = xml.replace(/<!DOCTYPE svg[^>]*>/, '');
					var xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
					xmlDoc.async = 'false';
					xmlDoc.loadXML(xml);
					return xmlDoc;
				}
			}

			svg.Property = function (name, value) {
				this.name = name;
				this.value = value;
			}
			svg.Property.prototype.getValue = function () {
				return this.value;
			}

			svg.Property.prototype.hasValue = function () {
				return (this.value != null && this.value !== '');
			}

			// return the numerical value of the property
			svg.Property.prototype.numValue = function () {
				if (!this.hasValue()) return 0;

				var n = parseFloat(this.value);
				if ((this.value + '').match(/%$/)) {
					n = n / 100.0;
				}
				return n;
			}

			svg.Property.prototype.valueOrDefault = function (def) {
				if (this.hasValue()) return this.value;
				return def;
			}

			svg.Property.prototype.numValueOrDefault = function (def) {
				if (this.hasValue()) return this.numValue();
				return def;
			}

			// color extensions
			// augment the current color value with the opacity
			svg.Property.prototype.addOpacity = function (opacityProp) {
				var newValue = this.value;
				if (opacityProp.value != null && opacityProp.value != '' && typeof this.value == 'string') { // can only add opacity to colors, not patterns
					var color = new RGBColor(this.value);
					if (color.ok) {
						newValue = 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', ' + opacityProp.numValue() + ')';
					}
				}
				return new svg.Property(this.name, newValue);
			}

			// definition extensions
			// get the definition from the definitions table
			svg.Property.prototype.getDefinition = function () {
				var name = this.value.match(/#([^\)'"]+)/);
				if (name) { name = name[1]; }
				if (!name) { name = this.value; }
				return svg.Definitions[name];
			}

			svg.Property.prototype.isUrlDefinition = function () {
				return this.value.indexOf('url(') == 0
			}

			svg.Property.prototype.getFillStyleDefinition = function (e, opacityProp) {
				var def = this.getDefinition();

				// gradient
				if (def != null && def.createGradient) {
					return def.createGradient(svg.ctx, e, opacityProp);
				}

				// pattern
				if (def != null && def.createPattern) {
					if (def.getHrefAttribute().hasValue()) {
						var pt = def.attribute('patternTransform');
						def = def.getHrefAttribute().getDefinition();
						if (pt.hasValue()) { def.attribute('patternTransform', true).value = pt.value; }
					}
					return def.createPattern(svg.ctx, e);
				}

				return null;
			}

			// length extensions
			svg.Property.prototype.getDPI = function (viewPort) {
				return 96.0; // TODO: compute?
			}

			svg.Property.prototype.getEM = function (viewPort) {
				var em = 12;

				var fontSize = new svg.Property('fontSize', svg.Font.Parse(svg.ctx.font).fontSize);
				if (fontSize.hasValue()) em = fontSize.toPixels(viewPort);

				return em;
			}

			svg.Property.prototype.getUnits = function () {
				var s = this.value + '';
				return s.replace(/[0-9\.\-]/g, '');
			}

			// get the length as pixels
			svg.Property.prototype.toPixels = function (viewPort, processPercent) {
				if (!this.hasValue()) return 0;
				var s = this.value + '';
				if (s.match(/em$/)) return this.numValue() * this.getEM(viewPort);
				if (s.match(/ex$/)) return this.numValue() * this.getEM(viewPort) / 2.0;
				if (s.match(/px$/)) return this.numValue();
				if (s.match(/pt$/)) return this.numValue() * this.getDPI(viewPort) * (1.0 / 72.0);
				if (s.match(/pc$/)) return this.numValue() * 15;
				if (s.match(/cm$/)) return this.numValue() * this.getDPI(viewPort) / 2.54;
				if (s.match(/mm$/)) return this.numValue() * this.getDPI(viewPort) / 25.4;
				if (s.match(/in$/)) return this.numValue() * this.getDPI(viewPort);
				if (s.match(/%$/)) return this.numValue() * svg.ViewPort.ComputeSize(viewPort);
				var n = this.numValue();
				if (processPercent && n < 1.0) return n * svg.ViewPort.ComputeSize(viewPort);
				return n;
			}

			// time extensions
			// get the time as milliseconds
			svg.Property.prototype.toMilliseconds = function () {
				if (!this.hasValue()) return 0;
				var s = this.value + '';
				if (s.match(/s$/)) return this.numValue() * 1000;
				if (s.match(/ms$/)) return this.numValue();
				return this.numValue();
			}

			// angle extensions
			// get the angle as radians
			svg.Property.prototype.toRadians = function () {
				if (!this.hasValue()) return 0;
				var s = this.value + '';
				if (s.match(/deg$/)) return this.numValue() * (Math.PI / 180.0);
				if (s.match(/grad$/)) return this.numValue() * (Math.PI / 200.0);
				if (s.match(/rad$/)) return this.numValue();
				return this.numValue() * (Math.PI / 180.0);
			}

			// text extensions
			// get the text baseline
			var textBaselineMapping = {
				'baseline': 'alphabetic',
				'before-edge': 'top',
				'text-before-edge': 'top',
				'middle': 'middle',
				'central': 'middle',
				'after-edge': 'bottom',
				'text-after-edge': 'bottom',
				'ideographic': 'ideographic',
				'alphabetic': 'alphabetic',
				'hanging': 'hanging',
				'mathematical': 'alphabetic'
			};
			svg.Property.prototype.toTextBaseline = function () {
				if (!this.hasValue()) return null;
				return textBaselineMapping[this.value];
			}

			// fonts
			svg.Font = new (function () {
				this.Styles = 'normal|italic|oblique|inherit';
				this.Variants = 'normal|small-caps|inherit';
				this.Weights = 'normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit';

				this.CreateFont = function (fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit) {
					var f = inherit != null ? this.Parse(inherit) : this.CreateFont('', '', '', '', '', svg.ctx.font);
					return {
						fontFamily: fontFamily || f.fontFamily,
						fontSize: fontSize || f.fontSize,
						fontStyle: fontStyle || f.fontStyle,
						fontWeight: fontWeight || f.fontWeight,
						fontVariant: fontVariant || f.fontVariant,
						toString: function () { return [this.fontStyle, this.fontVariant, this.fontWeight, this.fontSize, this.fontFamily].join(' ') }
					}
				}

				var that = this;
				this.Parse = function (s) {
					var f = {};
					var d = svg.trim(svg.compressSpaces(s || '')).split(' ');
					var set = { fontSize: false, fontStyle: false, fontWeight: false, fontVariant: false }
					var ff = '';
					for (var i = 0; i < d.length; i++) {
						if (!set.fontStyle && that.Styles.indexOf(d[i]) != -1) { if (d[i] != 'inherit') f.fontStyle = d[i]; set.fontStyle = true; }
						else if (!set.fontVariant && that.Variants.indexOf(d[i]) != -1) { if (d[i] != 'inherit') f.fontVariant = d[i]; set.fontStyle = set.fontVariant = true; }
						else if (!set.fontWeight && that.Weights.indexOf(d[i]) != -1) { if (d[i] != 'inherit') f.fontWeight = d[i]; set.fontStyle = set.fontVariant = set.fontWeight = true; }
						else if (!set.fontSize) { if (d[i] != 'inherit') f.fontSize = d[i].split('/')[0]; set.fontStyle = set.fontVariant = set.fontWeight = set.fontSize = true; }
						else { if (d[i] != 'inherit') ff += d[i]; }
					} if (ff != '') f.fontFamily = ff;
					return f;
				}
			});

			// points and paths
			svg.ToNumberArray = function (s) {
				var a = svg.trim(svg.compressSpaces((s || '').replace(/,/g, ' '))).split(' ');
				for (var i = 0; i < a.length; i++) {
					a[i] = parseFloat(a[i]);
				}
				return a;
			}
			svg.Point = function (x, y) {
				this.x = x;
				this.y = y;
			}
			svg.Point.prototype.angleTo = function (p) {
				return Math.atan2(p.y - this.y, p.x - this.x);
			}

			svg.Point.prototype.applyTransform = function (v) {
				var xp = this.x * v[0] + this.y * v[2] + v[4];
				var yp = this.x * v[1] + this.y * v[3] + v[5];
				this.x = xp;
				this.y = yp;
			}

			svg.CreatePoint = function (s) {
				var a = svg.ToNumberArray(s);
				return new svg.Point(a[0], a[1]);
			}
			svg.CreatePath = function (s) {
				var a = svg.ToNumberArray(s);
				var path = [];
				for (var i = 0; i < a.length; i += 2) {
					path.push(new svg.Point(a[i], a[i + 1]));
				}
				return path;
			}

			// bounding box
			svg.BoundingBox = function (x1, y1, x2, y2) { // pass in initial points if you want
				this.x1 = Number.NaN;
				this.y1 = Number.NaN;
				this.x2 = Number.NaN;
				this.y2 = Number.NaN;

				this.x = function () { return this.x1; }
				this.y = function () { return this.y1; }
				this.width = function () { return this.x2 - this.x1; }
				this.height = function () { return this.y2 - this.y1; }

				this.addPoint = function (x, y) {
					if (x != null) {
						if (isNaN(this.x1) || isNaN(this.x2)) {
							this.x1 = x;
							this.x2 = x;
						}
						if (x < this.x1) this.x1 = x;
						if (x > this.x2) this.x2 = x;
					}

					if (y != null) {
						if (isNaN(this.y1) || isNaN(this.y2)) {
							this.y1 = y;
							this.y2 = y;
						}
						if (y < this.y1) this.y1 = y;
						if (y > this.y2) this.y2 = y;
					}
				}
				this.addX = function (x) { this.addPoint(x, null); }
				this.addY = function (y) { this.addPoint(null, y); }

				this.addBoundingBox = function (bb) {
					this.addPoint(bb.x1, bb.y1);
					this.addPoint(bb.x2, bb.y2);
				}

				this.addQuadraticCurve = function (p0x, p0y, p1x, p1y, p2x, p2y) {
					var cp1x = p0x + 2 / 3 * (p1x - p0x); // CP1 = QP0 + 2/3 *(QP1-QP0)
					var cp1y = p0y + 2 / 3 * (p1y - p0y); // CP1 = QP0 + 2/3 *(QP1-QP0)
					var cp2x = cp1x + 1 / 3 * (p2x - p0x); // CP2 = CP1 + 1/3 *(QP2-QP0)
					var cp2y = cp1y + 1 / 3 * (p2y - p0y); // CP2 = CP1 + 1/3 *(QP2-QP0)
					this.addBezierCurve(p0x, p0y, cp1x, cp2x, cp1y, cp2y, p2x, p2y);
				}

				this.addBezierCurve = function (p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
					// from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
					var p0 = [p0x, p0y], p1 = [p1x, p1y], p2 = [p2x, p2y], p3 = [p3x, p3y];
					this.addPoint(p0[0], p0[1]);
					this.addPoint(p3[0], p3[1]);

					for (i = 0; i <= 1; i++) {
						var f = function (t) {
							return Math.pow(1 - t, 3) * p0[i]
								+ 3 * Math.pow(1 - t, 2) * t * p1[i]
								+ 3 * (1 - t) * Math.pow(t, 2) * p2[i]
								+ Math.pow(t, 3) * p3[i];
						}

						var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
						var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
						var c = 3 * p1[i] - 3 * p0[i];

						if (a == 0) {
							if (b == 0) continue;
							var t = -c / b;
							if (0 < t && t < 1) {
								if (i == 0) this.addX(f(t));
								if (i == 1) this.addY(f(t));
							}
							continue;
						}

						var b2ac = Math.pow(b, 2) - 4 * c * a;
						if (b2ac < 0) continue;
						var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
						if (0 < t1 && t1 < 1) {
							if (i == 0) this.addX(f(t1));
							if (i == 1) this.addY(f(t1));
						}
						var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
						if (0 < t2 && t2 < 1) {
							if (i == 0) this.addX(f(t2));
							if (i == 1) this.addY(f(t2));
						}
					}
				}

				this.isPointInBox = function (x, y) {
					return (this.x1 <= x && x <= this.x2 && this.y1 <= y && y <= this.y2);
				}

				this.addPoint(x1, y1);
				this.addPoint(x2, y2);
			}

			// transforms
			svg.Transform = function (v) {
				var that = this;
				this.Type = {}

				// translate
				this.Type.translate = function (s) {
					this.p = svg.CreatePoint(s);
					this.apply = function (ctx) {
						ctx.translate(this.p.x || 0.0, this.p.y || 0.0);
					}
					this.unapply = function (ctx) {
						ctx.translate(-1.0 * this.p.x || 0.0, -1.0 * this.p.y || 0.0);
					}
					this.applyToPoint = function (p) {
						p.applyTransform([1, 0, 0, 1, this.p.x || 0.0, this.p.y || 0.0]);
					}
				}

				// rotate
				this.Type.rotate = function (s) {
					var a = svg.ToNumberArray(s);
					this.angle = new svg.Property('angle', a[0]);
					this.cx = a[1] || 0;
					this.cy = a[2] || 0;
					this.apply = function (ctx) {
						ctx.translate(this.cx, this.cy);
						ctx.rotate(this.angle.toRadians());
						ctx.translate(-this.cx, -this.cy);
					}
					this.unapply = function (ctx) {
						ctx.translate(this.cx, this.cy);
						ctx.rotate(-1.0 * this.angle.toRadians());
						ctx.translate(-this.cx, -this.cy);
					}
					this.applyToPoint = function (p) {
						var a = this.angle.toRadians();
						p.applyTransform([1, 0, 0, 1, this.p.x || 0.0, this.p.y || 0.0]);
						p.applyTransform([Math.cos(a), Math.sin(a), -Math.sin(a), Math.cos(a), 0, 0]);
						p.applyTransform([1, 0, 0, 1, -this.p.x || 0.0, -this.p.y || 0.0]);
					}
				}

				this.Type.scale = function (s) {
					this.p = svg.CreatePoint(s);
					this.apply = function (ctx) {
						ctx.scale(this.p.x || 1.0, this.p.y || this.p.x || 1.0);
					}
					this.unapply = function (ctx) {
						ctx.scale(1.0 / this.p.x || 1.0, 1.0 / this.p.y || this.p.x || 1.0);
					}
					this.applyToPoint = function (p) {
						p.applyTransform([this.p.x || 0.0, 0, 0, this.p.y || 0.0, 0, 0]);
					}
				}

				this.Type.matrix = function (s) {
					this.m = svg.ToNumberArray(s);
					this.apply = function (ctx) {
						ctx.transform(this.m[0], this.m[1], this.m[2], this.m[3], this.m[4], this.m[5]);
					}
					this.unapply = function (ctx) {
						var a = this.m[0];
						var b = this.m[2];
						var c = this.m[4];
						var d = this.m[1];
						var e = this.m[3];
						var f = this.m[5];
						var g = 0.0;
						var h = 0.0;
						var i = 1.0;
						var det = 1 / (a * (e * i - f * h) - b * (d * i - f * g) + c * (d * h - e * g));
						ctx.transform(
							det * (e * i - f * h),
							det * (f * g - d * i),
							det * (c * h - b * i),
							det * (a * i - c * g),
							det * (b * f - c * e),
							det * (c * d - a * f)
						);
					}
					this.applyToPoint = function (p) {
						p.applyTransform(this.m);
					}
				}

				this.Type.SkewBase = function (s) {
					this.base = that.Type.matrix;
					this.base(s);
					this.angle = new svg.Property('angle', s);
				}
				this.Type.SkewBase.prototype = new this.Type.matrix;

				this.Type.skewX = function (s) {
					this.base = that.Type.SkewBase;
					this.base(s);
					this.m = [1, 0, Math.tan(this.angle.toRadians()), 1, 0, 0];
				}
				this.Type.skewX.prototype = new this.Type.SkewBase;

				this.Type.skewY = function (s) {
					this.base = that.Type.SkewBase;
					this.base(s);
					this.m = [1, Math.tan(this.angle.toRadians()), 0, 1, 0, 0];
				}
				this.Type.skewY.prototype = new this.Type.SkewBase;

				this.transforms = [];

				this.apply = function (ctx) {
					for (var i = 0; i < this.transforms.length; i++) {
						this.transforms[i].apply(ctx);
					}
				}

				this.unapply = function (ctx) {
					for (var i = this.transforms.length - 1; i >= 0; i--) {
						this.transforms[i].unapply(ctx);
					}
				}

				this.applyToPoint = function (p) {
					for (var i = 0; i < this.transforms.length; i++) {
						this.transforms[i].applyToPoint(p);
					}
				}

				var data = svg.trim(svg.compressSpaces(v)).replace(/\)([a-zA-Z])/g, ') $1').replace(/\)(\s?,\s?)/g, ') ').split(/\s(?=[a-z])/);
				for (var i = 0; i < data.length; i++) {
					var type = svg.trim(data[i].split('(')[0]);
					var s = data[i].split('(')[1].replace(')', '');
					var transformType = this.Type[type];
					if (typeof transformType != 'undefined') {
						var transform = new transformType(s);
						transform.type = type;
						this.transforms.push(transform);
					}
				}
			}

			// aspect ratio
			svg.AspectRatio = function (ctx, aspectRatio, width, desiredWidth, height, desiredHeight, minX, minY, refX, refY) {
				// aspect ratio - http://www.w3.org/TR/SVG/coords.html#PreserveAspectRatioAttribute
				aspectRatio = svg.compressSpaces(aspectRatio);
				aspectRatio = aspectRatio.replace(/^defer\s/, ''); // ignore defer
				var align = aspectRatio.split(' ')[0] || 'xMidYMid';
				var meetOrSlice = aspectRatio.split(' ')[1] || 'meet';

				// calculate scale
				var scaleX = width / desiredWidth;
				var scaleY = height / desiredHeight;
				var scaleMin = Math.min(scaleX, scaleY);
				var scaleMax = Math.max(scaleX, scaleY);
				if (meetOrSlice == 'meet') { desiredWidth *= scaleMin; desiredHeight *= scaleMin; }
				if (meetOrSlice == 'slice') { desiredWidth *= scaleMax; desiredHeight *= scaleMax; }

				refX = new svg.Property('refX', refX);
				refY = new svg.Property('refY', refY);
				if (refX.hasValue() && refY.hasValue()) {
					ctx.translate(-scaleMin * refX.toPixels('x'), -scaleMin * refY.toPixels('y'));
				}
				else {
					// align
					if (align.match(/^xMid/) && ((meetOrSlice == 'meet' && scaleMin == scaleY) || (meetOrSlice == 'slice' && scaleMax == scaleY))) ctx.translate(width / 2.0 - desiredWidth / 2.0, 0);
					if (align.match(/YMid$/) && ((meetOrSlice == 'meet' && scaleMin == scaleX) || (meetOrSlice == 'slice' && scaleMax == scaleX))) ctx.translate(0, height / 2.0 - desiredHeight / 2.0);
					if (align.match(/^xMax/) && ((meetOrSlice == 'meet' && scaleMin == scaleY) || (meetOrSlice == 'slice' && scaleMax == scaleY))) ctx.translate(width - desiredWidth, 0);
					if (align.match(/YMax$/) && ((meetOrSlice == 'meet' && scaleMin == scaleX) || (meetOrSlice == 'slice' && scaleMax == scaleX))) ctx.translate(0, height - desiredHeight);
				}

				// scale
				if (align == 'none') ctx.scale(scaleX, scaleY);
				else if (meetOrSlice == 'meet') ctx.scale(scaleMin, scaleMin);
				else if (meetOrSlice == 'slice') ctx.scale(scaleMax, scaleMax);

				// translate
				ctx.translate(minX == null ? 0 : -minX, minY == null ? 0 : -minY);
			}

			// elements
			svg.Element = {}

			svg.EmptyProperty = new svg.Property('EMPTY', '');

			svg.Element.ElementBase = function (node) {
				this.attributes = {};
				this.styles = {};
				this.stylesSpecificity = {};
				this.children = [];

				// get or create attribute
				this.attribute = function (name, createIfNotExists) {
					var a = this.attributes[name];
					if (a != null) return a;

					if (createIfNotExists == true) { a = new svg.Property(name, ''); this.attributes[name] = a; }
					return a || svg.EmptyProperty;
				}

				this.getHrefAttribute = function () {
					for (var a in this.attributes) {
						if (a == 'href' || a.match(/:href$/)) {
							return this.attributes[a];
						}
					}
					return svg.EmptyProperty;
				}

				// get or create style, crawls up node tree
				this.style = function (name, createIfNotExists, skipAncestors) {
					var s = this.styles[name];
					if (s != null) return s;

					var a = this.attribute(name);
					if (a != null && a.hasValue()) {
						this.styles[name] = a; // move up to me to cache
						return a;
					}

					if (skipAncestors != true) {
						var p = this.parent;
						if (p != null) {
							var ps = p.style(name);
							if (ps != null && ps.hasValue()) {
								return ps;
							}
						}
					}

					if (createIfNotExists == true) { s = new svg.Property(name, ''); this.styles[name] = s; }
					return s || svg.EmptyProperty;
				}

				// base render
				this.render = function (ctx) {
					// don't render display=none
					if (this.style('display').value == 'none') return;

					// don't render visibility=hidden
					if (this.style('visibility').value == 'hidden') return;

					ctx.save();
					if (this.style('mask').hasValue()) { // mask
						var mask = this.style('mask').getDefinition();
						if (mask != null) mask.apply(ctx, this);
					}
					else if (this.style('filter').hasValue()) { // filter
						var filter = this.style('filter').getDefinition();
						if (filter != null) filter.apply(ctx, this);
					}
					else {
						this.setContext(ctx);
						this.renderChildren(ctx);
						this.clearContext(ctx);
					}
					ctx.restore();
				}

				// base set context
				this.setContext = function (ctx) {
					// OVERRIDE ME!
				}

				// base clear context
				this.clearContext = function (ctx) {
					// OVERRIDE ME!
				}

				// base render children
				this.renderChildren = function (ctx) {
					for (var i = 0; i < this.children.length; i++) {
						this.children[i].render(ctx);
					}
				}

				this.addChild = function (childNode, create) {
					var child = childNode;
					if (create) child = svg.CreateElement(childNode);
					child.parent = this;
					if (child.type != 'title') { this.children.push(child); }
				}

				this.addStylesFromStyleDefinition = function () {
					// add styles
					for (var selector in svg.Styles) {
						if (selector[0] != '@' && matchesSelector(node, selector)) {
							var styles = svg.Styles[selector];
							var specificity = svg.StylesSpecificity[selector];
							if (styles != null) {
								for (var name in styles) {
									var existingSpecificity = this.stylesSpecificity[name];
									if (typeof existingSpecificity == 'undefined') {
										existingSpecificity = '000';
									}
									if (specificity > existingSpecificity) {
										this.styles[name] = styles[name];
										this.stylesSpecificity[name] = specificity;
									}
								}
							}
						}
					}
				};

				// Microsoft Edge fix
				var allUppercase = new RegExp("^[A-Z\-]+$");
				var normalizeAttributeName = function (name) {
					if (allUppercase.test(name)) {
						return name.toLowerCase();
					}
					return name;
				};

				if (node != null && node.nodeType == 1) { //ELEMENT_NODE
					// add attributes
					for (var i = 0; i < node.attributes.length; i++) {
						var attribute = node.attributes[i];
						var nodeName = normalizeAttributeName(attribute.nodeName);
						this.attributes[nodeName] = new svg.Property(nodeName, attribute.value);
					}

					this.addStylesFromStyleDefinition();

					// add inline styles
					if (this.attribute('style').hasValue()) {
						var styles = this.attribute('style').value.split(';');
						for (var i = 0; i < styles.length; i++) {
							if (svg.trim(styles[i]) != '') {
								var style = styles[i].split(':');
								var name = svg.trim(style[0]);
								var value = svg.trim(style[1]);
								this.styles[name] = new svg.Property(name, value);
							}
						}
					}

					// add id
					if (this.attribute('id').hasValue()) {
						if (svg.Definitions[this.attribute('id').value] == null) {
							svg.Definitions[this.attribute('id').value] = this;
						}
					}

					// add children
					for (var i = 0; i < node.childNodes.length; i++) {
						var childNode = node.childNodes[i];
						if (childNode.nodeType == 1) this.addChild(childNode, true); //ELEMENT_NODE
						if (this.captureTextNodes && (childNode.nodeType == 3 || childNode.nodeType == 4)) {
							var text = childNode.value || childNode.text || childNode.textContent || '';
							if (svg.compressSpaces(text) != '') {
								this.addChild(new svg.Element.tspan(childNode), false); // TEXT_NODE
							}
						}
					}
				}
			}

			svg.Element.RenderedElementBase = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.setContext = function (ctx) {
					// fill
					if (this.style('fill').isUrlDefinition()) {
						var fs = this.style('fill').getFillStyleDefinition(this, this.style('fill-opacity'));
						if (fs != null) ctx.fillStyle = fs;
					}
					else if (this.style('fill').hasValue()) {
						var fillStyle = this.style('fill');
						if (fillStyle.value == 'currentColor') fillStyle.value = this.style('color').value;
						if (fillStyle.value != 'inherit') ctx.fillStyle = (fillStyle.value == 'none' ? 'rgba(0,0,0,0)' : fillStyle.value);
					}
					if (this.style('fill-opacity').hasValue()) {
						var fillStyle = new svg.Property('fill', ctx.fillStyle);
						fillStyle = fillStyle.addOpacity(this.style('fill-opacity'));
						ctx.fillStyle = fillStyle.value;
					}

					// stroke
					if (this.style('stroke').isUrlDefinition()) {
						var fs = this.style('stroke').getFillStyleDefinition(this, this.style('stroke-opacity'));
						if (fs != null) ctx.strokeStyle = fs;
					}
					else if (this.style('stroke').hasValue()) {
						var strokeStyle = this.style('stroke');
						if (strokeStyle.value == 'currentColor') strokeStyle.value = this.style('color').value;
						if (strokeStyle.value != 'inherit') ctx.strokeStyle = (strokeStyle.value == 'none' ? 'rgba(0,0,0,0)' : strokeStyle.value);
					}
					if (this.style('stroke-opacity').hasValue()) {
						var strokeStyle = new svg.Property('stroke', ctx.strokeStyle);
						strokeStyle = strokeStyle.addOpacity(this.style('stroke-opacity'));
						ctx.strokeStyle = strokeStyle.value;
					}
					if (this.style('stroke-width').hasValue()) {
						var newLineWidth = this.style('stroke-width').toPixels();
						ctx.lineWidth = newLineWidth == 0 ? 0.001 : newLineWidth; // browsers don't respect 0
					}
					if (this.style('stroke-linecap').hasValue()) ctx.lineCap = this.style('stroke-linecap').value;
					if (this.style('stroke-linejoin').hasValue()) ctx.lineJoin = this.style('stroke-linejoin').value;
					if (this.style('stroke-miterlimit').hasValue()) ctx.miterLimit = this.style('stroke-miterlimit').value;
					if (this.style('stroke-dasharray').hasValue() && this.style('stroke-dasharray').value != 'none') {
						var gaps = svg.ToNumberArray(this.style('stroke-dasharray').value);
						if (typeof ctx.setLineDash != 'undefined') { ctx.setLineDash(gaps); }
						else if (typeof ctx.webkitLineDash != 'undefined') { ctx.webkitLineDash = gaps; }
						else if (typeof ctx.mozDash != 'undefined' && !(gaps.length == 1 && gaps[0] == 0)) { ctx.mozDash = gaps; }

						var offset = this.style('stroke-dashoffset').numValueOrDefault(1);
						if (typeof ctx.lineDashOffset != 'undefined') { ctx.lineDashOffset = offset; }
						else if (typeof ctx.webkitLineDashOffset != 'undefined') { ctx.webkitLineDashOffset = offset; }
						else if (typeof ctx.mozDashOffset != 'undefined') { ctx.mozDashOffset = offset; }
					}

					// font
					if (typeof ctx.font != 'undefined') {
						ctx.font = svg.Font.CreateFont(
							this.style('font-style').value,
							this.style('font-variant').value,
							this.style('font-weight').value,
							this.style('font-size').hasValue() ? this.style('font-size').toPixels() + 'px' : '',
							this.style('font-family').value).toString();
					}

					// transform
					if (this.style('transform', false, true).hasValue()) {
						var transform = new svg.Transform(this.style('transform', false, true).value);
						transform.apply(ctx);
					}

					// clip
					if (this.style('clip-path', false, true).hasValue()) {
						var clip = this.style('clip-path', false, true).getDefinition();
						if (clip != null) clip.apply(ctx);
					}

					// opacity
					if (this.style('opacity').hasValue()) {
						ctx.globalAlpha = this.style('opacity').numValue();
					}
				}
			}
			svg.Element.RenderedElementBase.prototype = new svg.Element.ElementBase;

			svg.Element.PathElementBase = function (node) {
				this.base = svg.Element.RenderedElementBase;
				this.base(node);

				this.path = function (ctx) {
					if (ctx != null) ctx.beginPath();
					return new svg.BoundingBox();
				}

				this.renderChildren = function (ctx) {
					this.path(ctx);
					svg.Mouse.checkPath(this, ctx);
					if (ctx.fillStyle != '') {
						if (this.style('fill-rule').valueOrDefault('inherit') != 'inherit') { ctx.fill(this.style('fill-rule').value); }
						else { ctx.fill(); }
					}
					if (ctx.strokeStyle != '') ctx.stroke();

					var markers = this.getMarkers();
					if (markers != null) {
						if (this.style('marker-start').isUrlDefinition()) {
							var marker = this.style('marker-start').getDefinition();
							marker.render(ctx, markers[0][0], markers[0][1]);
						}
						if (this.style('marker-mid').isUrlDefinition()) {
							var marker = this.style('marker-mid').getDefinition();
							for (var i = 1; i < markers.length - 1; i++) {
								marker.render(ctx, markers[i][0], markers[i][1]);
							}
						}
						if (this.style('marker-end').isUrlDefinition()) {
							var marker = this.style('marker-end').getDefinition();
							marker.render(ctx, markers[markers.length - 1][0], markers[markers.length - 1][1]);
						}
					}
				}

				this.getBoundingBox = function () {
					return this.path();
				}

				this.getMarkers = function () {
					return null;
				}
			}
			svg.Element.PathElementBase.prototype = new svg.Element.RenderedElementBase;

			// svg element
			svg.Element.svg = function (node) {
				this.base = svg.Element.RenderedElementBase;
				this.base(node);

				this.baseClearContext = this.clearContext;
				this.clearContext = function (ctx) {
					this.baseClearContext(ctx);
					svg.ViewPort.RemoveCurrent();
				}

				this.baseSetContext = this.setContext;
				this.setContext = function (ctx) {
					// initial values and defaults
					ctx.strokeStyle = 'rgba(0,0,0,0)';
					ctx.lineCap = 'butt';
					ctx.lineJoin = 'miter';
					ctx.miterLimit = 4;
					if (typeof ctx.font != 'undefined' && typeof window.getComputedStyle != 'undefined') {
						ctx.font = window.getComputedStyle(ctx.canvas).getPropertyValue('font');
					}

					this.baseSetContext(ctx);

					// create new view port
					if (!this.attribute('x').hasValue()) this.attribute('x', true).value = 0;
					if (!this.attribute('y').hasValue()) this.attribute('y', true).value = 0;
					ctx.translate(this.attribute('x').toPixels('x'), this.attribute('y').toPixels('y'));

					var width = svg.ViewPort.width();
					var height = svg.ViewPort.height();

					if (!this.attribute('width').hasValue()) this.attribute('width', true).value = '100%';
					if (!this.attribute('height').hasValue()) this.attribute('height', true).value = '100%';
					if (typeof this.root == 'undefined') {
						width = this.attribute('width').toPixels('x');
						height = this.attribute('height').toPixels('y');

						var x = 0;
						var y = 0;
						if (this.attribute('refX').hasValue() && this.attribute('refY').hasValue()) {
							x = -this.attribute('refX').toPixels('x');
							y = -this.attribute('refY').toPixels('y');
						}

						if (this.attribute('overflow').valueOrDefault('hidden') != 'visible') {
							ctx.beginPath();
							ctx.moveTo(x, y);
							ctx.lineTo(width, y);
							ctx.lineTo(width, height);
							ctx.lineTo(x, height);
							ctx.closePath();
							ctx.clip();
						}
					}
					svg.ViewPort.SetCurrent(width, height);

					// viewbox
					if (this.attribute('viewBox').hasValue()) {
						var viewBox = svg.ToNumberArray(this.attribute('viewBox').value);
						var minX = viewBox[0];
						var minY = viewBox[1];
						width = viewBox[2];
						height = viewBox[3];

						svg.AspectRatio(ctx,
							this.attribute('preserveAspectRatio').value,
							svg.ViewPort.width(),
							width,
							svg.ViewPort.height(),
							height,
							minX,
							minY,
							this.attribute('refX').value,
							this.attribute('refY').value);

						svg.ViewPort.RemoveCurrent();
						svg.ViewPort.SetCurrent(viewBox[2], viewBox[3]);
					}
				}
			}
			svg.Element.svg.prototype = new svg.Element.RenderedElementBase;

			// rect element
			svg.Element.rect = function (node) {
				this.base = svg.Element.PathElementBase;
				this.base(node);

				this.path = function (ctx) {
					var x = this.attribute('x').toPixels('x');
					var y = this.attribute('y').toPixels('y');
					var width = this.attribute('width').toPixels('x');
					var height = this.attribute('height').toPixels('y');
					var rx = this.attribute('rx').toPixels('x');
					var ry = this.attribute('ry').toPixels('y');
					if (this.attribute('rx').hasValue() && !this.attribute('ry').hasValue()) ry = rx;
					if (this.attribute('ry').hasValue() && !this.attribute('rx').hasValue()) rx = ry;
					rx = Math.min(rx, width / 2.0);
					ry = Math.min(ry, height / 2.0);
					if (ctx != null) {
						ctx.beginPath();
						ctx.moveTo(x + rx, y);
						ctx.lineTo(x + width - rx, y);
						ctx.quadraticCurveTo(x + width, y, x + width, y + ry)
						ctx.lineTo(x + width, y + height - ry);
						ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height)
						ctx.lineTo(x + rx, y + height);
						ctx.quadraticCurveTo(x, y + height, x, y + height - ry)
						ctx.lineTo(x, y + ry);
						ctx.quadraticCurveTo(x, y, x + rx, y)
						ctx.closePath();
					}

					return new svg.BoundingBox(x, y, x + width, y + height);
				}
			}
			svg.Element.rect.prototype = new svg.Element.PathElementBase;

			// circle element
			svg.Element.circle = function (node) {
				this.base = svg.Element.PathElementBase;
				this.base(node);

				this.path = function (ctx) {
					var cx = this.attribute('cx').toPixels('x');
					var cy = this.attribute('cy').toPixels('y');
					var r = this.attribute('r').toPixels();

					if (ctx != null) {
						ctx.beginPath();
						ctx.arc(cx, cy, r, 0, Math.PI * 2, true);
						ctx.closePath();
					}

					return new svg.BoundingBox(cx - r, cy - r, cx + r, cy + r);
				}
			}
			svg.Element.circle.prototype = new svg.Element.PathElementBase;

			// ellipse element
			svg.Element.ellipse = function (node) {
				this.base = svg.Element.PathElementBase;
				this.base(node);

				this.path = function (ctx) {
					var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
					var rx = this.attribute('rx').toPixels('x');
					var ry = this.attribute('ry').toPixels('y');
					var cx = this.attribute('cx').toPixels('x');
					var cy = this.attribute('cy').toPixels('y');

					if (ctx != null) {
						ctx.beginPath();
						ctx.moveTo(cx, cy - ry);
						ctx.bezierCurveTo(cx + (KAPPA * rx), cy - ry, cx + rx, cy - (KAPPA * ry), cx + rx, cy);
						ctx.bezierCurveTo(cx + rx, cy + (KAPPA * ry), cx + (KAPPA * rx), cy + ry, cx, cy + ry);
						ctx.bezierCurveTo(cx - (KAPPA * rx), cy + ry, cx - rx, cy + (KAPPA * ry), cx - rx, cy);
						ctx.bezierCurveTo(cx - rx, cy - (KAPPA * ry), cx - (KAPPA * rx), cy - ry, cx, cy - ry);
						ctx.closePath();
					}

					return new svg.BoundingBox(cx - rx, cy - ry, cx + rx, cy + ry);
				}
			}
			svg.Element.ellipse.prototype = new svg.Element.PathElementBase;

			// line element
			svg.Element.line = function (node) {
				this.base = svg.Element.PathElementBase;
				this.base(node);

				this.getPoints = function () {
					return [
						new svg.Point(this.attribute('x1').toPixels('x'), this.attribute('y1').toPixels('y')),
						new svg.Point(this.attribute('x2').toPixels('x'), this.attribute('y2').toPixels('y'))];
				}

				this.path = function (ctx) {
					var points = this.getPoints();

					if (ctx != null) {
						ctx.beginPath();
						ctx.moveTo(points[0].x, points[0].y);
						ctx.lineTo(points[1].x, points[1].y);
					}

					return new svg.BoundingBox(points[0].x, points[0].y, points[1].x, points[1].y);
				}

				this.getMarkers = function () {
					var points = this.getPoints();
					var a = points[0].angleTo(points[1]);
					return [[points[0], a], [points[1], a]];
				}
			}
			svg.Element.line.prototype = new svg.Element.PathElementBase;

			// polyline element
			svg.Element.polyline = function (node) {
				this.base = svg.Element.PathElementBase;
				this.base(node);

				this.points = svg.CreatePath(this.attribute('points').value);
				this.path = function (ctx) {
					var bb = new svg.BoundingBox(this.points[0].x, this.points[0].y);
					if (ctx != null) {
						ctx.beginPath();
						ctx.moveTo(this.points[0].x, this.points[0].y);
					}
					for (var i = 1; i < this.points.length; i++) {
						bb.addPoint(this.points[i].x, this.points[i].y);
						if (ctx != null) ctx.lineTo(this.points[i].x, this.points[i].y);
					}
					return bb;
				}

				this.getMarkers = function () {
					var markers = [];
					for (var i = 0; i < this.points.length - 1; i++) {
						markers.push([this.points[i], this.points[i].angleTo(this.points[i + 1])]);
					}
					if (markers.length > 0) {
						markers.push([this.points[this.points.length - 1], markers[markers.length - 1][1]]);
					}
					return markers;
				}
			}
			svg.Element.polyline.prototype = new svg.Element.PathElementBase;

			// polygon element
			svg.Element.polygon = function (node) {
				this.base = svg.Element.polyline;
				this.base(node);

				this.basePath = this.path;
				this.path = function (ctx) {
					var bb = this.basePath(ctx);
					if (ctx != null) {
						ctx.lineTo(this.points[0].x, this.points[0].y);
						ctx.closePath();
					}
					return bb;
				}
			}
			svg.Element.polygon.prototype = new svg.Element.polyline;

			// path element
			svg.Element.path = function (node) {
				this.base = svg.Element.PathElementBase;
				this.base(node);

				var d = this.attribute('d').value;
				// TODO: convert to real lexer based on http://www.w3.org/TR/SVG11/paths.html#PathDataBNF
				d = d.replace(/,/gm, ' '); // get rid of all commas
				// As the end of a match can also be the start of the next match, we need to run this replace twice.
				for (var i = 0; i < 2; i++)
					d = d.replace(/([MmZzLlHhVvCcSsQqTtAa])([^\s])/gm, '$1 $2'); // suffix commands with spaces
				d = d.replace(/([^\s])([MmZzLlHhVvCcSsQqTtAa])/gm, '$1 $2'); // prefix commands with spaces
				d = d.replace(/([0-9])([+\-])/gm, '$1 $2'); // separate digits on +- signs
				// Again, we need to run this twice to find all occurances
				for (var i = 0; i < 2; i++)
					d = d.replace(/(\.[0-9]*)(\.)/gm, '$1 $2'); // separate digits when they start with a comma
				d = d.replace(/([Aa](\s+[0-9]+){3})\s+([01])\s*([01])/gm, '$1 $3 $4 '); // shorthand elliptical arc path syntax
				d = svg.compressSpaces(d); // compress multiple spaces
				d = svg.trim(d);
				this.PathParser = new (function (d) {
					this.tokens = d.split(' ');

					this.reset = function () {
						this.i = -1;
						this.command = '';
						this.previousCommand = '';
						this.start = new svg.Point(0, 0);
						this.control = new svg.Point(0, 0);
						this.current = new svg.Point(0, 0);
						this.points = [];
						this.angles = [];
					}

					this.isEnd = function () {
						return this.i >= this.tokens.length - 1;
					}

					this.isCommandOrEnd = function () {
						if (this.isEnd()) return true;
						return this.tokens[this.i + 1].match(/^[A-Za-z]$/) != null;
					}

					this.isRelativeCommand = function () {
						switch (this.command) {
							case 'm':
							case 'l':
							case 'h':
							case 'v':
							case 'c':
							case 's':
							case 'q':
							case 't':
							case 'a':
							case 'z':
								return true;
								break;
						}
						return false;
					}

					this.getToken = function () {
						this.i++;
						return this.tokens[this.i];
					}

					this.getScalar = function () {
						return parseFloat(this.getToken());
					}

					this.nextCommand = function () {
						this.previousCommand = this.command;
						this.command = this.getToken();
					}

					this.getPoint = function () {
						var p = new svg.Point(this.getScalar(), this.getScalar());
						return this.makeAbsolute(p);
					}

					this.getAsControlPoint = function () {
						var p = this.getPoint();
						this.control = p;
						return p;
					}

					this.getAsCurrentPoint = function () {
						var p = this.getPoint();
						this.current = p;
						return p;
					}

					this.getReflectedControlPoint = function () {
						if (this.previousCommand.toLowerCase() != 'c' &&
							this.previousCommand.toLowerCase() != 's' &&
							this.previousCommand.toLowerCase() != 'q' &&
							this.previousCommand.toLowerCase() != 't') {
							return this.current;
						}

						// reflect point
						var p = new svg.Point(2 * this.current.x - this.control.x, 2 * this.current.y - this.control.y);
						return p;
					}

					this.makeAbsolute = function (p) {
						if (this.isRelativeCommand()) {
							p.x += this.current.x;
							p.y += this.current.y;
						}
						return p;
					}

					this.addMarker = function (p, from, priorTo) {
						// if the last angle isn't filled in because we didn't have this point yet ...
						if (priorTo != null && this.angles.length > 0 && this.angles[this.angles.length - 1] == null) {
							this.angles[this.angles.length - 1] = this.points[this.points.length - 1].angleTo(priorTo);
						}
						this.addMarkerAngle(p, from == null ? null : from.angleTo(p));
					}

					this.addMarkerAngle = function (p, a) {
						this.points.push(p);
						this.angles.push(a);
					}

					this.getMarkerPoints = function () { return this.points; }
					this.getMarkerAngles = function () {
						for (var i = 0; i < this.angles.length; i++) {
							if (this.angles[i] == null) {
								for (var j = i + 1; j < this.angles.length; j++) {
									if (this.angles[j] != null) {
										this.angles[i] = this.angles[j];
										break;
									}
								}
							}
						}
						return this.angles;
					}
				})(d);

				this.path = function (ctx) {
					var pp = this.PathParser;
					pp.reset();

					var bb = new svg.BoundingBox();
					if (ctx != null) ctx.beginPath();
					while (!pp.isEnd()) {
						pp.nextCommand();
						switch (pp.command) {
							case 'M':
							case 'm':
								var p = pp.getAsCurrentPoint();
								pp.addMarker(p);
								bb.addPoint(p.x, p.y);
								if (ctx != null) ctx.moveTo(p.x, p.y);
								pp.start = pp.current;
								while (!pp.isCommandOrEnd()) {
									var p = pp.getAsCurrentPoint();
									pp.addMarker(p, pp.start);
									bb.addPoint(p.x, p.y);
									if (ctx != null) ctx.lineTo(p.x, p.y);
								}
								break;
							case 'L':
							case 'l':
								while (!pp.isCommandOrEnd()) {
									var c = pp.current;
									var p = pp.getAsCurrentPoint();
									pp.addMarker(p, c);
									bb.addPoint(p.x, p.y);
									if (ctx != null) ctx.lineTo(p.x, p.y);
								}
								break;
							case 'H':
							case 'h':
								while (!pp.isCommandOrEnd()) {
									var newP = new svg.Point((pp.isRelativeCommand() ? pp.current.x : 0) + pp.getScalar(), pp.current.y);
									pp.addMarker(newP, pp.current);
									pp.current = newP;
									bb.addPoint(pp.current.x, pp.current.y);
									if (ctx != null) ctx.lineTo(pp.current.x, pp.current.y);
								}
								break;
							case 'V':
							case 'v':
								while (!pp.isCommandOrEnd()) {
									var newP = new svg.Point(pp.current.x, (pp.isRelativeCommand() ? pp.current.y : 0) + pp.getScalar());
									pp.addMarker(newP, pp.current);
									pp.current = newP;
									bb.addPoint(pp.current.x, pp.current.y);
									if (ctx != null) ctx.lineTo(pp.current.x, pp.current.y);
								}
								break;
							case 'C':
							case 'c':
								while (!pp.isCommandOrEnd()) {
									var curr = pp.current;
									var p1 = pp.getPoint();
									var cntrl = pp.getAsControlPoint();
									var cp = pp.getAsCurrentPoint();
									pp.addMarker(cp, cntrl, p1);
									bb.addBezierCurve(curr.x, curr.y, p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
									if (ctx != null) ctx.bezierCurveTo(p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
								}
								break;
							case 'S':
							case 's':
								while (!pp.isCommandOrEnd()) {
									var curr = pp.current;
									var p1 = pp.getReflectedControlPoint();
									var cntrl = pp.getAsControlPoint();
									var cp = pp.getAsCurrentPoint();
									pp.addMarker(cp, cntrl, p1);
									bb.addBezierCurve(curr.x, curr.y, p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
									if (ctx != null) ctx.bezierCurveTo(p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
								}
								break;
							case 'Q':
							case 'q':
								while (!pp.isCommandOrEnd()) {
									var curr = pp.current;
									var cntrl = pp.getAsControlPoint();
									var cp = pp.getAsCurrentPoint();
									pp.addMarker(cp, cntrl, cntrl);
									bb.addQuadraticCurve(curr.x, curr.y, cntrl.x, cntrl.y, cp.x, cp.y);
									if (ctx != null) ctx.quadraticCurveTo(cntrl.x, cntrl.y, cp.x, cp.y);
								}
								break;
							case 'T':
							case 't':
								while (!pp.isCommandOrEnd()) {
									var curr = pp.current;
									var cntrl = pp.getReflectedControlPoint();
									pp.control = cntrl;
									var cp = pp.getAsCurrentPoint();
									pp.addMarker(cp, cntrl, cntrl);
									bb.addQuadraticCurve(curr.x, curr.y, cntrl.x, cntrl.y, cp.x, cp.y);
									if (ctx != null) ctx.quadraticCurveTo(cntrl.x, cntrl.y, cp.x, cp.y);
								}
								break;
							case 'A':
							case 'a':
								while (!pp.isCommandOrEnd()) {
									var curr = pp.current;
									var rx = pp.getScalar();
									var ry = pp.getScalar();
									var xAxisRotation = pp.getScalar() * (Math.PI / 180.0);
									var largeArcFlag = pp.getScalar();
									var sweepFlag = pp.getScalar();
									var cp = pp.getAsCurrentPoint();

									// Conversion from endpoint to center parameterization
									// http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
									// x1', y1'
									var currp = new svg.Point(
										Math.cos(xAxisRotation) * (curr.x - cp.x) / 2.0 + Math.sin(xAxisRotation) * (curr.y - cp.y) / 2.0,
										-Math.sin(xAxisRotation) * (curr.x - cp.x) / 2.0 + Math.cos(xAxisRotation) * (curr.y - cp.y) / 2.0
									);
									// adjust radii
									var l = Math.pow(currp.x, 2) / Math.pow(rx, 2) + Math.pow(currp.y, 2) / Math.pow(ry, 2);
									if (l > 1) {
										rx *= Math.sqrt(l);
										ry *= Math.sqrt(l);
									}
									// cx', cy'
									var s = (largeArcFlag == sweepFlag ? -1 : 1) * Math.sqrt(
										((Math.pow(rx, 2) * Math.pow(ry, 2)) - (Math.pow(rx, 2) * Math.pow(currp.y, 2)) - (Math.pow(ry, 2) * Math.pow(currp.x, 2))) /
										(Math.pow(rx, 2) * Math.pow(currp.y, 2) + Math.pow(ry, 2) * Math.pow(currp.x, 2))
									);
									if (isNaN(s)) s = 0;
									var cpp = new svg.Point(s * rx * currp.y / ry, s * -ry * currp.x / rx);
									// cx, cy
									var centp = new svg.Point(
										(curr.x + cp.x) / 2.0 + Math.cos(xAxisRotation) * cpp.x - Math.sin(xAxisRotation) * cpp.y,
										(curr.y + cp.y) / 2.0 + Math.sin(xAxisRotation) * cpp.x + Math.cos(xAxisRotation) * cpp.y
									);
									// vector magnitude
									var m = function (v) { return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2)); }
									// ratio between two vectors
									var r = function (u, v) { return (u[0] * v[0] + u[1] * v[1]) / (m(u) * m(v)) }
									// angle between two vectors
									var a = function (u, v) { return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(r(u, v)); }
									// initial angle
									var a1 = a([1, 0], [(currp.x - cpp.x) / rx, (currp.y - cpp.y) / ry]);
									// angle delta
									var u = [(currp.x - cpp.x) / rx, (currp.y - cpp.y) / ry];
									var v = [(-currp.x - cpp.x) / rx, (-currp.y - cpp.y) / ry];
									var ad = a(u, v);
									if (r(u, v) <= -1) ad = Math.PI;
									if (r(u, v) >= 1) ad = 0;

									// for markers
									var dir = 1 - sweepFlag ? 1.0 : -1.0;
									var ah = a1 + dir * (ad / 2.0);
									var halfWay = new svg.Point(
										centp.x + rx * Math.cos(ah),
										centp.y + ry * Math.sin(ah)
									);
									pp.addMarkerAngle(halfWay, ah - dir * Math.PI / 2);
									pp.addMarkerAngle(cp, ah - dir * Math.PI);

									bb.addPoint(cp.x, cp.y); // TODO: this is too naive, make it better
									if (ctx != null) {
										var r = rx > ry ? rx : ry;
										var sx = rx > ry ? 1 : rx / ry;
										var sy = rx > ry ? ry / rx : 1;

										ctx.translate(centp.x, centp.y);
										ctx.rotate(xAxisRotation);
										ctx.scale(sx, sy);
										ctx.arc(0, 0, r, a1, a1 + ad, 1 - sweepFlag);
										ctx.scale(1 / sx, 1 / sy);
										ctx.rotate(-xAxisRotation);
										ctx.translate(-centp.x, -centp.y);
									}
								}
								break;
							case 'Z':
							case 'z':
								if (ctx != null) ctx.closePath();
								pp.current = pp.start;
						}
					}

					return bb;
				}

				this.getMarkers = function () {
					var points = this.PathParser.getMarkerPoints();
					var angles = this.PathParser.getMarkerAngles();

					var markers = [];
					for (var i = 0; i < points.length; i++) {
						markers.push([points[i], angles[i]]);
					}
					return markers;
				}
			}
			svg.Element.path.prototype = new svg.Element.PathElementBase;

			// pattern element
			svg.Element.pattern = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.createPattern = function (ctx, element) {
					var width = this.attribute('width').toPixels('x', true);
					var height = this.attribute('height').toPixels('y', true);

					// render me using a temporary svg element
					var tempSvg = new svg.Element.svg();
					tempSvg.attributes['viewBox'] = new svg.Property('viewBox', this.attribute('viewBox').value);
					tempSvg.attributes['width'] = new svg.Property('width', width + 'px');
					tempSvg.attributes['height'] = new svg.Property('height', height + 'px');
					tempSvg.attributes['transform'] = new svg.Property('transform', this.attribute('patternTransform').value);
					tempSvg.children = this.children;

					var c = document.createElement('canvas');
					c.width = width;
					c.height = height;
					var cctx = c.getContext('2d');
					if (this.attribute('x').hasValue() && this.attribute('y').hasValue()) {
						cctx.translate(this.attribute('x').toPixels('x', true), this.attribute('y').toPixels('y', true));
					}
					// render 3x3 grid so when we transform there's no white space on edges
					for (var x = -1; x <= 1; x++) {
						for (var y = -1; y <= 1; y++) {
							cctx.save();
							tempSvg.attributes['x'] = new svg.Property('x', x * c.width);
							tempSvg.attributes['y'] = new svg.Property('y', y * c.height);
							tempSvg.render(cctx);
							cctx.restore();
						}
					}
					var pattern = ctx.createPattern(c, 'repeat');
					return pattern;
				}
			}
			svg.Element.pattern.prototype = new svg.Element.ElementBase;

			// marker element
			svg.Element.marker = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.baseRender = this.render;
				this.render = function (ctx, point, angle) {
					ctx.translate(point.x, point.y);
					if (this.attribute('orient').valueOrDefault('auto') == 'auto') ctx.rotate(angle);
					if (this.attribute('markerUnits').valueOrDefault('strokeWidth') == 'strokeWidth') ctx.scale(ctx.lineWidth, ctx.lineWidth);
					ctx.save();

					// render me using a temporary svg element
					var tempSvg = new svg.Element.svg();
					tempSvg.attributes['viewBox'] = new svg.Property('viewBox', this.attribute('viewBox').value);
					tempSvg.attributes['refX'] = new svg.Property('refX', this.attribute('refX').value);
					tempSvg.attributes['refY'] = new svg.Property('refY', this.attribute('refY').value);
					tempSvg.attributes['width'] = new svg.Property('width', this.attribute('markerWidth').value);
					tempSvg.attributes['height'] = new svg.Property('height', this.attribute('markerHeight').value);
					tempSvg.attributes['fill'] = new svg.Property('fill', this.attribute('fill').valueOrDefault('black'));
					tempSvg.attributes['stroke'] = new svg.Property('stroke', this.attribute('stroke').valueOrDefault('none'));
					tempSvg.children = this.children;
					tempSvg.render(ctx);

					ctx.restore();
					if (this.attribute('markerUnits').valueOrDefault('strokeWidth') == 'strokeWidth') ctx.scale(1 / ctx.lineWidth, 1 / ctx.lineWidth);
					if (this.attribute('orient').valueOrDefault('auto') == 'auto') ctx.rotate(-angle);
					ctx.translate(-point.x, -point.y);
				}
			}
			svg.Element.marker.prototype = new svg.Element.ElementBase;

			// definitions element
			svg.Element.defs = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.render = function (ctx) {
					// NOOP
				}
			}
			svg.Element.defs.prototype = new svg.Element.ElementBase;

			// base for gradients
			svg.Element.GradientBase = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.stops = [];
				for (var i = 0; i < this.children.length; i++) {
					var child = this.children[i];
					if (child.type == 'stop') this.stops.push(child);
				}

				this.getGradient = function () {
					// OVERRIDE ME!
				}

				this.gradientUnits = function () {
					return this.attribute('gradientUnits').valueOrDefault('objectBoundingBox');
				}

				this.attributesToInherit = ['gradientUnits'];

				this.inheritStopContainer = function (stopsContainer) {
					for (var i = 0; i < this.attributesToInherit.length; i++) {
						var attributeToInherit = this.attributesToInherit[i];
						if (!this.attribute(attributeToInherit).hasValue() && stopsContainer.attribute(attributeToInherit).hasValue()) {
							this.attribute(attributeToInherit, true).value = stopsContainer.attribute(attributeToInherit).value;
						}
					}
				}

				this.createGradient = function (ctx, element, parentOpacityProp) {
					var stopsContainer = this;
					if (this.getHrefAttribute().hasValue()) {
						stopsContainer = this.getHrefAttribute().getDefinition();
						this.inheritStopContainer(stopsContainer);
					}

					var addParentOpacity = function (color) {
						if (parentOpacityProp.hasValue()) {
							var p = new svg.Property('color', color);
							return p.addOpacity(parentOpacityProp).value;
						}
						return color;
					};

					var g = this.getGradient(ctx, element);
					if (g == null) return addParentOpacity(stopsContainer.stops[stopsContainer.stops.length - 1].color);
					for (var i = 0; i < stopsContainer.stops.length; i++) {
						g.addColorStop(stopsContainer.stops[i].offset, addParentOpacity(stopsContainer.stops[i].color));
					}

					if (this.attribute('gradientTransform').hasValue()) {
						// render as transformed pattern on temporary canvas
						var rootView = svg.ViewPort.viewPorts[0];

						var rect = new svg.Element.rect();
						rect.attributes['x'] = new svg.Property('x', -svg.MAX_VIRTUAL_PIXELS / 3.0);
						rect.attributes['y'] = new svg.Property('y', -svg.MAX_VIRTUAL_PIXELS / 3.0);
						rect.attributes['width'] = new svg.Property('width', svg.MAX_VIRTUAL_PIXELS);
						rect.attributes['height'] = new svg.Property('height', svg.MAX_VIRTUAL_PIXELS);

						var group = new svg.Element.g();
						group.attributes['transform'] = new svg.Property('transform', this.attribute('gradientTransform').value);
						group.children = [rect];

						var tempSvg = new svg.Element.svg();
						tempSvg.attributes['x'] = new svg.Property('x', 0);
						tempSvg.attributes['y'] = new svg.Property('y', 0);
						tempSvg.attributes['width'] = new svg.Property('width', rootView.width);
						tempSvg.attributes['height'] = new svg.Property('height', rootView.height);
						tempSvg.children = [group];

						var c = document.createElement('canvas');
						c.width = rootView.width;
						c.height = rootView.height;
						var tempCtx = c.getContext('2d');
						tempCtx.fillStyle = g;
						tempSvg.render(tempCtx);
						return tempCtx.createPattern(c, 'no-repeat');
					}

					return g;
				}
			}
			svg.Element.GradientBase.prototype = new svg.Element.ElementBase;

			// linear gradient element
			svg.Element.linearGradient = function (node) {
				this.base = svg.Element.GradientBase;
				this.base(node);

				this.attributesToInherit.push('x1');
				this.attributesToInherit.push('y1');
				this.attributesToInherit.push('x2');
				this.attributesToInherit.push('y2');

				this.getGradient = function (ctx, element) {
					var bb = this.gradientUnits() == 'objectBoundingBox' ? element.getBoundingBox() : null;

					if (!this.attribute('x1').hasValue()
						&& !this.attribute('y1').hasValue()
						&& !this.attribute('x2').hasValue()
						&& !this.attribute('y2').hasValue()) {
						this.attribute('x1', true).value = 0;
						this.attribute('y1', true).value = 0;
						this.attribute('x2', true).value = 1;
						this.attribute('y2', true).value = 0;
					}

					var x1 = (this.gradientUnits() == 'objectBoundingBox'
						? bb.x() + bb.width() * this.attribute('x1').numValue()
						: this.attribute('x1').toPixels('x'));
					var y1 = (this.gradientUnits() == 'objectBoundingBox'
						? bb.y() + bb.height() * this.attribute('y1').numValue()
						: this.attribute('y1').toPixels('y'));
					var x2 = (this.gradientUnits() == 'objectBoundingBox'
						? bb.x() + bb.width() * this.attribute('x2').numValue()
						: this.attribute('x2').toPixels('x'));
					var y2 = (this.gradientUnits() == 'objectBoundingBox'
						? bb.y() + bb.height() * this.attribute('y2').numValue()
						: this.attribute('y2').toPixels('y'));

					if (x1 == x2 && y1 == y2) return null;
					return ctx.createLinearGradient(x1, y1, x2, y2);
				}
			}
			svg.Element.linearGradient.prototype = new svg.Element.GradientBase;

			// radial gradient element
			svg.Element.radialGradient = function (node) {
				this.base = svg.Element.GradientBase;
				this.base(node);

				this.attributesToInherit.push('cx');
				this.attributesToInherit.push('cy');
				this.attributesToInherit.push('r');
				this.attributesToInherit.push('fx');
				this.attributesToInherit.push('fy');

				this.getGradient = function (ctx, element) {
					var bb = element.getBoundingBox();

					if (!this.attribute('cx').hasValue()) this.attribute('cx', true).value = '50%';
					if (!this.attribute('cy').hasValue()) this.attribute('cy', true).value = '50%';
					if (!this.attribute('r').hasValue()) this.attribute('r', true).value = '50%';

					var cx = (this.gradientUnits() == 'objectBoundingBox'
						? bb.x() + bb.width() * this.attribute('cx').numValue()
						: this.attribute('cx').toPixels('x'));
					var cy = (this.gradientUnits() == 'objectBoundingBox'
						? bb.y() + bb.height() * this.attribute('cy').numValue()
						: this.attribute('cy').toPixels('y'));

					var fx = cx;
					var fy = cy;
					if (this.attribute('fx').hasValue()) {
						fx = (this.gradientUnits() == 'objectBoundingBox'
							? bb.x() + bb.width() * this.attribute('fx').numValue()
							: this.attribute('fx').toPixels('x'));
					}
					if (this.attribute('fy').hasValue()) {
						fy = (this.gradientUnits() == 'objectBoundingBox'
							? bb.y() + bb.height() * this.attribute('fy').numValue()
							: this.attribute('fy').toPixels('y'));
					}

					var r = (this.gradientUnits() == 'objectBoundingBox'
						? (bb.width() + bb.height()) / 2.0 * this.attribute('r').numValue()
						: this.attribute('r').toPixels());

					return ctx.createRadialGradient(fx, fy, 0, cx, cy, r);
				}
			}
			svg.Element.radialGradient.prototype = new svg.Element.GradientBase;

			// gradient stop element
			svg.Element.stop = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.offset = this.attribute('offset').numValue();
				if (this.offset < 0) this.offset = 0;
				if (this.offset > 1) this.offset = 1;

				var stopColor = this.style('stop-color', true);
				if (stopColor.value === '') stopColor.value = '#000';
				if (this.style('stop-opacity').hasValue()) stopColor = stopColor.addOpacity(this.style('stop-opacity'));
				this.color = stopColor.value;
			}
			svg.Element.stop.prototype = new svg.Element.ElementBase;

			// animation base element
			svg.Element.AnimateBase = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				svg.Animations.push(this);

				this.duration = 0.0;
				this.begin = this.attribute('begin').toMilliseconds();
				this.maxDuration = this.begin + this.attribute('dur').toMilliseconds();

				this.getProperty = function () {
					var attributeType = this.attribute('attributeType').value;
					var attributeName = this.attribute('attributeName').value;

					if (attributeType == 'CSS') {
						return this.parent.style(attributeName, true);
					}
					return this.parent.attribute(attributeName, true);
				};

				this.initialValue = null;
				this.initialUnits = '';
				this.removed = false;

				this.calcValue = function () {
					// OVERRIDE ME!
					return '';
				}

				this.update = function (delta) {
					// set initial value
					if (this.initialValue == null) {
						this.initialValue = this.getProperty().value;
						this.initialUnits = this.getProperty().getUnits();
					}

					// if we're past the end time
					if (this.duration > this.maxDuration) {
						// loop for indefinitely repeating animations
						if (this.attribute('repeatCount').value == 'indefinite'
							|| this.attribute('repeatDur').value == 'indefinite') {
							this.duration = 0.0
						}
						else if (this.attribute('fill').valueOrDefault('remove') == 'freeze' && !this.frozen) {
							this.frozen = true;
							this.parent.animationFrozen = true;
							this.parent.animationFrozenValue = this.getProperty().value;
						}
						else if (this.attribute('fill').valueOrDefault('remove') == 'remove' && !this.removed) {
							this.removed = true;
							this.getProperty().value = this.parent.animationFrozen ? this.parent.animationFrozenValue : this.initialValue;
							return true;
						}
						return false;
					}
					this.duration = this.duration + delta;

					// if we're past the begin time
					var updated = false;
					if (this.begin < this.duration) {
						var newValue = this.calcValue(); // tween

						if (this.attribute('type').hasValue()) {
							// for transform, etc.
							var type = this.attribute('type').value;
							newValue = type + '(' + newValue + ')';
						}

						this.getProperty().value = newValue;
						updated = true;
					}

					return updated;
				}

				this.from = this.attribute('from');
				this.to = this.attribute('to');
				this.values = this.attribute('values');
				if (this.values.hasValue()) this.values.value = this.values.value.split(';');

				// fraction of duration we've covered
				this.progress = function () {
					var ret = { progress: (this.duration - this.begin) / (this.maxDuration - this.begin) };
					if (this.values.hasValue()) {
						var p = ret.progress * (this.values.value.length - 1);
						var lb = Math.floor(p), ub = Math.ceil(p);
						ret.from = new svg.Property('from', parseFloat(this.values.value[lb]));
						ret.to = new svg.Property('to', parseFloat(this.values.value[ub]));
						ret.progress = (p - lb) / (ub - lb);
					}
					else {
						ret.from = this.from;
						ret.to = this.to;
					}
					return ret;
				}
			}
			svg.Element.AnimateBase.prototype = new svg.Element.ElementBase;

			// animate element
			svg.Element.animate = function (node) {
				this.base = svg.Element.AnimateBase;
				this.base(node);

				this.calcValue = function () {
					var p = this.progress();

					// tween value linearly
					var newValue = p.from.numValue() + (p.to.numValue() - p.from.numValue()) * p.progress;
					return newValue + this.initialUnits;
				};
			}
			svg.Element.animate.prototype = new svg.Element.AnimateBase;

			// animate color element
			svg.Element.animateColor = function (node) {
				this.base = svg.Element.AnimateBase;
				this.base(node);

				this.calcValue = function () {
					var p = this.progress();
					var from = new RGBColor(p.from.value);
					var to = new RGBColor(p.to.value);

					if (from.ok && to.ok) {
						// tween color linearly
						var r = from.r + (to.r - from.r) * p.progress;
						var g = from.g + (to.g - from.g) * p.progress;
						var b = from.b + (to.b - from.b) * p.progress;
						return 'rgb(' + parseInt(r, 10) + ',' + parseInt(g, 10) + ',' + parseInt(b, 10) + ')';
					}
					return this.attribute('from').value;
				};
			}
			svg.Element.animateColor.prototype = new svg.Element.AnimateBase;

			// animate transform element
			svg.Element.animateTransform = function (node) {
				this.base = svg.Element.AnimateBase;
				this.base(node);

				this.calcValue = function () {
					var p = this.progress();

					// tween value linearly
					var from = svg.ToNumberArray(p.from.value);
					var to = svg.ToNumberArray(p.to.value);
					var newValue = '';
					for (var i = 0; i < from.length; i++) {
						newValue += from[i] + (to[i] - from[i]) * p.progress + ' ';
					}
					return newValue;
				};
			}
			svg.Element.animateTransform.prototype = new svg.Element.animate;

			// font element
			svg.Element.font = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.horizAdvX = this.attribute('horiz-adv-x').numValue();

				this.isRTL = false;
				this.isArabic = false;
				this.fontFace = null;
				this.missingGlyph = null;
				this.glyphs = [];
				for (var i = 0; i < this.children.length; i++) {
					var child = this.children[i];
					if (child.type == 'font-face') {
						this.fontFace = child;
						if (child.style('font-family').hasValue()) {
							svg.Definitions[child.style('font-family').value] = this;
						}
					}
					else if (child.type == 'missing-glyph') this.missingGlyph = child;
					else if (child.type == 'glyph') {
						if (child.arabicForm != '') {
							this.isRTL = true;
							this.isArabic = true;
							if (typeof this.glyphs[child.unicode] == 'undefined') this.glyphs[child.unicode] = [];
							this.glyphs[child.unicode][child.arabicForm] = child;
						}
						else {
							this.glyphs[child.unicode] = child;
						}
					}
				}
			}
			svg.Element.font.prototype = new svg.Element.ElementBase;

			// font-face element
			svg.Element.fontface = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.ascent = this.attribute('ascent').value;
				this.descent = this.attribute('descent').value;
				this.unitsPerEm = this.attribute('units-per-em').numValue();
			}
			svg.Element.fontface.prototype = new svg.Element.ElementBase;

			// missing-glyph element
			svg.Element.missingglyph = function (node) {
				this.base = svg.Element.path;
				this.base(node);

				this.horizAdvX = 0;
			}
			svg.Element.missingglyph.prototype = new svg.Element.path;

			// glyph element
			svg.Element.glyph = function (node) {
				this.base = svg.Element.path;
				this.base(node);

				this.horizAdvX = this.attribute('horiz-adv-x').numValue();
				this.unicode = this.attribute('unicode').value;
				this.arabicForm = this.attribute('arabic-form').value;
			}
			svg.Element.glyph.prototype = new svg.Element.path;

			// text element
			svg.Element.text = function (node) {
				this.captureTextNodes = true;
				this.base = svg.Element.RenderedElementBase;
				this.base(node);

				this.baseSetContext = this.setContext;
				this.setContext = function (ctx) {
					this.baseSetContext(ctx);

					var textBaseline = this.style('dominant-baseline').toTextBaseline();
					if (textBaseline == null) textBaseline = this.style('alignment-baseline').toTextBaseline();
					if (textBaseline != null) ctx.textBaseline = textBaseline;
				}

				this.getBoundingBox = function () {
					var x = this.attribute('x').toPixels('x');
					var y = this.attribute('y').toPixels('y');
					var fontSize = this.parent.style('font-size').numValueOrDefault(svg.Font.Parse(svg.ctx.font).fontSize);
					return new svg.BoundingBox(x, y - fontSize, x + Math.floor(fontSize * 2.0 / 3.0) * this.children[0].getText().length, y);
				}

				this.renderChildren = function (ctx) {
					this.x = this.attribute('x').toPixels('x');
					this.y = this.attribute('y').toPixels('y');
					if (this.attribute('dx').hasValue()) this.x += this.attribute('dx').toPixels('x');
					if (this.attribute('dy').hasValue()) this.y += this.attribute('dy').toPixels('y');
					this.x += this.getAnchorDelta(ctx, this, 0);
					for (var i = 0; i < this.children.length; i++) {
						this.renderChild(ctx, this, this, i);
					}
				}

				this.getAnchorDelta = function (ctx, parent, startI) {
					var textAnchor = this.style('text-anchor').valueOrDefault('start');
					if (textAnchor != 'start') {
						var width = 0;
						for (var i = startI; i < parent.children.length; i++) {
							var child = parent.children[i];
							if (i > startI && child.attribute('x').hasValue()) break; // new group
							width += child.measureTextRecursive(ctx);
						}
						return -1 * (textAnchor == 'end' ? width : width / 2.0);
					}
					return 0;
				}

				this.renderChild = function (ctx, textParent, parent, i) {
					var child = parent.children[i];
					if (child.attribute('x').hasValue()) {
						child.x = child.attribute('x').toPixels('x') + textParent.getAnchorDelta(ctx, parent, i);
						if (child.attribute('dx').hasValue()) child.x += child.attribute('dx').toPixels('x');
					}
					else {
						if (child.attribute('dx').hasValue()) textParent.x += child.attribute('dx').toPixels('x');
						child.x = textParent.x;
					}
					textParent.x = child.x + child.measureText(ctx);

					if (child.attribute('y').hasValue()) {
						child.y = child.attribute('y').toPixels('y');
						if (child.attribute('dy').hasValue()) child.y += child.attribute('dy').toPixels('y');
					}
					else {
						if (child.attribute('dy').hasValue()) textParent.y += child.attribute('dy').toPixels('y');
						child.y = textParent.y;
					}
					textParent.y = child.y;

					child.render(ctx);

					for (var i = 0; i < child.children.length; i++) {
						textParent.renderChild(ctx, textParent, child, i);
					}
				}
			}
			svg.Element.text.prototype = new svg.Element.RenderedElementBase;

			// text base
			svg.Element.TextElementBase = function (node) {
				this.base = svg.Element.RenderedElementBase;
				this.base(node);

				this.getGlyph = function (font, text, i) {
					var c = text[i];
					var glyph = null;
					if (font.isArabic) {
						var arabicForm = 'isolated';
						if ((i == 0 || text[i - 1] == ' ') && i < text.length - 2 && text[i + 1] != ' ') arabicForm = 'terminal';
						if (i > 0 && text[i - 1] != ' ' && i < text.length - 2 && text[i + 1] != ' ') arabicForm = 'medial';
						if (i > 0 && text[i - 1] != ' ' && (i == text.length - 1 || text[i + 1] == ' ')) arabicForm = 'initial';
						if (typeof font.glyphs[c] != 'undefined') {
							glyph = font.glyphs[c][arabicForm];
							if (glyph == null && font.glyphs[c].type == 'glyph') glyph = font.glyphs[c];
						}
					}
					else {
						glyph = font.glyphs[c];
					}
					if (glyph == null) glyph = font.missingGlyph;
					return glyph;
				}

				this.renderChildren = function (ctx) {
					var customFont = this.parent.style('font-family').getDefinition();
					if (customFont != null) {
						var fontSize = this.parent.style('font-size').numValueOrDefault(svg.Font.Parse(svg.ctx.font).fontSize);
						var fontStyle = this.parent.style('font-style').valueOrDefault(svg.Font.Parse(svg.ctx.font).fontStyle);
						var text = this.getText();
						if (customFont.isRTL) text = text.split("").reverse().join("");

						var dx = svg.ToNumberArray(this.parent.attribute('dx').value);
						for (var i = 0; i < text.length; i++) {
							var glyph = this.getGlyph(customFont, text, i);
							var scale = fontSize / customFont.fontFace.unitsPerEm;
							ctx.translate(this.x, this.y);
							ctx.scale(scale, -scale);
							var lw = ctx.lineWidth;
							ctx.lineWidth = ctx.lineWidth * customFont.fontFace.unitsPerEm / fontSize;
							if (fontStyle == 'italic') ctx.transform(1, 0, .4, 1, 0, 0);
							glyph.render(ctx);
							if (fontStyle == 'italic') ctx.transform(1, 0, -.4, 1, 0, 0);
							ctx.lineWidth = lw;
							ctx.scale(1 / scale, -1 / scale);
							ctx.translate(-this.x, -this.y);

							this.x += fontSize * (glyph.horizAdvX || customFont.horizAdvX) / customFont.fontFace.unitsPerEm;
							if (typeof dx[i] != 'undefined' && !isNaN(dx[i])) {
								this.x += dx[i];
							}
						}
						return;
					}

					if (ctx.fillStyle != '') ctx.fillText(svg.compressSpaces(this.getText()), this.x, this.y);
					if (ctx.strokeStyle != '') ctx.strokeText(svg.compressSpaces(this.getText()), this.x, this.y);
				}

				this.getText = function () {
					// OVERRIDE ME
				}

				this.measureTextRecursive = function (ctx) {
					var width = this.measureText(ctx);
					for (var i = 0; i < this.children.length; i++) {
						width += this.children[i].measureTextRecursive(ctx);
					}
					return width;
				}

				this.measureText = function (ctx) {
					var customFont = this.parent.style('font-family').getDefinition();
					if (customFont != null) {
						var fontSize = this.parent.style('font-size').numValueOrDefault(svg.Font.Parse(svg.ctx.font).fontSize);
						var measure = 0;
						var text = this.getText();
						if (customFont.isRTL) text = text.split("").reverse().join("");
						var dx = svg.ToNumberArray(this.parent.attribute('dx').value);
						for (var i = 0; i < text.length; i++) {
							var glyph = this.getGlyph(customFont, text, i);
							measure += (glyph.horizAdvX || customFont.horizAdvX) * fontSize / customFont.fontFace.unitsPerEm;
							if (typeof dx[i] != 'undefined' && !isNaN(dx[i])) {
								measure += dx[i];
							}
						}
						return measure;
					}

					var textToMeasure = svg.compressSpaces(this.getText());
					if (!ctx.measureText) return textToMeasure.length * 10;

					ctx.save();
					this.setContext(ctx);
					var width = ctx.measureText(textToMeasure).width;
					ctx.restore();
					return width;
				}
			}
			svg.Element.TextElementBase.prototype = new svg.Element.RenderedElementBase;

			// tspan
			svg.Element.tspan = function (node) {
				this.captureTextNodes = true;
				this.base = svg.Element.TextElementBase;
				this.base(node);

				this.text = svg.compressSpaces(node.value || node.text || node.textContent || '');
				this.getText = function () {
					// if this node has children, then they own the text
					if (this.children.length > 0) { return ''; }
					return this.text;
				}
			}
			svg.Element.tspan.prototype = new svg.Element.TextElementBase;

			// tref
			svg.Element.tref = function (node) {
				this.base = svg.Element.TextElementBase;
				this.base(node);

				this.getText = function () {
					var element = this.getHrefAttribute().getDefinition();
					if (element != null) return element.children[0].getText();
				}
			}
			svg.Element.tref.prototype = new svg.Element.TextElementBase;

			// a element
			svg.Element.a = function (node) {
				this.base = svg.Element.TextElementBase;
				this.base(node);

				this.hasText = node.childNodes.length > 0;
				for (var i = 0; i < node.childNodes.length; i++) {
					if (node.childNodes[i].nodeType != 3) this.hasText = false;
				}

				// this might contain text
				this.text = this.hasText ? node.childNodes[0].value : '';
				this.getText = function () {
					return this.text;
				}

				this.baseRenderChildren = this.renderChildren;
				this.renderChildren = function (ctx) {
					if (this.hasText) {
						// render as text element
						this.baseRenderChildren(ctx);
						var fontSize = new svg.Property('fontSize', svg.Font.Parse(svg.ctx.font).fontSize);
						svg.Mouse.checkBoundingBox(this, new svg.BoundingBox(this.x, this.y - fontSize.toPixels('y'), this.x + this.measureText(ctx), this.y));
					}
					else if (this.children.length > 0) {
						// render as temporary group
						var g = new svg.Element.g();
						g.children = this.children;
						g.parent = this;
						g.render(ctx);
					}
				}

				this.onclick = function () {
					window.open(this.getHrefAttribute().value);
				}

				this.onmousemove = function () {
					svg.ctx.canvas.style.cursor = 'pointer';
				}
			}
			svg.Element.a.prototype = new svg.Element.TextElementBase;

			// image element
			svg.Element.image = function (node) {
				this.base = svg.Element.RenderedElementBase;
				this.base(node);

				var href = this.getHrefAttribute().value;
				if (href == '') { return; }
				var isSvg = href.match(/\.svg$/)

				svg.Images.push(this);
				this.loaded = false;
				if (!isSvg) {
					this.img = document.createElement('img');
					if (svg.opts['useCORS'] == true) { this.img.crossOrigin = 'Anonymous'; }
					var self = this;
					this.img.onload = function () { self.loaded = true; }
					this.img.onerror = function () { svg.log('ERROR: image "' + href + '" not found'); self.loaded = true; }
					this.img.src = href;
				}
				else {
					this.img = svg.ajax(href);
					this.loaded = true;
				}

				this.renderChildren = function (ctx) {
					var x = this.attribute('x').toPixels('x');
					var y = this.attribute('y').toPixels('y');

					var width = this.attribute('width').toPixels('x');
					var height = this.attribute('height').toPixels('y');
					if (width == 0 || height == 0) return;

					ctx.save();
					if (isSvg) {
						ctx.drawSvg(this.img, x, y, width, height);
					}
					else {
						ctx.translate(x, y);
						svg.AspectRatio(ctx,
							this.attribute('preserveAspectRatio').value,
							width,
							this.img.width,
							height,
							this.img.height,
							0,
							0);
						ctx.drawImage(this.img, 0, 0);
					}
					ctx.restore();
				}

				this.getBoundingBox = function () {
					var x = this.attribute('x').toPixels('x');
					var y = this.attribute('y').toPixels('y');
					var width = this.attribute('width').toPixels('x');
					var height = this.attribute('height').toPixels('y');
					return new svg.BoundingBox(x, y, x + width, y + height);
				}
			}
			svg.Element.image.prototype = new svg.Element.RenderedElementBase;

			// group element
			svg.Element.g = function (node) {
				this.base = svg.Element.RenderedElementBase;
				this.base(node);

				this.getBoundingBox = function () {
					var bb = new svg.BoundingBox();
					for (var i = 0; i < this.children.length; i++) {
						bb.addBoundingBox(this.children[i].getBoundingBox());
					}
					return bb;
				};
			}
			svg.Element.g.prototype = new svg.Element.RenderedElementBase;

			// symbol element
			svg.Element.symbol = function (node) {
				this.base = svg.Element.RenderedElementBase;
				this.base(node);

				this.render = function (ctx) {
					// NO RENDER
				};
			}
			svg.Element.symbol.prototype = new svg.Element.RenderedElementBase;

			// style element
			svg.Element.style = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				// text, or spaces then CDATA
				var css = ''
				for (var i = 0; i < node.childNodes.length; i++) {
					css += node.childNodes[i].data;
				}
				css = css.replace(/(\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, ''); // remove comments
				css = svg.compressSpaces(css); // replace whitespace
				var cssDefs = css.split('}');
				for (var i = 0; i < cssDefs.length; i++) {
					if (svg.trim(cssDefs[i]) != '') {
						var cssDef = cssDefs[i].split('{');
						var cssClasses = cssDef[0].split(',');
						var cssProps = cssDef[1].split(';');
						for (var j = 0; j < cssClasses.length; j++) {
							var cssClass = svg.trim(cssClasses[j]);
							if (cssClass != '') {
								var props = svg.Styles[cssClass] || {};
								for (var k = 0; k < cssProps.length; k++) {
									var prop = cssProps[k].indexOf(':');
									var name = cssProps[k].substr(0, prop);
									var value = cssProps[k].substr(prop + 1, cssProps[k].length - prop);
									if (name != null && value != null) {
										props[svg.trim(name)] = new svg.Property(svg.trim(name), svg.trim(value));
									}
								}
								svg.Styles[cssClass] = props;
								svg.StylesSpecificity[cssClass] = getSelectorSpecificity(cssClass);
								if (cssClass == '@font-face') {
									var fontFamily = props['font-family'].value.replace(/"/g, '');
									var srcs = props['src'].value.split(',');
									for (var s = 0; s < srcs.length; s++) {
										if (srcs[s].indexOf('format("svg")') > 0) {
											var urlStart = srcs[s].indexOf('url');
											var urlEnd = srcs[s].indexOf(')', urlStart);
											var url = srcs[s].substr(urlStart + 5, urlEnd - urlStart - 6);
											var doc = svg.parseXml(svg.ajax(url));
											var fonts = doc.getElementsByTagName('font');
											for (var f = 0; f < fonts.length; f++) {
												var font = svg.CreateElement(fonts[f]);
												svg.Definitions[fontFamily] = font;
											}
										}
									}
								}
							}
						}
					}
				}
			}
			svg.Element.style.prototype = new svg.Element.ElementBase;

			// use element
			svg.Element.use = function (node) {
				this.base = svg.Element.RenderedElementBase;
				this.base(node);

				this.baseSetContext = this.setContext;
				this.setContext = function (ctx) {
					this.baseSetContext(ctx);
					if (this.attribute('x').hasValue()) ctx.translate(this.attribute('x').toPixels('x'), 0);
					if (this.attribute('y').hasValue()) ctx.translate(0, this.attribute('y').toPixels('y'));
				}

				var element = this.getHrefAttribute().getDefinition();

				this.path = function (ctx) {
					if (element != null) element.path(ctx);
				}

				this.getBoundingBox = function () {
					if (element != null) return element.getBoundingBox();
				}

				this.renderChildren = function (ctx) {
					if (element != null) {
						var tempSvg = element;
						if (element.type == 'symbol') {
							// render me using a temporary svg element in symbol cases (http://www.w3.org/TR/SVG/struct.html#UseElement)
							tempSvg = new svg.Element.svg();
							tempSvg.type = 'svg';
							tempSvg.attributes['viewBox'] = new svg.Property('viewBox', element.attribute('viewBox').value);
							tempSvg.attributes['preserveAspectRatio'] = new svg.Property('preserveAspectRatio', element.attribute('preserveAspectRatio').value);
							tempSvg.attributes['overflow'] = new svg.Property('overflow', element.attribute('overflow').value);
							tempSvg.children = element.children;
						}
						if (tempSvg.type == 'svg') {
							// if symbol or svg, inherit width/height from me
							if (this.attribute('width').hasValue()) tempSvg.attributes['width'] = new svg.Property('width', this.attribute('width').value);
							if (this.attribute('height').hasValue()) tempSvg.attributes['height'] = new svg.Property('height', this.attribute('height').value);
						}
						var oldParent = tempSvg.parent;
						tempSvg.parent = null;
						tempSvg.render(ctx);
						tempSvg.parent = oldParent;
					}
				}
			}
			svg.Element.use.prototype = new svg.Element.RenderedElementBase;

			// mask element
			svg.Element.mask = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.apply = function (ctx, element) {
					// render as temp svg
					var x = this.attribute('x').toPixels('x');
					var y = this.attribute('y').toPixels('y');
					var width = this.attribute('width').toPixels('x');
					var height = this.attribute('height').toPixels('y');

					if (width == 0 && height == 0) {
						var bb = new svg.BoundingBox();
						for (var i = 0; i < this.children.length; i++) {
							bb.addBoundingBox(this.children[i].getBoundingBox());
						}
						var x = Math.floor(bb.x1);
						var y = Math.floor(bb.y1);
						var width = Math.floor(bb.width());
						var height = Math.floor(bb.height());
					}

					// temporarily remove mask to avoid recursion
					var mask = element.attribute('mask').value;
					element.attribute('mask').value = '';

					var cMask = document.createElement('canvas');
					cMask.width = x + width;
					cMask.height = y + height;
					var maskCtx = cMask.getContext('2d');
					this.renderChildren(maskCtx);

					var c = document.createElement('canvas');
					c.width = x + width;
					c.height = y + height;
					var tempCtx = c.getContext('2d');
					element.render(tempCtx);
					tempCtx.globalCompositeOperation = 'destination-in';
					tempCtx.fillStyle = maskCtx.createPattern(cMask, 'no-repeat');
					tempCtx.fillRect(0, 0, x + width, y + height);

					ctx.fillStyle = tempCtx.createPattern(c, 'no-repeat');
					ctx.fillRect(0, 0, x + width, y + height);

					// reassign mask
					element.attribute('mask').value = mask;
				}

				this.render = function (ctx) {
					// NO RENDER
				}
			}
			svg.Element.mask.prototype = new svg.Element.ElementBase;

			// clip element
			svg.Element.clipPath = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.apply = function (ctx) {
					var oldBeginPath = CanvasRenderingContext2D.prototype.beginPath;
					CanvasRenderingContext2D.prototype.beginPath = function () { };

					var oldClosePath = CanvasRenderingContext2D.prototype.closePath;
					CanvasRenderingContext2D.prototype.closePath = function () { };

					oldBeginPath.call(ctx);
					for (var i = 0; i < this.children.length; i++) {
						var child = this.children[i];
						if (typeof child.path != 'undefined') {
							var transform = null;
							if (child.style('transform', false, true).hasValue()) {
								transform = new svg.Transform(child.style('transform', false, true).value);
								transform.apply(ctx);
							}
							child.path(ctx);
							CanvasRenderingContext2D.prototype.closePath = oldClosePath;
							if (transform) { transform.unapply(ctx); }
						}
					}
					oldClosePath.call(ctx);
					ctx.clip();

					CanvasRenderingContext2D.prototype.beginPath = oldBeginPath;
					CanvasRenderingContext2D.prototype.closePath = oldClosePath;
				}

				this.render = function (ctx) {
					// NO RENDER
				}
			}
			svg.Element.clipPath.prototype = new svg.Element.ElementBase;

			// filters
			svg.Element.filter = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.apply = function (ctx, element) {
					// render as temp svg
					var bb = element.getBoundingBox();
					var x = Math.floor(bb.x1);
					var y = Math.floor(bb.y1);
					var width = Math.floor(bb.width());
					var height = Math.floor(bb.height());

					// temporarily remove filter to avoid recursion
					var filter = element.style('filter').value;
					element.style('filter').value = '';

					var px = 0, py = 0;
					for (var i = 0; i < this.children.length; i++) {
						var efd = this.children[i].extraFilterDistance || 0;
						px = Math.max(px, efd);
						py = Math.max(py, efd);
					}

					var c = document.createElement('canvas');
					c.width = width + 2 * px;
					c.height = height + 2 * py;
					var tempCtx = c.getContext('2d');
					tempCtx.translate(-x + px, -y + py);
					element.render(tempCtx);

					// apply filters
					for (var i = 0; i < this.children.length; i++) {
						if (typeof this.children[i].apply == 'function') {
							this.children[i].apply(tempCtx, 0, 0, width + 2 * px, height + 2 * py);
						}
					}

					// render on me
					ctx.drawImage(c, 0, 0, width + 2 * px, height + 2 * py, x - px, y - py, width + 2 * px, height + 2 * py);

					// reassign filter
					element.style('filter', true).value = filter;
				}

				this.render = function (ctx) {
					// NO RENDER
				}
			}
			svg.Element.filter.prototype = new svg.Element.ElementBase;

			// Credit for `feDropShadow` goes to InvisionApp Canvg Fork
			svg.Element.feDropShadow = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);
				this.addStylesFromStyleDefinition();

				this.apply = function (ctx, x, y, width, height) {
					// TODO: implement
				}
			}
			svg.Element.feDropShadow.prototype = new svg.Element.ElementBase;

			svg.Element.feMorphology = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.apply = function (ctx, x, y, width, height) {
					// TODO: implement
				}
			}
			svg.Element.feMorphology.prototype = new svg.Element.ElementBase;

			svg.Element.feComposite = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.apply = function (ctx, x, y, width, height) {
					// TODO: implement
				}
			}
			svg.Element.feComposite.prototype = new svg.Element.ElementBase;

			svg.Element.feColorMatrix = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				var matrix = svg.ToNumberArray(this.attribute('values').value);
				switch (this.attribute('type').valueOrDefault('matrix')) { // http://www.w3.org/TR/SVG/filters.html#feColorMatrixElement
					case 'saturate':
						var s = matrix[0];
						matrix = [0.213 + 0.787 * s, 0.715 - 0.715 * s, 0.072 - 0.072 * s, 0, 0,
						0.213 - 0.213 * s, 0.715 + 0.285 * s, 0.072 - 0.072 * s, 0, 0,
						0.213 - 0.213 * s, 0.715 - 0.715 * s, 0.072 + 0.928 * s, 0, 0,
							0, 0, 0, 1, 0,
							0, 0, 0, 0, 1];
						break;
					case 'hueRotate':
						var a = matrix[0] * Math.PI / 180.0;
						var c = function (m1, m2, m3) { return m1 + Math.cos(a) * m2 + Math.sin(a) * m3; };
						matrix = [c(0.213, 0.787, -0.213), c(0.715, -0.715, -0.715), c(0.072, -0.072, 0.928), 0, 0,
						c(0.213, -0.213, 0.143), c(0.715, 0.285, 0.140), c(0.072, -0.072, -0.283), 0, 0,
						c(0.213, -0.213, -0.787), c(0.715, -0.715, 0.715), c(0.072, 0.928, 0.072), 0, 0,
							0, 0, 0, 1, 0,
							0, 0, 0, 0, 1];
						break;
					case 'luminanceToAlpha':
						matrix = [0, 0, 0, 0, 0,
							0, 0, 0, 0, 0,
							0, 0, 0, 0, 0,
							0.2125, 0.7154, 0.0721, 0, 0,
							0, 0, 0, 0, 1];
						break;
				}

				function imGet(img, x, y, width, height, rgba) {
					return img[y * width * 4 + x * 4 + rgba];
				}

				function imSet(img, x, y, width, height, rgba, val) {
					img[y * width * 4 + x * 4 + rgba] = val;
				}

				function m(i, v) {
					var mi = matrix[i];
					return mi * (mi < 0 ? v - 255 : v);
				}

				this.apply = function (ctx, x, y, width, height) {
					// assuming x==0 && y==0 for now
					var srcData = ctx.getImageData(0, 0, width, height);
					for (var y = 0; y < height; y++) {
						for (var x = 0; x < width; x++) {
							var r = imGet(srcData.data, x, y, width, height, 0);
							var g = imGet(srcData.data, x, y, width, height, 1);
							var b = imGet(srcData.data, x, y, width, height, 2);
							var a = imGet(srcData.data, x, y, width, height, 3);
							imSet(srcData.data, x, y, width, height, 0, m(0, r) + m(1, g) + m(2, b) + m(3, a) + m(4, 1));
							imSet(srcData.data, x, y, width, height, 1, m(5, r) + m(6, g) + m(7, b) + m(8, a) + m(9, 1));
							imSet(srcData.data, x, y, width, height, 2, m(10, r) + m(11, g) + m(12, b) + m(13, a) + m(14, 1));
							imSet(srcData.data, x, y, width, height, 3, m(15, r) + m(16, g) + m(17, b) + m(18, a) + m(19, 1));
						}
					}
					ctx.clearRect(0, 0, width, height);
					ctx.putImageData(srcData, 0, 0);
				}
			}
			svg.Element.feColorMatrix.prototype = new svg.Element.ElementBase;

			svg.Element.feGaussianBlur = function (node) {
				this.base = svg.Element.ElementBase;
				this.base(node);

				this.blurRadius = Math.floor(this.attribute('stdDeviation').numValue());
				this.extraFilterDistance = this.blurRadius;

				this.apply = function (ctx, x, y, width, height) {
					if (typeof stackBlur.canvasRGBA == 'undefined') {
						svg.log('ERROR: StackBlur.js must be included for blur to work');
						return;
					}

					// StackBlur requires canvas be on document
					ctx.canvas.id = svg.UniqueId();
					ctx.canvas.style.display = 'none';
					document.body.appendChild(ctx.canvas);
					stackBlur.canvasRGBA(ctx.canvas.id, x, y, width, height, this.blurRadius);
					document.body.removeChild(ctx.canvas);
				}
			}
			svg.Element.feGaussianBlur.prototype = new svg.Element.ElementBase;

			// title element, do nothing
			svg.Element.title = function (node) {
			}
			svg.Element.title.prototype = new svg.Element.ElementBase;

			// desc element, do nothing
			svg.Element.desc = function (node) {
			}
			svg.Element.desc.prototype = new svg.Element.ElementBase;

			svg.Element.MISSING = function (node) {
				svg.log('ERROR: Element \'' + node.nodeName + '\' not yet implemented.');
			}
			svg.Element.MISSING.prototype = new svg.Element.ElementBase;

			// element factory
			svg.CreateElement = function (node) {
				var className = node.nodeName.replace(/^[^:]+:/, ''); // remove namespace
				className = className.replace(/\-/g, ''); // remove dashes
				var e = null;
				if (typeof svg.Element[className] != 'undefined') {
					e = new svg.Element[className](node);
				}
				else {
					e = new svg.Element.MISSING(node);
				}

				e.type = node.nodeName;
				return e;
			}

			// load from url
			svg.load = function (ctx, url) {
				svg.loadXml(ctx, svg.ajax(url));
			}

			// load from xml
			svg.loadXml = function (ctx, xml) {
				svg.loadXmlDoc(ctx, svg.parseXml(xml));
			}

			svg.loadXmlDoc = function (ctx, dom) {
				svg.init(ctx);

				var mapXY = function (p) {
					var e = ctx.canvas;
					while (e) {
						p.x -= e.offsetLeft;
						p.y -= e.offsetTop;
						e = e.offsetParent;
					}
					if (window.scrollX) p.x += window.scrollX;
					if (window.scrollY) p.y += window.scrollY;
					return p;
				}

				// bind mouse
				if (svg.opts['ignoreMouse'] != true) {
					ctx.canvas.onclick = function (e) {
						var p = mapXY(new svg.Point(e != null ? e.clientX : event.clientX, e != null ? e.clientY : event.clientY));
						svg.Mouse.onclick(p.x, p.y);
					};
					ctx.canvas.onmousemove = function (e) {
						var p = mapXY(new svg.Point(e != null ? e.clientX : event.clientX, e != null ? e.clientY : event.clientY));
						svg.Mouse.onmousemove(p.x, p.y);
					};
				}

				var e = svg.CreateElement(dom.documentElement);
				e.root = true;
				e.addStylesFromStyleDefinition();

				// render loop
				var isFirstRender = true;
				var draw = function () {
					svg.ViewPort.Clear();
					if (ctx.canvas.parentNode) svg.ViewPort.SetCurrent(ctx.canvas.parentNode.clientWidth, ctx.canvas.parentNode.clientHeight);

					if (svg.opts['ignoreDimensions'] != true) {
						// set canvas size
						if (e.style('width').hasValue()) {
							ctx.canvas.width = e.style('width').toPixels('x');
							ctx.canvas.style.width = ctx.canvas.width + 'px';
						}
						if (e.style('height').hasValue()) {
							ctx.canvas.height = e.style('height').toPixels('y');
							ctx.canvas.style.height = ctx.canvas.height + 'px';
						}
					}
					var cWidth = ctx.canvas.clientWidth || ctx.canvas.width;
					var cHeight = ctx.canvas.clientHeight || ctx.canvas.height;
					if (svg.opts['ignoreDimensions'] == true && e.style('width').hasValue() && e.style('height').hasValue()) {
						cWidth = e.style('width').toPixels('x');
						cHeight = e.style('height').toPixels('y');
					}
					svg.ViewPort.SetCurrent(cWidth, cHeight);

					if (svg.opts['offsetX'] != null) e.attribute('x', true).value = svg.opts['offsetX'];
					if (svg.opts['offsetY'] != null) e.attribute('y', true).value = svg.opts['offsetY'];
					if (svg.opts['scaleWidth'] != null || svg.opts['scaleHeight'] != null) {
						var xRatio = null, yRatio = null, viewBox = svg.ToNumberArray(e.attribute('viewBox').value);

						if (svg.opts['scaleWidth'] != null) {
							if (e.attribute('width').hasValue()) xRatio = e.attribute('width').toPixels('x') / svg.opts['scaleWidth'];
							else if (!isNaN(viewBox[2])) xRatio = viewBox[2] / svg.opts['scaleWidth'];
						}

						if (svg.opts['scaleHeight'] != null) {
							if (e.attribute('height').hasValue()) yRatio = e.attribute('height').toPixels('y') / svg.opts['scaleHeight'];
							else if (!isNaN(viewBox[3])) yRatio = viewBox[3] / svg.opts['scaleHeight'];
						}

						if (xRatio == null) { xRatio = yRatio; }
						if (yRatio == null) { yRatio = xRatio; }

						e.attribute('width', true).value = svg.opts['scaleWidth'];
						e.attribute('height', true).value = svg.opts['scaleHeight'];
						e.style('transform', true, true).value += ' scale(' + (1.0 / xRatio) + ',' + (1.0 / yRatio) + ')';
					}

					// clear and render
					if (svg.opts['ignoreClear'] != true) {
						ctx.clearRect(0, 0, cWidth, cHeight);
					}
					e.render(ctx);
					if (isFirstRender) {
						isFirstRender = false;
						if (typeof svg.opts['renderCallback'] == 'function') svg.opts['renderCallback'](dom);
					}
				}

				var waitingForImages = true;
				if (svg.ImagesLoaded()) {
					waitingForImages = false;
					draw();
				}
				svg.intervalID = setInterval(function () {
					var needUpdate = false;

					if (waitingForImages && svg.ImagesLoaded()) {
						waitingForImages = false;
						needUpdate = true;
					}

					// need update from mouse events?
					if (svg.opts['ignoreMouse'] != true) {
						needUpdate = needUpdate | svg.Mouse.hasEvents();
					}

					// need update from animations?
					if (svg.opts['ignoreAnimation'] != true) {
						for (var i = 0; i < svg.Animations.length; i++) {
							needUpdate = needUpdate | svg.Animations[i].update(1000 / svg.FRAMERATE);
						}
					}

					// need update from redraw?
					if (typeof svg.opts['forceRedraw'] == 'function') {
						if (svg.opts['forceRedraw']() == true) needUpdate = true;
					}

					// render if needed
					if (needUpdate) {
						draw();
						svg.Mouse.runEvents(); // run and clear our events
					}
				}, 1000 / svg.FRAMERATE);
			}

			svg.stop = function () {
				if (svg.intervalID) {
					clearInterval(svg.intervalID);
				}
			}

			svg.Mouse = new (function () {
				this.events = [];
				this.hasEvents = function () { return this.events.length != 0; }

				this.onclick = function (x, y) {
					this.events.push({
						type: 'onclick', x: x, y: y,
						run: function (e) { if (e.onclick) e.onclick(); }
					});
				}

				this.onmousemove = function (x, y) {
					this.events.push({
						type: 'onmousemove', x: x, y: y,
						run: function (e) { if (e.onmousemove) e.onmousemove(); }
					});
				}

				this.eventElements = [];

				this.checkPath = function (element, ctx) {
					for (var i = 0; i < this.events.length; i++) {
						var e = this.events[i];
						if (ctx.isPointInPath && ctx.isPointInPath(e.x, e.y)) this.eventElements[i] = element;
					}
				}

				this.checkBoundingBox = function (element, bb) {
					for (var i = 0; i < this.events.length; i++) {
						var e = this.events[i];
						if (bb.isPointInBox(e.x, e.y)) this.eventElements[i] = element;
					}
				}

				this.runEvents = function () {
					svg.ctx.canvas.style.cursor = '';

					for (var i = 0; i < this.events.length; i++) {
						var e = this.events[i];
						var element = this.eventElements[i];
						while (element) {
							e.run(element);
							element = element.parent;
						}
					}

					// done running, clear
					this.events = [];
					this.eventElements = [];
				}
			});

			return svg;
		};

		if (typeof CanvasRenderingContext2D != 'undefined') {
			CanvasRenderingContext2D.prototype.drawSvg = function (s, dx, dy, dw, dh, opts) {
				var cOpts = {
					ignoreMouse: true,
					ignoreAnimation: true,
					ignoreDimensions: true,
					ignoreClear: true,
					offsetX: dx,
					offsetY: dy,
					scaleWidth: dw,
					scaleHeight: dh
				}

				for (var prop in opts) {
					if (opts.hasOwnProperty(prop)) {
						cOpts[prop] = opts[prop];
					}
				}
				canvg(this.canvas, s, cOpts);
			}
		}

		return canvg;

	}));

	// requires: joint.format.svg.js plugin
	// support 3rd party library: canvg - canvg.js, rgbcolor.js, StackBlur.js

	(function (joint) {
		'use strict';

		/**
		 * @public
		 * @param {function} callback
		 * @param {{width?:number, height?: number, size?:string, padding?: Object|number type: string backgroundColor: string quality: string }} opt
		 */
		joint.dia.Paper.prototype.toDataURL = function (callback, opt) {

			// check whether the svg export plugin was loaded.
			if (typeof this.toSVG !== 'function') throw new Error('The joint.format.svg.js plugin must be loaded.');

			// options: type, width, height, quality (works only with type set to 'image/jpeg' or 'image/webp'),
			// backgroundColor
			opt = opt || {};

			var clientRect = opt.area || this.paperToLocalRect(this.getContentBBox());
			var svgViewBox = createSVGViewBox(clientRect, opt);

			var dimensions = (joint.util.isNumber(opt.width) && joint.util.isNumber(opt.height)) ? opt : svgViewBox;
			var rasterSize = scaleRasterSize(dimensions, getScale(opt.size));
			if (!isCanvasSizeAllowed(rasterSize.width, rasterSize.height)) {
				throw new Error('dia.Paper: raster size exceeded.');
			}

			var img = new Image();
			var svg;

			// Drawing an image into the canvas has to be done after the image was completely loaded.
			img.onload = function () {

				var dataURL, context, canvas;

				// Helper to create a new canvas.
				function createCanvas() {

					canvas = document.createElement('canvas');
					canvas.width = rasterSize.width;
					canvas.height = rasterSize.height;

					// Draw rectangle of a certain color covering the whole canvas area.
					// A JPEG image has black background by default and it might not be desirable.
					context = canvas.getContext('2d');
					context.fillStyle = opt.backgroundColor || 'white';
					context.fillRect(0, 0, rasterSize.width, rasterSize.height);
				}

				// Helper to read the canvas
				function readCanvas() {

					// Try to read the content of our canvas.
					dataURL = canvas.toDataURL(opt.type, opt.quality);
					// Return dataURL in the given callback.
					callback(dataURL);

					stopTimer();
				}

				function stopTimer() {
					if (canvas.svg && joint.util.isFunction(canvas.svg.stop)) {
						// Clear the interval that is set up by the Canvg lib.
						setTimeout(canvas.svg.stop, 1);
					}
				}

				createCanvas();

				// Drawing SVG images can taint our canvas in some browsers. That means we won't be able
				// to read canvas back as it would fail with `Error: SecurityError: DOM Exception 18`.
				// See `http://getcontext.net/read/chrome-securityerror-dom-exception-18`.
				try {

					// Draw the image to the canvas with native `drawImage` method.
					context.drawImage(img, 0, 0, rasterSize.width, rasterSize.height);

					readCanvas();

				} catch (e) {

					// The security error was thrown. We have to parse and render the SVG image with
					// `canvg` library (https://code.google.com/p/canvg/).
					if (typeof canvg === 'undefined') {

						// The library is not present.
						console.error('Canvas tainted. Canvg library required.');
						return;
					}

					// The canvas was tainted. We need to render a new one. Clearing only the content won't help.
					createCanvas();

					// Draw the SVG with canvg library.
					var canvgOpt = {
						ignoreDimensions: true,
						ignoreClear: true,
						ignoreMouse: true,
						ignoreAnimation: true,
						offsetX: 0,
						offsetY: 0,
						useCORS: true
					};

					canvg(canvas, svg, joint.util.assign(canvgOpt, {

						forceRedraw: function () {
							// Force the redraw only the first time.
							// Important in case the canvg is waiting for images to be loaded.
							if (this.called) {
								return false;
							}
							this.called = true;

							return true;
						}.bind({ called: false }),

						renderCallback: function () {

							try {

								readCanvas();

							} catch (e) {


								stopTimer();
								// As IE throws security error when trying to
								// draw an SVG into the canvas that contains (even though data-uri'ed)
								// <image> element with another SVG in it, we apply a little trick here.
								// The trick is in replacing all <image> elements that have
								// SVG in xlink:href with embedded <svg> elements.
								svg = replaceSVGImagesWithSVGEmbedded(svg);

								// And try again. If even this fails, there is no hope.
								createCanvas();

								canvg(canvas, svg, joint.util.assign(canvgOpt, { renderCallback: readCanvas }));
							}
						}
					}));
				}
			};

			this.toSVG(function (svgString) {

				// Setting the svg string for Canvg
				svg = svgString;
				// An image starts loading when we assign its source.
				img.src = 'data:image/svg+xml,' + encodeURIComponent(svgString);

			}, {
					convertImagesToDataUris: true,
					area: svgViewBox,
					useComputedStyles: opt.useComputedStyles,
					stylesheet: opt.stylesheet,
					// A canvas doesn't like width and height to be defined as percentage for some reason. We need to replace it
					// with desired width and height instead.
					preserveDimensions: {
						width: rasterSize.width,
						height: rasterSize.height
					}
				});
		};

		/**
		 * @param {function} callback
		 * @param {Object} opt
		 */
		joint.dia.Paper.prototype.toPNG = function (callback, opt) {

			// options: width, height, backgroundColor
			opt = opt || {};
			opt.type = 'image/png';
			this.toDataURL(callback, opt);
		};

		/**
		 * @param {function} callback
		 * @param {Object} opt
		 */
		joint.dia.Paper.prototype.toJPEG = function (callback, opt) {

			// options: width, height, backgroundColor, quality
			opt = opt || {};
			opt.type = 'image/jpeg';
			this.toDataURL(callback, opt);
		};

		/**
		 * Just a little helper for quick-opening the paper as PNG in a new browser window.
		 * @param {Object} opt
		 */
		joint.dia.Paper.prototype.openAsPNG = function (opt) {

			var windowFeatures = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes';
			var windowName = joint.util.uniqueId('png_output');

			this.toPNG(function (dataURL) {

				var imageWindow = window.open('', windowName, windowFeatures);
				imageWindow.document.write('<img src="' + dataURL + '"/>');

			}, joint.util.assign({ padding: 10 }, opt));
		};

		function isCanvasSizeAllowed(width, height) {

			var canvas = document.createElement('canvas');
			canvas.width = width;
			canvas.height = height;
			var x = width - 1;
			var y = height - 1;
			var context = canvas.getContext('2d');
			try {
				context.fillStyle = 'rgb(1,1,1)';
				context.fillRect(x, y, 1, 1);
				var rgba = context.getImageData(x, y, 1, 1).data;
				if (rgba[0] !== 1 || rgba[1] !== 1 || rgba[2] !== 1) {
					// Chrome, IE
					return false;
				}
			} catch (e) {
				// Firefox
				return false;
			}

			return true;
		}

		/**
		 * @private
		 * @param {{x:number, y:number, width:number, height:number}} clientBox
		 * @param {{width?:number, height?: number, size?:string, padding?: Object|number}} opt
		 * @returns {rect}
		 */
		function createSVGViewBox(clientBox, opt) {

			var padding = getPadding(opt);

			var paddingBox = g.rect({
				x: -padding.left,
				y: -padding.top,
				width: padding.left + padding.right,
				height: padding.top + padding.bottom
			});

			if (opt.width && opt.height) {

				var paddingWidth = clientBox.width + padding.left + padding.right;
				var paddingHeight = clientBox.height + padding.top + padding.bottom;

				paddingBox.scale(paddingWidth / opt.width, paddingHeight / opt.height);
			}

			return g.Rect(clientBox).moveAndExpand(paddingBox);
		}

		/**
		 * @private
		 * @param {string} size Size of the image could be also changed by a factor e.g, 0.5x, 2x, 4x
		 * @returns {number}
		 */
		function getScale(size) {

			var scale = 1;

			if (size !== undefined) {
				scale = parseFloat(size);
				if (!Number.isFinite(scale) || scale === 0) {
					throw new Error('dia.Paper: invalid raster size (' + size + ')');
				}
			}
			return scale;
		}

		/**
		 * @param {{width: number, height: number}} size
		 * @param {number} scale
		 * @returns {{width: number, height: number}}
		 */
		function scaleRasterSize(size, scale) {

			// the dimensions of the output image
			return {
				width: Math.max(Math.round(size.width * scale), 1),
				height: Math.max(Math.round(size.height * scale), 1)
			};
		}

		/**
		 * @private
		 * @param {{width?, height?, padding}}opt
		 * @returns {{top, bottom, left, right}}
		 */
		function getPadding(opt) {

			var padding = joint.util.normalizeSides(opt.padding);
			if (opt.width && opt.height) {

				// The content has to be at least 1px wide.
				if (padding.left + padding.right >= opt.width) {
					padding.left = padding.right = 0;
				}

				// The content has to be at least 1px high.
				if (padding.top + padding.bottom >= opt.height) {
					padding.top = padding.bottom = 0;
				}
			}

			return padding;
		}

		function replaceSVGImagesWithSVGEmbedded(svg) {

			return svg.replace(/\<image[^>]*>/g, function (imageTag) {

				var match = imageTag.match(/href="([^"]*)"/);
				var href = match && match[1];
				var svgDataUriPrefix = 'data:image/svg+xml';

				if (href && href.substr(0, svgDataUriPrefix.length) === svgDataUriPrefix) {
					var svg = atob(href.substr(href.indexOf(',') + 1));
					return svg.substr(svg.indexOf('<svg'));
				}

				return imageTag;
			});
		}

	}(joint));

	(function ($, V, joint) {

		/*
			Gotcha's:
			* IE won't show background images and colors unless the "Print background colors and images" option is on. [1]
			* SVG filters are removed if their ID attribute conflicts with other elements in the DOM. [2]
	
			[1] https://support.microsoft.com/en-us/kb/296326
			[2] https://stackoverflow.com/questions/19042282/svg-filters-after-cloning-svg
		*/

		/*
			Use media queries to apply styles when printing, like this:
	
			@media print {
				.printarea {
					position: absolute;
					left: 0px;
					top: 0px;
				}
			}
		*/

		function beforePrint(opt) {

			opt = opt || {};

			this.trigger('beforeprint', opt);

			this.$printArea = $('<div/>').addClass('printarea');

			if (opt.size) {
				this.$printArea.addClass('printarea-size-' + opt.size);
			}

			var $printPaper = this.$el.clone().appendTo(this.$printArea);
			var padding = joint.util.normalizeSides(opt.padding);
			var bbox = this.getContentBBox().moveAndExpand({
				x: - padding.left,
				y: - padding.top,
				width: padding.left + padding.right,
				height: padding.top + padding.bottom
			});

			// Stretch the content to the size of the container and apply padding.
			V($printPaper.find('svg')[0]).attr({
				width: '100%',
				height: '100%',
				viewBox: [bbox.x, bbox.y, bbox.width, bbox.height].join(' ')
			});

			/*
				Detach the children of the paper element before adding the cloned paper element to the DOM.
				This is necessary because otherwise the SVG filters are removed because of duplicate element IDs.
			*/
			this.$detachedChildren = this.$el.children().detach();
			this.$printArea.prependTo(document.body);
		}

		function afterPrint(opt) {

			opt = opt || {};

			this.$printArea.remove();
			this.$el.append(this.$detachedChildren);

			// Clean-up.
			this.$detachedChildren = null;
			this.$printArea = null;

			this.trigger('afterprint', opt);
		}

		joint.dia.Paper.prototype.print = function (opt) {

			opt = opt || {};

			joint.util.defaults(opt, {
				// For setting actual paper print size via CSS.
				// Adds another class to printarea <div/> like `printarea-size-a4`.
				size: 'a4',
				padding: 5
			});

			// Create local versions of before/after methods.
			var localBeforePrint = beforePrint.bind(this, opt);
			var localAfterPrint = afterPrint.bind(this, opt);

			var onceAfterPrint = function () {
				if (!this.called) {
					this.called = true;
					localAfterPrint();
					$(window).off('afterprint', onceAfterPrint);
				}
			}.bind({ called: false });

			$(window).one('afterprint', onceAfterPrint);

			// To make sure an app won't get stuck without its original body, add a delayed version.
			setTimeout(onceAfterPrint, 200);

			localBeforePrint();
			window.print();
		};

	})($, V, joint);

	// Channel - Graph synchronization plugin.
	// =======================================

	// The synchronization protocol is inspired by the paper
	// High-Latency, Low-Bandwidth Windowing in the Jupiter Collaboration System; 1995, Nichols, Curtis.

	// Basic usage
	// -----------

	// Server: (`port` is passed)
	// var channel = new joint.com.Channel({ graph: graph, port: 1234 });

	// Client: (`url` is passed)
	// var channel = new joint.com.Channel({ graph: graph, url: 'ws://localhost:1234' });

	// ChannelHub (a.k.a. rooms).
	// --------------------------

	// Client:
	// var channel1 = new joint.com.Channel({ graph: graph1, url: 'ws://localhost:1234', query: { room: 'A' } });
	// Another client:
	// var channel2 = new joint.com.Channel({ graph: graph2, url: 'ws://localhost:1234', query: { room: 'A' } });
	// Yet another client:
	// var channel3 = new joint.com.Channel({ graph: graph3, url: 'ws://localhost:1234', query: { room: 'B' } });

	// Server (one channel/graph per room):
	// var channels = {};
	// var channelHub = new joint.com.ChannelHub({ port: 4141 });
	// channelHub.route(function(req, callback) {

	//     var query = JSON.parse(req.query.query);
	//     var channel = channels[query.room] || null;

	//     if (!channel) {
	//        channel = channels[query.room] = new joint.com.Channel({ graph: new joint.dia.Graph });
	//     }

	//     // If an error occurred, call the callback function with the error as the first argument.
	//     // callback(new Error('Some error has occurred.'));

	//     // Otheriwse, call the callback function with the channel as the second argument.
	//     callback(null, channel);
	// });

	// Notifications (non-reliable but faster communication).
	// ------------------------------------------------------

	// channelClient1.on('telepointer', function(data) {  renderPointer(data.x, data.y, data.color) });
	// channelClient2.notify('telepointer', { x: 50, y: 50, color: 'red' });

	if (typeof exports === 'object') {

		var WebSocketServer = require('ws').Server;
		var WebSocket = require('ws');
		var url = require('url');
	}

	// In the browser, these variables are set to undefined because of JavaScript hoisting.
	// In that case, should grab them from the window object.
	WebSocket = WebSocket || (typeof window !== 'undefined' && window.WebSocket);

	joint.com = joint.com || {};

	// Channel
	// =======

	joint.com.Channel = function (opt) {

		this.options = opt;

		if (!this.options || !this.options.graph) throw new Error('Channel: missing a graph.');

		// Time-to-live of a site. If `ttl` for a site reaches zero, such site is considered dead
		// and the channel removes it from its register (`this.sites` and `this.state`).
		this.options.ttl = this.options.ttl || 60;

		// Interval in ms in which a health check is performed on all the sites. Each health
		// check decreases the `ttl` for a site if the site socket is considered disconnected.
		// If the site socket is connected, the `ttl` is returned to its original value.
		// The default is a health check performed every 1 minute with defualt ttl 60 meaning
		// that if a socket of a site was found disconnected every minute of an hour, then such site
		// is considered stale and therefore removed from the channel register.
		this.options.healthCheckInterval = this.options.healthCheckInterval || (1000 * 60 * 60);

		// If a connection got closed, try to reconnect every `options.reconnectInterval` milliseconds.
		// The default is 10s.
		this.options.reconnectInterval = this.options.reconnectInterval || 10000;

		// Set to `false` if you don't want newly connected clients to receive the whole graph from the server.
		// Default is `true`. Setting this to `false` is useful if it is the client who has the newest
		// graph, not the server. For example, if we have an application that loads a graph via AJAX on the
		// client side and we then want other clients to connect, we don't want those clients
		// to recieve an empty graph from the ChannelHub.
		this.options.serverShouldSendGraph = this.options.serverShouldSendGraph === undefined ? true : this.options.serverShouldSendGraph;

		// Servers do not have a `url` options but rather a `port` they listen on.
		this._isClient = !!this.options.url;

		// A list of sockets for all the clients connected to this channel.
		this._clients = [];

		// A list of operations waiting to be sent. This queue gets populated
		// when the channel gets paused.
		this.messageQueue = [];

		// This site ID.
		this.id = this.options.id || (this._isClient ? 'c_' : 's_') + joint.util.uuid();

		// State vector. Number of operations generated and processed for each connected channel including
		// the channel itself. This state vector is sent witch each operation.
		this.state = {};
		this.state[this.id] = 0;

		// Connected channels and the channel itself. Includes the `outgoing` queue and the current site socket.
		// This is also useful for recognizing if a site got re-connected or if it is a completely new site.
		this.sites = {};
		this.sites[this.id] = { socket: undefined, outgoing: [], ttl: this.options.ttl };

		this.initialize();
	};

	joint.util.assign(joint.com.Channel.prototype, Backbone.Events);

	// Establish a connection between client and server and listen on graph changes.
	joint.com.Channel.prototype.initialize = function () {

		this.options.graph.on('all', this.onGraphChange.bind(this));

		if (this._isClient) {

			this.connectClient();

		} else if (this.options.port) {

			this.server = new WebSocketServer({ port: this.options.port });
			this.server.on('connection', this.onConnection.bind(this));
		}

		if (!this._isClient) {

			this._healthCheckInterval = setInterval(this.healthCheck.bind(this), this.options.healthCheckInterval);
		}
	};

	// Connect client to the server defined in the `options.url`.
	joint.com.Channel.prototype.connectClient = function () {

		var url = this.options.url + '/?channelId=' + this.id + '&state=' + JSON.stringify(this.state) + (this.options.query ? '&query=' + JSON.stringify(this.options.query) : '');

		if (this.options.debugLevel > 0) this.log('connectClient', url);

		// Send current `state` together with this `channelId` to the server.
		var socket = new WebSocket(url);
		socket.onopen = this.onConnection.bind(this, socket);
		socket.onclose = this.onClose.bind(this, socket);
	};

	// Close all sockets. This effectively shuts down the channel.
	joint.com.Channel.prototype.close = function () {

		if (this._reconnectTimeout) clearTimeout(this._reconnectTimeout);
		if (this._healthCheckInterval) clearInterval(this._healthCheckInterval);

		// Mark the channel as closed. This will prevent future reconnection (see `onClose()`).
		// Note that the `onClose()` is called after we close the client socket in the following lines.
		this._closed = true;

		joint.util.forIn(this.sites, function (site) {

			if (site.socket) site.socket.close();
		});

		if (this.server) this.server.close();
	};

	// Checks wheater a site is alive (it's socket is connected). If it is not alive, decreate
	// the site `ttl`. If the `ttl` of a site reaches zero, remove the site and its state from the register.
	joint.com.Channel.prototype.healthCheck = function () {

		if (this.options.debugLevel > 0) {

			var message = Object.keys(this.sites).reduce(function (res, site) {
				res[site] = this[site].ttl;
				return res;
			}.bind(this.sites), {});

			this.log('healthCheck', message);
		}

		joint.util.forIn(this.sites, function (site, channelId) {

			// Do not health check the channel itself.
			if (channelId === this.id) return;

			// readyState === 1 => OPEN socket.
			if (!site.socket || site.socket.readyState !== 1) {
				site.ttl -= 1;
			} else {
				site.ttl = this.options.ttl;
			}

			if (site.ttl <= 0) {

				this.sites = joint.util.omit(this.sites, channelId);
				this.state = joint.util.omit(this.state, channelId);
			}

		}.bind(this));
	};

	// Handle a client connection to the server.
	joint.com.Channel.prototype.onConnection = function (socket) {

		// Store the socket to the internal list of clients. This is useful for cleaning up sockets
		// from clients that have re-connected.
		this._clients.push(socket);

		this.trigger('open', socket);

		if (this._isClient) {

			this.sites[this.id].socket = socket;
			socket.onmessage = function (evt) { this.onMessage(socket, evt.data); }.bind(this);

		} else {

			// The required query fields from clients are `channelId` and `state` object JSON stringified.
			var upgradeReqUrl = url.parse(socket.upgradeReq.url, true);
			var channelId = upgradeReqUrl.query.channelId;

			if (this.sites[channelId]) {
				// Re-connected site.
				// @TODO: send the site ops from the message queue that the client has not yet seen.
				this.sites[channelId].socket = socket;

			} else {

				if (this.debugLevel > 1) this.log('new_site', channelId);

				// New site.
				this.sites[channelId] = { socket: socket, outgoing: [], ttl: this.options.ttl };
				this.state[channelId] = 0;

				if (this.options.serverShouldSendGraph) {

					// Send the new site the whole graph.
					var op = {
						channelId: this.id,
						state: JSON.parse(JSON.stringify(this.state)),
						action: 'graph',
						graph: this.options.graph.toJSON()
					};

					this.messageQueue.push({ type: 'op', data: op, source: this.id, target: [channelId] });
					this.send();
				}
			}

			socket.on('message', this.onMessage.bind(this, socket));
			socket.on('close', this.onClose.bind(this, socket));
		}
	};

	// Handle a client disconnection.
	joint.com.Channel.prototype.onClose = function (socket) {

		var index = this._clients.indexOf(socket);
		if (index !== -1) {
			this._clients.splice(index, 1);
		}

		// If the connection got closed, try to reconnect every 10s or every `options.reconnectInterval` milliseconds.
		if (this._isClient && !this._closed) {

			if (this._reconnectTimeout) clearTimeout(this._reconnectTimeout);

			this._reconnectTimeout = setTimeout(this.connectClient.bind(this), this.options.reconnectInterval);
		}

		this.trigger('close', socket);
	};

	// Remote update.
	joint.com.Channel.prototype.onMessage = function (socket, message) {

		this.trigger('message:received', message);

		if (this.options.debugLevel > 1) this.log('message', message);

		try {
			message = JSON.parse(message);
		} catch (err) {
			// This should never happen.
			return console.error('Channel: message parsing failed.', err);
		}

		if (message.type == 'notification') {
			// Notification. If a notification is received, the event it carries is triggered on the channel.
			// If a server receives a notification, it broadcasts it to all the clients except the one
			// that sent the notification.

			this.trigger(message.data.event, message.data.data);
			return this.sendNotification(message);
		}

		var op = message.data;

		// Receive the op at every site.
		// Note that in case of a client, there is only one site.
		// In case of the server, there is the server's site itself and sites for all the clients.
		var mySite, otherSite;

		if (this._isClient) {

			// Transform the operation in the client's state. Note that clients do not store
			// the state of the server (or even other clients) but only their own state.
			mySite = this.sites[this.id];
			op = this.receive(mySite, this.id, op);

		} else {

			// Send and transform the operation in the state of the sending client.
			otherSite = this.sites[op.channelId];
			op = this.receive(otherSite, op.channelId, op);

			// Now send the transformed operation to my own state.
			mySite = this.sites[this.id];
			op = this.receive(mySite, this.id, op);
		}

		// Update the version tuple. Note that if the operation action was the whole graph, then we
		// need to update the state of the server (that the client keeps track of) to the state
		// that was sent with the graph operation as there might have been much more than one operation
		// applied on the server before the graph was sent.
		if (op.action === 'graph') {

			this.state[op.channelId] = op.state[op.channelId];

		} else {

			this.state[op.channelId] = (this.state[op.channelId] || 0) + 1;
		}

		if (this.options.debugLevel > 1) this.log('new state', this.state);

		// Execute the operation. Note that we have to execute after we have update the state as
		// executing one operation can lead to generating other operations (see e.g. `disconnectLinks` in `joint.dia.graph`).
		this.execute(op);

		// Update the `outgoing` queue in all the sites except my own and the one the operation
		// came from as these two cases we handled already (see above). The reason we do this here
		// is that we don't want the operation to be transformed again.
		joint.util.forIn(this.sites, function (site, channelId) {

			if (channelId !== this.id && channelId !== op.channelId) {

				this.receive(site, channelId, op);
			}
		}.bind(this));

		if (!this._isClient) {

			// Broadcast the transformed operation to all the other sites.
			message.op = op;
			this.messageQueue.push(message);
			this.broadcast(message);
		}

		this.trigger('message:processed', message);
	};

	// Receive an `op` at `site` with id `channelId`. Transform the `op` and Update the outgoing queue
	// accordingly. Return the transformed `op`.
	joint.com.Channel.prototype.receive = function (site, channelId, op) {

		if (!site) return op;

		if (this.options.debugLevel > 1) this.log('receive', channelId, op);
		if (this.options.debugLevel > 1) this.log('outgoing', site.outgoing);

		// Discard acknowledged.
		site.outgoing = site.outgoing.filter(function (oldOp) {

			return oldOp.state[oldOp.channelId] >= (op.state[oldOp.channelId] || 0);
		});

		if (this.options.debugLevel > 1) this.log('outgoing.length', site.outgoing.length);

		// Transform and store intermediate results to `outgoing` for next transformations.
		for (var i = 0; i < site.outgoing.length; i++) {
			var oldOp = site.outgoing[i];
			var transformResult = this.transform(op, oldOp);
			op = transformResult[0];
			site.outgoing[i] = transformResult[1];
		}

		return op;
	};

	// Transform operations `o1` and `o2`. Operation `o1` is the incoming operation. `o2` is taken from the outgoing queue.
	// The first item of the returned array is the operation that will be applied, the second is an operation
	// that will replace `o2` in outgoing (and will be used in future transformations).
	joint.com.Channel.prototype.transform = function (o1, o2) {

		if (this.options.debugLevel > 1) this.log('transform', o1, o2);

		// Note that the other way round is not neccessary to cover as if the incoming op is remove
		// and the the previous operation was change:target to the removed element, then the remove
		// automatically disconnects the link (see `disconnectLinks: true` in `execute()`).
		if (o1.action === 'change:target' && o2.action === 'remove') {

			if (o1.cell.target.id === o2.cell.id) {

				o1.cell.target = { x: 0, y: 0 };
			}
		}

		if (o1.action === 'change:source' && o2.action === 'remove') {

			if (o1.cell.source.id === o2.cell.id) {

				o1.cell.source = { x: 0, y: 0 };
			}
		}

		return [o1, o2];
	};

	joint.com.Channel.prototype.execute = function (op) {

		var cell;

		switch (op.action) {

			case 'add':
				this.options.graph.addCell(op.cell, { remote: true });
				break;

			case 'remove':
				cell = this.options.graph.getCell(op.cell.id);
				// Do not remove associated links (`disconnectLinks: true`) as these removals arrive as separate operations.
				if (cell) cell.remove({ remote: true, disconnectLinks: true });
				break;

			case 'graph':
				// Complete graph replacement.
				this.options.graph.fromJSON(op.graph);
				break;

			default:
				var attribute = op.action.substr('change:'.length);
				cell = this.options.graph.getCell(op.cell.id);
				if (cell) cell.set(attribute, op.cell[attribute], { remote: true });
				break;
		}
	};

	// Broadcast `message` to all the sites except the one that send the message (source site).
	joint.com.Channel.prototype.broadcast = function (message) {

		if (this._isClient) {
			message.target = Object.keys(this.sites);
		} else {
			message.target = Object.keys(joint.util.omit(this.sites, this.id, message.source));
		}

		this.send();
	};

	// Send all operations from the `messageQueue` to their intended recipients.
	joint.com.Channel.prototype.send = function () {

		if (this._paused) return;

		// Go through the messages one by one and check if they can be sent. If yes, send the message
		// and remove it from the `messageQueue`. If not, keep the message in the `messageQueue` and break up
		// from the function.

		// Indexes of messages from `messageQueue`.
		var toRemove = [];

		for (var i = 0; i < this.messageQueue.length; i++) {
			var m = this.messageQueue[i];
			if (this.sendMessage(m)) {
				// Mark a message that was successfully sent for removal.
				toRemove.push(i);
			}
		}

		// Remove all the successfully sent messages.
		toRemove.forEach(function (msgIdx) {
			this.messageQueue.splice(msgIdx, 1);
		}, this);
	};

	// Send one message to its targets.
	joint.com.Channel.prototype.sendMessage = function (m) {

		if (this.debugLevel > 1) this.log('sendMessage', m);

		var successTargets = [];

		m.target.forEach(function (target, idx) {

			var recievingSite = this.sites[target];
			// @assert recievingSite.socket

			// Check if the message can be safely send to such a target. If yes, mark
			// the target for removal so that next time we don't send the message to this target again.
			// If the recieving site does not exist anymore, consider the message was successfully sent.
			if (!recievingSite) return successTargets.push(idx);
			if (!recievingSite.socket) return;
			// readyState constants: See https://developer.mozilla.org/en-US/docs/Web/API/WebSocket#Ready_state_constants.
			// 1 === OPEN (The connection is open and ready to communicate.)
			if (recievingSite.socket.readyState !== 1) return;


			if (this.debugLevel > 1) this.log('sendMessage', target, m);

			recievingSite.socket.send(JSON.stringify(m));
			successTargets.push(idx);

		}, this);

		// Remove all the targets to which the message was successfully sent.
		successTargets.forEach(function (targetIdx) {
			m.target.splice(targetIdx, 1);
		});

		// Return `true` if the message was successfully sent to all the targets.
		if (!m.target.length) return true;
		return false;
	};

	joint.com.Channel.prototype.log = function (keyword, args) {

		var text = 'Channel [' + this.id + '] ' + keyword.toUpperCase() + ': ';

		console.log.apply(console, [text].concat(Array.prototype.slice.call(arguments, 1)));
	};

	// Pause the channel. All messages that are supposed to be sent from now one will end up in the
	// `messageQueue` until the channel is unpaused.
	joint.com.Channel.prototype.pause = function () {

		this._paused = true;
	};

	// Unpause the channel causing all the messages from `messageQueue` to be send immediately.
	joint.com.Channel.prototype.unpause = function () {

		this._paused = false;
		this.send();
	};

	// Notify everyone about the `event` carrying `data`.
	joint.com.Channel.prototype.notify = function (event, data) {

		var message = {
			type: 'notification',
			source: this.id,
			data: { event: event, data: data }
		};
		this.sendNotification(message);
	};

	// Send notification is like broadcast with send combined except that the message does not go
	// to the `messageQueue`. Notifications are not like ops, OT is not involved. They are useful though for
	// things like telepointers and other messages which don't require such a safety as ops.
	joint.com.Channel.prototype.sendNotification = function (message) {

		if (this._isClient) {
			message.target = Object.keys(this.sites);
		} else {
			message.target = Object.keys(joint.util.omit(this.sites, this.id, message.source));
		}

		this.sendMessage(message);
	};

	// Local update.
	// Broadcast the operation, store it to the `outgoing` queue and increment this site state.
	joint.com.Channel.prototype.onGraphChange = function (eventName, cell, graph, options) {

		// If this change is a result of executing an operation sent by others, do not broadcast.
		if (options && options.remote) return;

		// We're only interested in `add`, `remove` and `change:` events.
		var isInteresting = eventName === 'add' || eventName === 'remove' || eventName.substr(0, 'change:'.length) === 'change:';
		if (!isInteresting) return;

		// Generate operation.
		var op = {
			channelId: this.id,
			state: JSON.parse(JSON.stringify(this.state)),
			action: eventName,
			cell: cell.toJSON()
		};

		// Broadcast message with the operation.
		var message = { type: 'op', data: op, source: this.id };

		if (this.options.debugLevel > 1) this.log('generate', message);

		this.messageQueue.push(message);
		this.broadcast(message);

		// Store the `op` for later transformations.
		this.sites[this.id].outgoing.push(op);

		// Move down the state space.
		this.state[this.id]++;
	};

	// ChannelHub
	// ==========

	joint.com.ChannelHub = function (opt) {

		this.options = opt;

		if (!this.options.port) throw new Error('ChannelHub: missing a port.');

		this.initialize();
	};

	joint.util.assign(joint.com.ChannelHub.prototype, Backbone.Events);

	joint.com.ChannelHub.prototype.initialize = function () {

		this.server = new WebSocketServer({ port: this.options.port });
		this.server.on('connection', this.onConnection.bind(this));
	};

	joint.com.ChannelHub.prototype.onConnection = function (socket) {

		// The required query fields from clients are `channelId` and `state` object JSON stringified.
		var upgradeReqUrl = url.parse(socket.upgradeReq.url, true);
		var req = { query: upgradeReqUrl.query };

		if (!this.router) throw new Error('ChannelHub: missing a router.');

		var called = false;

		var channel = this.router(req, function (error, channel) {

			if (error) {
				throw new Error(error);
			}

			if (channel && !called) {
				channel.onConnection(socket);
				called = true;
			}
		});

		// For backwards compatibility.
		// This allows the previous synchronous behavior.
		if (channel instanceof joint.com.Channel) {
			channel.onConnection(socket);
			called = true;
		}
	};

	joint.com.ChannelHub.prototype.route = function (router) {

		this.router = router;
	};

	// Shut down the server.
	joint.com.ChannelHub.prototype.close = function () {

		this.server.close();
	};

	// Dijkstra's shortest path algorithm.
	// ===================================

	// Implemented using a priority queue.
	// Time complexity: O(|E| + |V| log |V|)

	joint.alg = joint.alg || {};

	// `adjacencyList` is an object where keys are nodes and values are
	// lists of neighbours.
	// `source` is the id of the source node from which shortest paths will be computed.
	// `weight` is a function that returns a distance between two nodes.
	joint.alg.Dijkstra = function (adjacencyList, source, weight) {

		weight = weight || function (u, v) { return 1; };

		var dist = {};
		dist[source] = 0;

		var previous = {};
		var Q = new joint.alg.PriorityQueue;

		for (var v in adjacencyList) {

			if (v !== source) {
				dist[v] = Infinity;
			}
			Q.insert(dist[v], v, v);
		}

		var u, neighbours, i, alt;
		var scanned = {};
		while (!Q.isEmpty()) {
			u = Q.remove();
			scanned[u] = true;
			neighbours = adjacencyList[u] || [];
			for (i = 0; i < neighbours.length; i++) {
				v = neighbours[i];
				if (!scanned[v]) {
					alt = dist[u] + weight(u, v);
					if (alt < dist[v]) {
						dist[v] = alt;
						previous[v] = u;
						Q.updatePriority(v, alt);
					}
				}
			}
		}

		return previous;
	};

	// PriorityQueue - using binary heap.
	// ==================================

	// Time complexity
	// ---------------

	// create: O(n)
	// insert: O(log n)
	// peek: O(1)
	// peekPriority: O(1)
	// remove: O(log n)
	// isEmpty: O(1)

	joint.alg = joint.alg || {};

	// Public interface.
	// -----------------

	joint.alg.PriorityQueue = function (opt) {

		opt = opt || {};

		this.comparator = opt.comparator || function (a, b) {
			return a - b;
		};

		// `index` is a map of node ID's (if provided in insert op) to their indexes in the `data` array.
		// This is necessary in order to implement `updatePriority` operation
		// (better known as "decreaseKey"). The map is here so that we
		// can find the index of the node object. We assume this lookup has
		// O(log n) time complexity.
		this.index = {};
		this.data = opt.data || [];
		this.heapify();
	};

	joint.alg.PriorityQueue.prototype.isEmpty = function () {

		return this.data.length === 0;
	};

	joint.alg.PriorityQueue.prototype.insert = function (priority, value, id) {

		var node = { priority: priority, value: value };
		this.data.push(node);
		var index = this.data.length - 1;
		if (id) {
			node.id = id;
			this.index[id] = index;
		}
		this.bubbleUp(index);
	};

	joint.alg.PriorityQueue.prototype.peek = function () {

		return this.data[0] && this.data[0].value;
	};

	joint.alg.PriorityQueue.prototype.peekPriority = function () {

		return this.data[0] && this.data[0].priority;
	};

	joint.alg.PriorityQueue.prototype.updatePriority = function (id, priority) {

		var index = this.index[id];
		if (index === null || typeof index === 'undefined') {
			throw new Error('Node with id ' + id + ' was not found in the heap.');
		}

		var data = this.data;
		var oldPriority = data[index].priority;
		var comp = this.comparator(priority, oldPriority);
		if (comp < 0) {

			data[index].priority = priority;
			this.bubbleUp(index);

		} else if (comp > 0) {

			data[index].priority = priority;
			this.bubbleDown(index);
		}
	};

	joint.alg.PriorityQueue.prototype.remove = function () {

		var data = this.data;
		var peek = data[0];
		var last = data.pop();

		this.index[data.length] = null;

		if (data.length > 0) {

			data[0] = last;
			if (last.id) {
				this.index[last.id] = 0;
			}
			this.bubbleDown(0);
		}

		return peek && peek.value;
	};

	// Private.
	// --------

	joint.alg.PriorityQueue.prototype.heapify = function () {

		for (var i = 0; i < this.data.length; i++) {

			this.bubbleUp(i);
		}
	};

	joint.alg.PriorityQueue.prototype.bubbleUp = function (pos) {

		var parent;
		var aux;
		var data = this.data;

		while (pos > 0) {

			parent = (pos - 1) >>> 1;
			if (this.comparator(data[pos].priority, data[parent].priority) < 0) {

				aux = data[parent];
				data[parent] = data[pos];
				if (data[pos].id) {
					this.index[data[pos].id] = parent;
				}
				data[pos] = aux;
				if (data[pos].id) {
					this.index[data[pos].id] = pos;
				}
				pos = parent;

			} else {
				break;
			}
		}
	};

	joint.alg.PriorityQueue.prototype.bubbleDown = function (pos) {

		var data = this.data;
		var last = data.length - 1;
		while (true) {

			var left = (pos << 1) + 1;
			var right = left + 1;
			var minIndex = pos;

			if (left <= last && this.comparator(data[left].priority, data[minIndex].priority) < 0) {

				minIndex = left;
			}
			if (right <= last && this.comparator(data[right].priority, data[minIndex].priority) < 0) {

				minIndex = right;
			}
			if (minIndex !== pos) {

				var aux = data[minIndex];
				data[minIndex] = data[pos];
				if (data[pos].id) {
					this.index[data[pos].id] = minIndex;
				}
				data[pos] = aux;
				if (data[pos].id) {
					this.index[data[pos].id] = pos;
				}
				pos = minIndex;

			} else {
				break;
			}
		}
	};

	// joint.storage.Local stores graphs to the HTML 5 localStorage.
	// The API is inspired by the great MongoDB database.

	// Example usage:
	//     var graph = new joint.dia.Graph;
	//     (new joint.shapes.basic.Rect).addTo(graph);
	//     joint.storage.Local.insert('graphs', graph);
	//     joint.storage.Local.find('graphs', {}, function(err, graphs) {});
	//     joint.storage.Local.remove('graphs', {}, function(err) {});

	joint.storage = joint.storage || {};

	joint.storage.Local = {

		prefix: 'joint.storage',

		// Store a document `doc` to the `collection` in localStorage.
		// `callback` has the following signature: `callback(err, doc)` where
		// `doc` is the inserted document.
		insert: function (collection, doc, callback) {

			var id = doc.id || joint.util.uuid();

			var index = this.loadIndex(collection);
			if (index.keys.indexOf(id) === -1) {
				index.keys.push(id);
			}

			this.setItem(this.docKey(collection, id), doc);
			this.setItem(this.indexKey(collection), index);

			// Don't add the `id` to the document if it wasn't there.
			this.callback(callback, null, joint.util.assign({}, doc, { id: id }));
		},

		// Find a document in `collection`.
		// `query` can currently be either empty in which case all the
		// documents from the `collection` are returned or it can contain `id`
		// of a document in which case only a document with that `id` is returned.
		// `callback` signature is: `callback(err, docs)`.
		find: function (collection, query, callback) {

			var index = this.loadIndex(collection);
			var docs = [];

			if (joint.util.isEmpty(query)) {

				// Find all documents in the collection.
				index.keys.forEach(function (id) {

					var doc = this.getItem(this.docKey(collection, id));
					if (!doc) {

						this.callback(callback, new Error('Storage incosistency. No document found for an ID ' + id + ' from index.'));
					}

					docs.push(doc);

				}, this);

				this.callback(callback, null, docs);

			} else if (query.id) {

				var doc = this.getItem(this.docKey(collection, query.id));
				this.callback(callback, null, doc ? [doc] : []);

			} else {

				// Other queries supported yet.
				this.callback(callback, null, []);
			}
		},

		// Remove a document from the `collection`. `query` can currently be either empty
		// in which case all the documents from the `collection` are removed
		// or it can contain an `id` of the document to be removed.
		// `callback` signature is: `callback(err)`.
		remove: function (collection, query, callback) {

			var index = this.loadIndex(collection);

			if (joint.util.isEmpty(query)) {

				index.keys.forEach(function (id) {

					localStorage.removeItem(this.docKey(collection, id));

				}, this);

				localStorage.removeItem(this.indexKey(collection));
				this.callback(callback, null);

			} else if (query.id) {

				index.keys = index.keys.filter(function (key) {
					return key !== query.id;
				});

				localStorage.removeItem(this.docKey(collection, query.id));
				this.setItem(this.indexKey(collection), index);
				this.callback(callback, null);
			}
		},

		// Private helpers.
		// ----------------

		callback: function (callback, err, ret) {

			if (callback) {

				setTimeout(function () {
					callback(err, ret);
				}, 1);
			}
		},

		setItem: function (key, item) {

			localStorage.setItem(key, JSON.stringify(item));
		},

		getItem: function (key) {

			var item = localStorage.getItem(key);
			return item ? JSON.parse(item) : item;
		},

		loadIndex: function (collection) {

			var index = this.getItem(this.indexKey(collection)) || {};
			index.keys = index.keys || [];
			return index;
		},

		docKey: function (collection, id) {

			return this.prefix + '.' + collection + '.docs.' + id;
		},

		indexKey: function (collection) {

			return this.prefix + '.' + collection + '.index';
		}
	};


	joint.g = g;
	joint.V = joint.Vectorizer = V;

	return joint;

}));
